var h6 = Object.defineProperty, m6 = Object.defineProperties;
var f6 = Object.getOwnPropertyDescriptors;
var Ni = Object.getOwnPropertySymbols;
var mh = Object.prototype.hasOwnProperty, fh = Object.prototype.propertyIsEnumerable;
var hh = (e, t, n) => t in e ? h6(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, ae = (e, t) => {
  for (var n in t || (t = {}))
    mh.call(t, n) && hh(e, n, t[n]);
  if (Ni)
    for (var n of Ni(t))
      fh.call(t, n) && hh(e, n, t[n]);
  return e;
}, ge = (e, t) => m6(e, f6(t));
var Js = (e, t) => {
  var n = {};
  for (var r in e)
    mh.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Ni)
    for (var r of Ni(e))
      t.indexOf(r) < 0 && fh.call(e, r) && (n[r] = e[r]);
  return n;
};
import { createElementBlock as f, openBlock as d, Fragment as J, renderList as ne, createElementVNode as c, createBlock as I, resolveDynamicComponent as Y, resolveComponent as V, normalizeStyle as Z, renderSlot as M, createVNode as j, normalizeClass as _, createCommentVNode as T, toDisplayString as k, createTextVNode as H, withCtx as S, TransitionGroup as zn, resolveDirective as Ke, withDirectives as we, withKeys as K, withModifiers as W, Transition as Le, vModelText as p6, unref as vc, getCurrentScope as Qp, onScopeDispose as Jp, ref as ho, computed as Mn, watch as vs, vShow as Un, nextTick as bc, normalizeProps as g6, guardReactiveProps as v6, mergeProps as Se, onMounted as Jc, getCurrentInstance as eg, toValue as tg, shallowRef as b6, useTemplateRef as y6, createSlots as ng, defineComponent as _6, onUnmounted as C6, Comment as w6, cloneVNode as T6, h as No } from "vue";
function ph(e) {
  return e.type.indexOf("mouse") !== -1 ? e.clientX : e.touches[0].clientX;
}
function gh(e) {
  return e.type.indexOf("mouse") !== -1 ? e.clientY : e.touches[0].clientY;
}
var k6 = function() {
  var e = !1;
  try {
    var t = Object.defineProperty({}, "passive", {
      get: function() {
        e = !0;
      }
    });
    window.addEventListener("test", null, t);
  } catch (n) {
  }
  return e;
}(), E6 = {
  install: function(e, t) {
    var n = Object.assign({}, {
      disableClick: !1,
      tapTolerance: 10,
      // px
      swipeTolerance: 30,
      // px
      touchHoldTolerance: 400,
      // ms
      longTapTimeInterval: 400,
      // ms
      touchClass: "",
      dragFrequency: 100,
      // ms
      rollOverFrequency: 100,
      // ms
      namespace: "touch"
    }, t);
    function r(C) {
      var A = this.$$touchObj, R = C.type.indexOf("touch") >= 0, O = C.type.indexOf("mouse") >= 0, F = this;
      R && (A.lastTouchStartTime = C.timeStamp), !(O && A.lastTouchStartTime && C.timeStamp - A.lastTouchStartTime < 350) && (A.touchStarted || (v(this), A.touchStarted = !0, A.touchMoved = !1, A.swipeOutBounded = !1, A.startX = ph(C), A.startY = gh(C), A.currentX = 0, A.currentY = 0, A.touchStartTime = C.timeStamp, A.hasSwipe = u(this, "swipe") || u(this, "swipe.left") || u(this, "swipe.right") || u(this, "swipe.top") || u(this, "swipe.bottom"), u(this, "hold") && (A.touchHoldTimer = setTimeout(function() {
        A.touchHoldTimer = null, m(C, F, "hold");
      }, A.options.touchHoldTolerance)), m(C, this, "press")));
    }
    function o(C) {
      var A = this.$$touchObj, R = ph(C), O = gh(C), F = A.currentX != R || A.currentY != O;
      if (A.currentX = R, A.currentY = O, A.touchMoved) {
        if (A.hasSwipe && !A.swipeOutBounded) {
          var D = A.options.swipeTolerance;
          A.swipeOutBounded = Math.abs(A.startX - A.currentX) > D && Math.abs(A.startY - A.currentY) > D;
        }
      } else {
        var L = A.options.tapTolerance;
        A.touchMoved = Math.abs(A.startX - A.currentX) > L || Math.abs(A.startY - A.currentY) > L, A.touchMoved && (h(A), m(C, this, "drag.once"));
      }
      if (u(this, "rollover") && F) {
        var P = C.timeStamp, U = A.options.rollOverFrequency;
        (A.touchRollTime == null || P > A.touchRollTime + U) && (A.touchRollTime = P, m(C, this, "rollover"));
      }
      if (u(this, "drag") && A.touchStarted && A.touchMoved && F) {
        var P = C.timeStamp, U = A.options.dragFrequency;
        (A.touchDragTime == null || P > A.touchDragTime + U) && (A.touchDragTime = P, m(C, this, "drag"));
      }
    }
    function i() {
      var C = this.$$touchObj;
      h(C), g(this), C.touchStarted = C.touchMoved = !1, C.startX = C.startY = 0;
    }
    function a(C) {
      var A = this.$$touchObj, R = C.type.indexOf("touch") >= 0, O = C.type.indexOf("mouse") >= 0;
      R && (A.lastTouchEndTime = C.timeStamp);
      var F = R && !A.touchHoldTimer;
      if (h(A), A.touchStarted = !1, g(this), !(O && A.lastTouchEndTime && C.timeStamp - A.lastTouchEndTime < 350))
        if (m(C, this, "release"), A.touchMoved) {
          if (A.hasSwipe && !A.swipeOutBounded) {
            var L = A.options.swipeTolerance, D, P = Math.abs(A.startY - A.currentY), U = Math.abs(A.startX - A.currentX);
            (P > L || U > L) && (P > U ? D = A.startY > A.currentY ? "top" : "bottom" : D = A.startX > A.currentX ? "left" : "right", u(this, "swipe." + D) ? m(C, this, "swipe." + D, D) : m(C, this, "swipe", D));
          }
        } else if (u(this, "longtap") && C.timeStamp - A.touchStartTime > A.options.longTapTimeInterval)
          C.cancelable && C.preventDefault(), m(C, this, "longtap");
        else if (u(this, "hold") && F) {
          C.cancelable && C.preventDefault();
          return;
        } else
          m(C, this, "tap");
    }
    function s() {
      v(this);
    }
    function l() {
      g(this);
    }
    function u(C, A) {
      var R = C.$$touchObj.callbacks[A];
      return R != null && R.length > 0;
    }
    function m(C, A, R, O) {
      var F = A.$$touchObj, L = F.callbacks[R];
      if (L == null || L.length === 0)
        return null;
      for (var D = 0; D < L.length; D++) {
        var P = L[D];
        P.modifiers.stop && C.stopPropagation(), P.modifiers.prevent && C.preventDefault(), !(P.modifiers.self && C.target !== C.currentTarget) && typeof P.value == "function" && (O ? P.value(O, C) : P.value(C));
      }
    }
    function v(C) {
      var A = C.$$touchObj.options.touchClass;
      A && C.classList.add(A);
    }
    function g(C) {
      var A = C.$$touchObj.options.touchClass;
      A && C.classList.remove(A);
    }
    function h(C) {
      C && C.touchHoldTimer && (clearTimeout(C.touchHoldTimer), C.touchHoldTimer = null);
    }
    function E(C, A) {
      var R = C.$$touchObj || {
        // an object contains all callbacks registered,
        // key is event name, value is an array
        callbacks: {},
        // prevent bind twice, set to true when event bound
        hasBindTouchEvents: !1,
        // default options, would be override by v-touch-options
        options: n
      };
      return A && (R.options = Object.assign({}, R.options, A)), C.$$touchObj = R, C.$$touchObj;
    }
    e.directive(n.namespace, {
      beforeMount: function(C, A) {
        var R = E(C), O = k6 ? { passive: !0 } : !1, F = A.arg || "tap";
        switch (F) {
          case "swipe":
            var L = A.modifiers;
            if (L.left || L.right || L.top || L.bottom) {
              for (var D in A.modifiers)
                if (["left", "right", "top", "bottom"].indexOf(D) >= 0) {
                  var P = "swipe." + D;
                  R.callbacks[P] = R.callbacks[P] || [], R.callbacks[P].push(A);
                }
            } else
              R.callbacks.swipe = R.callbacks.swipe || [], R.callbacks.swipe.push(A);
            break;
          case "press":
          case "drag":
            A.modifiers.disablePassive && (O = !1);
          default:
            R.callbacks[F] = R.callbacks[F] || [], R.callbacks[F].push(A);
        }
        R.hasBindTouchEvents || (C.addEventListener("touchstart", r, O), C.addEventListener("touchmove", o, O), C.addEventListener("touchcancel", i), C.addEventListener("touchend", a), R.options.disableClick || (C.addEventListener("mousedown", r), C.addEventListener("mousemove", o), C.addEventListener("mouseup", a), C.addEventListener("mouseenter", s), C.addEventListener("mouseleave", l)), R.hasBindTouchEvents = !0);
      },
      unmounted: function(C) {
        h(C.$$touchObj), C.removeEventListener("touchstart", r), C.removeEventListener("touchmove", o), C.removeEventListener("touchcancel", i), C.removeEventListener("touchend", a), C.$$touchObj && !C.$$touchObj.options.disableClick && (C.removeEventListener("mousedown", r), C.removeEventListener("mousemove", o), C.removeEventListener("mouseup", a), C.removeEventListener("mouseenter", s), C.removeEventListener("mouseleave", l)), delete C.$$touchObj;
      }
    }), e.directive(`${n.namespace}-class`, {
      beforeMount: function(C, A) {
        E(C, {
          touchClass: A.value
        });
      }
    }), e.directive(`${n.namespace}-options`, {
      beforeMount: function(C, A) {
        E(C, A.value);
      }
    });
  }
}, Hi = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Co(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ea, vh;
function Fr() {
  if (vh) return ea;
  vh = 1;
  var e = Array.isArray;
  return ea = e, ea;
}
var ta, bh;
function rg() {
  if (bh) return ta;
  bh = 1;
  var e = typeof Hi == "object" && Hi && Hi.Object === Object && Hi;
  return ta = e, ta;
}
var na, yh;
function dn() {
  if (yh) return na;
  yh = 1;
  var e = rg(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return na = n, na;
}
var ra, _h;
function bs() {
  if (_h) return ra;
  _h = 1;
  var e = dn(), t = e.Symbol;
  return ra = t, ra;
}
var oa, Ch;
function S6() {
  if (Ch) return oa;
  Ch = 1;
  var e = bs(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, o = e ? e.toStringTag : void 0;
  function i(a) {
    var s = n.call(a, o), l = a[o];
    try {
      a[o] = void 0;
      var u = !0;
    } catch (v) {
    }
    var m = r.call(a);
    return u && (s ? a[o] = l : delete a[o]), m;
  }
  return oa = i, oa;
}
var ia, wh;
function M6() {
  if (wh) return ia;
  wh = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return ia = n, ia;
}
var sa, Th;
function ci() {
  if (Th) return sa;
  Th = 1;
  var e = bs(), t = S6(), n = M6(), r = "[object Null]", o = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? o : r : i && i in Object(s) ? t(s) : n(s);
  }
  return sa = a, sa;
}
var aa, kh;
function wo() {
  if (kh) return aa;
  kh = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return aa = e, aa;
}
var la, Eh;
function ys() {
  if (Eh) return la;
  Eh = 1;
  var e = ci(), t = wo(), n = "[object Symbol]";
  function r(o) {
    return typeof o == "symbol" || t(o) && e(o) == n;
  }
  return la = r, la;
}
var ua, Sh;
function A6() {
  if (Sh) return ua;
  Sh = 1;
  var e = Fr(), t = ys(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function o(i, a) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : r.test(i) || !n.test(i) || a != null && i in Object(a);
  }
  return ua = o, ua;
}
var da, Mh;
function ur() {
  if (Mh) return da;
  Mh = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return da = e, da;
}
var ca, Ah;
function og() {
  if (Ah) return ca;
  Ah = 1;
  var e = ci(), t = ur(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", i = "[object Proxy]";
  function a(s) {
    if (!t(s))
      return !1;
    var l = e(s);
    return l == r || l == o || l == n || l == i;
  }
  return ca = a, ca;
}
var ha, Ih;
function I6() {
  if (Ih) return ha;
  Ih = 1;
  var e = dn(), t = e["__core-js_shared__"];
  return ha = t, ha;
}
var ma, Lh;
function L6() {
  if (Lh) return ma;
  Lh = 1;
  var e = I6(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return ma = n, ma;
}
var fa, Dh;
function ig() {
  if (Dh) return fa;
  Dh = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch (o) {
      }
      try {
        return r + "";
      } catch (o) {
      }
    }
    return "";
  }
  return fa = n, fa;
}
var pa, $h;
function D6() {
  if ($h) return pa;
  $h = 1;
  var e = og(), t = L6(), n = ur(), r = ig(), o = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, l = a.toString, u = s.hasOwnProperty, m = RegExp(
    "^" + l.call(u).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function v(g) {
    if (!n(g) || t(g))
      return !1;
    var h = e(g) ? m : i;
    return h.test(r(g));
  }
  return pa = v, pa;
}
var ga, Oh;
function $6() {
  if (Oh) return ga;
  Oh = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return ga = e, ga;
}
var va, Ph;
function Rr() {
  if (Ph) return va;
  Ph = 1;
  var e = D6(), t = $6();
  function n(r, o) {
    var i = t(r, o);
    return e(i) ? i : void 0;
  }
  return va = n, va;
}
var ba, Nh;
function _s() {
  if (Nh) return ba;
  Nh = 1;
  var e = Rr(), t = e(Object, "create");
  return ba = t, ba;
}
var ya, Hh;
function O6() {
  if (Hh) return ya;
  Hh = 1;
  var e = _s();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return ya = t, ya;
}
var _a, Fh;
function P6() {
  if (Fh) return _a;
  Fh = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return _a = e, _a;
}
var Ca, Rh;
function N6() {
  if (Rh) return Ca;
  Rh = 1;
  var e = _s(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    var a = this.__data__;
    if (e) {
      var s = a[i];
      return s === t ? void 0 : s;
    }
    return r.call(a, i) ? a[i] : void 0;
  }
  return Ca = o, Ca;
}
var wa, Vh;
function H6() {
  if (Vh) return wa;
  Vh = 1;
  var e = _s(), t = Object.prototype, n = t.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    return e ? i[o] !== void 0 : n.call(i, o);
  }
  return wa = r, wa;
}
var Ta, Bh;
function F6() {
  if (Bh) return Ta;
  Bh = 1;
  var e = _s(), t = "__lodash_hash_undefined__";
  function n(r, o) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = e && o === void 0 ? t : o, this;
  }
  return Ta = n, Ta;
}
var ka, jh;
function R6() {
  if (jh) return ka;
  jh = 1;
  var e = O6(), t = P6(), n = N6(), r = H6(), o = F6();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, ka = i, ka;
}
var Ea, Uh;
function V6() {
  if (Uh) return Ea;
  Uh = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Ea = e, Ea;
}
var Sa, qh;
function e0() {
  if (qh) return Sa;
  qh = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return Sa = e, Sa;
}
var Ma, Gh;
function Cs() {
  if (Gh) return Ma;
  Gh = 1;
  var e = e0();
  function t(n, r) {
    for (var o = n.length; o--; )
      if (e(n[o][0], r))
        return o;
    return -1;
  }
  return Ma = t, Ma;
}
var Aa, Kh;
function B6() {
  if (Kh) return Aa;
  Kh = 1;
  var e = Cs(), t = Array.prototype, n = t.splice;
  function r(o) {
    var i = this.__data__, a = e(i, o);
    if (a < 0)
      return !1;
    var s = i.length - 1;
    return a == s ? i.pop() : n.call(i, a, 1), --this.size, !0;
  }
  return Aa = r, Aa;
}
var Ia, zh;
function j6() {
  if (zh) return Ia;
  zh = 1;
  var e = Cs();
  function t(n) {
    var r = this.__data__, o = e(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return Ia = t, Ia;
}
var La, Zh;
function U6() {
  if (Zh) return La;
  Zh = 1;
  var e = Cs();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return La = t, La;
}
var Da, xh;
function q6() {
  if (xh) return Da;
  xh = 1;
  var e = Cs();
  function t(n, r) {
    var o = this.__data__, i = e(o, n);
    return i < 0 ? (++this.size, o.push([n, r])) : o[i][1] = r, this;
  }
  return Da = t, Da;
}
var $a, Wh;
function ws() {
  if (Wh) return $a;
  Wh = 1;
  var e = V6(), t = B6(), n = j6(), r = U6(), o = q6();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, $a = i, $a;
}
var Oa, Yh;
function t0() {
  if (Yh) return Oa;
  Yh = 1;
  var e = Rr(), t = dn(), n = e(t, "Map");
  return Oa = n, Oa;
}
var Pa, Xh;
function G6() {
  if (Xh) return Pa;
  Xh = 1;
  var e = R6(), t = ws(), n = t0();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return Pa = r, Pa;
}
var Na, Qh;
function K6() {
  if (Qh) return Na;
  Qh = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return Na = e, Na;
}
var Ha, Jh;
function Ts() {
  if (Jh) return Ha;
  Jh = 1;
  var e = K6();
  function t(n, r) {
    var o = n.__data__;
    return e(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return Ha = t, Ha;
}
var Fa, e2;
function z6() {
  if (e2) return Fa;
  e2 = 1;
  var e = Ts();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return Fa = t, Fa;
}
var Ra, t2;
function Z6() {
  if (t2) return Ra;
  t2 = 1;
  var e = Ts();
  function t(n) {
    return e(this, n).get(n);
  }
  return Ra = t, Ra;
}
var Va, n2;
function x6() {
  if (n2) return Va;
  n2 = 1;
  var e = Ts();
  function t(n) {
    return e(this, n).has(n);
  }
  return Va = t, Va;
}
var Ba, r2;
function W6() {
  if (r2) return Ba;
  r2 = 1;
  var e = Ts();
  function t(n, r) {
    var o = e(this, n), i = o.size;
    return o.set(n, r), this.size += o.size == i ? 0 : 1, this;
  }
  return Ba = t, Ba;
}
var ja, o2;
function sg() {
  if (o2) return ja;
  o2 = 1;
  var e = G6(), t = z6(), n = Z6(), r = x6(), o = W6();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, ja = i, ja;
}
var Ua, i2;
function Y6() {
  if (i2) return Ua;
  i2 = 1;
  var e = sg(), t = "Expected a function";
  function n(r, o) {
    if (typeof r != "function" || o != null && typeof o != "function")
      throw new TypeError(t);
    var i = function() {
      var a = arguments, s = o ? o.apply(this, a) : a[0], l = i.cache;
      if (l.has(s))
        return l.get(s);
      var u = r.apply(this, a);
      return i.cache = l.set(s, u) || l, u;
    };
    return i.cache = new (n.Cache || e)(), i;
  }
  return n.Cache = e, Ua = n, Ua;
}
var qa, s2;
function X6() {
  if (s2) return qa;
  s2 = 1;
  var e = Y6(), t = 500;
  function n(r) {
    var o = e(r, function(a) {
      return i.size === t && i.clear(), a;
    }), i = o.cache;
    return o;
  }
  return qa = n, qa;
}
var Ga, a2;
function Q6() {
  if (a2) return Ga;
  a2 = 1;
  var e = X6(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(o) {
    var i = [];
    return o.charCodeAt(0) === 46 && i.push(""), o.replace(t, function(a, s, l, u) {
      i.push(l ? u.replace(n, "$1") : s || a);
    }), i;
  });
  return Ga = r, Ga;
}
var Ka, l2;
function J6() {
  if (l2) return Ka;
  l2 = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = Array(o); ++r < o; )
      i[r] = n(t[r], r, t);
    return i;
  }
  return Ka = e, Ka;
}
var za, u2;
function e7() {
  if (u2) return za;
  u2 = 1;
  var e = bs(), t = J6(), n = Fr(), r = ys(), o = e ? e.prototype : void 0, i = o ? o.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, a) + "";
    if (r(s))
      return i ? i.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return za = a, za;
}
var Za, d2;
function t7() {
  if (d2) return Za;
  d2 = 1;
  var e = e7();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return Za = t, Za;
}
var xa, c2;
function n7() {
  if (c2) return xa;
  c2 = 1;
  var e = Fr(), t = A6(), n = Q6(), r = t7();
  function o(i, a) {
    return e(i) ? i : t(i, a) ? [i] : n(r(i));
  }
  return xa = o, xa;
}
var Wa, h2;
function r7() {
  if (h2) return Wa;
  h2 = 1;
  var e = ys();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return Wa = t, Wa;
}
var Ya, m2;
function o7() {
  if (m2) return Ya;
  m2 = 1;
  var e = n7(), t = r7();
  function n(r, o) {
    o = e(o, r);
    for (var i = 0, a = o.length; r != null && i < a; )
      r = r[t(o[i++])];
    return i && i == a ? r : void 0;
  }
  return Ya = n, Ya;
}
var Xa, f2;
function i7() {
  if (f2) return Xa;
  f2 = 1;
  var e = o7();
  function t(n, r, o) {
    var i = n == null ? void 0 : e(n, r);
    return i === void 0 ? o : i;
  }
  return Xa = t, Xa;
}
var s7 = i7();
const $ = /* @__PURE__ */ Co(s7);
function ts(e) {
  "@babel/helpers - typeof";
  return ts = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ts(e);
}
var a7 = /^\s+/, l7 = /\s+$/;
function de(e, t) {
  if (e = e || "", t = t || {}, e instanceof de)
    return e;
  if (!(this instanceof de))
    return new de(e, t);
  var n = u7(e);
  this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
de.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function() {
    var t = this.toRgb(), n, r, o, i, a, s;
    return n = t.r / 255, r = t.g / 255, o = t.b / 255, n <= 0.03928 ? i = n / 12.92 : i = Math.pow((n + 0.055) / 1.055, 2.4), r <= 0.03928 ? a = r / 12.92 : a = Math.pow((r + 0.055) / 1.055, 2.4), o <= 0.03928 ? s = o / 12.92 : s = Math.pow((o + 0.055) / 1.055, 2.4), 0.2126 * i + 0.7152 * a + 0.0722 * s;
  },
  setAlpha: function(t) {
    return this._a = ag(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var t = g2(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var t = g2(this._r, this._g, this._b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + r + "%, " + o + "%)" : "hsva(" + n + ", " + r + "%, " + o + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var t = p2(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function() {
    var t = p2(this._r, this._g, this._b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + r + "%, " + o + "%)" : "hsla(" + n + ", " + r + "%, " + o + "%, " + this._roundA + ")";
  },
  toHex: function(t) {
    return v2(this._r, this._g, this._b, t);
  },
  toHexString: function(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function(t) {
    return m7(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(qe(this._r, 255) * 100) + "%",
      g: Math.round(qe(this._g, 255) * 100) + "%",
      b: Math.round(qe(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(qe(this._r, 255) * 100) + "%, " + Math.round(qe(this._g, 255) * 100) + "%, " + Math.round(qe(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(qe(this._r, 255) * 100) + "%, " + Math.round(qe(this._g, 255) * 100) + "%, " + Math.round(qe(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : E7[v2(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(t) {
    var n = "#" + b2(this._r, this._g, this._b, this._a), r = n, o = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var i = de(t);
      r = "#" + b2(i._r, i._g, i._b, i._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + o + "startColorstr=" + n + ",endColorstr=" + r + ")";
  },
  toString: function(t) {
    var n = !!t;
    t = t || this._format;
    var r = !1, o = this._a < 1 && this._a >= 0, i = !n && o && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return i ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
  },
  clone: function() {
    return de(this.toString());
  },
  _applyModification: function(t, n) {
    var r = t.apply(null, [this].concat([].slice.call(n)));
    return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
  },
  lighten: function() {
    return this._applyModification(v7, arguments);
  },
  brighten: function() {
    return this._applyModification(b7, arguments);
  },
  darken: function() {
    return this._applyModification(y7, arguments);
  },
  desaturate: function() {
    return this._applyModification(f7, arguments);
  },
  saturate: function() {
    return this._applyModification(p7, arguments);
  },
  greyscale: function() {
    return this._applyModification(g7, arguments);
  },
  spin: function() {
    return this._applyModification(_7, arguments);
  },
  _applyCombination: function(t, n) {
    return t.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(T7, arguments);
  },
  complement: function() {
    return this._applyCombination(C7, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(k7, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(w7, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(y2, [3]);
  },
  tetrad: function() {
    return this._applyCombination(y2, [4]);
  }
};
de.fromRatio = function(e, t) {
  if (ts(e) == "object") {
    var n = {};
    for (var r in e)
      e.hasOwnProperty(r) && (r === "a" ? n[r] = e[r] : n[r] = Go(e[r]));
    e = n;
  }
  return de(e, t);
};
function u7(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, r = null, o = null, i = null, a = !1, s = !1;
  return typeof e == "string" && (e = I7(e)), ts(e) == "object" && (Fn(e.r) && Fn(e.g) && Fn(e.b) ? (t = d7(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Fn(e.h) && Fn(e.s) && Fn(e.v) ? (r = Go(e.s), o = Go(e.v), t = h7(e.h, r, o), a = !0, s = "hsv") : Fn(e.h) && Fn(e.s) && Fn(e.l) && (r = Go(e.s), i = Go(e.l), t = c7(e.h, r, i), a = !0, s = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = ag(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
function d7(e, t, n) {
  return {
    r: qe(e, 255) * 255,
    g: qe(t, 255) * 255,
    b: qe(n, 255) * 255
  };
}
function p2(e, t, n) {
  e = qe(e, 255), t = qe(t, 255), n = qe(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), i, a, s = (r + o) / 2;
  if (r == o)
    i = a = 0;
  else {
    var l = r - o;
    switch (a = s > 0.5 ? l / (2 - r - o) : l / (r + o), r) {
      case e:
        i = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        i = (n - e) / l + 2;
        break;
      case n:
        i = (e - t) / l + 4;
        break;
    }
    i /= 6;
  }
  return {
    h: i,
    s: a,
    l: s
  };
}
function c7(e, t, n) {
  var r, o, i;
  e = qe(e, 360), t = qe(t, 100), n = qe(n, 100);
  function a(u, m, v) {
    return v < 0 && (v += 1), v > 1 && (v -= 1), v < 1 / 6 ? u + (m - u) * 6 * v : v < 1 / 2 ? m : v < 2 / 3 ? u + (m - u) * (2 / 3 - v) * 6 : u;
  }
  if (t === 0)
    r = o = i = n;
  else {
    var s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    r = a(l, s, e + 1 / 3), o = a(l, s, e), i = a(l, s, e - 1 / 3);
  }
  return {
    r: r * 255,
    g: o * 255,
    b: i * 255
  };
}
function g2(e, t, n) {
  e = qe(e, 255), t = qe(t, 255), n = qe(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), i, a, s = r, l = r - o;
  if (a = r === 0 ? 0 : l / r, r == o)
    i = 0;
  else {
    switch (r) {
      case e:
        i = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        i = (n - e) / l + 2;
        break;
      case n:
        i = (e - t) / l + 4;
        break;
    }
    i /= 6;
  }
  return {
    h: i,
    s: a,
    v: s
  };
}
function h7(e, t, n) {
  e = qe(e, 360) * 6, t = qe(t, 100), n = qe(n, 100);
  var r = Math.floor(e), o = e - r, i = n * (1 - t), a = n * (1 - o * t), s = n * (1 - (1 - o) * t), l = r % 6, u = [n, a, i, i, s, n][l], m = [s, n, n, a, i, i][l], v = [i, i, s, n, n, a][l];
  return {
    r: u * 255,
    g: m * 255,
    b: v * 255
  };
}
function v2(e, t, n, r) {
  var o = [un(Math.round(e).toString(16)), un(Math.round(t).toString(16)), un(Math.round(n).toString(16))];
  return r && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function m7(e, t, n, r, o) {
  var i = [un(Math.round(e).toString(16)), un(Math.round(t).toString(16)), un(Math.round(n).toString(16)), un(lg(r))];
  return o && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) && i[3].charAt(0) == i[3].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function b2(e, t, n, r) {
  var o = [un(lg(r)), un(Math.round(e).toString(16)), un(Math.round(t).toString(16)), un(Math.round(n).toString(16))];
  return o.join("");
}
de.equals = function(e, t) {
  return !e || !t ? !1 : de(e).toRgbString() == de(t).toRgbString();
};
de.random = function() {
  return de.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function f7(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = de(e).toHsl();
  return n.s -= t / 100, n.s = ks(n.s), de(n);
}
function p7(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = de(e).toHsl();
  return n.s += t / 100, n.s = ks(n.s), de(n);
}
function g7(e) {
  return de(e).desaturate(100);
}
function v7(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = de(e).toHsl();
  return n.l += t / 100, n.l = ks(n.l), de(n);
}
function b7(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = de(e).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), de(n);
}
function y7(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = de(e).toHsl();
  return n.l -= t / 100, n.l = ks(n.l), de(n);
}
function _7(e, t) {
  var n = de(e).toHsl(), r = (n.h + t) % 360;
  return n.h = r < 0 ? 360 + r : r, de(n);
}
function C7(e) {
  var t = de(e).toHsl();
  return t.h = (t.h + 180) % 360, de(t);
}
function y2(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = de(e).toHsl(), r = [de(e)], o = 360 / t, i = 1; i < t; i++)
    r.push(de({
      h: (n.h + i * o) % 360,
      s: n.s,
      l: n.l
    }));
  return r;
}
function w7(e) {
  var t = de(e).toHsl(), n = t.h;
  return [de(e), de({
    h: (n + 72) % 360,
    s: t.s,
    l: t.l
  }), de({
    h: (n + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function T7(e, t, n) {
  t = t || 6, n = n || 30;
  var r = de(e).toHsl(), o = 360 / n, i = [de(e)];
  for (r.h = (r.h - (o * t >> 1) + 720) % 360; --t; )
    r.h = (r.h + o) % 360, i.push(de(r));
  return i;
}
function k7(e, t) {
  t = t || 6;
  for (var n = de(e).toHsv(), r = n.h, o = n.s, i = n.v, a = [], s = 1 / t; t--; )
    a.push(de({
      h: r,
      s: o,
      v: i
    })), i = (i + s) % 1;
  return a;
}
de.mix = function(e, t, n) {
  n = n === 0 ? 0 : n || 50;
  var r = de(e).toRgb(), o = de(t).toRgb(), i = n / 100, a = {
    r: (o.r - r.r) * i + r.r,
    g: (o.g - r.g) * i + r.g,
    b: (o.b - r.b) * i + r.b,
    a: (o.a - r.a) * i + r.a
  };
  return de(a);
};
de.readability = function(e, t) {
  var n = de(e), r = de(t);
  return (Math.max(n.getLuminance(), r.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), r.getLuminance()) + 0.05);
};
de.isReadable = function(e, t, n) {
  var r = de.readability(e, t), o, i;
  switch (i = !1, o = L7(n), o.level + o.size) {
    case "AAsmall":
    case "AAAlarge":
      i = r >= 4.5;
      break;
    case "AAlarge":
      i = r >= 3;
      break;
    case "AAAsmall":
      i = r >= 7;
      break;
  }
  return i;
};
de.mostReadable = function(e, t, n) {
  var r = null, o = 0, i, a, s, l;
  n = n || {}, a = n.includeFallbackColors, s = n.level, l = n.size;
  for (var u = 0; u < t.length; u++)
    i = de.readability(e, t[u]), i > o && (o = i, r = de(t[u]));
  return de.isReadable(e, r, {
    level: s,
    size: l
  }) || !a ? r : (n.includeFallbackColors = !1, de.mostReadable(e, ["#fff", "#000"], n));
};
var yc = de.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, E7 = de.hexNames = S7(yc);
function S7(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
function ag(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function qe(e, t) {
  M7(e) && (e = "100%");
  var n = A7(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function ks(e) {
  return Math.min(1, Math.max(0, e));
}
function Bt(e) {
  return parseInt(e, 16);
}
function M7(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function A7(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function un(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function Go(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function lg(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function _2(e) {
  return Bt(e) / 255;
}
var an = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + t + ")|(?:" + e + ")", r = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", o = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + r),
    rgba: new RegExp("rgba" + o),
    hsl: new RegExp("hsl" + r),
    hsla: new RegExp("hsla" + o),
    hsv: new RegExp("hsv" + r),
    hsva: new RegExp("hsva" + o),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function Fn(e) {
  return !!an.CSS_UNIT.exec(e);
}
function I7(e) {
  e = e.replace(a7, "").replace(l7, "").toLowerCase();
  var t = !1;
  if (yc[e])
    e = yc[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = an.rgb.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = an.rgba.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = an.hsl.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = an.hsla.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = an.hsv.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = an.hsva.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = an.hex8.exec(e)) ? {
    r: Bt(n[1]),
    g: Bt(n[2]),
    b: Bt(n[3]),
    a: _2(n[4]),
    format: t ? "name" : "hex8"
  } : (n = an.hex6.exec(e)) ? {
    r: Bt(n[1]),
    g: Bt(n[2]),
    b: Bt(n[3]),
    format: t ? "name" : "hex"
  } : (n = an.hex4.exec(e)) ? {
    r: Bt(n[1] + "" + n[1]),
    g: Bt(n[2] + "" + n[2]),
    b: Bt(n[3] + "" + n[3]),
    a: _2(n[4] + "" + n[4]),
    format: t ? "name" : "hex8"
  } : (n = an.hex3.exec(e)) ? {
    r: Bt(n[1] + "" + n[1]),
    g: Bt(n[2] + "" + n[2]),
    b: Bt(n[3] + "" + n[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function L7(e) {
  var t, n;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: t,
    size: n
  };
}
var Qa, C2;
function D7() {
  if (C2) return Qa;
  C2 = 1;
  var e = dn(), t = function() {
    return e.Date.now();
  };
  return Qa = t, Qa;
}
var Ja, w2;
function $7() {
  if (w2) return Ja;
  w2 = 1;
  var e = /\s/;
  function t(n) {
    for (var r = n.length; r-- && e.test(n.charAt(r)); )
      ;
    return r;
  }
  return Ja = t, Ja;
}
var el, T2;
function O7() {
  if (T2) return el;
  T2 = 1;
  var e = $7(), t = /^\s+/;
  function n(r) {
    return r && r.slice(0, e(r) + 1).replace(t, "");
  }
  return el = n, el;
}
var tl, k2;
function ug() {
  if (k2) return tl;
  k2 = 1;
  var e = O7(), t = ur(), n = ys(), r = NaN, o = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, a = /^0o[0-7]+$/i, s = parseInt;
  function l(u) {
    if (typeof u == "number")
      return u;
    if (n(u))
      return r;
    if (t(u)) {
      var m = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = t(m) ? m + "" : m;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = e(u);
    var v = i.test(u);
    return v || a.test(u) ? s(u.slice(2), v ? 2 : 8) : o.test(u) ? r : +u;
  }
  return tl = l, tl;
}
var nl, E2;
function P7() {
  if (E2) return nl;
  E2 = 1;
  var e = ur(), t = D7(), n = ug(), r = "Expected a function", o = Math.max, i = Math.min;
  function a(s, l, u) {
    var m, v, g, h, E, C, A = 0, R = !1, O = !1, F = !0;
    if (typeof s != "function")
      throw new TypeError(r);
    l = n(l) || 0, e(u) && (R = !!u.leading, O = "maxWait" in u, g = O ? o(n(u.maxWait) || 0, l) : g, F = "trailing" in u ? !!u.trailing : F);
    function L(N) {
      var G = m, X = v;
      return m = v = void 0, A = N, h = s.apply(X, G), h;
    }
    function D(N) {
      return A = N, E = setTimeout(q, l), R ? L(N) : h;
    }
    function P(N) {
      var G = N - C, X = N - A, Q = l - G;
      return O ? i(Q, g - X) : Q;
    }
    function U(N) {
      var G = N - C, X = N - A;
      return C === void 0 || G >= l || G < 0 || O && X >= g;
    }
    function q() {
      var N = t();
      if (U(N))
        return z(N);
      E = setTimeout(q, P(N));
    }
    function z(N) {
      return E = void 0, F && m ? L(N) : (m = v = void 0, h);
    }
    function te() {
      E !== void 0 && clearTimeout(E), A = 0, m = C = v = E = void 0;
    }
    function ee() {
      return E === void 0 ? h : z(t());
    }
    function x() {
      var N = t(), G = U(N);
      if (m = arguments, v = this, C = N, G) {
        if (E === void 0)
          return D(C);
        if (O)
          return clearTimeout(E), E = setTimeout(q, l), L(C);
      }
      return E === void 0 && (E = setTimeout(q, l)), h;
    }
    return x.cancel = te, x.flush = ee, x;
  }
  return nl = a, nl;
}
var N7 = P7();
const mo = /* @__PURE__ */ Co(N7), Rt = {
  data() {
    return {
      screenSize: "",
      debouncedSetScreenSize: () => {
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setScreenSize();
    }), this.debouncedSetScreenSize = mo(this.setScreenSize, 100), window.addEventListener("resize", this.debouncedSetScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debouncedSetScreenSize);
  },
  methods: {
    setScreenSize() {
      this.screenSize = document.documentElement.clientWidth;
    }
  }
}, B = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, H7 = {
  name: "LinesAccent"
}, F7 = { class: "lines-accent" };
function R7(e, t, n, r, o, i) {
  return d(), f("div", F7, [
    (d(), f(J, null, ne(3, (a, s) => c("div", {
      key: s,
      class: "accent"
    })), 64))
  ]);
}
const V7 = /* @__PURE__ */ B(H7, [["render", R7], ["__scopeId", "data-v-0477e467"]]), B7 = {
  name: "DotsAccent",
  methods: {
    yOffset(e) {
      return e * 8 + 1;
    }
  }
}, j7 = { class: "dots-accent" }, U7 = {
  width: "4000",
  height: "18",
  viewBox: "0 0 4000 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, q7 = ["y1", "y2"];
function G7(e, t, n, r, o, i) {
  return d(), f("div", j7, [
    (d(), f("svg", U7, [
      (d(), f(J, null, ne(3, (a, s) => c("line", {
        key: s,
        x1: "0",
        y1: i.yOffset(s),
        x2: "4000",
        y2: i.yOffset(s),
        "stroke-dasharray": "2, 6",
        "stroke-width": "2"
      }, null, 8, q7)), 64))
    ]))
  ]);
}
const K7 = /* @__PURE__ */ B(B7, [["render", G7], ["__scopeId", "data-v-49a600d6"]]), z7 = {
  name: "HeaderAccent",
  components: { LinesAccent: V7, DotsAccent: K7 },
  props: {
    version: {
      type: String,
      default: ""
    }
  },
  computed: {
    accentType() {
      return this.version === "dot" ? "DotsAccent" : "LinesAccent";
    }
  }
}, Z7 = { class: "header-accent" };
function x7(e, t, n, r, o, i) {
  return d(), f("div", Z7, [
    (d(), I(Y(i.accentType)))
  ]);
}
const W7 = /* @__PURE__ */ B(z7, [["render", x7], ["__scopeId", "data-v-8bc0e22c"]]), Y7 = {
  name: "SeeAllContainer",
  components: { HeaderAccent: W7 },
  mixins: [Rt],
  props: {
    themeOptions: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      headerWidth: 32
    };
  },
  computed: {
    cssVars() {
      return {
        "--width-header": `${this.headerWidth}px`
      };
    },
    accentType() {
      return $(this.themeOptions, "globalThemeSettings.accentType", "dot");
    }
  },
  watch: {
    screenSize() {
      this.resize("watch");
    }
  },
  mounted() {
    this.resize("mounted");
  },
  methods: {
    resize() {
      this.$nextTick(() => {
        if (!this.$refs["header-slot-container"]) return;
        const e = this.$refs["header-slot-container"];
        e.firstElementChild && e.firstElementChild.offsetWidth !== null && e.firstElementChild.offsetWidth > 32 && (this.headerWidth = e.firstElementChild.offsetWidth);
      });
    }
  }
}, X7 = {
  ref: "header-slot-container",
  class: "header-slot-container"
}, Q7 = {
  class: "purple-header-accent",
  "data-testid": "purple-header-accent"
};
function J7(e, t, n, r, o, i) {
  const a = V("HeaderAccent");
  return d(), f("div", {
    class: "see-all-container",
    "data-testid": "header",
    style: Z(i.cssVars)
  }, [
    t[0] || (t[0] = c("span", {
      "data-testid": "monterrey-header-accent-left",
      class: "monterrey-header-accent-left"
    }, null, -1)),
    c("div", X7, [
      M(e.$slots, "header", { ref: "header-slot" })
    ], 512),
    c("div", Q7, [
      j(a, { version: i.accentType }, null, 8, ["version"])
    ]),
    t[1] || (t[1] = c("span", {
      "data-testid": "light-header-accent",
      class: "light-header-accent"
    }, null, -1)),
    t[2] || (t[2] = c("span", {
      "data-testid": "monterrey-header-accent",
      class: "monterrey-header-accent"
    }, null, -1)),
    M(e.$slots, "default")
  ], 4);
}
const ev = /* @__PURE__ */ B(Y7, [["render", J7], ["__scopeId", "data-v-5a17ac72"]]), kt = {
  components: { SeeAllContainer: ev },
  mixins: [Rt],
  methods: {
    getColorOption(e, ...t) {
      const n = t.find((r) => e[r]);
      return n ? e[n] : { hex: "" };
    },
    link(e = "") {
      return this.isPreview ? "#" : `${this.pathPrefix}/${e}`;
    },
    sharedThemeColors() {
      const e = this.theme.style, n = ["light", "purple", "monterrey", "sydney"].includes(e), r = $(this.theme, "bg_color.hex", "none"), o = $(this.theme, "heading_color.hex", "#000"), i = $(this.theme, "top_heading_color.hex", "#000"), a = $(this.theme, "see_all_link_color.hex", o), s = $(this.theme, "see_all_bg_color.hex", "#000"), l = $(this.theme, "see_all_text_color.hex", "#fff"), u = $(this.theme, "button_border_color.hex", "#000"), m = n ? $(this.theme, "button_bg_color.hex", s) : "none", v = n ? $(this.theme, "button_text_color.hex", l) : a, g = $(this.theme, "header_accent_color.hex", "#000");
      return {
        "--bg-color": r,
        "--heading-color": o,
        "--top-heading-color": i,
        "--button-bg-color": m,
        "--button-text-color": v,
        "--button-border-color": u,
        "--header-accent-color": g,
        "--focus-visible-outline": de.mostReadable(r, ["#0000FF", "#FFFFFF"], { includeFallbackColors: !0 }).toHexString(),
        "--focus-visible-box-shadow": "#FFFFFF"
      };
    }
  }
};
function dg(e = "", t = 180) {
  return e.length <= t ? e : e.slice(0, t).concat("...");
}
const S2 = (e = "") => e.replace(/<[^>]*>/g, "").trim(), _c = (e = "") => {
  const t = {
    "&amp;": "&",
    "&nbsp;": " ",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#44;": ",",
    "&gt;": ">",
    "&lt;": "<"
  }, n = new RegExp(Object.keys(t).join("|"), "gi");
  return e.replace(n, (r) => t[r.toLowerCase()]);
}, tv = (e = "", t = 180) => t ? dg(S2(_c(e)), t) : S2(_c(e)), nv = (e = "") => e.toLowerCase().replace(/ /g, "-"), rv = (e = "") => {
  const n = (e.match(/<[^>]*>*/g) || []).pop() || "</>";
  return n.startsWith("</") ? e : e.replace(n, "...");
}, dr = {
  mixins: [kt],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    articles: {
      type: Array,
      default: () => []
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    fallbackImage: {
      type: Object,
      default: () => ({})
    },
    isIFrame: Boolean,
    newsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: Boolean
  },
  computed: {
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    isBoldStyle() {
      return this.theme.style === "bold";
    },
    cssVars() {
      const e = this.sharedThemeColors(), t = e["--heading-color"];
      return ge(ae({}, e), {
        "--article-title-color": $(this.theme, "article_title_color.hex", t),
        "--article-date-color": $(this.theme, "article_date_color.hex", "#757575"),
        "--article-link-color": $(this.theme, "article_link_color.hex", "#CC314B"),
        "--snippet-color": $(this.theme, "snippet_color.hex", "#333"),
        "--news-accent-border-color": $(
          this.theme,
          "news_image_borders_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--news-accent-image-bar": $(
          this.theme,
          "news_image_color_bar.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--top-heading-color": $(this.theme, "top_heading_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--button-border-color": $(
          this.theme,
          "button_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--pager-color": $(this.theme, "pager_color.hex", "#CC314B"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "#CC314B"),
        "--event-arrow-color": $(this.theme, "event_arrow_color.hex", "#fff"),
        "--scrollbar-color": $(this.theme, "scrollbar_color.hex", "#000"),
        "--scrollbar-bg_color": $(
          this.theme,
          "scrollbar_bg_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--scrollbar-arrow-color": $(this.theme, "scrollbar_arrow_color.hex", "#000"),
        "--arrow-icon-color": $(this.theme, "arrow_icon_color.hex", "#fff"),
        "--overlay-color": $(this.theme, "overlay_color.hex", "#000"),
        "--arrow-border-color": $(this.theme, "arrow_border_color.hex", "#000"),
        "--focus-outline-width": "2px",
        "--focus-outline-offset": "1px",
        "--focus-outline-margin": "calc(var(--focus-outline-width) + var(--focus-outline-offset))",
        "--focus-outline-shadow": "0 0 0 calc(var(--focus-outline-margin) * 2)"
      });
    },
    translations() {
      return this.theme.translations;
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("news");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.newsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  },
  methods: {
    saniTruncate: tv,
    replaceHTMLEntities: _c,
    calculateFocalPoints(e) {
      var r, o;
      if (!(e != null && e.cover_image)) return "50% 50%";
      const t = (r = e == null ? void 0 : e.image_focal_point_x) != null ? r : 50, n = (o = e == null ? void 0 : e.image_focal_point_y) != null ? o : 50;
      return `${t}% ${n}%`;
    }
  }
}, ov = {
  name: "NewsStory",
  mixins: [dr],
  props: {
    item: {
      type: Object,
      required: !0
    },
    showSnippet: {
      type: Boolean,
      default: !0
    },
    showTitle: {
      type: Boolean,
      default: !0
    },
    variant: {
      type: String,
      required: !0
    },
    showPublishedTime: {
      type: Boolean,
      default: !1
    },
    totalCards: {
      type: Number,
      default: 0
    },
    cardNumber: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    },
    showSliderAriaLabels() {
      return ["N6-story", "N5-story"].includes(this.variant);
    },
    renderSeeAllButtonOverImage() {
      return this.seeAllButtonOverImage && this.theme.style !== "bold" && this.screenSize < 481;
    }
  },
  methods: {
    formatDate(e) {
      const t = e !== void 0 ? new Date(e) : /* @__PURE__ */ new Date();
      return new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeStyle: "short" }).format(t);
    }
  }
}, iv = ["role", "aria-roledescription", "aria-label"], sv = ["href"], av = { class: "news-image-container" }, lv = { class: "news-image" }, uv = ["src"], dv = {
  key: 0,
  class: "news-date",
  "data-testid": "news-date"
};
function cv(e, t, n, r, o, i) {
  return d(), f("div", {
    role: i.showSliderAriaLabels ? "group" : void 0,
    "aria-roledescription": i.showSliderAriaLabels ? "slide" : void 0,
    "aria-label": i.showSliderAriaLabels ? `${n.cardNumber} of ${n.totalCards}` : void 0,
    class: _(["story", e.theme.style, n.variant])
  }, [
    c("a", {
      href: e.link(`article/${n.item.id}`),
      class: "news-image-title-link"
    }, [
      c("div", av, [
        c("div", lv, [
          c("div", {
            class: _(["image-hidden-wrapper", { "accent-styling": i.hasAccentStyling }])
          }, [
            c("img", {
              alt: "",
              src: n.item.cover_image ? n.item.cover_image : e.fallbackImage.url,
              style: Z({ objectPosition: e.calculateFocalPoints(n.item) }),
              loading: "lazy"
            }, null, 12, uv),
            t[0] || (t[0] = c("div", { class: "news-backdrop" }, null, -1))
          ], 2)
        ])
      ]),
      n.showPublishedTime ? (d(), f("div", dv, k(i.formatDate(n.item.published_at)), 1)) : T("", !0),
      n.showTitle ? (d(), f("div", {
        key: 1,
        class: _(["news-title", [e.theme.style, { "accent-styling": i.hasAccentStyling }]])
      }, [
        H(k(e.saniTruncate(n.item.title)) + " ", 1),
        c("div", {
          class: _(["news-snippet inner-snippet", e.theme.style])
        }, k(e.replaceHTMLEntities(n.item.snippet)), 3)
      ], 2)) : T("", !0)
    ], 8, sv),
    n.showSnippet ? (d(), f("div", {
      key: 0,
      class: _(["news-snippet outer-snippet", e.theme.style])
    }, k(e.replaceHTMLEntities(n.item.snippet)), 3)) : T("", !0)
  ], 10, iv);
}
const Vr = /* @__PURE__ */ B(ov, [["render", cv], ["__scopeId", "data-v-8769d942"]]), hv = {
  name: "N1",
  components: { NewsStory: Vr },
  mixins: [dr]
}, mv = ["data-testid"], fv = { class: "news-content" };
function pv(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory");
  return d(), f("div", {
    id: "news-n1",
    style: Z(e.cssVars),
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "n1"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, mv)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", fv, [
      (d(!0), f(J, null, ne(e.articles.slice(0, 4), (l, u) => (d(), I(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N1-story",
        class: _({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const gv = /* @__PURE__ */ B(hv, [["render", pv], ["__scopeId", "data-v-9c532a68"]]), vv = {
  name: "N2",
  components: { NewsStory: Vr },
  mixins: [dr]
}, bv = ["data-testid"], yv = { class: "news-content" }, _v = {
  "data-testid": "more-headlines",
  class: "more-headlines-header"
};
function Cv(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory");
  return d(), f("div", {
    id: "news-n2",
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    style: Z(e.cssVars)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, bv)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", yv, [
      (d(!0), f(J, null, ne(e.articles.slice(0, 2), (l, u) => (d(), I(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N2-story",
        class: _({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    c("div", _v, k(e.translations.more_headlines), 1),
    c("div", {
      class: _([e.theme.style, "more-headlines-content news-content"])
    }, [
      (d(!0), f(J, null, ne(e.articles.slice(2, 6), (l, u) => (d(), I(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N2-more-story",
        class: _({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "show-snippet": !1,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ], 2),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const wv = /* @__PURE__ */ B(vv, [["render", Cv], ["__scopeId", "data-v-8889f982"]]), Tv = {
  name: "N3",
  components: { NewsStory: Vr },
  mixins: [dr]
}, kv = ["data-testid"], Ev = { class: "news-content" };
function Sv(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory");
  return d(), f("div", {
    id: "news-n3",
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    style: Z(e.cssVars)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, kv)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Ev, [
      (d(!0), f(J, null, ne(e.articles.slice(0, 4), (l, u) => (d(), I(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N3-story",
        class: _({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "show-snippet": !1,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const Mv = /* @__PURE__ */ B(Tv, [["render", Sv], ["__scopeId", "data-v-cf8b1b78"]]), Av = {
  name: "N4",
  components: { NewsStory: Vr },
  mixins: [dr]
}, Iv = ["data-testid"], Lv = { class: "news-content" };
function Dv(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory");
  return d(), f("div", {
    id: "news-n4",
    style: Z(e.cssVars),
    class: _([e.theme.style, { "is-editing": e.isEditing }])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Iv)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        !e.isPurpleStyle && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Lv, [
      (d(!0), f(J, null, ne(e.articles.slice(0, 3), (l, u) => (d(), I(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N4-story",
        class: _({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.isPurpleStyle || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const $v = /* @__PURE__ */ B(Av, [["render", Dv], ["__scopeId", "data-v-4b721186"]]), Ov = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, Pv = ["fill"], Nv = ["stroke"];
function Hv(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.21582 1.18164L6.21582 14.1816M6.21582 1.18164L1.21582 5.97111M6.21582 1.18164L11.2158 5.97112",
      stroke: n.fillColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, Nv)
  ], 8, Pv);
}
const Fv = /* @__PURE__ */ B(Ov, [["render", Hv]]), bt = {
  data() {
    return {
      currentCard: 0,
      visibleCardNum: 0,
      allCardsVisible: !1
    };
  },
  computed: {
    pagerSectionCount() {
      return Math.ceil(this.content.length / (this.visibleCardNum <= 0 ? 1 : this.visibleCardNum));
    },
    sliderCenterElements() {
      return this.sliderCenterSize && this.sliderCenterSize >= this.screenSize;
    },
    sliderReady() {
      return !!(this.$refs[`sliderCard-${this.currentCard}`] && this.$refs["sliderCard-0"] && this.$refs[`sliderCard-${this.content.length - 1}`]);
    }
  },
  mixins: [Rt],
  mounted() {
    this.$nextTick(() => {
      this.sliderReady && this.setVisibleCardNumber();
    }), window.addEventListener("resize", this.setVisibleCardNumber);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setVisibleCardNumber);
  },
  methods: {
    setVisibleCardNumber() {
      const e = this.lastVisibleCard(), t = this.firstVisibleCard();
      this.allCardsVisible = e < 0 && t === 0, this.visibleCardNum = e - t || 1, this.calculateScroll();
    },
    calculateScroll() {
      if (this.sliderReady) {
        const e = this.getHTMLElement(this.$refs[`sliderCard-${this.currentCard}`]), t = this.getHTMLElement(this.$refs["sliderCard-0"]), n = this.getHTMLElement(this.$refs[`sliderCard-${this.content.length - 1}`]), r = this.getHTMLElement(this.$refs.scrollWrapper);
        t.style["margin-left"] = this.sliderCenterElements ? "50vw" : "0px", n.style["margin-right"] = this.sliderCenterElements ? "50vw" : "0px";
        const o = e.getBoundingClientRect().left, i = this.sliderCenterElements ? e.offsetWidth / 2 : 0, a = this.sliderCenterElements ? (r.getBoundingClientRect().left + r.getBoundingClientRect().right) / 2 : r.getBoundingClientRect().left, s = o - (a - i);
        r.scrollLeft += s;
      }
    },
    lastVisibleCard() {
      if (!this.$refs) return;
      const e = this.getHTMLElement(this.$refs.scrollWrapper);
      if (!e || !this.sliderReady)
        return null;
      const t = e.getBoundingClientRect().right;
      return this.content.findIndex((n, r) => {
        var i, a;
        return ((a = this.getHTMLElement((i = this.$refs) == null ? void 0 : i[`sliderCard-${r}`])) == null ? void 0 : a.getBoundingClientRect().right) > t;
      });
    },
    firstVisibleCard() {
      if (!this.$refs) return;
      const e = this.getHTMLElement(this.$refs.scrollWrapper);
      if (!e || !this.sliderReady)
        return null;
      const t = e.getBoundingClientRect().left;
      return this.content.findIndex((n, r) => {
        var i, a;
        const o = (a = this.getHTMLElement((i = this.$refs) == null ? void 0 : i[`sliderCard-${r}`])) == null ? void 0 : a.getBoundingClientRect().left;
        return Math.round(o) >= t;
      });
    },
    scrollLeft() {
      if (this.sliderCenterElements)
        this.currentCard = this.currentCard === 0 ? this.content.length - 1 : this.currentCard - 1;
      else {
        const e = this.firstVisibleCard() - 1;
        this.currentCard = e < 0 ? this.content.length - 1 : e;
      }
      this.calculateScroll();
    },
    scrollRight() {
      this.sliderCenterElements ? this.currentCard = this.currentCard === this.content.length - 1 ? 0 : this.currentCard + 1 : this.currentCard = this.lastVisibleCard() < 0 || this.currentCard === this.content.length - this.visibleCardNum ? 0 : this.currentCard + 1, this.calculateScroll();
    },
    goToSection(e) {
      this.currentCard = (e - 1) * this.visibleCardNum, this.calculateScroll();
    },
    getHTMLElement(e) {
      if (!this.sliderReady)
        return;
      const t = Array.isArray(e) ? e[0] : e;
      return t instanceof Element ? t : t.$el;
    }
  }
}, Rv = {
  name: "Pager",
  props: {
    pagerColor: {
      type: String,
      default: "#0F0F0F"
    },
    totalCards: {
      type: Number,
      default: 0
    },
    currentCard: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      required: !0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    }
  },
  computed: {
    pagerStyles() {
      return {
        "--total-sections": this.pagerSectionCount,
        "--pager-color": this.pagerColor
      };
    },
    cardsPerSection() {
      return Math.ceil(this.totalCards / this.pagerSectionCount);
    }
  },
  methods: {
    activeCard(e) {
      const t = (e - 1) * this.cardsPerSection, n = e * this.cardsPerSection - 1;
      return this.currentCard >= t && this.currentCard <= n;
    },
    ariaLabel(e) {
      return this.activeCard(e) ? $(this.themeStyles, "translations.active", "Active") : $(this.themeStyles, "translations.inactive", "Inactive");
    },
    ariaText(e) {
      return `Display slide ${this.cardsPerSection * e - this.cardsPerSection + 1} through ${this.cardsPerSection * e}`;
    }
  }
}, Vv = ["aria-current", "aria-label", "onClick"];
function Bv(e, t, n, r, o, i) {
  return d(), f("div", {
    class: "pager",
    style: Z(i.pagerStyles)
  }, [
    (d(!0), f(J, null, ne(n.pagerSectionCount, (a, s) => (d(), f("button", {
      key: s,
      class: _([{ active: i.activeCard(a) }, "section"]),
      "aria-current": i.ariaLabel(a),
      "aria-label": i.ariaText(a),
      onClick: (l) => e.$emit("go-to-section", a)
    }, null, 10, Vv))), 128))
  ], 4);
}
const n0 = /* @__PURE__ */ B(Rv, [["render", Bv], ["__scopeId", "data-v-627c6375"]]), jv = {
  name: "SliderLeftButton",
  props: {
    arrowBackgroundColor: {
      type: String,
      default: "#FFFFFF"
    },
    arrowIconColor: {
      type: String,
      default: "#FFFFFF"
    },
    translatedAria: {
      type: String,
      default: ""
    }
  }
}, Uv = ["aria-label"], qv = {
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Gv = ["stroke"];
function Kv(e, t, n, r, o, i) {
  return d(), f("button", {
    class: "scroll-left",
    "aria-label": n.translatedAria,
    style: Z({ "background-color": n.arrowBackgroundColor }),
    onClick: t[0] || (t[0] = (a) => e.$emit("scroll-left"))
  }, [
    (d(), f("svg", qv, [
      c("path", {
        d: "M1 6L14 6M1 6L5.78947 11M1 6L5.78947 0.999999",
        stroke: n.arrowIconColor,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Gv)
    ]))
  ], 12, Uv);
}
const zv = /* @__PURE__ */ B(jv, [["render", Kv], ["__scopeId", "data-v-766a4ad9"]]), Zv = {
  name: "SliderRightButton",
  props: {
    arrowBackgroundColor: {
      type: String,
      default: "#FFFFFF"
    },
    arrowIconColor: {
      type: String,
      default: "#FFFFFF"
    },
    translatedAria: {
      type: String,
      default: ""
    }
  }
}, xv = ["aria-label"], Wv = {
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Yv = ["stroke"];
function Xv(e, t, n, r, o, i) {
  return d(), f("button", {
    class: "scroll-right",
    "aria-label": n.translatedAria,
    style: Z({ "background-color": n.arrowBackgroundColor }),
    onClick: t[0] || (t[0] = (a) => e.$emit("scroll-right"))
  }, [
    (d(), f("svg", Wv, [
      c("path", {
        d: "M14 6H1M14 6L9.21053 1M14 6L9.21053 11",
        stroke: n.arrowIconColor,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Yv)
    ]))
  ], 12, xv);
}
const Qv = /* @__PURE__ */ B(Zv, [["render", Xv], ["__scopeId", "data-v-e7f3ab3f"]]), Jv = {
  name: "NavSection",
  components: {
    Pager: n0,
    LeftSliderButton: zv,
    RightSliderButton: Qv
  },
  props: {
    hasPager: Boolean,
    hasAccent: Boolean,
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    navOrientation: {
      type: String,
      default: "bottom"
    },
    pagerOrientation: {
      type: String,
      default: "right"
    },
    totalCards: {
      type: Number,
      default: 0
    },
    currentCard: {
      type: Number,
      default: 0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    },
    sectionHeader: {
      type: String,
      default: ""
    },
    screenSize: {
      type: Number,
      default: 0
    }
  },
  computed: {
    navStyles() {
      return {
        "--nav-margin-bottom": this.navOrientation === "top" ? "32px" : "0",
        "--nav-margin-top": this.navMarginTop,
        "--button-section-margin": this.navOrientation === "top" || this.navOrientation === "wide" ? "0" : "40px"
      };
    },
    eventArrowColor() {
      return $(this.themeStyles, "event_arrow_color.hex", "#fff");
    },
    arrowIconColor() {
      return $(this.themeStyles, "arrow_icon_color.hex", this.eventArrowColor);
    },
    arrowBackgroundColor() {
      return this.themeStyles.style === "texas" ? "transparent" : $(this.themeStyles, "arrow_background_color.hex", "#000");
    },
    pagerColor() {
      return $(this.themeStyles, "pager_color.hex", "#000");
    },
    accentColor() {
      return {
        "--accent-color": $(this.themeStyles, "accent_color.hex", "#000")
      };
    },
    navMarginTop() {
      switch (this.navOrientation) {
        case "wide":
          return this.themeStyles.version === "S5" ? this.screenSize < 600 ? "0" : "80px" : "32px";
        case "bottom":
          return "32px";
        default:
          return "0";
      }
    },
    nextSlideText() {
      return $(this.themeStyles, "translations.next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return $(this.themeStyles, "translations.previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    }
  }
}, eb = {
  class: "button-section",
  "data-testid": "slider-buttons"
}, tb = {
  key: 0,
  class: "pager-section"
}, nb = {
  key: 1,
  class: "accent-border",
  "data-testid": "accent-border"
};
function rb(e, t, n, r, o, i) {
  const a = V("LeftSliderButton"), s = V("RightSliderButton"), l = V("Pager");
  return d(), f("div", {
    class: _(["nav", `pager-${n.pagerOrientation}`]),
    style: Z([n.themeStyles, i.navStyles]),
    role: "group",
    "aria-label": "slide controls"
  }, [
    c("div", eb, [
      j(a, {
        class: "button",
        "arrow-background-color": i.arrowBackgroundColor,
        "arrow-icon-color": i.arrowIconColor,
        "translated-aria": i.previousSlideText,
        onScrollLeft: t[0] || (t[0] = (u) => e.$emit("scroll-left"))
      }, null, 8, ["arrow-background-color", "arrow-icon-color", "translated-aria"]),
      j(s, {
        class: "button",
        "arrow-background-color": i.arrowBackgroundColor,
        "arrow-icon-color": i.arrowIconColor,
        "translated-aria": i.nextSlideText,
        onScrollRight: t[1] || (t[1] = (u) => e.$emit("scroll-right"))
      }, null, 8, ["arrow-background-color", "arrow-icon-color", "translated-aria"])
    ]),
    n.hasPager ? (d(), f("div", tb, [
      j(l, {
        "total-cards": n.totalCards,
        "pager-color": i.pagerColor,
        "theme-styles": n.themeStyles,
        "current-card": n.currentCard,
        "pager-section-count": n.pagerSectionCount,
        onGoToSection: t[2] || (t[2] = (u) => e.$emit("go-to-section", u))
      }, null, 8, ["total-cards", "pager-color", "theme-styles", "current-card", "pager-section-count"])
    ])) : T("", !0),
    n.hasAccent ? (d(), f("div", nb)) : T("", !0)
  ], 6);
}
const ob = /* @__PURE__ */ B(Jv, [["render", rb], ["__scopeId", "data-v-670020bb"]]), ib = {
  name: "CardSlider",
  components: { NavSection: ob },
  props: {
    navOrientation: {
      type: String,
      default: "bottom"
    },
    pagerOrientation: {
      type: String,
      default: "right"
    },
    hasPager: {
      type: Boolean,
      default: !0
    },
    hasAccent: Boolean,
    totalCards: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    currentCard: {
      type: Number,
      default: 0
    },
    allCardsVisible: Boolean,
    screenSize: {
      type: Number,
      default: 0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    },
    sectionHeader: {
      type: String,
      required: !0
    }
  },
  emits: ["go-to-section", "scroll-left", "scroll-right"]
}, sb = ["aria-label"];
function ab(e, t, n, r, o, i) {
  const a = V("NavSection");
  return d(), f("div", {
    class: _([n.navOrientation, "card-slider"]),
    "aria-label": n.sectionHeader,
    role: "region",
    "aria-roledescription": "carousel"
  }, [
    n.allCardsVisible ? T("", !0) : (d(), I(a, {
      key: 0,
      "nav-orientation": n.navOrientation,
      "pager-orientation": n.pagerOrientation,
      "pager-section-count": n.pagerSectionCount,
      "has-accent": n.hasAccent,
      "current-card": n.currentCard,
      "total-cards": n.totalCards,
      "theme-styles": n.themeStyles,
      "has-pager": n.hasPager,
      "screen-size": n.screenSize,
      "section-header": n.sectionHeader,
      onGoToSection: t[0] || (t[0] = (s) => e.$emit("go-to-section", s)),
      onScrollLeft: t[1] || (t[1] = (s) => e.$emit("scroll-left")),
      onScrollRight: t[2] || (t[2] = (s) => e.$emit("scroll-right"))
    }, null, 8, ["nav-orientation", "pager-orientation", "pager-section-count", "has-accent", "current-card", "total-cards", "theme-styles", "has-pager", "screen-size", "section-header"])),
    M(e.$slots, "default")
  ], 10, sb);
}
const cn = /* @__PURE__ */ B(ib, [["render", ab], ["__scopeId", "data-v-fbf2997e"]]), lb = {
  name: "N5",
  components: { NewsStory: Vr, ArrowIcon: Fv, CardSlider: cn },
  mixins: [dr, bt],
  data: () => ({
    activeNewsContainer: 0,
    newsArticles: []
  }),
  computed: {
    scrollbarArrowColor() {
      var e;
      return ((e = this.theme) == null ? void 0 : e.scrollbar_arrow_color) || { hex: "#FFF" };
    },
    cardSliderStyles() {
      var e, t;
      return ge(ae({}, this.theme), {
        arrow_background_color: ((e = this.theme) == null ? void 0 : e.scrollbar_bg_color) || this.cssVars["--scrollbar-bg_color"],
        arrow_icon_color: ((t = this.theme) == null ? void 0 : t.scrollbar_arrow_color) || this.cssVars["--scrollbar-arrow-color"]
      });
    },
    totalArticles() {
      return { "--total-articles": this.articles.slice(0, 6).length };
    },
    content() {
      return this.newsArticles;
    },
    sliderCenterSize() {
      return 959;
    },
    responsiveSliderImage() {
      return {
        "--responsive-width": this.newsArticles.length > 1 && this.screenSize >= 960 ? `${this.screenSize - 80}px` : "100%"
      };
    },
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    },
    overviewImage() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.cover_image) || this.fallbackImage.url;
    },
    overviewTitle() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.title) || "";
    },
    articleTitle() {
      var e;
      return ((e = this.newsArticles[this.currentCard]) == null ? void 0 : e.title) || "";
    },
    overviewPublishedTime() {
      var t;
      const e = (t = this.newsArticles[0]) != null && t.published_at ? new Date(this.newsArticles[0].published_at) : /* @__PURE__ */ new Date();
      return new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeStyle: "short" }).format(e);
    },
    overviewLink() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.id) || "";
    },
    overviewStyles() {
      return {
        "--overview-width": this.newsArticles.length === 1 ? "100%" : "70%",
        "--overview-width-md": this.newsArticles.length === 1 ? "100%" : "55%",
        "--overview-body-width": this.newsArticles.length === 1 ? "auto" : "90%",
        "--overview-body-margin": this.newsArticles.length === 1 ? "48px" : "0",
        "--overview-margin-md": this.newsArticles.length === 1 ? "0" : "35px"
      };
    },
    scrollStyles() {
      return {
        "--wrapper-margin-bottom": this.newsArticles.length < 5 ? "0" : "-32px"
      };
    },
    articleLink() {
      var e;
      return ((e = this.newsArticles[this.currentCard]) == null ? void 0 : e.id) || "";
    },
    nextSlideText() {
      return $(this.translations, "next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return $(this.translations, "previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    },
    displaySeeAllBottom() {
      return this.isPurpleStyle || this.screenSize < 960 && !this.isBoldStyle || this.screenSize < 600;
    },
    displaySeeAllTop() {
      return !this.isPurpleStyle && this.screenSize >= 960 || this.isBoldStyle && this.screenSize < 959 && this.screenSize >= 600;
    },
    n5PagerStyle() {
      return {
        "--pager-width": `${this.screenSize / this.newsArticles.length * 0.8}px`
      };
    }
  },
  created() {
    this.newsArticles = this.articles.slice(0, 6);
  },
  methods: {
    /**
     * @name scrollUp
     * First it triggers the moveUp function.
     * Then, after the animation has ended, it re arrenges the order of the news list, removing the last element in the list and pushing it at the beginning.
     * Finally, updates the activeNewsContainer variable to update the scroll position and calls the resetTranslate function.
     */
    scrollUp() {
      const e = this.newsArticles, t = e.pop();
      e.unshift(t), this.newsArticles = e, this.activeNewsContainer === 0 ? this.activeNewsContainer = this.newsArticles.length - 1 : this.activeNewsContainer -= 1;
    },
    /**
     * @name scrollDown
     * First it triggers the moveDown function.
     * Then, after the animation has ended, it re arrenges the order of the news list, removing the first element in the list and pushing it at the end.
     * After that, it calls the function setOverviewNews to change the overview news on the left.
     * Finally, updates the activeNewsContainer variable to update the scroll position and calls the resetTranslate function.
     */
    scrollDown() {
      const e = this.newsArticles, t = e.shift();
      e.push(t), this.newsArticles = e, this.activeNewsContainer === this.newsArticles.length - 1 ? this.activeNewsContainer = 0 : this.activeNewsContainer += 1;
    }
  }
}, ub = { class: "news-v5-title" }, db = ["data-testid"], cb = ["data-testid"], hb = { class: "news-overview" }, mb = { class: "news-overview-body" }, fb = ["href"], pb = ["src"], gb = { class: "news-overview-published-time" }, vb = { class: "news-overview-title" }, bb = { class: "news-overview-link" }, yb = ["aria-label"], _b = {
  key: 0,
  class: "news-scroll",
  role: "group",
  "aria-label": "slide controls"
}, Cb = ["aria-label"], wb = ["aria-label"], Tb = ["aria-current"], kb = { class: "article-title" }, Eb = ["href"], Sb = ["href"];
function Mb(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("arrow-icon"), l = V("NewsStory"), u = V("CardSlider");
  return d(), f("div", {
    id: "news-n5",
    style: Z(e.cssVars),
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "n5"
  }, [
    c("div", ub, [
      j(a, {
        class: _([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (d(), f("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.sectionHeaderTop), 1)
              ], !0)
            ], 8, cb)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ], 8, db)
        ]),
        default: S(() => [
          i.displaySeeAllTop ? (d(), I(Y(e.isEditing ? "button" : "a"), {
            key: 0,
            class: _(["see-all-button hide-on-xs", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (m) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])
    ]),
    e.screenSize >= 960 ? (d(), f("div", {
      key: 0,
      class: _(["news-content", { "is-editing": e.isEditing }]),
      style: Z(i.overviewStyles)
    }, [
      c("div", hb, [
        c("div", mb, [
          c("a", {
            href: e.link(`article/${i.overviewLink}`)
          }, [
            c("div", {
              class: _([{ "accent-styling": i.hasAccentStyling }, "news-overview-image-container"])
            }, [
              (d(), f("img", {
                key: e.activeNewsContainer,
                src: i.overviewImage,
                style: Z({ objectPosition: e.calculateFocalPoints(e.newsArticles[0]) }),
                alt: "",
                class: "news-overview-image"
              }, null, 12, pb)),
              t[4] || (t[4] = c("div", { class: "news-backdrop" }, null, -1))
            ], 2),
            c("p", gb, k(i.overviewPublishedTime), 1),
            c("h3", vb, k(i.overviewTitle), 1),
            c("div", bb, [
              c("p", null, k(e.translations.read_article), 1)
            ])
          ], 8, fb)
        ])
      ]),
      c("div", {
        "aria-label": e.sectionHeader,
        class: "news-scroll-wrapper",
        role: "region",
        "aria-roledescription": "carousel"
      }, [
        e.newsArticles.length > 4 ? (d(), f("div", _b, [
          c("button", {
            class: "news-scroll-up",
            "aria-label": i.previousSlideText,
            onClick: t[1] || (t[1] = (...m) => i.scrollUp && i.scrollUp(...m))
          }, [
            j(s, {
              "fill-color": i.scrollbarArrowColor.hex,
              class: "arrow"
            }, null, 8, ["fill-color"])
          ], 8, Cb),
          c("button", {
            class: "news-scroll-down",
            "aria-label": i.nextSlideText,
            onClick: t[2] || (t[2] = (...m) => i.scrollDown && i.scrollDown(...m))
          }, [
            j(s, {
              "fill-color": i.scrollbarArrowColor.hex,
              class: "arrow",
              "dropdown-class": "open"
            }, null, 8, ["fill-color"])
          ], 8, wb),
          c("div", {
            class: "progress-bar",
            style: Z(i.totalArticles)
          }, [
            (d(!0), f(J, null, ne(e.newsArticles, (m, v) => (d(), f("div", {
              key: m.id,
              class: _(["progress-section", { active: e.activeNewsContainer === v }]),
              "aria-current": e.activeNewsContainer === v ? e.translations.active : e.translations.inactive
            }, null, 10, Tb))), 128))
          ], 4)
        ])) : T("", !0),
        c("div", {
          class: "news-list",
          "data-testid": "list",
          style: Z({ "margin-right": e.newsArticles.length < 5 ? "15px" : 0 })
        }, [
          j(zn, {
            name: "scroll-wrapper",
            tag: "div",
            class: "scroll-wrapper",
            style: Z(i.scrollStyles)
          }, {
            default: S(() => [
              (d(!0), f(J, null, ne(e.newsArticles, (m, v) => (d(), I(l, {
                key: m.id,
                item: m,
                theme: e.theme,
                class: _([{ "is-editing": e.isEditing, "has-scroll": e.newsArticles.length > 4 }, "article-container"]),
                "show-snippet": !1,
                "is-preview": e.isPreview,
                "fallback-image": e.fallbackImage,
                "path-prefix": e.pathPrefix,
                "total-cards": e.newsArticles.length,
                "card-number": v + 1,
                variant: "N5-story",
                "data-testid": "news-story"
              }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
            ]),
            _: 1
          }, 8, ["style"])
        ], 4)
      ], 8, yb)
    ], 6)) : (d(), I(u, {
      key: 1,
      "current-card": e.currentCard,
      "pager-section-count": e.newsArticles.length,
      "all-cards-visible": e.newsArticles.length === 1,
      "total-cards": e.newsArticles.length,
      "theme-styles": i.cardSliderStyles,
      "section-header": e.sectionHeader,
      "pager-orientation": "right",
      class: _({ "all-cards-visible": e.allCardsVisible }),
      style: Z(i.n5PagerStyle),
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        c("div", {
          ref: "scrollWrapper",
          class: _(["scroll-wrapper", { "all-cards-visible": e.allCardsVisible }]),
          "data-testid": "blocks-array"
        }, [
          (d(), I(l, {
            ref: "`sliderCard-0",
            key: e.newsArticles[e.currentCard].id,
            item: e.newsArticles[e.currentCard],
            theme: e.theme,
            "show-snippet": !1,
            "show-title": !1,
            "show-published-time": !0,
            "is-preview": e.isPreview,
            "fallback-image": e.fallbackImage,
            "path-prefix": e.pathPrefix,
            "total-cards": e.newsArticles.length,
            "card-number": e.currentCard,
            "aria-label": `${e.currentCard} of ${e.newsArticles.length}`,
            class: _([{ "is-editing": e.isEditing }, "article"]),
            "aria-roledescription": "slide",
            role: "group",
            variant: "N5-story",
            "data-testid": "news-story",
            style: Z(i.responsiveSliderImage)
          }, null, 8, ["item", "theme", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number", "aria-label", "class", "style"])),
          c("h3", kb, [
            c("a", {
              href: e.link(`article/${e.newsArticles[e.currentCard].id}`)
            }, k(i.articleTitle), 9, Eb)
          ]),
          c("a", {
            href: e.link(`article/${e.newsArticles[e.currentCard].id}`),
            class: "article-link"
          }, [
            c("p", null, k(e.translations.read_article), 1)
          ], 8, Sb)
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "class", "style", "onScrollRight", "onScrollLeft", "onGoToSection"])),
    i.displaySeeAllBottom ? (d(), I(a, {
      key: 2,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[3] || (t[3] = (m) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const Ab = /* @__PURE__ */ B(lb, [["render", Mb], ["__scopeId", "data-v-c67050fe"]]), Ib = {
  name: "N6",
  components: { NewsStory: Vr, CardSlider: cn },
  mixins: [dr, bt],
  data() {
    const e = this.articles.slice(0, 6);
    return {
      newsArticles: e,
      newsArticlesLength: e.length
    };
  },
  computed: {
    content() {
      return this.newsArticles;
    },
    themeStyles() {
      return ge(ae({}, this.theme), {
        arrow_background_color: { hex: this.cssVars["--arrow-background-color"] },
        pager_color: { hex: this.cssVars["--pager-color"] },
        arrow_icon_color: { hex: this.cssVars["--arrow-icon-color"] }
      });
    }
  }
}, Lb = ["data-testid"], Db = ["data-testid"], $b = {
  ref: "scrollWrapper",
  class: "news-wrapper"
};
function Ob(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory"), l = V("CardSlider");
  return d(), f("div", {
    id: "news-n6",
    "data-testid": "news-v6",
    style: Z(e.cssVars),
    class: _([e.theme.style, { "is-editing": e.isEditing }])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, Db)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, Lb)
      ]),
      default: S(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(l, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "total-cards": o.newsArticles.length,
      class: _({ "is-editing": e.isEditing }),
      "theme-styles": i.themeStyles,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        c("div", $b, [
          (d(!0), f(J, null, ne(o.newsArticles, (u, m) => (d(), I(s, {
            ref_for: !0,
            ref: `sliderCard-${m}`,
            key: u.id,
            item: u,
            theme: e.theme,
            class: _({ "is-editing": e.isEditing }),
            "is-preview": e.isPreview,
            "fallback-image": e.fallbackImage,
            "path-prefix": e.pathPrefix,
            "total-cards": o.newsArticles.length,
            "card-number": m + 1,
            "show-published-time": "",
            variant: "N6-story",
            "data-testid": "news-story"
          }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
        ], 512)
      ]),
      _: 1
    }, 8, ["current-card", "pager-section-count", "total-cards", "class", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const Pb = /* @__PURE__ */ B(Ib, [["render", Ob], ["__scopeId", "data-v-5893c0e6"]]), Nb = {
  name: "N7",
  components: { NewsStory: Vr, CardSlider: cn },
  mixins: [dr, bt],
  data() {
    return {
      newsArticles: this.articles.slice(0, 6)
    };
  },
  computed: {
    content() {
      return this.newsArticles;
    },
    themeStyles() {
      return ge(ae({}, this.theme), {
        arrow_background_color: { hex: this.cssVars["--arrow-background-color"] },
        pager_color: { hex: this.cssVars["--pager-color"] },
        arrow_icon_color: { hex: this.cssVars["--arrow-icon-color"] }
      });
    }
  }
}, Hb = ["data-testid"], Fb = ["data-testid"], Rb = { class: "color-overlay" }, Vb = {
  ref: "scrollWrapper",
  class: "news-wrapper"
};
function Bb(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory"), l = V("CardSlider");
  return d(), f("div", {
    "data-testid": "news-v7",
    style: Z(e.cssVars),
    class: _([e.theme.style, "news-n7"])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, Fb)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, Hb)
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize > 480 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Rb, [
      j(l, {
        "nav-orientation": "bottom",
        "pager-orientation": "right",
        "has-pager": !1,
        "current-card": e.currentCard,
        "total-cards": o.newsArticles.length,
        "section-header": e.sectionHeader,
        "theme-styles": i.themeStyles,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        default: S(() => [
          c("div", Vb, [
            (d(!0), f(J, null, ne(o.newsArticles, (u, m) => (d(), I(s, {
              ref_for: !0,
              ref: `sliderCard-${m}`,
              key: u.id,
              item: u,
              theme: e.theme,
              "is-preview": e.isPreview,
              "fallback-image": e.fallbackImage,
              "path-prefix": e.pathPrefix,
              "total-cards": e.articles.length,
              "card-number": m + 1,
              "show-published-time": "",
              variant: "N7-story",
              "data-testid": "news-story"
            }, null, 8, ["item", "theme", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
          ], 512)
        ]),
        _: 1
      }, 8, ["current-card", "total-cards", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"]),
      e.theme.style !== "bold" || e.screenSize < 960 ? (d(), I(a, {
        key: 0,
        class: _([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme
      }, {
        default: S(() => [
          (d(), I(Y(e.isEditing ? "button" : "a"), {
            class: _(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-bottom`,
            onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options"])) : T("", !0)
    ])
  ], 6);
}
const jb = /* @__PURE__ */ B(Nb, [["render", Bb], ["__scopeId", "data-v-68a98c6a"]]);
var rl, M2;
function Es() {
  if (M2) return rl;
  M2 = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || e;
    return n === o;
  }
  return rl = t, rl;
}
var ol, A2;
function cg() {
  if (A2) return ol;
  A2 = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return ol = e, ol;
}
var il, I2;
function Ub() {
  if (I2) return il;
  I2 = 1;
  var e = cg(), t = e(Object.keys, Object);
  return il = t, il;
}
var sl, L2;
function hg() {
  if (L2) return sl;
  L2 = 1;
  var e = Es(), t = Ub(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    if (!e(i))
      return t(i);
    var a = [];
    for (var s in Object(i))
      r.call(i, s) && s != "constructor" && a.push(s);
    return a;
  }
  return sl = o, sl;
}
var al, D2;
function qb() {
  if (D2) return al;
  D2 = 1;
  var e = Rr(), t = dn(), n = e(t, "DataView");
  return al = n, al;
}
var ll, $2;
function Gb() {
  if ($2) return ll;
  $2 = 1;
  var e = Rr(), t = dn(), n = e(t, "Promise");
  return ll = n, ll;
}
var ul, O2;
function Kb() {
  if (O2) return ul;
  O2 = 1;
  var e = Rr(), t = dn(), n = e(t, "Set");
  return ul = n, ul;
}
var dl, P2;
function zb() {
  if (P2) return dl;
  P2 = 1;
  var e = Rr(), t = dn(), n = e(t, "WeakMap");
  return dl = n, dl;
}
var cl, N2;
function Ss() {
  if (N2) return cl;
  N2 = 1;
  var e = qb(), t = t0(), n = Gb(), r = Kb(), o = zb(), i = ci(), a = ig(), s = "[object Map]", l = "[object Object]", u = "[object Promise]", m = "[object Set]", v = "[object WeakMap]", g = "[object DataView]", h = a(e), E = a(t), C = a(n), A = a(r), R = a(o), O = i;
  return (e && O(new e(new ArrayBuffer(1))) != g || t && O(new t()) != s || n && O(n.resolve()) != u || r && O(new r()) != m || o && O(new o()) != v) && (O = function(F) {
    var L = i(F), D = L == l ? F.constructor : void 0, P = D ? a(D) : "";
    if (P)
      switch (P) {
        case h:
          return g;
        case E:
          return s;
        case C:
          return u;
        case A:
          return m;
        case R:
          return v;
      }
    return L;
  }), cl = O, cl;
}
var hl, H2;
function Zb() {
  if (H2) return hl;
  H2 = 1;
  var e = ci(), t = wo(), n = "[object Arguments]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return hl = r, hl;
}
var ml, F2;
function mg() {
  if (F2) return ml;
  F2 = 1;
  var e = Zb(), t = wo(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !o.call(a, "callee");
  };
  return ml = i, ml;
}
var fl, R2;
function fg() {
  if (R2) return fl;
  R2 = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return fl = t, fl;
}
var pl, V2;
function Ms() {
  if (V2) return pl;
  V2 = 1;
  var e = og(), t = fg();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return pl = n, pl;
}
var Ko = { exports: {} }, gl, B2;
function xb() {
  if (B2) return gl;
  B2 = 1;
  function e() {
    return !1;
  }
  return gl = e, gl;
}
Ko.exports;
var j2;
function r0() {
  return j2 || (j2 = 1, function(e, t) {
    var n = dn(), r = xb(), o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || r;
    e.exports = u;
  }(Ko, Ko.exports)), Ko.exports;
}
var vl, U2;
function Wb() {
  if (U2) return vl;
  U2 = 1;
  var e = ci(), t = fg(), n = wo(), r = "[object Arguments]", o = "[object Array]", i = "[object Boolean]", a = "[object Date]", s = "[object Error]", l = "[object Function]", u = "[object Map]", m = "[object Number]", v = "[object Object]", g = "[object RegExp]", h = "[object Set]", E = "[object String]", C = "[object WeakMap]", A = "[object ArrayBuffer]", R = "[object DataView]", O = "[object Float32Array]", F = "[object Float64Array]", L = "[object Int8Array]", D = "[object Int16Array]", P = "[object Int32Array]", U = "[object Uint8Array]", q = "[object Uint8ClampedArray]", z = "[object Uint16Array]", te = "[object Uint32Array]", ee = {};
  ee[O] = ee[F] = ee[L] = ee[D] = ee[P] = ee[U] = ee[q] = ee[z] = ee[te] = !0, ee[r] = ee[o] = ee[A] = ee[i] = ee[R] = ee[a] = ee[s] = ee[l] = ee[u] = ee[m] = ee[v] = ee[g] = ee[h] = ee[E] = ee[C] = !1;
  function x(N) {
    return n(N) && t(N.length) && !!ee[e(N)];
  }
  return vl = x, vl;
}
var bl, q2;
function o0() {
  if (q2) return bl;
  q2 = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return bl = e, bl;
}
var zo = { exports: {} };
zo.exports;
var G2;
function i0() {
  return G2 || (G2 = 1, function(e, t) {
    var n = rg(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i && n.process, s = function() {
      try {
        var l = o && o.require && o.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch (u) {
      }
    }();
    e.exports = s;
  }(zo, zo.exports)), zo.exports;
}
var yl, K2;
function pg() {
  if (K2) return yl;
  K2 = 1;
  var e = Wb(), t = o0(), n = i0(), r = n && n.isTypedArray, o = r ? t(r) : e;
  return yl = o, yl;
}
var _l, z2;
function Yb() {
  if (z2) return _l;
  z2 = 1;
  var e = hg(), t = Ss(), n = mg(), r = Fr(), o = Ms(), i = r0(), a = Es(), s = pg(), l = "[object Map]", u = "[object Set]", m = Object.prototype, v = m.hasOwnProperty;
  function g(h) {
    if (h == null)
      return !0;
    if (o(h) && (r(h) || typeof h == "string" || typeof h.splice == "function" || i(h) || s(h) || n(h)))
      return !h.length;
    var E = t(h);
    if (E == l || E == u)
      return !h.size;
    if (a(h))
      return !e(h).length;
    for (var C in h)
      if (v.call(h, C))
        return !1;
    return !0;
  }
  return _l = g, _l;
}
var Xb = Yb();
const Br = /* @__PURE__ */ Co(Xb), Qb = {
  name: "News",
  components: {
    N1: gv,
    N2: wv,
    N3: Mv,
    N4: $v,
    N5: Ab,
    N6: Pb,
    N7: jb
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    newsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    sidebarOffset: {
      type: Number,
      default: 0
    },
    fallbackImage: {
      type: Object,
      default: () => {
      }
    },
    isIFrame: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      fallbackImageDefault: {
        url: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png",
        alt: "news default image"
      }
    };
  },
  computed: {
    cssVars() {
      return {
        "--sidebar-offset": `${this.sidebarOffset}px`
      };
    },
    fallbackImg() {
      return Br(this.fallbackImage) ? this.fallbackImageDefault : this.fallbackImage;
    }
  }
}, Jb = { id: "view-news" };
function ey(e, t, n, r, o, i) {
  return d(), f("div", Jb, [
    (d(), I(Y(n.theme.version), {
      style: Z(i.cssVars),
      theme: n.theme,
      articles: n.content,
      "news-config": n.newsConfig,
      "component-id": n.componentId,
      "is-preview": n.isPreview,
      "is-editing": n.isEditing,
      "is-i-frame": n.isIFrame,
      "fallback-image": i.fallbackImg,
      "path-prefix": n.pathPrefix,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["style", "theme", "articles", "news-config", "component-id", "is-preview", "is-editing", "is-i-frame", "fallback-image", "path-prefix"]))
  ]);
}
const ty = /* @__PURE__ */ B(Qb, [["render", ey], ["__scopeId", "data-v-b303fa92"]]);
function Vn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gg(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Kt = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, fo = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, s0, ct, Ge, en = 1e8, Fe = 1 / en, Cc = Math.PI * 2, ny = Cc / 4, ry = 0, vg = Math.sqrt, oy = Math.cos, iy = Math.sin, at = function(t) {
  return typeof t == "string";
}, Ye = function(t) {
  return typeof t == "function";
}, Gn = function(t) {
  return typeof t == "number";
}, a0 = function(t) {
  return typeof t == "undefined";
}, An = function(t) {
  return typeof t == "object";
}, Ot = function(t) {
  return t !== !1;
}, l0 = function() {
  return typeof window != "undefined";
}, Fi = function(t) {
  return Ye(t) || at(t);
}, bg = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, gt = Array.isArray, wc = /(?:-?\.?\d|\.)+/gi, yg = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, to = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, Cl = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, _g = /[+-]=-?[.\d]+/, Cg = /[^,'"\[\]\s]+/gi, sy = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, xe, Tn, Tc, u0, zt = {}, ns = {}, wg, Tg = function(t) {
  return (ns = po(t, zt)) && Ft;
}, d0 = function(t, n) {
  return console.warn("Invalid property", t, "set to", n, "Missing plugin? gsap.registerPlugin()");
}, ei = function(t, n) {
  return !n && console.warn(t);
}, kg = function(t, n) {
  return t && (zt[t] = n) && ns && (ns[t] = n) || zt;
}, ti = function() {
  return 0;
}, ay = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, Gi = {
  suppressEvents: !0,
  kill: !1
}, ly = {
  suppressEvents: !0
}, c0 = {}, ir = [], kc = {}, Eg, Ut = {}, wl = {}, Z2 = 30, Ki = [], h0 = "", m0 = function(t) {
  var n = t[0], r, o;
  if (An(n) || Ye(n) || (t = [t]), !(r = (n._gsap || {}).harness)) {
    for (o = Ki.length; o-- && !Ki[o].targetTest(n); )
      ;
    r = Ki[o];
  }
  for (o = t.length; o--; )
    t[o] && (t[o]._gsap || (t[o]._gsap = new Wg(t[o], r))) || t.splice(o, 1);
  return t;
}, Ir = function(t) {
  return t._gsap || m0(tn(t))[0]._gsap;
}, Sg = function(t, n, r) {
  return (r = t[n]) && Ye(r) ? t[n]() : a0(r) && t.getAttribute && t.getAttribute(n) || r;
}, Pt = function(t, n) {
  return (t = t.split(",")).forEach(n) || t;
}, Xe = function(t) {
  return Math.round(t * 1e5) / 1e5 || 0;
}, ot = function(t) {
  return Math.round(t * 1e7) / 1e7 || 0;
}, io = function(t, n) {
  var r = n.charAt(0), o = parseFloat(n.substr(2));
  return t = parseFloat(t), r === "+" ? t + o : r === "-" ? t - o : r === "*" ? t * o : t / o;
}, uy = function(t, n) {
  for (var r = n.length, o = 0; t.indexOf(n[o]) < 0 && ++o < r; )
    ;
  return o < r;
}, rs = function() {
  var t = ir.length, n = ir.slice(0), r, o;
  for (kc = {}, ir.length = 0, r = 0; r < t; r++)
    o = n[r], o && o._lazy && (o.render(o._lazy[0], o._lazy[1], !0)._lazy = 0);
}, f0 = function(t) {
  return !!(t._initted || t._startAt || t.add);
}, Mg = function(t, n, r, o) {
  ir.length && !ct && rs(), t.render(n, r, !!(ct && n < 0 && f0(t))), ir.length && !ct && rs();
}, Ag = function(t) {
  var n = parseFloat(t);
  return (n || n === 0) && (t + "").match(Cg).length < 2 ? n : at(t) ? t.trim() : t;
}, Ig = function(t) {
  return t;
}, Zt = function(t, n) {
  for (var r in n)
    r in t || (t[r] = n[r]);
  return t;
}, dy = function(t) {
  return function(n, r) {
    for (var o in r)
      o in n || o === "duration" && t || o === "ease" || (n[o] = r[o]);
  };
}, po = function(t, n) {
  for (var r in n)
    t[r] = n[r];
  return t;
}, x2 = function e(t, n) {
  for (var r in n)
    r !== "__proto__" && r !== "constructor" && r !== "prototype" && (t[r] = An(n[r]) ? e(t[r] || (t[r] = {}), n[r]) : n[r]);
  return t;
}, os = function(t, n) {
  var r = {}, o;
  for (o in t)
    o in n || (r[o] = t[o]);
  return r;
}, Yo = function(t) {
  var n = t.parent || xe, r = t.keyframes ? dy(gt(t.keyframes)) : Zt;
  if (Ot(t.inherit))
    for (; n; )
      r(t, n.vars.defaults), n = n.parent || n._dp;
  return t;
}, cy = function(t, n) {
  for (var r = t.length, o = r === n.length; o && r-- && t[r] === n[r]; )
    ;
  return r < 0;
}, Lg = function(t, n, r, o, i) {
  var a = t[o], s;
  if (i)
    for (s = n[i]; a && a[i] > s; )
      a = a._prev;
  return a ? (n._next = a._next, a._next = n) : (n._next = t[r], t[r] = n), n._next ? n._next._prev = n : t[o] = n, n._prev = a, n.parent = n._dp = t, n;
}, As = function(t, n, r, o) {
  r === void 0 && (r = "_first"), o === void 0 && (o = "_last");
  var i = n._prev, a = n._next;
  i ? i._next = a : t[r] === n && (t[r] = a), a ? a._prev = i : t[o] === n && (t[o] = i), n._next = n._prev = n.parent = null;
}, ar = function(t, n) {
  t.parent && (!n || t.parent.autoRemoveChildren) && t.parent.remove && t.parent.remove(t), t._act = 0;
}, Lr = function(t, n) {
  if (t && (!n || n._end > t._dur || n._start < 0))
    for (var r = t; r; )
      r._dirty = 1, r = r.parent;
  return t;
}, hy = function(t) {
  for (var n = t.parent; n && n.parent; )
    n._dirty = 1, n.totalDuration(), n = n.parent;
  return t;
}, Ec = function(t, n, r, o) {
  return t._startAt && (ct ? t._startAt.revert(Gi) : t.vars.immediateRender && !t.vars.autoRevert || t._startAt.render(n, !0, o));
}, my = function e(t) {
  return !t || t._ts && e(t.parent);
}, W2 = function(t) {
  return t._repeat ? go(t._tTime, t = t.duration() + t._rDelay) * t : 0;
}, go = function(t, n) {
  var r = Math.floor(t = ot(t / n));
  return t && r === t ? r - 1 : r;
}, is = function(t, n) {
  return (t - n._start) * n._ts + (n._ts >= 0 ? 0 : n._dirty ? n.totalDuration() : n._tDur);
}, Is = function(t) {
  return t._end = ot(t._start + (t._tDur / Math.abs(t._ts || t._rts || Fe) || 0));
}, Ls = function(t, n) {
  var r = t._dp;
  return r && r.smoothChildTiming && t._ts && (t._start = ot(r._time - (t._ts > 0 ? n / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - n) / -t._ts)), Is(t), r._dirty || Lr(r, t)), t;
}, Dg = function(t, n) {
  var r;
  if ((n._time || !n._dur && n._initted || n._start < t._time && (n._dur || !n.add)) && (r = is(t.rawTime(), n), (!n._dur || hi(0, n.totalDuration(), r) - n._tTime > Fe) && n.render(r, !0)), Lr(t, n)._dp && t._initted && t._time >= t._dur && t._ts) {
    if (t._dur < t.duration())
      for (r = t; r._dp; )
        r.rawTime() >= 0 && r.totalTime(r._tTime), r = r._dp;
    t._zTime = -Fe;
  }
}, En = function(t, n, r, o) {
  return n.parent && ar(n), n._start = ot((Gn(r) ? r : r || t !== xe ? Jt(t, r, n) : t._time) + n._delay), n._end = ot(n._start + (n.totalDuration() / Math.abs(n.timeScale()) || 0)), Lg(t, n, "_first", "_last", t._sort ? "_start" : 0), Sc(n) || (t._recent = n), o || Dg(t, n), t._ts < 0 && Ls(t, t._tTime), t;
}, $g = function(t, n) {
  return (zt.ScrollTrigger || d0("scrollTrigger", n)) && zt.ScrollTrigger.create(n, t);
}, Og = function(t, n, r, o, i) {
  if (g0(t, n, i), !t._initted)
    return 1;
  if (!r && t._pt && !ct && (t._dur && t.vars.lazy !== !1 || !t._dur && t.vars.lazy) && Eg !== qt.frame)
    return ir.push(t), t._lazy = [i, o], 1;
}, fy = function e(t) {
  var n = t.parent;
  return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || e(n));
}, Sc = function(t) {
  var n = t.data;
  return n === "isFromStart" || n === "isStart";
}, py = function(t, n, r, o) {
  var i = t.ratio, a = n < 0 || !n && (!t._start && fy(t) && !(!t._initted && Sc(t)) || (t._ts < 0 || t._dp._ts < 0) && !Sc(t)) ? 0 : 1, s = t._rDelay, l = 0, u, m, v;
  if (s && t._repeat && (l = hi(0, t._tDur, n), m = go(l, s), t._yoyo && m & 1 && (a = 1 - a), m !== go(t._tTime, s) && (i = 1 - a, t.vars.repeatRefresh && t._initted && t.invalidate())), a !== i || ct || o || t._zTime === Fe || !n && t._zTime) {
    if (!t._initted && Og(t, n, o, r, l))
      return;
    for (v = t._zTime, t._zTime = n || (r ? Fe : 0), r || (r = n && !v), t.ratio = a, t._from && (a = 1 - a), t._time = 0, t._tTime = l, u = t._pt; u; )
      u.r(a, u.d), u = u._next;
    n < 0 && Ec(t, n, r, !0), t._onUpdate && !r && Gt(t, "onUpdate"), l && t._repeat && !r && t.parent && Gt(t, "onRepeat"), (n >= t._tDur || n < 0) && t.ratio === a && (a && ar(t, 1), !r && !ct && (Gt(t, a ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
  } else t._zTime || (t._zTime = n);
}, gy = function(t, n, r) {
  var o;
  if (r > n)
    for (o = t._first; o && o._start <= r; ) {
      if (o.data === "isPause" && o._start > n)
        return o;
      o = o._next;
    }
  else
    for (o = t._last; o && o._start >= r; ) {
      if (o.data === "isPause" && o._start < n)
        return o;
      o = o._prev;
    }
}, vo = function(t, n, r, o) {
  var i = t._repeat, a = ot(n) || 0, s = t._tTime / t._tDur;
  return s && !o && (t._time *= a / t._dur), t._dur = a, t._tDur = i ? i < 0 ? 1e10 : ot(a * (i + 1) + t._rDelay * i) : a, s > 0 && !o && Ls(t, t._tTime = t._tDur * s), t.parent && Is(t), r || Lr(t.parent, t), t;
}, Y2 = function(t) {
  return t instanceof wt ? Lr(t) : vo(t, t._dur);
}, vy = {
  _start: 0,
  endTime: ti,
  totalDuration: ti
}, Jt = function e(t, n, r) {
  var o = t.labels, i = t._recent || vy, a = t.duration() >= en ? i.endTime(!1) : t._dur, s, l, u;
  return at(n) && (isNaN(n) || n in o) ? (l = n.charAt(0), u = n.substr(-1) === "%", s = n.indexOf("="), l === "<" || l === ">" ? (s >= 0 && (n = n.replace(/=/, "")), (l === "<" ? i._start : i.endTime(i._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (u ? (s < 0 ? i : r).totalDuration() / 100 : 1)) : s < 0 ? (n in o || (o[n] = a), o[n]) : (l = parseFloat(n.charAt(s - 1) + n.substr(s + 1)), u && r && (l = l / 100 * (gt(r) ? r[0] : r).totalDuration()), s > 1 ? e(t, n.substr(0, s - 1), r) + l : a + l)) : n == null ? a : +n;
}, Xo = function(t, n, r) {
  var o = Gn(n[1]), i = (o ? 2 : 1) + (t < 2 ? 0 : 1), a = n[i], s, l;
  if (o && (a.duration = n[1]), a.parent = r, t) {
    for (s = a, l = r; l && !("immediateRender" in s); )
      s = l.vars.defaults || {}, l = Ot(l.vars.inherit) && l.parent;
    a.immediateRender = Ot(s.immediateRender), t < 2 ? a.runBackwards = 1 : a.startAt = n[i - 1];
  }
  return new rt(n[0], a, n[i + 1]);
}, cr = function(t, n) {
  return t || t === 0 ? n(t) : n;
}, hi = function(t, n, r) {
  return r < t ? t : r > n ? n : r;
}, pt = function(t, n) {
  return !at(t) || !(n = sy.exec(t)) ? "" : n[1];
}, by = function(t, n, r) {
  return cr(r, function(o) {
    return hi(t, n, o);
  });
}, Mc = [].slice, Pg = function(t, n) {
  return t && An(t) && "length" in t && (!n && !t.length || t.length - 1 in t && An(t[0])) && !t.nodeType && t !== Tn;
}, yy = function(t, n, r) {
  return r === void 0 && (r = []), t.forEach(function(o) {
    var i;
    return at(o) && !n || Pg(o, 1) ? (i = r).push.apply(i, tn(o)) : r.push(o);
  }) || r;
}, tn = function(t, n, r) {
  return Ge && !n && Ge.selector ? Ge.selector(t) : at(t) && !r && (Tc || !bo()) ? Mc.call((n || u0).querySelectorAll(t), 0) : gt(t) ? yy(t, r) : Pg(t) ? Mc.call(t, 0) : t ? [t] : [];
}, Ac = function(t) {
  return t = tn(t)[0] || ei("Invalid scope") || {}, function(n) {
    var r = t.current || t.nativeElement || t;
    return tn(n, r.querySelectorAll ? r : r === t ? ei("Invalid scope") || u0.createElement("div") : t);
  };
}, Ng = function(t) {
  return t.sort(function() {
    return 0.5 - Math.random();
  });
}, Hg = function(t) {
  if (Ye(t))
    return t;
  var n = An(t) ? t : {
    each: t
  }, r = Dr(n.ease), o = n.from || 0, i = parseFloat(n.base) || 0, a = {}, s = o > 0 && o < 1, l = isNaN(o) || s, u = n.axis, m = o, v = o;
  return at(o) ? m = v = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[o] || 0 : !s && l && (m = o[0], v = o[1]), function(g, h, E) {
    var C = (E || n).length, A = a[C], R, O, F, L, D, P, U, q, z;
    if (!A) {
      if (z = n.grid === "auto" ? 0 : (n.grid || [1, en])[1], !z) {
        for (U = -en; U < (U = E[z++].getBoundingClientRect().left) && z < C; )
          ;
        z < C && z--;
      }
      for (A = a[C] = [], R = l ? Math.min(z, C) * m - 0.5 : o % z, O = z === en ? 0 : l ? C * v / z - 0.5 : o / z | 0, U = 0, q = en, P = 0; P < C; P++)
        F = P % z - R, L = O - (P / z | 0), A[P] = D = u ? Math.abs(u === "y" ? L : F) : vg(F * F + L * L), D > U && (U = D), D < q && (q = D);
      o === "random" && Ng(A), A.max = U - q, A.min = q, A.v = C = (parseFloat(n.amount) || parseFloat(n.each) * (z > C ? C - 1 : u ? u === "y" ? C / z : z : Math.max(z, C / z)) || 0) * (o === "edges" ? -1 : 1), A.b = C < 0 ? i - C : i, A.u = pt(n.amount || n.each) || 0, r = r && C < 0 ? zg(r) : r;
    }
    return C = (A[g] - A.min) / A.max || 0, ot(A.b + (r ? r(C) : C) * A.v) + A.u;
  };
}, Ic = function(t) {
  var n = Math.pow(10, ((t + "").split(".")[1] || "").length);
  return function(r) {
    var o = ot(Math.round(parseFloat(r) / t) * t * n);
    return (o - o % 1) / n + (Gn(r) ? 0 : pt(r));
  };
}, Fg = function(t, n) {
  var r = gt(t), o, i;
  return !r && An(t) && (o = r = t.radius || en, t.values ? (t = tn(t.values), (i = !Gn(t[0])) && (o *= o)) : t = Ic(t.increment)), cr(n, r ? Ye(t) ? function(a) {
    return i = t(a), Math.abs(i - a) <= o ? i : a;
  } : function(a) {
    for (var s = parseFloat(i ? a.x : a), l = parseFloat(i ? a.y : 0), u = en, m = 0, v = t.length, g, h; v--; )
      i ? (g = t[v].x - s, h = t[v].y - l, g = g * g + h * h) : g = Math.abs(t[v] - s), g < u && (u = g, m = v);
    return m = !o || u <= o ? t[m] : a, i || m === a || Gn(a) ? m : m + pt(a);
  } : Ic(t));
}, Rg = function(t, n, r, o) {
  return cr(gt(t) ? !n : r === !0 ? !!(r = 0) : !o, function() {
    return gt(t) ? t[~~(Math.random() * t.length)] : (r = r || 1e-5) && (o = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) && Math.floor(Math.round((t - r / 2 + Math.random() * (n - t + r * 0.99)) / r) * r * o) / o;
  });
}, _y = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return function(o) {
    return n.reduce(function(i, a) {
      return a(i);
    }, o);
  };
}, Cy = function(t, n) {
  return function(r) {
    return t(parseFloat(r)) + (n || pt(r));
  };
}, wy = function(t, n, r) {
  return Bg(t, n, 0, 1, r);
}, Vg = function(t, n, r) {
  return cr(r, function(o) {
    return t[~~n(o)];
  });
}, Ty = function e(t, n, r) {
  var o = n - t;
  return gt(t) ? Vg(t, e(0, t.length), n) : cr(r, function(i) {
    return (o + (i - t) % o) % o + t;
  });
}, ky = function e(t, n, r) {
  var o = n - t, i = o * 2;
  return gt(t) ? Vg(t, e(0, t.length - 1), n) : cr(r, function(a) {
    return a = (i + (a - t) % i) % i || 0, t + (a > o ? i - a : a);
  });
}, ni = function(t) {
  for (var n = 0, r = "", o, i, a, s; ~(o = t.indexOf("random(", n)); )
    a = t.indexOf(")", o), s = t.charAt(o + 7) === "[", i = t.substr(o + 7, a - o - 7).match(s ? Cg : wc), r += t.substr(n, o - n) + Rg(s ? i : +i[0], s ? 0 : +i[1], +i[2] || 1e-5), n = a + 1;
  return r + t.substr(n, t.length - n);
}, Bg = function(t, n, r, o, i) {
  var a = n - t, s = o - r;
  return cr(i, function(l) {
    return r + ((l - t) / a * s || 0);
  });
}, Ey = function e(t, n, r, o) {
  var i = isNaN(t + n) ? 0 : function(h) {
    return (1 - h) * t + h * n;
  };
  if (!i) {
    var a = at(t), s = {}, l, u, m, v, g;
    if (r === !0 && (o = 1) && (r = null), a)
      t = {
        p: t
      }, n = {
        p: n
      };
    else if (gt(t) && !gt(n)) {
      for (m = [], v = t.length, g = v - 2, u = 1; u < v; u++)
        m.push(e(t[u - 1], t[u]));
      v--, i = function(E) {
        E *= v;
        var C = Math.min(g, ~~E);
        return m[C](E - C);
      }, r = n;
    } else o || (t = po(gt(t) ? [] : {}, t));
    if (!m) {
      for (l in n)
        p0.call(s, t, l, "get", n[l]);
      i = function(E) {
        return y0(E, s) || (a ? t.p : t);
      };
    }
  }
  return cr(r, i);
}, X2 = function(t, n, r) {
  var o = t.labels, i = en, a, s, l;
  for (a in o)
    s = o[a] - n, s < 0 == !!r && s && i > (s = Math.abs(s)) && (l = a, i = s);
  return l;
}, Gt = function(t, n, r) {
  var o = t.vars, i = o[n], a = Ge, s = t._ctx, l, u, m;
  if (i)
    return l = o[n + "Params"], u = o.callbackScope || t, r && ir.length && rs(), s && (Ge = s), m = l ? i.apply(u, l) : i.call(u), Ge = a, m;
}, Zo = function(t) {
  return ar(t), t.scrollTrigger && t.scrollTrigger.kill(!!ct), t.progress() < 1 && Gt(t, "onInterrupt"), t;
}, no, jg = [], Ug = function(t) {
  if (t)
    if (t = !t.name && t.default || t, l0() || t.headless) {
      var n = t.name, r = Ye(t), o = n && !r && t.init ? function() {
        this._props = [];
      } : t, i = {
        init: ti,
        render: y0,
        add: p0,
        kill: jy,
        modifier: By,
        rawVars: 0
      }, a = {
        targetTest: 0,
        get: 0,
        getSetter: b0,
        aliases: {},
        register: 0
      };
      if (bo(), t !== o) {
        if (Ut[n])
          return;
        Zt(o, Zt(os(t, i), a)), po(o.prototype, po(i, os(t, a))), Ut[o.prop = n] = o, t.targetTest && (Ki.push(o), c0[n] = 1), n = (n === "css" ? "CSS" : n.charAt(0).toUpperCase() + n.substr(1)) + "Plugin";
      }
      kg(n, o), t.register && t.register(Ft, o, Nt);
    } else
      jg.push(t);
}, He = 255, xo = {
  aqua: [0, He, He],
  lime: [0, He, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, He],
  navy: [0, 0, 128],
  white: [He, He, He],
  olive: [128, 128, 0],
  yellow: [He, He, 0],
  orange: [He, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [He, 0, 0],
  pink: [He, 192, 203],
  cyan: [0, He, He],
  transparent: [He, He, He, 0]
}, Tl = function(t, n, r) {
  return t += t < 0 ? 1 : t > 1 ? -1 : 0, (t * 6 < 1 ? n + (r - n) * t * 6 : t < 0.5 ? r : t * 3 < 2 ? n + (r - n) * (2 / 3 - t) * 6 : n) * He + 0.5 | 0;
}, qg = function(t, n, r) {
  var o = t ? Gn(t) ? [t >> 16, t >> 8 & He, t & He] : 0 : xo.black, i, a, s, l, u, m, v, g, h, E;
  if (!o) {
    if (t.substr(-1) === "," && (t = t.substr(0, t.length - 1)), xo[t])
      o = xo[t];
    else if (t.charAt(0) === "#") {
      if (t.length < 6 && (i = t.charAt(1), a = t.charAt(2), s = t.charAt(3), t = "#" + i + i + a + a + s + s + (t.length === 5 ? t.charAt(4) + t.charAt(4) : "")), t.length === 9)
        return o = parseInt(t.substr(1, 6), 16), [o >> 16, o >> 8 & He, o & He, parseInt(t.substr(7), 16) / 255];
      t = parseInt(t.substr(1), 16), o = [t >> 16, t >> 8 & He, t & He];
    } else if (t.substr(0, 3) === "hsl") {
      if (o = E = t.match(wc), !n)
        l = +o[0] % 360 / 360, u = +o[1] / 100, m = +o[2] / 100, a = m <= 0.5 ? m * (u + 1) : m + u - m * u, i = m * 2 - a, o.length > 3 && (o[3] *= 1), o[0] = Tl(l + 1 / 3, i, a), o[1] = Tl(l, i, a), o[2] = Tl(l - 1 / 3, i, a);
      else if (~t.indexOf("="))
        return o = t.match(yg), r && o.length < 4 && (o[3] = 1), o;
    } else
      o = t.match(wc) || xo.transparent;
    o = o.map(Number);
  }
  return n && !E && (i = o[0] / He, a = o[1] / He, s = o[2] / He, v = Math.max(i, a, s), g = Math.min(i, a, s), m = (v + g) / 2, v === g ? l = u = 0 : (h = v - g, u = m > 0.5 ? h / (2 - v - g) : h / (v + g), l = v === i ? (a - s) / h + (a < s ? 6 : 0) : v === a ? (s - i) / h + 2 : (i - a) / h + 4, l *= 60), o[0] = ~~(l + 0.5), o[1] = ~~(u * 100 + 0.5), o[2] = ~~(m * 100 + 0.5)), r && o.length < 4 && (o[3] = 1), o;
}, Gg = function(t) {
  var n = [], r = [], o = -1;
  return t.split(sr).forEach(function(i) {
    var a = i.match(to) || [];
    n.push.apply(n, a), r.push(o += a.length + 1);
  }), n.c = r, n;
}, Q2 = function(t, n, r) {
  var o = "", i = (t + o).match(sr), a = n ? "hsla(" : "rgba(", s = 0, l, u, m, v;
  if (!i)
    return t;
  if (i = i.map(function(g) {
    return (g = qg(g, n, 1)) && a + (n ? g[0] + "," + g[1] + "%," + g[2] + "%," + g[3] : g.join(",")) + ")";
  }), r && (m = Gg(t), l = r.c, l.join(o) !== m.c.join(o)))
    for (u = t.replace(sr, "1").split(to), v = u.length - 1; s < v; s++)
      o += u[s] + (~l.indexOf(s) ? i.shift() || a + "0,0,0,0)" : (m.length ? m : i.length ? i : r).shift());
  if (!u)
    for (u = t.split(sr), v = u.length - 1; s < v; s++)
      o += u[s] + i[s];
  return o + u[v];
}, sr = function() {
  var e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", t;
  for (t in xo)
    e += "|" + t + "\\b";
  return new RegExp(e + ")", "gi");
}(), Sy = /hsl[a]?\(/, Kg = function(t) {
  var n = t.join(" "), r;
  if (sr.lastIndex = 0, sr.test(n))
    return r = Sy.test(n), t[1] = Q2(t[1], r), t[0] = Q2(t[0], r, Gg(t[1])), !0;
}, ri, qt = function() {
  var e = Date.now, t = 500, n = 33, r = e(), o = r, i = 1e3 / 240, a = i, s = [], l, u, m, v, g, h, E = function C(A) {
    var R = e() - o, O = A === !0, F, L, D, P;
    if ((R > t || R < 0) && (r += R - n), o += R, D = o - r, F = D - a, (F > 0 || O) && (P = ++v.frame, g = D - v.time * 1e3, v.time = D = D / 1e3, a += F + (F >= i ? 4 : i - F), L = 1), O || (l = u(C)), L)
      for (h = 0; h < s.length; h++)
        s[h](D, g, P, A);
  };
  return v = {
    time: 0,
    frame: 0,
    tick: function() {
      E(!0);
    },
    deltaRatio: function(A) {
      return g / (1e3 / (A || 60));
    },
    wake: function() {
      wg && (!Tc && l0() && (Tn = Tc = window, u0 = Tn.document || {}, zt.gsap = Ft, (Tn.gsapVersions || (Tn.gsapVersions = [])).push(Ft.version), Tg(ns || Tn.GreenSockGlobals || !Tn.gsap && Tn || {}), jg.forEach(Ug)), m = typeof requestAnimationFrame != "undefined" && requestAnimationFrame, l && v.sleep(), u = m || function(A) {
        return setTimeout(A, a - v.time * 1e3 + 1 | 0);
      }, ri = 1, E(2));
    },
    sleep: function() {
      (m ? cancelAnimationFrame : clearTimeout)(l), ri = 0, u = ti;
    },
    lagSmoothing: function(A, R) {
      t = A || 1 / 0, n = Math.min(R || 33, t);
    },
    fps: function(A) {
      i = 1e3 / (A || 240), a = v.time * 1e3 + i;
    },
    add: function(A, R, O) {
      var F = R ? function(L, D, P, U) {
        A(L, D, P, U), v.remove(F);
      } : A;
      return v.remove(A), s[O ? "unshift" : "push"](F), bo(), F;
    },
    remove: function(A, R) {
      ~(R = s.indexOf(A)) && s.splice(R, 1) && h >= R && h--;
    },
    _listeners: s
  }, v;
}(), bo = function() {
  return !ri && qt.wake();
}, Ee = {}, My = /^[\d.\-M][\d.\-,\s]/, Ay = /["']/g, Iy = function(t) {
  for (var n = {}, r = t.substr(1, t.length - 3).split(":"), o = r[0], i = 1, a = r.length, s, l, u; i < a; i++)
    l = r[i], s = i !== a - 1 ? l.lastIndexOf(",") : l.length, u = l.substr(0, s), n[o] = isNaN(u) ? u.replace(Ay, "").trim() : +u, o = l.substr(s + 1).trim();
  return n;
}, Ly = function(t) {
  var n = t.indexOf("(") + 1, r = t.indexOf(")"), o = t.indexOf("(", n);
  return t.substring(n, ~o && o < r ? t.indexOf(")", r + 1) : r);
}, Dy = function(t) {
  var n = (t + "").split("("), r = Ee[n[0]];
  return r && n.length > 1 && r.config ? r.config.apply(null, ~t.indexOf("{") ? [Iy(n[1])] : Ly(t).split(",").map(Ag)) : Ee._CE && My.test(t) ? Ee._CE("", t) : r;
}, zg = function(t) {
  return function(n) {
    return 1 - t(1 - n);
  };
}, Zg = function e(t, n) {
  for (var r = t._first, o; r; )
    r instanceof wt ? e(r, n) : r.vars.yoyoEase && (!r._yoyo || !r._repeat) && r._yoyo !== n && (r.timeline ? e(r.timeline, n) : (o = r._ease, r._ease = r._yEase, r._yEase = o, r._yoyo = n)), r = r._next;
}, Dr = function(t, n) {
  return t && (Ye(t) ? t : Ee[t] || Dy(t)) || n;
}, jr = function(t, n, r, o) {
  r === void 0 && (r = function(l) {
    return 1 - n(1 - l);
  }), o === void 0 && (o = function(l) {
    return l < 0.5 ? n(l * 2) / 2 : 1 - n((1 - l) * 2) / 2;
  });
  var i = {
    easeIn: n,
    easeOut: r,
    easeInOut: o
  }, a;
  return Pt(t, function(s) {
    Ee[s] = zt[s] = i, Ee[a = s.toLowerCase()] = r;
    for (var l in i)
      Ee[a + (l === "easeIn" ? ".in" : l === "easeOut" ? ".out" : ".inOut")] = Ee[s + "." + l] = i[l];
  }), i;
}, xg = function(t) {
  return function(n) {
    return n < 0.5 ? (1 - t(1 - n * 2)) / 2 : 0.5 + t((n - 0.5) * 2) / 2;
  };
}, kl = function e(t, n, r) {
  var o = n >= 1 ? n : 1, i = (r || (t ? 0.3 : 0.45)) / (n < 1 ? n : 1), a = i / Cc * (Math.asin(1 / o) || 0), s = function(m) {
    return m === 1 ? 1 : o * Math.pow(2, -10 * m) * iy((m - a) * i) + 1;
  }, l = t === "out" ? s : t === "in" ? function(u) {
    return 1 - s(1 - u);
  } : xg(s);
  return i = Cc / i, l.config = function(u, m) {
    return e(t, u, m);
  }, l;
}, El = function e(t, n) {
  n === void 0 && (n = 1.70158);
  var r = function(a) {
    return a ? --a * a * ((n + 1) * a + n) + 1 : 0;
  }, o = t === "out" ? r : t === "in" ? function(i) {
    return 1 - r(1 - i);
  } : xg(r);
  return o.config = function(i) {
    return e(t, i);
  }, o;
};
Pt("Linear,Quad,Cubic,Quart,Quint,Strong", function(e, t) {
  var n = t < 5 ? t + 1 : t;
  jr(e + ",Power" + (n - 1), t ? function(r) {
    return Math.pow(r, n);
  } : function(r) {
    return r;
  }, function(r) {
    return 1 - Math.pow(1 - r, n);
  }, function(r) {
    return r < 0.5 ? Math.pow(r * 2, n) / 2 : 1 - Math.pow((1 - r) * 2, n) / 2;
  });
});
Ee.Linear.easeNone = Ee.none = Ee.Linear.easeIn;
jr("Elastic", kl("in"), kl("out"), kl());
(function(e, t) {
  var n = 1 / t, r = 2 * n, o = 2.5 * n, i = function(s) {
    return s < n ? e * s * s : s < r ? e * Math.pow(s - 1.5 / t, 2) + 0.75 : s < o ? e * (s -= 2.25 / t) * s + 0.9375 : e * Math.pow(s - 2.625 / t, 2) + 0.984375;
  };
  jr("Bounce", function(a) {
    return 1 - i(1 - a);
  }, i);
})(7.5625, 2.75);
jr("Expo", function(e) {
  return Math.pow(2, 10 * (e - 1)) * e + e * e * e * e * e * e * (1 - e);
});
jr("Circ", function(e) {
  return -(vg(1 - e * e) - 1);
});
jr("Sine", function(e) {
  return e === 1 ? 1 : -oy(e * ny) + 1;
});
jr("Back", El("in"), El("out"), El());
Ee.SteppedEase = Ee.steps = zt.SteppedEase = {
  config: function(t, n) {
    t === void 0 && (t = 1);
    var r = 1 / t, o = t + (n ? 0 : 1), i = n ? 1 : 0, a = 1 - Fe;
    return function(s) {
      return ((o * hi(0, a, s) | 0) + i) * r;
    };
  }
};
fo.ease = Ee["quad.out"];
Pt("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(e) {
  return h0 += e + "," + e + "Params,";
});
var Wg = function(t, n) {
  this.id = ry++, t._gsap = this, this.target = t, this.harness = n, this.get = n ? n.get : Sg, this.set = n ? n.getSetter : b0;
}, oi = /* @__PURE__ */ function() {
  function e(n) {
    this.vars = n, this._delay = +n.delay || 0, (this._repeat = n.repeat === 1 / 0 ? -2 : n.repeat || 0) && (this._rDelay = n.repeatDelay || 0, this._yoyo = !!n.yoyo || !!n.yoyoEase), this._ts = 1, vo(this, +n.duration, 1, 1), this.data = n.data, Ge && (this._ctx = Ge, Ge.data.push(this)), ri || qt.wake();
  }
  var t = e.prototype;
  return t.delay = function(r) {
    return r || r === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + r - this._delay), this._delay = r, this) : this._delay;
  }, t.duration = function(r) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? r + (r + this._rDelay) * this._repeat : r) : this.totalDuration() && this._dur;
  }, t.totalDuration = function(r) {
    return arguments.length ? (this._dirty = 0, vo(this, this._repeat < 0 ? r : (r - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, t.totalTime = function(r, o) {
    if (bo(), !arguments.length)
      return this._tTime;
    var i = this._dp;
    if (i && i.smoothChildTiming && this._ts) {
      for (Ls(this, r), !i._dp || i.parent || Dg(i, this); i && i.parent; )
        i.parent._time !== i._start + (i._ts >= 0 ? i._tTime / i._ts : (i.totalDuration() - i._tTime) / -i._ts) && i.totalTime(i._tTime, !0), i = i.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && r < this._tDur || this._ts < 0 && r > 0 || !this._tDur && !r) && En(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== r || !this._dur && !o || this._initted && Math.abs(this._zTime) === Fe || !r && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = r), Mg(this, r, o)), this;
  }, t.time = function(r, o) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), r + W2(this)) % (this._dur + this._rDelay) || (r ? this._dur : 0), o) : this._time;
  }, t.totalProgress = function(r, o) {
    return arguments.length ? this.totalTime(this.totalDuration() * r, o) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, t.progress = function(r, o) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - r : r) + W2(this), o) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, t.iteration = function(r, o) {
    var i = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (r - 1) * i, o) : this._repeat ? go(this._tTime, i) + 1 : 1;
  }, t.timeScale = function(r, o) {
    if (!arguments.length)
      return this._rts === -Fe ? 0 : this._rts;
    if (this._rts === r)
      return this;
    var i = this.parent && this._ts ? is(this.parent._time, this) : this._tTime;
    return this._rts = +r || 0, this._ts = this._ps || r === -Fe ? 0 : this._rts, this.totalTime(hi(-Math.abs(this._delay), this.totalDuration(), i), o !== !1), Is(this), hy(this);
  }, t.paused = function(r) {
    return arguments.length ? (this._ps !== r && (this._ps = r, r ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (bo(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== Fe && (this._tTime -= Fe)))), this) : this._ps;
  }, t.startTime = function(r) {
    if (arguments.length) {
      this._start = r;
      var o = this.parent || this._dp;
      return o && (o._sort || !this.parent) && En(o, this, r - this._delay), this;
    }
    return this._start;
  }, t.endTime = function(r) {
    return this._start + (Ot(r) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, t.rawTime = function(r) {
    var o = this.parent || this._dp;
    return o ? r && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? is(o.rawTime(r), this) : this._tTime : this._tTime;
  }, t.revert = function(r) {
    r === void 0 && (r = ly);
    var o = ct;
    return ct = r, f0(this) && (this.timeline && this.timeline.revert(r), this.totalTime(-0.01, r.suppressEvents)), this.data !== "nested" && r.kill !== !1 && this.kill(), ct = o, this;
  }, t.globalTime = function(r) {
    for (var o = this, i = arguments.length ? r : o.rawTime(); o; )
      i = o._start + i / (Math.abs(o._ts) || 1), o = o._dp;
    return !this.parent && this._sat ? this._sat.globalTime(r) : i;
  }, t.repeat = function(r) {
    return arguments.length ? (this._repeat = r === 1 / 0 ? -2 : r, Y2(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, t.repeatDelay = function(r) {
    if (arguments.length) {
      var o = this._time;
      return this._rDelay = r, Y2(this), o ? this.time(o) : this;
    }
    return this._rDelay;
  }, t.yoyo = function(r) {
    return arguments.length ? (this._yoyo = r, this) : this._yoyo;
  }, t.seek = function(r, o) {
    return this.totalTime(Jt(this, r), Ot(o));
  }, t.restart = function(r, o) {
    return this.play().totalTime(r ? -this._delay : 0, Ot(o)), this._dur || (this._zTime = -Fe), this;
  }, t.play = function(r, o) {
    return r != null && this.seek(r, o), this.reversed(!1).paused(!1);
  }, t.reverse = function(r, o) {
    return r != null && this.seek(r || this.totalDuration(), o), this.reversed(!0).paused(!1);
  }, t.pause = function(r, o) {
    return r != null && this.seek(r, o), this.paused(!0);
  }, t.resume = function() {
    return this.paused(!1);
  }, t.reversed = function(r) {
    return arguments.length ? (!!r !== this.reversed() && this.timeScale(-this._rts || (r ? -Fe : 0)), this) : this._rts < 0;
  }, t.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -Fe, this;
  }, t.isActive = function() {
    var r = this.parent || this._dp, o = this._start, i;
    return !!(!r || this._ts && this._initted && r.isActive() && (i = r.rawTime(!0)) >= o && i < this.endTime(!0) - Fe);
  }, t.eventCallback = function(r, o, i) {
    var a = this.vars;
    return arguments.length > 1 ? (o ? (a[r] = o, i && (a[r + "Params"] = i), r === "onUpdate" && (this._onUpdate = o)) : delete a[r], this) : a[r];
  }, t.then = function(r) {
    var o = this;
    return new Promise(function(i) {
      var a = Ye(r) ? r : Ig, s = function() {
        var u = o.then;
        o.then = null, Ye(a) && (a = a(o)) && (a.then || a === o) && (o.then = u), i(a), o.then = u;
      };
      o._initted && o.totalProgress() === 1 && o._ts >= 0 || !o._tTime && o._ts < 0 ? s() : o._prom = s;
    });
  }, t.kill = function() {
    Zo(this);
  }, e;
}();
Zt(oi.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -Fe,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var wt = /* @__PURE__ */ function(e) {
  gg(t, e);
  function t(r, o) {
    var i;
    return r === void 0 && (r = {}), i = e.call(this, r) || this, i.labels = {}, i.smoothChildTiming = !!r.smoothChildTiming, i.autoRemoveChildren = !!r.autoRemoveChildren, i._sort = Ot(r.sortChildren), xe && En(r.parent || xe, Vn(i), o), r.reversed && i.reverse(), r.paused && i.paused(!0), r.scrollTrigger && $g(Vn(i), r.scrollTrigger), i;
  }
  var n = t.prototype;
  return n.to = function(o, i, a) {
    return Xo(0, arguments, this), this;
  }, n.from = function(o, i, a) {
    return Xo(1, arguments, this), this;
  }, n.fromTo = function(o, i, a, s) {
    return Xo(2, arguments, this), this;
  }, n.set = function(o, i, a) {
    return i.duration = 0, i.parent = this, Yo(i).repeatDelay || (i.repeat = 0), i.immediateRender = !!i.immediateRender, new rt(o, i, Jt(this, a), 1), this;
  }, n.call = function(o, i, a) {
    return En(this, rt.delayedCall(0, o, i), a);
  }, n.staggerTo = function(o, i, a, s, l, u, m) {
    return a.duration = i, a.stagger = a.stagger || s, a.onComplete = u, a.onCompleteParams = m, a.parent = this, new rt(o, a, Jt(this, l)), this;
  }, n.staggerFrom = function(o, i, a, s, l, u, m) {
    return a.runBackwards = 1, Yo(a).immediateRender = Ot(a.immediateRender), this.staggerTo(o, i, a, s, l, u, m);
  }, n.staggerFromTo = function(o, i, a, s, l, u, m, v) {
    return s.startAt = a, Yo(s).immediateRender = Ot(s.immediateRender), this.staggerTo(o, i, s, l, u, m, v);
  }, n.render = function(o, i, a) {
    var s = this._time, l = this._dirty ? this.totalDuration() : this._tDur, u = this._dur, m = o <= 0 ? 0 : ot(o), v = this._zTime < 0 != o < 0 && (this._initted || !u), g, h, E, C, A, R, O, F, L, D, P, U;
    if (this !== xe && m > l && o >= 0 && (m = l), m !== this._tTime || a || v) {
      if (s !== this._time && u && (m += this._time - s, o += this._time - s), g = m, L = this._start, F = this._ts, R = !F, v && (u || (s = this._zTime), (o || !i) && (this._zTime = o)), this._repeat) {
        if (P = this._yoyo, A = u + this._rDelay, this._repeat < -1 && o < 0)
          return this.totalTime(A * 100 + o, i, a);
        if (g = ot(m % A), m === l ? (C = this._repeat, g = u) : (D = ot(m / A), C = ~~D, C && C === D && (g = u, C--), g > u && (g = u)), D = go(this._tTime, A), !s && this._tTime && D !== C && this._tTime - D * A - this._dur <= 0 && (D = C), P && C & 1 && (g = u - g, U = 1), C !== D && !this._lock) {
          var q = P && D & 1, z = q === (P && C & 1);
          if (C < D && (q = !q), s = q ? 0 : m % u ? u : m, this._lock = 1, this.render(s || (U ? 0 : ot(C * A)), i, !u)._lock = 0, this._tTime = m, !i && this.parent && Gt(this, "onRepeat"), this.vars.repeatRefresh && !U && (this.invalidate()._lock = 1), s && s !== this._time || R !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (u = this._dur, l = this._tDur, z && (this._lock = 2, s = q ? u : -1e-4, this.render(s, !0), this.vars.repeatRefresh && !U && this.invalidate()), this._lock = 0, !this._ts && !R)
            return this;
          Zg(this, U);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (O = gy(this, ot(s), ot(g)), O && (m -= g - (g = O._start))), this._tTime = m, this._time = g, this._act = !F, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = o, s = 0), !s && m && !i && !D && (Gt(this, "onStart"), this._tTime !== m))
        return this;
      if (g >= s && o >= 0)
        for (h = this._first; h; ) {
          if (E = h._next, (h._act || g >= h._start) && h._ts && O !== h) {
            if (h.parent !== this)
              return this.render(o, i, a);
            if (h.render(h._ts > 0 ? (g - h._start) * h._ts : (h._dirty ? h.totalDuration() : h._tDur) + (g - h._start) * h._ts, i, a), g !== this._time || !this._ts && !R) {
              O = 0, E && (m += this._zTime = -Fe);
              break;
            }
          }
          h = E;
        }
      else {
        h = this._last;
        for (var te = o < 0 ? o : g; h; ) {
          if (E = h._prev, (h._act || te <= h._end) && h._ts && O !== h) {
            if (h.parent !== this)
              return this.render(o, i, a);
            if (h.render(h._ts > 0 ? (te - h._start) * h._ts : (h._dirty ? h.totalDuration() : h._tDur) + (te - h._start) * h._ts, i, a || ct && f0(h)), g !== this._time || !this._ts && !R) {
              O = 0, E && (m += this._zTime = te ? -Fe : Fe);
              break;
            }
          }
          h = E;
        }
      }
      if (O && !i && (this.pause(), O.render(g >= s ? 0 : -Fe)._zTime = g >= s ? 1 : -1, this._ts))
        return this._start = L, Is(this), this.render(o, i, a);
      this._onUpdate && !i && Gt(this, "onUpdate", !0), (m === l && this._tTime >= this.totalDuration() || !m && s) && (L === this._start || Math.abs(F) !== Math.abs(this._ts)) && (this._lock || ((o || !u) && (m === l && this._ts > 0 || !m && this._ts < 0) && ar(this, 1), !i && !(o < 0 && !s) && (m || s || !l) && (Gt(this, m === l && o >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(m < l && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, n.add = function(o, i) {
    var a = this;
    if (Gn(i) || (i = Jt(this, i, o)), !(o instanceof oi)) {
      if (gt(o))
        return o.forEach(function(s) {
          return a.add(s, i);
        }), this;
      if (at(o))
        return this.addLabel(o, i);
      if (Ye(o))
        o = rt.delayedCall(0, o);
      else
        return this;
    }
    return this !== o ? En(this, o, i) : this;
  }, n.getChildren = function(o, i, a, s) {
    o === void 0 && (o = !0), i === void 0 && (i = !0), a === void 0 && (a = !0), s === void 0 && (s = -en);
    for (var l = [], u = this._first; u; )
      u._start >= s && (u instanceof rt ? i && l.push(u) : (a && l.push(u), o && l.push.apply(l, u.getChildren(!0, i, a)))), u = u._next;
    return l;
  }, n.getById = function(o) {
    for (var i = this.getChildren(1, 1, 1), a = i.length; a--; )
      if (i[a].vars.id === o)
        return i[a];
  }, n.remove = function(o) {
    return at(o) ? this.removeLabel(o) : Ye(o) ? this.killTweensOf(o) : (o.parent === this && As(this, o), o === this._recent && (this._recent = this._last), Lr(this));
  }, n.totalTime = function(o, i) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = ot(qt.time - (this._ts > 0 ? o / this._ts : (this.totalDuration() - o) / -this._ts))), e.prototype.totalTime.call(this, o, i), this._forcing = 0, this) : this._tTime;
  }, n.addLabel = function(o, i) {
    return this.labels[o] = Jt(this, i), this;
  }, n.removeLabel = function(o) {
    return delete this.labels[o], this;
  }, n.addPause = function(o, i, a) {
    var s = rt.delayedCall(0, i || ti, a);
    return s.data = "isPause", this._hasPause = 1, En(this, s, Jt(this, o));
  }, n.removePause = function(o) {
    var i = this._first;
    for (o = Jt(this, o); i; )
      i._start === o && i.data === "isPause" && ar(i), i = i._next;
  }, n.killTweensOf = function(o, i, a) {
    for (var s = this.getTweensOf(o, a), l = s.length; l--; )
      nr !== s[l] && s[l].kill(o, i);
    return this;
  }, n.getTweensOf = function(o, i) {
    for (var a = [], s = tn(o), l = this._first, u = Gn(i), m; l; )
      l instanceof rt ? uy(l._targets, s) && (u ? (!nr || l._initted && l._ts) && l.globalTime(0) <= i && l.globalTime(l.totalDuration()) > i : !i || l.isActive()) && a.push(l) : (m = l.getTweensOf(s, i)).length && a.push.apply(a, m), l = l._next;
    return a;
  }, n.tweenTo = function(o, i) {
    i = i || {};
    var a = this, s = Jt(a, o), l = i, u = l.startAt, m = l.onStart, v = l.onStartParams, g = l.immediateRender, h, E = rt.to(a, Zt({
      ease: i.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: s,
      overwrite: "auto",
      duration: i.duration || Math.abs((s - (u && "time" in u ? u.time : a._time)) / a.timeScale()) || Fe,
      onStart: function() {
        if (a.pause(), !h) {
          var A = i.duration || Math.abs((s - (u && "time" in u ? u.time : a._time)) / a.timeScale());
          E._dur !== A && vo(E, A, 0, 1).render(E._time, !0, !0), h = 1;
        }
        m && m.apply(E, v || []);
      }
    }, i));
    return g ? E.render(0) : E;
  }, n.tweenFromTo = function(o, i, a) {
    return this.tweenTo(i, Zt({
      startAt: {
        time: Jt(this, o)
      }
    }, a));
  }, n.recent = function() {
    return this._recent;
  }, n.nextLabel = function(o) {
    return o === void 0 && (o = this._time), X2(this, Jt(this, o));
  }, n.previousLabel = function(o) {
    return o === void 0 && (o = this._time), X2(this, Jt(this, o), 1);
  }, n.currentLabel = function(o) {
    return arguments.length ? this.seek(o, !0) : this.previousLabel(this._time + Fe);
  }, n.shiftChildren = function(o, i, a) {
    a === void 0 && (a = 0);
    for (var s = this._first, l = this.labels, u; s; )
      s._start >= a && (s._start += o, s._end += o), s = s._next;
    if (i)
      for (u in l)
        l[u] >= a && (l[u] += o);
    return Lr(this);
  }, n.invalidate = function(o) {
    var i = this._first;
    for (this._lock = 0; i; )
      i.invalidate(o), i = i._next;
    return e.prototype.invalidate.call(this, o);
  }, n.clear = function(o) {
    o === void 0 && (o = !0);
    for (var i = this._first, a; i; )
      a = i._next, this.remove(i), i = a;
    return this._dp && (this._time = this._tTime = this._pTime = 0), o && (this.labels = {}), Lr(this);
  }, n.totalDuration = function(o) {
    var i = 0, a = this, s = a._last, l = en, u, m, v;
    if (arguments.length)
      return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -o : o));
    if (a._dirty) {
      for (v = a.parent; s; )
        u = s._prev, s._dirty && s.totalDuration(), m = s._start, m > l && a._sort && s._ts && !a._lock ? (a._lock = 1, En(a, s, m - s._delay, 1)._lock = 0) : l = m, m < 0 && s._ts && (i -= m, (!v && !a._dp || v && v.smoothChildTiming) && (a._start += m / a._ts, a._time -= m, a._tTime -= m), a.shiftChildren(-m, !1, -1 / 0), l = 0), s._end > i && s._ts && (i = s._end), s = u;
      vo(a, a === xe && a._time > i ? a._time : i, 1, 1), a._dirty = 0;
    }
    return a._tDur;
  }, t.updateRoot = function(o) {
    if (xe._ts && (Mg(xe, is(o, xe)), Eg = qt.frame), qt.frame >= Z2) {
      Z2 += Kt.autoSleep || 120;
      var i = xe._first;
      if ((!i || !i._ts) && Kt.autoSleep && qt._listeners.length < 2) {
        for (; i && !i._ts; )
          i = i._next;
        i || qt.sleep();
      }
    }
  }, t;
}(oi);
Zt(wt.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var $y = function(t, n, r, o, i, a, s) {
  var l = new Nt(this._pt, t, n, 0, 1, t4, null, i), u = 0, m = 0, v, g, h, E, C, A, R, O;
  for (l.b = r, l.e = o, r += "", o += "", (R = ~o.indexOf("random(")) && (o = ni(o)), a && (O = [r, o], a(O, t, n), r = O[0], o = O[1]), g = r.match(Cl) || []; v = Cl.exec(o); )
    E = v[0], C = o.substring(u, v.index), h ? h = (h + 1) % 5 : C.substr(-5) === "rgba(" && (h = 1), E !== g[m++] && (A = parseFloat(g[m - 1]) || 0, l._pt = {
      _next: l._pt,
      p: C || m === 1 ? C : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: A,
      c: E.charAt(1) === "=" ? io(A, E) - A : parseFloat(E) - A,
      m: h && h < 4 ? Math.round : 0
    }, u = Cl.lastIndex);
  return l.c = u < o.length ? o.substring(u, o.length) : "", l.fp = s, (_g.test(o) || R) && (l.e = 0), this._pt = l, l;
}, p0 = function(t, n, r, o, i, a, s, l, u, m) {
  Ye(o) && (o = o(i || 0, t, a));
  var v = t[n], g = r !== "get" ? r : Ye(v) ? u ? t[n.indexOf("set") || !Ye(t["get" + n.substr(3)]) ? n : "get" + n.substr(3)](u) : t[n]() : v, h = Ye(v) ? u ? Fy : Jg : v0, E;
  if (at(o) && (~o.indexOf("random(") && (o = ni(o)), o.charAt(1) === "=" && (E = io(g, o) + (pt(g) || 0), (E || E === 0) && (o = E))), !m || g !== o || Lc)
    return !isNaN(g * o) && o !== "" ? (E = new Nt(this._pt, t, n, +g || 0, o - (g || 0), typeof v == "boolean" ? Vy : e4, 0, h), u && (E.fp = u), s && E.modifier(s, this, t), this._pt = E) : (!v && !(n in t) && d0(n, o), $y.call(this, t, n, g, o, h, l || Kt.stringFilter, u));
}, Oy = function(t, n, r, o, i) {
  if (Ye(t) && (t = Qo(t, i, n, r, o)), !An(t) || t.style && t.nodeType || gt(t) || bg(t))
    return at(t) ? Qo(t, i, n, r, o) : t;
  var a = {}, s;
  for (s in t)
    a[s] = Qo(t[s], i, n, r, o);
  return a;
}, Yg = function(t, n, r, o, i, a) {
  var s, l, u, m;
  if (Ut[t] && (s = new Ut[t]()).init(i, s.rawVars ? n[t] : Oy(n[t], o, i, a, r), r, o, a) !== !1 && (r._pt = l = new Nt(r._pt, i, t, 0, 1, s.render, s, 0, s.priority), r !== no))
    for (u = r._ptLookup[r._targets.indexOf(i)], m = s._props.length; m--; )
      u[s._props[m]] = l;
  return s;
}, nr, Lc, g0 = function e(t, n, r) {
  var o = t.vars, i = o.ease, a = o.startAt, s = o.immediateRender, l = o.lazy, u = o.onUpdate, m = o.runBackwards, v = o.yoyoEase, g = o.keyframes, h = o.autoRevert, E = t._dur, C = t._startAt, A = t._targets, R = t.parent, O = R && R.data === "nested" ? R.vars.targets : A, F = t._overwrite === "auto" && !s0, L = t.timeline, D, P, U, q, z, te, ee, x, N, G, X, Q, re;
  if (L && (!g || !i) && (i = "none"), t._ease = Dr(i, fo.ease), t._yEase = v ? zg(Dr(v === !0 ? i : v, fo.ease)) : 0, v && t._yoyo && !t._repeat && (v = t._yEase, t._yEase = t._ease, t._ease = v), t._from = !L && !!o.runBackwards, !L || g && !o.stagger) {
    if (x = A[0] ? Ir(A[0]).harness : 0, Q = x && o[x.prop], D = os(o, c0), C && (C._zTime < 0 && C.progress(1), n < 0 && m && s && !h ? C.render(-1, !0) : C.revert(m && E ? Gi : ay), C._lazy = 0), a) {
      if (ar(t._startAt = rt.set(A, Zt({
        data: "isStart",
        overwrite: !1,
        parent: R,
        immediateRender: !0,
        lazy: !C && Ot(l),
        startAt: null,
        delay: 0,
        onUpdate: u && function() {
          return Gt(t, "onUpdate");
        },
        stagger: 0
      }, a))), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (ct || !s && !h) && t._startAt.revert(Gi), s && E && n <= 0 && r <= 0) {
        n && (t._zTime = n);
        return;
      }
    } else if (m && E && !C) {
      if (n && (s = !1), U = Zt({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: s && !C && Ot(l),
        immediateRender: s,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: R
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, D), Q && (U[x.prop] = Q), ar(t._startAt = rt.set(A, U)), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (ct ? t._startAt.revert(Gi) : t._startAt.render(-1, !0)), t._zTime = n, !s)
        e(t._startAt, Fe, Fe);
      else if (!n)
        return;
    }
    for (t._pt = t._ptCache = 0, l = E && Ot(l) || l && !E, P = 0; P < A.length; P++) {
      if (z = A[P], ee = z._gsap || m0(A)[P]._gsap, t._ptLookup[P] = G = {}, kc[ee.id] && ir.length && rs(), X = O === A ? P : O.indexOf(z), x && (N = new x()).init(z, Q || D, t, X, O) !== !1 && (t._pt = q = new Nt(t._pt, z, N.name, 0, 1, N.render, N, 0, N.priority), N._props.forEach(function(se) {
        G[se] = q;
      }), N.priority && (te = 1)), !x || Q)
        for (U in D)
          Ut[U] && (N = Yg(U, D, t, X, z, O)) ? N.priority && (te = 1) : G[U] = q = p0.call(t, z, U, "get", D[U], X, O, 0, o.stringFilter);
      t._op && t._op[P] && t.kill(z, t._op[P]), F && t._pt && (nr = t, xe.killTweensOf(z, G, t.globalTime(n)), re = !t.parent, nr = 0), t._pt && l && (kc[ee.id] = 1);
    }
    te && n4(t), t._onInit && t._onInit(t);
  }
  t._onUpdate = u, t._initted = (!t._op || t._pt) && !re, g && n <= 0 && L.render(en, !0, !0);
}, Py = function(t, n, r, o, i, a, s, l) {
  var u = (t._pt && t._ptCache || (t._ptCache = {}))[n], m, v, g, h;
  if (!u)
    for (u = t._ptCache[n] = [], g = t._ptLookup, h = t._targets.length; h--; ) {
      if (m = g[h][n], m && m.d && m.d._pt)
        for (m = m.d._pt; m && m.p !== n && m.fp !== n; )
          m = m._next;
      if (!m)
        return Lc = 1, t.vars[n] = "+=0", g0(t, s), Lc = 0, l ? ei(n + " not eligible for reset") : 1;
      u.push(m);
    }
  for (h = u.length; h--; )
    v = u[h], m = v._pt || v, m.s = (o || o === 0) && !i ? o : m.s + (o || 0) + a * m.c, m.c = r - m.s, v.e && (v.e = Xe(r) + pt(v.e)), v.b && (v.b = m.s + pt(v.b));
}, Ny = function(t, n) {
  var r = t[0] ? Ir(t[0]).harness : 0, o = r && r.aliases, i, a, s, l;
  if (!o)
    return n;
  i = po({}, n);
  for (a in o)
    if (a in i)
      for (l = o[a].split(","), s = l.length; s--; )
        i[l[s]] = i[a];
  return i;
}, Hy = function(t, n, r, o) {
  var i = n.ease || o || "power1.inOut", a, s;
  if (gt(n))
    s = r[t] || (r[t] = []), n.forEach(function(l, u) {
      return s.push({
        t: u / (n.length - 1) * 100,
        v: l,
        e: i
      });
    });
  else
    for (a in n)
      s = r[a] || (r[a] = []), a === "ease" || s.push({
        t: parseFloat(t),
        v: n[a],
        e: i
      });
}, Qo = function(t, n, r, o, i) {
  return Ye(t) ? t.call(n, r, o, i) : at(t) && ~t.indexOf("random(") ? ni(t) : t;
}, Xg = h0 + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", Qg = {};
Pt(Xg + ",id,stagger,delay,duration,paused,scrollTrigger", function(e) {
  return Qg[e] = 1;
});
var rt = /* @__PURE__ */ function(e) {
  gg(t, e);
  function t(r, o, i, a) {
    var s;
    typeof o == "number" && (i.duration = o, o = i, i = null), s = e.call(this, a ? o : Yo(o)) || this;
    var l = s.vars, u = l.duration, m = l.delay, v = l.immediateRender, g = l.stagger, h = l.overwrite, E = l.keyframes, C = l.defaults, A = l.scrollTrigger, R = l.yoyoEase, O = o.parent || xe, F = (gt(r) || bg(r) ? Gn(r[0]) : "length" in o) ? [r] : tn(r), L, D, P, U, q, z, te, ee;
    if (s._targets = F.length ? m0(F) : ei("GSAP target " + r + " not found. https://gsap.com", !Kt.nullTargetWarn) || [], s._ptLookup = [], s._overwrite = h, E || g || Fi(u) || Fi(m)) {
      if (o = s.vars, L = s.timeline = new wt({
        data: "nested",
        defaults: C || {},
        targets: O && O.data === "nested" ? O.vars.targets : F
      }), L.kill(), L.parent = L._dp = Vn(s), L._start = 0, g || Fi(u) || Fi(m)) {
        if (U = F.length, te = g && Hg(g), An(g))
          for (q in g)
            ~Xg.indexOf(q) && (ee || (ee = {}), ee[q] = g[q]);
        for (D = 0; D < U; D++)
          P = os(o, Qg), P.stagger = 0, R && (P.yoyoEase = R), ee && po(P, ee), z = F[D], P.duration = +Qo(u, Vn(s), D, z, F), P.delay = (+Qo(m, Vn(s), D, z, F) || 0) - s._delay, !g && U === 1 && P.delay && (s._delay = m = P.delay, s._start += m, P.delay = 0), L.to(z, P, te ? te(D, z, F) : 0), L._ease = Ee.none;
        L.duration() ? u = m = 0 : s.timeline = 0;
      } else if (E) {
        Yo(Zt(L.vars.defaults, {
          ease: "none"
        })), L._ease = Dr(E.ease || o.ease || "none");
        var x = 0, N, G, X;
        if (gt(E))
          E.forEach(function(Q) {
            return L.to(F, Q, ">");
          }), L.duration();
        else {
          P = {};
          for (q in E)
            q === "ease" || q === "easeEach" || Hy(q, E[q], P, E.easeEach);
          for (q in P)
            for (N = P[q].sort(function(Q, re) {
              return Q.t - re.t;
            }), x = 0, D = 0; D < N.length; D++)
              G = N[D], X = {
                ease: G.e,
                duration: (G.t - (D ? N[D - 1].t : 0)) / 100 * u
              }, X[q] = G.v, L.to(F, X, x), x += X.duration;
          L.duration() < u && L.to({}, {
            duration: u - L.duration()
          });
        }
      }
      u || s.duration(u = L.duration());
    } else
      s.timeline = 0;
    return h === !0 && !s0 && (nr = Vn(s), xe.killTweensOf(F), nr = 0), En(O, Vn(s), i), o.reversed && s.reverse(), o.paused && s.paused(!0), (v || !u && !E && s._start === ot(O._time) && Ot(v) && my(Vn(s)) && O.data !== "nested") && (s._tTime = -Fe, s.render(Math.max(0, -m) || 0)), A && $g(Vn(s), A), s;
  }
  var n = t.prototype;
  return n.render = function(o, i, a) {
    var s = this._time, l = this._tDur, u = this._dur, m = o < 0, v = o > l - Fe && !m ? l : o < Fe ? 0 : o, g, h, E, C, A, R, O, F, L;
    if (!u)
      py(this, o, i, a);
    else if (v !== this._tTime || !o || a || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== m || this._lazy) {
      if (g = v, F = this.timeline, this._repeat) {
        if (C = u + this._rDelay, this._repeat < -1 && m)
          return this.totalTime(C * 100 + o, i, a);
        if (g = ot(v % C), v === l ? (E = this._repeat, g = u) : (A = ot(v / C), E = ~~A, E && E === A ? (g = u, E--) : g > u && (g = u)), R = this._yoyo && E & 1, R && (L = this._yEase, g = u - g), A = go(this._tTime, C), g === s && !a && this._initted && E === A)
          return this._tTime = v, this;
        E !== A && (F && this._yEase && Zg(F, R), this.vars.repeatRefresh && !R && !this._lock && g !== C && this._initted && (this._lock = a = 1, this.render(ot(C * E), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (Og(this, m ? o : g, a, i, v))
          return this._tTime = 0, this;
        if (s !== this._time && !(a && this.vars.repeatRefresh && E !== A))
          return this;
        if (u !== this._dur)
          return this.render(o, i, a);
      }
      if (this._tTime = v, this._time = g, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = O = (L || this._ease)(g / u), this._from && (this.ratio = O = 1 - O), !s && v && !i && !A && (Gt(this, "onStart"), this._tTime !== v))
        return this;
      for (h = this._pt; h; )
        h.r(O, h.d), h = h._next;
      F && F.render(o < 0 ? o : F._dur * F._ease(g / this._dur), i, a) || this._startAt && (this._zTime = o), this._onUpdate && !i && (m && Ec(this, o, i, a), Gt(this, "onUpdate")), this._repeat && E !== A && this.vars.onRepeat && !i && this.parent && Gt(this, "onRepeat"), (v === this._tDur || !v) && this._tTime === v && (m && !this._onUpdate && Ec(this, o, !0, !0), (o || !u) && (v === this._tDur && this._ts > 0 || !v && this._ts < 0) && ar(this, 1), !i && !(m && !s) && (v || s || R) && (Gt(this, v === l ? "onComplete" : "onReverseComplete", !0), this._prom && !(v < l && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, n.targets = function() {
    return this._targets;
  }, n.invalidate = function(o) {
    return (!o || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(o), e.prototype.invalidate.call(this, o);
  }, n.resetTo = function(o, i, a, s, l) {
    ri || qt.wake(), this._ts || this.play();
    var u = Math.min(this._dur, (this._dp._time - this._start) * this._ts), m;
    return this._initted || g0(this, u), m = this._ease(u / this._dur), Py(this, o, i, a, s, m, u, l) ? this.resetTo(o, i, a, s, 1) : (Ls(this, 0), this.parent || Lg(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, n.kill = function(o, i) {
    if (i === void 0 && (i = "all"), !o && (!i || i === "all"))
      return this._lazy = this._pt = 0, this.parent ? Zo(this) : this.scrollTrigger && this.scrollTrigger.kill(!!ct), this;
    if (this.timeline) {
      var a = this.timeline.totalDuration();
      return this.timeline.killTweensOf(o, i, nr && nr.vars.overwrite !== !0)._first || Zo(this), this.parent && a !== this.timeline.totalDuration() && vo(this, this._dur * this.timeline._tDur / a, 0, 1), this;
    }
    var s = this._targets, l = o ? tn(o) : s, u = this._ptLookup, m = this._pt, v, g, h, E, C, A, R;
    if ((!i || i === "all") && cy(s, l))
      return i === "all" && (this._pt = 0), Zo(this);
    for (v = this._op = this._op || [], i !== "all" && (at(i) && (C = {}, Pt(i, function(O) {
      return C[O] = 1;
    }), i = C), i = Ny(s, i)), R = s.length; R--; )
      if (~l.indexOf(s[R])) {
        g = u[R], i === "all" ? (v[R] = i, E = g, h = {}) : (h = v[R] = v[R] || {}, E = i);
        for (C in E)
          A = g && g[C], A && ((!("kill" in A.d) || A.d.kill(C) === !0) && As(this, A, "_pt"), delete g[C]), h !== "all" && (h[C] = 1);
      }
    return this._initted && !this._pt && m && Zo(this), this;
  }, t.to = function(o, i) {
    return new t(o, i, arguments[2]);
  }, t.from = function(o, i) {
    return Xo(1, arguments);
  }, t.delayedCall = function(o, i, a, s) {
    return new t(i, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: o,
      onComplete: i,
      onReverseComplete: i,
      onCompleteParams: a,
      onReverseCompleteParams: a,
      callbackScope: s
    });
  }, t.fromTo = function(o, i, a) {
    return Xo(2, arguments);
  }, t.set = function(o, i) {
    return i.duration = 0, i.repeatDelay || (i.repeat = 0), new t(o, i);
  }, t.killTweensOf = function(o, i, a) {
    return xe.killTweensOf(o, i, a);
  }, t;
}(oi);
Zt(rt.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Pt("staggerTo,staggerFrom,staggerFromTo", function(e) {
  rt[e] = function() {
    var t = new wt(), n = Mc.call(arguments, 0);
    return n.splice(e === "staggerFromTo" ? 5 : 4, 0, 0), t[e].apply(t, n);
  };
});
var v0 = function(t, n, r) {
  return t[n] = r;
}, Jg = function(t, n, r) {
  return t[n](r);
}, Fy = function(t, n, r, o) {
  return t[n](o.fp, r);
}, Ry = function(t, n, r) {
  return t.setAttribute(n, r);
}, b0 = function(t, n) {
  return Ye(t[n]) ? Jg : a0(t[n]) && t.setAttribute ? Ry : v0;
}, e4 = function(t, n) {
  return n.set(n.t, n.p, Math.round((n.s + n.c * t) * 1e6) / 1e6, n);
}, Vy = function(t, n) {
  return n.set(n.t, n.p, !!(n.s + n.c * t), n);
}, t4 = function(t, n) {
  var r = n._pt, o = "";
  if (!t && n.b)
    o = n.b;
  else if (t === 1 && n.e)
    o = n.e;
  else {
    for (; r; )
      o = r.p + (r.m ? r.m(r.s + r.c * t) : Math.round((r.s + r.c * t) * 1e4) / 1e4) + o, r = r._next;
    o += n.c;
  }
  n.set(n.t, n.p, o, n);
}, y0 = function(t, n) {
  for (var r = n._pt; r; )
    r.r(t, r.d), r = r._next;
}, By = function(t, n, r, o) {
  for (var i = this._pt, a; i; )
    a = i._next, i.p === o && i.modifier(t, n, r), i = a;
}, jy = function(t) {
  for (var n = this._pt, r, o; n; )
    o = n._next, n.p === t && !n.op || n.op === t ? As(this, n, "_pt") : n.dep || (r = 1), n = o;
  return !r;
}, Uy = function(t, n, r, o) {
  o.mSet(t, n, o.m.call(o.tween, r, o.mt), o);
}, n4 = function(t) {
  for (var n = t._pt, r, o, i, a; n; ) {
    for (r = n._next, o = i; o && o.pr > n.pr; )
      o = o._next;
    (n._prev = o ? o._prev : a) ? n._prev._next = n : i = n, (n._next = o) ? o._prev = n : a = n, n = r;
  }
  t._pt = i;
}, Nt = /* @__PURE__ */ function() {
  function e(n, r, o, i, a, s, l, u, m) {
    this.t = r, this.s = i, this.c = a, this.p = o, this.r = s || e4, this.d = l || this, this.set = u || v0, this.pr = m || 0, this._next = n, n && (n._prev = this);
  }
  var t = e.prototype;
  return t.modifier = function(r, o, i) {
    this.mSet = this.mSet || this.set, this.set = Uy, this.m = r, this.mt = i, this.tween = o;
  }, e;
}();
Pt(h0 + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(e) {
  return c0[e] = 1;
});
zt.TweenMax = zt.TweenLite = rt;
zt.TimelineLite = zt.TimelineMax = wt;
xe = new wt({
  sortChildren: !1,
  defaults: fo,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
Kt.stringFilter = Kg;
var $r = [], zi = {}, qy = [], J2 = 0, Gy = 0, Sl = function(t) {
  return (zi[t] || qy).map(function(n) {
    return n();
  });
}, Dc = function() {
  var t = Date.now(), n = [];
  t - J2 > 2 && (Sl("matchMediaInit"), $r.forEach(function(r) {
    var o = r.queries, i = r.conditions, a, s, l, u;
    for (s in o)
      a = Tn.matchMedia(o[s]).matches, a && (l = 1), a !== i[s] && (i[s] = a, u = 1);
    u && (r.revert(), l && n.push(r));
  }), Sl("matchMediaRevert"), n.forEach(function(r) {
    return r.onMatch(r, function(o) {
      return r.add(null, o);
    });
  }), J2 = t, Sl("matchMedia"));
}, r4 = /* @__PURE__ */ function() {
  function e(n, r) {
    this.selector = r && Ac(r), this.data = [], this._r = [], this.isReverted = !1, this.id = Gy++, n && this.add(n);
  }
  var t = e.prototype;
  return t.add = function(r, o, i) {
    Ye(r) && (i = o, o = r, r = Ye);
    var a = this, s = function() {
      var u = Ge, m = a.selector, v;
      return u && u !== a && u.data.push(a), i && (a.selector = Ac(i)), Ge = a, v = o.apply(a, arguments), Ye(v) && a._r.push(v), Ge = u, a.selector = m, a.isReverted = !1, v;
    };
    return a.last = s, r === Ye ? s(a, function(l) {
      return a.add(null, l);
    }) : r ? a[r] = s : s;
  }, t.ignore = function(r) {
    var o = Ge;
    Ge = null, r(this), Ge = o;
  }, t.getTweens = function() {
    var r = [];
    return this.data.forEach(function(o) {
      return o instanceof e ? r.push.apply(r, o.getTweens()) : o instanceof rt && !(o.parent && o.parent.data === "nested") && r.push(o);
    }), r;
  }, t.clear = function() {
    this._r.length = this.data.length = 0;
  }, t.kill = function(r, o) {
    var i = this;
    if (r ? function() {
      for (var s = i.getTweens(), l = i.data.length, u; l--; )
        u = i.data[l], u.data === "isFlip" && (u.revert(), u.getChildren(!0, !0, !1).forEach(function(m) {
          return s.splice(s.indexOf(m), 1);
        }));
      for (s.map(function(m) {
        return {
          g: m._dur || m._delay || m._sat && !m._sat.vars.immediateRender ? m.globalTime(0) : -1 / 0,
          t: m
        };
      }).sort(function(m, v) {
        return v.g - m.g || -1 / 0;
      }).forEach(function(m) {
        return m.t.revert(r);
      }), l = i.data.length; l--; )
        u = i.data[l], u instanceof wt ? u.data !== "nested" && (u.scrollTrigger && u.scrollTrigger.revert(), u.kill()) : !(u instanceof rt) && u.revert && u.revert(r);
      i._r.forEach(function(m) {
        return m(r, i);
      }), i.isReverted = !0;
    }() : this.data.forEach(function(s) {
      return s.kill && s.kill();
    }), this.clear(), o)
      for (var a = $r.length; a--; )
        $r[a].id === this.id && $r.splice(a, 1);
  }, t.revert = function(r) {
    this.kill(r || {});
  }, e;
}(), Ky = /* @__PURE__ */ function() {
  function e(n) {
    this.contexts = [], this.scope = n, Ge && Ge.data.push(this);
  }
  var t = e.prototype;
  return t.add = function(r, o, i) {
    An(r) || (r = {
      matches: r
    });
    var a = new r4(0, i || this.scope), s = a.conditions = {}, l, u, m;
    Ge && !a.selector && (a.selector = Ge.selector), this.contexts.push(a), o = a.add("onMatch", o), a.queries = r;
    for (u in r)
      u === "all" ? m = 1 : (l = Tn.matchMedia(r[u]), l && ($r.indexOf(a) < 0 && $r.push(a), (s[u] = l.matches) && (m = 1), l.addListener ? l.addListener(Dc) : l.addEventListener("change", Dc)));
    return m && o(a, function(v) {
      return a.add(null, v);
    }), this;
  }, t.revert = function(r) {
    this.kill(r || {});
  }, t.kill = function(r) {
    this.contexts.forEach(function(o) {
      return o.kill(r, !0);
    });
  }, e;
}(), ss = {
  registerPlugin: function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    n.forEach(function(o) {
      return Ug(o);
    });
  },
  timeline: function(t) {
    return new wt(t);
  },
  getTweensOf: function(t, n) {
    return xe.getTweensOf(t, n);
  },
  getProperty: function(t, n, r, o) {
    at(t) && (t = tn(t)[0]);
    var i = Ir(t || {}).get, a = r ? Ig : Ag;
    return r === "native" && (r = ""), t && (n ? a((Ut[n] && Ut[n].get || i)(t, n, r, o)) : function(s, l, u) {
      return a((Ut[s] && Ut[s].get || i)(t, s, l, u));
    });
  },
  quickSetter: function(t, n, r) {
    if (t = tn(t), t.length > 1) {
      var o = t.map(function(m) {
        return Ft.quickSetter(m, n, r);
      }), i = o.length;
      return function(m) {
        for (var v = i; v--; )
          o[v](m);
      };
    }
    t = t[0] || {};
    var a = Ut[n], s = Ir(t), l = s.harness && (s.harness.aliases || {})[n] || n, u = a ? function(m) {
      var v = new a();
      no._pt = 0, v.init(t, r ? m + r : m, no, 0, [t]), v.render(1, v), no._pt && y0(1, no);
    } : s.set(t, l);
    return a ? u : function(m) {
      return u(t, l, r ? m + r : m, s, 1);
    };
  },
  quickTo: function(t, n, r) {
    var o, i = Ft.to(t, Zt((o = {}, o[n] = "+=0.1", o.paused = !0, o.stagger = 0, o), r || {})), a = function(l, u, m) {
      return i.resetTo(n, l, u, m);
    };
    return a.tween = i, a;
  },
  isTweening: function(t) {
    return xe.getTweensOf(t, !0).length > 0;
  },
  defaults: function(t) {
    return t && t.ease && (t.ease = Dr(t.ease, fo.ease)), x2(fo, t || {});
  },
  config: function(t) {
    return x2(Kt, t || {});
  },
  registerEffect: function(t) {
    var n = t.name, r = t.effect, o = t.plugins, i = t.defaults, a = t.extendTimeline;
    (o || "").split(",").forEach(function(s) {
      return s && !Ut[s] && !zt[s] && ei(n + " effect requires " + s + " plugin.");
    }), wl[n] = function(s, l, u) {
      return r(tn(s), Zt(l || {}, i), u);
    }, a && (wt.prototype[n] = function(s, l, u) {
      return this.add(wl[n](s, An(l) ? l : (u = l) && {}, this), u);
    });
  },
  registerEase: function(t, n) {
    Ee[t] = Dr(n);
  },
  parseEase: function(t, n) {
    return arguments.length ? Dr(t, n) : Ee;
  },
  getById: function(t) {
    return xe.getById(t);
  },
  exportRoot: function(t, n) {
    t === void 0 && (t = {});
    var r = new wt(t), o, i;
    for (r.smoothChildTiming = Ot(t.smoothChildTiming), xe.remove(r), r._dp = 0, r._time = r._tTime = xe._time, o = xe._first; o; )
      i = o._next, (n || !(!o._dur && o instanceof rt && o.vars.onComplete === o._targets[0])) && En(r, o, o._start - o._delay), o = i;
    return En(xe, r, 0), r;
  },
  context: function(t, n) {
    return t ? new r4(t, n) : Ge;
  },
  matchMedia: function(t) {
    return new Ky(t);
  },
  matchMediaRefresh: function() {
    return $r.forEach(function(t) {
      var n = t.conditions, r, o;
      for (o in n)
        n[o] && (n[o] = !1, r = 1);
      r && t.revert();
    }) || Dc();
  },
  addEventListener: function(t, n) {
    var r = zi[t] || (zi[t] = []);
    ~r.indexOf(n) || r.push(n);
  },
  removeEventListener: function(t, n) {
    var r = zi[t], o = r && r.indexOf(n);
    o >= 0 && r.splice(o, 1);
  },
  utils: {
    wrap: Ty,
    wrapYoyo: ky,
    distribute: Hg,
    random: Rg,
    snap: Fg,
    normalize: wy,
    getUnit: pt,
    clamp: by,
    splitColor: qg,
    toArray: tn,
    selector: Ac,
    mapRange: Bg,
    pipe: _y,
    unitize: Cy,
    interpolate: Ey,
    shuffle: Ng
  },
  install: Tg,
  effects: wl,
  ticker: qt,
  updateRoot: wt.updateRoot,
  plugins: Ut,
  globalTimeline: xe,
  core: {
    PropTween: Nt,
    globals: kg,
    Tween: rt,
    Timeline: wt,
    Animation: oi,
    getCache: Ir,
    _removeLinkedListItem: As,
    reverting: function() {
      return ct;
    },
    context: function(t) {
      return t && Ge && (Ge.data.push(t), t._ctx = Ge), Ge;
    },
    suppressOverwrites: function(t) {
      return s0 = t;
    }
  }
};
Pt("to,from,fromTo,delayedCall,set,killTweensOf", function(e) {
  return ss[e] = rt[e];
});
qt.add(wt.updateRoot);
no = ss.to({}, {
  duration: 0
});
var zy = function(t, n) {
  for (var r = t._pt; r && r.p !== n && r.op !== n && r.fp !== n; )
    r = r._next;
  return r;
}, Zy = function(t, n) {
  var r = t._targets, o, i, a;
  for (o in n)
    for (i = r.length; i--; )
      a = t._ptLookup[i][o], a && (a = a.d) && (a._pt && (a = zy(a, o)), a && a.modifier && a.modifier(n[o], t, r[i], o));
}, Ml = function(t, n) {
  return {
    name: t,
    headless: 1,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(o, i, a) {
      a._onInit = function(s) {
        var l, u;
        if (at(i) && (l = {}, Pt(i, function(m) {
          return l[m] = 1;
        }), i = l), n) {
          l = {};
          for (u in i)
            l[u] = n(i[u]);
          i = l;
        }
        Zy(s, i);
      };
    }
  };
}, Ft = ss.registerPlugin({
  name: "attr",
  init: function(t, n, r, o, i) {
    var a, s, l;
    this.tween = r;
    for (a in n)
      l = t.getAttribute(a) || "", s = this.add(t, "setAttribute", (l || 0) + "", n[a], o, i, 0, 0, a), s.op = a, s.b = l, this._props.push(a);
  },
  render: function(t, n) {
    for (var r = n._pt; r; )
      ct ? r.set(r.t, r.p, r.b, r) : r.r(t, r.d), r = r._next;
  }
}, {
  name: "endArray",
  headless: 1,
  init: function(t, n) {
    for (var r = n.length; r--; )
      this.add(t, r, t[r] || 0, n[r], 0, 0, 0, 0, 0, 1);
  }
}, Ml("roundProps", Ic), Ml("modifiers"), Ml("snap", Fg)) || ss;
rt.version = wt.version = Ft.version = "3.13.0";
wg = 1;
l0() && bo();
Ee.Power0;
Ee.Power1;
Ee.Power2;
Ee.Power3;
Ee.Power4;
Ee.Linear;
Ee.Quad;
Ee.Cubic;
Ee.Quart;
Ee.Quint;
Ee.Strong;
Ee.Elastic;
Ee.Back;
Ee.SteppedEase;
Ee.Bounce;
Ee.Sine;
Ee.Expo;
Ee.Circ;
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var em, rr, so, _0, Mr, tm, C0, xy = function() {
  return typeof window != "undefined";
}, Kn = {}, Tr = 180 / Math.PI, ao = Math.PI / 180, Xr = Math.atan2, nm = 1e8, w0 = /([A-Z])/g, Wy = /(left|right|width|margin|padding|x)/i, Yy = /[\s,\(]\S/, Sn = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, $c = function(t, n) {
  return n.set(n.t, n.p, Math.round((n.s + n.c * t) * 1e4) / 1e4 + n.u, n);
}, Xy = function(t, n) {
  return n.set(n.t, n.p, t === 1 ? n.e : Math.round((n.s + n.c * t) * 1e4) / 1e4 + n.u, n);
}, Qy = function(t, n) {
  return n.set(n.t, n.p, t ? Math.round((n.s + n.c * t) * 1e4) / 1e4 + n.u : n.b, n);
}, Jy = function(t, n) {
  var r = n.s + n.c * t;
  n.set(n.t, n.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + n.u, n);
}, o4 = function(t, n) {
  return n.set(n.t, n.p, t ? n.e : n.b, n);
}, i4 = function(t, n) {
  return n.set(n.t, n.p, t !== 1 ? n.b : n.e, n);
}, e_ = function(t, n, r) {
  return t.style[n] = r;
}, t_ = function(t, n, r) {
  return t.style.setProperty(n, r);
}, n_ = function(t, n, r) {
  return t._gsap[n] = r;
}, r_ = function(t, n, r) {
  return t._gsap.scaleX = t._gsap.scaleY = r;
}, o_ = function(t, n, r, o, i) {
  var a = t._gsap;
  a.scaleX = a.scaleY = r, a.renderTransform(i, a);
}, i_ = function(t, n, r, o, i) {
  var a = t._gsap;
  a[n] = r, a.renderTransform(i, a);
}, We = "transform", Ht = We + "Origin", s_ = function e(t, n) {
  var r = this, o = this.target, i = o.style, a = o._gsap;
  if (t in Kn && i) {
    if (this.tfm = this.tfm || {}, t !== "transform")
      t = Sn[t] || t, ~t.indexOf(",") ? t.split(",").forEach(function(s) {
        return r.tfm[s] = jn(o, s);
      }) : this.tfm[t] = a.x ? a[t] : jn(o, t), t === Ht && (this.tfm.zOrigin = a.zOrigin);
    else
      return Sn.transform.split(",").forEach(function(s) {
        return e.call(r, s, n);
      });
    if (this.props.indexOf(We) >= 0)
      return;
    a.svg && (this.svgo = o.getAttribute("data-svg-origin"), this.props.push(Ht, n, "")), t = We;
  }
  (i || n) && this.props.push(t, n, i[t]);
}, s4 = function(t) {
  t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, a_ = function() {
  var t = this.props, n = this.target, r = n.style, o = n._gsap, i, a;
  for (i = 0; i < t.length; i += 3)
    t[i + 1] ? t[i + 1] === 2 ? n[t[i]](t[i + 2]) : n[t[i]] = t[i + 2] : t[i + 2] ? r[t[i]] = t[i + 2] : r.removeProperty(t[i].substr(0, 2) === "--" ? t[i] : t[i].replace(w0, "-$1").toLowerCase());
  if (this.tfm) {
    for (a in this.tfm)
      o[a] = this.tfm[a];
    o.svg && (o.renderTransform(), n.setAttribute("data-svg-origin", this.svgo || "")), i = C0(), (!i || !i.isStart) && !r[We] && (s4(r), o.zOrigin && r[Ht] && (r[Ht] += " " + o.zOrigin + "px", o.zOrigin = 0, o.renderTransform()), o.uncache = 1);
  }
}, a4 = function(t, n) {
  var r = {
    target: t,
    props: [],
    revert: a_,
    save: s_
  };
  return t._gsap || Ft.core.getCache(t), n && t.style && t.nodeType && n.split(",").forEach(function(o) {
    return r.save(o);
  }), r;
}, l4, Oc = function(t, n) {
  var r = rr.createElementNS ? rr.createElementNS((n || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : rr.createElement(t);
  return r && r.style ? r : rr.createElement(t);
}, nn = function e(t, n, r) {
  var o = getComputedStyle(t);
  return o[n] || o.getPropertyValue(n.replace(w0, "-$1").toLowerCase()) || o.getPropertyValue(n) || !r && e(t, yo(n) || n, 1) || "";
}, rm = "O,Moz,ms,Ms,Webkit".split(","), yo = function(t, n, r) {
  var o = n || Mr, i = o.style, a = 5;
  if (t in i && !r)
    return t;
  for (t = t.charAt(0).toUpperCase() + t.substr(1); a-- && !(rm[a] + t in i); )
    ;
  return a < 0 ? null : (a === 3 ? "ms" : a >= 0 ? rm[a] : "") + t;
}, Pc = function() {
  xy() && window.document && (em = window, rr = em.document, so = rr.documentElement, Mr = Oc("div") || {
    style: {}
  }, Oc("div"), We = yo(We), Ht = We + "Origin", Mr.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", l4 = !!yo("perspective"), C0 = Ft.core.reverting, _0 = 1);
}, om = function(t) {
  var n = t.ownerSVGElement, r = Oc("svg", n && n.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), o = t.cloneNode(!0), i;
  o.style.display = "block", r.appendChild(o), so.appendChild(r);
  try {
    i = o.getBBox();
  } catch (a) {
  }
  return r.removeChild(o), so.removeChild(r), i;
}, im = function(t, n) {
  for (var r = n.length; r--; )
    if (t.hasAttribute(n[r]))
      return t.getAttribute(n[r]);
}, u4 = function(t) {
  var n, r;
  try {
    n = t.getBBox();
  } catch (o) {
    n = om(t), r = 1;
  }
  return n && (n.width || n.height) || r || (n = om(t)), n && !n.width && !n.x && !n.y ? {
    x: +im(t, ["x", "cx", "x1"]) || 0,
    y: +im(t, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : n;
}, d4 = function(t) {
  return !!(t.getCTM && (!t.parentNode || t.ownerSVGElement) && u4(t));
}, Or = function(t, n) {
  if (n) {
    var r = t.style, o;
    n in Kn && n !== Ht && (n = We), r.removeProperty ? (o = n.substr(0, 2), (o === "ms" || n.substr(0, 6) === "webkit") && (n = "-" + n), r.removeProperty(o === "--" ? n : n.replace(w0, "-$1").toLowerCase())) : r.removeAttribute(n);
  }
}, or = function(t, n, r, o, i, a) {
  var s = new Nt(t._pt, n, r, 0, 1, a ? i4 : o4);
  return t._pt = s, s.b = o, s.e = i, t._props.push(r), s;
}, sm = {
  deg: 1,
  rad: 1,
  turn: 1
}, l_ = {
  grid: 1,
  flex: 1
}, lr = function e(t, n, r, o) {
  var i = parseFloat(r) || 0, a = (r + "").trim().substr((i + "").length) || "px", s = Mr.style, l = Wy.test(n), u = t.tagName.toLowerCase() === "svg", m = (u ? "client" : "offset") + (l ? "Width" : "Height"), v = 100, g = o === "px", h = o === "%", E, C, A, R;
  if (o === a || !i || sm[o] || sm[a])
    return i;
  if (a !== "px" && !g && (i = e(t, n, r, "px")), R = t.getCTM && d4(t), (h || a === "%") && (Kn[n] || ~n.indexOf("adius")))
    return E = R ? t.getBBox()[l ? "width" : "height"] : t[m], Xe(h ? i / E * v : i / 100 * E);
  if (s[l ? "width" : "height"] = v + (g ? a : o), C = o !== "rem" && ~n.indexOf("adius") || o === "em" && t.appendChild && !u ? t : t.parentNode, R && (C = (t.ownerSVGElement || {}).parentNode), (!C || C === rr || !C.appendChild) && (C = rr.body), A = C._gsap, A && h && A.width && l && A.time === qt.time && !A.uncache)
    return Xe(i / A.width * v);
  if (h && (n === "height" || n === "width")) {
    var O = t.style[n];
    t.style[n] = v + o, E = t[m], O ? t.style[n] = O : Or(t, n);
  } else
    (h || a === "%") && !l_[nn(C, "display")] && (s.position = nn(t, "position")), C === t && (s.position = "static"), C.appendChild(Mr), E = Mr[m], C.removeChild(Mr), s.position = "absolute";
  return l && h && (A = Ir(C), A.time = qt.time, A.width = C[m]), Xe(g ? E * i / v : E && i ? v / E * i : 0);
}, jn = function(t, n, r, o) {
  var i;
  return _0 || Pc(), n in Sn && n !== "transform" && (n = Sn[n], ~n.indexOf(",") && (n = n.split(",")[0])), Kn[n] && n !== "transform" ? (i = si(t, o), i = n !== "transformOrigin" ? i[n] : i.svg ? i.origin : ls(nn(t, Ht)) + " " + i.zOrigin + "px") : (i = t.style[n], (!i || i === "auto" || o || ~(i + "").indexOf("calc(")) && (i = as[n] && as[n](t, n, r) || nn(t, n) || Sg(t, n) || (n === "opacity" ? 1 : 0))), r && !~(i + "").trim().indexOf(" ") ? lr(t, n, i, r) + r : i;
}, u_ = function(t, n, r, o) {
  if (!r || r === "none") {
    var i = yo(n, t, 1), a = i && nn(t, i, 1);
    a && a !== r ? (n = i, r = a) : n === "borderColor" && (r = nn(t, "borderTopColor"));
  }
  var s = new Nt(this._pt, t.style, n, 0, 1, t4), l = 0, u = 0, m, v, g, h, E, C, A, R, O, F, L, D;
  if (s.b = r, s.e = o, r += "", o += "", o.substring(0, 6) === "var(--" && (o = nn(t, o.substring(4, o.indexOf(")")))), o === "auto" && (C = t.style[n], t.style[n] = o, o = nn(t, n) || o, C ? t.style[n] = C : Or(t, n)), m = [r, o], Kg(m), r = m[0], o = m[1], g = r.match(to) || [], D = o.match(to) || [], D.length) {
    for (; v = to.exec(o); )
      A = v[0], O = o.substring(l, v.index), E ? E = (E + 1) % 5 : (O.substr(-5) === "rgba(" || O.substr(-5) === "hsla(") && (E = 1), A !== (C = g[u++] || "") && (h = parseFloat(C) || 0, L = C.substr((h + "").length), A.charAt(1) === "=" && (A = io(h, A) + L), R = parseFloat(A), F = A.substr((R + "").length), l = to.lastIndex - F.length, F || (F = F || Kt.units[n] || L, l === o.length && (o += F, s.e += F)), L !== F && (h = lr(t, n, C, F) || 0), s._pt = {
        _next: s._pt,
        p: O || u === 1 ? O : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: h,
        c: R - h,
        m: E && E < 4 || n === "zIndex" ? Math.round : 0
      });
    s.c = l < o.length ? o.substring(l, o.length) : "";
  } else
    s.r = n === "display" && o === "none" ? i4 : o4;
  return _g.test(o) && (s.e = 0), this._pt = s, s;
}, am = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, d_ = function(t) {
  var n = t.split(" "), r = n[0], o = n[1] || "50%";
  return (r === "top" || r === "bottom" || o === "left" || o === "right") && (t = r, r = o, o = t), n[0] = am[r] || r, n[1] = am[o] || o, n.join(" ");
}, c_ = function(t, n) {
  if (n.tween && n.tween._time === n.tween._dur) {
    var r = n.t, o = r.style, i = n.u, a = r._gsap, s, l, u;
    if (i === "all" || i === !0)
      o.cssText = "", l = 1;
    else
      for (i = i.split(","), u = i.length; --u > -1; )
        s = i[u], Kn[s] && (l = 1, s = s === "transformOrigin" ? Ht : We), Or(r, s);
    l && (Or(r, We), a && (a.svg && r.removeAttribute("transform"), o.scale = o.rotate = o.translate = "none", si(r, 1), a.uncache = 1, s4(o)));
  }
}, as = {
  clearProps: function(t, n, r, o, i) {
    if (i.data !== "isFromStart") {
      var a = t._pt = new Nt(t._pt, n, r, 0, 0, c_);
      return a.u = o, a.pr = -10, a.tween = i, t._props.push(r), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, ii = [1, 0, 0, 1, 0, 0], c4 = {}, h4 = function(t) {
  return t === "matrix(1, 0, 0, 1, 0, 0)" || t === "none" || !t;
}, lm = function(t) {
  var n = nn(t, We);
  return h4(n) ? ii : n.substr(7).match(yg).map(Xe);
}, T0 = function(t, n) {
  var r = t._gsap || Ir(t), o = t.style, i = lm(t), a, s, l, u;
  return r.svg && t.getAttribute("transform") ? (l = t.transform.baseVal.consolidate().matrix, i = [l.a, l.b, l.c, l.d, l.e, l.f], i.join(",") === "1,0,0,1,0,0" ? ii : i) : (i === ii && !t.offsetParent && t !== so && !r.svg && (l = o.display, o.display = "block", a = t.parentNode, (!a || !t.offsetParent && !t.getBoundingClientRect().width) && (u = 1, s = t.nextElementSibling, so.appendChild(t)), i = lm(t), l ? o.display = l : Or(t, "display"), u && (s ? a.insertBefore(t, s) : a ? a.appendChild(t) : so.removeChild(t))), n && i.length > 6 ? [i[0], i[1], i[4], i[5], i[12], i[13]] : i);
}, Nc = function(t, n, r, o, i, a) {
  var s = t._gsap, l = i || T0(t, !0), u = s.xOrigin || 0, m = s.yOrigin || 0, v = s.xOffset || 0, g = s.yOffset || 0, h = l[0], E = l[1], C = l[2], A = l[3], R = l[4], O = l[5], F = n.split(" "), L = parseFloat(F[0]) || 0, D = parseFloat(F[1]) || 0, P, U, q, z;
  r ? l !== ii && (U = h * A - E * C) && (q = L * (A / U) + D * (-C / U) + (C * O - A * R) / U, z = L * (-E / U) + D * (h / U) - (h * O - E * R) / U, L = q, D = z) : (P = u4(t), L = P.x + (~F[0].indexOf("%") ? L / 100 * P.width : L), D = P.y + (~(F[1] || F[0]).indexOf("%") ? D / 100 * P.height : D)), o || o !== !1 && s.smooth ? (R = L - u, O = D - m, s.xOffset = v + (R * h + O * C) - R, s.yOffset = g + (R * E + O * A) - O) : s.xOffset = s.yOffset = 0, s.xOrigin = L, s.yOrigin = D, s.smooth = !!o, s.origin = n, s.originIsAbsolute = !!r, t.style[Ht] = "0px 0px", a && (or(a, s, "xOrigin", u, L), or(a, s, "yOrigin", m, D), or(a, s, "xOffset", v, s.xOffset), or(a, s, "yOffset", g, s.yOffset)), t.setAttribute("data-svg-origin", L + " " + D);
}, si = function(t, n) {
  var r = t._gsap || new Wg(t);
  if ("x" in r && !n && !r.uncache)
    return r;
  var o = t.style, i = r.scaleX < 0, a = "px", s = "deg", l = getComputedStyle(t), u = nn(t, Ht) || "0", m, v, g, h, E, C, A, R, O, F, L, D, P, U, q, z, te, ee, x, N, G, X, Q, re, se, ue, me, he, _e, De, Ae, ze;
  return m = v = g = C = A = R = O = F = L = 0, h = E = 1, r.svg = !!(t.getCTM && d4(t)), l.translate && ((l.translate !== "none" || l.scale !== "none" || l.rotate !== "none") && (o[We] = (l.translate !== "none" ? "translate3d(" + (l.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (l.rotate !== "none" ? "rotate(" + l.rotate + ") " : "") + (l.scale !== "none" ? "scale(" + l.scale.split(" ").join(",") + ") " : "") + (l[We] !== "none" ? l[We] : "")), o.scale = o.rotate = o.translate = "none"), U = T0(t, r.svg), r.svg && (r.uncache ? (se = t.getBBox(), u = r.xOrigin - se.x + "px " + (r.yOrigin - se.y) + "px", re = "") : re = !n && t.getAttribute("data-svg-origin"), Nc(t, re || u, !!re || r.originIsAbsolute, r.smooth !== !1, U)), D = r.xOrigin || 0, P = r.yOrigin || 0, U !== ii && (ee = U[0], x = U[1], N = U[2], G = U[3], m = X = U[4], v = Q = U[5], U.length === 6 ? (h = Math.sqrt(ee * ee + x * x), E = Math.sqrt(G * G + N * N), C = ee || x ? Xr(x, ee) * Tr : 0, O = N || G ? Xr(N, G) * Tr + C : 0, O && (E *= Math.abs(Math.cos(O * ao))), r.svg && (m -= D - (D * ee + P * N), v -= P - (D * x + P * G))) : (ze = U[6], De = U[7], me = U[8], he = U[9], _e = U[10], Ae = U[11], m = U[12], v = U[13], g = U[14], q = Xr(ze, _e), A = q * Tr, q && (z = Math.cos(-q), te = Math.sin(-q), re = X * z + me * te, se = Q * z + he * te, ue = ze * z + _e * te, me = X * -te + me * z, he = Q * -te + he * z, _e = ze * -te + _e * z, Ae = De * -te + Ae * z, X = re, Q = se, ze = ue), q = Xr(-N, _e), R = q * Tr, q && (z = Math.cos(-q), te = Math.sin(-q), re = ee * z - me * te, se = x * z - he * te, ue = N * z - _e * te, Ae = G * te + Ae * z, ee = re, x = se, N = ue), q = Xr(x, ee), C = q * Tr, q && (z = Math.cos(q), te = Math.sin(q), re = ee * z + x * te, se = X * z + Q * te, x = x * z - ee * te, Q = Q * z - X * te, ee = re, X = se), A && Math.abs(A) + Math.abs(C) > 359.9 && (A = C = 0, R = 180 - R), h = Xe(Math.sqrt(ee * ee + x * x + N * N)), E = Xe(Math.sqrt(Q * Q + ze * ze)), q = Xr(X, Q), O = Math.abs(q) > 2e-4 ? q * Tr : 0, L = Ae ? 1 / (Ae < 0 ? -Ae : Ae) : 0), r.svg && (re = t.getAttribute("transform"), r.forceCSS = t.setAttribute("transform", "") || !h4(nn(t, We)), re && t.setAttribute("transform", re))), Math.abs(O) > 90 && Math.abs(O) < 270 && (i ? (h *= -1, O += C <= 0 ? 180 : -180, C += C <= 0 ? 180 : -180) : (E *= -1, O += O <= 0 ? 180 : -180)), n = n || r.uncache, r.x = m - ((r.xPercent = m && (!n && r.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-m) ? -50 : 0))) ? t.offsetWidth * r.xPercent / 100 : 0) + a, r.y = v - ((r.yPercent = v && (!n && r.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-v) ? -50 : 0))) ? t.offsetHeight * r.yPercent / 100 : 0) + a, r.z = g + a, r.scaleX = Xe(h), r.scaleY = Xe(E), r.rotation = Xe(C) + s, r.rotationX = Xe(A) + s, r.rotationY = Xe(R) + s, r.skewX = O + s, r.skewY = F + s, r.transformPerspective = L + a, (r.zOrigin = parseFloat(u.split(" ")[2]) || !n && r.zOrigin || 0) && (o[Ht] = ls(u)), r.xOffset = r.yOffset = 0, r.force3D = Kt.force3D, r.renderTransform = r.svg ? m_ : l4 ? m4 : h_, r.uncache = 0, r;
}, ls = function(t) {
  return (t = t.split(" "))[0] + " " + t[1];
}, Al = function(t, n, r) {
  var o = pt(n);
  return Xe(parseFloat(n) + parseFloat(lr(t, "x", r + "px", o))) + o;
}, h_ = function(t, n) {
  n.z = "0px", n.rotationY = n.rotationX = "0deg", n.force3D = 0, m4(t, n);
}, yr = "0deg", Ho = "0px", _r = ") ", m4 = function(t, n) {
  var r = n || this, o = r.xPercent, i = r.yPercent, a = r.x, s = r.y, l = r.z, u = r.rotation, m = r.rotationY, v = r.rotationX, g = r.skewX, h = r.skewY, E = r.scaleX, C = r.scaleY, A = r.transformPerspective, R = r.force3D, O = r.target, F = r.zOrigin, L = "", D = R === "auto" && t && t !== 1 || R === !0;
  if (F && (v !== yr || m !== yr)) {
    var P = parseFloat(m) * ao, U = Math.sin(P), q = Math.cos(P), z;
    P = parseFloat(v) * ao, z = Math.cos(P), a = Al(O, a, U * z * -F), s = Al(O, s, -Math.sin(P) * -F), l = Al(O, l, q * z * -F + F);
  }
  A !== Ho && (L += "perspective(" + A + _r), (o || i) && (L += "translate(" + o + "%, " + i + "%) "), (D || a !== Ho || s !== Ho || l !== Ho) && (L += l !== Ho || D ? "translate3d(" + a + ", " + s + ", " + l + ") " : "translate(" + a + ", " + s + _r), u !== yr && (L += "rotate(" + u + _r), m !== yr && (L += "rotateY(" + m + _r), v !== yr && (L += "rotateX(" + v + _r), (g !== yr || h !== yr) && (L += "skew(" + g + ", " + h + _r), (E !== 1 || C !== 1) && (L += "scale(" + E + ", " + C + _r), O.style[We] = L || "translate(0, 0)";
}, m_ = function(t, n) {
  var r = n || this, o = r.xPercent, i = r.yPercent, a = r.x, s = r.y, l = r.rotation, u = r.skewX, m = r.skewY, v = r.scaleX, g = r.scaleY, h = r.target, E = r.xOrigin, C = r.yOrigin, A = r.xOffset, R = r.yOffset, O = r.forceCSS, F = parseFloat(a), L = parseFloat(s), D, P, U, q, z;
  l = parseFloat(l), u = parseFloat(u), m = parseFloat(m), m && (m = parseFloat(m), u += m, l += m), l || u ? (l *= ao, u *= ao, D = Math.cos(l) * v, P = Math.sin(l) * v, U = Math.sin(l - u) * -g, q = Math.cos(l - u) * g, u && (m *= ao, z = Math.tan(u - m), z = Math.sqrt(1 + z * z), U *= z, q *= z, m && (z = Math.tan(m), z = Math.sqrt(1 + z * z), D *= z, P *= z)), D = Xe(D), P = Xe(P), U = Xe(U), q = Xe(q)) : (D = v, q = g, P = U = 0), (F && !~(a + "").indexOf("px") || L && !~(s + "").indexOf("px")) && (F = lr(h, "x", a, "px"), L = lr(h, "y", s, "px")), (E || C || A || R) && (F = Xe(F + E - (E * D + C * U) + A), L = Xe(L + C - (E * P + C * q) + R)), (o || i) && (z = h.getBBox(), F = Xe(F + o / 100 * z.width), L = Xe(L + i / 100 * z.height)), z = "matrix(" + D + "," + P + "," + U + "," + q + "," + F + "," + L + ")", h.setAttribute("transform", z), O && (h.style[We] = z);
}, f_ = function(t, n, r, o, i) {
  var a = 360, s = at(i), l = parseFloat(i) * (s && ~i.indexOf("rad") ? Tr : 1), u = l - o, m = o + u + "deg", v, g;
  return s && (v = i.split("_")[1], v === "short" && (u %= a, u !== u % (a / 2) && (u += u < 0 ? a : -a)), v === "cw" && u < 0 ? u = (u + a * nm) % a - ~~(u / a) * a : v === "ccw" && u > 0 && (u = (u - a * nm) % a - ~~(u / a) * a)), t._pt = g = new Nt(t._pt, n, r, o, u, Xy), g.e = m, g.u = "deg", t._props.push(r), g;
}, um = function(t, n) {
  for (var r in n)
    t[r] = n[r];
  return t;
}, p_ = function(t, n, r) {
  var o = um({}, r._gsap), i = "perspective,force3D,transformOrigin,svgOrigin", a = r.style, s, l, u, m, v, g, h, E;
  o.svg ? (u = r.getAttribute("transform"), r.setAttribute("transform", ""), a[We] = n, s = si(r, 1), Or(r, We), r.setAttribute("transform", u)) : (u = getComputedStyle(r)[We], a[We] = n, s = si(r, 1), a[We] = u);
  for (l in Kn)
    u = o[l], m = s[l], u !== m && i.indexOf(l) < 0 && (h = pt(u), E = pt(m), v = h !== E ? lr(r, l, u, E) : parseFloat(u), g = parseFloat(m), t._pt = new Nt(t._pt, s, l, v, g - v, $c), t._pt.u = E || 0, t._props.push(l));
  um(s, o);
};
Pt("padding,margin,Width,Radius", function(e, t) {
  var n = "Top", r = "Right", o = "Bottom", i = "Left", a = (t < 3 ? [n, r, o, i] : [n + i, n + r, o + r, o + i]).map(function(s) {
    return t < 2 ? e + s : "border" + s + e;
  });
  as[t > 1 ? "border" + e : e] = function(s, l, u, m, v) {
    var g, h;
    if (arguments.length < 4)
      return g = a.map(function(E) {
        return jn(s, E, u);
      }), h = g.join(" "), h.split(g[0]).length === 5 ? g[0] : h;
    g = (m + "").split(" "), h = {}, a.forEach(function(E, C) {
      return h[E] = g[C] = g[C] || g[(C - 1) / 2 | 0];
    }), s.init(l, h, v);
  };
});
var f4 = {
  name: "css",
  register: Pc,
  targetTest: function(t) {
    return t.style && t.nodeType;
  },
  init: function(t, n, r, o, i) {
    var a = this._props, s = t.style, l = r.vars.startAt, u, m, v, g, h, E, C, A, R, O, F, L, D, P, U, q;
    _0 || Pc(), this.styles = this.styles || a4(t), q = this.styles.props, this.tween = r;
    for (C in n)
      if (C !== "autoRound" && (m = n[C], !(Ut[C] && Yg(C, n, r, o, t, i)))) {
        if (h = typeof m, E = as[C], h === "function" && (m = m.call(r, o, t, i), h = typeof m), h === "string" && ~m.indexOf("random(") && (m = ni(m)), E)
          E(this, t, C, m, r) && (U = 1);
        else if (C.substr(0, 2) === "--")
          u = (getComputedStyle(t).getPropertyValue(C) + "").trim(), m += "", sr.lastIndex = 0, sr.test(u) || (A = pt(u), R = pt(m)), R ? A !== R && (u = lr(t, C, u, R) + R) : A && (m += A), this.add(s, "setProperty", u, m, o, i, 0, 0, C), a.push(C), q.push(C, 0, s[C]);
        else if (h !== "undefined") {
          if (l && C in l ? (u = typeof l[C] == "function" ? l[C].call(r, o, t, i) : l[C], at(u) && ~u.indexOf("random(") && (u = ni(u)), pt(u + "") || u === "auto" || (u += Kt.units[C] || pt(jn(t, C)) || ""), (u + "").charAt(1) === "=" && (u = jn(t, C))) : u = jn(t, C), g = parseFloat(u), O = h === "string" && m.charAt(1) === "=" && m.substr(0, 2), O && (m = m.substr(2)), v = parseFloat(m), C in Sn && (C === "autoAlpha" && (g === 1 && jn(t, "visibility") === "hidden" && v && (g = 0), q.push("visibility", 0, s.visibility), or(this, s, "visibility", g ? "inherit" : "hidden", v ? "inherit" : "hidden", !v)), C !== "scale" && C !== "transform" && (C = Sn[C], ~C.indexOf(",") && (C = C.split(",")[0]))), F = C in Kn, F) {
            if (this.styles.save(C), h === "string" && m.substring(0, 6) === "var(--" && (m = nn(t, m.substring(4, m.indexOf(")"))), v = parseFloat(m)), L || (D = t._gsap, D.renderTransform && !n.parseTransform || si(t, n.parseTransform), P = n.smoothOrigin !== !1 && D.smooth, L = this._pt = new Nt(this._pt, s, We, 0, 1, D.renderTransform, D, 0, -1), L.dep = 1), C === "scale")
              this._pt = new Nt(this._pt, D, "scaleY", D.scaleY, (O ? io(D.scaleY, O + v) : v) - D.scaleY || 0, $c), this._pt.u = 0, a.push("scaleY", C), C += "X";
            else if (C === "transformOrigin") {
              q.push(Ht, 0, s[Ht]), m = d_(m), D.svg ? Nc(t, m, 0, P, 0, this) : (R = parseFloat(m.split(" ")[2]) || 0, R !== D.zOrigin && or(this, D, "zOrigin", D.zOrigin, R), or(this, s, C, ls(u), ls(m)));
              continue;
            } else if (C === "svgOrigin") {
              Nc(t, m, 1, P, 0, this);
              continue;
            } else if (C in c4) {
              f_(this, D, C, g, O ? io(g, O + m) : m);
              continue;
            } else if (C === "smoothOrigin") {
              or(this, D, "smooth", D.smooth, m);
              continue;
            } else if (C === "force3D") {
              D[C] = m;
              continue;
            } else if (C === "transform") {
              p_(this, m, t);
              continue;
            }
          } else C in s || (C = yo(C) || C);
          if (F || (v || v === 0) && (g || g === 0) && !Yy.test(m) && C in s)
            A = (u + "").substr((g + "").length), v || (v = 0), R = pt(m) || (C in Kt.units ? Kt.units[C] : A), A !== R && (g = lr(t, C, u, R)), this._pt = new Nt(this._pt, F ? D : s, C, g, (O ? io(g, O + v) : v) - g, !F && (R === "px" || C === "zIndex") && n.autoRound !== !1 ? Jy : $c), this._pt.u = R || 0, A !== R && R !== "%" && (this._pt.b = u, this._pt.r = Qy);
          else if (C in s)
            u_.call(this, t, C, u, O ? O + m : m);
          else if (C in t)
            this.add(t, C, u || t[C], O ? O + m : m, o, i);
          else if (C !== "parseTransform") {
            d0(C, m);
            continue;
          }
          F || (C in s ? q.push(C, 0, s[C]) : typeof t[C] == "function" ? q.push(C, 2, t[C]()) : q.push(C, 1, u || t[C])), a.push(C);
        }
      }
    U && n4(this);
  },
  render: function(t, n) {
    if (n.tween._time || !C0())
      for (var r = n._pt; r; )
        r.r(t, r.d), r = r._next;
    else
      n.styles.revert();
  },
  get: jn,
  aliases: Sn,
  getSetter: function(t, n, r) {
    var o = Sn[n];
    return o && o.indexOf(",") < 0 && (n = o), n in Kn && n !== Ht && (t._gsap.x || jn(t, "x")) ? r && tm === r ? n === "scale" ? r_ : n_ : (tm = r || {}) && (n === "scale" ? o_ : i_) : t.style && !a0(t.style[n]) ? e_ : ~n.indexOf("-") ? t_ : b0(t, n);
  },
  core: {
    _removeProperty: Or,
    _getMatrix: T0
  }
};
Ft.utils.checkPrefix = yo;
Ft.core.getStyleSaver = a4;
(function(e, t, n, r) {
  var o = Pt(e + "," + t + "," + n, function(i) {
    Kn[i] = 1;
  });
  Pt(t, function(i) {
    Kt.units[i] = "deg", c4[i] = 1;
  }), Sn[o[13]] = e + "," + t, Pt(r, function(i) {
    var a = i.split(":");
    Sn[a[1]] = o[a[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Pt("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(e) {
  Kt.units[e] = "px";
});
Ft.registerPlugin(f4);
var tr = Ft.registerPlugin(f4) || Ft;
tr.core.Tween;
const g_ = (e, t) => {
  const r = (() => {
    if (typeof t != "number")
      return "";
    switch (!0) {
      case t < 600:
        return "px600";
      case (t >= 600 && t < 960):
        return "px960";
      case (t >= 960 && t < 1280):
        return "px1280";
      case (t >= 1280 && t < 1600):
        return "px1600";
      case (t >= 1600 && t < 1920):
        return "px1920";
      case (t >= 1920 && t < 2560):
        return "px2560";
      default:
        return "";
    }
  })();
  e.forEach((o) => {
    var a;
    const i = new Image();
    i.src = r && ((a = o.sizes) == null ? void 0 : a[r]) || o.url;
  });
}, Zn = {
  mixins: [kt],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    gallery: {
      type: Object,
      default: () => ({})
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    hidePager: Boolean
  },
  data() {
    return {
      playSlideshow: !0,
      playVideo: !0,
      index: 0,
      activeImageIdx: 0,
      timer: null,
      transition: "right"
    };
  },
  computed: {
    imageHeight() {
      if (this.theme.version === "G1")
        return "";
      const e = this.theme.version === "G4";
      let t = "42.9vw";
      switch (this.theme.image_size) {
        case "small":
          t = e ? "47vw" : "31vw";
          break;
        case "medium":
          t = e ? "52vw" : "37vw";
          break;
        case "large":
          t = e ? "59vw" : "42.9vw";
          break;
        default:
          t = e ? "59vw" : "42.9vw";
      }
      return {
        "--image-height": t
      };
    },
    accentColor() {
      var e;
      return {
        "--gallery-accent-color": $(
          this.theme,
          "gallery_image_border_color.hex",
          (e = this.theme.globalThemeSettings) == null ? void 0 : e.secondaryColor
        )
      };
    },
    linkStyle() {
      return {
        "--link-color": this.theme.link_color.hex
      };
    },
    bgColor() {
      var e, t;
      return {
        "--bg-color": (t = (e = this.theme) == null ? void 0 : e.bg_color) == null ? void 0 : t.hex
      };
    },
    slides() {
      var e;
      return ((e = this.gallery) == null ? void 0 : e.slides) || [];
    },
    widget() {
      var e;
      return ((e = this.gallery) == null ? void 0 : e.widget) || {};
    },
    currentTransition() {
      return this.theme.fade_transition ? `${this.transition}-fade` : this.transition;
    },
    hasSmoothTransition() {
      return ["G7"].includes(this.theme.version);
    }
  },
  mounted() {
    this.preloadImages(), this.$refs.title && this.$refs.title.children[0] && (this.$refs.title.children[0].id = "galleryheading"), !(this.theme.version === "G2" && this.theme.use_video) && this.restartSlideTimer();
  },
  methods: {
    async preloadImages() {
      await this.$nextTick(), g_(this.slides, this.screenSize);
    },
    togglePlay() {
      this.playSlideshow = !this.playSlideshow, this.restartSlideTimer();
    },
    toggleVideoPlay() {
      if (this.togglePlay(), this.playVideo = !this.playVideo, this.$refs.videoPlayer)
        return this.playVideo ? this.$refs.videoPlayer.play() : this.$refs.videoPlayer.pause();
    },
    jump(e) {
      this.activeImageIdx = e, this.restartSlideTimer();
    },
    moveForward() {
      this.transition = "right", this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.restartSlideTimer();
    },
    moveBack() {
      this.transition = "left", this.activeImageIdx === 0 ? (this.activeImageIdx = this.slides.length - 1, this.restartSlideTimer()) : (this.activeImageIdx = (this.activeImageIdx - 1) % this.slides.length, this.restartSlideTimer());
    },
    smoothForward() {
      if (this.slides.length <= 1) return;
      this.transition = "right";
      const e = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
      if (e.length === 0) {
        this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.$nextTick(() => {
          const r = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
          r.length > 0 && (tr.set(r, { opacity: 0 }), tr.to(r, {
            opacity: 1,
            duration: 0.5,
            ease: "sine.in"
          }));
        });
        return;
      }
      const t = () => {
        this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.$nextTick(() => {
          const r = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
          r.length > 0 && tr.set(r, { opacity: 0 });
        });
      }, n = 650;
      tr.to(e, {
        opacity: 0,
        duration: 0.5,
        ease: "sine.out",
        onComplete: () => {
          t(), setTimeout(() => {
            this.$nextTick(() => {
              const r = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
              r.length > 0 && tr.to(r, {
                opacity: 1,
                duration: 0.5,
                ease: "sine.in"
              });
            });
          }, n);
        },
        onError: (r) => {
          console.warn("GSAP animation error:", r);
        }
      });
    },
    restartSlideTimer() {
      var e;
      this.isEditing || (clearTimeout(this.timer), this.playSlideshow && (this.timer = setTimeout(() => {
        this.hasSmoothTransition ? this.smoothForward() : this.moveForward(), this.restartSlideTimer();
      }, ((e = this.theme) == null ? void 0 : e.gallery_speed) || 5e3)));
    },
    handleJump(e) {
      this.isEditing ? (this.$emit("jumpTo", e), this.activeImageIdx = e) : this.jump(e);
    },
    handleScrollLeft() {
      this.isEditing ? (this.activeImageIdx = (this.activeImageIdx - 1 + this.slides.length) % this.slides.length, this.$emit("scrollLeft")) : this.moveBack();
    },
    handleScrollRight() {
      this.isEditing ? (this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.$emit("scrollRight")) : this.moveForward();
    }
  }
}, v_ = {
  props: {
    image: {
      type: Object,
      required: !0
    },
    altText: {
      type: String,
      required: !0
    },
    idx: {
      type: Number,
      required: !0
    }
  },
  computed: {
    sizes() {
      return this.image.sizes || {};
    }
  }
}, b_ = ["srcset"], y_ = ["srcset"], __ = ["srcset"], C_ = ["srcset"], w_ = ["srcset"], T_ = ["srcset"], k_ = ["src", "alt"];
function E_(e, t, n, r, o, i) {
  return d(), f("div", { key: n.idx }, [
    c("picture", null, [
      c("source", {
        srcset: i.sizes.px600,
        media: "(max-width: 600px)"
      }, null, 8, b_),
      c("source", {
        srcset: i.sizes.px960,
        media: "(max-width: 960px)"
      }, null, 8, y_),
      c("source", {
        srcset: i.sizes.px1280,
        media: "(max-width: 1280px)"
      }, null, 8, __),
      c("source", {
        srcset: i.sizes.px1600,
        media: "(max-width: 1600px)"
      }, null, 8, C_),
      c("source", {
        srcset: i.sizes.px1920,
        media: "(max-width: 1920px)"
      }, null, 8, w_),
      c("source", {
        srcset: i.sizes.px2560,
        media: "(max-width: 2560px)"
      }, null, 8, T_),
      c("img", {
        src: n.image.url,
        alt: n.altText
      }, null, 8, k_)
    ])
  ]);
}
const Ur = /* @__PURE__ */ B(v_, [["render", E_]]), S_ = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, M_ = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, A_ = ["fill"], I_ = ["fill"];
function L_(e, t, n, r, o, i) {
  return d(), f("svg", M_, [
    c("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, A_),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 10H12V22H15V10ZM20 10H17V22H20V10Z",
      fill: n.buttonIconColor.hex
    }, null, 8, I_)
  ]);
}
const D_ = /* @__PURE__ */ B(S_, [["render", L_]]), $_ = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, O_ = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P_ = ["fill"], N_ = ["fill"];
function H_(e, t, n, r, o, i) {
  return d(), f("svg", O_, [
    c("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, P_),
    c("path", {
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, N_)
  ]);
}
const F_ = /* @__PURE__ */ B($_, [["render", H_]]), R_ = {
  name: "SvgReverse",
  mixins: [Zn],
  props: {
    theme: {
      type: Object,
      required: !0
    }
  }
}, V_ = ["fill"], B_ = ["fill"];
function j_(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "8",
    height: "13",
    viewBox: "0 0 8 13",
    fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.82843 6.50008L7.62132 1.70718L6.20711 0.292969L0 6.50008L6.20711 12.7072L7.62132 11.293L2.82843 6.50008Z",
      fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex
    }, null, 8, B_)
  ], 8, V_);
}
const U_ = /* @__PURE__ */ B(R_, [["render", j_]]), q_ = {
  name: "SvgAdvance",
  mixins: [Zn],
  props: {
    theme: {
      type: Object,
      required: !0
    }
  }
}, G_ = ["fill"], K_ = ["fill"];
function z_(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "9",
    height: "13",
    viewBox: "0 0 9 13",
    fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.4997 6.49992L0.706805 11.2928L2.12102 12.707L8.32813 6.49992L2.12102 0.292818L0.706806 1.70703L5.4997 6.49992Z",
      fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex
    }, null, 8, K_)
  ], 8, G_);
}
const Z_ = /* @__PURE__ */ B(q_, [["render", z_]]), x_ = {
  name: "G1",
  components: {
    ResponsiveImage: Ur,
    PauseSvg: D_,
    PlaySvg: F_,
    ReverseSvg: U_,
    AdvanceSvg: Z_
  },
  mixins: [Zn]
}, W_ = { class: "text" }, Y_ = ["innerHTML"], X_ = ["innerHTML"], Q_ = { class: "image-wrapper" }, J_ = {
  key: 0,
  class: "navigation"
}, eC = { class: "button-action-content" }, tC = { class: "button-action-content" }, nC = { class: "arrow-position" }, rC = { class: "button-action-content" }, oC = { class: "position" }, iC = ["aria-label", "aria-current", "onClick", "onKeydown"], sC = { class: "button-action-content" }, aC = { class: "button-action-content" };
function lC(e, t, n, r, o, i) {
  const a = V("responsive-image"), s = V("PlaySvg"), l = V("PauseSvg"), u = V("ReverseSvg"), m = V("AdvanceSvg"), v = Ke("touch");
  return d(), f("div", {
    id: "g1",
    "data-testid": "G1",
    style: Z([e.linkStyle, e.accentColor])
  }, [
    c("div", {
      style: Z(`background-color: ${e.theme.bg_color.hex}`),
      class: "slide"
    }, [
      c("div", W_, [
        c("div", {
          ref: "title",
          class: _(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          c("div", {
            style: Z(`color: ${e.theme.heading_color.hex}`),
            innerHTML: e.slides[0].title
          }, null, 12, Y_)
        ], 2),
        c("div", {
          class: _(["description", e.theme.style])
        }, [
          c("div", {
            style: Z(`color: ${e.theme.text_color.hex}`),
            innerHTML: e.slides[0].content
          }, null, 12, X_)
        ], 2)
      ]),
      c("div", Q_, [
        we((d(), I(zn, {
          tag: "div",
          class: "img-slider",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: S(() => [
            (d(), I(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            v,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            v,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.slides.length > 1 ? (d(), f("div", J_, [
          e.playSlideshow ? (d(), f("button", {
            key: 1,
            "aria-label": "Pause Gallery",
            "data-testid": "pause-button",
            class: "pause button-action",
            onClick: t[2] || (t[2] = (...g) => e.togglePlay && e.togglePlay(...g)),
            onKeydown: t[3] || (t[3] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", tC, [
              j(l, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)) : (d(), f("button", {
            key: 0,
            "aria-label": "Play Gallery",
            "data-testid": "play-button",
            class: "play button-action",
            onClick: t[0] || (t[0] = (...g) => e.togglePlay && e.togglePlay(...g)),
            onKeydown: t[1] || (t[1] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", eC, [
              j(s, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)),
          c("div", nC, [
            c("button", {
              class: "left-arrow button-action",
              "aria-label": "Previous Image",
              "data-testid": "gallery-left-button",
              onClick: t[4] || (t[4] = (...g) => e.moveBack && e.moveBack(...g)),
              onKeydown: t[5] || (t[5] = K(W((...g) => e.moveBack && e.moveBack(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", rC, [
                j(u, { theme: e.theme }, null, 8, ["theme"])
              ])
            ], 32),
            c("p", {
              style: Z(`color: ${e.theme.text_color.hex}`)
            }, "1", 4),
            c("div", oC, [
              (d(!0), f(J, null, ne(e.slides, (g, h) => (d(), f("button", {
                key: g.url,
                class: "button-action",
                "aria-label": `Image ${h + 1}`,
                "aria-current": e.activeImageIdx === h ? "active" : null,
                "data-testid": "gallery-pager-button",
                onClick: (E) => e.jump(h),
                onKeydown: K(W((E) => e.jump(h), ["exact", "prevent"]), ["enter"])
              }, [
                c("div", sC, [
                  c("div", {
                    class: _(["rectangle button-action-content", { active: e.activeImageIdx === h }]),
                    style: Z({
                      "background-color": e.theme.pager_color.hex,
                      height: e.activeImageIdx === h ? "4px" : "1px"
                    })
                  }, null, 6)
                ])
              ], 40, iC))), 128))
            ]),
            c("p", {
              style: Z(`color: ${e.theme.text_color.hex}`)
            }, k(e.slides.length), 5),
            c("button", {
              "aria-label": "Next Image",
              class: "right-arrow button-action",
              "data-testid": "gallery-right-button",
              onClick: t[6] || (t[6] = (...g) => e.moveForward && e.moveForward(...g)),
              onKeydown: t[7] || (t[7] = K(W((...g) => e.moveForward && e.moveForward(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", aC, [
                j(m, { theme: e.theme }, null, 8, ["theme"])
              ])
            ], 32)
          ])
        ])) : T("", !0)
      ])
    ], 4)
  ], 4);
}
const uC = /* @__PURE__ */ B(x_, [["render", lC], ["__scopeId", "data-v-11dc02a2"]]), dC = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, cC = {
  class: "pause_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hC = ["fill"], mC = ["fill"];
function fC(e, t, n, r, o, i) {
  return d(), f("svg", cC, [
    c("rect", {
      class: "icon-background",
      width: "40",
      height: "40",
      fill: n.buttonBgColor.hex
    }, null, 8, hC),
    c("path", {
      class: "icon-button",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 14H16V26H19V14ZM24 14H21V26H24V14Z",
      fill: n.buttonIconColor.hex
    }, null, 8, mC)
  ]);
}
const pC = /* @__PURE__ */ B(dC, [["render", fC]]), gC = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, vC = {
  class: "play_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bC = ["fill"], yC = ["fill"];
function _C(e, t, n, r, o, i) {
  return d(), f("svg", vC, [
    c("rect", {
      class: "icon-background",
      width: "32",
      height: "32",
      fill: n.buttonBgColor.hex
    }, null, 8, bC),
    c("path", {
      class: "icon-button",
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, yC)
  ]);
}
const CC = /* @__PURE__ */ B(gC, [["render", _C]]), wC = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, TC = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kC = ["fill"], EC = ["fill"];
function SC(e, t, n, r, o, i) {
  return d(), f("svg", TC, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M-6.10352e-05 0L64 0L64 64L-6.10352e-05 64L-6.10352e-05 0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, kC),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25 32L37 19.5L35.5 18L21.9999 32.0428L35.5 46L37 44.5L25 32Z",
      fill: n.buttonIconColor.hex
    }, null, 8, EC)
  ]);
}
const MC = /* @__PURE__ */ B(wC, [["render", SC]]), AC = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, IC = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LC = ["fill"], DC = ["fill"];
function $C(e, t, n, r, o, i) {
  return d(), f("svg", IC, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M64 64L-7.62939e-06 64L-2.03434e-06 -1.78036e-06L64 3.8147e-06L64 64Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, LC),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M39 32L27 44.5L28.5 46L42 31.9572L28.5 18L27 19.5L39 32Z",
      fill: n.buttonIconColor.hex
    }, null, 8, DC)
  ]);
}
const OC = /* @__PURE__ */ B(AC, [["render", $C]]), PC = {
  name: "G2",
  components: {
    PauseSvg: pC,
    PlaySvg: CC,
    ReverseSvg: MC,
    AdvanceSvg: OC,
    ResponsiveImage: Ur
  },
  mixins: [Zn],
  computed: {
    titleText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.title) || "";
    },
    descriptionText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.content) || "";
    },
    colors() {
      var e, t, n, r;
      return {
        "--button-bg-color": ((t = (e = this.theme) == null ? void 0 : e.button_bg_color) == null ? void 0 : t.hex) || "",
        "--button-color": ((r = (n = this.theme) == null ? void 0 : n.button_icon_color) == null ? void 0 : r.hex) || ""
      };
    },
    arrowsVisible() {
      return this.slides.length > 1 && !this.theme.use_video && !this.theme.hasFloatingNav;
    },
    videoAltText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.alt_text) || "";
    },
    videoUrl() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.url) || "";
    },
    showPauseButton() {
      return this.theme.use_video && this.playVideo || !this.theme.use_video && this.playSlideshow && this.slides.length > 1;
    },
    showPlayButton() {
      return this.theme.use_video && !this.playVideo || !this.theme.use_video && !this.playSlideshow && this.slides.length > 1;
    }
  },
  watch: {
    "theme.use_video": {
      handler() {
        this.theme.use_video ? (this.playSlideshow = !1, this.toggleVideoPlay()) : (this.playVideo = !1, this.togglePlay());
      }
    }
  }
}, NC = { class: "image-wrapper" }, HC = {
  key: 1,
  class: "video-wrapper"
}, FC = ["aria-label", "src"], RC = { "data-testid": "video-play-pause-wrapper" }, VC = ["data-testid"], BC = { class: "button-action-content" }, jC = ["data-testid"], UC = { class: "button-action-content" }, qC = { class: "button-action-content" }, GC = { class: "button-action-content" }, KC = {
  key: 4,
  class: "position"
}, zC = ["aria-current", "aria-label", "onClick", "onKeydown"], ZC = ["innerHTML"], xC = ["innerHTML"];
function WC(e, t, n, r, o, i) {
  const a = V("responsive-image"), s = V("PauseSvg"), l = V("PlaySvg"), u = V("ReverseSvg"), m = V("AdvanceSvg"), v = Ke("touch");
  return d(), f("div", {
    id: "g2",
    style: Z([e.linkStyle, i.colors, e.imageHeight])
  }, [
    c("div", {
      class: "slide",
      style: Z(`background: ${e.theme.bg_color.hex}`)
    }, [
      c("div", NC, [
        e.theme.use_video ? T("", !0) : we((d(), I(zn, {
          key: 0,
          class: "img-slider",
          tag: "div",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: S(() => [
            (d(), I(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            v,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            v,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.theme.use_video ? (d(), f("div", HC, [
          c("video", {
            ref: "videoPlayer",
            "aria-label": i.videoAltText,
            src: i.videoUrl,
            class: "video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            "data-testid": "gallery-video"
          }, " Your browser does not support videos. ", 8, FC)
        ])) : T("", !0),
        c("div", RC, [
          i.showPauseButton ? (d(), f("button", {
            key: 0,
            "aria-label": "Pause Gallery",
            "data-testid": e.theme.use_video ? "video-pause-button" : "pause-button",
            class: "pause button-action",
            onClick: t[0] || (t[0] = (g) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay()),
            onKeydown: t[1] || (t[1] = K(W((g) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay(), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", BC, [
              j(s, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 40, VC)) : i.showPlayButton ? (d(), f("button", {
            key: 1,
            "aria-label": "Play Gallery",
            "data-testid": e.theme.use_video ? "video-play-button" : "play-button",
            class: "play button-action",
            onClick: t[2] || (t[2] = (g) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay()),
            onKeydown: t[3] || (t[3] = K(W((g) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay(), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", UC, [
              j(l, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 40, jC)) : T("", !0)
        ]),
        i.arrowsVisible ? (d(), f("button", {
          key: 2,
          class: "left-arrow button-action",
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image",
          onClick: t[4] || (t[4] = (...g) => e.moveBack && e.moveBack(...g)),
          onKeydown: t[5] || (t[5] = K(W((...g) => e.moveBack && e.moveBack(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", qC, [
            j(u, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : T("", !0),
        i.arrowsVisible ? (d(), f("button", {
          key: 3,
          class: "right-arrow button-action",
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image",
          onClick: t[6] || (t[6] = (...g) => e.moveForward && e.moveForward(...g)),
          onKeydown: t[7] || (t[7] = K(W((...g) => e.moveForward && e.moveForward(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", GC, [
            j(m, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : T("", !0),
        e.slides.length > 1 && !e.theme.use_video ? (d(), f("div", KC, [
          (d(!0), f(J, null, ne(e.slides, (g, h) => (d(), f("div", {
            key: g.url
          }, [
            c("button", {
              class: _(["square button-action", { active: e.activeImageIdx === h }]),
              "aria-current": e.activeImageIdx === h ? "active" : null,
              "aria-label": `Image ${h + 1}`,
              style: Z({
                "background-color": e.activeImageIdx === h ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
              }),
              "data-testid": "gallery-pager-button",
              onClick: (E) => e.jump(h),
              onKeydown: K(W((E) => e.jump(h), ["exact", "prevent"]), ["enter"])
            }, t[8] || (t[8] = [
              c("div", { class: "button-action-content" }, null, -1)
            ]), 46, zC)
          ]))), 128))
        ])) : T("", !0)
      ]),
      i.titleText || i.descriptionText ? (d(), f("div", {
        key: 0,
        class: "text",
        style: Z(`background: ${e.theme.overlay_color.hex}CC`)
      }, [
        i.titleText ? (d(), f("div", {
          key: 0,
          class: _(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          c("div", {
            ref: "title",
            style: Z(`color: ${e.theme.heading_color.hex}`),
            innerHTML: i.titleText
          }, null, 12, ZC)
        ], 2)) : T("", !0),
        i.descriptionText ? (d(), f("div", {
          key: 1,
          class: _(["description", e.theme.style])
        }, [
          c("div", {
            style: Z(`color: ${e.theme.text_color.hex}`),
            innerHTML: i.descriptionText
          }, null, 12, xC)
        ], 2)) : T("", !0)
      ], 4)) : T("", !0)
    ], 4)
  ], 4);
}
const YC = /* @__PURE__ */ B(PC, [["render", WC], ["__scopeId", "data-v-802dd901"]]), XC = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, QC = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, JC = ["fill", "stroke"], ew = ["fill"];
function tw(e, t, n, r, o, i) {
  return d(), f("svg", QC, [
    c("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9",
      stroke: n.buttonIconColor.hex
    }, null, 8, JC),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex
    }, null, 8, ew)
  ]);
}
const nw = /* @__PURE__ */ B(XC, [["render", tw]]), rw = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, ow = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iw = ["fill", "stroke"], sw = ["fill"];
function aw(e, t, n, r, o, i) {
  return d(), f("svg", ow, [
    c("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9",
      stroke: n.buttonIconColor.hex
    }, null, 8, iw),
    c("path", {
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, sw)
  ]);
}
const lw = /* @__PURE__ */ B(rw, [["render", aw]]), uw = {
  name: "SvgReverse",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    buttonBgColor: {
      type: Object,
      required: !0
    }
  }
}, dw = ["stroke"], cw = ["fill"];
function hw(e, t, n, r, o, i) {
  return d(), f("svg", {
    style: Z({ backgroundColor: n.buttonBgColor.hex }),
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      d: "M45.5 45.4999L0.5 45.4999L0.500004 0.500007L45.5 0.500011L45.5 45.4999Z",
      fill: "black",
      "fill-opacity": "0.01",
      stroke: n.buttonIconColor.hex
    }, null, 8, dw),
    c("path", {
      d: "M19.5 33.9999L8 22.9999L19.5 10.9999L21 12.4999L12 21.9999L38 21.9999L38 23.9999L12 23.9999L21 32.4999L19.5 33.9999Z",
      fill: n.buttonIconColor.hex
    }, null, 8, cw)
  ], 4);
}
const mw = /* @__PURE__ */ B(uw, [["render", hw]]), fw = {
  name: "SvgAdvance",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    buttonBgColor: {
      type: Object,
      required: !0
    }
  }
}, pw = ["stroke"], gw = ["fill"];
function vw(e, t, n, r, o, i) {
  return d(), f("svg", {
    style: Z({ backgroundColor: n.buttonBgColor.hex }),
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01",
      stroke: n.buttonIconColor.hex
    }, null, 8, pw),
    c("path", {
      d: "M26.5 12L38 23L26.5 35L25 33.5L34 24H8V22H34L25 13.5L26.5 12Z",
      fill: n.buttonIconColor.hex
    }, null, 8, gw)
  ], 4);
}
const bw = /* @__PURE__ */ B(fw, [["render", vw]]), yw = {
  name: "G3",
  components: {
    ResponsiveImage: Ur,
    PauseSvg: nw,
    ReverseSvg: mw,
    PlaySvg: lw,
    AdvanceSvg: bw
  },
  mixins: [Zn],
  computed: {
    cssVars() {
      return {
        "--gradient-color": `linear-gradient(180deg, rgba(1, 73, 145, 0) 0%, ${this.theme.overlay_color.hex} 80.73%)`
      };
    }
  }
}, _w = { class: "image-wrapper" }, Cw = { class: "button-action-content" }, ww = { class: "button-action-content" }, Tw = { class: "position-tablet" }, kw = ["aria-current", "aria-label", "onKeydown", "onClick"], Ew = { class: "button-action-content" }, Sw = { class: "button-action-content" }, Mw = ["innerHTML"], Aw = {
  key: 0,
  class: "navigation"
}, Iw = { class: "button-action-content" }, Lw = { class: "button-action-content" }, Dw = { class: "info" }, $w = {
  key: 0,
  class: "position"
}, Ow = ["aria-label", "aria-current", "onClick", "onKeydown"], Pw = ["innerHTML"], Nw = ["innerHTML"], Hw = {
  key: 1,
  class: "arrows"
}, Fw = { class: "button-action-content" }, Rw = { class: "button-action-content" };
function Vw(e, t, n, r, o, i) {
  const a = V("responsive-image"), s = V("PlaySvg"), l = V("PauseSvg"), u = V("ReverseSvg"), m = V("AdvanceSvg"), v = Ke("touch");
  return d(), f("div", {
    id: "g3",
    style: Z([e.linkStyle, e.imageHeight, i.cssVars])
  }, [
    c("div", {
      class: "slide",
      style: Z({ "background-color": e.theme.overlay_color.hex })
    }, [
      c("div", _w, [
        we((d(), I(zn, {
          tag: "div",
          class: "image",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: S(() => [
            (d(), I(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            v,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            v,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.slides.length > 1 ? (d(), f("div", {
          key: 0,
          class: _(["navigation-small", { "gradient-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }])
        }, [
          e.playSlideshow ? (d(), f("button", {
            key: 1,
            "aria-label": "Pause Gallery",
            "data-testid": "pause-button",
            class: "pause button-action",
            onClick: t[2] || (t[2] = (...g) => e.togglePlay && e.togglePlay(...g)),
            onKeydown: t[3] || (t[3] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", ww, [
              j(l, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)) : (d(), f("button", {
            key: 0,
            "aria-label": "Play Gallery",
            "data-testid": "play-button",
            class: "play button-action",
            onClick: t[0] || (t[0] = (...g) => e.togglePlay && e.togglePlay(...g)),
            onKeydown: t[1] || (t[1] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", Cw, [
              j(s, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32)),
          c("div", Tw, [
            (d(!0), f(J, null, ne(e.slides, (g, h) => (d(), f("div", {
              key: g.url
            }, [
              c("button", {
                class: "square button-action",
                style: Z({
                  "background-color": e.activeImageIdx === h ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
                }),
                "aria-current": e.activeImageIdx === h ? "active" : "inactive",
                "aria-label": `Image ${h + 1}`,
                "data-testid": "gallery-pager-button",
                onKeydown: K(W((E) => e.jump(h), ["exact", "prevent"]), ["enter"]),
                onClick: (E) => e.jump(h)
              }, null, 44, kw)
            ]))), 128))
          ]),
          c("button", {
            class: "left-arrow button-action",
            "data-testid": "gallery-left-button",
            "aria-label": "Previous Image",
            onClick: t[4] || (t[4] = (...g) => e.moveBack && e.moveBack(...g)),
            onKeydown: t[5] || (t[5] = K(W((...g) => e.moveBack && e.moveBack(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", Ew, [
              j(u, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32),
          c("button", {
            class: "right-arrow button-action",
            "data-testid": "gallery-right-button",
            "aria-label": "Next Image",
            onClick: t[6] || (t[6] = (...g) => e.moveForward && e.moveForward(...g)),
            onKeydown: t[7] || (t[7] = K(W((...g) => e.moveForward && e.moveForward(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", Sw, [
              j(m, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32)
        ], 2)) : T("", !0),
        c("div", {
          class: _(["title-on-image", [
            e.theme.style,
            { "gradient-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }
          ]])
        }, [
          c("div", {
            ref: "title",
            style: Z(`color: ${e.theme.heading_color.hex}`),
            "data-testid": "gallery-title",
            innerHTML: e.slides[e.activeImageIdx].title
          }, null, 12, Mw)
        ], 2)
      ]),
      e.slides.length > 1 ? (d(), f("div", Aw, [
        e.playSlideshow ? (d(), f("button", {
          key: 1,
          "aria-label": "Pause Gallery",
          "data-testid": "pause-button",
          class: "pause button-action",
          onClick: t[10] || (t[10] = (...g) => e.togglePlay && e.togglePlay(...g)),
          onKeydown: t[11] || (t[11] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", Lw, [
            j(l, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : (d(), f("button", {
          key: 0,
          "aria-label": "Play Gallery",
          "data-testid": "play-button",
          class: "play button-action",
          onClick: t[8] || (t[8] = (...g) => e.togglePlay && e.togglePlay(...g)),
          onKeydown: t[9] || (t[9] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", Iw, [
            j(s, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32))
      ])) : T("", !0),
      c("div", Dw, [
        e.slides.length > 1 ? (d(), f("div", $w, [
          (d(!0), f(J, null, ne(e.slides, (g, h) => (d(), f("div", {
            key: g.url
          }, [
            c("button", {
              class: "square",
              style: Z({
                "background-color": e.activeImageIdx === h ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
              }),
              "aria-label": `Image ${h + 1}`,
              "aria-current": e.activeImageIdx === h ? "active" : null,
              onClick: (E) => e.jump(h),
              onKeydown: K(W((E) => e.jump(h), ["exact", "prevent"]), ["enter"])
            }, null, 44, Ow)
          ]))), 128))
        ])) : T("", !0),
        c("div", {
          class: _(["gradient", { "show-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }])
        }, [
          c("div", {
            class: _(["title", e.theme.style])
          }, [
            c("div", {
              style: Z(`color: ${e.theme.heading_color.hex}`),
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 12, Pw)
          ], 2),
          c("div", {
            class: _(["description", e.theme.style])
          }, [
            c("div", {
              style: Z(`color: ${e.theme.text_color.hex}`),
              innerHTML: e.slides[e.activeImageIdx].content
            }, null, 12, Nw)
          ], 2)
        ], 2)
      ]),
      e.slides.length > 1 ? (d(), f("div", Hw, [
        c("button", {
          class: "left-arrow button-action",
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image",
          onClick: t[12] || (t[12] = (...g) => e.moveBack && e.moveBack(...g)),
          onKeydown: t[13] || (t[13] = K(W((...g) => e.moveBack && e.moveBack(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", Fw, [
            j(u, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32),
        c("button", {
          class: "right-arrow button-action",
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image",
          onClick: t[14] || (t[14] = (...g) => e.moveForward && e.moveForward(...g)),
          onKeydown: t[15] || (t[15] = K(W((...g) => e.moveForward && e.moveForward(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", Rw, [
            j(m, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)
      ])) : T("", !0)
    ], 4)
  ], 4);
}
const Bw = /* @__PURE__ */ B(yw, [["render", Vw], ["__scopeId", "data-v-b8acb151"]]), jw = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Uw = {
  class: "pause_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qw = ["fill"], Gw = ["fill"];
function Kw(e, t, n, r, o, i) {
  return d(), f("svg", Uw, [
    c("rect", {
      class: "icon-background",
      width: "40",
      height: "40",
      fill: n.buttonBgColor.hex
    }, null, 8, qw),
    c("path", {
      class: "icon-button",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 14H16V26H19V14ZM24 14H21V26H24V14Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Gw)
  ]);
}
const zw = /* @__PURE__ */ B(jw, [["render", Kw]]), Zw = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, xw = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ww = ["fill"], Yw = ["fill"];
function Xw(e, t, n, r, o, i) {
  return d(), f("svg", xw, [
    c("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, Ww),
    c("path", {
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Yw)
  ]);
}
const Qw = /* @__PURE__ */ B(Zw, [["render", Xw]]), Jw = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, eT = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tT = ["fill"], nT = ["fill"];
function rT(e, t, n, r, o, i) {
  return d(), f("svg", eT, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M-0.00012207 0H63.9999V62.9999H-0.00012207V0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, tT),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.7803 31.209L37.1333 43.8414L35.7324 45.265L21.9999 31.2222L35.9117 17L37.2991 18.4104L24.7803 31.209Z",
      fill: n.buttonIconColor.hex
    }, null, 8, nT)
  ]);
}
const oT = /* @__PURE__ */ B(Jw, [["render", rT]]), iT = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, sT = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aT = ["fill"], lT = ["fill"];
function uT(e, t, n, r, o, i) {
  return d(), f("svg", sT, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 0H63.9999V62.9999H0V0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, aT),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.5191 31.209L26.1659 43.8414L27.5668 45.265L41.2995 31.2222L27.3874 17L26 18.4104L38.5191 31.209Z",
      fill: n.buttonIconColor.hex
    }, null, 8, lT)
  ]);
}
const dT = /* @__PURE__ */ B(iT, [["render", uT]]), cT = {
  name: "G4",
  components: {
    ResponsiveImage: Ur,
    PauseSvg: zw,
    PlaySvg: Qw,
    ReverseSvg: oT,
    AdvanceSvg: dT
  },
  mixins: [Zn]
}, hT = { class: "image-and-nav" }, mT = { class: "image-wrapper" }, fT = {
  key: 0,
  class: "position-and-play"
}, pT = { class: "button-action-content" }, gT = { class: "button-action-content" }, vT = { class: "position" }, bT = ["aria-current", "aria-label", "onClick", "onKeydown"], yT = {
  key: 0,
  class: "navigation"
}, _T = { class: "arrows" }, CT = { class: "button-action-content" }, wT = { class: "button-action-content" }, TT = { class: "text" }, kT = ["innerHTML"], ET = ["innerHTML"];
function ST(e, t, n, r, o, i) {
  const a = V("PlaySvg"), s = V("PauseSvg"), l = V("responsive-image"), u = V("ReverseSvg"), m = V("AdvanceSvg"), v = Ke("touch");
  return d(), f("div", {
    id: "g4",
    style: Z([e.linkStyle, e.imageHeight])
  }, [
    c("div", {
      class: "slide",
      style: Z(`background: ${e.theme.bg_color.hex}`)
    }, [
      c("div", hT, [
        c("div", mT, [
          e.slides.length > 1 ? (d(), f("div", fT, [
            e.playSlideshow ? (d(), f("button", {
              key: 1,
              "aria-label": "Pause Gallery",
              "data-testid": "pause-button",
              class: "pause button-action",
              onClick: t[2] || (t[2] = (...g) => e.togglePlay && e.togglePlay(...g)),
              onKeydown: t[3] || (t[3] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", gT, [
                j(s, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)) : (d(), f("button", {
              key: 0,
              "aria-label": "Play Gallery",
              "data-testid": "play-button",
              class: "play button-action",
              onClick: t[0] || (t[0] = (...g) => e.togglePlay && e.togglePlay(...g)),
              onKeydown: t[1] || (t[1] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", pT, [
                j(a, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)),
            c("div", vT, [
              (d(!0), f(J, null, ne(e.slides, (g, h) => (d(), f("div", {
                key: g.url
              }, [
                c("button", {
                  class: _(["square", { active: e.activeImageIdx === h }]),
                  style: Z({
                    "background-color": e.activeImageIdx === h ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
                  }),
                  "aria-current": e.activeImageIdx === h ? "active" : null,
                  "aria-label": `Image ${h + 1}`,
                  "data-testid": "gallery-pager-button",
                  onClick: (E) => e.jump(h),
                  onKeydown: K(W((E) => e.jump(h), ["exact", "prevent"]), ["enter"])
                }, null, 46, bT)
              ]))), 128))
            ])
          ])) : T("", !0),
          we((d(), I(zn, {
            tag: "div",
            class: "img-slider",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: S(() => [
              (d(), I(l, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              v,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              v,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ]),
        e.slides.length > 1 ? (d(), f("div", yT, [
          c("div", _T, [
            c("button", {
              class: "left-arrow button-action",
              "data-testid": "gallery-left-button",
              "aria-label": "Previous Image",
              onClick: t[4] || (t[4] = (...g) => e.moveBack && e.moveBack(...g)),
              onKeydown: t[5] || (t[5] = K(W((...g) => e.moveBack && e.moveBack(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", CT, [
                j(u, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32),
            c("button", {
              class: "right-arrow button-action",
              "data-testid": "gallery-right-button",
              "aria-label": "Next Image",
              onClick: t[6] || (t[6] = (...g) => e.moveForward && e.moveForward(...g)),
              onKeydown: t[7] || (t[7] = K(W((...g) => e.moveForward && e.moveForward(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", wT, [
                j(m, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)
          ])
        ])) : T("", !0)
      ]),
      c("div", TT, [
        c("div", {
          class: _(["title", e.theme.style])
        }, [
          c("div", {
            ref: "title",
            style: Z(`color: ${e.theme.heading_color.hex}`),
            "data-testid": "gallery-title",
            innerHTML: e.slides[0].title
          }, null, 12, kT)
        ], 2),
        c("div", {
          class: _(["description", e.theme.style])
        }, [
          c("div", {
            style: Z(`color: ${e.theme.text_color.hex}`),
            innerHTML: e.slides[0].content
          }, null, 12, ET)
        ], 2)
      ])
    ], 4)
  ], 4);
}
const MT = /* @__PURE__ */ B(cT, [["render", ST], ["__scopeId", "data-v-958685b9"]]), AT = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, IT = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LT = ["fill"], DT = ["fill"];
function $T(e, t, n, r, o, i) {
  return d(), f("svg", IT, [
    c("path", {
      fill: n.buttonBgColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.0700684 0.910156L66.2576 0.910156L66.2576 65.0005L0.0700684 65.0005L0.0700684 0.910156Z"
    }, null, 8, LT),
    c("path", {
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25.9246 32.9568L38.3347 20.4391L36.7834 18.937L22.822 32.9997L36.7834 46.9766L38.3347 45.4744L25.9246 32.9568Z"
    }, null, 8, DT)
  ]);
}
const OT = /* @__PURE__ */ B(AT, [["render", $T]]), PT = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, NT = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HT = ["fill"], FT = ["stroke"];
function RT(e, t, n, r, o, i) {
  return d(), f("svg", NT, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.88353 22.6238L8.11814 22.8624L7.57617 23.4133L19.2807 35.3118L20.6718 33.899L10.9346 23.9994H38.3765V21.9993H11.2035L20.6718 12.373L19.3191 10.998L7.88353 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, HT),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, FT)
  ]);
}
const VT = /* @__PURE__ */ B(PT, [["render", RT]]), BT = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, jT = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, UT = ["fill"], qT = ["stroke"];
function GT(e, t, n, r, o, i) {
  return d(), f("svg", jT, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.361 22.6238L38.1264 22.8624L38.6684 23.4133L26.9641 35.3118L25.5731 33.899L35.3101 23.9994H7.86816V21.9993H35.0411L25.5731 12.373L26.9257 10.998L38.361 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, UT),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, qT)
  ]);
}
const KT = /* @__PURE__ */ B(BT, [["render", GT]]), zT = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, ZT = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xT = ["fill"], WT = ["fill"];
function YT(e, t, n, r, o, i) {
  return d(), f("svg", ZT, [
    c("path", {
      fill: n.buttonBgColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M66.6326 65L0.445007 65L0.445013 0.909601L66.6326 0.909607L66.6326 65Z"
    }, null, 8, xT),
    c("path", {
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M40.7781 32.9534L28.3679 45.471L29.9192 46.9731L43.8806 32.9105L29.9192 18.9336L28.3679 20.4357L40.7781 32.9534Z"
    }, null, 8, WT)
  ]);
}
const XT = /* @__PURE__ */ B(zT, [["render", YT]]), QT = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, JT = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ek = ["stroke"], tk = ["fill"], nk = ["fill"];
function rk(e, t, n, r, o, i) {
  return d(), f("svg", JT, [
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, ek),
    n.paused ? (d(), f("path", {
      key: 0,
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, tk)) : (d(), f("path", {
      key: 1,
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, 8, nk))
  ]);
}
const ok = /* @__PURE__ */ B(QT, [["render", rk]]), ik = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, sk = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ak = ["fill"], lk = ["fill"], uk = ["fill"];
function dk(e, t, n, r, o, i) {
  return d(), f("svg", sk, [
    c("rect", {
      fill: n.buttonBgColor.hex,
      x: "0.257568",
      y: "0.910156",
      width: "66.1876",
      height: "64.0904"
    }, null, 8, ak),
    n.paused ? (d(), f("path", {
      key: 0,
      fill: n.buttonIconColor.hex,
      d: "M29.2146 44.9734L41.6248 32.9564L29.2146 20.9395V44.9734Z"
    }, null, 8, lk)) : (d(), f("path", {
      key: 1,
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31 20H25V44H31V20ZM41 20H35V44H41V20Z"
    }, null, 8, uk))
  ]);
}
const ck = /* @__PURE__ */ B(ik, [["render", dk]]), hk = {
  name: "G5Buttons",
  components: { ReverseASvg: VT, ReverseBSvg: OT, AdvanceASvg: KT, AdvanceBSvg: XT, PlayPauseASvg: ok, PlayPauseBSvg: ck },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    activeImageIdx: {
      type: Number,
      default: 0
    },
    pagerNumber: {
      type: Number,
      default: 0
    },
    hidePager: Boolean,
    playSlideshow: Boolean,
    onlyPlayButton: Boolean,
    smallPager: Boolean,
    isEditing: Boolean
  },
  computed: {
    cssVars() {
      var e, t, n, r;
      return {
        "--gallery-button-color": ((e = this.theme.button_icon_color) == null ? void 0 : e.hex) || "#FFFFFF",
        "--gallery-button-bg-color": ((t = this.theme.button_bg_color) == null ? void 0 : t.hex) || "#333333",
        "--gallery-pager-color": ((n = this.theme.pager_color) == null ? void 0 : n.hex) || "#333333",
        "--gallery-pager-active-color": ((r = this.theme.pager_active_color) == null ? void 0 : r.hex) || "#0000FF"
      };
    }
  }
}, mk = { class: "gallery-buttons" }, fk = ["aria-label", "data-testid", "disabled"], pk = {
  key: 0,
  class: "gallery-pager"
}, gk = ["aria-label", "aria-current", "onClick"], vk = {
  key: 0,
  class: "pager-bottom"
}, bk = {
  key: 1,
  class: "gallery-small-pager"
}, yk = ["aria-label", "aria-current", "onClick"];
function _k(e, t, n, r, o, i) {
  const a = V("PlayPauseASvg"), s = V("PlayPauseBSvg"), l = V("ReverseASvg"), u = V("ReverseBSvg"), m = V("AdvanceASvg"), v = V("AdvanceBSvg");
  return d(), f("div", {
    style: Z(i.cssVars),
    class: _(["gallery-button-wrapper", `type-${n.theme.type}`])
  }, [
    c("div", mk, [
      c("button", {
        style: { order: 2 },
        "aria-label": n.playSlideshow ? "Pause Gallery" : "Play Gallery",
        "data-testid": n.playSlideshow ? "pause-button" : "play-button ",
        class: _(["pause-play-button", { hasWidget: n.theme.cta_widget }]),
        disabled: n.isEditing,
        onClick: t[0] || (t[0] = (g) => e.$emit("togglePlay")),
        onKeydown: t[1] || (t[1] = K(W((g) => e.$emit("togglePlay"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (d(), I(a, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"])) : (d(), I(s, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"]))
      ], 42, fk),
      n.onlyPlayButton ? T("", !0) : (d(), f("button", {
        key: 0,
        "aria-label": "Previous Image",
        "data-testid": "gallery-left-button",
        style: { order: 1 },
        onClick: t[2] || (t[2] = (g) => e.$emit("scrollLeft")),
        onKeydown: t[3] || (t[3] = K(W((g) => e.$emit("scrollLeft"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (d(), I(l, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])) : (d(), I(u, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"]))
      ], 32)),
      n.onlyPlayButton ? T("", !0) : (d(), f("button", {
        key: 1,
        "aria-label": "Next Image",
        "data-testid": "gallery-right-button",
        style: { order: 3 },
        onClick: t[4] || (t[4] = (g) => e.$emit("scrollRight")),
        onKeydown: t[5] || (t[5] = K(W((g) => e.$emit("scrollRight"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (d(), I(m, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])) : (d(), I(v, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"]))
      ], 32))
    ]),
    n.hidePager ? T("", !0) : (d(), f(J, { key: 0 }, [
      n.pagerNumber && !n.smallPager ? (d(), f("div", pk, [
        (d(!0), f(J, null, ne(n.pagerNumber, (g, h) => (d(), f("button", {
          key: g,
          class: _({ active: n.activeImageIdx === h }),
          "aria-label": `Image ${h + 1}`,
          "aria-current": n.activeImageIdx === h ? "active" : null,
          "data-testid": "gallery-pager-button",
          onClick: (E) => e.$emit("jumpTo", h)
        }, [
          c("span", null, k(g), 1),
          n.theme.type === "A" ? (d(), f("div", vk)) : T("", !0)
        ], 10, gk))), 128))
      ])) : (d(), f("div", bk, [
        (d(!0), f(J, null, ne(n.pagerNumber, (g, h) => (d(), f("button", {
          key: g,
          "aria-label": `Image ${h + 1}`,
          "aria-current": n.activeImageIdx === h,
          class: _([{ active: n.activeImageIdx === h }, "circle"]),
          "data-testid": "gallery-pager-button",
          onClick: (E) => e.$emit("jumpTo", h)
        }, null, 10, yk))), 128))
      ]))
    ], 64))
  ], 6);
}
const Ck = /* @__PURE__ */ B(hk, [["render", _k], ["__scopeId", "data-v-099308b8"]]), wk = {
  name: "G5",
  components: {
    ResponsiveImage: Ur,
    G5Buttons: Ck
  },
  mixins: [Zn],
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    cssVars() {
      return {
        "--gallery-heading-color": $(this.theme, "heading_color.hex", "#fff"),
        "--gallery-link-color": $(this.theme, "link_color.hex", "#fff"),
        "--gradient-color": `linear-gradient(0deg, ${this.theme.overlay_color.hex} 0%, rgba(19, 19, 19, 0) 71.87%)`
      };
    }
  }
}, Tk = { class: "slide-wrapper" }, kk = { class: "bottom-content gradient" }, Ek = ["innerHTML"], Sk = {
  key: 0,
  class: "navigation"
};
function Mk(e, t, n, r, o, i) {
  const a = V("responsive-image"), s = V("G5Buttons"), l = Ke("touch");
  return d(), f("div", {
    id: "g5",
    "data-testid": "G5",
    class: _(`type-${e.theme.type}`),
    style: Z([i.cssVars, e.imageHeight])
  }, [
    c("div", {
      class: "slide",
      style: Z({ "background-color": e.theme.overlay_color.hex })
    }, [
      c("div", Tk, [
        M(e.$slots, "controls"),
        M(e.$slots, "image", {}, () => [
          we((d(), I(zn, {
            tag: "div",
            class: "image",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: S(() => [
              (d(), I(a, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              l,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              l,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ])
      ]),
      c("div", kk, [
        c("div", {
          class: _(["left-text", e.theme.style])
        }, [
          M(e.$slots, "title", {}, () => [
            c("div", {
              class: "title",
              "data-testid": "gallery-title",
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 8, Ek)
          ])
        ], 2),
        e.slides.length > 1 ? (d(), f("div", Sk, [
          j(s, {
            theme: e.theme,
            "pager-number": e.slides.length,
            "active-image-idx": e.activeImageIdx,
            "play-slideshow": e.playSlideshow,
            "is-editing": n.isEditing,
            "hide-pager": e.screenSize < 600,
            onJumpTo: e.handleJump,
            onScrollLeft: e.handleScrollLeft,
            onScrollRight: e.handleScrollRight,
            onTogglePlay: e.togglePlay
          }, null, 8, ["theme", "pager-number", "active-image-idx", "play-slideshow", "is-editing", "hide-pager", "onJumpTo", "onScrollLeft", "onScrollRight", "onTogglePlay"])
        ])) : T("", !0)
      ])
    ], 4)
  ], 6);
}
const Ak = /* @__PURE__ */ B(wk, [["render", Mk], ["__scopeId", "data-v-5e12fa68"]]), Ik = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Lk = ["fill"], Dk = ["stroke"];
function $k(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: Z({ backgroundColor: n.buttonBgColor.hex })
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.88353 22.6238L8.11814 22.8624L7.57617 23.4133L19.2807 35.3118L20.6718 33.899L10.9346 23.9994H38.3765V21.9993H11.2035L20.6718 12.373L19.3191 10.998L7.88353 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Lk),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Dk)
  ], 4);
}
const Ok = /* @__PURE__ */ B(Ik, [["render", $k]]), Pk = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Nk = ["fill"], Hk = ["stroke"];
function Fk(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: Z({ backgroundColor: n.buttonBgColor.hex })
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.361 22.6238L38.1264 22.8624L38.6684 23.4133L26.9641 35.3118L25.5731 33.899L35.3101 23.9994H7.86816V21.9993H35.0411L25.5731 12.373L26.9257 10.998L38.361 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Nk),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Hk)
  ], 4);
}
const Rk = /* @__PURE__ */ B(Pk, [["render", Fk]]), Vk = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, Bk = ["stroke"], jk = ["fill"], Uk = ["fill"];
function qk(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: Z({ backgroundColor: n.buttonBgColor.hex })
  }, [
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Bk),
    n.paused ? (d(), f("path", {
      key: 0,
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, jk)) : (d(), f("path", {
      key: 1,
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, 8, Uk))
  ], 4);
}
const Gk = /* @__PURE__ */ B(Vk, [["render", qk]]), Kk = {
  name: "G6Buttons",
  components: { ReverseSvg: Ok, AdvanceSvg: Rk, PlayPauseSvg: Gk },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    pagerNumber: {
      type: Number,
      default: 0
    },
    activeImageIdx: {
      type: Number,
      default: 0
    },
    hidePager: Boolean,
    playSlideshow: Boolean,
    isEditing: Boolean
  },
  computed: {
    cssVars() {
      return {
        "--gallery-button-color": $(this.theme, "button_icon_color.hex", "#FFFFFF"),
        "--gallery-button-bg-color": $(this.theme, "button_bg_color.hex", "#333333"),
        "--gallery-pager-color": $(this.theme, "pager_color.hex", "#333333"),
        "--gallery-pager-active-color": $(this.theme, "pager_active_color.hex", "#0000FF")
      };
    }
  }
}, zk = ["aria-label", "data-testid", "disabled"], Zk = {
  key: 0,
  class: "gallery-pager"
}, xk = ["aria-label", "aria-current", "onClick"];
function Wk(e, t, n, r, o, i) {
  const a = V("PlayPauseSvg"), s = V("ReverseSvg"), l = V("AdvanceSvg");
  return d(), f("div", {
    style: Z(i.cssVars),
    class: _(["gallery-button-wrapper"])
  }, [
    c("div", {
      class: _(["gallery-buttons", { hasWidget: n.theme.cta_widget }])
    }, [
      c("button", {
        style: { order: 2 },
        "aria-label": n.playSlideshow ? "Pause Gallery" : "Play Gallery",
        "data-testid": n.playSlideshow ? "pause-button" : "play-button ",
        class: "pause-play-button",
        disabled: n.isEditing,
        onClick: t[0] || (t[0] = (u) => e.$emit("togglePlay")),
        onKeydown: t[1] || (t[1] = K(W((u) => e.$emit("togglePlay"), ["exact", "prevent"]), ["enter"]))
      }, [
        j(a, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"])
      ], 40, zk),
      c("button", {
        "aria-label": "Previous Image",
        "data-testid": "gallery-left-button",
        style: { order: 1 },
        onClick: t[2] || (t[2] = (u) => e.$emit("scrollLeft")),
        onKeydown: t[3] || (t[3] = K(W((u) => e.$emit("scrollLeft"), ["exact", "prevent"]), ["enter"]))
      }, [
        j(s, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])
      ], 32),
      c("button", {
        "aria-label": "Next Image",
        "data-testid": "gallery-right-button",
        style: { order: 3 },
        onClick: t[4] || (t[4] = (u) => e.$emit("scrollRight")),
        onKeydown: t[5] || (t[5] = K(W((u) => e.$emit("scrollRight"), ["exact", "prevent"]), ["enter"]))
      }, [
        j(l, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])
      ], 32)
    ], 2),
    n.hidePager ? T("", !0) : (d(), f("div", Zk, [
      (d(!0), f(J, null, ne(n.pagerNumber, (u, m) => (d(), f("button", {
        key: u,
        class: _({ active: n.activeImageIdx === m }),
        "aria-label": `Image ${m + 1}`,
        "aria-current": n.activeImageIdx === m ? "active" : null,
        "data-testid": "gallery-pager-button",
        onClick: (v) => e.$emit("jumpTo", m)
      }, [
        c("span", null, k(u), 1),
        t[6] || (t[6] = c("div", { class: "pager-bottom" }, null, -1))
      ], 10, xk))), 128))
    ]))
  ], 4);
}
const Yk = /* @__PURE__ */ B(Kk, [["render", Wk], ["__scopeId", "data-v-b6c5f932"]]), Xk = {
  name: "G6",
  components: {
    ResponsiveImage: Ur,
    G6Buttons: Yk
  },
  mixins: [Zn],
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    displayWidget() {
      return this.theme.cta_widget && (!Br(this.widget) || this.isEditing);
    },
    cssVars() {
      var e, t;
      return {
        "--gallery-heading-color": $(this.theme, "heading_color.hex", "#fff"),
        "--gallery-link-color": $(this.theme, "link_color.hex", "#fff"),
        "--gradient-color": `radial-gradient( ${(t = (e = this.theme) == null ? void 0 : e.overlay_color) == null ? void 0 : t.hex}, rgba(255, 255, 255, 0) 75%)`,
        "--widget-line-color": $(this.theme, "widget_line_color.hex", "#B9770E"),
        "--widget-background-color": $(this.theme, "widget_background_color.hex", "#fff"),
        "--widget-text-color": $(this.theme, "widget_text_color.hex", "#000000"),
        "--widget-button-icon-color": $(this.theme, "widget_button_icon_color.hex", "#fff"),
        "--widget-button-background-color": $(this.theme, "widget_button_background_color.hex", "#B9770E")
      };
    },
    widgetLinkName() {
      var e, t;
      return (t = (e = this.widget) == null ? void 0 : e.link) != null && t.name ? this.widget.link.name : this.widgetLinkHref;
    },
    widgetBody() {
      var e;
      return ((e = this.widget) == null ? void 0 : e.body) || "";
    },
    widgetLinkHref() {
      var e, t;
      return ((t = (e = this.widget) == null ? void 0 : e.link) == null ? void 0 : t.href) || "";
    },
    widgetLinkTarget() {
      var e, t;
      return ((t = (e = this.widget) == null ? void 0 : e.link) == null ? void 0 : t.target) || "_blank";
    }
  }
}, Qk = { class: "slide" }, Jk = ["innerHTML"], eE = {
  key: 0,
  class: "main-content-button"
}, tE = { class: "slide-wrapper" }, nE = {
  key: 0,
  class: "widget",
  "data-testid": "cta-widget"
}, rE = ["innerHTML"];
function oE(e, t, n, r, o, i) {
  const a = V("G6Buttons"), s = V("responsive-image"), l = Ke("touch");
  return d(), f("div", {
    class: "g6",
    "data-testid": "G6",
    style: Z([i.cssVars, e.imageHeight, e.bgColor])
  }, [
    c("div", Qk, [
      c("div", {
        class: _(["main-content", { "has-widget": e.theme.cta_widget }])
      }, [
        c("div", {
          class: _([
            e.slides[e.activeImageIdx].title ? "main-content-title" : "main-content-title-empty",
            "left-text",
            e.theme.style
          ])
        }, [
          M(e.$slots, "title", {}, () => [
            c("div", {
              class: "title",
              "data-testid": "gallery-title",
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 8, Jk)
          ])
        ], 2),
        e.slides.length > 1 ? (d(), f("div", eE, [
          j(a, {
            theme: e.theme,
            "pager-number": e.slides.length,
            "active-image-idx": e.activeImageIdx,
            "hide-pager": e.screenSize < 600,
            "play-slideshow": e.playSlideshow,
            "is-editing": n.isEditing,
            onJumpTo: e.handleJump,
            onScrollLeft: e.handleScrollLeft,
            onScrollRight: e.handleScrollRight,
            onTogglePlay: e.togglePlay
          }, null, 8, ["theme", "pager-number", "active-image-idx", "hide-pager", "play-slideshow", "is-editing", "onJumpTo", "onScrollLeft", "onScrollRight", "onTogglePlay"])
        ])) : T("", !0)
      ], 2),
      c("div", tE, [
        i.displayWidget ? (d(), f("div", nE, [
          M(e.$slots, "widget", {}, () => [
            c("div", {
              class: _(["widget-body", e.theme.style]),
              "data-testid": "cta-widget-body",
              innerHTML: i.widgetBody
            }, null, 10, rE)
          ]),
          (d(), I(Y(n.isEditing ? "button" : "a"), {
            class: "widget-button",
            "aria-label": i.widgetLinkName,
            href: i.widgetLinkHref,
            target: i.widgetLinkTarget,
            "data-testid": "cta-widget-button",
            onClick: t[0] || (t[0] = (u) => e.$emit("openLinkModal"))
          }, {
            default: S(() => t[1] || (t[1] = [
              c("svg", {
                width: "15",
                height: "12",
                viewBox: "0 0 15 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                c("path", {
                  d: "M14 6H1M14 6L9.21053 1M14 6L9.21053 11",
                  stroke: "var(--widget-button-icon-color)",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ])),
            _: 1,
            __: [1]
          }, 8, ["aria-label", "href", "target"]))
        ])) : T("", !0),
        t[2] || (t[2] = c("div", { class: "gallery-decoration" }, [
          c("div", { class: "gallery-decoration-left" }),
          c("div", { class: "gallery-decoration-right" })
        ], -1)),
        M(e.$slots, "controls"),
        M(e.$slots, "image", {}, () => [
          we((d(), I(zn, {
            tag: "div",
            class: "image",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: S(() => [
              (d(), I(s, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              l,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              l,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ])
      ])
    ])
  ], 4);
}
const iE = /* @__PURE__ */ B(Xk, [["render", oE], ["__scopeId", "data-v-c1112145"]]), sE = {
  name: "PauseSvg",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, aE = {
  viewBox: "0 0 64 64",
  "aria-hidden": "true"
}, lE = { id: "Layer_1" }, uE = ["fill"], dE = ["fill"];
function cE(e, t, n, r, o, i) {
  return d(), f("svg", aE, [
    c("g", null, [
      c("g", lE, [
        c("g", null, [
          c("rect", {
            x: "26",
            y: "24",
            width: "3",
            height: "16",
            fill: n.buttonIconColor.hex
          }, null, 8, uE),
          c("rect", {
            x: "34",
            y: "24",
            width: "3",
            height: "16",
            fill: n.buttonIconColor.hex
          }, null, 8, dE)
        ])
      ])
    ])
  ]);
}
const hE = /* @__PURE__ */ B(sE, [["render", cE]]), mE = {
  name: "PlaySVG",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, fE = {
  viewBox: "0 0 64 64",
  "aria-hidden": "true"
}, pE = ["fill"];
function gE(e, t, n, r, o, i) {
  return d(), f("svg", fE, [
    c("g", null, [
      c("g", null, [
        c("path", {
          d: "M26,39.8l11-8-11-8v16Z",
          fill: n.buttonIconColor.hex
        }, null, 8, pE)
      ])
    ])
  ]);
}
const vE = /* @__PURE__ */ B(mE, [["render", gE]]), bE = {
  name: "ArrowSvg",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    forward: {
      type: Boolean,
      default: !1
    }
  }
}, yE = {
  id: "Layer_11",
  "data-name": "Layer_1"
}, _E = ["fill"];
function CE(e, t, n, r, o, i) {
  return d(), f("svg", {
    id: "Layer_1",
    class: _({ forward: n.forward }),
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    version: "1.1",
    viewBox: "0 0 64 64",
    "aria-hidden": "true"
  }, [
    c("g", yE, [
      c("polygon", {
        fill: n.buttonIconColor.hex,
        points: "25.5 38.5 19 32 25.5 25.5 26.5 26.5 21.8 31.2 44 31.2 44 32.8 21.8 32.8 26.5 37.5 25.5 38.5"
      }, null, 8, _E)
    ])
  ], 2);
}
const wE = /* @__PURE__ */ B(bE, [["render", CE], ["__scopeId", "data-v-ccc04a6e"]]), TE = {
  name: "G7",
  components: {
    PauseSvg: hE,
    PlaySvg: vE,
    ArrowSvg: wE,
    ResponsiveImage: Ur
  },
  mixins: [Zn],
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["openLinkModal"],
  data() {
    return {
      headerHeight: 0
    };
  },
  computed: {
    titleText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.title) || "";
    },
    descriptionText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.content) || "";
    },
    link() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.href) || "";
    },
    linkName() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.name) || "";
    },
    linkTarget() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.target) || "";
    },
    arrowsVisible() {
      return this.slides.length > 1 && !this.theme.hasFloatingNav;
    },
    videoAltText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[0]) == null ? void 0 : t.alt_text) || "";
    },
    videoUrl() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[0]) == null ? void 0 : t.url) || "";
    },
    isPlaying() {
      return this.theme.use_video ? this.playVideo : this.playSlideshow;
    },
    displayButton() {
      return this.theme.use_video || !this.theme.use_video && this.slides.length > 1;
    },
    colors() {
      var e, t, n, r, o, i, a, s, l, u, m, v, g, h, E, C, A, R, O, F, L, D, P, U, q, z, te, ee;
      return {
        "--image-height": `calc(100vh - ${this.headerHeight}px)`,
        "--image-brightness": `${(t = (e = this.theme) == null ? void 0 : e.image_brightness) != null ? t : 60}%`,
        "--bg-color": ((r = (n = this.theme) == null ? void 0 : n.bg_color) == null ? void 0 : r.hex) || "",
        "--heading-color": ((i = (o = this.theme) == null ? void 0 : o.heading_color) == null ? void 0 : i.hex) || "",
        "--text-color": ((s = (a = this.theme) == null ? void 0 : a.text_color) == null ? void 0 : s.hex) || "",
        "--button-text-color": ((u = (l = this.theme) == null ? void 0 : l.widget_button_text_color) == null ? void 0 : u.hex) || "",
        "--button-bg-color": ((v = (m = this.theme) == null ? void 0 : m.widget_button_background_color) == null ? void 0 : v.hex) || "",
        "--button-bg-hover-color": ((h = (g = this.theme) == null ? void 0 : g.widget_button_background_hover_color) == null ? void 0 : h.hex) || "",
        "--pager-border-color": ((C = (E = this.theme) == null ? void 0 : E.pager_border_color) == null ? void 0 : C.hex) || "",
        "--pager-active-color": ((R = (A = this.theme) == null ? void 0 : A.pager_active_color) == null ? void 0 : R.hex) || "",
        "--play-pause-border-color": ((F = (O = this.theme) == null ? void 0 : O.button_border_color) == null ? void 0 : F.hex) || "",
        "--play-pause-border-hover-color": ((D = (L = this.theme) == null ? void 0 : L.button_border_hover_color) == null ? void 0 : D.hex) || "",
        "--play-pause-icon-color": ((U = (P = this.theme) == null ? void 0 : P.button_icon_color) == null ? void 0 : U.hex) || "",
        "--play-pause-icon-hover-color": ((z = (q = this.theme) == null ? void 0 : q.button_icon_hover_color) == null ? void 0 : z.hex) || "",
        "--play-pause-hover-color": ((ee = (te = this.theme) == null ? void 0 : te.button_hover_color) == null ? void 0 : ee.hex) || ""
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isPreview || this.isEditing) return;
      const e = document.getElementById("cms-header");
      if (!e) return;
      window.getComputedStyle(e).position !== "absolute" && (this.headerHeight = e.offsetHeight);
    });
  },
  methods: {
    handleClick() {
      if (!this.isPreview) {
        if (this.isEditing) {
          this.$emit("openLinkModal");
          return;
        }
        this.link && window.open(this.link, this.linkTarget || "_self");
      }
    }
  }
}, kE = {
  ref: "galleryContainer",
  class: "gallery-container"
}, EE = {
  key: 1,
  class: "video-wrapper"
}, SE = ["aria-label", "src"], ME = { class: "gallery-content" }, AE = ["innerHTML"], IE = ["innerHTML"], LE = {
  key: 2,
  ref: "link",
  class: "button-link"
}, DE = ["aria-label"], $E = {
  key: 0,
  class: "gallery-controls"
}, OE = {
  key: 2,
  class: "pager"
}, PE = ["aria-current", "aria-label", "onClick"];
function NE(e, t, n, r, o, i) {
  const a = V("responsive-image"), s = V("PauseSvg"), l = V("PlaySvg"), u = V("ArrowSvg"), m = Ke("touch");
  return d(), f("div", {
    id: "G7",
    class: _(["gallery-v7", { "is-editing": n.isEditing }]),
    style: Z([e.linkStyle, i.colors])
  }, [
    c("div", kE, [
      M(e.$slots, "controls", {}, void 0, !0),
      M(e.$slots, "image", {}, () => [
        e.theme.use_video ? T("", !0) : we((d(), I(zn, {
          key: 0,
          class: "image-wrapper",
          tag: "div",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: S(() => [
            (d(), I(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx]
            }, null, 8, ["idx", "image"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            m,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            m,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.theme.use_video ? (d(), f("div", EE, [
          c("video", {
            ref: "videoPlayer",
            "aria-label": i.videoAltText,
            src: i.videoUrl,
            class: "video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            "data-testid": "gallery-video"
          }, " Your browser does not support videos. ", 8, SE)
        ])) : T("", !0)
      ], !0),
      c("div", ME, [
        i.titleText || n.isEditing ? (d(), f("div", {
          key: 0,
          class: _(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          M(e.$slots, "title", {}, () => [
            c("div", {
              ref: "title",
              tabindex: "0",
              innerHTML: i.titleText
            }, null, 8, AE)
          ], !0)
        ], 2)) : T("", !0),
        i.descriptionText || n.isEditing ? (d(), f("div", {
          key: 1,
          class: _(["description", e.theme.style])
        }, [
          M(e.$slots, "description", {}, () => [
            c("div", {
              ref: "description",
              tabindex: "0",
              innerHTML: i.descriptionText
            }, null, 8, IE)
          ], !0)
        ], 2)) : T("", !0),
        i.link || n.isEditing ? (d(), f("div", LE, [
          c("button", {
            type: "button",
            "aria-label": `Link to ${i.linkName}`,
            onClick: t[0] || (t[0] = (...v) => i.handleClick && i.handleClick(...v))
          }, [
            M(e.$slots, "link", {}, () => [
              H(k(i.linkName), 1)
            ], !0)
          ], 8, DE)
        ], 512)) : T("", !0)
      ]),
      n.isEditing ? T("", !0) : (d(), f("div", $E, [
        i.displayButton ? (d(), f("button", {
          key: 0,
          "aria-label": "Play Pause Gallery",
          "data-testid": "pause-button",
          class: "pause button",
          onClick: t[1] || (t[1] = (v) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay())
        }, [
          i.isPlaying ? (d(), I(s, {
            key: 0,
            "button-icon-color": e.theme.button_icon_color
          }, null, 8, ["button-icon-color"])) : (d(), I(l, {
            key: 1,
            "button-icon-color": e.theme.button_icon_color
          }, null, 8, ["button-icon-color"]))
        ])) : T("", !0),
        i.arrowsVisible ? (d(), f("button", {
          key: 1,
          class: "left-arrow button",
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image",
          onClick: t[2] || (t[2] = (...v) => e.moveBack && e.moveBack(...v))
        }, [
          j(u, {
            "button-icon-color": e.theme.pager_arrow_color
          }, null, 8, ["button-icon-color"])
        ])) : T("", !0),
        e.slides.length > 1 ? (d(), f("div", OE, [
          (d(!0), f(J, null, ne(e.slides, (v, g) => (d(), f("button", {
            key: v.url,
            class: _(["item", { active: e.activeImageIdx === g }]),
            "aria-current": e.activeImageIdx === g ? "active" : null,
            "aria-label": `Image ${g + 1}`,
            "data-testid": "gallery-pager-button",
            onClick: (h) => e.jump(g)
          }, null, 10, PE))), 128))
        ])) : T("", !0),
        i.arrowsVisible ? (d(), f("button", {
          key: 3,
          class: "right-arrow button",
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image",
          onClick: t[3] || (t[3] = (...v) => e.moveForward && e.moveForward(...v))
        }, [
          j(u, {
            forward: "",
            "button-icon-color": e.theme.pager_arrow_color
          }, null, 8, ["button-icon-color"])
        ])) : T("", !0)
      ]))
    ], 512)
  ], 6);
}
const HE = /* @__PURE__ */ B(TE, [["render", NE], ["__scopeId", "data-v-aa32b36f"]]), FE = {
  name: "CmsGallery",
  components: {
    G1: uC,
    G2: YC,
    G3: Bw,
    G4: MT,
    G5: Ak,
    G6: iE,
    G7: HE
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    gallery: {
      type: Object,
      default: () => ({})
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    isEditing: Boolean
  },
  computed: {
    skipButtonText() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.skipButtonText) || "Skip Gallery";
    },
    galleryEndText() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.galleryEndText) || "End of Gallery";
    }
  },
  methods: {
    jumpTo(e) {
      this.$emit("jumpTo", e);
    },
    focusEnd() {
      this.$refs.galleryEnd.focus();
    }
  }
}, RE = { id: "cms-gallery" };
function VE(e, t, n, r, o, i) {
  return d(), f("div", RE, [
    c("button", {
      class: "skip-button",
      type: "button",
      tabindex: "0",
      onKeydown: t[0] || (t[0] = K(W((...a) => i.focusEnd && i.focusEnd(...a), ["exact", "prevent"]), ["enter"]))
    }, k(i.skipButtonText), 33),
    (d(), I(Y(n.theme.version), {
      theme: n.theme,
      gallery: n.gallery,
      "is-preview": n.isPreview,
      "is-iframe": n.isIFrame,
      "is-editing": n.isEditing,
      onScrollLeft: t[1] || (t[1] = (a) => e.$emit("scrollLeft")),
      onScrollRight: t[2] || (t[2] = (a) => e.$emit("scrollRight")),
      onJumpTo: i.jumpTo,
      onOpenLinkModal: t[3] || (t[3] = (a) => e.$emit("openLinkModal"))
    }, {
      widget: S(({ widget: a }) => [
        M(e.$slots, "widget", { widget: a }, void 0, !0)
      ]),
      controls: S(({ controls: a }) => [
        M(e.$slots, "controls", { controls: a }, void 0, !0)
      ]),
      image: S(({ image: a }) => [
        M(e.$slots, "image", { image: a }, void 0, !0)
      ]),
      title: S(({ title: a }) => [
        M(e.$slots, "title", { title: a }, void 0, !0)
      ]),
      description: S(({ description: a }) => [
        M(e.$slots, "description", { description: a }, void 0, !0)
      ]),
      link: S(({ link: a }) => [
        M(e.$slots, "link", { link: a }, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "gallery", "is-preview", "is-iframe", "is-editing", "onJumpTo"])),
    c("div", {
      ref: "galleryEnd",
      class: "gallery-end",
      tabindex: "-1"
    }, k(i.galleryEndText), 513)
  ]);
}
const BE = /* @__PURE__ */ B(FE, [["render", VE], ["__scopeId", "data-v-0316ae22"]]), p4 = function() {
  return document.ontouchstart !== null ? "click" : "touchstart";
}, us = "__vue_click_away__", g4 = function(e, t, n) {
  v4(e);
  let r = n.context, o = t.value, i = !1;
  setTimeout(function() {
    i = !0;
  }, 0), e[us] = function(a) {
    if ((!e || !e.contains(a.target)) && o && i && typeof o == "function")
      return o.call(r, a);
  }, document.addEventListener(p4(), e[us], !1);
}, v4 = function(e) {
  document.removeEventListener(p4(), e[us], !1), delete e[us];
}, jE = function(e, t, n) {
  t.value !== t.oldValue && g4(e, t, n);
}, UE = {
  mounted: g4,
  updated: jE,
  unmounted: v4
}, Tt = {
  directives: {
    ClickAway: UE
  }
}, qE = {
  name: "HamburgerIcon",
  props: {
    themeStyle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    },
    fillPathColor: {
      type: String,
      default: "#fff"
    },
    rx: {
      type: [String, Number],
      default: null
    }
  }
}, GE = { "clip-path": "url(#clip0)" }, KE = ["fill", "rx"], zE = ["fill"];
function ZE(e, t, n, r, o, i) {
  return d(), f("svg", {
    class: _(n.themeStyle),
    fill: "#fff",
    width: "23",
    height: "23",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, [
    c("g", GE, [
      c("rect", {
        fill: n.fillColor,
        rx: n.rx,
        width: "23",
        height: "23"
      }, null, 8, KE),
      c("path", {
        fill: n.fillPathColor,
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.00195 7H17V8H6.00195V7ZM6.00195 11H17V12H6.00195V11ZM17 15H6.00195V16H17V15Z"
      }, null, 8, zE)
    ]),
    t[0] || (t[0] = c("defs", null, [
      c("clipPath", { id: "clip0" }, [
        c("rect", {
          width: "23",
          height: "23",
          fill: "#fff"
        })
      ])
    ], -1))
  ], 2);
}
const k0 = /* @__PURE__ */ B(qE, [["render", ZE]]), xE = {
  name: "PlusIcon",
  props: {
    fillColor: {
      type: String,
      default: "#000"
    },
    fillPathColor: {
      type: String,
      default: "#fff"
    },
    rx: {
      type: [String, Number],
      default: null
    }
  }
}, WE = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, YE = ["fill", "rx"], XE = ["fill"], QE = ["fill"];
function JE(e, t, n, r, o, i) {
  return d(), f("svg", WE, [
    c("rect", {
      fill: n.fillColor,
      rx: n.rx,
      width: "23",
      height: "23"
    }, null, 8, YE),
    c("path", {
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 18L11 5L12 5L12 18L11 18Z"
    }, null, 8, XE),
    c("path", {
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 11L18 11L18 12L5 12L5 11Z"
    }, null, 8, QE)
  ]);
}
const E0 = /* @__PURE__ */ B(xE, [["render", JE]]), eS = {
  name: "MenuSearchIcon",
  props: {
    iconColor: {
      type: String,
      default: "#fff"
    }
  }
}, tS = ["fill"];
function nS(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.iconColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    "data-cy": "search-icon"
  }, t[0] || (t[0] = [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.03661 17.8C13.362 17.8 16.8683 14.3078 16.8683 10C16.8683 5.69218 13.362 2.2 9.03661 2.2C4.71127 2.2 1.20488 5.69218 1.20488 10C1.20488 14.3078 4.71127 17.8 9.03661 17.8ZM9.03661 19C14.0274 19 18.0732 14.9706 18.0732 10C18.0732 5.02944 14.0274 1 9.03661 1C4.04583 1 0 5.02944 0 10C0 14.9706 4.04583 19 9.03661 19Z"
    }, null, -1),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.3011 24L15.1138 16.1179L15.8128 15.3968L24.0001 23.2789L23.3011 24Z"
    }, null, -1)
  ]), 8, tS);
}
const rS = /* @__PURE__ */ B(eS, [["render", nS]]), oS = {
  props: {
    fillColor: {
      type: String,
      default: "#000"
    }
  }
}, iS = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sS = ["fill"], aS = ["fill"];
function lS(e, t, n, r, o, i) {
  return d(), f("svg", iS, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.9503 17.7175L11.5 19.1679V15.875H14.3893C13.996 16.5319 13.5163 17.1516 12.9503 17.7175ZM18.5666 15.875C17.1619 18.0508 14.8443 19.5819 12.1556 19.9265L13.6575 18.4247C14.4285 17.6536 15.0546 16.7924 15.5357 15.875H18.5666ZM19.125 14.875H15.9945C16.4244 13.7905 16.6666 12.6489 16.721 11.5H19.9863C19.9204 12.7035 19.6181 13.844 19.125 14.8758V14.875ZM11.5 11.5H15.7198C15.6593 12.6546 15.3892 13.8002 14.9094 14.875H11.5V11.5ZM11.5 10.5H15.7198C15.6593 9.34543 15.3892 8.19979 14.9094 7.125H11.5V10.5ZM19.9863 10.5H16.721C16.6666 9.35113 16.4244 8.20949 15.9945 7.125H19.125V7.12417C19.6181 8.15604 19.9204 9.29654 19.9863 10.5ZM18.5666 6.125H15.5357C15.0546 5.20762 14.4285 4.34646 13.6574 3.57538L12.1555 2.07349C14.8443 2.41811 17.1619 3.9492 18.5666 6.125ZM11.5 6.125H14.3892C13.996 5.46809 13.5163 4.84847 12.9503 4.28249L11.5 2.83217V6.125ZM10.5 19.1679V15.875H7.61071C8.00401 16.5319 8.48364 17.1515 9.04962 17.7175L10.5 19.1679ZM9.84439 19.9265C7.15566 19.5819 4.83807 18.0508 3.43337 15.875H6.46427C6.94536 16.7924 7.57144 17.6535 8.34252 18.4246L9.84439 19.9265ZM7.09055 14.875H10.5V11.5H6.28022C6.3407 12.6546 6.61081 13.8002 7.09055 14.875ZM5.27898 11.5C5.33341 12.6489 5.57557 13.7905 6.00545 14.875H2.875V14.8758C2.38189 13.844 2.07955 12.7035 2.01365 11.5H5.27898ZM6.28022 10.5H10.5V7.125H7.09055C6.61081 8.19979 6.3407 9.34543 6.28022 10.5ZM6.00545 7.125C5.57556 8.20949 5.33341 9.35113 5.27898 10.5H2.01365C2.07955 9.29654 2.38189 8.15604 2.875 7.12417V7.125H6.00545ZM7.61071 6.125H10.5V2.83211L9.04962 4.28248C8.48364 4.84846 8.004 5.46809 7.61071 6.125ZM9.84439 2.0735L8.34251 3.57538C7.57144 4.34646 6.94536 5.20762 6.46427 6.125H3.43337C4.83807 3.94922 7.15566 2.41814 9.84439 2.0735ZM11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
      fill: n.fillColor
    }, null, 8, sS),
    c("path", {
      fill: n.fillColor,
      d: "M11.5 19.1679H11.35V19.53L11.6061 19.274L11.5 19.1679ZM11.5 15.875V15.725H11.35V15.875H11.5ZM14.3893 15.875L14.518 15.9521L14.6539 15.725H14.3893V15.875ZM12.1556 19.9265L12.0495 19.8204L11.7388 20.1311L12.1747 20.0753L12.1556 19.9265ZM18.5666 15.875L18.6926 15.9564L18.842 15.725H18.5666V15.875ZM15.5357 15.875V15.725H15.445L15.4029 15.8053L15.5357 15.875ZM15.9945 14.875L15.8551 14.8197L15.7737 15.025H15.9945V14.875ZM19.125 14.875H19.275V14.725H19.125V14.875ZM16.721 11.5V11.35H16.5779L16.5712 11.4929L16.721 11.5ZM19.9863 11.5L20.1361 11.5082L20.1448 11.35H19.9863V11.5ZM19.125 14.8758H18.975L19.2603 14.9405L19.125 14.8758ZM15.7198 11.5L15.8695 11.5078L15.8778 11.35H15.7198V11.5ZM11.5 11.5V11.35H11.35V11.5H11.5ZM14.9094 14.875V15.025H15.0067L15.0464 14.9361L14.9094 14.875ZM11.5 14.875H11.35V15.025H11.5V14.875ZM15.7198 10.5V10.65H15.8778L15.8695 10.4922L15.7198 10.5ZM11.5 10.5H11.35V10.65H11.5V10.5ZM14.9094 7.125L15.0464 7.06386L15.0067 6.975H14.9094V7.125ZM11.5 7.125V6.975H11.35V7.125H11.5ZM16.721 10.5L16.5712 10.5071L16.5779 10.65H16.721V10.5ZM19.9863 10.5V10.65H20.1448L20.1361 10.4918L19.9863 10.5ZM15.9945 7.125V6.975H15.7737L15.8551 7.18027L15.9945 7.125ZM19.125 7.125V7.275H19.275V7.125H19.125ZM19.125 7.12417L19.2603 7.0595L18.975 7.12417H19.125ZM15.5357 6.125L15.4028 6.19466L15.445 6.275H15.5357V6.125ZM18.5666 6.125V6.275H18.842L18.6926 6.04364L18.5666 6.125ZM13.6574 3.57538L13.5514 3.68144L13.6574 3.57538ZM12.1555 2.07349L12.1746 1.92471L11.7388 1.86885L12.0495 2.17956L12.1555 2.07349ZM14.3892 6.125V6.275H14.6539L14.5179 6.04795L14.3892 6.125ZM11.5 6.125H11.35V6.275H11.5V6.125ZM12.9503 4.28249L12.8443 4.38855L12.9503 4.28249ZM11.5 2.83217L11.6061 2.7261L11.35 2.47004V2.83217H11.5ZM10.5 15.875H10.65V15.725H10.5V15.875ZM10.5 19.1679L10.3939 19.274L10.65 19.53V19.1679H10.5ZM7.61071 15.875V15.725H7.34608L7.48202 15.9521L7.61071 15.875ZM9.04962 17.7175L9.15569 17.6115L9.04962 17.7175ZM9.84439 19.9265L9.82532 20.0753L10.2612 20.1311L9.95046 19.8204L9.84439 19.9265ZM3.43337 15.875V15.725H3.15798L3.30735 15.9564L3.43337 15.875ZM6.46427 15.875L6.59711 15.8053L6.55499 15.725H6.46427V15.875ZM8.34252 18.4246L8.44858 18.3186L8.34252 18.4246ZM7.09055 14.875L6.95358 14.9361L6.99324 15.025H7.09055V14.875ZM10.5 14.875V15.025H10.65V14.875H10.5ZM10.5 11.5H10.65V11.35H10.5V11.5ZM6.28022 11.5V11.35H6.12216L6.13043 11.5078L6.28022 11.5ZM5.27898 11.5L5.42881 11.4929L5.42204 11.35H5.27898V11.5ZM6.00545 14.875V15.025H6.22626L6.14489 14.8197L6.00545 14.875ZM2.875 14.875V14.725H2.725V14.875H2.875ZM2.875 14.8758L2.73966 14.9405L3.025 14.8758H2.875ZM2.01365 11.5V11.35H1.85522L1.86388 11.5082L2.01365 11.5ZM6.28022 10.5L6.13043 10.4922L6.12216 10.65H6.28022V10.5ZM10.5 10.5V10.65H10.65V10.5H10.5ZM10.5 7.125H10.65V6.975H10.5V7.125ZM7.09055 7.125V6.975H6.99324L6.95358 7.06386L7.09055 7.125ZM6.00545 7.125L6.14489 7.18027L6.22626 6.975H6.00545V7.125ZM5.27898 10.5V10.65H5.42204L5.42881 10.5071L5.27898 10.5ZM2.01365 10.5L1.86388 10.4918L1.85522 10.65H2.01365V10.5ZM2.875 7.12417H3.025L2.73966 7.05949L2.875 7.12417ZM2.875 7.125H2.725V7.275H2.875V7.125ZM7.61071 6.125L7.48201 6.04795L7.34608 6.275H7.61071V6.125ZM10.5 6.125V6.275H10.65V6.125H10.5ZM10.5 2.83211H10.65V2.46997L10.3939 2.72604L10.5 2.83211ZM9.04962 4.28248L8.94356 4.17642H8.94356L9.04962 4.28248ZM9.84439 2.0735L9.95046 2.17957L10.2612 1.86885L9.82532 1.92472L9.84439 2.0735ZM8.34251 3.57538L8.44858 3.68144L8.34251 3.57538ZM6.46427 6.125V6.275H6.55499L6.59711 6.19466L6.46427 6.125ZM3.43337 6.125L3.30735 6.04364L3.15798 6.275H3.43337V6.125ZM11.6061 19.274L13.0564 17.8236L12.8443 17.6115L11.3939 19.0618L11.6061 19.274ZM11.35 15.875V19.1679H11.65V15.875H11.35ZM14.3893 15.725H11.5V16.025H14.3893V15.725ZM13.0564 17.8236C13.6312 17.2488 14.1184 16.6194 14.518 15.9521L14.2606 15.7979C13.8736 16.4444 13.4015 17.0543 12.8443 17.6115L13.0564 17.8236ZM12.1747 20.0753C14.9087 19.7248 17.2648 18.1681 18.6926 15.9564L18.4406 15.7936C17.0591 17.9335 14.78 19.4389 12.1365 19.7777L12.1747 20.0753ZM13.5514 18.3186L12.0495 19.8204L12.2617 20.0326L13.7635 18.5307L13.5514 18.3186ZM15.4029 15.8053C14.9287 16.7095 14.3116 17.5583 13.5514 18.3186L13.7635 18.5307C14.5454 17.7488 15.1805 16.8753 15.6686 15.9447L15.4029 15.8053ZM18.5666 15.725H15.5357V16.025H18.5666V15.725ZM15.9945 15.025H19.125V14.725H15.9945V15.025ZM16.5712 11.4929C16.5175 12.6255 16.2788 13.7508 15.8551 14.8197L16.134 14.9303C16.57 13.8302 16.8156 12.6723 16.8708 11.5071L16.5712 11.4929ZM19.9863 11.35H16.721V11.65H19.9863V11.35ZM19.2603 14.9405C19.7617 13.8913 20.0691 12.7316 20.1361 11.5082L19.8366 11.4918C19.7718 12.6753 19.4745 13.7966 18.9897 14.8112L19.2603 14.9405ZM18.975 14.875V14.8758H19.275V14.875H18.975ZM15.7198 11.35H11.5V11.65H15.7198V11.35ZM15.0464 14.9361C15.5338 13.8443 15.8081 12.6805 15.8695 11.5078L15.57 11.4922C15.5104 12.6286 15.2446 13.7562 14.7725 14.8139L15.0464 14.9361ZM11.5 15.025H14.9094V14.725H11.5V15.025ZM11.35 11.5V14.875H11.65V11.5H11.35ZM15.7198 10.35H11.5V10.65H15.7198V10.35ZM14.7724 7.18614C15.2446 8.24383 15.5104 9.37137 15.57 10.5078L15.8695 10.4922C15.8081 9.31948 15.5338 8.15574 15.0464 7.06386L14.7724 7.18614ZM11.5 7.275H14.9094V6.975H11.5V7.275ZM11.65 10.5V7.125H11.35V10.5H11.65ZM16.721 10.65H19.9863V10.35H16.721V10.65ZM15.8551 7.18027C16.2788 8.24918 16.5175 9.37452 16.5712 10.5071L16.8708 10.4929C16.8156 9.32773 16.57 8.1698 16.134 7.06973L15.8551 7.18027ZM19.125 6.975H15.9945V7.275H19.125V6.975ZM18.975 7.12417V7.125H19.275V7.12417H18.975ZM20.1361 10.4918C20.0691 9.26836 19.7617 8.10871 19.2603 7.0595L18.9897 7.18885C19.4745 8.20338 19.7718 9.32472 19.8366 10.5082L20.1361 10.4918ZM15.5357 6.275H18.5666V5.975H15.5357V6.275ZM13.5514 3.68144C14.3116 4.44169 14.9287 5.29055 15.4028 6.19466L15.6685 6.05534C15.1805 5.1247 14.5454 4.25122 13.7635 3.46931L13.5514 3.68144ZM12.0495 2.17956L13.5514 3.68144L13.7635 3.46931L12.2616 1.96742L12.0495 2.17956ZM18.6926 6.04364C17.2647 3.83192 14.9086 2.27513 12.1746 1.92471L12.1365 2.22227C14.78 2.56109 17.0591 4.06648 18.4406 6.20636L18.6926 6.04364ZM14.3892 5.975H11.5V6.275H14.3892V5.975ZM12.8443 4.38855C13.4015 4.94576 13.8735 5.55562 14.2606 6.20205L14.5179 6.04795C14.1184 5.38056 13.6312 4.75118 13.0564 4.17642L12.8443 4.38855ZM11.3939 2.93823L12.8443 4.38855L13.0564 4.17642L11.6061 2.7261L11.3939 2.93823ZM11.65 6.125V2.83217H11.35V6.125H11.65ZM10.35 15.875V19.1679H10.65V15.875H10.35ZM7.61071 16.025H10.5V15.725H7.61071V16.025ZM9.15569 17.6115C8.59848 17.0542 8.12643 16.4444 7.73941 15.7979L7.48202 15.9521C7.88158 16.6194 8.3688 17.2488 8.94356 17.8236L9.15569 17.6115ZM10.6061 19.0618L9.15569 17.6115L8.94356 17.8236L10.3939 19.274L10.6061 19.0618ZM9.86346 19.7777C7.21998 19.4389 4.9409 17.9335 3.55939 15.7936L3.30735 15.9564C4.73524 18.1681 7.09133 19.7248 9.82532 20.0753L9.86346 19.7777ZM3.43337 16.025H6.46427V15.725H3.43337V16.025ZM6.33143 15.9447C6.81947 16.8753 7.45454 17.7488 8.23645 18.5307L8.44858 18.3186C7.68834 17.5583 7.07124 16.7094 6.59711 15.8053L6.33143 15.9447ZM8.23645 18.5307L9.73833 20.0326L9.95046 19.8204L8.44858 18.3186L8.23645 18.5307ZM7.09055 15.025H10.5V14.725H7.09055V15.025ZM10.65 14.875V11.5H10.35V14.875H10.65ZM10.5 11.35H6.28022V11.65H10.5V11.35ZM7.22753 14.8139C6.75542 13.7562 6.48955 12.6286 6.43002 11.4922L6.13043 11.5078C6.19185 12.6805 6.46621 13.8443 6.95358 14.9361L7.22753 14.8139ZM5.12914 11.5071C5.18435 12.6723 5.42994 13.8302 5.866 14.9303L6.14489 14.8197C5.72119 13.7508 5.48247 12.6255 5.42881 11.4929L5.12914 11.5071ZM2.875 15.025H6.00545V14.725H2.875V15.025ZM3.025 14.8758V14.875H2.725V14.8758H3.025ZM1.86388 11.5082C1.93087 12.7316 2.23826 13.8913 2.73966 14.9405L3.01034 14.8112C2.52552 13.7966 2.22823 12.6753 2.16343 11.4918L1.86388 11.5082ZM5.27898 11.35H2.01365V11.65H5.27898V11.35ZM6.28022 10.65H10.5V10.35H6.28022V10.65ZM10.65 10.5V7.125H10.35V10.5H10.65ZM10.5 6.975H7.09055V7.275H10.5V6.975ZM6.43002 10.5078C6.48955 9.37137 6.75542 8.24383 7.22753 7.18614L6.95358 7.06386C6.4662 8.15575 6.19185 9.31948 6.13043 10.4922L6.43002 10.5078ZM5.866 7.06973C5.42994 8.1698 5.18435 9.32773 5.12914 10.4929L5.42881 10.5071C5.48247 9.37452 5.72119 8.24918 6.14489 7.18027L5.866 7.06973ZM2.01365 10.65H5.27898V10.35H2.01365V10.65ZM2.73966 7.05949C2.23826 8.10871 1.93087 9.26836 1.86388 10.4918L2.16343 10.5082C2.22823 9.32472 2.52552 8.20337 3.01034 7.18885L2.73966 7.05949ZM3.025 7.125V7.12417H2.725V7.125H3.025ZM6.00545 6.975H2.875V7.275H6.00545V6.975ZM7.61071 6.275H10.5V5.975H7.61071V6.275ZM10.65 6.125V2.83211H10.35V6.125H10.65ZM9.15569 4.38855L10.6061 2.93817L10.3939 2.72604L8.94356 4.17642L9.15569 4.38855ZM7.73941 6.20205C8.12643 5.55562 8.59848 4.94576 9.15569 4.38855L8.94356 4.17642C8.3688 4.75117 7.88158 5.38056 7.48201 6.04795L7.73941 6.20205ZM9.73833 1.96743L8.23645 3.46931L8.44858 3.68144L9.95046 2.17957L9.73833 1.96743ZM8.23645 3.46931C7.45454 4.25122 6.81947 5.1247 6.33143 6.05534L6.59711 6.19466C7.07124 5.29055 7.68834 4.44169 8.44858 3.68144L8.23645 3.46931ZM3.43337 6.275H6.46427V5.975H3.43337V6.275ZM9.82532 1.92472C7.09133 2.27516 4.73524 3.83194 3.30735 6.04364L3.55939 6.20636C4.9409 4.0665 7.21998 2.56112 9.86346 2.22228L9.82532 1.92472ZM20.85 11C20.85 16.44 16.44 20.85 11 20.85V21.15C16.6057 21.15 21.15 16.6057 21.15 11H20.85ZM11 1.15C16.44 1.15 20.85 5.56 20.85 11H21.15C21.15 5.39431 16.6057 0.85 11 0.85V1.15ZM1.15 11C1.15 5.56 5.56 1.15 11 1.15V0.85C5.39431 0.85 0.85 5.39431 0.85 11H1.15ZM11 20.85C5.56 20.85 1.15 16.44 1.15 11H0.85C0.85 16.6057 5.39431 21.15 11 21.15V20.85Z"
    }, null, 8, aS)
  ]);
}
const uS = /* @__PURE__ */ B(oS, [["render", lS], ["__scopeId", "data-v-ffbe6fac"]]), dS = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    fillPathColor: {
      type: String,
      default: "#000"
    },
    dropdownClass: {
      type: String,
      default: "close"
    },
    circleBackground: {
      type: Boolean
    }
  }
}, cS = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, hS = ["fill", "rx"], mS = ["fill"];
function fS(e, t, n, r, o, i) {
  return d(), f("svg", cS, [
    c("rect", {
      fill: n.fillColor,
      rx: n.circleBackground ? 50 : 4,
      width: "23",
      height: "23"
    }, null, 8, hS),
    c("path", {
      class: _([n.dropdownClass, "arrow"]),
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.14645 8.14645C5.34171 7.95118 5.65829 7.95118 5.85355 8.14645L11.5 13.7929L17.1464 8.14645C17.3417 7.95118 17.6583 7.95118 17.8536 8.14645C18.0488 8.34171 18.0488 8.65829 17.8536 8.85355L11.8536 14.8536C11.6583 15.0488 11.3417 15.0488 11.1464 14.8536L5.14645 8.85355C4.95118 8.65829 4.95118 8.34171 5.14645 8.14645Z"
    }, null, 10, mS)
  ]);
}
const pS = /* @__PURE__ */ B(dS, [["render", fS], ["__scopeId", "data-v-964bccff"]]), gS = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    dropdownClass: {
      type: String,
      default: "close"
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  }
}, vS = ["fill"];
function bS(e, t, n, r, o, i) {
  return d(), f("svg", {
    class: _({
      [n.dropdownClass]: !0,
      open: n.isOpen,
      close: !n.isOpen
    }),
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 14 11",
    fill: "none"
  }, [
    c("path", {
      d: "M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z",
      fill: n.fillColor
    }, null, 8, vS)
  ], 2);
}
const b4 = /* @__PURE__ */ B(gS, [["render", bS], ["__scopeId", "data-v-174954e1"]]), yS = {
  name: "SvgClose",
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, _S = ["fill"], CS = ["fill"], wS = ["fill"];
function TS(e, t, n, r, o, i) {
  return d(), f("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.fillColor,
    "aria-label": "Close icon"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.439341 0.43934C1.02513 -0.146447 1.97488 -0.146447 2.56066 0.43934L23.5607 21.4393C24.1464 22.0251 24.1464 22.9749 23.5607 23.5607C22.9749 24.1464 22.0251 24.1464 21.4393 23.5607L0.439341 2.56066C-0.146445 1.97487 -0.146445 1.02513 0.439341 0.43934Z",
      fill: n.fillColor
    }, null, 8, CS),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.5607 0.43934C24.1464 1.02513 24.1464 1.97487 23.5607 2.56066L2.56066 23.5607C1.97487 24.1464 1.02513 24.1464 0.43934 23.5607C-0.146447 22.9749 -0.146447 22.0251 0.43934 21.4393L21.4393 0.43934C22.0251 -0.146447 22.9749 -0.146447 23.5607 0.43934Z",
      fill: n.fillColor
    }, null, 8, wS)
  ], 8, _S);
}
const mi = /* @__PURE__ */ B(yS, [["render", TS]]), kS = {
  name: "MenuItem",
  components: {
    FilledDropdownArrow: pS,
    HamburgerIcon: k0,
    PlusIcon: E0,
    SearchIcon: rS,
    LanguageIcon: uS,
    TriangleIcon: b4,
    Close: mi
  },
  props: {
    item: {
      type: String,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    },
    themeOverrides: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      required: !0
    },
    focusVisibleColor: {
      type: String,
      default: "#0000FF"
    },
    mobileTextColor: {
      type: String,
      default: "#0000FF"
    },
    isMobile: Boolean,
    dropdownOpen: Boolean,
    showText: {
      type: Boolean,
      default: !0
    },
    screenSize: {
      type: Number,
      default: 0
    }
  },
  emits: ["toggle-dropdown", "toggle-search"],
  computed: {
    showTitleTop() {
      return this.showText && ["schoolsbutton", "explore-button", "languagebutton"].includes(this.menuItem.id) || this.menuItem.id === "searchbutton" && ["H6", "H7", "H8"].includes(this.theme.version) && this.screenSize > 599;
    },
    showTitleBottom() {
      return this.showText && this.menuItem.id === "menubutton" && !this.isMobile || this.menuItem.id === "searchbutton";
    },
    focusColor() {
      return { "--focus-visible-color": this.focusVisibleColor };
    },
    menuItem() {
      const t = [
        this.menuButton,
        this.exploreButton,
        this.schoolsButton,
        this.languagesButton,
        this.searchButton,
        this.closeButton
      ].find((n) => n.id === this.item);
      return ge(ae(ae({}, t), this.themeOverrides), {
        colors: ae(ae({}, t.colors), this.themeOverrides.colors)
      });
    },
    menuButton() {
      var e, t, n, r;
      return {
        id: "menubutton",
        class: ["menu", { "m4-menu": this.content.menuOptions.version === "M4" }, "button-action", this.theme.style],
        iconClass: this.theme.menu_icon,
        dataTestId: "menu-button",
        ariaExpanded: this.content.showMenu,
        ariaControls: this.content.showMenu ? "mainmenu" : null,
        ariaLabel: this.content.newMobileHeader && this.screenSize < 600 ? this.theme.translations.open_mobile_menu : null,
        translatedTitle: this.theme.translations.menu_dropdown_title || "Menu",
        icon: this.theme.menu_icon === "plus" ? "PlusIcon" : "HamburgerIcon",
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex,
          "--fill-path-color": (t = this.theme.navigation_icon_color) == null ? void 0 : t.hex,
          "--bg-color": (n = this.theme.bg_color) == null ? void 0 : n.hex,
          "--nav-color": (r = this.theme.navigation_color) == null ? void 0 : r.hex
        }
      };
    },
    exploreButton() {
      var e, t, n, r, o, i;
      return {
        id: "explore-button",
        ref: "explore-button",
        class: ["explore", "button-action", "menu", this.theme.style],
        dataTestId: "explore-button",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.dropdownOpen ? "explore-menu" : null,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.menu_dropdown_title) || ((t = this.theme.translations) == null ? void 0 : t.explore_dropdown_title) || "Explore",
        icon: "FilledDropdownArrow",
        colors: {
          "--fill-color": (n = this.theme.navigation_color) == null ? void 0 : n.hex,
          "--fill-path-color": (r = this.theme.navigation_icon_color) == null ? void 0 : r.hex,
          "--bg-color": (o = this.theme.bg_color) == null ? void 0 : o.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": (i = this.theme.navigation_color) == null ? void 0 : i.hex
        }
      };
    },
    schoolsButton() {
      var e, t, n, r;
      return {
        id: "schoolsbutton",
        ref: "schoolsbutton",
        class: ["schools", "button-action", "menu", this.theme.style],
        dataTestId: "schools-button",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.ariaControlsSchoolsMenu,
        icon: "FilledDropdownArrow",
        translatedTitle: this.content.orgDropdownTitle,
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex,
          "--fill-path-color": (t = this.theme.navigation_icon_color) == null ? void 0 : t.hex,
          "--bg-color": (n = this.theme.bg_color) == null ? void 0 : n.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": (r = this.theme.navigation_color) == null ? void 0 : r.hex
        }
      };
    },
    ariaControlsSchoolsMenu() {
      return this.dropdownOpen ? this.content.hasCustomSchoolsMenu ? "schools-menu-sm1" : "schoolsmenu" : null;
    },
    languagesButton() {
      var e, t, n, r, o, i;
      return {
        id: "languagebutton",
        class: ["languages", "button-action", "menu", this.theme.style],
        dataTestId: "language-button",
        menuItemType: "languagebutton",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.dropdownOpen ? "languagesmenu" : null,
        icon: this.isMobile && this.content.newMobileHeader || this.isMobile && this.theme.version === "H3" ? "LanguageIcon" : "FilledDropdownArrow",
        ariaLabel: this.theme.translations.translate_site,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.translate_dropdown_title) || ((n = (t = this.theme.translations) == null ? void 0 : t.header) == null ? void 0 : n.translate_dropdown_title) || "Translate",
        colors: {
          "--fill-color": this.languageButtonColor,
          "--fill-path-color": ((r = this.theme.navigation_icon_color) == null ? void 0 : r.hex) || "#FFFFFF",
          "--bg-color": (o = this.theme.bg_color) == null ? void 0 : o.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": ((i = this.theme.navigation_color) == null ? void 0 : i.hex) || "#0000FF"
        }
      };
    },
    languageButtonColor() {
      var e, t;
      return this.isMobile && this.theme.version === "H3" ? this.mobileTextColor : this.theme.version === "H2" ? (e = this.theme.navigation_icon_bg_color) == null ? void 0 : e.hex : (t = this.theme.navigation_color) == null ? void 0 : t.hex;
    },
    searchButton() {
      var e, t;
      return {
        id: "searchbutton",
        class: [
          "search",
          "focus-search-icon",
          "button-action",
          "menu",
          this.theme.style,
          { shrinkCSSClass: !this.isMobile || !this.content.newMobileHeader }
        ],
        dataTestId: this.searchTestIdByHeader,
        icon: "SearchIcon",
        translatedTitle: this.theme.translations.search_title || "Search Site",
        colors: {
          "--icon-color": this.isMobile ? this.mobileTextColor : (e = this.theme.search_icon_color) == null ? void 0 : e.hex,
          "--bg-color": (t = this.theme.bg_color) == null ? void 0 : t.hex
        }
      };
    },
    closeButton() {
      var e;
      return {
        id: "closebutton",
        class: ["menu", this.theme.style, "close-icon"],
        dataTestId: "close-button",
        icon: "Close",
        ariaLabel: this.content.newMobileHeader && this.screenSize < 600 ? this.theme.translations.close_mobile_menu : null,
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex
        }
      };
    },
    searchTestIdByHeader() {
      return this.theme.version === "H2" ? this.isMobile ? "small-utilities-search-button" : "large-utilities-search-button" : "search-button";
    }
  },
  methods: {
    itemAction(e) {
      e === "searchbutton" ? this.$emit("toggle-search") : this.$emit("toggle-dropdown", e);
    }
  }
}, ES = ["id", "data-testid", "aria-expanded", "aria-controls", "aria-label"], SS = { class: "button-action-content" };
function MS(e, t, n, r, o, i) {
  return d(), f("button", {
    id: i.menuItem.id,
    "data-testid": i.menuItem.dataTestId,
    "aria-haspopup": "true",
    "aria-expanded": i.menuItem.ariaExpanded,
    "aria-controls": i.menuItem.ariaControls,
    "aria-label": i.menuItem.ariaLabel,
    class: _(["menu-item", i.menuItem.class]),
    style: Z(i.focusColor),
    onClick: t[0] || (t[0] = (a) => i.itemAction(i.menuItem.id))
  }, [
    c("span", SS, [
      i.showTitleTop ? (d(), f("span", {
        key: 0,
        class: "menu-field",
        style: Z({
          color: i.menuItem.colors["--nav-color"]
        })
      }, k(i.menuItem.translatedTitle), 5)) : T("", !0),
      (d(), I(Y(i.menuItem.icon), {
        class: _(i.menuItem.iconClass),
        "theme-style": n.theme.style,
        "bg-color": i.menuItem.colors["--bg-color"] || null,
        "icon-color": i.menuItem.colors["--icon-color"] || null,
        rx: n.theme.style === "purple" ? "50" : "4",
        "fill-color": i.menuItem.colors["--fill-color"] || null,
        "fill-path-color": i.menuItem.colors["--fill-path-color"] || null,
        "fill-background": i.menuItem.colors["--fill-background"] || null,
        "circle-background": i.menuItem.colors["--circle-background"] || null,
        "dropdown-class": i.menuItem.colors["--dropdown-class"],
        "nav-color": i.menuItem.colors["--nav-color"]
      }, null, 8, ["class", "theme-style", "bg-color", "icon-color", "rx", "fill-color", "fill-path-color", "fill-background", "circle-background", "dropdown-class", "nav-color"])),
      i.showTitleBottom ? (d(), f("span", {
        key: 1,
        class: _(["menu-field", { "sr-only": i.menuItem.id === "searchbutton" && n.theme.version !== "H4" }])
      }, k(i.menuItem.translatedTitle), 3)) : T("", !0)
    ])
  ], 14, ES);
}
const xt = /* @__PURE__ */ B(kS, [["render", MS], ["__scopeId", "data-v-5573ec1c"]]), AS = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    dropdownClass: {
      type: String,
      default: "close"
    }
  }
}, IS = ["fill"];
function LS(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    class: _(n.dropdownClass),
    "aria-hidden": "true"
  }, t[0] || (t[0] = [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.7144 9L11.5003 14.3919L5.28389 9L4 10.4956L11.5003 17L18.9997 10.4956L17.7144 9Z"
    }, null, -1)
  ]), 10, IS);
}
const To = /* @__PURE__ */ B(AS, [["render", LS], ["__scopeId", "data-v-5678f690"]]), DS = {
  name: "SchoolsMenuHeader",
  components: {
    DropdownArrowIcon: To
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    isMobile: Boolean,
    isMobileActive: Boolean
  }
}, $S = ["tabindex"];
function OS(e, t, n, r, o, i) {
  const a = V("DropdownArrowIcon");
  return d(), f("div", {
    class: _({ "mobile-cursor": n.isMobile }),
    style: Z(`color: ${n.theme.schools_menu_text_color.hex}`),
    tabindex: n.isMobile ? "0" : "-1",
    onKeydown: [
      t[0] || (t[0] = K(W((s) => e.$emit("set-active-header"), ["exact", "prevent"]), ["enter"])),
      t[1] || (t[1] = K(W((s) => e.$emit("set-active-header"), ["exact", "prevent"]), ["space"])),
      t[2] || (t[2] = K(W((s) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[3] || (t[3] = K((s) => e.$emit("tab-action", s), ["tab"]))
    ]
  }, [
    c("h2", {
      class: _(["schools-menu-header", n.theme.style])
    }, k(n.item.name), 3),
    n.isMobile && n.item.children ? (d(), I(a, {
      key: 0,
      class: "schools-menu-arrow",
      "fill-color": `${n.theme.schools_menu_text_color.hex}`,
      "dropdown-class": n.isMobileActive ? "open" : "close"
    }, null, 8, ["fill-color", "dropdown-class"])) : T("", !0)
  ], 46, $S);
}
const PS = /* @__PURE__ */ B(DS, [["render", OS], ["__scopeId", "data-v-0ee6ab64"]]), NS = "sites.thrillshare.com", HS = "sites.thrillshare.ca", FS = "develop.thrillshare.com", RS = "qa.thrillshare.com", VS = "localhost:4000", BS = [NS, HS, FS, RS, VS], Il = "/", jS = (e) => !!BS.find((t) => e && !!e.toLowerCase().includes(t)), qr = (e, { isPreview: t, currentDomain: n }) => e ? jS(n) || t ? e.path_prefix || Il : e.org_url ? e.org_url === e.path_prefix ? e.path_prefix || Il : `https://${e.org_url}` : e.path_prefix || Il : "#", S0 = (e, t, { isPreview: n }) => {
  const r = nv(e.link), o = t.find(
    (a) => a && a.alias && e.alias && a.alias.toLowerCase() === e.alias.toLowerCase()
  ), i = {
    isPreview: n,
    currentDomain: window.location.href
  };
  return o ? qr(o, i) : r;
}, US = {
  name: "SchoolsMenuOrg",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    organizations: {
      type: Array,
      default: () => []
    },
    isPreview: Boolean
  },
  computed: {
    link() {
      return S0(this.item, this.organizations, {
        isPreview: this.isPreview
      });
    }
  }
}, qS = ["href"];
function GS(e, t, n, r, o, i) {
  return d(), f("a", {
    href: i.link,
    style: Z(`color: ${n.theme.schools_menu_text_color.hex}`),
    onKeydown: [
      t[0] || (t[0] = K(W((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[1] || (t[1] = K((a) => e.$emit("tab-action", a), ["tab"]))
    ]
  }, k(n.item.name), 45, qS);
}
const KS = /* @__PURE__ */ B(US, [["render", GS], ["__scopeId", "data-v-40d9da4e"]]), zS = {
  name: "SchoolsMenuOrg",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    organizations: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    linkTarget() {
      return this.item.opens_in_new_tab ? "_blank" : "_self";
    }
  }
}, ZS = ["href", "target"];
function xS(e, t, n, r, o, i) {
  return d(), f("a", {
    href: n.item.link,
    target: i.linkTarget,
    style: Z(`color: ${n.theme.schools_menu_text_color.hex}`),
    onKeydown: [
      t[0] || (t[0] = K(W((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[1] || (t[1] = K((a) => e.$emit("tab-action", a), ["tab"]))
    ]
  }, k(n.item.name), 45, ZS);
}
const WS = /* @__PURE__ */ B(zS, [["render", xS], ["__scopeId", "data-v-ca9c8a65"]]), YS = {
  name: "SchoolsMenuImage",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    }
  },
  computed: {
    opensInNewTab() {
      return this.item.open_in_new_tab ? "_blank" : "_self";
    },
    width() {
      return this.item.display === "percentage" ? `${this.item.set_ratio * 100}%` : `${this.item.preferred_width}px`;
    },
    height() {
      let e = `max-height: ${this.item.preferred_height}px`;
      return this.item.display === "percentage" && (e = "auto"), e;
    },
    isDecorativeImage() {
      return !!this.item.decorative_image;
    }
  }
}, XS = { key: 0 }, QS = ["src", "alt"], JS = { key: 1 }, eM = ["href", "target"], tM = ["src", "alt"];
function nM(e, t, n, r, o, i) {
  return d(), f("div", {
    class: _([n.item.image_alignment, "image-container"])
  }, [
    n.item.action_on_click === "no_action" ? (d(), f("div", XS, [
      c("img", {
        src: n.item.url,
        alt: i.isDecorativeImage ? "" : n.item.alt_text,
        style: Z({ width: i.width, height: i.height })
      }, null, 12, QS)
    ])) : (d(), f("div", JS, [
      c("a", {
        href: n.item.link_url,
        target: i.opensInNewTab,
        onKeydown: [
          t[0] || (t[0] = K(W((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
          t[1] || (t[1] = K((a) => e.$emit("tab-action", a), ["tab"]))
        ]
      }, [
        c("img", {
          src: n.item.url,
          alt: i.isDecorativeImage ? "" : n.item.alt_text,
          style: Z({ width: i.width, height: i.height })
        }, null, 12, tM)
      ], 40, eM)
    ]))
  ], 2);
}
const rM = /* @__PURE__ */ B(YS, [["render", nM], ["__scopeId", "data-v-92129cf0"]]), oM = {
  name: "SM1",
  components: {
    SchoolsMenuHeader: PS,
    SchoolsMenuOrg: KS,
    SchoolsMenuLink: WS,
    SchoolsMenuImage: rM
  },
  props: {
    headerTheme: {
      type: Object,
      required: !0
    },
    columns: {
      type: Array,
      default: () => []
    },
    organizations: {
      type: Array,
      default: () => []
    },
    stickyHeader: Boolean,
    shrinkHeader: Boolean,
    isPreview: Boolean
  },
  data() {
    return {
      debounceSetScreenSize: () => {
      },
      screenSize: "",
      activeHeader: "",
      allFocusableElements: []
    };
  },
  computed: {
    isMobile() {
      return this.screenSize < 540;
    },
    styles() {
      return {
        background: this.headerTheme.version === "H4" ? "transparent" : this.headerTheme.schools_menu_bg_color.hex
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setScreenSize();
    }), this.debounceSetScreenSize = mo(this.setScreenSize, 100), window.addEventListener("resize", this.debounceSetScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debounceSetScreenSize);
  },
  methods: {
    setScreenSize() {
      this.screenSize = window.innerWidth;
    },
    setActiveHeader(e) {
      this.activeHeader = e === this.activeHeader ? "" : e;
    },
    determineFocusableElements() {
      this.allFocusableElements = this.$refs["menu-wrapper"].querySelectorAll("[href], .mobile-cursor");
    },
    tabAction(e, t) {
      var u, m;
      this.determineFocusableElements();
      const n = t.shiftKey, r = this.allFocusableElements[0], o = this.allFocusableElements[this.allFocusableElements.length - 1];
      let i = "", a = "";
      e.type === "SchoolsMenuImage" && (i = (u = r == null ? void 0 : r.href) == null ? void 0 : u.toString().slice(0, -1), a = (m = o == null ? void 0 : o.href) == null ? void 0 : m.toString().slice(0, -1));
      const s = r.innerText === e.name || i === e.link_url, l = o.innerText === e.name || a === e.link_url;
      s && n && this.$emit("focus-lost"), l && !n && this.$emit("focus-lost");
    }
  }
}, iM = {
  ref: "menu-wrapper",
  class: "wrapper"
}, sM = ["id", "onClick"], aM = ["aria-describedby"];
function lM(e, t, n, r, o, i) {
  return d(), f("div", {
    id: "schools-menu-sm1",
    class: _([
      n.headerTheme.version,
      {
        sticky: n.stickyHeader,
        shrink: n.shrinkHeader
      }
    ]),
    style: Z(i.styles)
  }, [
    c("div", iM, [
      (d(!0), f(J, null, ne(n.columns, (a, s) => (d(), f("div", {
        key: `sm1-col-${s}`,
        class: "column"
      }, [
        c("ul", null, [
          (d(!0), f(J, null, ne(a, (l, u) => (d(), f("li", {
            id: `parent-item-${s}-${u}`,
            key: `parent-item-${s}-${u}`,
            class: _(["parent-item", l.type]),
            onClick: (m) => i.setActiveHeader(`${s}-${u}`)
          }, [
            (d(), I(Y(l.type), {
              item: l,
              organizations: n.organizations,
              theme: n.headerTheme,
              "is-mobile": i.isMobile,
              "is-preview": n.isPreview,
              "is-mobile-active": o.activeHeader === `${s}-${u}`,
              onHideOnEsc: t[0] || (t[0] = (m) => e.$emit("hide-on-esc")),
              onSetActiveHeader: (m) => i.setActiveHeader(`${s}-${u}`),
              onTabAction: (m) => i.tabAction(l, m)
            }, null, 40, ["item", "organizations", "theme", "is-mobile", "is-preview", "is-mobile-active", "onSetActiveHeader", "onTabAction"])),
            j(Le, {
              name: i.isMobile ? "slide" : ""
            }, {
              default: S(() => [
                l.type === "SchoolsMenuHeader" && !i.isMobile || i.isMobile && o.activeHeader === `${s}-${u}` ? (d(), f("ul", {
                  key: 0,
                  class: "child-ul",
                  "aria-describedby": `parent-item-${s}-${u}`
                }, [
                  (d(!0), f(J, null, ne(l.children, (m, v) => (d(), f("li", {
                    key: `child-item-${s}-${u}-${v}`,
                    class: "child-item"
                  }, [
                    (d(), I(Y(m.type), {
                      organizations: n.organizations,
                      item: m,
                      theme: n.headerTheme,
                      onHideOnEsc: t[1] || (t[1] = (g) => e.$emit("hide-on-esc")),
                      onTabAction: (g) => i.tabAction(m, g)
                    }, null, 40, ["organizations", "item", "theme", "onTabAction"]))
                  ]))), 128))
                ], 8, aM)) : T("", !0)
              ]),
              _: 2
            }, 1032, ["name"])
          ], 10, sM))), 128))
        ])
      ]))), 128))
    ], 512)
  ], 6);
}
const uM = /* @__PURE__ */ B(oM, [["render", lM], ["__scopeId", "data-v-fa1c07e4"]]), dM = {
  name: "SchoolsMenu",
  components: {
    SM1: uM
  },
  mixins: [Tt],
  props: {
    headerTheme: {
      type: Object,
      required: !0
    },
    orgMenuContent: {
      type: Array,
      default: () => []
    },
    organizations: {
      type: Array,
      default: () => []
    },
    showCustomSchoolsMenu: Boolean,
    stickyHeader: Boolean,
    shrinkHeader: Boolean,
    isPreview: Boolean,
    isIFrame: Boolean
  },
  methods: {
    hideOnClickaway() {
      this.$emit("hide-on-clickaway");
    },
    onFocusLost() {
      this.$emit("focus-lost");
    }
  }
};
function cM(e, t, n, r, o, i) {
  const a = Ke("click-away");
  return d(), f("div", {
    onKeydown: t[0] || (t[0] = K(W((...s) => i.hideOnClickaway && i.hideOnClickaway(...s), ["exact", "prevent"]), ["esc"]))
  }, [
    j(Le, { name: "slide" }, {
      default: S(() => [
        n.showCustomSchoolsMenu ? we((d(), I(Y("SM1"), {
          key: 0,
          "header-theme": n.headerTheme,
          columns: n.orgMenuContent,
          organizations: n.organizations,
          "sticky-header": n.stickyHeader,
          "shrink-header": n.shrinkHeader,
          "is-preview": n.isPreview,
          onHideOnEsc: i.hideOnClickaway,
          onFocusLost: i.onFocusLost
        }, null, 40, ["header-theme", "columns", "organizations", "sticky-header", "shrink-header", "is-preview", "onHideOnEsc", "onFocusLost"])), [
          [a, i.hideOnClickaway]
        ]) : T("", !0)
      ]),
      _: 1
    })
  ], 32);
}
const hr = /* @__PURE__ */ B(dM, [["render", cM], ["__scopeId", "data-v-e9ebd598"]]), hM = {
  name: "HeaderDropdown",
  props: {
    id: {
      type: String,
      default: ""
    },
    role: {
      type: String,
      default: ""
    },
    labelledby: {
      type: String,
      default: ""
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    data: {
      type: Array,
      default: () => []
    },
    isVisible: Boolean,
    menuV4Enabled: Boolean,
    isPreview: Boolean,
    isLanguageMenuHidden: Boolean,
    pathPrefix: {
      type: String,
      default: ""
    },
    isShrink: Boolean
  },
  data() {
    return {
      focusedIndex: 0,
      headerHeight: 200
    };
  },
  computed: {
    colors() {
      const e = this.isShrink ? 46 : this.headerHeight;
      return {
        "--school-bg-color": this.styles.schools_menu_bg_color.hex,
        "--school-text-color": this.styles.schools_menu_text_color.hex,
        "--explore-bg-color": $(
          this.styles,
          "explore_menu_bg_color.hex",
          this.styles.language_menu_dropdown_color.hex
        ),
        "--explore-text-color": $(
          this.styles,
          "explore_menu_text_color.hex",
          this.styles.language_menu_text_color.hex
        ),
        "--lang-bg-color": this.styles.language_menu_dropdown_color.hex,
        "--lang-text-color": this.styles.language_menu_text_color.hex,
        "--header-height": `${e + 12}px`
      };
    },
    isSchoolMenu() {
      return this.id === "schoolsmenu";
    },
    isMenuV4() {
      return this.menuV4Enabled && this.id === "explore-menu";
    }
  },
  mounted() {
    typeof window != "undefined" && window.addEventListener("resize", this.calculateParentHeight);
  },
  beforeUnmount() {
    typeof window != "undefined" && window.removeEventListener("resize", this.calculateParentHeight);
  },
  beforeUpdate() {
    this.calculateParentHeight();
  },
  updated() {
    this.isVisible && this.$refs.dropdown && (this.focusedIndex = 0);
  },
  methods: {
    calculateParentHeight() {
      this.$parent.$parent.$refs.cmsHeader && (this.headerHeight = this.$parent.$parent.$refs.cmsHeader.clientHeight);
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.pathPrefix}${e}` : e;
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    changeFocus(e, t) {
      const n = this.focusedIndex + e;
      if (n < 0 || n > this.data.length - 1) {
        this.closeDropdown();
        return;
      }
      this.focusedIndex = n, t ? this.focusItem() : this.focusArrowNavigation();
    },
    focusPrevious(e, t) {
      this.changeFocus(-1, t);
    },
    focusNext(e, t) {
      this.changeFocus(1, t);
    },
    focusItem() {
      this.$refs.dropdown.children[this.focusedIndex].focus();
    },
    focusArrowNavigation() {
      this.$refs.dropdown.children[this.focusedIndex].children[0].focus();
    },
    updateLanguageCode(e) {
      this.$emit("setLanguage", e);
    },
    closeDropdown(e) {
      this.$emit("close-dropdown", e);
    },
    orgLink(e) {
      return qr(e, {
        isPreview: this.isPreview,
        currentDomain: window.location.href
      });
    }
  }
}, mM = ["id", "role", "aria-labelledby"], fM = { ref: "dropdown" }, pM = ["href", "target"], gM = ["href"], vM = ["onKeydown"], bM = ["onClick"], yM = {
  class: "button-action-content",
  tabindex: "-1"
};
function _M(e, t, n, r, o, i) {
  return d(), I(Le, { name: "fade" }, {
    default: S(() => [
      n.isVisible ? (d(), f("div", {
        key: 0,
        class: "header--dropdown-wrapper",
        style: Z(i.colors)
      }, [
        c("div", {
          id: n.id,
          role: n.role,
          "aria-labelledby": n.labelledby,
          class: _(["dropdown", {
            "dropdown--school": i.isSchoolMenu,
            "dropdown--explore": i.isMenuV4,
            "dropdown--lang": !i.isSchoolMenu && !i.isMenuV4,
            "no-language-menu": n.isLanguageMenuHidden
          }]),
          onClick: W(() => {
          }, ["stop"]),
          onKeydown: t[14] || (t[14] = K(W((a) => i.closeDropdown(!0), ["exact", "prevent"]), ["esc"]))
        }, [
          c("ul", fM, [
            i.isMenuV4 ? (d(!0), f(J, { key: 0 }, ne(n.data, (a) => (d(), f("li", {
              key: a.id,
              role: "menuitem",
              onKeydown: [
                t[0] || (t[0] = K(W((...s) => i.focusPrevious && i.focusPrevious(...s), ["exact", "prevent"]), ["up"])),
                t[1] || (t[1] = K(W((...s) => i.focusNext && i.focusNext(...s), ["exact", "prevent"]), ["down"])),
                t[2] || (t[2] = K(W((s) => i.focusPrevious(s, !0), ["shift", "exact"]), ["tab"])),
                t[3] || (t[3] = K(W((s) => i.focusNext(s, !0), ["exact"]), ["tab"]))
              ],
              onClick: t[4] || (t[4] = (...s) => i.closeDropdown && i.closeDropdown(...s))
            }, [
              c("a", {
                href: i.getLink(a.url),
                class: "link-explore",
                target: i.targetWindow(a)
              }, k(a.name), 9, pM)
            ], 32))), 128)) : i.isSchoolMenu ? (d(!0), f(J, { key: 1 }, ne(n.data, (a, s) => (d(), f("li", {
              key: s,
              role: "menuitem",
              onKeydown: [
                t[5] || (t[5] = K(W((...l) => i.focusPrevious && i.focusPrevious(...l), ["exact", "prevent"]), ["up"])),
                t[6] || (t[6] = K(W((...l) => i.focusNext && i.focusNext(...l), ["exact", "prevent"]), ["down"])),
                t[7] || (t[7] = K(W((l) => i.focusPrevious(l, !0), ["shift", "exact"]), ["tab"])),
                t[8] || (t[8] = K(W((l) => i.focusNext(l, !0), ["exact"]), ["tab"]))
              ],
              onClick: t[9] || (t[9] = (...l) => i.closeDropdown && i.closeDropdown(...l))
            }, [
              c("a", {
                href: i.orgLink(a),
                class: "link-school"
              }, k(a.name), 9, gM)
            ], 32))), 128)) : (d(!0), f(J, { key: 2 }, ne(n.data, (a, s) => (d(), f("li", {
              key: s,
              role: "menuitem",
              onKeydown: [
                K(W((l) => i.updateLanguageCode(a), ["exact", "prevent"]), ["enter"]),
                t[10] || (t[10] = K(W((...l) => i.focusPrevious && i.focusPrevious(...l), ["exact", "prevent"]), ["up"])),
                t[11] || (t[11] = K(W((...l) => i.focusNext && i.focusNext(...l), ["exact", "prevent"]), ["down"])),
                t[12] || (t[12] = K(W((l) => i.focusPrevious(l, !0), ["shift", "exact"]), ["tab"])),
                t[13] || (t[13] = K(W((l) => i.focusNext(l, !0), ["exact"]), ["tab"]))
              ]
            }, [
              c("button", {
                class: "button-action link-lang",
                onClick: (l) => i.updateLanguageCode(a)
              }, [
                c("div", yM, k(a.language), 1)
              ], 8, bM)
            ], 40, vM))), 128))
          ], 512)
        ], 42, mM)
      ], 4)) : T("", !0)
    ]),
    _: 1
  });
}
const CM = /* @__PURE__ */ B(hM, [["render", _M], ["__scopeId", "data-v-49b8bc7d"]]), wM = {
  props: {
    color: {
      type: String,
      default: ""
    }
  }
}, TM = {
  width: "176",
  height: "16",
  viewBox: "0 0 176 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  "aria-labelledby": "googleTranslateLogoID"
}, kM = ["fill"], EM = ["fill"], SM = ["fill"], MM = ["fill"], AM = ["fill"], IM = ["fill"], LM = ["fill"], DM = ["fill"], $M = ["fill"], OM = ["fill"], PM = ["fill"], NM = ["fill"], HM = ["fill"], FM = ["fill"], RM = ["fill"], VM = ["fill"], BM = ["fill"], jM = ["fill"], UM = ["fill"], qM = ["fill"], GM = ["fill"], KM = ["fill"], zM = ["fill"], ZM = ["fill"];
function xM(e, t, n, r, o, i) {
  return d(), f("svg", TM, [
    t[0] || (t[0] = c("title", { id: "googleTranslateLogoID" }, "powered by Google Translate", -1)),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M128.97 4.67C128.23 4.67 127.2 5.19 126.91 6H126.85V4.78H125.58V11.88H126.91V8.06C126.91 6.76 127.84 5.99 128.75 5.99C129.04 5.99 129.27 6.02 129.46 6.09L129.97 4.84C129.69 4.72 129.4 4.67 128.97 4.67",
      fill: n.color || "#757575"
    }, null, 8, kM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M152.98 1.33H154.31V11.87H152.98V1.33Z",
      fill: n.color || "#757575"
    }, null, 8, EM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M148.84 4.67C147.41 4.67 146.07 5.47 146.07 6.72C146.07 7.97 147.28 8.48 147.91 8.63L149.34 8.97C150.07 9.15 150.32 9.53 150.32 9.88C150.32 10.46 149.7 10.83 148.9 10.83C148.1 10.83 147.36 10.43 146.99 9.54L145.84 10.02C146.25 11.02 147.23 12 148.89 12C150.55 12 151.64 11.06 151.64 9.84C151.64 9 151.07 8.15 149.7 7.83L148.3 7.51C147.75 7.38 147.39 7.15 147.39 6.71C147.39 6.15 148.06 5.84 148.79 5.84C149.46 5.84 150.14 6.11 150.4 6.75L151.52 6.29C151.1 5.24 150.02 4.67 148.82 4.67",
      fill: n.color || "#757575"
    }, null, 8, SM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M158.76 10.8C158.09 10.8 157.25 10.45 157.25 9.72C157.25 9.09 157.86 8.4 159.22 8.4C160.32 8.4 160.84 8.81 160.84 8.81C160.84 9.93 159.78 10.8 158.75 10.8M159.03 4.67C157.3 4.67 156.33 5.68 156.09 6.31L157.27 6.82C157.51 6.17 158.34 5.87 159.06 5.87C160.03 5.87 160.84 6.47 160.84 7.56V7.76C160.57 7.61 159.92 7.34 158.99 7.34C157.37 7.34 155.87 8.14 155.87 9.7C155.87 11.13 157.13 12 158.54 12C159.72 12 160.4 11.36 160.78 10.79H160.84V11.87H162.1V7.61C162.1 5.67 160.72 4.66 159.04 4.66",
      fill: n.color || "#757575"
    }, null, 8, MM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M133.5 10.8C132.83 10.8 131.99 10.45 131.99 9.72C131.99 9.09 132.6 8.4 133.96 8.4C135.06 8.4 135.58 8.81 135.58 8.81C135.58 9.93 134.52 10.8 133.49 10.8M133.77 4.67C132.04 4.67 131.07 5.68 130.83 6.31L132.01 6.82C132.25 6.17 133.08 5.87 133.8 5.87C134.77 5.87 135.58 6.47 135.58 7.56V7.76C135.31 7.61 134.66 7.34 133.73 7.34C132.11 7.34 130.61 8.14 130.61 9.7C130.61 11.13 131.87 12 133.28 12C134.46 12 135.14 11.36 135.52 10.79H135.58V11.87H136.84V7.61C136.84 5.67 135.46 4.66 133.78 4.66",
      fill: n.color || "#757575"
    }, null, 8, AM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M169.58 7.5C169.84 6.5 170.61 5.87 171.58 5.87C173.08 5.87 173.59 6.91 173.63 7.5H169.58ZM171.61 4.67C169.56 4.67 168.19 6.38 168.19 8.34C168.19 10.42 169.62 12.01 171.76 12.01C173.37 12.01 174.4 11.11 174.81 10.13L173.64 9.65C173.27 10.52 172.5 10.81 171.73 10.81C170.65 10.81 169.58 10.04 169.5 8.59H175.02C175.02 8.59 175.03 8.44 175.03 8.34C175.03 6.12 173.69 4.67 171.61 4.67",
      fill: n.color || "#757575"
    }, null, 8, IM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M141.96 4.67C140.99 4.67 140.09 5.23 139.71 5.89H139.65V4.78H138.38V11.88H139.71V8.08C139.71 6.99 140.42 5.89 141.58 5.89C142.59 5.89 143.33 6.38 143.33 7.86V11.88H144.66V7.66C144.66 5.91 143.76 4.68 141.95 4.68",
      fill: n.color || "#757575"
    }, null, 8, LM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M165.58 2.67H164.25V4.78H163V6.01H164.25V9.73C164.25 11.18 165.05 12 166.54 12C166.99 12 167.31 11.94 167.61 11.81L167.15 10.67C166.96 10.76 166.79 10.79 166.54 10.79C165.92 10.79 165.58 10.43 165.58 9.63V6.01H167.32V4.78H165.58V2.67",
      fill: n.color || "#757575"
    }, null, 8, DM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M125.13 1.33H117.91V2.7H120.84V11.87H122.19V2.7H125.12V1.33",
      fill: n.color || "#757575"
    }, null, 8, $M),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M72.34 5.46V7.1H76.26C76.14 8.02 75.84 8.7 75.37 9.16C74.8 9.73 73.91 10.36 72.34 10.36C69.92 10.36 68.04 8.41 68.04 6C68.04 3.59 69.93 1.64 72.34 1.64C73.64 1.64 74.59 2.15 75.3 2.81L76.46 1.65C75.48 0.71 74.18 0 72.35 0C69.04 0 66.26 2.69 66.26 6C66.26 9.31 69.04 12 72.35 12C74.13 12 75.48 11.41 76.54 10.32C77.62 9.24 77.96 7.71 77.96 6.49C77.96 6.11 77.93 5.76 77.87 5.47H72.35",
      fill: n.color || "#4285F4"
    }, null, 8, OM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M82.85 4.13C80.71 4.13 78.96 5.76 78.96 8C78.96 10.24 80.71 11.87 82.85 11.87C84.99 11.87 86.74 10.23 86.74 8C86.74 5.77 84.99 4.13 82.85 4.13ZM82.85 10.35C81.68 10.35 80.66 9.38 80.66 8C80.66 6.62 81.67 5.65 82.85 5.65C84.03 5.65 85.04 6.6 85.04 8C85.04 9.4 84.03 10.35 82.85 10.35Z",
      fill: n.color || "#EB4335"
    }, null, 8, PM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M101.9 4.99H101.84C101.46 4.53 100.72 4.12 99.8001 4.12C97.8601 4.12 96.1801 5.81 96.1801 7.99C96.1801 10.17 97.8701 11.86 99.8001 11.86C100.72 11.86 101.46 11.45 101.84 10.98H101.9V11.52C101.9 13 101.11 13.79 99.8301 13.79C98.7901 13.79 98.1401 13.04 97.8801 12.41L96.4001 13.03C96.8301 14.06 97.9501 15.32 99.8301 15.32C101.83 15.32 103.51 14.15 103.51 11.29V4.32H101.9V4.99V4.99ZM99.9501 10.34C98.7801 10.34 97.8801 9.34 97.8801 7.99C97.8801 6.64 98.7701 5.64 99.9501 5.64C101.13 5.64 102.02 6.64 102.02 8C102.02 9.36 101.11 10.33 99.9501 10.33V10.34Z",
      fill: n.color || "#4285F4"
    }, null, 8, NM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M91.51 4.13C89.37 4.13 87.62 5.76 87.62 8C87.62 10.24 89.37 11.87 91.51 11.87C93.65 11.87 95.4 10.23 95.4 8C95.4 5.77 93.65 4.13 91.51 4.13ZM91.51 10.35C90.34 10.35 89.32 9.38 89.32 8C89.32 6.62 90.33 5.65 91.51 5.65C92.69 5.65 93.7 6.6 93.7 8C93.7 9.4 92.69 10.35 91.51 10.35Z",
      fill: n.color || "#FBBC05"
    }, null, 8, HM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M104.85 0.160004H106.52V11.87H104.85V0.160004Z",
      fill: n.color || "#34A853"
    }, null, 8, FM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M111.69 10.35C110.82 10.35 110.21 9.95 109.81 9.18L114.99 7.04L114.81 6.6C114.49 5.73 113.5 4.14 111.5 4.14C109.5 4.14 107.85 5.71 107.85 8.01C107.85 10.18 109.49 11.88 111.69 11.88C113.46 11.88 114.49 10.79 114.92 10.16L113.6 9.28C113.16 9.93 112.56 10.35 111.69 10.35V10.35ZM111.56 5.58C112.25 5.58 112.83 5.93 113.03 6.43L109.53 7.88C109.53 6.25 110.68 5.58 111.56 5.58Z",
      fill: n.color || "#EB4335"
    }, null, 8, RM),
    c("path", {
      d: "M5.36 8.77C5.36 9.73 5.14 10.51 4.7 11.1C4.26 11.69 3.66 11.98 2.91 11.98C2.16 11.98 1.53 11.74 1.09 11.25V14.3H0V5.53H0.99L1.04 6.23C1.48 5.68 2.09 5.41 2.88 5.41C3.67 5.41 4.24 5.7 4.69 6.27C5.14 6.84 5.36 7.64 5.36 8.67V8.77V8.77ZM4.28 8.65C4.28 7.94 4.13 7.37 3.82 6.96C3.51 6.55 3.1 6.34 2.57 6.34C1.91 6.34 1.42 6.63 1.09 7.21V10.24C1.41 10.82 1.91 11.11 2.58 11.11C3.1 11.11 3.51 10.9 3.82 10.49C4.13 10.08 4.28 9.47 4.28 8.65Z",
      fill: n.color || "black"
    }, null, 8, VM),
    c("path", {
      d: "M6.44995 8.64C6.44995 8.02 6.56995 7.46 6.81995 6.96C7.06995 6.46 7.39995 6.08 7.83995 5.81C8.27995 5.54 8.76995 5.41 9.32995 5.41C10.19 5.41 10.89 5.71 11.42 6.31C11.95 6.91 12.22 7.7 12.22 8.69V8.77C12.22 9.39 12.1 9.94 11.87 10.43C11.64 10.92 11.3 11.3 10.86 11.58C10.42 11.86 9.91995 11.99 9.34995 11.99C8.48995 11.99 7.78995 11.69 7.25995 11.09C6.72995 10.49 6.45995 9.7 6.45995 8.72V8.64H6.44995ZM7.53995 8.77C7.53995 9.47 7.69995 10.04 8.02995 10.46C8.35995 10.88 8.78995 11.1 9.33995 11.1C9.88995 11.1 10.33 10.88 10.65 10.45C10.97 10.02 11.14 9.41 11.14 8.64C11.14 7.94 10.97 7.38 10.64 6.95C10.31 6.52 9.86995 6.3 9.31995 6.3C8.76995 6.3 8.34995 6.51 8.02995 6.94C7.70995 7.37 7.53995 7.98 7.53995 8.77V8.77Z",
      fill: n.color || "black"
    }, null, 8, BM),
    c("path", {
      d: "M19.19 10.38L20.41 5.53H21.49L19.64 11.87H18.76L17.22 7.07L15.72 11.87H14.84L13 5.53H14.08L15.33 10.28L16.81 5.53H17.68L19.19 10.38V10.38Z",
      fill: n.color || "black"
    }, null, 8, jM),
    c("path", {
      d: "M25.2201 11.99C24.3601 11.99 23.6601 11.71 23.1201 11.14C22.5801 10.57 22.3101 9.82 22.3101 8.88V8.68C22.3101 8.05 22.4301 7.49 22.6701 7C22.9101 6.51 23.2501 6.12 23.6801 5.84C24.1101 5.56 24.5801 5.42 25.0801 5.42C25.9001 5.42 26.5401 5.69 27.0001 6.23C27.4601 6.77 27.6901 7.55 27.6901 8.56V9.01H23.4001C23.4201 9.63 23.6001 10.14 23.9501 10.52C24.3001 10.9 24.7401 11.1 25.2801 11.1C25.6601 11.1 25.9901 11.02 26.2501 10.87C26.5101 10.72 26.7501 10.51 26.9501 10.25L27.6101 10.77C27.0801 11.59 26.2801 11.99 25.2201 11.99V11.99ZM25.0901 6.31C24.6501 6.31 24.2901 6.47 23.9901 6.79C23.6901 7.11 23.5101 7.55 23.4401 8.13H26.6201V8.05C26.5901 7.5 26.4401 7.07 26.1701 6.77C25.9001 6.47 25.5501 6.32 25.0901 6.32V6.31Z",
      fill: n.color || "black"
    }, null, 8, UM),
    c("path", {
      d: "M32.02 6.51C31.86 6.48 31.68 6.47 31.49 6.47C30.78 6.47 30.3 6.77 30.04 7.38V11.88H28.96V5.54H30.01L30.03 6.27C30.39 5.7 30.89 5.42 31.54 5.42C31.75 5.42 31.91 5.45 32.02 5.5V6.51Z",
      fill: n.color || "black"
    }, null, 8, qM),
    c("path", {
      d: "M35.64 11.99C34.78 11.99 34.08 11.71 33.54 11.14C33 10.57 32.73 9.82 32.73 8.88V8.68C32.73 8.05 32.85 7.49 33.09 7C33.33 6.51 33.67 6.12 34.1 5.84C34.53 5.56 35 5.42 35.5 5.42C36.32 5.42 36.96 5.69 37.42 6.23C37.88 6.77 38.11 7.55 38.11 8.56V9.01H33.82C33.84 9.63 34.02 10.14 34.37 10.52C34.72 10.9 35.16 11.1 35.7 11.1C36.08 11.1 36.41 11.02 36.67 10.87C36.93 10.72 37.17 10.51 37.37 10.25L38.03 10.77C37.5 11.59 36.7 11.99 35.64 11.99V11.99ZM35.51 6.31C35.07 6.31 34.71 6.47 34.41 6.79C34.11 7.11 33.93 7.55 33.86 8.13H37.04V8.05C37.01 7.5 36.86 7.07 36.59 6.77C36.32 6.47 35.97 6.32 35.51 6.32V6.31Z",
      fill: n.color || "black"
    }, null, 8, GM),
    c("path", {
      d: "M39.11 8.64999C39.11 7.67999 39.34 6.9 39.8 6.3C40.26 5.7 40.86 5.41 41.61 5.41C42.36 5.41 42.94 5.66 43.37 6.17V2.87H44.45V11.87H43.45L43.4 11.19C42.97 11.72 42.36 11.99 41.59 11.99C40.82 11.99 40.26 11.69 39.79 11.09C39.32 10.49 39.1 9.69999 39.1 8.72999V8.64999H39.11ZM40.19 8.77C40.19 9.49 40.34 10.05 40.64 10.46C40.94 10.87 41.35 11.07 41.87 11.07C42.56 11.07 43.06 10.76 43.38 10.14V7.23C43.06 6.63 42.56 6.33 41.89 6.33C41.36 6.33 40.94 6.54 40.65 6.95C40.36 7.36 40.2 7.97 40.2 8.77H40.19Z",
      fill: n.color || "black"
    }, null, 8, KM),
    c("path", {
      d: "M54.47 8.77C54.47 9.74 54.25 10.52 53.8 11.1C53.35 11.68 52.76 11.98 52.01 11.98C51.21 11.98 50.59 11.7 50.15 11.13L50.1 11.86H49.1V2.87H50.18V6.23C50.62 5.69 51.22 5.42 51.99 5.42C52.76 5.42 53.36 5.71 53.8 6.29C54.24 6.87 54.46 7.67 54.46 8.68V8.77H54.47ZM53.39 8.64999C53.39 7.90999 53.25 7.34 52.96 6.94C52.67 6.54 52.26 6.34 51.73 6.34C51.02 6.34 50.5 6.67 50.19 7.34V10.08C50.52 10.74 51.04 11.08 51.74 11.08C52.26 11.08 52.66 10.88 52.95 10.48C53.24 10.08 53.38 9.47 53.38 8.66L53.39 8.64999Z",
      fill: n.color || "black"
    }, null, 8, zM),
    c("path", {
      d: "M57.91 10.29L59.39 5.53999H60.55L58 12.86C57.61 13.91 56.98 14.44 56.12 14.44L55.91 14.42L55.51 14.34V13.46L55.8 13.48C56.17 13.48 56.45 13.41 56.66 13.26C56.87 13.11 57.03 12.84 57.17 12.45L57.41 11.81L55.15 5.53999H56.33L57.91 10.29V10.29Z",
      fill: n.color || "black"
    }, null, 8, ZM)
  ]);
}
const WM = /* @__PURE__ */ B(wM, [["render", xM]]), YM = {
  props: {
    color: {
      type: String,
      default: "#662E80"
    }
  }
}, XM = {
  width: "12",
  height: "10",
  viewBox: "0 0 12 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QM = ["stroke"];
function JM(e, t, n, r, o, i) {
  return d(), f("svg", XM, [
    c("path", {
      d: "M1 5.53089L4.75 8.95946L11 0.959457",
      stroke: n.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, QM)
  ]);
}
const eA = /* @__PURE__ */ B(YM, [["render", JM]]), tA = {
  name: "LanguageDropdown",
  components: {
    SelectedIcon: eA,
    PoweredByGoogle: WM
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "All Languages"
    },
    data: {
      type: Array,
      default: () => []
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    currentLanguage: {
      type: String,
      default: "en"
    },
    role: {
      type: String,
      default: ""
    },
    isVisible: Boolean
  },
  data() {
    return {
      bottomListReached: !1,
      focusedIndex: 0,
      inputValue: "",
      selectedLanguage: ""
    };
  },
  computed: {
    colors() {
      return {
        "--lang-bg-color": this.styles.language_menu_dropdown_color.hex || "#fff",
        "--lang-text-color": this.langTextColor || "#000",
        "--column-count": this.data.length < 5 ? 2 : 3,
        "--inner-shadow-height": this.data.length > 18 && !this.bottomListReached ? "35px" : "0px"
      };
    },
    googleLogoColor() {
      return this.colors["--lang-bg-color"] === "#fff" ? "" : de(this.colors["--lang-bg-color"]).isLight() ? "#000" : "#fff";
    },
    langTextColor() {
      return this.styles.language_menu_text_color.hex || "#000";
    },
    filteredLanguages() {
      const e = this.inputValue.trim().toLowerCase();
      return e.length === 0 ? this.data : this.data.filter(
        ({ language: t, code: n }) => t.toLowerCase().includes(e) || n.toLowerCase().includes(e)
      );
    }
  },
  mounted() {
    this.selectedLanguage = this.currentLanguage;
  },
  methods: {
    listScroll(e) {
      const { scrollTop: t, offsetHeight: n, scrollHeight: r } = e.target, o = 10;
      this.bottomListReached = t + n + o >= r;
    },
    inputSearch() {
      var e;
      !this.inputValue.trim().length || !this.filteredLanguages.length || (this.selectedLanguage = (e = this.filteredLanguages[0]) == null ? void 0 : e.code, this.confirmLanguageSelection(this.selectedLanguage));
    },
    selectLanguage(e) {
      this.selectedLanguage = e, this.confirmLanguageSelection(this.selectedLanguage);
    },
    confirmLanguageSelection(e) {
      this.$emit("set-language", { code: e });
    },
    changeFocus(e, t = !1) {
      const n = this.focusedIndex + e;
      if (n < 0) {
        this.focusedIndex = 0, this.$refs["language-input"].focus();
        return;
      }
      if (n > this.filteredLanguages.length - 1) {
        this.focusedIndex = 0, this.$emit("close-dropdown");
        return;
      }
      this.focusedIndex = n, t || this.$refs["languages-list"].children[this.focusedIndex].focus();
    }
  }
}, nA = ["id", "role"], rA = { class: "header" }, oA = { class: "title" }, iA = { class: "body" }, sA = {
  ref: "languages-list",
  class: "languages-list"
}, aA = ["onClick", "onKeydown"], lA = { class: "language-text" }, uA = { class: "footer" };
function dA(e, t, n, r, o, i) {
  const a = V("selected-icon"), s = V("powered-by-google");
  return d(), I(Le, { name: "fade" }, {
    default: S(() => [
      n.isVisible ? (d(), f("div", {
        key: 0,
        id: n.id,
        style: Z(i.colors),
        role: n.role,
        class: "dropdown-wrapper"
      }, [
        c("div", rA, [
          c("h1", oA, k(n.title), 1),
          we(c("input", {
            ref: "language-input",
            "onUpdate:modelValue": t[0] || (t[0] = (l) => o.inputValue = l),
            class: "search-input",
            type: "text",
            placeholder: "search languages...",
            onKeydown: [
              t[1] || (t[1] = K(W((...l) => i.inputSearch && i.inputSearch(...l), ["exact", "prevent"]), ["enter"])),
              t[2] || (t[2] = K(W((l) => e.$emit("close-dropdown"), ["shift", "exact"]), ["tab"]))
            ],
            onFocus: t[3] || (t[3] = (l) => o.focusedIndex = 0)
          }, null, 544), [
            [p6, o.inputValue]
          ])
        ]),
        c("div", iA, [
          c("div", {
            class: "languages-container",
            onScroll: t[8] || (t[8] = (...l) => i.listScroll && i.listScroll(...l))
          }, [
            c("ul", sA, [
              (d(!0), f(J, null, ne(i.filteredLanguages, ({ language: l, code: u }) => (d(), f("li", {
                key: u,
                role: "menuitem",
                tabindex: "0",
                class: "language",
                onClick: (m) => i.selectLanguage(u),
                onKeydown: [
                  K(W((m) => i.selectLanguage(u), ["exact", "prevent"]), ["enter"]),
                  t[4] || (t[4] = K(W((m) => i.changeFocus(-1), ["exact", "prevent"]), ["up"])),
                  t[5] || (t[5] = K(W((m) => i.changeFocus(1), ["exact", "prevent"]), ["down"])),
                  t[6] || (t[6] = K(W((m) => i.changeFocus(-1), ["shift", "exact", "prevent"]), ["tab"])),
                  t[7] || (t[7] = K(W((m) => i.changeFocus(1, !0), ["exact"]), ["tab"]))
                ]
              }, [
                o.selectedLanguage === u ? (d(), I(a, {
                  key: 0,
                  color: i.langTextColor,
                  class: "selected-icon"
                }, null, 8, ["color"])) : T("", !0),
                c("div", lA, k(l), 1)
              ], 40, aA))), 128))
            ], 512)
          ], 32)
        ]),
        c("div", uA, [
          j(s, { color: i.googleLogoColor }, null, 8, ["color"])
        ])
      ], 12, nA)) : T("", !0)
    ]),
    _: 1
  });
}
const Ds = /* @__PURE__ */ B(tA, [["render", dA], ["__scopeId", "data-v-f1cc0f89"]]), cA = [[{ type: "SchoolsMenuOrg", name: "School District", link: "#" }, { type: "SchoolsMenuHeader", name: "High Schools", children: [{ type: "SchoolsMenuOrg", name: "Bella High School", link: "#" }, { type: "SchoolsMenuOrg", name: "Northside High School", link: "#" }, { type: "SchoolsMenuOrg", name: "No-Link High School" }] }], [{ type: "SchoolsMenuHeader", name: "Middle Schools", children: [{ type: "SchoolsMenuOrg", name: "Bella Middle School", link: "#" }, { type: "SchoolsMenuOrg", name: "Northside Intermediate", link: "#" }, { type: "SchoolsMenuOrg", name: "Parkway Middle School", link: "#" }, { type: "SchoolsMenuOrg", name: "Bohr Science Magnet", link: "#" }] }], [{ type: "SchoolsMenuHeader", name: "Elementary Schools", children: [{ type: "SchoolsMenuOrg", name: "Bella Elementary School", link: "#" }, { type: "SchoolsMenuOrg", name: "Northside Elementary", link: "#" }, { type: "SchoolsMenuOrg", name: "Parkway Elementary", link: "#" }, { type: "SchoolsMenuOrg", name: "Eastside Elementary", link: "#" }, { type: "SchoolsMenuOrg", name: "Southside Elementary", link: "#" }, { type: "SchoolsMenuOrg", name: "Burnside Elementary", link: "#" }, { type: "SchoolsMenuOrg", name: "Gibbs Magnet School", link: "#" }] }], [{ url: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg", type: "SchoolsMenuImage", caption: "Girl walking up steps to school", display: "actual-size", alt_text: "Girl walking up steps to school", asset_id: 206, link_url: "", set_ratio: 1, cropped_width: {}, cropped_height: {}, action_on_click: "no_action", image_alignment: "center", preferred_width: null, preferred_height: null, caption_alignment: "center", open_link_in_new_tab: !1 }]], y4 = {
  menu: cA
}, lt = {
  components: {
    HeaderDropdown: CM,
    LanguageDropdown: Ds
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    shouldShrink: Boolean,
    shouldBeSticky: Boolean,
    isMobile: Boolean,
    isHomepage: Boolean,
    showSignInButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    }
  },
  emits: ["language-change", "toggle-search", "toggle-menu", "toggle-mobile-menu"],
  data() {
    return {
      customSchoolsMenuVisible: !1,
      schoolDropdownVisible: !1,
      exploreMenuVisible: !1,
      languageDropdownVisible: !1,
      containerHeight: "auto"
    };
  },
  computed: {
    isCustomSchoolsMenuVisible() {
      return this.content.hasCustomSchoolsMenu && this.customSchoolsMenuVisible;
    },
    isSchoolDropdownVisible() {
      return !this.content.hasCustomSchoolsMenu && this.schoolDropdownVisible;
    },
    logoLink() {
      const e = this.content.pathPrefix ? this.content.pathPrefix : "/";
      return this.content.isIFrame ? "" : e;
    },
    shrinkCSSClass() {
      return this.shouldShrink && !this.content.isIFrame ? "shrink" : "";
    },
    logoCircleCSSClass() {
      return this.theme.logo_circle ? "logo-circle" : "";
    },
    menuV4Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4";
    },
    menuV5Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M5";
    },
    menuV6Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M6";
    },
    shouldDisplaySchoolsDropdown() {
      var e;
      return ((e = this.content.organizations) == null ? void 0 : e.length) > 1 || this.content.hasCustomSchoolsMenu;
    },
    shouldDisplayLanguagesDropdown() {
      var e;
      return ((e = this.content.languages) == null ? void 0 : e.length) > 1;
    },
    customSchoolsMenu() {
      var e, t;
      return this.content.isPreview || this.content.isIFrame ? y4 : (t = (e = this.content.globals) == null ? void 0 : e.homepage) == null ? void 0 : t.schools_menu;
    },
    menuIdByType() {
      let e = null;
      return this.isSchoolDropdownVisible ? e = "schoolsmenu" : this.isCustomSchoolsMenuVisible && (e = "schools-menu-sm1"), e;
    },
    mobileHeaderBgColor() {
      var e, t, n, r;
      return this.menuV4Enabled && this.theme.version !== "H3" ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : this.menuV5Enabled && this.theme.version === "H3" ? "transparent" : ((r = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : r.hex) || "#fff";
    },
    mobileMenuBgColor() {
      var e, t, n, r;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : ((r = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : r.hex) || "#fff";
    },
    mobileMenuTextColor() {
      var e, t, n, r;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_text_color) == null ? void 0 : t.hex : ((r = (n = this.content.menuOptions) == null ? void 0 : n.text_color) == null ? void 0 : r.hex) || "#000";
    },
    hasLanguages() {
      var e;
      return ((e = this.content.languages) == null ? void 0 : e.length) > 0;
    },
    signInColors() {
      var e, t, n, r;
      return {
        "--sign-in-border": (e = this.theme.sign_in_button_border) == null ? void 0 : e.hex,
        "--sign-in-color": (t = this.theme.sign_in_button_color) == null ? void 0 : t.hex,
        "--sign-in-bg": (n = this.theme.sign_in_button_bg) == null ? void 0 : n.hex,
        "--sign-in-bg-hover": `${(r = this.theme.sign_in_button_bg) == null ? void 0 : r.hex}CC`
      };
    },
    signInText() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.translations) == null ? void 0 : t.sign_in_button_title) || "Sign in";
    },
    hasExploreMenuContent() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.customMenuItems) == null ? void 0 : t.length) >= 1;
    },
    colors() {
      var e, t, n, r, o;
      return ae({
        "--bg-color": this.theme.bg_color ? this.theme.bg_color.hex : "#014990",
        "--logo-container-height": this.containerHeight,
        "--mobile-logo-height": (t = (e = this.content.globals) == null ? void 0 : e.info) != null && t.customHeader ? "auto" : "100%",
        "--more-text-color": this.theme.more_text_color ? this.theme.more_text_color.hex : "FFFFFF",
        "--more-bg-color": this.theme.more_bg_color ? this.theme.more_bg_color.hex : "#014990",
        "--dropdown-text-color": this.theme.dropdown_text_color ? this.theme.dropdown_text_color.hex : "#000000",
        "--dropdown-bg-color": this.theme.dropdown_bg_color ? this.theme.dropdown_bg_color.hex : "#FFFFFF",
        "--explore-menu-text-color": this.theme.explore_menu_text_color ? this.theme.explore_menu_text_color.hex : "#333333",
        "--explore-menu-bg-color": this.theme.explore_menu_bg_color ? this.theme.explore_menu_bg_color.hex : "#FFFFFF",
        "--schools-menu-text-color": this.theme.schools_menu_text_color ? this.theme.schools_menu_text_color.hex : "#333333",
        "--schools-menu-bg-color": this.theme.schools_menu_bg_color ? this.theme.schools_menu_bg_color.hex : "#FFFFFF",
        "--icon-bg-color": this.theme.icon_bg_color ? this.theme.icon_bg_color.hex : "#014990",
        "--icon-text-color": this.theme.icon_bg_color ? this.theme.icon_text_color.hex : "#014990",
        "--icon-color": this.theme.icon_color ? this.theme.icon_color.hex : "#014990",
        "--nav-color": this.theme.navigation_color ? this.theme.navigation_color.hex : "#014990",
        "--nav-icon-color": this.theme.navigation_icon_color ? this.theme.navigation_icon_color.hex : "#FFFFFF",
        "--text-color": this.theme.text_color ? this.theme.text_color.hex : "#FFFFFF",
        "--menu-heading-line-color": (r = (n = this.theme) == null ? void 0 : n.menu_heading_line_color) == null ? void 0 : r.hex,
        "--utility-link-color": this.theme.utility_link_color ? this.theme.utility_link_color.hex : "#000000",
        "--utility-bg-color": this.theme.utility_bg_color ? this.theme.utility_bg_color.hex : "#FFFFFF",
        searchIcon: (o = this.theme.search_icon_color) == null ? void 0 : o.hex,
        "--mobile-header-bg-color": this.mobileHeaderBgColor,
        "--mobile-menu-bg-color": this.mobileMenuBgColor,
        "--mobile-menu-text-color": this.mobileMenuTextColor,
        "--logo-container-height": this.containerHeight,
        "--mobile-logo-height": this.content.globals.info.customHeader ? "auto" : "100%"
      }, this.signInColors);
    }
  },
  mounted() {
    typeof window != "undefined" && (this.resizeLogoContainer(), window.addEventListener("resize", this.resizeLogoContainer));
  },
  beforeUnmount() {
    typeof window != "undefined" && window.removeEventListener("resize", this.resizeLogoContainer);
  },
  methods: {
    resizeLogoContainer() {
      var e, t, n;
      (n = (t = (e = this.content) == null ? void 0 : e.globals) == null ? void 0 : t.info) != null && n.customHeader ? this.containerHeight = `${window.document.getElementsByClassName("logo")[0].offsetHeight + 15}px` : this.containerHeight = "auto";
    },
    setLanguage(e) {
      this.languageDropdownVisible = !1, this.$emit("language-change", e);
    },
    toggleSearch() {
      this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.$emit("toggle-search");
    },
    clickedMenu(e) {
      this.setDropdownVisibility(e);
    },
    setDropdownVisibility(e) {
      switch (e) {
        case "menubutton":
          this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.$emit("toggle-menu", !this.content.showMenu);
          break;
        case "explore-button":
          this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.exploreMenuVisible = !this.exploreMenuVisible;
          break;
        case "schoolsbutton":
          this.exploreMenuVisible = !1, this.languageDropdownVisible = !1, this.content.hasCustomSchoolsMenu ? this.customSchoolsMenuVisible = !this.customSchoolsMenuVisible : this.schoolDropdownVisible = !this.schoolDropdownVisible;
          break;
        case "languagebutton":
          this.exploreMenuVisible = !1, this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !this.languageDropdownVisible;
          break;
        case "closebutton":
          this.$emit("toggle-menu", !1);
      }
    },
    closeAllMenus() {
      this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.exploreMenuVisible = !1;
    }
  }
};
function hA(e) {
  return Qp() ? (Jp(e), !0) : !1;
}
function Hc(e) {
  return typeof e == "function" ? e() : vc(e);
}
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const mA = (e) => e != null;
function fA(e) {
  var t;
  const n = Hc(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var _4 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], ds = /* @__PURE__ */ _4.join(","), C4 = typeof Element == "undefined", Pr = C4 ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, cs = !C4 && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, hs = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", a = i || n && t && e(t.parentNode);
  return a;
}, pA = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, w4 = function(t, n, r) {
  if (hs(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(ds));
  return n && Pr.call(t, ds) && o.unshift(t), o = o.filter(r), o;
}, T4 = function e(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!hs(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, u = e(l, !0, r);
        r.flatten ? o.push.apply(o, u) : o.push({
          scopeParent: a,
          candidates: u
        });
      } else {
        var m = Pr.call(a, ds);
        m && r.filter(a) && (n || !t.includes(a)) && o.push(a);
        var v = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), g = !hs(v, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (v && g) {
          var h = e(v === !0 ? a.children : v.children, !0, r);
          r.flatten ? o.push.apply(o, h) : o.push({
            scopeParent: a,
            candidates: h
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return o;
}, k4 = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Sr = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || pA(t)) && !k4(t) ? 0 : t.tabIndex;
}, gA = function(t, n) {
  var r = Sr(t);
  return r < 0 && n && !k4(t) ? 0 : r;
}, vA = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, E4 = function(t) {
  return t.tagName === "INPUT";
}, bA = function(t) {
  return E4(t) && t.type === "hidden";
}, yA = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, _A = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, CA = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || cs(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window != "undefined" && typeof window.CSS != "undefined" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = _A(o, t.form);
  return !i || i === t;
}, wA = function(t) {
  return E4(t) && t.type === "radio";
}, TA = function(t) {
  return wA(t) && !CA(t);
}, kA = function(t) {
  var n, r = t && cs(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, s, l;
    for (i = !!((a = o) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && o; ) {
      var u, m, v;
      r = cs(o), o = (u = r) === null || u === void 0 ? void 0 : u.host, i = !!((m = o) !== null && m !== void 0 && (v = m.ownerDocument) !== null && v !== void 0 && v.contains(o));
    }
  }
  return i;
}, dm = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, EA = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = Pr.call(t, "details>summary:first-of-type"), a = i ? t.parentElement : t;
  if (Pr.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, u = cs(t);
        if (l && !l.shadowRoot && o(l) === !0)
          return dm(t);
        t.assignedSlot ? t = t.assignedSlot : !l && u !== t.ownerDocument ? t = u.host : t = l;
      }
      t = s;
    }
    if (kA(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return dm(t);
  return !1;
}, SA = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return Pr.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, ms = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  hs(n) || bA(n) || EA(n, t) || // For a details element with a summary, the summary element gets the focus
  yA(n) || SA(n));
}, Fc = function(t, n) {
  return !(TA(n) || Sr(n) < 0 || !ms(t, n));
}, MA = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, AA = function e(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var a = !!o.scopeParent, s = a ? o.scopeParent : o, l = gA(s, a), u = a ? e(o.candidates) : s;
    l === 0 ? a ? n.push.apply(n, u) : n.push(s) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: a,
      content: u
    });
  }), r.sort(vA).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, IA = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = T4([t], n.includeContainer, {
    filter: Fc.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: MA
  }) : r = w4(t, n.includeContainer, Fc.bind(null, n)), AA(r);
}, LA = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = T4([t], n.includeContainer, {
    filter: ms.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = w4(t, n.includeContainer, ms.bind(null, n)), r;
}, Qr = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Pr.call(t, ds) === !1 ? !1 : Fc(n, t);
}, DA = /* @__PURE__ */ _4.concat("iframe").join(","), Ll = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Pr.call(t, DA) === !1 ? !1 : ms(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Rc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function $A(e) {
  if (Array.isArray(e)) return Rc(e);
}
function OA(e, t, n) {
  return (t = RA(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function PA(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function NA() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cm(Object(n), !0).forEach(function(r) {
      OA(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cm(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function HA(e) {
  return $A(e) || PA(e) || VA(e) || NA();
}
function FA(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function RA(e) {
  var t = FA(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function VA(e, t) {
  if (e) {
    if (typeof e == "string") return Rc(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Rc(e, t) : void 0;
  }
}
var mm = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var r = t[t.length - 1];
      r !== n && r._setPausedState(!0);
    }
    var o = t.indexOf(n);
    o === -1 || t.splice(o, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, BA = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, jA = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, Jo = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, UA = function(t) {
  return Jo(t) && !t.shiftKey;
}, qA = function(t) {
  return Jo(t) && t.shiftKey;
}, fm = function(t) {
  return setTimeout(t, 0);
}, Fo = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Ri = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, GA = [], S4 = function(t, n) {
  var r = (n == null ? void 0 : n.document) || document, o = (n == null ? void 0 : n.trapStack) || GA, i = hm({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: UA,
    isKeyBackward: qA
  }, n), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(N, G, X) {
    return N && N[G] !== void 0 ? N[G] : i[X || G];
  }, u = function(N, G) {
    var X = typeof (G == null ? void 0 : G.composedPath) == "function" ? G.composedPath() : void 0;
    return a.containerGroups.findIndex(function(Q) {
      var re = Q.container, se = Q.tabbableNodes;
      return re.contains(N) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (X == null ? void 0 : X.includes(re)) || se.find(function(ue) {
        return ue === N;
      });
    });
  }, m = function(N) {
    var G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, X = G.hasFallback, Q = X === void 0 ? !1 : X, re = G.params, se = re === void 0 ? [] : re, ue = i[N];
    if (typeof ue == "function" && (ue = ue.apply(void 0, HA(se))), ue === !0 && (ue = void 0), !ue) {
      if (ue === void 0 || ue === !1)
        return ue;
      throw new Error("`".concat(N, "` was specified but was not a node, or did not return a node"));
    }
    var me = ue;
    if (typeof ue == "string") {
      try {
        me = r.querySelector(ue);
      } catch (he) {
        throw new Error("`".concat(N, '` appears to be an invalid selector; error="').concat(he.message, '"'));
      }
      if (!me && !Q)
        throw new Error("`".concat(N, "` as selector refers to no known node"));
    }
    return me;
  }, v = function() {
    var N = m("initialFocus", {
      hasFallback: !0
    });
    if (N === !1)
      return !1;
    if (N === void 0 || N && !Ll(N, i.tabbableOptions))
      if (u(r.activeElement) >= 0)
        N = r.activeElement;
      else {
        var G = a.tabbableGroups[0], X = G && G.firstTabbableNode;
        N = X || m("fallbackFocus");
      }
    else N === null && (N = m("fallbackFocus"));
    if (!N)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return N;
  }, g = function() {
    if (a.containerGroups = a.containers.map(function(N) {
      var G = IA(N, i.tabbableOptions), X = LA(N, i.tabbableOptions), Q = G.length > 0 ? G[0] : void 0, re = G.length > 0 ? G[G.length - 1] : void 0, se = X.find(function(he) {
        return Qr(he);
      }), ue = X.slice().reverse().find(function(he) {
        return Qr(he);
      }), me = !!G.find(function(he) {
        return Sr(he) > 0;
      });
      return {
        container: N,
        tabbableNodes: G,
        focusableNodes: X,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: me,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: Q,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: re,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: se,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ue,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(_e) {
          var De = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Ae = G.indexOf(_e);
          return Ae < 0 ? De ? X.slice(X.indexOf(_e) + 1).find(function(ze) {
            return Qr(ze);
          }) : X.slice(0, X.indexOf(_e)).reverse().find(function(ze) {
            return Qr(ze);
          }) : G[Ae + (De ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(N) {
      return N.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !m("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(N) {
      return N.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, h = function(N) {
    var G = N.activeElement;
    if (G)
      return G.shadowRoot && G.shadowRoot.activeElement !== null ? h(G.shadowRoot) : G;
  }, E = function(N) {
    if (N !== !1 && N !== h(document)) {
      if (!N || !N.focus) {
        E(v());
        return;
      }
      N.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = N, BA(N) && N.select();
    }
  }, C = function(N) {
    var G = m("setReturnFocus", {
      params: [N]
    });
    return G || (G === !1 ? !1 : N);
  }, A = function(N) {
    var G = N.target, X = N.event, Q = N.isBackward, re = Q === void 0 ? !1 : Q;
    G = G || Ri(X), g();
    var se = null;
    if (a.tabbableGroups.length > 0) {
      var ue = u(G, X), me = ue >= 0 ? a.containerGroups[ue] : void 0;
      if (ue < 0)
        re ? se = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : se = a.tabbableGroups[0].firstTabbableNode;
      else if (re) {
        var he = a.tabbableGroups.findIndex(function(Et) {
          var Vt = Et.firstTabbableNode;
          return G === Vt;
        });
        if (he < 0 && (me.container === G || Ll(G, i.tabbableOptions) && !Qr(G, i.tabbableOptions) && !me.nextTabbableNode(G, !1)) && (he = ue), he >= 0) {
          var _e = he === 0 ? a.tabbableGroups.length - 1 : he - 1, De = a.tabbableGroups[_e];
          se = Sr(G) >= 0 ? De.lastTabbableNode : De.lastDomTabbableNode;
        } else Jo(X) || (se = me.nextTabbableNode(G, !1));
      } else {
        var Ae = a.tabbableGroups.findIndex(function(Et) {
          var Vt = Et.lastTabbableNode;
          return G === Vt;
        });
        if (Ae < 0 && (me.container === G || Ll(G, i.tabbableOptions) && !Qr(G, i.tabbableOptions) && !me.nextTabbableNode(G)) && (Ae = ue), Ae >= 0) {
          var ze = Ae === a.tabbableGroups.length - 1 ? 0 : Ae + 1, Qe = a.tabbableGroups[ze];
          se = Sr(G) >= 0 ? Qe.firstTabbableNode : Qe.firstDomTabbableNode;
        } else Jo(X) || (se = me.nextTabbableNode(G));
      }
    } else
      se = m("fallbackFocus");
    return se;
  }, R = function(N) {
    var G = Ri(N);
    if (!(u(G, N) >= 0)) {
      if (Fo(i.clickOutsideDeactivates, N)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Fo(i.allowOutsideClick, N) || N.preventDefault();
    }
  }, O = function(N) {
    var G = Ri(N), X = u(G, N) >= 0;
    if (X || G instanceof Document)
      X && (a.mostRecentlyFocusedNode = G);
    else {
      N.stopImmediatePropagation();
      var Q, re = !0;
      if (a.mostRecentlyFocusedNode)
        if (Sr(a.mostRecentlyFocusedNode) > 0) {
          var se = u(a.mostRecentlyFocusedNode), ue = a.containerGroups[se].tabbableNodes;
          if (ue.length > 0) {
            var me = ue.findIndex(function(he) {
              return he === a.mostRecentlyFocusedNode;
            });
            me >= 0 && (i.isKeyForward(a.recentNavEvent) ? me + 1 < ue.length && (Q = ue[me + 1], re = !1) : me - 1 >= 0 && (Q = ue[me - 1], re = !1));
          }
        } else
          a.containerGroups.some(function(he) {
            return he.tabbableNodes.some(function(_e) {
              return Sr(_e) > 0;
            });
          }) || (re = !1);
      else
        re = !1;
      re && (Q = A({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), E(Q || a.mostRecentlyFocusedNode || v());
    }
    a.recentNavEvent = void 0;
  }, F = function(N) {
    var G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = N;
    var X = A({
      event: N,
      isBackward: G
    });
    X && (Jo(N) && N.preventDefault(), E(X));
  }, L = function(N) {
    (i.isKeyForward(N) || i.isKeyBackward(N)) && F(N, i.isKeyBackward(N));
  }, D = function(N) {
    jA(N) && Fo(i.escapeDeactivates, N) !== !1 && (N.preventDefault(), s.deactivate());
  }, P = function(N) {
    var G = Ri(N);
    u(G, N) >= 0 || Fo(i.clickOutsideDeactivates, N) || Fo(i.allowOutsideClick, N) || (N.preventDefault(), N.stopImmediatePropagation());
  }, U = function() {
    if (a.active)
      return mm.activateTrap(o, s), a.delayInitialFocusTimer = i.delayInitialFocus ? fm(function() {
        E(v());
      }) : E(v()), r.addEventListener("focusin", O, !0), r.addEventListener("mousedown", R, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", R, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", P, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", L, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", D), s;
  }, q = function() {
    if (a.active)
      return r.removeEventListener("focusin", O, !0), r.removeEventListener("mousedown", R, !0), r.removeEventListener("touchstart", R, !0), r.removeEventListener("click", P, !0), r.removeEventListener("keydown", L, !0), r.removeEventListener("keydown", D), s;
  }, z = function(N) {
    var G = N.some(function(X) {
      var Q = Array.from(X.removedNodes);
      return Q.some(function(re) {
        return re === a.mostRecentlyFocusedNode;
      });
    });
    G && E(v());
  }, te = typeof window != "undefined" && "MutationObserver" in window ? new MutationObserver(z) : void 0, ee = function() {
    te && (te.disconnect(), a.active && !a.paused && a.containers.map(function(N) {
      te.observe(N, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(N) {
      if (a.active)
        return this;
      var G = l(N, "onActivate"), X = l(N, "onPostActivate"), Q = l(N, "checkCanFocusTrap");
      Q || g(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = r.activeElement, G == null || G();
      var re = function() {
        Q && g(), U(), ee(), X == null || X();
      };
      return Q ? (Q(a.containers.concat()).then(re, re), this) : (re(), this);
    },
    deactivate: function(N) {
      if (!a.active)
        return this;
      var G = hm({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, N);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, q(), a.active = !1, a.paused = !1, ee(), mm.deactivateTrap(o, s);
      var X = l(G, "onDeactivate"), Q = l(G, "onPostDeactivate"), re = l(G, "checkCanReturnFocus"), se = l(G, "returnFocus", "returnFocusOnDeactivate");
      X == null || X();
      var ue = function() {
        fm(function() {
          se && E(C(a.nodeFocusedBeforeActivation)), Q == null || Q();
        });
      };
      return se && re ? (re(C(a.nodeFocusedBeforeActivation)).then(ue, ue), this) : (ue(), this);
    },
    pause: function(N) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, N)) : this;
    },
    unpause: function(N) {
      return a.active ? (a.manuallyPaused = !1, o[o.length - 1] !== this ? this : this._setPausedState(!1, N)) : this;
    },
    updateContainerElements: function(N) {
      var G = [].concat(N).filter(Boolean);
      return a.containers = G.map(function(X) {
        return typeof X == "string" ? r.querySelector(X) : X;
      }), a.active && g(), ee(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(N, G) {
        if (a.paused === N)
          return this;
        if (a.paused = N, N) {
          var X = l(G, "onPause"), Q = l(G, "onPostPause");
          X == null || X(), q(), ee(), Q == null || Q();
        } else {
          var re = l(G, "onUnpause"), se = l(G, "onPostUnpause");
          re == null || re(), g(), U(), ee(), se == null || se();
        }
        return this;
      }
    }
  }), s.updateContainerElements(t), s;
};
function KA(e, t = {}) {
  let n;
  const g = t, { immediate: r } = g, o = Js(g, ["immediate"]), i = ho(!1), a = ho(!1), s = (h) => n && n.activate(h), l = (h) => n && n.deactivate(h), u = () => {
    n && (n.pause(), a.value = !0);
  }, m = () => {
    n && (n.unpause(), a.value = !1);
  }, v = Mn(() => {
    const h = Hc(e);
    return (Array.isArray(h) ? h : [h]).map((E) => {
      const C = Hc(E);
      return typeof C == "string" ? C : fA(C);
    }).filter(mA);
  });
  return vs(
    v,
    (h) => {
      h.length && (n = S4(h, ge(ae({}, o), {
        onActivate() {
          i.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          i.value = !1, t.onDeactivate && t.onDeactivate();
        }
      })), r && s());
    },
    { flush: "post" }
  ), hA(() => l()), {
    hasFocus: i,
    isPaused: a,
    activate: s,
    deactivate: l,
    pause: u,
    unpause: m
  };
}
const zA = {
  name: "MenuElement",
  props: {
    element: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    toggleFn: {
      type: Function,
      default: () => {
      }
    },
    isParent: {
      type: Boolean,
      default: !1
    },
    isSubParent: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: null
    },
    cursorPointer: {
      type: Boolean,
      default: !1
    }
  }
}, ZA = ["href"], xA = {
  class: "link-content",
  tabindex: "-1"
}, WA = ["href"], YA = {
  class: "link-content",
  tabindex: "-1"
}, XA = ["href", "target"], QA = {
  class: "link-content",
  tabindex: "-1"
}, JA = ["href", "target"], eI = {
  class: "link-content",
  tabindex: "-1"
};
function tI(e, t, n, r, o, i) {
  return d(), f("span", {
    class: "menu-element",
    style: Z(n.theme),
    onClick: t[5] || (t[5] = (a) => n.toggleFn(n.element.id, n.isParent))
  }, [
    n.element.type === "page" ? (d(), f("a", {
      key: 0,
      href: `${n.pathPrefix}/page/${n.element.slug}`,
      class: "link",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[0] || (t[0] = W(() => {
      }, ["stop"])),
      onKeydown: t[1] || (t[1] = K(W(() => {
      }, ["stop"]), ["enter"]))
    }, [
      c("span", xA, k(n.element.name), 1)
    ], 40, ZA)) : n.element.mailto ? (d(), f("a", {
      key: 1,
      href: `mailto:${n.element.email_address}`,
      class: "link",
      style: { color: "inherit", "text-decoration": "none" }
    }, [
      c("span", YA, k(n.element.name), 1)
    ], 8, WA)) : n.element.type === "link" && n.element.ipAddress ? (d(), f("a", {
      key: 2,
      href: `http://${n.element.url}`,
      target: n.element.opens_in_new_tab ? "_blank" : "",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[2] || (t[2] = W(() => {
      }, ["stop"]))
    }, [
      c("span", QA, k(n.element.name), 1)
    ], 8, XA)) : n.element.type === "link" && !n.element.ipAddress ? (d(), f("a", {
      key: 3,
      href: n.element.url,
      class: "link",
      target: n.element.opens_in_new_tab ? "_blank" : "",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[3] || (t[3] = W(() => {
      }, ["stop"])),
      onKeydown: t[4] || (t[4] = K(W(() => {
      }, ["stop"]), ["enter"]))
    }, [
      c("span", eI, k(n.element.name), 1)
    ], 40, JA)) : (d(), f("span", {
      key: 4,
      style: Z({
        color: "inherit",
        "text-decoration": "none",
        cursor: n.isSubParent || n.cursorPointer ? "pointer" : "initial"
      })
    }, k(n.element.name), 5))
  ], 4);
}
const nI = /* @__PURE__ */ B(zA, [["render", tI], ["__scopeId", "data-v-90cb0a6b"]]), $s = {
  components: {
    MenuElement: nI
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: Boolean
  },
  data() {
    return {
      activeIds: []
    };
  },
  computed: {
    menuIconStyle() {
      return {
        "--icon-color": this.theme.icon_color.hex
      };
    },
    translations() {
      return this.theme.translations;
    }
  },
  methods: {
    getLink(e) {
      return e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    },
    toggleOpen(e, t) {
      const n = this.activeIds.indexOf(e);
      n > -1 ? this.activeIds.splice(n, 1) : (t && (this.activeIds = []), this.activeIds.length > 1 && this.activeIds.splice(1, 1), this.activeIds.push(e));
    },
    clickStaticLink(e) {
      this.$route.fullPath !== e && this.$router.push({ path: `${e}` });
    },
    clickGeneratedLink(e, t) {
      e.type === "page" && this.$route.fullPath !== `/page/${e.slug}` ? this.$router.push({ path: `/page/${e.slug}` }) : e.type === "link" ? document.getElementById(`${e.slug || e.id}-${e.type}`).getElementsByTagName("a")[0].click() : e.children.length && this.toggleOpen(e.id, t);
    },
    getUrl(e) {
      return !e || e.type === "header" ? "" : e.type === "page" ? `${this.content.pathPrefix}/page/${e.slug}` : e.mailto && e.email_address ? `mailto:${e.email_address}` : e.ipAddress ? `http://${e.url}` : e.url;
    },
    closeMenu() {
      this.$emit("close-menu");
    }
  }
}, M4 = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    currentDomain: {
      type: String,
      default: null
    },
    showSignInButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    }
  },
  components: {
    Close: mi
  },
  mixins: [Tt],
  emits: ["close-menu", "toggle-search"],
  data() {
    return {
      displayMoreButton: !0,
      isMoreDropdownVisible: !1,
      isTemporarilyHideMenu: !1,
      visibleItems: [],
      underLappedItems: [],
      activeItem: null,
      parentWidth: 0,
      totalElementsWidth: 0,
      timer: null,
      moreMenuTimeout: null,
      hideMenuTimeOut: null,
      menuTimeout: null,
      debounceParentWidth: () => {
      },
      openMoreMenuDropDown: null,
      loadingMenu: !0,
      preventMouseLeaveClose: !1
    };
  },
  computed: {
    colors() {
      var e;
      return {
        "--text-color": this.theme.text_color ? this.theme.text_color.hex : "#FFFFFF",
        "--bg-color": this.theme.bg_color ? this.theme.bg_color.hex : "#014990",
        "--more-text-color": this.theme.more_text_color ? this.theme.more_text_color.hex : "FFFFFF",
        "--more-bg-color": this.theme.more_bg_color ? this.theme.more_bg_color.hex : "#014990",
        "--dropdown-text-color": this.theme.dropdown_text_color ? this.theme.dropdown_text_color.hex : "#333",
        "--dropdown-bg-color": this.theme.dropdown_bg_color ? this.theme.dropdown_bg_color.hex : "#FFFFFF",
        "--explore-menu-text-color": this.theme.explore_menu_text_color ? this.theme.explore_menu_text_color.hex : "#333333",
        "--explore-menu-bg-color": this.theme.explore_menu_bg_color ? this.theme.explore_menu_bg_color.hex : "#FFFFFF",
        "--schools-menu-text-color": this.theme.schools_menu_text_color ? this.theme.schools_menu_text_color.hex : "#333333",
        "--schools-menu-bg-color": this.theme.schools_menu_bg_color ? this.theme.schools_menu_bg_color.hex : "#FFFFFF",
        "--icon-bg-color": this.theme.icon_bg_color ? this.theme.icon_bg_color.hex : "#014990",
        "--icon-text-color": this.theme.icon_bg_color ? this.theme.icon_text_color.hex : "#014990",
        "--icon-color": this.theme.icon_color ? this.theme.icon_color.hex : "#014990",
        "--nav-color": this.theme.navigation_color ? this.theme.navigation_color.hex : "#014990",
        "--nav-icon-color": this.theme.navigation_icon_color ? this.theme.navigation_icon_color.hex : "#FFFFFF",
        "--nav-icon-bg-color": this.theme.navigation_icon_bg_color ? (e = this.theme.navigation_icon_bg_color) == null ? void 0 : e.hex : "#014990",
        "--utility-link-color": this.theme.utility_link_color ? this.theme.utility_link_color.hex : "#000000",
        "--utility-bg-color": this.theme.utility_bg_color ? this.theme.utility_bg_color.hex : "#FFFFFF"
      };
    },
    mobileMenuItems() {
      return [
        {
          id: "explore-header",
          name: "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    barNavOptions() {
      return ge(ae(ae({}, this.theme), this.content.menuOptions), {
        translations: this.theme.translations || this.content.menuOptions.translations
      });
    },
    signInText() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.translations) == null ? void 0 : t.sign_in_button_title) || "Sign in";
    }
  },
  watch: {
    parentWidth() {
      this.displayMoreButton = !0, this.debounceParentWidth.flush(), this.$nextTick(this.calculateUnderlappedItems.bind(this));
    },
    isMoreDropdownVisible() {
      this.isMoreDropdownVisible && this.handleDrawerToggle();
    }
  },
  mounted() {
    this.loadingMenu = !1;
    let e = 0;
    if (this.isMobile) return;
    const t = this.$refs["bar-nav-item-wrapper"];
    Object.entries(t.childNodes).forEach((n) => {
      var r;
      if (this.theme.version === "M5") {
        const i = Array.from(n[1].childNodes).find((a) => a.className === "bar-menu-item");
        i && (e += i.clientWidth);
      } else ((r = n[1]) == null ? void 0 : r.className) === "m4--menu-item" && (e += n[1].clientWidth);
    }), this.totalElementsWidth = e, this.updateParentWidth(), this.debounceParentWidth = mo(this.updateParentWidth.bind(this), 30), window.addEventListener("resize", this.debounceParentWidth), window.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debounceParentWidth), window.removeEventListener("keydown", this.onKeydown);
  },
  created() {
    this.visibleItems = this.content.sitemapMenuItems;
  },
  methods: {
    canTriggerCloseFirstItem(e, t, n) {
      const r = (i) => n === "exploreButton" || n === "schoolsButton" || i.type !== "header" && i.children.length === 0 || i.type !== "header" && i.children.length > 0 && !t || i.type === "header" && t && i.children.length > 0, o = this.activeItem.children.findIndex(r);
      if (o !== -1) {
        const i = this.activeItem.children[o];
        return e === i.id;
      }
      return !1;
    },
    canTriggerCloseLastItem(e, t, n) {
      const r = (u) => n === "exploreButton" || n === "schoolsButton" || u.type !== "header" && u.children.length === 0 || !!u.children.length, o = this.activeItem.children.findLastIndex(r), i = this.activeItem.children[o];
      if (n === "exploreButton" || n === "schoolsButton")
        return e === i.id;
      const a = e === i.id && !i.children.length, s = e === i.id && t && !i.childrenVisible, l = e === i.id && t && (i.children.length === 0 || i.children.findLastIndex(r) === -1);
      if (a || s || l)
        return e === i.id;
      if (i.childrenVisible && i.children.findLastIndex(r) !== -1) {
        const u = i.children.findLastIndex(r), m = i.children[u].id;
        return e == m;
      }
    },
    toggleParentCollapsible({ itemId: e }) {
      const t = this.activeItem.children.findIndex((r) => r.id === e);
      this.activeItem.children.filter((r) => r.id !== e).forEach(
        (r) => this.activeItem.children[this.activeItem.children.indexOf(r)].childrenVisible = !1
      ), this.activeItem.children[t].childrenVisible = !this.activeItem.children[t].childrenVisible;
    },
    nextTabAction({ itemId: e, isIconButton: t, isBackwardsTab: n }, r) {
      const o = this.canTriggerCloseFirstItem(e, t, r), i = this.canTriggerCloseLastItem(e, t, r);
      if (o && n) {
        this.handleClose();
        return;
      }
      if (i && !n) {
        this.handleClose();
        return;
      }
    },
    onKeydown(e) {
      e.key === "Escape" && !Br(this.activeItem) && this.handleClose();
    },
    temporalHide() {
      this.isMoreDropdownVisible = !1, this.isTemporarilyHideMenu = !0;
    },
    handleDropdownMenuOpen(e) {
      clearTimeout(this.openMoreMenuDropDown), this.openMoreMenuDropDown = setTimeout(() => {
        this.onMenuItemClick(e);
      }, 300);
    },
    preventClose(e) {
      this.preventMouseLeaveClose = !1, clearTimeout(this.moreMenuTimeout), clearTimeout(this.menuTimeout), clearTimeout(this.hideMenuTimeOut), clearTimeout(this.openMoreMenuDropDown), this.onMenuItemClick(e, !0);
    },
    preventCloseDrawer() {
      this.preventMouseLeaveClose = !0;
    },
    onMenuItemClick(e, t) {
      if (t && this.hideMoreMenu(), !e) {
        this.hideDrawer();
        return;
      }
      this.$emit("close-menu"), this.activeItem = e;
    },
    focusSubMenu(e) {
      this.activeItem = e;
      const n = this.$refs[`drawer-${e.id}`][0].$refs["drawer-wrapper"];
      n.tabIndex = 0, n.focus(), this.hideMoreMenu();
    },
    handleDrawerToggle(e) {
      if (e) {
        if (e.id === "schoolsbutton" && this.content.hasCustomSchoolsMenu && this.customSchoolsMenuVisible === !1 ? this.showItem(e) : this.customSchoolsMenuVisible = !1, !this.activeItem) {
          this.hideDrawer(), this.activeItem = e;
          return;
        }
        if (!e || !e.children || !e.children.length) {
          this.hideDrawer();
          return;
        }
        e.id === this.activeItem.id ? this.hideDrawer() : this.activeItem = e;
      }
    },
    handleMoreMenuToggle(e) {
      clearTimeout(this.moreMenuTimeout), clearTimeout(this.hideMenuTimeOut), clearTimeout(this.menuTimeout), this.moreMenuTimeout = setTimeout(() => {
        this.$emit("close-menu"), e ? this.isMoreDropdownVisible = e : this.isMoreDropdownVisible = !this.isMoreDropdownVisible;
      }, 220);
    },
    handleClose(e) {
      this.hideDrawer(e), this.hideMoreMenu();
    },
    hideMoreMenu() {
      this.isMoreDropdownVisible = !1;
    },
    showDrawer(e) {
      var t, n, r;
      return ((t = this.activeItem) == null ? void 0 : t.id) === e.id && ((r = (n = this.activeItem) == null ? void 0 : n.children) == null ? void 0 : r.length) > 0;
    },
    hideDrawer(e) {
      (!this.preventMouseLeaveClose || e !== "mouseleave") && (this.activeItem = null);
    },
    updateParentWidth() {
      this.parentWidth = this.getWrapperWidth();
    },
    getWrapperWidth() {
      const e = this.theme.version === "M5" ? this.$refs["bar-nav-menu-bar"] : this.$refs["m4-menu--bar"], t = window.getComputedStyle(e, null).getPropertyValue("padding-left"), n = window.getComputedStyle(e, null).getPropertyValue("padding-right");
      return e.clientWidth - parseInt(t, 10) - parseInt(n, 10);
    },
    calculateUnderlappedItems() {
      var o;
      let e = 0;
      const t = {}, n = this.$refs["bar-nav-item-wrapper"];
      let r = this.getWrapperWidth();
      if (this.theme.version === "M5") {
        this.$refs["bar-end-options"];
        const i = ((o = this.$refs["bar-end-options"]) == null ? void 0 : o.clientWidth) || 0;
        r -= i;
      }
      this.visibleItems = this.content.sitemapMenuItems, clearTimeout(this.timer), this.timer = setTimeout(() => {
        this.totalElementsWidth > r ? (this.displayMoreButton = !0, r -= this.moreBtnWidth) : this.displayMoreButton = !1, Object.entries(n.childNodes).forEach((s) => {
          if (this.theme.version === "M5") {
            const u = Array.from(s[1].childNodes).find((m) => m.className === "bar-menu-item");
            u && (e += u.clientWidth, e > r && (t[u.id] = u));
          } else s[1].className === "m4--menu-item" && (e += s[1].clientWidth, e > r && (t[s[1].id] = s[1]));
        });
        const i = Object.entries(t).map(([s, l]) => this.content.sitemapMenuItems.find((u) => +u.id == +s)).sort((s, l) => s.position - l.position), a = this.content.sitemapMenuItems.filter((s) => !i.find((l) => s && l && s.id === l.id)).sort((s, l) => s.position - l.position);
        this.underLappedItems = i, this.visibleItems = a;
      }, 50);
    },
    navigate(e) {
      let t;
      if (!e)
        return null;
      switch (e.type) {
        case "page":
          t = `${this.content.pathPrefix}/page/${e.slug}`;
          break;
        case "link":
          e.mailto && e.email_address ? t = `mailto:${e.email_address}` : t = e.url;
          break;
        case "explore":
          t = this.content.pathPrefix + e.slug;
          break;
        default:
          return null;
      }
      return e.opens_in_new_tab ? window.open(t) : window.location.href = t, null;
    },
    showItem(e) {
      this.customSchoolsMenuVisible = !1, e.id === "schoolsbutton" && this.content.hasCustomSchoolsMenu && (this.customSchoolsMenuVisible = !0), clearTimeout(this.menuTimeout), this.menuTimeout = setTimeout(() => {
        this.onMenuItemClick(e, !0);
      }, 220);
    },
    mouseLeaveMenu() {
      clearTimeout(this.menuTimeout), clearTimeout(this.moreMenuTimeout), clearTimeout(this.hideMenuTimeOut), this.hideMenuTimeOut = setTimeout(() => {
        this.content.hasCustomSchoolsMenu && (this.customSchoolsMenuVisible = !1), this.handleClose("mouseleave");
      }, 600);
    },
    mouseEnterMenu() {
      this.hideMenuTimeOut && clearTimeout(this.hideMenuTimeOut);
    }
  }
}, rI = {
  name: "MenuItemType",
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    moreMenuTitle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    }
  },
  emits: ["handle-header-click"],
  computed: {
    href() {
      if (!this.item)
        return null;
      switch (this.item.type) {
        case "page":
          return `${this.pathPrefix}/page/${this.item.slug}`;
        case "link":
          return this.getLinkHref;
        case "explore":
          return this.getExploreHref;
        case "header":
          return null;
        default:
          return null;
      }
    },
    iconVisible() {
      return (this.item.icon || this.item.icon_cms) && this.item.id !== "explore-button" && this.item.id !== "schoolsbutton";
    },
    noChildren() {
      var e;
      return ((e = this.item.children) == null ? void 0 : e.length) === 0;
    },
    getExploreHref() {
      var e;
      return (e = this.item.slug) != null && e.includes("http") ? this.item.slug : this.pathPrefix + this.item.slug;
    },
    getLinkHref() {
      return this.item ? this.item.mailto && this.item.email_address ? `mailto:${this.item.email_address}` : this.item.ipAddress ? `http://${this.item.url}` : this.item.url : null;
    },
    colors() {
      return {
        "--icon-fill-color": this.fillColor
      };
    }
  }
}, oI = { class: "m4--menu-item-focusable" }, iI = ["innerHTML"], sI = ["href", "target"], aI = { key: 0 };
function lI(e, t, n, r, o, i) {
  return d(), f("span", oI, [
    i.iconVisible ? (d(), f("div", {
      key: 0,
      class: _(["item-icon", { "global-icon": n.item.cms_icon_id }]),
      style: Z(i.colors),
      innerHTML: n.item.cms_icon_id ? n.item.icon_cms : n.item.icon
    }, null, 14, iI)) : i.href ? (d(), f("a", {
      key: 1,
      href: i.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "m4--menu-item-link"
    }, k(n.item.name), 9, sI)) : (d(), f(J, { key: 2 }, [
      n.moreMenuTitle ? (d(), f("span", aI, k(n.moreMenuTitle), 1)) : (d(), f("span", {
        key: 1,
        class: _(["item-type-header", { "no-children": i.noChildren }]),
        onClick: t[0] || (t[0] = (a) => e.$emit("handle-header-click"))
      }, k(n.item.translatedTitle || n.item.name), 3))
    ], 64))
  ]);
}
const A4 = /* @__PURE__ */ B(rI, [["render", lI], ["__scopeId", "data-v-09de12df"]]), uI = {
  name: "M4MainItem",
  components: { MenuItemType: A4, DropdownArrowIcon: To },
  props: {
    item: {
      type: Object,
      default: void 0
    },
    forceShow: Boolean,
    moreMenuItem: {
      type: String,
      default: null
    },
    moreMenuVisible: Boolean,
    isMoreMenuItem: Boolean,
    themeStyle: {
      type: String,
      default: null
    },
    colors: {
      type: Object,
      default: null
    },
    activeId: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    firstItemId: {
      type: Number,
      default: 0
    },
    lastItemId: {
      type: Number,
      default: 0
    }
  },
  emits: ["toggle-more-menu", "close", "toggle-drawer", "navigate", "mouseover", "focus-sub-menu"],
  computed: {
    isActive() {
      var e;
      return this.moreMenuItem ? this.moreMenuVisible : ((e = this.item) == null ? void 0 : e.id) === this.activeId;
    },
    iconClass() {
      return this.isActive ? "open" : void 0;
    },
    iconColor() {
      if (this.colors)
        return this.isMoreMenuItem ? this.colors["--more-text-color"] : this.colors["--text-color"];
    },
    itemId() {
      return this.moreMenuItem ? "more-menu-item" : this.item ? this.item.id : "";
    },
    hasChildren() {
      var e, t;
      return !!((t = (e = this.item) == null ? void 0 : e.children) != null && t.length);
    },
    hasFocusableChildren() {
      var t, n, r;
      const e = (o) => {
        var i;
        return [o, ...((i = o.children) == null ? void 0 : i.map((a) => e(a))) || []].flat();
      };
      return (r = (n = (t = this.item.children) == null ? void 0 : t.map((o) => e(o))) == null ? void 0 : n.flat()) == null ? void 0 : r.filter((o) => o.type !== "header").length;
    },
    isHeader() {
      var e;
      return ((e = this.item) == null ? void 0 : e.type) === "header";
    },
    hasSlug() {
      var e;
      return (e = this.item) == null ? void 0 : e.slug;
    },
    ariaId() {
      return this.moreMenuItem ? "menu-button-more" : `menu-button-${this.item ? this.item.id : ""}`;
    },
    ariaHasPopup() {
      return this.moreMenuItem ? "true" : this.hasChildren ? "dialog" : "false";
    },
    ariaControls() {
      return this.moreMenuItem ? "more-menu-dropdown" : this.hasChildren ? `drawer-${this.item ? this.item.id : ""}` : void 0;
    },
    ariaExpanded() {
      if (this.moreMenuItem)
        return this.moreMenuVisible ? "true" : "false";
      if (this.hasChildren)
        return this.isActive ? "true" : "false";
    },
    ariaLabel() {
      if (!this.isHeader && this.hasChildren)
        return `Toggle ${this.item.name} Submenu`;
    },
    showTransition() {
      var e, t;
      return ((t = (e = this.item) == null ? void 0 : e.children) == null ? void 0 : t.length) > 0 && !this.isMoreMenuItem && !this.moreMenuItem && this.isActive;
    }
  },
  methods: {
    handleEnterEvent(e) {
      if (this.moreMenuItem) {
        this.$emit("toggle-more-menu", !this.moreMenuVisible);
        return;
      }
      if (!this.item) {
        this.$emit("close");
        return;
      }
      if (this.isHeader || e === !0) {
        this.$emit("toggle-drawer", this.item);
        return;
      }
      this.$emit("navigate", this.item);
    },
    /**  handling this behavior here because M4MainItem is shared.
     M4MainItem is found in the top level of the Menu Items in the bar
     and within the More Dropdown**/
    handleNextTab(e, t) {
      var s, l;
      const n = e.shiftKey, r = this.isActive, o = this.activeId && r, i = ((s = this.item) == null ? void 0 : s.id) === this.firstItemId, a = ((l = this.item) == null ? void 0 : l.id) === this.lastItemId;
      if (n) {
        if (this.isMoreMenuItem && i && !t) {
          this.$emit("close");
          return;
        }
        if (!this.isMoreMenuItem && r) {
          this.$emit("close");
          return;
        }
        if (a && t && this.hasChildren && o) {
          this.$emit("close");
          return;
        }
      } else {
        if (o && (t && this.hasFocusableChildren || this.isHeader)) {
          this.$emit("focus-sub-menu", this.item);
          return;
        }
        if (this.moreMenuItem === "More") return;
        this.hasFocusableChildren === 0 && !this.isMoreMenuItem && r && this.$emit("close"), a && (!this.hasChildren || t && this.hasChildren && !o) && this.$emit("close");
      }
    }
  }
}, dI = ["id"], cI = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-label"], hI = ["id"], mI = ["aria-expanded", "aria-label", "aria-haspopup", "aria-controls"], fI = {
  class: "m4--menu-item-focusable",
  tabindex: "-1"
}, pI = { class: "sr-only" }, gI = { class: "sr-only" }, vI = {
  key: 0,
  class: "m4--menu-item-active-line"
};
function bI(e, t, n, r, o, i) {
  const a = V("MenuItemType"), s = V("DropdownArrowIcon");
  return n.forceShow || n.moreMenuItem || n.item ? (d(), f("div", {
    key: 0,
    id: i.itemId,
    ref: i.itemId,
    class: _(["m4--menu-item", {
      "m4--menu-dropdown-item": n.isMoreMenuItem,
      "m4--menu-item-active": !n.isMoreMenuItem && i.isActive
    }]),
    onMouseover: t[13] || (t[13] = W((l) => e.$emit("mouseover", n.item), ["stop", "prevent"])),
    onClick: t[14] || (t[14] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"])),
    onTouchstart: t[15] || (t[15] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
  }, [
    n.item && n.item.type === "header" && i.hasChildren || n.moreMenuItem === "More" ? (d(), f("button", {
      key: 0,
      id: i.ariaId,
      "aria-controls": i.ariaControls,
      "aria-expanded": i.ariaExpanded,
      "aria-haspopup": i.ariaHasPopup,
      class: _(["m4--menu-item-text", {
        "m4--menu-dropdown-item-active": i.isActive,
        [n.themeStyle]: !!n.themeStyle
      }]),
      "aria-label": n.moreMenuItem === "More" ? "Show submenu for More" : `Show submenu for ${n.item && n.item.name}`,
      onKeydown: [
        t[0] || (t[0] = K(W((l) => i.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"])),
        t[1] || (t[1] = K((l) => i.handleNextTab(l, !0), ["tab"]))
      ],
      onTouchstart: t[2] || (t[2] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
    }, [
      j(a, {
        "path-prefix": n.pathPrefix,
        "more-menu-title": n.moreMenuItem,
        item: n.item
      }, null, 8, ["path-prefix", "more-menu-title", "item"])
    ], 42, cI)) : (d(), f("div", {
      key: 1,
      id: i.ariaId,
      class: _(["m4--menu-item-text", {
        "m4--menu-dropdown-item-active": i.isActive,
        [n.themeStyle]: !!n.themeStyle
      }])
    }, [
      j(a, {
        "path-prefix": n.pathPrefix,
        "more-menu-title": n.moreMenuItem,
        item: n.item,
        onKeydown: t[3] || (t[3] = K((l) => i.handleNextTab(l), ["tab"]))
      }, null, 8, ["path-prefix", "more-menu-title", "item"])
    ], 10, hI)),
    i.isHeader ? T("", !0) : (d(), f(J, { key: 2 }, [
      i.hasChildren ? (d(), f("button", {
        key: 0,
        class: "m4--menu-item-icon",
        "aria-expanded": i.ariaExpanded,
        "aria-label": i.ariaLabel,
        "aria-haspopup": i.ariaHasPopup,
        "aria-controls": i.ariaControls,
        onKeydown: [
          t[4] || (t[4] = K(W((l) => i.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"])),
          t[5] || (t[5] = K((l) => i.handleNextTab(l, !0), ["tab"]))
        ],
        onTouchstart: t[6] || (t[6] = W((l) => i.handleEnterEvent(!0), ["exact", "stop", "prevent"])),
        onClick: t[7] || (t[7] = W((l) => i.handleEnterEvent(!0), ["stop", "prevent"]))
      }, [
        c("span", fI, [
          j(s, {
            "dropdown-class": i.iconClass,
            "fill-color": i.iconColor
          }, null, 8, ["dropdown-class", "fill-color"]),
          c("span", pI, " Show submenu for " + k(n.item && n.item.name), 1)
        ])
      ], 40, mI)) : T("", !0)
    ], 64)),
    i.isHeader || n.moreMenuItem ? (d(), f(J, { key: 3 }, [
      n.moreMenuItem || i.hasChildren ? (d(), f("span", {
        key: 0,
        class: "m4--menu-item-icon",
        onMouseover: t[8] || (t[8] = W(() => {
        }, ["stop", "prevent"])),
        onTouchstart: t[9] || (t[9] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"])),
        onKeydown: [
          t[10] || (t[10] = K((l) => i.handleNextTab(l, !0), ["tab"])),
          t[12] || (t[12] = K(W((l) => i.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"]))
        ],
        onClick: t[11] || (t[11] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
      }, [
        j(s, {
          "dropdown-class": i.iconClass,
          "fill-color": i.iconColor
        }, null, 8, ["dropdown-class", "fill-color"]),
        c("span", gI, " Show submenu for " + k(n.item && n.item.name), 1)
      ], 32)) : T("", !0)
    ], 64)) : T("", !0),
    j(Le, { name: "slide-fade-up" }, {
      default: S(() => [
        i.showTransition ? (d(), f("hr", vI)) : T("", !0)
      ]),
      _: 1
    })
  ], 42, dI)) : T("", !0);
}
const I4 = /* @__PURE__ */ B(uI, [["render", bI], ["__scopeId", "data-v-b1ec7e1d"]]), yI = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, _I = ["fill"];
function CI(e, t, n, r, o, i) {
  return d(), f("svg", {
    class: "plus",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, t[0] || (t[0] = [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.85721 0H7.14293V7.14283H0V7.85714H7.14293V15H7.85721V7.85714H15V7.14283H7.85721V0Z"
    }, null, -1)
  ]), 8, _I);
}
const L4 = /* @__PURE__ */ B(yI, [["render", CI]]), wI = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, TI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, kI = ["fill"];
function EI(e, t, n, r, o, i) {
  return d(), f("svg", TI, [
    c("path", {
      fill: n.fillColor,
      d: "M2 7.5V8.5H14V7.5H2Z"
    }, null, 8, kI)
  ]);
}
const D4 = /* @__PURE__ */ B(wI, [["render", EI]]), SI = {
  name: "ImageElement",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    href() {
      return this.item ? this.item.url : null;
    }
  }
}, MI = {
  class: "m4--menu-item-focusable",
  tabindex: "-1"
}, AI = ["src", "alt"];
function II(e, t, n, r, o, i) {
  return d(), f("span", MI, [
    (d(), I(Y(i.href ? "a" : "div"), {
      href: i.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "m4--menu-item-link",
      tabindex: "-1"
    }, {
      default: S(() => [
        c("img", {
          src: n.item.imgSrc,
          alt: n.item.altText
        }, null, 8, AI)
      ]),
      _: 1
    }, 8, ["href", "target"]))
  ]);
}
const LI = /* @__PURE__ */ B(SI, [["render", II], ["__scopeId", "data-v-a0cf2cf9"]]), DI = {
  name: "M4DrawerElement",
  components: { MenuItemType: A4, ImageElement: LI, MenuPlusIcon: L4, MenuMinusIcon: D4, DropdownArrowIcon: To },
  props: {
    elemData: {
      type: Object,
      default: null
    },
    themeStyle: {
      type: String,
      default: ""
    },
    isMobile: Boolean,
    colors: {
      type: Object,
      default: void 0
    },
    activeParent: {
      type: [String, Number],
      default: null
    },
    activeChild: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    nestLevel: {
      type: Number,
      default: 0
    },
    newMobileHeaderElement: Boolean
  },
  emits: ["navigate", "toggle-child", "toggle-parent", "next-tab"],
  computed: {
    iconColor() {
      if (this.colors)
        return this.isMobile && this.newMobileHeaderElement ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"];
    },
    hasChildren() {
      var e;
      return !!((e = this.elemData) != null && e.children.length);
    },
    showChildren() {
      return Number.isNaN(+this.activeParent) ? this.activeParent === this.elemData.id : +this.activeParent == +this.elemData.id;
    },
    isChild() {
      return this.nestLevel >= 1;
    },
    isSubChild() {
      return this.nestLevel >= 2;
    },
    ariaParentId() {
      return `menu-button-${this.elemData.id}`;
    },
    ariaExpanded() {
      if (this.hasChildren)
        return this.showChildren ? "true" : "false";
    },
    ariaControls() {
      if (this.hasChildren)
        return this.ariaChildId;
    },
    ariaChildId() {
      return `${this.elemData.id}-collapsible`;
    },
    ariaHasPopup() {
      return this.hasChildren ? "true" : "false";
    }
  },
  methods: {
    toggleParentCollapsible() {
      this.$emit("toggle-parent", this.elemData);
    },
    handleEnterEvent() {
      this.$emit("navigate", this.elemData);
    },
    handleNextTab(e, t, n) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    }
  }
}, $I = ["id"], OI = ["id"], PI = ["aria-expanded", "aria-controls", "aria-haspopup"], NI = {
  class: "m4--drawer-element-focusable",
  tabindex: "-1"
}, HI = {
  key: 3,
  class: "sr-only"
}, FI = ["id", "aria-labelledby"];
function RI(e, t, n, r, o, i) {
  const a = V("ImageElement"), s = V("MenuItemType"), l = V("MenuPlusIcon"), u = V("MenuMinusIcon"), m = V("DropdownArrowIcon"), v = V("M4DrawerElement", !0);
  return d(), f("div", {
    role: "menuitem",
    class: _(["m4--drawer-element", {
      "mobile-element": n.isMobile,
      "new-mobile-header": n.newMobileHeaderElement,
      "child-element": i.isChild,
      "has-children": i.hasChildren,
      "has-icon": n.elemData.icon || n.elemData.icon_cms,
      "sub-child": i.isSubChild,
      "image-element": n.elemData.type === "image"
    }]),
    style: Z(n.colors)
  }, [
    c("div", {
      id: n.elemData.id,
      class: "m4--drawer-element-title",
      onClick: t[4] || (t[4] = (...g) => i.toggleParentCollapsible && i.toggleParentCollapsible(...g))
    }, [
      c("div", {
        id: i.ariaParentId,
        class: _(["m4--drawer-element-title-text", n.themeStyle]),
        onClick: t[1] || (t[1] = W(() => {
        }, ["stop"]))
      }, [
        n.elemData.type === "image" ? (d(), I(a, {
          key: 0,
          item: n.elemData
        }, null, 8, ["item"])) : (d(), I(s, {
          key: 1,
          "path-prefix": n.pathPrefix,
          item: n.elemData,
          "fill-color": i.iconColor,
          onHandleHeaderClick: i.toggleParentCollapsible,
          onKeydown: [
            t[0] || (t[0] = K((g) => i.handleNextTab(n.elemData.id, !1, g.shiftKey), ["tab"])),
            K(i.handleEnterEvent, ["enter"])
          ]
        }, null, 8, ["path-prefix", "item", "fill-color", "onHandleHeaderClick", "onKeydown"]))
      ], 10, OI),
      n.elemData.children.length ? (d(), f(J, { key: 0 }, [
        n.elemData.children.length ? (d(), f("button", {
          key: 0,
          "aria-expanded": i.ariaExpanded,
          "aria-controls": i.ariaControls,
          "aria-haspopup": i.ariaHasPopup,
          class: "m4--drawer-element-title-icon",
          onClick: t[2] || (t[2] = W((...g) => i.toggleParentCollapsible && i.toggleParentCollapsible(...g), ["stop", "prevent"])),
          onKeydown: t[3] || (t[3] = K((g) => i.handleNextTab(n.elemData.id, !0, g.shiftKey), ["tab"]))
        }, [
          c("span", NI, [
            n.isMobile && !i.showChildren ? (d(), I(l, {
              key: 0,
              "fill-color": i.iconColor
            }, null, 8, ["fill-color"])) : n.isMobile && i.showChildren ? (d(), I(u, {
              key: 1,
              "fill-color": i.iconColor
            }, null, 8, ["fill-color"])) : T("", !0),
            n.isMobile ? T("", !0) : (d(), I(m, {
              key: 2,
              "fill-color": i.iconColor,
              "dropdown-class": i.showChildren ? "open" : "close"
            }, null, 8, ["fill-color", "dropdown-class"])),
            n.elemData && n.elemData.name ? (d(), f("span", HI, " Show submenu for " + k(n.elemData.name), 1)) : T("", !0)
          ])
        ], 40, PI)) : T("", !0)
      ], 64)) : T("", !0)
    ], 8, $I),
    j(Le, { name: "collapse-in" }, {
      default: S(() => [
        i.hasChildren ? we((d(), f("div", {
          key: 0,
          id: i.ariaChildId,
          "aria-labelledby": i.ariaParentId,
          class: _(["m4--drawer-children", { "show-children": i.showChildren }])
        }, [
          (d(!0), f(J, null, ne(n.elemData.children, (g) => (d(), I(v, {
            key: g.id,
            "elem-data": g,
            "is-mobile": n.isMobile,
            "theme-style": n.themeStyle,
            "active-parent": n.activeChild,
            "path-prefix": n.pathPrefix,
            colors: n.colors,
            "new-mobile-header-element": n.newMobileHeaderElement,
            "nest-level": n.nestLevel + 1,
            onToggleParent: t[5] || (t[5] = (h) => e.$emit("toggle-child", h)),
            onNextTab: (h) => i.handleNextTab(g.id, !1, h.isBackwardsTab),
            onNavigate: t[6] || (t[6] = (h) => e.$emit("navigate", h))
          }, null, 8, ["elem-data", "is-mobile", "theme-style", "active-parent", "path-prefix", "colors", "new-mobile-header-element", "nest-level", "onNextTab"]))), 128))
        ], 10, FI)), [
          [Un, i.showChildren]
        ]) : T("", !0)
      ]),
      _: 1
    })
  ], 6);
}
const $4 = /* @__PURE__ */ B(DI, [["render", RI], ["__scopeId", "data-v-4331a2f6"]]), VI = {
  name: "M4MobileMenu",
  components: { M4DrawerElement: $4 },
  props: {
    isVisible: {
      type: Boolean,
      default: !1
    },
    menuItems: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Object,
      default: void 0
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  emits: ["navigate", "close-menu"],
  data() {
    return {
      activeParent: null,
      activeChild: null,
      localItems: []
    };
  },
  computed: {
    styles() {
      return ae({}, this.colors);
    }
  },
  beforeUpdate() {
    this.isVisible || (this.activeParent = null, this.activeChild = null);
  },
  mounted() {
    this.localItems = this.menuItems.filter((e) => e.name === "Explore" ? e.children && e.children.length >= 1 : !0), this.$parent.$parent.$refs.schoolsbutton && this.$parent.$parent.$refs.schoolsbutton.$el.addEventListener("focus", this.$emit("close-menu")), this.$parent.$parent.$refs.schoolsbuttonMobile && this.$parent.$parent.$refs.schoolsbuttonMobile.$el.addEventListener("focus", this.$emit("close-menu"));
  },
  beforeUnmount() {
    this.$parent.$parent.$refs.schoolsbutton && this.$parent.$parent.$refs.schoolsbutton.$el.removeEventListener("focus", this.$emit("close-menu")), this.$parent.$parent.$refs.schoolsbuttonMobile && this.$parent.$parent.$refs.schoolsbuttonMobile.$el.removeEventListener("focus", this.$emit("close-menu"));
  },
  methods: {
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null;
        return;
      }
      this.activeParent = e.id;
    },
    handleToggleChild(e) {
      if (!e) {
        this.activeChild = null;
        return;
      }
      if (e.id === this.activeChild) {
        this.activeChild = null;
        return;
      }
      this.activeChild = e.id;
    },
    handleNavigate(e) {
      this.$emit("navigate", e);
    }
  }
};
function BI(e, t, n, r, o, i) {
  const a = V("M4DrawerElement");
  return d(), I(Le, { name: "slide-fade-up" }, {
    default: S(() => [
      we(c("div", {
        style: Z(i.styles),
        class: "m4-menu--mobile-wrapper"
      }, [
        (d(!0), f(J, null, ne(o.localItems, (s) => (d(), I(a, {
          ref_for: !0,
          ref: "drawerElement",
          key: `${s.name}-${s.id}`,
          "elem-data": s,
          "is-mobile": !0,
          colors: n.colors,
          "active-parent": o.activeParent,
          "active-child": o.activeChild,
          "path-prefix": n.pathPrefix,
          onToggleParent: i.handleToggleParent,
          onToggleChild: i.handleToggleChild,
          onNavigate: i.handleNavigate
        }, null, 8, ["elem-data", "colors", "active-parent", "active-child", "path-prefix", "onToggleParent", "onToggleChild", "onNavigate"]))), 128))
      ], 4), [
        [Un, n.isVisible]
      ])
    ]),
    _: 1
  });
}
const jI = /* @__PURE__ */ B(VI, [["render", BI], ["__scopeId", "data-v-5d2991ec"]]), UI = {
  name: "M4MoreMenuDropdown",
  components: { M4MainItem: I4 },
  props: {
    isVisible: {
      type: Boolean,
      default: !1
    },
    dropdownId: {
      type: String,
      default: "h4-menu--dropdown"
    },
    moreItems: {
      type: Array,
      default: () => []
    },
    activeId: {
      type: [String, Number],
      default: null
    },
    colors: {
      type: Object,
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  emits: ["mouseleave", "toggle-drawer", "navigate", "open", "close", "toggle-more-menu", "focus-sub-menu"],
  computed: {
    ariaId() {
      return "more-menu-dropdown";
    },
    ariaLabelledBy() {
      return "menu-button-more";
    },
    ariaExpanded() {
      return this.isVisible ? "true" : "false";
    },
    lastItemId() {
      const e = (n) => {
        var r;
        return n.type !== "header" || ((r = n.children) == null ? void 0 : r.length) > 0;
      }, t = this.moreItems.findLastIndex(e);
      return this.moreItems[t].id;
    },
    firstItemId() {
      var n;
      const e = (r) => {
        var o;
        return r.type !== "header" || ((o = r.children) == null ? void 0 : o.length) > 0;
      }, t = this.moreItems.findIndex(e);
      return (n = this.moreItems[t]) == null ? void 0 : n.id;
    }
  }
}, qI = ["id", "aria-labelledby", "aria-expanded"];
function GI(e, t, n, r, o, i) {
  const a = V("M4MainItem");
  return d(), f("div", {
    id: i.ariaId,
    "aria-labelledby": i.ariaLabelledBy,
    "aria-expanded": i.ariaExpanded,
    class: "m4-menu--dropdown-item-wrapper",
    onMouseleave: t[4] || (t[4] = (s) => e.$emit("mouseleave"))
  }, [
    (d(!0), f(J, null, ne(n.moreItems, (s) => (d(), f(J, null, [
      s ? (d(), I(a, {
        ref_for: !0,
        ref: `more-${s.id}`,
        key: s.id,
        item: s,
        "force-show": !0,
        "is-more-menu-item": !0,
        "first-item-id": i.firstItemId,
        "last-item-id": i.lastItemId,
        "active-id": n.activeId,
        "is-active": s.id === n.activeId,
        colors: n.colors,
        "path-prefix": n.pathPrefix,
        onNavigate: (l) => e.$emit("navigate", s),
        onMouseover: (l) => e.$emit("open", s),
        onToggleMoreMenu: t[0] || (t[0] = (l) => e.$emit("toggle-more-menu", l)),
        onToggleDrawer: t[1] || (t[1] = (l) => e.$emit("toggle-drawer", l)),
        onClose: t[2] || (t[2] = (l) => e.$emit("close")),
        onFocusSubMenu: t[3] || (t[3] = (l) => e.$emit("focus-sub-menu", l))
      }, null, 8, ["item", "first-item-id", "last-item-id", "active-id", "is-active", "colors", "path-prefix", "onNavigate", "onMouseover"])) : T("", !0)
    ], 64))), 256))
  ], 40, qI);
}
const KI = /* @__PURE__ */ B(UI, [["render", GI], ["__scopeId", "data-v-b58cb58f"]]), zI = {
  name: "M4Drawer",
  components: { M4DrawerElement: $4 },
  props: {
    activeItem: {
      type: Object,
      default: void 0
    },
    themeStyle: {
      type: String,
      default: "light"
    },
    colors: {
      type: Object,
      default: void 0
    },
    isMoreMenuActive: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    isTemporarilyHideMenu: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["mouseenter", "mouseleave", "hide-drawer", "close", "prevent-close", "toggle-parent", "next-tab", "navigate"],
  data() {
    return {
      activeParent: null,
      scrollWidth: !1
    };
  },
  computed: {
    itemId() {
      return `drawer-${this.activeItem.id}`;
    }
  },
  watch: {
    isOpen(e) {
      if (e) {
        const { scrollWidth: t, clientWidth: n } = this.$refs["drawer-wrapper"];
        t > n && (this.scrollWidth = !0);
      }
    }
  },
  methods: {
    hideDrawer() {
      this.$emit("hide-drawer");
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null, this.$emit("toggle-parent", { itemId: e.id });
        return;
      }
      this.$emit("prevent-close"), this.activeParent = e.id, this.$emit("toggle-parent", { itemId: e.id });
    }
  }
}, ZI = ["id", "aria-labelledby"], xI = { class: "m4-menu--drawer-title" };
function WI(e, t, n, r, o, i) {
  const a = V("M4DrawerElement");
  return d(), f("div", {
    id: i.itemId,
    ref: i.itemId,
    "aria-labelledby": `menu-button-${n.activeItem.id}`,
    "aria-modal": "true",
    class: "m4-menu--drawer",
    style: Z({ flexDirection: o.scrollWidth ? "column" : "row" }),
    onMouseleave: t[2] || (t[2] = W((s) => e.$emit("mouseleave"), ["exact", "stop", "prevent"])),
    onMouseenter: t[3] || (t[3] = (s) => e.$emit("mouseenter"))
  }, [
    c("div", xI, [
      c("h2", {
        class: _(n.themeStyle)
      }, k(n.activeItem.name), 3)
    ]),
    c("div", {
      ref: "drawer-wrapper",
      class: _(["m4-menu--drawer-content-wrapper", { scrollWidth: o.scrollWidth }])
    }, [
      (d(!0), f(J, null, ne(n.activeItem.children, (s) => (d(), I(a, {
        key: s.id,
        "elem-data": s,
        colors: n.colors,
        "theme-style": n.themeStyle,
        "active-parent": o.activeParent,
        "path-prefix": n.pathPrefix,
        onToggleParent: i.handleToggleParent,
        onNextTab: t[0] || (t[0] = (l) => e.$emit("next-tab", l)),
        onNavigate: t[1] || (t[1] = (l) => e.$emit("navigate", l))
      }, null, 8, ["elem-data", "colors", "theme-style", "active-parent", "path-prefix", "onToggleParent"]))), 128))
    ], 2)
  ], 44, ZI);
}
const YI = /* @__PURE__ */ B(zI, [["render", WI], ["__scopeId", "data-v-6a36474b"]]), XI = {
  name: "M4",
  components: {
    M4Drawer: YI,
    M4MobileMenu: jI,
    M4MoreMenuDropdown: KI,
    M4MainItem: I4
  },
  mixins: [$s, M4],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: Boolean,
    isMobile: Boolean
  },
  emits: ["close-menus", "toggle-mobile-menu"],
  setup() {
    const e = ho(), { hasFocus: t, activate: n, deactivate: r } = KA(e);
    return {
      activate: n,
      deactivate: r,
      hasFocus: t,
      m4MobileMenu: e
    };
  },
  computed: {
    showMobileMenu() {
      return this.content.showMenu;
    },
    moreBtnWidth() {
      var e, t;
      return ((t = (e = this.$refs) == null ? void 0 : e["m4-menu--more-wrapper"]) == null ? void 0 : t.clientWidth) || 10;
    },
    mobileMenuItems() {
      return [
        {
          id: "explore-header",
          name: "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    }
  },
  watch: {
    async showMobileMenu() {
      this.isMobile && (this.showMobileMenu ? (await bc(), this.activate()) : (await bc(), this.deactivate()));
    }
  }
}, QI = { class: "m4-menu--align-right" }, JI = {
  ref: "bar-nav-item-wrapper",
  class: "m4-menu--bar-item-wrapper"
}, eL = {
  ref: "m4-menu--more-wrapper",
  class: "m4-menu--bar-dropdown-wrapper"
}, tL = { ref: "m4MobileMenu" };
function nL(e, t, n, r, o, i) {
  const a = V("M4MainItem"), s = V("M4Drawer"), l = V("M4MoreMenuDropdown"), u = V("Close"), m = V("M4MobileMenu"), v = Ke("click-away");
  return d(), f("div", {
    id: "m4",
    style: Z(e.colors),
    class: _(["m4-menu", { loadingMenu: e.loadingMenu }])
  }, [
    c("div", {
      ref: "m4-menu--bar",
      class: "m4-menu--bar",
      onMouseleave: t[13] || (t[13] = (g) => e.mouseLeaveMenu()),
      onMouseenter: t[14] || (t[14] = (g) => e.mouseEnterMenu())
    }, [
      c("div", QI, [
        we((d(), f("div", JI, [
          (d(!0), f(J, null, ne(n.content.sitemapMenuItems, (g) => (d(), f(J, {
            key: g.id
          }, [
            we(j(a, {
              item: g,
              "active-id": e.activeItem ? e.activeItem.id : null,
              "theme-style": n.theme.style,
              colors: e.colors,
              "path-prefix": n.content.pathPrefix,
              onNavigate: e.navigate,
              onMouseover: (h) => e.showItem(g),
              onToggleDrawer: (h) => e.handleDrawerToggle(g),
              onClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme-style", "colors", "path-prefix", "onNavigate", "onMouseover", "onToggleDrawer", "onClose"]), [
              [Un, e.visibleItems.find(({ id: h }) => h === g.id)]
            ]),
            j(Le, { name: "slide-fade-up" }, {
              default: S(() => [
                c("div", {
                  onMousemove: t[5] || (t[5] = (h) => e.preventMouseLeaveClose = !1)
                }, [
                  we(j(s, {
                    id: `drawer-${g.id}`,
                    ref_for: !0,
                    ref: `drawer-${g.id}`,
                    "active-item": g,
                    "theme-style": n.theme.style,
                    colors: e.colors,
                    "is-more-menu-active": e.isMoreDropdownVisible,
                    "is-open": e.activeItem && e.activeItem.id === g.id,
                    "path-prefix": n.content.pathPrefix,
                    "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                    onToggleParent: e.toggleParentCollapsible,
                    onPreventClose: t[0] || (t[0] = (h) => e.preventCloseDrawer(h)),
                    onNavigate: t[1] || (t[1] = (h) => e.navigate(h)),
                    onMouseleave: t[2] || (t[2] = (h) => e.hideDrawer("mouseleave")),
                    onClose: e.handleClose,
                    onHideDrawer: e.hideDrawer,
                    onMouseenter: t[3] || (t[3] = (h) => e.preventClose(e.activeItem)),
                    onNextTab: t[4] || (t[4] = (h) => e.nextTabAction(h))
                  }, null, 8, ["id", "active-item", "theme-style", "colors", "is-more-menu-active", "is-open", "path-prefix", "is-temporarily-hide-menu", "onToggleParent", "onClose", "onHideDrawer"]), [
                    [Un, e.showDrawer(g)]
                  ])
                ], 32)
              ]),
              _: 2
            }, 1024)
          ], 64))), 128))
        ])), [
          [v, e.hideDrawer]
        ]),
        we(c("div", eL, [
          j(a, {
            id: "m4-menu--bar-dropdown-button",
            "more-menu-item": e.translations.more_dropdown_title,
            "more-menu-visible": e.isMoreDropdownVisible,
            "force-show": !0,
            "theme-style": n.theme.style,
            colors: e.colors,
            "path-prefix": n.content.pathPrefix,
            onNavigate: e.navigate,
            onToggleMoreMenu: t[6] || (t[6] = (g) => e.handleMoreMenuToggle(g)),
            onMouseover: t[7] || (t[7] = (g) => e.handleMoreMenuToggle(!0)),
            onClose: e.handleClose
          }, null, 8, ["more-menu-item", "more-menu-visible", "theme-style", "colors", "path-prefix", "onNavigate", "onClose"]),
          j(Le, { name: "slide-fade-up" }, {
            default: S(() => [
              e.underLappedItems && e.isMoreDropdownVisible ? we((d(), I(l, {
                key: 0,
                ref: "moreDropdown",
                "active-id": e.activeItem ? e.activeItem.id : null,
                "is-visible": e.isMoreDropdownVisible,
                "more-items": e.underLappedItems,
                "theme-style": n.theme.style,
                colors: e.colors,
                "path-prefix": n.content.pathPrefix,
                onNavigate: e.navigate,
                onOpen: t[8] || (t[8] = (g) => e.handleDropdownMenuOpen(g)),
                onToggleMoreMenu: t[9] || (t[9] = (g) => e.handleMoreMenuToggle(g)),
                onToggleDrawer: t[10] || (t[10] = (g) => e.handleDrawerToggle(g)),
                onMouseleave: t[11] || (t[11] = (g) => e.preventClose(e.activeItem)),
                onFocusSubMenu: t[12] || (t[12] = (g) => e.focusSubMenu(g)),
                onClose: e.handleClose,
                onTemporarilyHideMenu: e.temporalHide
              }, null, 8, ["active-id", "is-visible", "more-items", "theme-style", "colors", "path-prefix", "onNavigate", "onClose", "onTemporarilyHideMenu"])), [
                [v, e.hideMoreMenu]
              ]) : T("", !0)
            ]),
            _: 1
          })
        ], 512), [
          [Un, e.displayMoreButton]
        ])
      ])
    ], 544),
    n.isMobile ? (d(), f("div", {
      key: 0,
      id: "mainmenu",
      ref: "mainmenu",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      class: _(["m4-menu--mobile", n.content.showMenu && "is-visible"])
    }, [
      c("div", tL, [
        c("button", {
          ref: "closeButton",
          class: "close-icon",
          "aria-label": "close",
          onClick: t[15] || (t[15] = (g) => e.$emit("toggle-mobile-menu", !1))
        }, [
          j(u, {
            tabindex: "-1",
            "fill-color": e.colors["--dropdown-text-color"]
          }, null, 8, ["fill-color"])
        ], 512),
        j(m, {
          "menu-items": i.mobileMenuItems,
          "is-visible": n.content.showMenu,
          colors: e.colors,
          "path-prefix": n.content.pathPrefix,
          onNavigate: e.navigate,
          onCloseMenu: t[16] || (t[16] = (g) => e.$emit("close-menus"))
        }, null, 8, ["menu-items", "is-visible", "colors", "path-prefix", "onNavigate"])
      ], 512)
    ], 2)) : T("", !0)
  ], 6);
}
const M0 = /* @__PURE__ */ B(XI, [["render", nL], ["__scopeId", "data-v-d6ea7a9e"]]), rL = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    globals: {
      type: Object,
      required: !0
    },
    logoLink: {
      type: String,
      required: !0
    },
    shouldShrink: {
      type: Boolean,
      default: !1
    },
    isMobile: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      return {
        "--nav-color": this.theme.navigation_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--school-name-color": this.theme.school_name_color.hex,
        "--school-tagline-color": this.theme.school_tagline_color.hex
      };
    },
    aClass() {
      return {
        "logo-circle": this.theme.logo_circle && ["H1", "H2"].includes(this.theme.version),
        shrink: this.shouldShrink,
        mobile: this.isMobile
      };
    },
    slogan() {
      const e = $(this.theme, "translations.school_tag_line"), t = $(this.globals, "info.school_tag_line");
      return e || t;
    }
  }
}, oL = ["href"], iL = {
  key: 0,
  class: "clipping-rect"
}, sL = { class: "logo" }, aL = ["src"], lL = {
  key: 0,
  class: "circle"
}, uL = { class: "school-info" }, dL = {
  key: 1,
  class: "name"
};
function cL(e, t, n, r, o, i) {
  return d(), f("a", {
    href: n.logoLink,
    class: _(i.aClass),
    style: Z(i.colors)
  }, [
    n.theme.logo_circle ? (d(), f("div", iL)) : T("", !0),
    c("div", sL, [
      c("img", {
        src: n.globals.logo.url,
        alt: "Return to Home"
      }, null, 8, aL),
      n.theme.logo_circle ? (d(), f("div", lL)) : T("", !0)
    ]),
    c("div", uL, [
      n.globals.info.customHeader ? (d(), f("h1", {
        key: 0,
        class: _({ "sr-only": n.globals.info.customHeader })
      }, k(n.globals.info.school_name) + " - " + k(i.slogan), 3)) : T("", !0),
      n.globals.info.customHeader ? T("", !0) : (d(), f("div", dL, [
        c("h1", {
          class: _([n.theme.style, "org-name"])
        }, k(n.globals.info.school_name), 3),
        c("div", {
          class: _(["slogan", { [n.theme.style]: n.theme.style }])
        }, k(i.slogan), 3)
      ]))
    ])
  ], 14, oL);
}
const mr = /* @__PURE__ */ B(rL, [["render", cL], ["__scopeId", "data-v-a845ad16"]]), hL = {
  name: "MenuElementType",
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    moreMenuTitle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    },
    moreMenuVisible: Boolean,
    ariaExpanded: {
      type: String,
      default: "false"
    },
    ariaHasPopup: {
      type: String,
      default: "false"
    },
    ariaControls: {
      type: String,
      default: ""
    }
  },
  emits: ["handle-header-click"],
  computed: {
    href() {
      if (!this.item)
        return null;
      switch (this.item.type) {
        case "page":
          return `${this.pathPrefix}/page/${this.item.slug}`;
        case "link":
          return this.getLinkHref;
        case "explore":
          return this.getExploreHref;
        case "header":
          return null;
        default:
          return null;
      }
    },
    iconVisible() {
      return (this.item.icon || this.item.icon_cms) && this.item.id !== "explore-button" && this.item.id !== "schoolsbutton";
    },
    noChildren() {
      var e;
      return ((e = this.item.children) == null ? void 0 : e.length) === 0;
    },
    getExploreHref() {
      var e;
      return (e = this.item.slug) != null && e.includes("http") ? this.item.slug : this.pathPrefix + this.item.slug;
    },
    getLinkHref() {
      return this.item ? this.item.mailto && this.item.email_address ? `mailto:${this.item.email_address}` : this.item.ipAddress ? `http://${this.item.url}` : this.item.url : null;
    },
    colors() {
      return {
        "--icon-fill-color": this.fillColor
      };
    }
  }
}, mL = { class: "bar-nav-element" }, fL = ["innerHTML"], pL = ["href", "target"], gL = { key: 0 };
function vL(e, t, n, r, o, i) {
  return d(), f("div", mL, [
    i.href ? (d(), f(J, { key: 0 }, [
      i.iconVisible ? (d(), f("div", {
        key: 0,
        class: _(["item-icon", { "global-icon": n.item.cms_icon_id }]),
        style: Z(i.colors),
        innerHTML: n.item.cms_icon_id ? n.item.icon_cms : n.item.icon
      }, null, 14, fL)) : T("", !0),
      c("a", {
        href: i.href,
        target: n.item.opens_in_new_tab ? "_blank" : void 0,
        class: "link"
      }, k(n.item.translatedTitle || n.item.name), 9, pL)
    ], 64)) : (d(), f(J, { key: 1 }, [
      n.moreMenuTitle && n.item.name === "more" ? (d(), f("span", gL, k(n.moreMenuTitle), 1)) : (d(), f("span", {
        key: 1,
        class: _(["item-type-header", { "no-children": i.noChildren }]),
        onClick: t[0] || (t[0] = (a) => e.$emit("handle-header-click"))
      }, k(n.item.translatedTitle || n.item.name), 3))
    ], 64))
  ]);
}
const O4 = /* @__PURE__ */ B(hL, [["render", vL], ["__scopeId", "data-v-5589e202"]]), bL = {
  name: "ImageElement",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    href() {
      return this.item ? this.item.url : null;
    }
  }
}, yL = {
  class: "menu-item-focusable",
  tabindex: "-1"
}, _L = ["src", "alt"];
function CL(e, t, n, r, o, i) {
  return d(), f("span", yL, [
    (d(), I(Y(i.href ? "a" : "div"), {
      href: i.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "menu-item-link",
      tabindex: "-1"
    }, {
      default: S(() => [
        c("img", {
          src: n.item.imgSrc,
          alt: n.item.altText
        }, null, 8, _L)
      ]),
      _: 1
    }, 8, ["href", "target"]))
  ]);
}
const wL = /* @__PURE__ */ B(bL, [["render", CL], ["__scopeId", "data-v-e7e5596a"]]), TL = {
  name: "BarNavDrawerItem",
  components: { MenuElementType: O4, ImageElement: wL, MenuPlusIcon: L4, MenuMinusIcon: D4, DropdownArrowIcon: To },
  props: {
    elemData: {
      type: Object,
      default: null
    },
    themeStyle: {
      type: String,
      default: ""
    },
    isMobile: Boolean,
    colors: {
      type: Object,
      default: void 0
    },
    activeParent: {
      type: [String, Number],
      default: null
    },
    activeChild: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    nestLevel: {
      type: Number,
      default: 0
    },
    newMobileHeaderElement: Boolean
  },
  emits: ["toggle-child", "toggle-parent", "next-tab", "navigate"],
  computed: {
    iconColor() {
      return this.isMobile && this.newMobileHeaderElement ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"];
    },
    itemBgColor() {
      return {
        "--item-bg-color": this.isMobile ? this.colors["--mobile-menu-bg-color"] : this.colors["--dropdown-bg-color"]
      };
    },
    itemTextColor() {
      return {
        "--item-text-color": this.isMobile ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"]
      };
    },
    hasChildren() {
      var e;
      return !!((e = this.elemData) != null && e.children.length);
    },
    showChildren() {
      return Number.isNaN(+this.activeParent) ? this.activeParent === this.elemData.id : +this.activeParent == +this.elemData.id;
    },
    isChild() {
      return this.nestLevel >= 1;
    },
    isSubChild() {
      return this.nestLevel >= 2;
    },
    ariaParentId() {
      return `menu-button-${this.elemData.id}`;
    },
    ariaExpanded() {
      if (this.hasChildren)
        return this.showChildren ? "true" : "false";
    },
    ariaControls() {
      if (this.hasChildren)
        return this.ariaChildId;
    },
    ariaChildId() {
      return `${this.elemData.id}-collapsible`;
    },
    ariaHasPopup() {
      return this.hasChildren ? "true" : "false";
    }
  },
  methods: {
    toggleParentCollapsible() {
      this.$emit("toggle-parent", this.elemData);
    },
    handleEnterEvent() {
      this.$emit("navigate", this.elemData);
    },
    handleNextTab(e, t, n) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    }
  }
}, kL = ["id"], EL = ["id"], SL = ["aria-expanded", "aria-controls", "aria-haspopup"], ML = {
  class: "bar-nav--drawer-element-focusable",
  tabindex: "-1"
}, AL = {
  key: 3,
  class: "sr-only"
}, IL = ["id", "aria-labelledby"];
function LL(e, t, n, r, o, i) {
  const a = V("ImageElement"), s = V("MenuElementType"), l = V("MenuPlusIcon"), u = V("MenuMinusIcon"), m = V("DropdownArrowIcon"), v = V("BarNavDrawerItem", !0);
  return d(), f("div", {
    role: "menuitem",
    class: _(["bar-nav--drawer-element", {
      "mobile-element": n.isMobile,
      "new-mobile-header": n.newMobileHeaderElement,
      "child-element": i.isChild,
      "has-children": i.hasChildren,
      "has-icon": n.elemData.icon || n.elemData.icon_cms,
      "sub-child": i.isSubChild,
      "image-element": n.elemData.type === "image"
    }]),
    style: Z([i.itemBgColor, i.itemTextColor]),
    onClick: t[7] || (t[7] = (...g) => i.toggleParentCollapsible && i.toggleParentCollapsible(...g))
  }, [
    c("div", {
      id: n.elemData.id,
      class: "bar-nav--drawer-element-title"
    }, [
      c("div", {
        id: i.ariaParentId,
        class: _(["bar-nav--drawer-element-title-text", n.themeStyle]),
        onClick: t[1] || (t[1] = W(() => {
        }, ["stop"]))
      }, [
        n.elemData.type === "image" ? (d(), I(a, {
          key: 0,
          item: n.elemData
        }, null, 8, ["item"])) : (d(), I(s, {
          key: 1,
          "path-prefix": n.pathPrefix,
          item: n.elemData,
          "fill-color": i.iconColor,
          "aria-expanded": i.ariaExpanded,
          "aria-has-popup": i.ariaHasPopup,
          "aria-controls": i.ariaControls,
          onHandleHeaderClick: i.toggleParentCollapsible,
          onKeydown: [
            K(i.handleEnterEvent, ["enter"]),
            t[0] || (t[0] = K((g) => i.handleNextTab(n.elemData.id, !1, g.shiftKey), ["tab"]))
          ]
        }, null, 8, ["path-prefix", "item", "fill-color", "aria-expanded", "aria-has-popup", "aria-controls", "onHandleHeaderClick", "onKeydown"]))
      ], 10, EL),
      n.elemData.children.length ? (d(), f(J, { key: 0 }, [
        n.elemData.children.length ? (d(), f("button", {
          key: 0,
          "aria-expanded": i.ariaExpanded,
          "aria-controls": i.ariaControls,
          "aria-haspopup": i.ariaHasPopup,
          class: "bar-nav--drawer-element-title-icon",
          onClick: t[2] || (t[2] = W((...g) => i.toggleParentCollapsible && i.toggleParentCollapsible(...g), ["stop", "prevent"])),
          onKeydown: t[3] || (t[3] = K((g) => i.handleNextTab(n.elemData.id, !0, g.shiftKey), ["tab"]))
        }, [
          c("span", ML, [
            n.isMobile && !i.showChildren ? (d(), I(l, {
              key: 0,
              "fill-color": i.iconColor
            }, null, 8, ["fill-color"])) : n.isMobile && i.showChildren ? (d(), I(u, {
              key: 1,
              "fill-color": i.iconColor
            }, null, 8, ["fill-color"])) : T("", !0),
            n.isMobile ? T("", !0) : (d(), I(m, {
              key: 2,
              "fill-color": i.iconColor,
              "dropdown-class": i.showChildren ? "open" : "close"
            }, null, 8, ["fill-color", "dropdown-class"])),
            n.elemData ? (d(), f("span", AL, " Show submenu for " + k(n.elemData.name || n.elemData.translatedTitle), 1)) : T("", !0)
          ])
        ], 40, SL)) : T("", !0)
      ], 64)) : T("", !0)
    ], 8, kL),
    j(Le, { name: "collapse-in" }, {
      default: S(() => [
        we(c("div", {
          id: i.ariaChildId,
          "aria-labelledby": i.ariaParentId,
          class: _(["bar-nav--drawer-children", { "show-children": i.showChildren }])
        }, [
          (d(!0), f(J, null, ne(n.elemData.children, (g) => (d(), I(v, {
            key: g.id,
            "elem-data": g,
            "is-mobile": n.isMobile,
            "theme-style": n.themeStyle,
            "active-parent": n.activeChild,
            "path-prefix": n.pathPrefix,
            colors: n.colors,
            "new-mobile-header-element": n.newMobileHeaderElement,
            "nest-level": n.nestLevel + 1,
            onToggleParent: t[4] || (t[4] = (h) => e.$emit("toggle-child", h)),
            onNextTab: t[5] || (t[5] = (h) => e.$emit("next-tab", h)),
            onNavigate: t[6] || (t[6] = (h) => e.$emit("navigate", h))
          }, null, 8, ["elem-data", "is-mobile", "theme-style", "active-parent", "path-prefix", "colors", "new-mobile-header-element", "nest-level"]))), 128))
        ], 10, IL), [
          [Un, i.hasChildren & i.showChildren]
        ])
      ]),
      _: 1
    })
  ], 6);
}
const P4 = /* @__PURE__ */ B(TL, [["render", LL], ["__scopeId", "data-v-1e9b1b42"]]), DL = {
  name: "MobileMenu",
  components: {
    BarNavDrawerItem: P4,
    MenuItem: xt,
    LanguageDropdown: Ds
  },
  mixins: [Tt],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    },
    colors: {
      type: Object,
      default: () => ({})
    },
    showUtilities: Boolean,
    signInColors: {
      type: Object,
      default: () => ({})
    },
    signInUrl: {
      type: String,
      default: ""
    },
    signInText: {
      type: String,
      default: ""
    },
    showSignInButton: Boolean,
    showMenuButtons: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close-menu", "set-language", "toggle-search"],
  data() {
    return {
      activeParent: null,
      activeChild: null,
      languageDropdownVisible: !1
    };
  },
  mounted() {
    window.addEventListener("keydown", this.keydownHandler);
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydownHandler);
  },
  methods: {
    keydownHandler(e) {
      e.key === "Escape" && this.$emit("close-menu");
    },
    setLanguage(e) {
      this.toggleLanguageDropdown(), this.$emit("set-language", e);
    },
    toggleLanguageDropdown() {
      this.languageDropdownVisible = !this.languageDropdownVisible;
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null;
        return;
      }
      this.activeParent = e.id;
    },
    handleToggleChild(e) {
      if (!e) {
        this.activeChild = null;
        return;
      }
      if (e.id === this.activeChild) {
        this.activeChild = null;
        return;
      }
      this.activeChild = e.id;
    }
  }
}, $L = {
  key: 0,
  class: "mobile-menu-wrapper"
}, OL = {
  key: 0,
  class: "search-translate-buttons"
}, PL = ["href"], NL = {
  key: 1,
  class: "utilities-wrapper"
}, HL = ["href", ":href", "target"], FL = {
  key: 2,
  class: "icon-links-container"
}, RL = ["href", ":href", "target", "aria-label"], VL = ["innerHTML"];
function BL(e, t, n, r, o, i) {
  const a = V("MenuItem"), s = V("LanguageDropdown"), l = V("BarNavDrawerItem"), u = Ke("click-away");
  return d(), I(Le, { name: "slide-fade-up" }, {
    default: S(() => [
      n.content.showMenu ? (d(), f("nav", $L, [
        n.showMenuButtons ? (d(), f("div", OL, [
          j(a, {
            item: "searchbutton",
            theme: n.theme,
            content: n.content,
            "is-mobile": "",
            "theme-overrides": {
              colors: {
                "--icon-color": n.colors["--mobile-menu-text-color"],
                "--bg-color": "transparent"
              }
            },
            "mobile-text-color": n.colors["--mobile-menu-text-color"],
            onToggleSearch: t[0] || (t[0] = (m) => e.$emit("toggle-search"))
          }, null, 8, ["theme", "content", "theme-overrides", "mobile-text-color"]),
          n.content.languages.length > 1 ? (d(), I(a, {
            key: 0,
            item: "languagebutton",
            theme: n.theme,
            content: n.content,
            "is-mobile": "",
            "theme-overrides": {
              colors: {
                "--fill-color": n.colors["--mobile-menu-text-color"],
                "--fill-path-color": n.colors["--mobile-menu-text-color"],
                "--nav-color": n.colors["--mobile-menu-text-color"]
              }
            },
            "mobile-text-color": n.colors["--mobile-menu-text-color"],
            onToggleDropdown: i.toggleLanguageDropdown
          }, null, 8, ["theme", "content", "theme-overrides", "mobile-text-color", "onToggleDropdown"])) : T("", !0),
          we(j(s, {
            id: "languagesmenu",
            data: n.content.languages,
            styles: n.theme,
            "is-visible": o.languageDropdownVisible,
            "current-language": n.content.langCode,
            class: "language-dropdown",
            onSetLanguage: i.setLanguage,
            onCloseDropdown: i.toggleLanguageDropdown
          }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage", "onCloseDropdown"]), [
            [
              u,
              () => {
                o.languageDropdownVisible = !1;
              }
            ]
          ]),
          n.showSignInButton ? (d(), f("a", {
            key: 1,
            href: n.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(n.signInText), 9, PL)) : T("", !0)
        ])) : T("", !0),
        M(e.$slots, "menu-top", {}, void 0, !0),
        n.showUtilities ? (d(), f("div", NL, [
          (d(!0), f(J, null, ne(n.content.utilities, (m, v) => (d(), f("a", {
            key: v,
            href: m.link,
            ":href": m.link,
            target: m.opens_in_new_tab ? "_blank" : "",
            class: "utility",
            style: Z({ color: n.colors["--mobile-menu-text-color"] })
          }, k(m.name), 13, HL))), 128))
        ])) : T("", !0),
        n.theme.version === "H8" && n.theme.style === "texas" ? (d(), f("div", FL, [
          (d(!0), f(J, null, ne(n.content.iconLinks, (m) => (d(), f("a", {
            key: m.icon_id,
            href: m.link,
            ":href": m.link,
            target: m.opens_in_new_tab ? "_blank" : "",
            class: "icon-link",
            "aria-label": m.name,
            style: Z({ color: n.colors["--mobile-menu-text-color"] })
          }, [
            c("span", {
              "data-testid": "svg",
              innerHTML: m.icon
            }, null, 8, VL)
          ], 12, RL))), 128))
        ])) : T("", !0),
        (d(!0), f(J, null, ne(n.content.menuItems, (m) => (d(), I(l, {
          key: `${m.name}-${m.id}`,
          "elem-data": m,
          "is-mobile": "",
          colors: n.colors,
          "active-parent": o.activeParent,
          "active-child": o.activeChild,
          "path-prefix": n.content.pathPrefix,
          "new-mobile-header-element": "",
          onToggleParent: i.handleToggleParent,
          onToggleChild: i.handleToggleChild
        }, null, 8, ["elem-data", "colors", "active-parent", "active-child", "path-prefix", "onToggleParent", "onToggleChild"]))), 128))
      ])) : T("", !0)
    ]),
    _: 3
  });
}
const jL = /* @__PURE__ */ B(DL, [["render", BL], ["__scopeId", "data-v-912cfa21"]]), UL = {
  name: "MobileHeader",
  components: {
    MenuItem: xt,
    OrgBanner: mr,
    MobileMenu: jL
  },
  mixins: [lt],
  props: {
    isShrink: Boolean,
    showUtilities: Boolean,
    showSignInButton: Boolean,
    hideMenuButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    },
    menuButtonBgColor: {
      type: String,
      default: ""
    },
    menuButtonIconColor: {
      type: String,
      default: ""
    },
    showMenuButtons: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["toggle-mobile-menu", "toggle-search", "set-language"],
  computed: {
    mobileContent() {
      return ge(ae({}, this.content), { menuItems: this.mobileMenuItems });
    },
    mobileMenuItems() {
      return [
        ...this.shouldDisplaySchoolsDropdown ? [
          {
            id: "schools-header",
            name: this.theme.schools_field || "Schools",
            slug: "schools",
            type: "header",
            children: this.buildSchoolsMenu(
              this.content.hasCustomSchoolsMenu ? this.content.orgMenuContent.flat() : this.content.organizations
            )
          }
        ] : [{}],
        {
          id: "explore-header",
          name: this.theme.menu_field || "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            icon: e.icon,
            cms_icon_id: e.cms_icon_id,
            icon_cms: e.icon_cms,
            opens_in_new_tab: e.opens_in_new_tab,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    mobileHeaderBgColor() {
      var e, t, n, r;
      return this.menuV4Enabled || this.content.newMobileHeader && this.theme.version !== "H3" ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : this.menuV5Enabled && this.theme.version === "H3" ? "transparent" : ((r = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : r.hex) || "#fff";
    },
    mobileMenuBgColor() {
      var e, t, n, r;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : ((r = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : r.hex) || "#fff";
    },
    mobileMenuTextColor() {
      var e, t, n, r;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_text_color) == null ? void 0 : t.hex : ((r = (n = this.content.menuOptions) == null ? void 0 : n.text_color) == null ? void 0 : r.hex) || "#000";
    },
    colors() {
      var e, t, n, r, o, i, a, s, l, u;
      return {
        "--nav-color": ((e = this.theme.navigation_color) == null ? void 0 : e.hex) || "#fff",
        searchIcon: (t = this.theme.search_icon_color) == null ? void 0 : t.hex,
        "--mobile-menu-bg-color": (this.menuV4Enabled ? (r = (n = this.content.menuOptions) == null ? void 0 : n.dropdown_bg_color) == null ? void 0 : r.hex : (i = (o = this.content.menuOptions) == null ? void 0 : o.bg_color) == null ? void 0 : i.hex) || "#fff",
        "--mobile-menu-text-color": (this.menuV4Enabled ? (s = (a = this.content.menuOptions) == null ? void 0 : a.dropdown_text_color) == null ? void 0 : s.hex : (u = (l = this.content.menuOptions) == null ? void 0 : l.text_color) == null ? void 0 : u.hex) || "#000"
      };
    },
    focusHighlightColor() {
      return de.mostReadable(this.mobileHeaderBgColor, ["#0000FF", "#FFFFFF"]).toHexString();
    },
    isSearchOpen() {
      return this.$route.query.openSearch === "true";
    }
  },
  // watch: {
  //   'content.showMenu': {
  //     async handler(showMenu) {
  //       if (showMenu) {
  //         await nextTick();
  //         this.activate();
  //       } else {
  //         await nextTick();
  //         this.deactivate();
  //       }
  //     },
  //   },
  // },
  methods: {
    async toggleSearch() {
      this.$emit("toggle-search");
    },
    buildSchoolsMenu(e) {
      if (Br(e))
        return [];
      const t = (r) => {
        let o = "";
        switch (r) {
          case "SchoolsMenuOrg":
            o = "link";
            break;
          case "SchoolsMenuLink":
            o = "link";
            break;
          case "SchoolsMenuImage":
            o = "image";
            break;
          case "SchoolsMenuHeader":
            o = "header";
            break;
          default:
            o = "link";
            break;
        }
        return o;
      }, n = (r) => r.type === "SchoolsMenuLink" ? r.link : r.type === "SchoolsMenuOrg" && this.content.hasCustomSchoolsMenu ? S0(r, this.content.organizations, {
        isPreview: this.content.isPreview
      }) : qr(r, {
        isPreview: this.content.isPreview,
        currentDomain: window.location.href
      });
      return e.map((r, o) => ({
        id: `schools-${o}`,
        name: r.name,
        slug: r.link || r.path_prefix,
        url: n(r),
        imgSrc: r.url,
        altText: r.alt_text,
        imgHasLink: r.action_on_click === "no_action",
        opens_in_new_tab: r.opens_in_new_tab,
        type: t(r.type),
        children: this.buildSchoolsMenu(r.children)
      }));
    }
  }
}, qL = {
  key: 0,
  class: "left-icon"
}, GL = { class: "main-content" }, KL = {
  key: 0,
  class: "right-icon"
}, zL = {
  key: 0,
  id: "mainmenu",
  "aria-labelledby": "menubutton",
  "aria-modal": "true",
  class: "menu-mobile"
};
function ZL(e, t, n, r, o, i) {
  const a = V("MenuItem"), s = V("OrgBanner"), l = V("MobileMenu");
  return d(), f("div", {
    "data-testid": "mobile-header",
    class: _(["mobile-header", e.theme.version, { "menu-open": e.content.showMenu, shrink: n.isShrink }]),
    style: Z(i.colors)
  }, [
    M(e.$slots, "default", {}, () => [
      n.hideMenuButton ? T("", !0) : (d(), f("div", qL, [
        e.content.showMenu ? (d(), I(a, {
          key: 1,
          item: "closebutton",
          "show-text": !1,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": n.menuButtonIconColor
            }
          },
          "is-mobile-header": "",
          "focus-visible-color": i.focusHighlightColor,
          onToggleDropdown: t[1] || (t[1] = (u) => e.$emit("toggle-mobile-menu", !1))
        }, null, 8, ["theme", "content", "theme-overrides", "focus-visible-color"])) : (d(), I(a, {
          key: 0,
          item: "menubutton",
          theme: e.theme,
          content: e.content,
          "show-text": !1,
          "theme-overrides": {
            colors: {
              "--fill-color": n.menuButtonBgColor,
              "--fill-path-color": n.menuButtonIconColor
            }
          },
          "is-mobile-header": "",
          "focus-visible-color": i.focusHighlightColor,
          onToggleDropdown: t[0] || (t[0] = (u) => e.$emit("toggle-mobile-menu", !0))
        }, null, 8, ["theme", "content", "theme-overrides", "focus-visible-color"]))
      ])),
      c("div", GL, [
        j(s, {
          "logo-link": e.logoLink,
          "should-shrink": n.isShrink,
          theme: e.theme,
          globals: e.content.globals,
          "is-mobile": e.theme.version !== "H3",
          class: _(e.theme.version)
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals", "is-mobile", "class"]),
        e.theme.version === "H3" ? (d(), f("div", KL, [
          e.content.showMenu ? (d(), I(a, {
            key: 1,
            item: "closebutton",
            theme: e.theme,
            content: e.content,
            "focus-visible-color": i.focusHighlightColor,
            onToggleDropdown: t[3] || (t[3] = (u) => e.$emit("toggle-mobile-menu", !1))
          }, null, 8, ["theme", "content", "focus-visible-color"])) : (d(), I(a, {
            key: 0,
            item: "menubutton",
            theme: e.theme,
            content: e.content,
            "is-mobile": "",
            "focus-visible-color": i.focusHighlightColor,
            onToggleDropdown: t[2] || (t[2] = (u) => e.$emit("toggle-mobile-menu", !0))
          }, null, 8, ["theme", "content", "focus-visible-color"]))
        ])) : T("", !0)
      ])
    ], !0),
    M(e.$slots, "bottom", {}, void 0, !0),
    e.content.showMenu ? (d(), f("div", zL, [
      j(l, {
        theme: e.theme,
        "show-utilities": n.showUtilities,
        utilities: e.content.utilities,
        "lang-code": e.content.langCode,
        "show-menu-buttons": n.showMenuButtons,
        content: i.mobileContent,
        colors: i.colors,
        "sign-in-colors": e.signInColors,
        "sigin-in-url": n.signInUrl,
        "show-sign-in-button": n.showSignInButton,
        "sign-in-text": e.signInText,
        "sign-in-url": n.signInUrl,
        onCloseMenu: t[4] || (t[4] = (u) => e.$emit("toggle-mobile-menu", !1)),
        onToggleSearch: t[5] || (t[5] = (u) => e.$emit("toggle-search")),
        onSetLanguage: t[6] || (t[6] = (u) => e.$emit("set-language", u))
      }, {
        "menu-top": S(() => [
          M(e.$slots, "menu-top", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["theme", "show-utilities", "utilities", "lang-code", "show-menu-buttons", "content", "colors", "sign-in-colors", "sigin-in-url", "show-sign-in-button", "sign-in-text", "sign-in-url"])
    ])) : T("", !0)
  ], 6);
}
const Gr = /* @__PURE__ */ B(UL, [["render", ZL], ["__scopeId", "data-v-6a611167"]]), xL = {
  name: "Header1",
  components: {
    CmsSchoolsMenu: hr,
    M4: M0,
    OrgBanner: mr,
    MobileHeader: Gr,
    MenuItem: xt
  },
  mixins: [lt, Tt],
  emits: ["language-change", "toggle-search"]
}, WL = { class: "left" }, YL = { class: "right" }, XL = { class: "right-left-menu" }, QL = { class: "explore-menu-container" }, JL = {
  key: 0,
  class: "schools-menu-container"
}, eD = { key: 0 }, tD = ["href"];
function nD(e, t, n, r, o, i) {
  var E, C, A, R, O;
  const a = V("OrgBanner"), s = V("MenuItem"), l = V("HeaderDropdown"), u = V("M4"), m = V("cms-schools-menu"), v = V("LanguageDropdown"), g = V("MobileHeader"), h = Ke("click-away");
  return we((d(), f("div", {
    id: "h1",
    style: Z(e.colors)
  }, [
    !e.isMobile || !e.content.newMobileHeader ? (d(), f("div", {
      key: 0,
      "data-testid": "large-screen-header",
      class: _(["header-container", e.shrinkCSSClass, e.logoCircleCSSClass])
    }, [
      c("div", WL, [
        j(a, {
          "logo-link": e.logoLink,
          "should-shrink": e.shouldShrink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals"])
      ]),
      c("div", YL, [
        c("div", XL, [
          c("div", QL, [
            j(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (E = e.theme.navigation_color) == null ? void 0 : E.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.hasExploreMenuContent && !e.isMobile ? (d(), I(s, {
              key: 0,
              item: "explore-button",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (C = e.theme.navigation_color) == null ? void 0 : C.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility,
              onKeydown: t[0] || (t[0] = K(W((F) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"]))
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"])) : T("", !0),
            e.menuV4Enabled && e.exploreMenuVisible ? we((d(), I(l, {
              key: 1,
              id: "explore-menu",
              "data-testid": "explore-menu",
              role: "menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.customMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[1] || (t[1] = (F) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])), [
              [
                h,
                () => {
                  e.exploreMenuVisible = !1;
                }
              ]
            ]) : T("", !0),
            e.menuV4Enabled && e.isMobile ? (d(), I(u, {
              key: 2,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[2] || (t[2] = (F) => e.$emit("toggle-mobile-menu", F))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : T("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (d(), f("div", JL, [
            j(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (A = e.theme.navigation_color) == null ? void 0 : A.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[3] || (t[3] = K(W((F) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), I(l, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-preview": e.content.isPreview,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[4] || (t[4] = (F) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
            j(Le, { name: "slide" }, {
              default: S(() => [
                e.content.hasCustomSchoolsMenu ? (d(), I(m, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.customSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onHideOnClickaway: t[5] || (t[5] = (F) => e.customSchoolsMenuVisible = !1),
                  onFocusLost: t[6] || (t[6] = (F) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
              ]),
              _: 1
            })
          ])) : T("", !0)
        ]),
        c("div", {
          class: _(["right-right-menu", { "show-sign-in-button": e.showSignInButton }])
        }, [
          e.shouldDisplayLanguagesDropdown ? (d(), f("div", eD, [
            j(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (R = e.theme.navigation_color) == null ? void 0 : R.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[7] || (t[7] = K(W((F) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            we(j(v, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[8] || (t[8] = (F) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
              [
                h,
                () => {
                  e.languageDropdownVisible = !1;
                }
              ]
            ])
          ])) : T("", !0),
          j(s, {
            item: "searchbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--bg-color": "transparent",
                "--fill-color": "transparent"
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["theme", "content", "onToggleSearch"]),
          e.showSignInButton ? (d(), f("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(e.signInText), 9, tD)) : T("", !0)
        ], 2)
      ])
    ], 2)) : (d(), I(g, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": "transparent",
      "menu-button-icon-color": (O = e.theme.navigation_color) == null ? void 0 : O.hex,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onToggleMobileMenu: t[9] || (t[9] = (F) => e.$emit("toggle-mobile-menu", F)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-icon-color", "is-shrink", "show-sign-in-button", "sign-in-url", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4)), [
    [h, e.closeAllMenus]
  ]);
}
const rD = /* @__PURE__ */ B(xL, [["render", nD], ["__scopeId", "data-v-3506f7af"]]), oD = {
  name: "DraggableWrapper",
  props: {
    modelValue: {
      type: Array,
      required: !0
    },
    itemKey: {
      type: String,
      required: !0
    }
  }
};
function iD(e, t, n, r, o, i) {
  return d(), f("div", g6(v6(e.$attrs)), [
    (d(!0), f(J, null, ne(n.modelValue, (a, s) => M(e.$slots, "item", {
      key: s,
      element: a,
      index: s
    })), 128))
  ], 16);
}
const vt = /* @__PURE__ */ B(oD, [["render", iD]]), sD = {
  name: "UtilityBar",
  props: {
    utilities: {
      type: Array,
      required: !0
    },
    textColor: {
      type: String,
      required: !0
    },
    bgColor: {
      type: String,
      required: !0
    },
    themeVersion: {
      type: String,
      default: ""
    },
    translatedTitle: {
      type: String,
      default: ""
    },
    languageDropdownOpen: Boolean,
    hasLanguages: Boolean,
    isEditing: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  components: {
    DropdownArrowIcon: To,
    DraggableWrapper: vt
  },
  computed: {
    iconClass() {
      return this.languageDropdownOpen ? "open" : void 0;
    }
  }
};
function aD(e, t, n, r, o, i) {
  const a = V("DropdownArrowIcon");
  return d(), f(J, null, [
    (d(), I(Y(n.wrapperComponent), Se({ "item-key": "idx" }, n.wrapperProps, {
      "model-value": n.utilities,
      style: [{ color: n.textColor }, { background: n.bgColor }],
      class: ["utility-bar", [n.themeVersion, e.$attrs.class, { "is-editing": n.isEditing }]],
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.$emit("update:utilities", s))
    }), {
      item: S(({ element: s, index: l }) => [
        (d(), I(Y(n.isEditing ? "div" : "a"), {
          class: "utilities",
          href: n.isEditing ? "" : s.link,
          target: s.opens_in_new_tab ? "_blank" : ""
        }, {
          default: S(() => [
            M(e.$slots, "utility", { idx: l }, () => [
              H(k(s.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value", "style", "class"])),
    n.themeVersion === "H3" && n.hasLanguages ? (d(), f("button", {
      key: 0,
      class: "translate-button",
      "data-testid": "language-dropdown-button",
      onClick: t[1] || (t[1] = (s) => e.$emit("toggle-language-dropdown"))
    }, [
      c("span", {
        class: "translate-text",
        style: Z({ color: n.textColor })
      }, k(n.translatedTitle), 5),
      j(a, {
        "dropdown-class": i.iconClass,
        "fill-color": n.textColor
      }, null, 8, ["dropdown-class", "fill-color"])
    ])) : T("", !0)
  ], 64);
}
const N4 = /* @__PURE__ */ B(sD, [["render", aD], ["__scopeId", "data-v-6e681a3d"]]), lD = {
  name: "Header2",
  components: {
    CmsSchoolsMenu: hr,
    MenuItem: xt,
    M4: M0,
    OrgBanner: mr,
    UtilityBar: N4,
    MobileHeader: Gr
  },
  mixins: [lt, Tt],
  emits: ["toggle-menu", "toggle-mobile-menu", "close-menu", "language-change", "toggle-search", "update:utilities"]
}, uD = { class: "left" }, dD = { class: "right" }, cD = ["fill"], hD = { class: "right-menu-items" }, mD = { key: 0 }, fD = { key: 1 }, pD = ["href"], gD = { class: "right-mobile" }, vD = { class: "right-left-menu" }, bD = { class: "explore-menu-container" }, yD = {
  key: 0,
  class: "schools-menu-container"
}, _D = {
  key: 0,
  class: "language-icon"
}, CD = ["href"];
function wD(e, t, n, r, o, i) {
  var C, A, R, O, F, L, D, P, U, q;
  const a = V("UtilityBar"), s = V("MenuItem"), l = V("OrgBanner"), u = V("HeaderDropdown"), m = V("M4"), v = V("cms-schools-menu"), g = V("LanguageDropdown"), h = V("MobileHeader"), E = Ke("click-away");
  return we((d(), f("div", {
    id: "h2",
    style: Z(e.colors)
  }, [
    c("div", {
      "data-testid": "small-utilities-bar",
      class: _([e.shrinkCSSClass, "utilities utilities-top"])
    }, [
      j(a, {
        class: _([[{ "is-mobile": e.isMobile }, e.shrinkCSSClass], "utility-bar-items"]),
        utilities: e.content.utilities,
        "theme-version": e.theme.version,
        "text-color": e.colors["--utility-link-color"],
        "bg-color": e.colors["--utility-bg-color"]
      }, null, 8, ["class", "utilities", "theme-version", "text-color", "bg-color"]),
      !e.isMobile || !e.content.newMobileHeader ? (d(), I(s, {
        key: 0,
        item: "searchbutton",
        class: _(e.shrinkCSSClass),
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (C = e.theme.search_icon_color) == null ? void 0 : C.hex
          }
        },
        "is-mobile": "",
        onToggleSearch: e.toggleSearch
      }, null, 8, ["class", "theme", "content", "theme-overrides", "onToggleSearch"])) : T("", !0)
    ], 2),
    !e.isMobile || !e.content.newMobileHeader ? (d(), f("div", {
      key: 0,
      "data-testid": "large-screen-header",
      class: _(["header-container", e.shrinkCSSClass, e.logoCircleCSSClass])
    }, [
      c("div", uD, [
        j(l, {
          "logo-link": e.logoLink,
          "should-shrink": e.shouldShrink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals"])
      ]),
      c("div", dD, [
        c("div", {
          "data-testid": "large-utilities-bar",
          class: _([e.shrinkCSSClass, "utilities utilities-right"])
        }, [
          (d(), f("svg", {
            class: _([e.shrinkCSSClass, "sloped-edge"]),
            width: "97",
            height: "56",
            viewBox: "0 0 97 56",
            preserveAspectRatio: "none",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true"
          }, [
            c("path", {
              d: "M94.5015 56H97V0H1.00114C0.188275 0 -0.284554 0.919373 0.187909 1.58124L6.79574 10.8378C27.0277 39.1796 59.6932 56 94.5015 56Z",
              fill: e.colors["--utility-bg-color"]
            }, null, 8, cD)
          ], 2)),
          j(a, {
            utilities: e.content.utilities,
            class: _([e.shrinkCSSClass, "utility-bar-items"]),
            "theme-version": e.theme.version,
            "text-color": e.colors["--utility-link-color"],
            "bg-color": e.colors["--utility-bg-color"]
          }, null, 8, ["utilities", "class", "theme-version", "text-color", "bg-color"]),
          j(s, {
            item: "searchbutton",
            class: _(e.shrinkCSSClass),
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--icon-color": (A = e.theme.search_icon_color) == null ? void 0 : A.hex
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["class", "theme", "content", "theme-overrides", "onToggleSearch"])
        ], 2),
        c("div", hD, [
          c("div", null, [
            j(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (R = e.theme.navigation_icon_bg_color) == null ? void 0 : R.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.hasExploreMenuContent && !e.isMobile ? (d(), I(s, {
              key: 0,
              item: "explore-button",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (O = e.theme.navigation_icon_bg_color) == null ? void 0 : O.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onKeydown: t[0] || (t[0] = K(W((z) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"])) : T("", !0),
            e.menuV4Enabled && e.exploreMenuVisible ? (d(), I(u, {
              key: 1,
              id: "explore-menu",
              "data-testid": "explore-menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.customMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[1] || (t[1] = (z) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : T("", !0),
            e.menuV4Enabled && e.isMobile ? (d(), I(m, {
              key: 2,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[2] || (t[2] = (z) => e.$emit("toggle-mobile-menu", z))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : T("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (d(), f("div", mD, [
            j(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (F = e.theme.navigation_icon_bg_color) == null ? void 0 : F.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[3] || (t[3] = K(W((z) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), I(u, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[4] || (t[4] = (z) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-language-menu-hidden", "is-shrink"])),
            j(Le, { name: "slide" }, {
              default: S(() => [
                e.content.hasCustomSchoolsMenu ? (d(), I(v, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: t[5] || (t[5] = (z) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
              ]),
              _: 1
            })
          ])) : T("", !0),
          e.shouldDisplayLanguagesDropdown ? (d(), f("div", fD, [
            j(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (L = e.theme.navigation_icon_bg_color) == null ? void 0 : L.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[6] || (t[6] = K(W((z) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            j(g, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[7] || (t[7] = (z) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
          ])) : T("", !0),
          e.showSignInButton ? (d(), f("a", {
            key: 2,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(e.signInText), 9, pD)) : T("", !0)
        ])
      ]),
      c("div", gD, [
        c("div", vD, [
          c("div", bD, [
            j(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (D = e.theme.navigation_icon_bg_color) == null ? void 0 : D.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onKeydown: t[8] || (t[8] = K(W((z) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.exploreMenuVisible ? (d(), I(u, {
              key: 0,
              id: "explore-menu",
              "data-testid": "explore-menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.sitemapMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[9] || (t[9] = (z) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : T("", !0),
            e.menuV4Enabled && e.isMobile ? (d(), I(m, {
              key: 1,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[10] || (t[10] = (z) => e.$emit("toggle-mobile-menu", z))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : T("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (d(), f("div", yD, [
            j(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (P = e.theme.navigation_icon_bg_color) == null ? void 0 : P.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[11] || (t[11] = K(W((z) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), I(u, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-preview": e.content.isPreview,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[12] || (t[12] = (z) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
            j(Le, { name: "slide" }, {
              default: S(() => [
                e.content.hasCustomSchoolsMenu ? (d(), I(v, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "schools-menu",
                  "header-theme": e.theme,
                  content: e.content.globals.homepage,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: t[13] || (t[13] = (z) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
              ]),
              _: 1
            })
          ])) : T("", !0)
        ]),
        c("div", {
          class: _(["right-right-menu", { "show-sign-in-button": e.showSignInButton }])
        }, [
          e.shouldDisplayLanguagesDropdown ? (d(), f("div", _D, [
            j(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (U = e.theme.navigation_icon_bg_color) == null ? void 0 : U.hex
                }
              },
              "is-mobile": "",
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[14] || (t[14] = K(W((z) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            j(g, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[15] || (t[15] = (z) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
          ])) : T("", !0),
          e.showSignInButton ? (d(), f("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(e.signInText), 9, CD)) : T("", !0)
        ], 2)
      ])
    ], 2)) : (d(), I(h, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": "transparent",
      "menu-button-icon-color": (q = e.theme.navigation_color) == null ? void 0 : q.hex,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onToggleMobileMenu: t[16] || (t[16] = (z) => e.$emit("toggle-mobile-menu", z)),
      onToggleSearch: t[17] || (t[17] = (z) => e.$emit("toggle-search")),
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-icon-color", "is-shrink", "show-sign-in-button", "sign-in-url", "onSetLanguage", "onCloseMenu"]))
  ], 4)), [
    [E, e.closeAllMenus]
  ]);
}
const TD = /* @__PURE__ */ B(lD, [["render", wD], ["__scopeId", "data-v-fb2a625c"]]), kD = {
  mixins: [lt, Tt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-language-dropdown"],
  components: {
    OrgBanner: mr,
    UtilityBar: N4,
    LanguageDropdown: Ds,
    MobileHeader: Gr
  },
  mixins: [lt, Tt]
};
function ED(e, t, n, r, o, i) {
  var v, g;
  const a = V("MobileHeader"), s = V("OrgBanner"), l = V("UtilityBar"), u = V("LanguageDropdown"), m = Ke("click-away");
  return we((d(), f("div", {
    id: "h3",
    style: Z(e.colors)
  }, [
    e.isMobile ? (d(), I(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": (v = e.theme.navigation_icon_bg_color) == null ? void 0 : v.hex,
      "menu-button-icon-color": (g = e.theme.navigation_icon_color) == null ? void 0 : g.hex,
      "show-utilities": !0,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "hide-menu-button": "",
      onToggleMenu: t[0] || (t[0] = (h) => e.$emit("toggle-menu")),
      onToggleMobileMenu: t[1] || (t[1] = (h) => e.$emit("toggle-mobile-menu", h)),
      onToggleSearch: t[2] || (t[2] = (h) => e.$emit("toggle-search")),
      onLanguageChange: t[3] || (t[3] = (h) => e.$emit("language-change")),
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-bg-color", "menu-button-icon-color", "show-sign-in-button", "sign-in-url", "is-shrink", "onCloseMenu"])) : (d(), f("div", {
      key: 1,
      class: _(["utility-menu", [e.theme.shadow_type, { isIframe: e.content.isIFrame }]])
    }, [
      j(s, {
        "logo-link": e.logoLink,
        "should-shrink": e.shouldShrink,
        theme: e.theme,
        globals: e.content.globals
      }, null, 8, ["logo-link", "should-shrink", "theme", "globals"]),
      c("div", {
        "data-testid": "utilities-bar",
        class: _([e.shrinkCSSClass, "utilities-bar"])
      }, [
        j(l, {
          class: _([[e.theme.style, e.theme.version, e.shrinkCSSClass], "utility-bar-items"]),
          utilities: e.content.utilities,
          "is-editing": e.content.isEditing,
          "theme-version": e.theme.version,
          "translated-title": e.theme.translations.translate_dropdown_title,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "text-color": e.colors["--utility-link-color"],
          "bg-color": "transparent",
          "language-dropdown-open": e.languageDropdownVisible,
          "has-languages": e.hasLanguages,
          onToggleLanguageDropdown: t[4] || (t[4] = (h) => e.setDropdownVisibility("languagebutton")),
          "onUpdate:utilities": t[5] || (t[5] = (h) => e.$emit("update:utilities", h))
        }, {
          utility: S(({ idx: h }) => [
            M(e.$slots, "utility", { idx: h }, void 0, !0)
          ]),
          _: 3
        }, 8, ["class", "utilities", "is-editing", "theme-version", "translated-title", "wrapper-component", "wrapper-props", "text-color", "language-dropdown-open", "has-languages"]),
        j(u, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[6] || (t[6] = (h) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
      ], 2)
    ], 2))
  ], 4)), [
    [m, e.closeAllMenus]
  ]);
}
const SD = /* @__PURE__ */ B(kD, [["render", ED], ["__scopeId", "data-v-04771afc"]]), MD = {
  name: "UtilityBar",
  components: {
    DraggableWrapper: vt
  },
  props: {
    utilities: {
      type: Array,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    textColor: {
      type: String,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"]
};
function AD(e, t, n, r, o, i) {
  return d(), I(Y(n.wrapperComponent), Se(n.wrapperProps, {
    "model-value": n.utilities,
    "item-key": "idx",
    class: "utility-bar",
    "onUpdate:modelValue": t[0] || (t[0] = (a) => e.$emit("update:utilities", a))
  }), {
    item: S(({ element: a, index: s }) => [
      (d(), I(Y(n.isEditing ? "div" : "a"), {
        class: "utilities",
        href: a.link,
        style: Z({ color: n.textColor }),
        target: a.opens_in_new_tab ? "_blank" : ""
      }, {
        default: S(() => [
          M(e.$slots, "utility", { idx: s }, () => [
            H(k(a.name), 1)
          ], !0)
        ]),
        _: 2
      }, 1032, ["href", "style", "target"]))
    ]),
    _: 3
  }, 16, ["model-value"]);
}
const ID = /* @__PURE__ */ B(MD, [["render", AD], ["__scopeId", "data-v-f4ecbd63"]]), LD = {
  name: "MenuIcon",
  props: {
    type: {
      type: String,
      default: "arrow-1"
    }
  }
}, DD = {
  key: 0,
  class: "menu-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, $D = {
  key: 1,
  class: "menu-icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
};
function OD(e, t, n, r, o, i) {
  return d(), f(J, null, [
    n.type === "arrow-2" ? (d(), f("svg", DD, t[0] || (t[0] = [
      c("path", {
        d: "M6 13L11 8L6 3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ]))) : T("", !0),
    n.type === "arrow-1" ? (d(), f("svg", $D, t[1] || (t[1] = [
      c("g", null, [
        c("path", {
          d: "M1.5 8L14.5 8M14.5 8L10.4375 12.875M14.5 8L10.4375 3.125",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]))) : T("", !0)
  ], 64);
}
const PD = /* @__PURE__ */ B(LD, [["render", OD]]), ND = {
  name: "M6",
  components: {
    MenuIcon: PD
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isMobile: Boolean
  },
  data() {
    return {
      currentPath: []
    };
  },
  computed: {
    breadcrumbTrail() {
      return this.currentPath;
    },
    currentLevelItems() {
      return this.currentPath.length === 0 ? this.isMobile ? this.mobileMenuItems : this.content.sitemapMenuItems : this.currentPath[this.currentPath.length - 1].children || [];
    },
    mobileContent() {
      return ge(ae({}, this.content), { menuItems: this.mobileMenuItems });
    },
    shouldDisplaySchoolsDropdown() {
      var e;
      return ((e = this.content.organizations) == null ? void 0 : e.length) > 1 || this.content.hasCustomSchoolsMenu;
    },
    shouldDisplayUtilities() {
      return this.isMobile ? this.currentPath.length === 0 : !0;
    },
    mobileMenuItems() {
      return [
        ...this.shouldDisplaySchoolsDropdown ? [
          {
            id: "schools-header",
            name: this.theme.schools_field || "Schools",
            slug: "schools",
            type: "header",
            children: this.buildSchoolsMenu(
              this.content.hasCustomSchoolsMenu ? this.content.orgMenuContent.flat() : this.content.organizations
            )
          }
        ] : [{}],
        {
          id: "explore-header",
          name: this.theme.menu_field || "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            icon: e.icon,
            cms_icon_id: e.cms_icon_id,
            icon_cms: e.icon_cms,
            opens_in_new_tab: e.opens_in_new_tab,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    colors() {
      return {
        "--heading-color": this.theme.menu_heading_color.hex,
        "--heading-line-color": this.theme.menu_heading_line_color.hex,
        "--icon-color": this.content.menuOptions.icon_color.hex,
        "--icon-bg-color": this.content.menuOptions.icon_bg_color.hex,
        "--icon-text-color": this.content.menuOptions.icon_text_color.hex,
        "--icon-text-hover-color": this.content.menuOptions.icon_text_hover_color.hex,
        "--text-color": this.content.menuOptions.text_color.hex,
        "--text-hover-color": this.content.menuOptions.text_hover_color.hex,
        "--utilities-color": this.theme.utility_link_color.hex
      };
    }
  },
  methods: {
    getPageUrl(e) {
      return e ? `${this.content.pathPrefix}/page/${e.slug}` : "";
    },
    getLinkUrl(e) {
      return e ? e.mailto && e.email_address ? `mailto:${e.email_address}` : e.ipAddress ? `http://${e.url}` : e.url : "";
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    },
    selectItem(e) {
      e.children && e.children.length > 0 && this.currentPath.push(e);
    },
    navigateTo(e) {
      this.currentPath = this.currentPath.slice(0, e + 1);
    },
    resetToMenu() {
      this.currentPath = [];
    },
    buildSchoolsMenu(e) {
      if (Br(e))
        return [];
      const t = (r) => {
        let o = "";
        switch (r) {
          case "SchoolsMenuOrg":
            o = "link";
            break;
          case "SchoolsMenuLink":
            o = "link";
            break;
          case "SchoolsMenuImage":
            o = "image";
            break;
          case "SchoolsMenuHeader":
            o = "header";
            break;
          default:
            o = "link";
            break;
        }
        return o;
      }, n = (r) => r.type === "SchoolsMenuLink" ? r.link : r.type === "SchoolsMenuOrg" && this.content.hasCustomSchoolsMenu ? S0(r, this.content.organizations, {
        isPreview: this.content.isPreview
      }) : qr(r, {
        isPreview: this.content.isPreview,
        currentDomain: window.location.href
      });
      return e.map((r, o) => ({
        id: `schools-${o}`,
        name: r.name,
        slug: r.link || r.path_prefix,
        url: n(r),
        imgSrc: r.url,
        altText: r.alt_text,
        imgHasLink: r.action_on_click === "no_action",
        opens_in_new_tab: r.opens_in_new_tab,
        type: t(r.type),
        children: this.buildSchoolsMenu(r.children)
      }));
    }
  }
}, HD = {
  key: 0,
  class: "heading"
}, FD = ["onClick", "onKeydown"], RD = { key: 1 }, VD = { class: "custom-menu-items" }, BD = ["innerHTML"], jD = ["href", "target"], UD = {
  key: 1,
  class: "utilities"
}, qD = ["href", "target"], GD = {
  key: 2,
  class: "heading-mobile"
}, KD = ["onClick", "onKeydown"], zD = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, ZD = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, xD = ["onClick", "onKeydown"], WD = { class: "name" }, YD = ["src", "alt"], XD = ["innerHTML"], QD = ["href", "target"], JD = ["onClick", "onKeydown"];
function e$(e, t, n, r, o, i) {
  const a = V("MenuIcon");
  return d(), f("div", {
    id: "m6",
    class: "menu",
    style: Z(i.colors)
  }, [
    n.content.menuOptions.menu_titles ? (d(), f("div", HD, [
      c("div", {
        class: _(["breadcrumb", { [n.theme.style]: n.theme.style }])
      }, [
        c("div", {
          class: _(["breadcrumb-item", { active: o.currentPath.length === 0 }])
        }, [
          c("div", {
            tabindex: "0",
            role: "button",
            class: "home",
            onClick: t[0] || (t[0] = (...s) => i.resetToMenu && i.resetToMenu(...s)),
            onKeydown: [
              t[1] || (t[1] = K((...s) => i.resetToMenu && i.resetToMenu(...s), ["enter"])),
              t[2] || (t[2] = K((...s) => i.resetToMenu && i.resetToMenu(...s), ["space"]))
            ]
          }, [
            o.currentPath.length > 0 ? (d(), I(a, {
              key: 0,
              type: n.content.menuOptions.link_icon
            }, null, 8, ["type"])) : T("", !0),
            H(" " + k(n.theme.translations.menu_dropdown_title), 1)
          ], 32)
        ], 2),
        (d(!0), f(J, null, ne(i.breadcrumbTrail, (s, l) => (d(), f("div", {
          key: s.id,
          class: _(["breadcrumb-item", { active: l === i.breadcrumbTrail.length - 1 }])
        }, [
          l !== i.breadcrumbTrail.length - 1 ? (d(), f("div", {
            key: 0,
            tabindex: "0",
            role: "button",
            onClick: (u) => i.navigateTo(l),
            onKeydown: [
              K((u) => i.navigateTo(l), ["enter"]),
              K((u) => i.navigateTo(l), ["space"])
            ]
          }, k(s.name), 41, FD)) : (d(), f("span", RD, k(s.name), 1))
        ], 2))), 128))
      ], 2),
      t[3] || (t[3] = c("div", { class: "line" }, null, -1))
    ])) : T("", !0),
    c("div", VD, [
      (d(!0), f(J, null, ne(n.content.customMenuItems, (s) => (d(), f("div", {
        key: s.id,
        class: "item"
      }, [
        s.icon || s.icon_cms ? (d(), f("span", {
          key: 0,
          class: _(["icon", s.icon_cms && "global-icon"]),
          innerHTML: s.icon || s.icon_cms
        }, null, 10, BD)) : T("", !0),
        c("a", {
          class: "name",
          href: i.getLink(s.url),
          target: i.targetWindow(s)
        }, k(s.name), 9, jD)
      ]))), 128))
    ]),
    i.shouldDisplayUtilities ? (d(), f("div", UD, [
      (d(!0), f(J, null, ne(n.content.utilities, (s) => (d(), f("a", {
        key: s.id,
        href: s.link,
        target: s.opens_in_new_tab ? "_blank" : "",
        class: "utility"
      }, k(s.name), 9, qD))), 128))
    ])) : T("", !0),
    o.currentPath.length > 0 && n.isMobile ? (d(), f("div", GD, [
      (d(!0), f(J, null, ne(i.breadcrumbTrail, (s, l) => (d(), f("div", {
        key: s.id,
        class: _(["breadcrumb", { [n.theme.style]: n.theme.style }])
      }, [
        c("div", {
          tabindex: "0",
          role: "button",
          class: _(["breadcrumb-item", { active: l === i.breadcrumbTrail.length - 1 }]),
          onClick: (u) => i.navigateTo(l - 1),
          onKeydown: [
            K((u) => i.navigateTo(l - 1), ["enter"]),
            K((u) => i.navigateTo(l - 1), ["space"])
          ]
        }, [
          n.content.menuOptions.link_icon === "arrow-2" ? (d(), f("svg", zD, t[4] || (t[4] = [
            c("path", {
              d: "M6 13L11 8L6 3",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))) : (d(), f("svg", ZD, t[5] || (t[5] = [
            c("g", null, [
              c("path", {
                d: "M1.5 8L14.5 8M14.5 8L10.4375 12.875M14.5 8L10.4375 3.125",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]))),
          c("span", null, k(s.name), 1)
        ], 42, KD)
      ], 2))), 128)),
      t[6] || (t[6] = c("div", { class: "line" }, null, -1))
    ])) : T("", !0),
    c("div", {
      class: _(["sitemap-menu-items", { "first-level": o.currentPath.length === 0 && n.isMobile }])
    }, [
      (d(!0), f(J, null, ne(i.currentLevelItems, (s) => (d(), f("div", {
        key: s.id,
        class: _(["item", s.type])
      }, [
        s.type === "header" ? (d(), f("div", {
          key: 0,
          class: "wrapper",
          role: "button",
          tabindex: "0",
          onClick: (l) => i.selectItem(s),
          onKeydown: [
            K((l) => i.selectItem(s), ["enter"]),
            K((l) => i.selectItem(s), ["space"])
          ]
        }, [
          c("span", WD, k(s.name), 1),
          j(a, {
            type: n.content.menuOptions.link_icon
          }, null, 8, ["type"])
        ], 40, xD)) : s.type === "image" ? (d(), f("img", {
          key: 1,
          src: s.imgSrc,
          alt: s.altText
        }, null, 8, YD)) : (d(), f(J, { key: 2 }, [
          s.icon || s.icon_cms ? (d(), f("span", {
            key: 0,
            class: _(["icon", s.icon_cms && "global-icon"]),
            innerHTML: s.icon || s.icon_cms
          }, null, 10, XD)) : T("", !0),
          c("a", {
            class: "name",
            href: s.type === "page" ? i.getPageUrl(s) : i.getLinkUrl(s),
            target: i.targetWindow(s)
          }, k(s.name), 9, QD),
          s.children && s.children.length > 0 ? (d(), f("div", {
            key: 1,
            class: "icon-wrapper",
            role: "button",
            tabindex: "0",
            onClick: (l) => i.selectItem(s),
            onKeydown: [
              K((l) => i.selectItem(s), ["enter"]),
              K((l) => i.selectItem(s), ["space"])
            ]
          }, [
            j(a, {
              type: n.content.menuOptions.link_icon
            }, null, 8, ["type"])
          ], 40, JD)) : T("", !0)
        ], 64))
      ], 2))), 128))
    ], 2)
  ], 4);
}
const t$ = /* @__PURE__ */ B(ND, [["render", e$], ["__scopeId", "data-v-3b4053dc"]]), n$ = {
  components: {
    UtilityBar: ID,
    LanguageDropdown: Ds,
    MenuItem: xt,
    CmsSchoolsMenu: hr,
    M6: t$
  },
  mixins: [lt, Tt],
  mixins: [lt, Tt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    slogan() {
      var n, r, o, i, a;
      const e = (r = (n = this.theme) == null ? void 0 : n.translations) == null ? void 0 : r.school_tag_line, t = (a = (i = (o = this.content) == null ? void 0 : o.globals) == null ? void 0 : i.info) == null ? void 0 : a.school_tag_line;
      return e || t;
    },
    menuButtonIcon() {
      return {
        arrow: "TriangleIcon",
        plus: "PlusIcon",
        hamburger: "HamburgerIcon"
      }[this.theme.menu_icon];
    },
    menuButtonColors() {
      var n, r, o;
      const e = {
        "--dropdown-class": this.content.showMenu ? "open" : "close"
      }, t = {
        plus: {
          "--fill-color": "transparent",
          "--fill-path-color": (n = this.theme.navigation_color) == null ? void 0 : n.hex
        },
        hamburger: {
          "--fill-color": "transparent",
          "--fill-path-color": (r = this.theme.navigation_color) == null ? void 0 : r.hex
        },
        arrow: {
          "--fill-color": (o = this.theme.navigation_color) == null ? void 0 : o.hex
        }
      };
      return ae(ae({}, e), t[this.theme.menu_icon]);
    },
    colors() {
      var e, t, n, r, o, i, a, s, l, u, m, v, g, h, E, C, A, R, O, F, L, D;
      return ae({
        "--bg-color": this.theme.bg_color.hex,
        "--nav-color": (t = (e = this.theme) == null ? void 0 : e.navigation_color) == null ? void 0 : t.hex,
        "--menu-heading-color": (r = (n = this.theme) == null ? void 0 : n.menu_heading_color) == null ? void 0 : r.hex,
        "--menu-heading-line-color": (i = (o = this.theme) == null ? void 0 : o.menu_heading_line_color) == null ? void 0 : i.hex,
        "--school-name-color": (s = (a = this.theme) == null ? void 0 : a.school_name_color) == null ? void 0 : s.hex,
        "--school-menu-text-color": (u = (l = this.theme) == null ? void 0 : l.schools_menu_text_color) == null ? void 0 : u.hex,
        "--school-tagline-color": (v = (m = this.theme) == null ? void 0 : m.school_tagline_color) == null ? void 0 : v.hex,
        "--school-tagline-bg-color": (h = (g = this.theme) == null ? void 0 : g.utility_bg_color) == null ? void 0 : h.hex,
        "--navigation-links": (C = (E = this.theme) == null ? void 0 : E.utility_link_color) == null ? void 0 : C.hex,
        "--language-color": (R = (A = this.theme) == null ? void 0 : A.language_color) == null ? void 0 : R.hex,
        "--search-color": (F = (O = this.theme) == null ? void 0 : O.search_color) == null ? void 0 : F.hex,
        "--background-opacity": `${(D = (L = this.theme) == null ? void 0 : L.background_opacity) != null ? D : "80"}%`
      }, this.signInColors);
    }
  },
  methods: {
    orgLink(e) {
      return qr(e, {
        isPreview: this.isPreview,
        currentDomain: window.location.href
      });
    },
    schoolButtonClick() {
      this.setDropdownVisibility("schoolsbutton"), this.content.showMenu && this.$emit("toggle-menu", !1);
    }
  }
}, r$ = { class: "top-header" }, o$ = { class: "slogan" }, i$ = { class: "menu" }, s$ = { class: "wrapper" }, a$ = { class: "org-banner" }, l$ = ["href"], u$ = ["src"], d$ = { class: "school-info" }, c$ = ["href"], h$ = { class: "menu-buttons" }, m$ = {
  key: 0,
  id: "sign-in-button-wrapper"
}, f$ = ["href"], p$ = { class: "menus" }, g$ = {
  key: 1,
  class: "schools-menu",
  "data-testid": "schools-menu"
}, v$ = { class: "school-links" }, b$ = ["href"], y$ = {
  key: 2,
  class: "schools-menu",
  "data-testid": "schools-menu"
};
function _$(e, t, n, r, o, i) {
  var g, h, E, C;
  const a = V("MenuItem"), s = V("LanguageDropdown"), l = V("UtilityBar"), u = V("M6"), m = V("CmsSchoolsMenu"), v = Ke("click-away");
  return we((d(), f("div", {
    class: "h4",
    style: Z(i.colors)
  }, [
    c("div", r$, [
      c("span", o$, k(i.slogan), 1),
      c("div", i$, [
        j(a, {
          item: "languagebutton",
          theme: e.theme,
          content: e.content,
          "is-uppercase": !0,
          "dropdown-open": e.languageDropdownVisible,
          "theme-overrides": {
            icon: "TriangleIcon",
            colors: {
              "--fill-color": (g = e.theme.language_color) == null ? void 0 : g.hex,
              "--nav-color": (h = e.theme.language_color) == null ? void 0 : h.hex
            }
          },
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides", "onToggleDropdown"]),
        j(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[0] || (t[0] = (A) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]),
        j(a, {
          item: "searchbutton",
          class: "search-button",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--icon-color": (E = e.theme.search_color) == null ? void 0 : E.hex,
              "--nav-color": (C = e.theme.search_color) == null ? void 0 : C.hex
            }
          },
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "theme-overrides", "onToggleSearch"])
      ])
    ]),
    c("div", {
      class: _(["bottom-header", [
        e.theme.shadow_type,
        e.theme.bg_type,
        { expanded: e.isCustomSchoolsMenuVisible || e.schoolDropdownVisible || e.content.showMenu }
      ]])
    }, [
      c("div", s$, [
        c("div", a$, [
          c("a", {
            href: e.logoLink,
            class: "logo"
          }, [
            c("img", {
              src: e.content.globals.logo.url,
              alt: "Return to Home"
            }, null, 8, u$)
          ], 8, l$),
          c("div", d$, [
            e.content.globals.info.customHeader ? (d(), f("h1", {
              key: 0,
              class: _({ "sr-only": e.content.globals.info.customHeader })
            }, k(e.content.globals.info.school_name) + " - " + k(i.slogan), 3)) : T("", !0),
            e.content.globals.info.customHeader ? T("", !0) : (d(), f("a", {
              key: 1,
              href: e.logoLink,
              class: "name"
            }, [
              c("h1", {
                class: _([e.theme.style, "org-name"])
              }, k(e.content.globals.info.school_name), 3),
              c("div", {
                class: _(["slogan", { [e.theme.style]: e.theme.style }])
              }, k(i.slogan), 3)
            ], 8, c$)),
            c("div", h$, [
              j(a, {
                item: "schoolsbutton",
                class: "schools-button",
                theme: e.theme,
                content: e.content,
                "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
                "theme-overrides": {
                  icon: "TriangleIcon"
                },
                onToggleDropdown: i.schoolButtonClick
              }, null, 8, ["theme", "content", "dropdown-open", "onToggleDropdown"]),
              j(a, {
                item: "menubutton",
                class: "desktop-menu-button",
                theme: e.theme,
                content: e.content,
                "theme-overrides": {
                  icon: i.menuButtonIcon,
                  colors: i.menuButtonColors
                },
                onToggleDropdown: e.setDropdownVisibility
              }, null, 8, ["theme", "content", "theme-overrides", "onToggleDropdown"])
            ])
          ])
        ]),
        j(a, {
          item: "menubutton",
          class: "mobile-menu-button",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            icon: i.menuButtonIcon,
            colors: i.menuButtonColors
          },
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "theme-overrides", "onToggleDropdown"]),
        j(l, {
          class: _([[e.theme.style, e.theme.version, e.shrinkCSSClass], "utility-bar-items"]),
          "data-testid": "utility-bar",
          utilities: e.content.utilities,
          "is-editing": e.content.isEditing,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "text-color": e.theme.utility_link_color.hex,
          "onUpdate:utilities": t[1] || (t[1] = (A) => e.$emit("update:utilities", A))
        }, {
          utility: S(({ idx: A }) => [
            M(e.$slots, "utility", { idx: A }, void 0, !0)
          ]),
          _: 3
        }, 8, ["class", "utilities", "is-editing", "wrapper-component", "wrapper-props", "text-color"]),
        e.showSignInButton ? (d(), f("div", m$, [
          c("a", {
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(e.signInText), 9, f$)
        ])) : T("", !0)
      ]),
      c("div", p$, [
        e.menuV6Enabled && e.content.showMenu ? (d(), I(u, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "is-mobile": e.isMobile
        }, null, 8, ["theme", "content", "is-mobile"])) : T("", !0),
        !e.content.hasCustomSchoolsMenu && e.schoolDropdownVisible ? (d(), f("div", g$, [
          c("div", {
            class: _(["heading", { [e.theme.style]: e.theme.style }])
          }, [
            c("div", null, k(e.theme.translations.schools_dropdown_title), 1),
            t[3] || (t[3] = c("div", { class: "line" }, null, -1))
          ], 2),
          c("div", v$, [
            (d(!0), f(J, null, ne(e.content.organizations, (A, R) => (d(), f("a", {
              key: R,
              href: i.orgLink(A),
              class: "link"
            }, k(A.name), 9, b$))), 128))
          ])
        ])) : T("", !0),
        e.content.hasCustomSchoolsMenu && e.isCustomSchoolsMenuVisible ? (d(), f("div", y$, [
          c("div", {
            class: _(["heading", { [e.theme.style]: e.theme.style }])
          }, [
            c("div", null, k(e.theme.translations.schools_dropdown_title), 1),
            t[4] || (t[4] = c("div", { class: "line" }, null, -1))
          ], 2),
          j(m, {
            id: "schoolsmenu",
            ref: "schoolsmenu",
            "data-testid": "custom-schools-menu",
            role: "menu",
            "header-theme": e.theme,
            "org-menu-content": e.content.orgMenuContent,
            organizations: e.content.organizations,
            "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
            "shrink-header": e.shouldShrink,
            "is-preview": e.content.isPreview,
            onFocusLost: t[2] || (t[2] = (A) => e.customSchoolsMenuVisible = !1)
          }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "shrink-header", "is-preview"])
        ])) : T("", !0)
      ])
    ], 2)
  ], 4)), [
    [v, e.closeAllMenus]
  ]);
}
const C$ = /* @__PURE__ */ B(n$, [["render", _$], ["__scopeId", "data-v-755b338b"]]), w$ = ["fill"], T$ = {
  __name: "FilledTriangleArrow",
  props: {
    iconColor: {
      type: String,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (d(), f("svg", {
      class: _(e.isOpen ? "open" : "close"),
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 14 11",
      fill: "none"
    }, [
      c("path", {
        d: "M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z",
        fill: e.iconColor
      }, null, 8, w$)
    ], 2));
  }
}, k$ = /* @__PURE__ */ B(T$, [["__scopeId", "data-v-23478d63"]]), E$ = {
  components: {
    DraggableWrapper: vt,
    HamburgerIcon: k0,
    TriangleIcon: b4,
    FilledTriangleArrow: k$,
    PlusIcon: E0,
    MenuItem: xt,
    CmsSchoolsMenu: hr
  },
  mixins: [lt, Tt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    colors() {
      return ae({
        "--utility-bg-color": this.theme.main_nav_bg === "solid" || !this.isHomepage ? this.theme.utility_bg_color.hex : de(this.theme.utility_bg_color.hex).setAlpha(0.75).toRgbString(),
        "--utility-text-color": this.theme.utility_link_color.hex,
        "--utility-nav-position": this.theme.main_nav_bg === "solid" || !this.isHomepage ? "block" : "absolute",
        "--box-shadow": this.theme.nav_inner_drop_shadow ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25) inset" : "unset",
        "--utility-nav-overflow": this.exploreMenuVisible || this.schoolDropdownVisible || this.customSchoolsMenuVisible || this.isMobile ? "unset" : "auto"
      }, this.signInColors);
    },
    menuDropdownIcon() {
      switch (this.theme.menu_icon) {
        case "arrow":
          return "FilledTriangleArrow";
        case "hamburger":
          return "HamburgerIcon";
        case "plus":
          return "PlusIcon";
        default:
          return "FilledTriangleArrow";
      }
    },
    showTemplateWithSignInButton() {
      return this.showSignInButton && this.isMobile && !this.content.isEditing;
    },
    schoolDropdownAriaControlsValue() {
      return (this.isSchoolDropdownVisible || this.isCustomSchoolsMenuVisible) && this.content.hasCustomSchoolsMenu ? "schoolsmenu" : void 0;
    },
    getExploreDropdownText() {
      var e, t, n, r, o;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.menu_dropdown_title) || ((o = (r = (n = this.theme) == null ? void 0 : n.translations) == null ? void 0 : r.header) == null ? void 0 : o.explore_dropdown_title) || "Explore";
    }
  }
}, S$ = ["aria-expanded", "aria-controls"], M$ = ["href"], A$ = { class: "bottom-bar-item schools-dropdown-wrapper" }, I$ = ["aria-expanded", "aria-controls"], L$ = { class: "bottom-bar-item mobile-right" }, D$ = ["aria-expanded", "aria-controls"], $$ = { class: "bottom-bar-item mobile-right" }, O$ = ["aria-expanded", "aria-controls"], P$ = { class: "bottom-bar-item schools-dropdown-wrapper" }, N$ = ["aria-expanded", "aria-controls"];
function H$(e, t, n, r, o, i) {
  const a = V("TriangleIcon"), s = V("HeaderDropdown"), l = V("cms-schools-menu"), u = V("MenuItem"), m = V("LanguageDropdown"), v = Ke("click-away");
  return d(), f("div", {
    style: Z(i.colors),
    class: _(["bottom-bar", { "show-sign-in-button": e.showSignInButton }]),
    "data-testid": "utility-bar"
  }, [
    i.showTemplateWithSignInButton ? (d(), f(J, { key: 0 }, [
      e.isMobile ? (d(), f("button", {
        key: 0,
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        onClick: t[0] || (t[0] = (g) => e.clickedMenu("menubutton"))
      }, [
        H(k(i.getExploreDropdownText) + " ", 1),
        j(a, {
          "fill-color": i.colors["--utility-text-color"],
          "is-open": e.exploreMenuVisible || e.content.showMenu
        }, null, 8, ["fill-color", "is-open"])
      ], 8, S$)) : T("", !0),
      e.showSignInButton ? (d(), f("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        target: "_blank"
      }, k(e.signInText), 9, M$)) : T("", !0),
      c("div", A$, [
        c("button", {
          id: "schoolsbutton",
          "aria-expanded": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          "aria-controls": i.schoolDropdownAriaControlsValue,
          class: "bottom-bar-item",
          "aria-haspopup": "true",
          onClick: t[1] || (t[1] = (g) => e.clickedMenu("schoolsbutton"))
        }, [
          H(k(e.content.orgDropdownTitle) + " ", 1),
          j(a, {
            "fill-color": i.colors["--utility-text-color"],
            "is-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible
          }, null, 8, ["fill-color", "is-open"])
        ], 8, I$),
        e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), I(s, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          onCloseDropdown: t[2] || (t[2] = (g) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden"])),
        j(Le, { name: "slide" }, {
          default: S(() => [
            e.content.hasCustomSchoolsMenu ? (d(), I(l, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "custom-schools-menu",
              "header-theme": e.theme,
              content: e.customSchoolsMenu,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.customSchoolsMenuVisible,
              "is-preview": e.content.isPreview,
              onHideOnClickaway: t[3] || (t[3] = (g) => e.customSchoolsMenuVisible = !1),
              onFocusLost: t[4] || (t[4] = (g) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "is-preview"])) : T("", !0)
          ]),
          _: 1
        })
      ]),
      c("div", L$, [
        e.shouldDisplayLanguagesDropdown ? (d(), I(u, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--nav-color": void 0
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[5] || (t[5] = (g) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "dropdown-open"])) : T("", !0),
        we(j(m, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[6] || (t[6] = (g) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            v,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ]),
        j(u, {
          theme: e.theme,
          content: e.content,
          "is-mobile-header": e.isMobile,
          item: "searchbutton",
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "is-mobile-header", "onToggleSearch"])
      ])
    ], 64)) : e.isMobile && !e.content.isEditing ? (d(), f(J, { key: 1 }, [
      e.isMobile ? (d(), f("button", {
        key: 0,
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        onClick: t[7] || (t[7] = (g) => e.clickedMenu("menubutton"))
      }, [
        H(k(i.getExploreDropdownText) + " ", 1),
        j(a, {
          "fill-color": i.colors["--utility-text-color"],
          "is-open": e.exploreMenuVisible || e.content.showMenu
        }, null, 8, ["fill-color", "is-open"])
      ], 8, D$)) : T("", !0),
      c("div", $$, [
        e.shouldDisplayLanguagesDropdown ? (d(), I(u, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--nav-color": void 0
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[8] || (t[8] = (g) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "dropdown-open"])) : T("", !0),
        we(j(m, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[9] || (t[9] = (g) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            v,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ]),
        j(u, {
          theme: e.theme,
          content: e.content,
          "is-mobile-header": e.isMobile,
          item: "searchbutton",
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "is-mobile-header", "onToggleSearch"])
      ])
    ], 64)) : (d(), f(J, { key: 2 }, [
      c("button", {
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        "aria-haspopup": "true",
        onClick: t[10] || (t[10] = (g) => e.clickedMenu("menubutton"))
      }, [
        H(k(e.theme.translations.menu_dropdown_title || "Menu") + " ", 1),
        (d(), I(Y(i.menuDropdownIcon), {
          "theme-style": e.theme.style,
          "bg-color": i.colors["--utility-bg-color"],
          "icon-color": i.colors["--utility-text-color"],
          "fill-color": "transparent",
          "fill-path-color": i.colors["--utility-text-color"],
          rx: e.theme.style === "purple" ? "50" : "4",
          "is-open": e.content.showMenu || e.exploreMenuVisible
        }, null, 8, ["theme-style", "bg-color", "icon-color", "fill-path-color", "rx", "is-open"]))
      ], 8, O$),
      c("div", P$, [
        c("button", {
          id: "schoolsbutton",
          "aria-expanded": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          "aria-controls": i.schoolDropdownAriaControlsValue,
          class: "bottom-bar-item",
          "aria-haspopup": "true",
          onClick: t[11] || (t[11] = (g) => e.clickedMenu("schoolsbutton"))
        }, [
          H(k(e.content.orgDropdownTitle) + " ", 1),
          (d(), I(Y(i.menuDropdownIcon), {
            "theme-style": e.theme.style,
            "bg-color": i.colors["--utility-bg-color"],
            "icon-color": i.colors["--utility-text-color"],
            "fill-color": "transparent",
            "fill-path-color": i.colors["--utility-text-color"],
            rx: e.theme.style === "purple" ? "50" : "4",
            "is-open": e.isSchoolDropdownVisible || e.customSchoolsMenuVisible
          }, null, 8, ["theme-style", "bg-color", "icon-color", "fill-path-color", "rx", "is-open"]))
        ], 8, N$),
        e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), I(s, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          onCloseDropdown: t[12] || (t[12] = (g) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden"])),
        j(Le, { name: "slide" }, {
          default: S(() => [
            e.content.hasCustomSchoolsMenu ? (d(), I(l, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "custom-schools-menu",
              "header-theme": e.theme,
              content: e.customSchoolsMenu,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.customSchoolsMenuVisible,
              "is-preview": e.content.isPreview,
              onHideOnClickaway: t[13] || (t[13] = (g) => e.customSchoolsMenuVisible = !1),
              onFocusLost: t[14] || (t[14] = (g) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "is-preview"])) : T("", !0)
          ]),
          _: 1
        })
      ]),
      (d(), I(Y(n.wrapperComponent), Se(n.wrapperProps, {
        "model-value": e.content.utilities,
        "item-key": "idx",
        class: "bottom-bar-utilities-wrapper",
        "onUpdate:modelValue": t[15] || (t[15] = (g) => e.$emit("update:utilities", g))
      }), {
        item: S(({ element: g, index: h }) => [
          (d(), I(Y(e.content.isEditing ? "div" : "a"), {
            class: "bottom-bar-item utilities",
            href: g.link,
            target: g.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "utility", { idx: h }, () => [
                H(k(g.name), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ]),
        _: 3
      }, 16, ["model-value"]))
    ], 64))
  ], 6);
}
const F$ = /* @__PURE__ */ B(E$, [["render", H$], ["__scopeId", "data-v-2e458f1f"]]), R$ = {
  name: "Header5",
  components: {
    UtilityBar: F$,
    OrgBanner: mr,
    MobileHeader: Gr,
    MenuItem: xt
  },
  mixins: [lt, Tt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    colors() {
      var e, t;
      return ae({
        "--top-bar": this.theme.show_top_bar ? `8px solid ${this.theme.top_bar_color.hex}` : "none",
        "--bg-color": this.theme.bg_color.hex,
        "--nav-color": (t = (e = this.theme) == null ? void 0 : e.navigation_color) == null ? void 0 : t.hex
      }, this.signInColors);
    }
  }
}, V$ = {
  key: 0,
  "data-testid": "large-screen-header",
  class: "header-container"
}, B$ = { class: "left" }, j$ = { class: "right" }, U$ = { class: "right-right-menu" }, q$ = { key: 0 }, G$ = ["href"];
function K$(e, t, n, r, o, i) {
  var g, h, E;
  const a = V("OrgBanner"), s = V("MenuItem"), l = V("LanguageDropdown"), u = V("UtilityBar"), m = V("MobileHeader"), v = Ke("click-away");
  return d(), f("div", {
    style: Z(i.colors),
    class: "h5"
  }, [
    !e.isMobile || e.isEditing ? (d(), f("div", V$, [
      c("div", B$, [
        j(a, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      c("div", j$, [
        c("div", U$, [
          e.shouldDisplayLanguagesDropdown ? (d(), f("div", q$, [
            j(s, {
              theme: e.theme,
              content: e.content,
              item: "languagebutton",
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--icon-color": (g = e.theme.navigation_color) == null ? void 0 : g.hex,
                  "--fill-color": "transparent",
                  "--fill-path-color": (h = e.theme.navigation_color) == null ? void 0 : h.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onToggleDropdown: t[0] || (t[0] = (C) => e.clickedMenu("languagebutton"))
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
            we(j(l, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[1] || (t[1] = (C) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
              [
                v,
                () => {
                  e.languageDropdownVisible = !1;
                }
              ]
            ])
          ])) : T("", !0),
          j(s, {
            theme: e.theme,
            content: e.content,
            item: "searchbutton",
            "theme-overrides": {
              colors: {
                "--bg-color": "transparent",
                "--fill-color": "transparent",
                "--fill-path-color": (E = e.theme.navigation_color) == null ? void 0 : E.hex
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["theme", "content", "theme-overrides", "onToggleSearch"]),
          e.showSignInButton ? (d(), f("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(e.signInText), 9, G$)) : T("", !0)
        ])
      ])
    ])) : (d(), I(m, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "hide-menu-button": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onCloseMenu: e.closeAllMenus
    }, {
      bottom: S(() => [
        j(u, {
          content: e.content,
          "is-homepage": e.isHomepage,
          "is-mobile": e.isMobile,
          theme: e.theme,
          "show-sign-in-button": e.showSignInButton,
          onToggleMenu: t[2] || (t[2] = (C) => e.$emit("toggle-mobile-menu", C)),
          onToggleSearch: e.toggleSearch,
          onLanguageChange: t[3] || (t[3] = (C) => e.$emit("language-change", C))
        }, null, 8, ["content", "is-homepage", "is-mobile", "theme", "show-sign-in-button", "onToggleSearch"])
      ]),
      _: 1
    }, 8, ["theme", "content", "onCloseMenu"])),
    !e.isMobile || e.isEditing ? (d(), I(u, {
      key: 2,
      content: e.content,
      "is-homepage": e.isHomepage,
      "is-mobile": e.isMobile,
      theme: e.theme,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      onToggleMenu: t[4] || (t[4] = (C) => e.$emit("toggle-menu", C)),
      "onUpdate:utilities": t[5] || (t[5] = (C) => e.$emit("update:utilities", C))
    }, {
      utility: S(({ idx: C }) => [
        M(e.$slots, "utility", { idx: C }, void 0, !0)
      ]),
      _: 3
    }, 8, ["content", "is-homepage", "is-mobile", "theme", "wrapper-component", "wrapper-props"])) : T("", !0)
  ], 4);
}
const z$ = /* @__PURE__ */ B(R$, [["render", K$], ["__scopeId", "data-v-da475bf3"]]), Z$ = {
  components: {
    CmsSchoolsMenu: hr,
    MenuItem: xt
  },
  mixins: [lt, Tt, Rt],
  props: {
    textColor: {
      type: String,
      required: !0
    },
    largeSize: {
      type: Boolean,
      default: !1
    }
  }
}, x$ = { class: "header-nav-wrapper" }, W$ = { class: "left button-group" }, Y$ = {
  key: 1,
  class: "language-button-wrapper"
}, X$ = { class: "center" }, Q$ = {
  key: 0,
  class: "schools-menu-container"
}, J$ = ["href"];
function eO(e, t, n, r, o, i) {
  var v, g, h, E, C, A, R, O, F, L, D, P, U;
  const a = V("MenuItem"), s = V("LanguageDropdown"), l = V("HeaderDropdown"), u = V("CmsSchoolsMenu"), m = Ke("click-away");
  return d(), f("div", x$, [
    c("div", W$, [
      n.largeSize ? T("", !0) : (d(), I(a, {
        key: 0,
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (v = e.theme.utility_link_color) == null ? void 0 : v.hex
          }
        },
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "theme-overrides", "screen-size", "onToggleSearch"])),
      e.shouldDisplayLanguagesDropdown ? (d(), f("div", Y$, [
        j(a, {
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (g = e.theme.navigation_color) == null ? void 0 : g.hex : (h = e.theme.utility_link_color) == null ? void 0 : h.hex,
              "--nav-color": n.largeSize ? (E = e.theme.navigation_color) == null ? void 0 : E.hex : (C = e.theme.utility_link_color) == null ? void 0 : C.hex
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[0] || (t[0] = (q) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
        we(j(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[1] || (t[1] = (q) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            m,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ])
      ])) : T("", !0),
      n.largeSize ? (d(), I(a, {
        key: 2,
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (A = e.theme.navigation_color) == null ? void 0 : A.hex,
            "--nav-color": (R = e.theme.navigation_color) == null ? void 0 : R.hex
          }
        },
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "theme-overrides", "screen-size", "onToggleSearch"])) : T("", !0)
    ]),
    c("div", X$, [
      M(e.$slots, "default", {}, void 0, !0)
    ]),
    c("div", {
      class: _([[n.largeSize ? "" : "small-bar"], "right button-group"])
    }, [
      e.shouldDisplaySchoolsDropdown && !e.isMobile ? (d(), f("div", Q$, [
        j(a, {
          item: "schoolsbutton",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (O = e.theme.navigation_color) == null ? void 0 : O.hex : (F = e.theme.utility_link_color) == null ? void 0 : F.hex,
              "--nav-color": n.largeSize ? (L = e.theme.navigation_color) == null ? void 0 : L.hex : (D = e.theme.utility_link_color) == null ? void 0 : D.hex
            }
          },
          "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
        e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), I(l, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          "is-shrink": e.shrinkCSSClass === "shrink",
          onCloseDropdown: t[2] || (t[2] = (q) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
        j(Le, { name: "slide" }, {
          default: S(() => [
            e.content.hasCustomSchoolsMenu ? (d(), I(u, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "schools-menu",
              "header-theme": e.theme,
              content: e.content.globals.homepage,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
              "sticky-header": e.shouldBeSticky,
              "shrink-header": e.shouldShrink,
              "is-preview": e.content.isPreview,
              onFocusLost: t[3] || (t[3] = (q) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
          ]),
          _: 1
        })
      ])) : T("", !0),
      c("div", null, [
        j(a, {
          theme: e.theme,
          content: e.content,
          "dropdown-open": e.content.showMenu,
          "theme-overrides": {
            icon: "HamburgerIcon",
            colors: {
              "--nav-color": n.textColor,
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (P = e.theme.navigation_color) == null ? void 0 : P.hex : (U = e.theme.utility_link_color) == null ? void 0 : U.hex
            }
          },
          item: "explore-button",
          onToggleDropdown: t[4] || (t[4] = (q) => e.clickedMenu("menubutton"))
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
        e.menuV4Enabled && e.content.showMenu ? (d(), I(l, {
          key: 0,
          id: "explore-menu",
          "data-testid": "explore-menu",
          "aria-labelledby": "explore-button",
          styles: e.theme,
          data: e.content.sitemapMenuItems,
          "menu-v4-enabled": e.menuV4Enabled,
          "is-visible": e.exploreMenuVisible,
          "path-prefix": e.content.pathPrefix,
          "is-shrink": e.shrinkCSSClass === "shrink",
          onCloseDropdown: t[5] || (t[5] = (q) => e.exploreMenuVisible = !1)
        }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : T("", !0)
      ]),
      e.showSignInButton ? (d(), f("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        "data-testid": "desktop-signin-button",
        target: "_blank"
      }, k(e.signInText), 9, J$)) : T("", !0)
    ], 2)
  ]);
}
const tO = /* @__PURE__ */ B(Z$, [["render", eO], ["__scopeId", "data-v-950897bb"]]);
function nO(e) {
  return Qp() ? (Jp(e), !0) : !1;
}
const rO = typeof window != "undefined" && typeof document != "undefined";
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
function oO(e) {
  return eg();
}
function iO(e) {
  return Array.isArray(e) ? e : [e];
}
function sO(e, t = !0, n) {
  oO() ? Jc(e, n) : t ? e() : bc(e);
}
const H4 = rO ? window : void 0;
function ro(e) {
  var t;
  const n = tg(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function aO() {
  const e = b6(!1), t = eg();
  return t && Jc(() => {
    e.value = !0;
  }, t), e;
}
function lO(e) {
  const t = aO();
  return Mn(() => (t.value, !!e()));
}
function uO(e, t, n = {}) {
  const v = n, { window: r = H4 } = v, o = Js(v, ["window"]);
  let i;
  const a = lO(() => r && "ResizeObserver" in r), s = () => {
    i && (i.disconnect(), i = void 0);
  }, l = Mn(() => {
    const g = tg(e);
    return Array.isArray(g) ? g.map((h) => ro(h)) : [ro(g)];
  }), u = vs(
    l,
    (g) => {
      if (s(), a.value && r) {
        i = new ResizeObserver(t);
        for (const h of g)
          h && i.observe(h, o);
      }
    },
    { immediate: !0, flush: "post" }
  ), m = () => {
    s(), u();
  };
  return nO(m), {
    isSupported: a,
    stop: m
  };
}
function dO(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: r = H4, box: o = "content-box" } = n, i = Mn(() => {
    var v, g;
    return (g = (v = ro(e)) == null ? void 0 : v.namespaceURI) == null ? void 0 : g.includes("svg");
  }), a = ho(t.width), s = ho(t.height), { stop: l } = uO(
    e,
    ([v]) => {
      const g = o === "border-box" ? v.borderBoxSize : o === "content-box" ? v.contentBoxSize : v.devicePixelContentBoxSize;
      if (r && i.value) {
        const h = ro(e);
        if (h) {
          const E = h.getBoundingClientRect();
          a.value = E.width, s.value = E.height;
        }
      } else if (g) {
        const h = iO(g);
        a.value = h.reduce((E, { inlineSize: C }) => E + C, 0), s.value = h.reduce((E, { blockSize: C }) => E + C, 0);
      } else
        a.value = v.contentRect.width, s.value = v.contentRect.height;
    },
    n
  );
  sO(() => {
    const v = ro(e);
    v && (a.value = "offsetWidth" in v ? v.offsetWidth : t.width, s.value = "offsetHeight" in v ? v.offsetHeight : t.height);
  });
  const u = vs(
    () => ro(e),
    (v) => {
      a.value = v ? t.width : 0, s.value = v ? t.height : 0;
    }
  );
  function m() {
    l(), u();
  }
  return {
    width: a,
    height: s,
    stop: m
  };
}
const cO = {
  name: "Header6",
  components: {
    OrgBanner: mr,
    MobileHeader: Gr,
    HeaderNav: tO
  },
  mixins: [lt],
  setup() {
    const e = y6("headerElement"), { width: t } = dO(e);
    return {
      headerWidth: t
    };
  },
  computed: {
    colors() {
      return ae({
        "--utility-bg-color": this.theme.utility_bg_color.hex,
        "--utility-text-color": this.theme.utility_link_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--bg-color": this.theme.bg_color.hex
      }, this.signInColors);
    }
  }
}, hO = {
  key: 0,
  class: "header-container"
}, mO = { class: "org-banner-wrapper" }, fO = {
  key: 1,
  class: "org-banner-wrapper smaller-screen"
}, pO = {
  key: 2,
  class: "bottom-nav"
}, gO = { class: "mobile-header-top" }, vO = { class: "org-banner-wrapper" }, bO = { class: "bottom-nav" }, yO = ["href"];
function _O(e, t, n, r, o, i) {
  const a = V("OrgBanner"), s = V("HeaderNav"), l = V("MobileHeader");
  return d(), f("div", {
    ref: "headerElement",
    style: Z(i.colors),
    class: "h6"
  }, [
    e.isMobile ? (d(), I(l, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[9] || (t[9] = (u) => e.$emit("toggle-mobile-menu")),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: S(() => [
        c("div", gO, [
          c("div", vO, [
            j(a, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          c("div", bO, [
            j(s, {
              theme: e.theme,
              content: e.content,
              "show-sign-in-button": e.showSignInButton,
              "sign-in-url": e.signInUrl,
              "text-color": e.theme.utility_link_color.hex,
              "bg-color": e.theme.utility_bg_color.hex,
              "is-mobile": "",
              onLanguageChange: t[6] || (t[6] = (u) => e.$emit("language-change", u)),
              onToggleSearch: t[7] || (t[7] = (u) => e.$emit("toggle-search")),
              onToggleMenu: t[8] || (t[8] = (u) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
            }, null, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color", "bg-color"])
          ])
        ])
      ]),
      "menu-top": S(() => [
        e.showSignInButton && r.headerWidth <= 320 ? (d(), f("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, k(e.signInText), 9, yO)) : T("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"])) : (d(), f("div", hO, [
      r.headerWidth > 1280 ? (d(), I(s, {
        key: 0,
        theme: e.theme,
        content: e.content,
        "show-sign-in-button": e.showSignInButton,
        "sign-in-url": e.signInUrl,
        "large-size": "",
        "text-color": e.theme.navigation_color.hex,
        onLanguageChange: t[0] || (t[0] = (u) => e.$emit("language-change", u)),
        onToggleSearch: t[1] || (t[1] = (u) => e.$emit("toggle-search")),
        onToggleMenu: t[2] || (t[2] = (u) => e.$emit("toggle-menu", u))
      }, {
        default: S(() => [
          c("div", mO, [
            j(a, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ])
        ]),
        _: 1
      }, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color"])) : (d(), f("div", fO, [
        j(a, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals,
          class: "org-banner"
        }, null, 8, ["logo-link", "theme", "globals"])
      ])),
      r.headerWidth <= 1280 ? (d(), f("div", pO, [
        j(s, {
          theme: e.theme,
          content: e.content,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "text-color": e.theme.utility_link_color.hex,
          onLanguageChange: t[3] || (t[3] = (u) => e.$emit("language-change", u)),
          onToggleSearch: t[4] || (t[4] = (u) => e.$emit("toggle-search")),
          onToggleMenu: t[5] || (t[5] = (u) => e.$emit("toggle-menu", u))
        }, null, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color"])
      ])) : T("", !0)
    ]))
  ], 4);
}
const CO = /* @__PURE__ */ B(cO, [["render", _O], ["__scopeId", "data-v-e1b257fb"]]), wO = {
  name: "H7TopBar",
  components: { DraggableWrapper: vt, MenuItem: xt },
  mixins: [lt, Tt, Rt],
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-mobile-menu"]
}, TO = { class: "right-icons" }, kO = { key: 0 }, EO = ["href"];
function SO(e, t, n, r, o, i) {
  const a = V("MenuItem"), s = V("LanguageDropdown"), l = Ke("click-away");
  return d(), f("div", {
    class: "top-bar",
    style: Z({
      "--nav-color": n.theme.utility_link_color.hex
    })
  }, [
    n.content.isEditing || !e.isMobile ? (d(), I(Y(n.wrapperComponent), Se({ key: 0 }, n.wrapperProps, {
      "model-value": n.content.utilities,
      "item-key": "idx",
      class: "utilities-container",
      "data-testid": "utility-bar",
      "onUpdate:modelValue": t[0] || (t[0] = (u) => e.$emit("update:utilities", u))
    }), {
      item: S(({ element: u, index: m }) => [
        (d(), I(Y(n.content.isEditing ? "div" : "a"), {
          class: "utility",
          href: u.link,
          target: u.opens_in_new_tab ? "_blank" : ""
        }, {
          default: S(() => [
            M(e.$slots, "utility", { idx: m }, () => [
              H(k(u.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value"])) : T("", !0),
    c("div", TO, [
      e.shouldDisplayLanguagesDropdown ? (d(), f("div", kO, [
        j(a, {
          theme: n.theme,
          content: n.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.theme.utility_link_color.hex,
              "--bg-color": "transparent",
              "--nav-color": n.theme.utility_link_color.hex
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[1] || (t[1] = (u) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
        we(j(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: n.content.languages,
          styles: n.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": n.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[2] || (t[2] = (u) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            l,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ])
      ])) : T("", !0),
      j(a, {
        theme: n.theme,
        content: n.content,
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "screen-size", "onToggleSearch"]),
      e.showSignInButton && e.screenSize > 320 ? (d(), f("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        "data-testid": "desktop-signin-button",
        target: "_blank"
      }, k(e.signInText), 9, EO)) : T("", !0),
      e.screenSize <= 320 ? (d(), I(a, {
        key: 2,
        theme: n.theme,
        content: n.content,
        "dropdown-open": n.content.showMenu,
        "theme-overrides": {
          icon: "HamburgerIcon",
          colors: {
            "--fill-color": "transparent",
            "--fill-path-color": n.theme.utility_link_color.hex,
            "--bg-color": "transparent"
          }
        },
        item: "explore-button",
        onToggleDropdown: t[3] || (t[3] = (u) => e.$emit("toggle-mobile-menu", !n.content.showMenu))
      }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"])) : T("", !0)
    ])
  ], 4);
}
const MO = /* @__PURE__ */ B(wO, [["render", SO], ["__scopeId", "data-v-5fbe6bc7"]]), AO = {
  name: "Header7",
  components: {
    CmsSchoolsMenu: hr,
    OrgBanner: mr,
    MobileHeader: Gr,
    MenuItem: xt,
    TopBar: MO
  },
  mixins: [lt, Rt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-mobile-menu"],
  computed: {
    colors() {
      return ae({
        "--top-bar-bg-color": this.theme.utility_bg_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--top-bar-text-color": this.theme.utility_link_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--text-color": this.theme.bg_color.hex
      }, this.signInColors);
    }
  }
}, IO = {
  key: 1,
  class: "header-container"
}, LO = { class: "header-container-left" }, DO = { class: "header-container-right" }, $O = {
  key: 0,
  class: "schools-menu-container"
}, OO = { class: "mobile-header-top" }, PO = { class: "org-banner-wrapper" }, NO = ["href"];
function HO(e, t, n, r, o, i) {
  const a = V("TopBar"), s = V("OrgBanner"), l = V("MenuItem"), u = V("HeaderDropdown"), m = V("CmsSchoolsMenu"), v = V("MobileHeader");
  return d(), f("div", {
    style: Z(i.colors),
    class: "h7"
  }, [
    !e.isMobile || e.content.isEditing ? (d(), I(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onLanguageChange: e.setLanguage,
      onToggleSearch: e.toggleSearch,
      "onUpdate:utilities": t[0] || (t[0] = (g) => e.$emit("update:utilities", g))
    }, {
      utility: S(({ idx: g }) => [
        M(e.$slots, "utility", { idx: g }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onLanguageChange", "onToggleSearch"])) : T("", !0),
    !e.isMobile || e.content.isEditing ? (d(), f("div", IO, [
      c("div", LO, [
        j(s, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      c("div", DO, [
        e.shouldDisplaySchoolsDropdown ? (d(), f("div", $O, [
          j(l, {
            item: "schoolsbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
            onToggleDropdown: e.setDropdownVisibility
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
          e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), I(u, {
            key: 0,
            id: "schoolsmenu",
            "data-testid": "schools-menu",
            "aria-labelledby": "schoolsbutton",
            styles: e.theme,
            data: e.content.organizations,
            "is-visible": e.schoolDropdownVisible,
            "is-preview": e.content.isPreview,
            "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[1] || (t[1] = (g) => e.schoolDropdownVisible = !1)
          }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
          j(Le, { name: "slide" }, {
            default: S(() => [
              e.content.hasCustomSchoolsMenu ? (d(), I(m, {
                key: 0,
                id: "schoolsmenu",
                ref: "schoolsmenu",
                "data-testid": "schools-menu",
                "header-theme": e.theme,
                content: e.content.globals.homepage,
                "org-menu-content": e.content.orgMenuContent,
                organizations: e.content.organizations,
                "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                "sticky-header": e.shouldBeSticky,
                "shrink-header": e.shouldShrink,
                "is-preview": e.content.isPreview,
                onFocusLost: t[2] || (t[2] = (g) => e.customSchoolsMenuVisible = !1)
              }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
            ]),
            _: 1
          })
        ])) : T("", !0),
        c("div", null, [
          j(l, {
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            item: "explore-button",
            onToggleDropdown: t[3] || (t[3] = (g) => e.clickedMenu("menubutton"))
          }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
          e.menuV4Enabled && e.content.showMenu ? (d(), I(u, {
            key: 0,
            id: "explore-menu",
            "data-testid": "explore-menu",
            "aria-labelledby": "explore-button",
            styles: e.theme,
            data: e.content.sitemapMenuItems,
            "menu-v4-enabled": e.menuV4Enabled,
            "is-visible": e.exploreMenuVisible,
            "path-prefix": e.content.pathPrefix,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[4] || (t[4] = (g) => e.exploreMenuVisible = !1)
          }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : T("", !0)
        ])
      ])
    ])) : (d(), I(v, {
      key: 2,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[7] || (t[7] = (g) => e.$emit("toggle-mobile-menu", g)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: S(() => [
        j(a, {
          theme: e.theme,
          content: e.content,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "is-mobile": "",
          onToggleMobileMenu: t[5] || (t[5] = (g) => e.$emit("toggle-mobile-menu", g)),
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"]),
        c("div", OO, [
          c("div", PO, [
            j(s, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          e.screenSize > 320 ? (d(), I(l, {
            key: 0,
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            item: "explore-button",
            onToggleDropdown: t[6] || (t[6] = (g) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
          }, null, 8, ["theme", "content", "dropdown-open"])) : T("", !0)
        ])
      ]),
      "menu-top": S(() => [
        e.showSignInButton && e.screenSize <= 320 ? (d(), f("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, k(e.signInText), 9, NO)) : T("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4);
}
const FO = /* @__PURE__ */ B(AO, [["render", HO], ["__scopeId", "data-v-ef0abdd8"]]), RO = {
  name: "H8TopBar",
  components: { DraggableWrapper: vt, MenuItem: xt },
  mixins: [lt, Tt, Rt],
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "update:icon-links", "toggle-mobile-menu", "open-icon-modal"]
}, VO = { class: "right-utilities-wrapper" }, BO = ["innerHTML"], jO = { class: "other-utility-options" }, UO = { key: 0 }, qO = ["href"];
function GO(e, t, n, r, o, i) {
  const a = V("MenuItem"), s = V("LanguageDropdown"), l = Ke("click-away");
  return d(), f("div", {
    class: "top-bar",
    style: Z({
      "--nav-color": n.theme.utility_link_color.hex
    })
  }, [
    n.content.isEditing || !e.isMobile ? (d(), I(Y(n.wrapperComponent), Se({ key: 0 }, n.wrapperProps, {
      "model-value": n.content.utilities,
      "item-key": "idx",
      class: "utilities-container",
      "data-testid": "utility-bar",
      "onUpdate:modelValue": t[0] || (t[0] = (u) => e.$emit("update:utilities", u))
    }), {
      item: S(({ element: u, index: m }) => [
        (d(), I(Y(n.content.isEditing ? "div" : "a"), {
          class: "utility",
          href: u.link,
          target: u.opens_in_new_tab ? "_blank" : ""
        }, {
          default: S(() => [
            M(e.$slots, "utility", { idx: m }, () => [
              H(k(u.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value"])) : T("", !0),
    c("div", VO, [
      n.content.isEditing || !e.isMobile ? (d(), I(Y(n.wrapperComponent), Se({ key: 0 }, n.wrapperProps, {
        "model-value": n.content.iconLinks,
        "item-key": "idx",
        class: "icon-links-container",
        "data-testid": "icon-links-section",
        "onUpdate:modelValue": t[2] || (t[2] = (u) => e.$emit("update:icon-links", u))
      }), {
        item: S(({ element: u, index: m }) => [
          n.theme.version === "H8" && n.theme.style === "texas" ? (d(), I(Y(n.content.isEditing ? "div" : "a"), {
            key: 0,
            class: "icon-link",
            href: u.link,
            target: u.opens_in_new_tab ? "_blank" : "",
            "aria-label": u.name
          }, {
            default: S(() => [
              M(e.$slots, "iconLink", { idx: m }, () => [
                c("span", {
                  "data-testid": "svg",
                  onClick: t[1] || (t[1] = (v) => e.$emit("open-icon-modal")),
                  innerHTML: u.icon
                }, null, 8, BO)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target", "aria-label"])) : T("", !0)
        ]),
        _: 3
      }, 16, ["model-value"])) : T("", !0),
      c("div", jO, [
        e.shouldDisplayLanguagesDropdown ? (d(), f("div", UO, [
          j(a, {
            theme: n.theme,
            content: n.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": n.theme.utility_link_color.hex,
                "--bg-color": "transparent",
                "--nav-color": n.theme.utility_link_color.hex
              }
            },
            item: "languagebutton",
            "dropdown-open": e.languageDropdownVisible,
            onToggleDropdown: t[3] || (t[3] = (u) => e.clickedMenu("languagebutton"))
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
          we(j(s, {
            id: "languagesmenu",
            "data-testid": "languages-menu",
            role: "menu",
            data: n.content.languages,
            styles: n.theme,
            "is-visible": e.languageDropdownVisible,
            "current-language": n.content.langCode,
            onSetLanguage: e.setLanguage,
            onCloseDropdown: t[4] || (t[4] = (u) => e.languageDropdownVisible = !1)
          }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
            [
              l,
              () => {
                e.languageDropdownVisible = !1;
              }
            ]
          ])
        ])) : T("", !0),
        j(a, {
          theme: n.theme,
          content: n.content,
          item: "searchbutton",
          "screen-size": e.screenSize,
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "screen-size", "onToggleSearch"]),
        e.showSignInButton && e.screenSize > 320 ? (d(), f("a", {
          key: 1,
          href: e.signInUrl,
          class: "sign-in-button",
          "data-testid": "desktop-signin-button",
          target: "_blank"
        }, k(e.signInText), 9, qO)) : T("", !0),
        e.screenSize <= 320 ? (d(), I(a, {
          key: 2,
          theme: n.theme,
          content: n.content,
          "dropdown-open": n.content.showMenu,
          "theme-overrides": {
            icon: "HamburgerIcon",
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.theme.utility_link_color.hex,
              "--bg-color": "transparent"
            }
          },
          item: "explore-button",
          onToggleDropdown: t[5] || (t[5] = (u) => e.$emit("toggle-mobile-menu", !n.content.showMenu))
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"])) : T("", !0)
      ])
    ])
  ], 4);
}
const KO = /* @__PURE__ */ B(RO, [["render", GO], ["__scopeId", "data-v-50c1cbcc"]]), zO = {
  name: "Header8",
  components: {
    CmsSchoolsMenu: hr,
    OrgBanner: mr,
    MobileHeader: Gr,
    MenuItem: xt,
    H8TopBar: KO
  },
  mixins: [lt, Rt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "update:icon-links", "open-icon-modal", "toggle-mobile-menu"],
  computed: {
    colors() {
      return ae({
        "--top-bar-bg-color": this.theme.utility_bg_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--top-bar-text-color": this.theme.utility_link_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--icon-link-color": this.theme.icon_link_color.hex
      }, this.signInColors);
    }
  }
}, ZO = {
  key: 1,
  class: "header-container"
}, xO = { class: "header-container-left" }, WO = { class: "header-container-right" }, YO = {
  key: 0,
  class: "schools-menu-container"
}, XO = { class: "mobile-header-top" }, QO = { class: "org-banner-wrapper" }, JO = ["href"];
function eP(e, t, n, r, o, i) {
  const a = V("H8TopBar"), s = V("OrgBanner"), l = V("MenuItem"), u = V("HeaderDropdown"), m = V("CmsSchoolsMenu"), v = V("MobileHeader");
  return d(), f("div", {
    style: Z(i.colors),
    class: "h8"
  }, [
    !e.isMobile || e.content.isEditing ? (d(), I(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onLanguageChange: e.setLanguage,
      onOpenIconModal: t[0] || (t[0] = (g) => e.$emit("open-icon-modal", g)),
      onToggleSearch: e.toggleSearch,
      "onUpdate:utilities": t[1] || (t[1] = (g) => e.$emit("update:utilities", g)),
      "onUpdate:iconLinks": t[2] || (t[2] = (g) => e.$emit("update:icon-links", g))
    }, {
      utility: S(({ idx: g }) => [
        M(e.$slots, "utility", { idx: g }, void 0, !0)
      ]),
      iconLink: S(({ idx: g }) => [
        M(e.$slots, "iconLink", { idx: g }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onLanguageChange", "onToggleSearch"])) : T("", !0),
    !e.isMobile || e.content.isEditing ? (d(), f("div", ZO, [
      c("div", xO, [
        j(s, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      c("div", WO, [
        e.shouldDisplaySchoolsDropdown ? (d(), f("div", YO, [
          j(l, {
            item: "schoolsbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
            onToggleDropdown: e.setDropdownVisibility
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
          e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), I(u, {
            key: 0,
            id: "schoolsmenu",
            "data-testid": "schools-menu",
            "aria-labelledby": "schoolsbutton",
            styles: e.theme,
            data: e.content.organizations,
            "is-visible": e.schoolDropdownVisible,
            "is-preview": e.content.isPreview,
            "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[3] || (t[3] = (g) => e.schoolDropdownVisible = !1)
          }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
          j(Le, { name: "slide" }, {
            default: S(() => [
              e.content.hasCustomSchoolsMenu ? (d(), I(m, {
                key: 0,
                id: "schoolsmenu",
                ref: "schoolsmenu",
                "data-testid": "schools-menu",
                "header-theme": e.theme,
                content: e.content.globals.homepage,
                "org-menu-content": e.content.orgMenuContent,
                organizations: e.content.organizations,
                "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                "sticky-header": e.shouldBeSticky,
                "shrink-header": e.shouldShrink,
                "is-preview": e.content.isPreview,
                onFocusLost: t[4] || (t[4] = (g) => e.customSchoolsMenuVisible = !1)
              }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
            ]),
            _: 1
          })
        ])) : T("", !0),
        c("div", null, [
          j(l, {
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            item: "explore-button",
            onToggleDropdown: t[5] || (t[5] = (g) => e.clickedMenu("menubutton"))
          }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
          e.menuV4Enabled && e.content.showMenu ? (d(), I(u, {
            key: 0,
            id: "explore-menu",
            "data-testid": "explore-menu",
            "aria-labelledby": "explore-button",
            styles: e.theme,
            data: e.content.sitemapMenuItems,
            "menu-v4-enabled": e.menuV4Enabled,
            "is-visible": e.exploreMenuVisible,
            "path-prefix": e.content.pathPrefix,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[6] || (t[6] = (g) => e.exploreMenuVisible = !1)
          }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : T("", !0)
        ])
      ])
    ])) : (d(), I(v, {
      key: 2,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[9] || (t[9] = (g) => e.$emit("toggle-mobile-menu", g)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: S(() => [
        j(a, {
          theme: e.theme,
          content: e.content,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "is-mobile": "",
          onToggleMobileMenu: t[7] || (t[7] = (g) => e.$emit("toggle-mobile-menu", g)),
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"]),
        c("div", XO, [
          c("div", QO, [
            j(s, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          e.screenSize > 320 ? (d(), I(l, {
            key: 0,
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            item: "explore-button",
            onToggleDropdown: t[8] || (t[8] = (g) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
          }, null, 8, ["theme", "content", "dropdown-open"])) : T("", !0)
        ])
      ]),
      "menu-top": S(() => [
        e.showSignInButton && e.screenSize <= 320 ? (d(), f("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, k(e.signInText), 9, JO)) : T("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4);
}
const tP = /* @__PURE__ */ B(zO, [["render", eP], ["__scopeId", "data-v-919a6f56"]]);
var nP = Object.defineProperty, rP = Object.defineProperties, oP = Object.getOwnPropertyDescriptors, pm = Object.getOwnPropertySymbols, iP = Object.prototype.hasOwnProperty, sP = Object.prototype.propertyIsEnumerable, gm = (e, t, n) => t in e ? nP(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Bn = (e, t) => {
  for (var n in t || (t = {}))
    iP.call(t, n) && gm(e, n, t[n]);
  if (pm)
    for (var n of pm(t))
      sP.call(t, n) && gm(e, n, t[n]);
  return e;
}, A0 = (e, t) => rP(e, oP(t));
function vm(e) {
  if (e)
    throw e;
}
var Vi = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ko(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var bm, ym;
function aP() {
  return ym || (ym = 1, bm = function(e) {
    return e != null && e.constructor != null && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
  }), bm;
}
var lP = aP();
const F4 = /* @__PURE__ */ ko(lP);
var Dl, _m;
function uP() {
  if (_m) return Dl;
  _m = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, o = function(l) {
    return typeof Array.isArray == "function" ? Array.isArray(l) : t.call(l) === "[object Array]";
  }, i = function(l) {
    if (!l || t.call(l) !== "[object Object]")
      return !1;
    var u = e.call(l, "constructor"), m = l.constructor && l.constructor.prototype && e.call(l.constructor.prototype, "isPrototypeOf");
    if (l.constructor && !u && !m)
      return !1;
    var v;
    for (v in l)
      ;
    return typeof v == "undefined" || e.call(l, v);
  }, a = function(l, u) {
    n && u.name === "__proto__" ? n(l, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : l[u.name] = u.newValue;
  }, s = function(l, u) {
    if (u === "__proto__")
      if (e.call(l, u)) {
        if (r)
          return r(l, u).value;
      } else return;
    return l[u];
  };
  return Dl = function l() {
    var u, m, v, g, h, E, C = arguments[0], A = 1, R = arguments.length, O = !1;
    for (typeof C == "boolean" && (O = C, C = arguments[1] || {}, A = 2), (C == null || typeof C != "object" && typeof C != "function") && (C = {}); A < R; ++A)
      if (u = arguments[A], u != null)
        for (m in u)
          v = s(C, m), g = s(u, m), C !== g && (O && g && (i(g) || (h = o(g))) ? (h ? (h = !1, E = v && o(v) ? v : []) : E = v && i(v) ? v : {}, a(C, { name: m, newValue: l(O, E, g) })) : typeof g != "undefined" && a(C, { name: m, newValue: g }));
    return C;
  }, Dl;
}
var dP = uP();
const Cm = /* @__PURE__ */ ko(dP);
function Vc(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function cP() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...o) {
    let i = -1;
    const a = o.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    s(null, ...o);
    function s(l, ...u) {
      const m = e[++i];
      let v = -1;
      if (l) {
        a(l);
        return;
      }
      for (; ++v < o.length; )
        (u[v] === null || u[v] === void 0) && (u[v] = o[v]);
      o = u, m ? hP(m, s)(...u) : a(null, ...u);
    }
  }
  function r(o) {
    if (typeof o != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + o
      );
    return e.push(o), t;
  }
}
function hP(e, t) {
  let n;
  return r;
  function r(...a) {
    const s = e.length > a.length;
    let l;
    s && a.push(o);
    try {
      l = e.apply(this, a);
    } catch (u) {
      const m = (
        /** @type {Error} */
        u
      );
      if (s && n)
        throw m;
      return o(m);
    }
    s || (l && l.then && typeof l.then == "function" ? l.then(i, o) : l instanceof Error ? o(l) : i(l));
  }
  function o(a, ...s) {
    n || (n = !0, t(a, ...s));
  }
  function i(a) {
    o(null, a);
  }
}
function mP(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? wm(e.position) : "start" in e || "end" in e ? wm(e) : "line" in e || "column" in e ? Bc(e) : "";
}
function Bc(e) {
  return Tm(e && e.line) + ":" + Tm(e && e.column);
}
function wm(e) {
  return Bc(e && e.start) + "-" + Bc(e && e.end);
}
function Tm(e) {
  return e && typeof e == "number" ? e : 1;
}
class rn extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(t, n, r) {
    const o = [null, null];
    let i = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
      const a = r.indexOf(":");
      a === -1 ? o[1] = r : (o[0] = r.slice(0, a), o[1] = r.slice(a + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (i = n.position) : "start" in n || "end" in n ? i = n : ("line" in n || "column" in n) && (i.start = n)), this.name = mP(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = "", typeof t == "object" && t.stack && (this.stack = t.stack), this.reason = this.message, this.fatal, this.line = i.start.line, this.column = i.start.column, this.position = i, this.source = o[0], this.ruleId = o[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
rn.prototype.file = "";
rn.prototype.name = "";
rn.prototype.reason = "";
rn.prototype.message = "";
rn.prototype.stack = "";
rn.prototype.fatal = null;
rn.prototype.column = null;
rn.prototype.line = null;
rn.prototype.source = null;
rn.prototype.ruleId = null;
rn.prototype.position = null;
const Cn = { basename: fP, dirname: pP, extname: gP, join: vP, sep: "/" };
function fP(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  fi(e);
  let n = 0, r = -1, o = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; o--; )
      if (e.charCodeAt(o) === 47) {
        if (i) {
          n = o + 1;
          break;
        }
      } else r < 0 && (i = !0, r = o + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, s = t.length - 1;
  for (; o--; )
    if (e.charCodeAt(o) === 47) {
      if (i) {
        n = o + 1;
        break;
      }
    } else
      a < 0 && (i = !0, a = o + 1), s > -1 && (e.charCodeAt(o) === t.charCodeAt(s--) ? s < 0 && (r = o) : (s = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function pP(e) {
  if (fi(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.charCodeAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function gP(e) {
  fi(e);
  let t = e.length, n = -1, r = 0, o = -1, i = 0, a;
  for (; t--; ) {
    const s = e.charCodeAt(t);
    if (s === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), s === 46 ? o < 0 ? o = t : i !== 1 && (i = 1) : o > -1 && (i = -1);
  }
  return o < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && o === n - 1 && o === r + 1 ? "" : e.slice(o, n);
}
function vP(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    fi(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : bP(n);
}
function bP(e) {
  fi(e);
  const t = e.charCodeAt(0) === 47;
  let n = yP(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function yP(e, t) {
  let n = "", r = 0, o = -1, i = 0, a = -1, s, l;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      s = e.charCodeAt(a);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(o === a - 1 || i === 1)) if (o !== a - 1 && i === 2) {
        if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (l = n.lastIndexOf("/"), l !== n.length - 1) {
              l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), o = a, i = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, o = a, i = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(o + 1, a) : n = e.slice(o + 1, a), r = a - o - 1;
      o = a, i = 0;
    } else s === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function fi(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const _P = { cwd: CP };
function CP() {
  return "/";
}
function jc(e) {
  return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
  e.href && // @ts-expect-error: indexable.
  e.origin;
}
function wP(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!jc(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return TP(e);
}
function TP(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
      const r = t.charCodeAt(n + 2);
      if (r === 70 || r === 102) {
        const o = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw o.code = "ERR_INVALID_FILE_URL_PATH", o;
      }
    }
  return decodeURIComponent(t);
}
const $l = ["history", "path", "basename", "stem", "extname", "dirname"];
class kP {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? typeof t == "string" || EP(t) ? n = { value: t } : jc(t) ? n = { path: t } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = _P.cwd(), this.value, this.stored, this.result, this.map;
    let r = -1;
    for (; ++r < $l.length; ) {
      const i = $l[r];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let o;
    for (o in n)
      $l.includes(o) || (this[o] = n[o]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(t) {
    jc(t) && (t = wP(t)), Pl(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? Cn.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(t) {
    km(this.basename, "dirname"), this.path = Cn.join(t || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? Cn.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(t) {
    Pl(t, "basename"), Ol(t, "basename"), this.path = Cn.join(this.dirname || "", t);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? Cn.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(t) {
    if (Ol(t, "extname"), km(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Cn.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? Cn.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(t) {
    Pl(t, "stem"), Ol(t, "stem"), this.path = Cn.join(this.dirname || "", t + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return (this.value || "").toString(t || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const o = new rn(t, n, r);
    return this.path && (o.name = this.path + ":" + o.name, o.file = this.path), o.fatal = !1, this.messages.push(o), o;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const o = this.message(t, n, r);
    return o.fatal = null, o;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const o = this.message(t, n, r);
    throw o.fatal = !0, o;
  }
}
function Ol(e, t) {
  if (e && e.includes(Cn.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Cn.sep + "`"
    );
}
function Pl(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function km(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function EP(e) {
  return F4(e);
}
const Uc = V4().freeze(), R4 = {}.hasOwnProperty;
function V4() {
  const e = cP(), t = [];
  let n = {}, r, o = -1;
  return i.data = a, i.Parser = void 0, i.Compiler = void 0, i.freeze = s, i.attachers = t, i.use = l, i.parse = u, i.stringify = m, i.run = v, i.runSync = g, i.process = h, i.processSync = E, i;
  function i() {
    const C = V4();
    let A = -1;
    for (; ++A < t.length; )
      C.use(...t[A]);
    return C.data(Cm(!0, {}, n)), C;
  }
  function a(C, A) {
    return typeof C == "string" ? arguments.length === 2 ? (Fl("data", r), n[C] = A, i) : R4.call(n, C) && n[C] || null : C ? (Fl("data", r), n = C, i) : n;
  }
  function s() {
    if (r)
      return i;
    for (; ++o < t.length; ) {
      const [C, ...A] = t[o];
      if (A[0] === !1)
        continue;
      A[0] === !0 && (A[0] = void 0);
      const R = C.call(i, ...A);
      typeof R == "function" && e.use(R);
    }
    return r = !0, o = Number.POSITIVE_INFINITY, i;
  }
  function l(C, ...A) {
    let R;
    if (Fl("use", r), C != null) if (typeof C == "function")
      D(C, ...A);
    else if (typeof C == "object")
      Array.isArray(C) ? L(C) : F(C);
    else
      throw new TypeError("Expected usable value, not `" + C + "`");
    return R && (n.settings = Object.assign(n.settings || {}, R)), i;
    function O(P) {
      if (typeof P == "function")
        D(P);
      else if (typeof P == "object")
        if (Array.isArray(P)) {
          const [U, ...q] = P;
          D(U, ...q);
        } else
          F(P);
      else
        throw new TypeError("Expected usable value, not `" + P + "`");
    }
    function F(P) {
      L(P.plugins), P.settings && (R = Object.assign(R || {}, P.settings));
    }
    function L(P) {
      let U = -1;
      if (P != null) if (Array.isArray(P))
        for (; ++U < P.length; ) {
          const q = P[U];
          O(q);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + P + "`");
    }
    function D(P, U) {
      let q = -1, z;
      for (; ++q < t.length; )
        if (t[q][0] === P) {
          z = t[q];
          break;
        }
      z ? (Vc(z[1]) && Vc(U) && (U = Cm(!0, z[1], U)), z[1] = U) : t.push([...arguments]);
    }
  }
  function u(C) {
    i.freeze();
    const A = Ro(C), R = i.Parser;
    return Nl("parse", R), Em(R, "parse") ? new R(String(A), A).parse() : R(String(A), A);
  }
  function m(C, A) {
    i.freeze();
    const R = Ro(A), O = i.Compiler;
    return Hl("stringify", O), Sm(C), Em(O, "compile") ? new O(C, R).compile() : O(C, R);
  }
  function v(C, A, R) {
    if (Sm(C), i.freeze(), !R && typeof A == "function" && (R = A, A = void 0), !R)
      return new Promise(O);
    O(null, R);
    function O(F, L) {
      e.run(C, Ro(A), D);
      function D(P, U, q) {
        U = U || C, P ? L(P) : F ? F(U) : R(null, U, q);
      }
    }
  }
  function g(C, A) {
    let R, O;
    return i.run(C, A, F), Mm("runSync", "run", O), R;
    function F(L, D) {
      vm(L), R = D, O = !0;
    }
  }
  function h(C, A) {
    if (i.freeze(), Nl("process", i.Parser), Hl("process", i.Compiler), !A)
      return new Promise(R);
    R(null, A);
    function R(O, F) {
      const L = Ro(C);
      i.run(i.parse(L), L, (P, U, q) => {
        if (P || !U || !q)
          D(P);
        else {
          const z = i.stringify(U, q);
          z == null || (AP(z) ? q.value = z : q.result = z), D(P, q);
        }
      });
      function D(P, U) {
        P || !U ? F(P) : O ? O(U) : A(null, U);
      }
    }
  }
  function E(C) {
    let A;
    i.freeze(), Nl("processSync", i.Parser), Hl("processSync", i.Compiler);
    const R = Ro(C);
    return i.process(R, O), Mm("processSync", "process", A), R;
    function O(F) {
      A = !0, vm(F);
    }
  }
}
function Em(e, t) {
  return typeof e == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (SP(e.prototype) || t in e.prototype);
}
function SP(e) {
  let t;
  for (t in e)
    if (R4.call(e, t))
      return !0;
  return !1;
}
function Nl(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function Hl(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function Fl(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Sm(e) {
  if (!Vc(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Mm(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Ro(e) {
  return MP(e) ? e : new kP(e);
}
function MP(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function AP(e) {
  return typeof e == "string" || F4(e);
}
var _n = {}, Am;
function I0() {
  if (Am) return _n;
  Am = 1;
  const e = [
    65534,
    65535,
    131070,
    131071,
    196606,
    196607,
    262142,
    262143,
    327678,
    327679,
    393214,
    393215,
    458750,
    458751,
    524286,
    524287,
    589822,
    589823,
    655358,
    655359,
    720894,
    720895,
    786430,
    786431,
    851966,
    851967,
    917502,
    917503,
    983038,
    983039,
    1048574,
    1048575,
    1114110,
    1114111
  ];
  return _n.REPLACEMENT_CHARACTER = "�", _n.CODE_POINTS = {
    EOF: -1,
    NULL: 0,
    TABULATION: 9,
    CARRIAGE_RETURN: 13,
    LINE_FEED: 10,
    FORM_FEED: 12,
    SPACE: 32,
    EXCLAMATION_MARK: 33,
    QUOTATION_MARK: 34,
    NUMBER_SIGN: 35,
    AMPERSAND: 38,
    APOSTROPHE: 39,
    HYPHEN_MINUS: 45,
    SOLIDUS: 47,
    DIGIT_0: 48,
    DIGIT_9: 57,
    SEMICOLON: 59,
    LESS_THAN_SIGN: 60,
    EQUALS_SIGN: 61,
    GREATER_THAN_SIGN: 62,
    QUESTION_MARK: 63,
    LATIN_CAPITAL_A: 65,
    LATIN_CAPITAL_F: 70,
    LATIN_CAPITAL_X: 88,
    LATIN_CAPITAL_Z: 90,
    RIGHT_SQUARE_BRACKET: 93,
    GRAVE_ACCENT: 96,
    LATIN_SMALL_A: 97,
    LATIN_SMALL_F: 102,
    LATIN_SMALL_X: 120,
    LATIN_SMALL_Z: 122,
    REPLACEMENT_CHARACTER: 65533
  }, _n.CODE_POINT_SEQUENCES = {
    DASH_DASH_STRING: [45, 45],
    //--
    DOCTYPE_STRING: [68, 79, 67, 84, 89, 80, 69],
    //DOCTYPE
    CDATA_START_STRING: [91, 67, 68, 65, 84, 65, 91],
    //[CDATA[
    SCRIPT_STRING: [115, 99, 114, 105, 112, 116],
    //script
    PUBLIC_STRING: [80, 85, 66, 76, 73, 67],
    //PUBLIC
    SYSTEM_STRING: [83, 89, 83, 84, 69, 77]
    //SYSTEM
  }, _n.isSurrogate = function(t) {
    return t >= 55296 && t <= 57343;
  }, _n.isSurrogatePair = function(t) {
    return t >= 56320 && t <= 57343;
  }, _n.getSurrogatePairCodePoint = function(t, n) {
    return (t - 55296) * 1024 + 9216 + n;
  }, _n.isControlCodePoint = function(t) {
    return t !== 32 && t !== 10 && t !== 13 && t !== 9 && t !== 12 && t >= 1 && t <= 31 || t >= 127 && t <= 159;
  }, _n.isUndefinedCodePoint = function(t) {
    return t >= 64976 && t <= 65007 || e.indexOf(t) > -1;
  }, _n;
}
var Im, Lm;
function L0() {
  return Lm || (Lm = 1, Im = {
    controlCharacterInInputStream: "control-character-in-input-stream",
    noncharacterInInputStream: "noncharacter-in-input-stream",
    surrogateInInputStream: "surrogate-in-input-stream",
    nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
    endTagWithAttributes: "end-tag-with-attributes",
    endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
    unexpectedSolidusInTag: "unexpected-solidus-in-tag",
    unexpectedNullCharacter: "unexpected-null-character",
    unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
    invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
    unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
    missingEndTagName: "missing-end-tag-name",
    unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
    unknownNamedCharacterReference: "unknown-named-character-reference",
    missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
    unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
    unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
    eofBeforeTagName: "eof-before-tag-name",
    eofInTag: "eof-in-tag",
    missingAttributeValue: "missing-attribute-value",
    missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
    missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
    missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
    missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
    missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
    missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
    missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
    missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
    abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
    abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
    cdataInHtmlContent: "cdata-in-html-content",
    incorrectlyOpenedComment: "incorrectly-opened-comment",
    eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
    eofInDoctype: "eof-in-doctype",
    nestedComment: "nested-comment",
    abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
    eofInComment: "eof-in-comment",
    incorrectlyClosedComment: "incorrectly-closed-comment",
    eofInCdata: "eof-in-cdata",
    absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
    nullCharacterReference: "null-character-reference",
    surrogateCharacterReference: "surrogate-character-reference",
    characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
    controlCharacterReference: "control-character-reference",
    noncharacterCharacterReference: "noncharacter-character-reference",
    missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
    missingDoctypeName: "missing-doctype-name",
    invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
    duplicateAttribute: "duplicate-attribute",
    nonConformingDoctype: "non-conforming-doctype",
    missingDoctype: "missing-doctype",
    misplacedDoctype: "misplaced-doctype",
    endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
    closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
    disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
    openElementsLeftAfterEof: "open-elements-left-after-eof",
    abandonedHeadElementChild: "abandoned-head-element-child",
    misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
    nestedNoscriptInHead: "nested-noscript-in-head",
    eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
  }), Im;
}
var Rl, Dm;
function IP() {
  if (Dm) return Rl;
  Dm = 1;
  const e = I0(), t = L0(), n = e.CODE_POINTS, r = 65536;
  class o {
    constructor() {
      this.html = null, this.pos = -1, this.lastGapPos = -1, this.lastCharPos = -1, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = r;
    }
    _err() {
    }
    _addGap() {
      this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
    }
    _processSurrogate(a) {
      if (this.pos !== this.lastCharPos) {
        const s = this.html.charCodeAt(this.pos + 1);
        if (e.isSurrogatePair(s))
          return this.pos++, this._addGap(), e.getSurrogatePairCodePoint(a, s);
      } else if (!this.lastChunkWritten)
        return this.endOfChunkHit = !0, n.EOF;
      return this._err(t.surrogateInInputStream), a;
    }
    dropParsedChunk() {
      this.pos > this.bufferWaterline && (this.lastCharPos -= this.pos, this.html = this.html.substring(this.pos), this.pos = 0, this.lastGapPos = -1, this.gapStack = []);
    }
    write(a, s) {
      this.html ? this.html += a : this.html = a, this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1, this.lastChunkWritten = s;
    }
    insertHtmlAtCurrentPos(a) {
      this.html = this.html.substring(0, this.pos + 1) + a + this.html.substring(this.pos + 1, this.html.length), this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1;
    }
    advance() {
      if (this.pos++, this.pos > this.lastCharPos)
        return this.endOfChunkHit = !this.lastChunkWritten, n.EOF;
      let a = this.html.charCodeAt(this.pos);
      return this.skipNextNewLine && a === n.LINE_FEED ? (this.skipNextNewLine = !1, this._addGap(), this.advance()) : a === n.CARRIAGE_RETURN ? (this.skipNextNewLine = !0, n.LINE_FEED) : (this.skipNextNewLine = !1, e.isSurrogate(a) && (a = this._processSurrogate(a)), a > 31 && a < 127 || a === n.LINE_FEED || a === n.CARRIAGE_RETURN || a > 159 && a < 64976 || this._checkForProblematicCharacters(a), a);
    }
    _checkForProblematicCharacters(a) {
      e.isControlCodePoint(a) ? this._err(t.controlCharacterInInputStream) : e.isUndefinedCodePoint(a) && this._err(t.noncharacterInInputStream);
    }
    retreat() {
      this.pos === this.lastGapPos && (this.lastGapPos = this.gapStack.pop(), this.pos--), this.pos--;
    }
  }
  return Rl = o, Rl;
}
var $m, Om;
function LP() {
  return Om || (Om = 1, $m = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4e3, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 1e4, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13e3, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204])), $m;
}
var Vl, Pm;
function Os() {
  if (Pm) return Vl;
  Pm = 1;
  const e = IP(), t = I0(), n = LP(), r = L0(), o = t.CODE_POINTS, i = t.CODE_POINT_SEQUENCES, a = {
    128: 8364,
    130: 8218,
    131: 402,
    132: 8222,
    133: 8230,
    134: 8224,
    135: 8225,
    136: 710,
    137: 8240,
    138: 352,
    139: 8249,
    140: 338,
    142: 381,
    145: 8216,
    146: 8217,
    147: 8220,
    148: 8221,
    149: 8226,
    150: 8211,
    151: 8212,
    152: 732,
    153: 8482,
    154: 353,
    155: 8250,
    156: 339,
    158: 382,
    159: 376
  }, s = 1, l = 2, u = 4, m = s | l | u, v = "DATA_STATE", g = "RCDATA_STATE", h = "RAWTEXT_STATE", E = "SCRIPT_DATA_STATE", C = "PLAINTEXT_STATE", A = "TAG_OPEN_STATE", R = "END_TAG_OPEN_STATE", O = "TAG_NAME_STATE", F = "RCDATA_LESS_THAN_SIGN_STATE", L = "RCDATA_END_TAG_OPEN_STATE", D = "RCDATA_END_TAG_NAME_STATE", P = "RAWTEXT_LESS_THAN_SIGN_STATE", U = "RAWTEXT_END_TAG_OPEN_STATE", q = "RAWTEXT_END_TAG_NAME_STATE", z = "SCRIPT_DATA_LESS_THAN_SIGN_STATE", te = "SCRIPT_DATA_END_TAG_OPEN_STATE", ee = "SCRIPT_DATA_END_TAG_NAME_STATE", x = "SCRIPT_DATA_ESCAPE_START_STATE", N = "SCRIPT_DATA_ESCAPE_START_DASH_STATE", G = "SCRIPT_DATA_ESCAPED_STATE", X = "SCRIPT_DATA_ESCAPED_DASH_STATE", Q = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE", re = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE", se = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE", ue = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE", me = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE", he = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE", _e = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE", De = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE", Ae = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE", ze = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE", Qe = "BEFORE_ATTRIBUTE_NAME_STATE", Et = "ATTRIBUTE_NAME_STATE", Vt = "AFTER_ATTRIBUTE_NAME_STATE", mn = "BEFORE_ATTRIBUTE_VALUE_STATE", fn = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE", pn = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE", gn = "ATTRIBUTE_VALUE_UNQUOTED_STATE", Ln = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE", St = "SELF_CLOSING_START_TAG_STATE", ce = "BOGUS_COMMENT_STATE", Mt = "MARKUP_DECLARATION_OPEN_STATE", le = "COMMENT_START_STATE", fe = "COMMENT_START_DASH_STATE", Pe = "COMMENT_STATE", Re = "COMMENT_LESS_THAN_SIGN_STATE", At = "COMMENT_LESS_THAN_SIGN_BANG_STATE", Ze = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE", be = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE", Je = "COMMENT_END_DASH_STATE", ht = "COMMENT_END_STATE", Wt = "COMMENT_END_BANG_STATE", vn = "DOCTYPE_STATE", et = "BEFORE_DOCTYPE_NAME_STATE", mt = "DOCTYPE_NAME_STATE", bn = "AFTER_DOCTYPE_NAME_STATE", Wn = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE", It = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE", Ce = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE", Ne = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE", Dn = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE", wi = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE", Ti = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE", Yn = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE", pr = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE", gr = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE", $n = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE", ut = "BOGUS_DOCTYPE_STATE", On = "CDATA_SECTION_STATE", ki = "CDATA_SECTION_BRACKET_STATE", Ei = "CDATA_SECTION_END_STATE", Xn = "CHARACTER_REFERENCE_STATE", Yt = "NAMED_CHARACTER_REFERENCE_STATE", Si = "AMBIGUOS_AMPERSAND_STATE", Ao = "NUMERIC_CHARACTER_REFERENCE_STATE", Mi = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE", Ai = "DECIMAL_CHARACTER_REFERENCE_START_STATE", Ii = "HEXADEMICAL_CHARACTER_REFERENCE_STATE", Li = "DECIMAL_CHARACTER_REFERENCE_STATE", vr = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
  function Me(ve) {
    return ve === o.SPACE || ve === o.LINE_FEED || ve === o.TABULATION || ve === o.FORM_FEED;
  }
  function br(ve) {
    return ve >= o.DIGIT_0 && ve <= o.DIGIT_9;
  }
  function Lt(ve) {
    return ve >= o.LATIN_CAPITAL_A && ve <= o.LATIN_CAPITAL_Z;
  }
  function Pn(ve) {
    return ve >= o.LATIN_SMALL_A && ve <= o.LATIN_SMALL_Z;
  }
  function yt(ve) {
    return Pn(ve) || Lt(ve);
  }
  function Io(ve) {
    return yt(ve) || br(ve);
  }
  function Lo(ve) {
    return ve >= o.LATIN_CAPITAL_A && ve <= o.LATIN_CAPITAL_F;
  }
  function Di(ve) {
    return ve >= o.LATIN_SMALL_A && ve <= o.LATIN_SMALL_F;
  }
  function Ws(ve) {
    return br(ve) || Lo(ve) || Di(ve);
  }
  function Wr(ve) {
    return ve + 32;
  }
  function je(ve) {
    return ve <= 65535 ? String.fromCharCode(ve) : (ve -= 65536, String.fromCharCode(ve >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | ve & 1023));
  }
  function yn(ve) {
    return String.fromCharCode(Wr(ve));
  }
  function Do(ve, w) {
    const Te = n[++ve];
    let _t = ++ve, st = _t + Te - 1;
    for (; _t <= st; ) {
      const dt = _t + st >>> 1, tt = n[dt];
      if (tt < w)
        _t = dt + 1;
      else if (tt > w)
        st = dt - 1;
      else
        return n[dt + Te];
    }
    return -1;
  }
  class $e {
    constructor() {
      this.preprocessor = new e(), this.tokenQueue = [], this.allowCDATA = !1, this.state = v, this.returnState = "", this.charRefCode = -1, this.tempBuff = [], this.lastStartTagName = "", this.consumedAfterSnapshot = -1, this.active = !1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = null;
    }
    //Errors
    _err() {
    }
    _errOnNextCodePoint(w) {
      this._consume(), this._err(w), this._unconsume();
    }
    //API
    getNextToken() {
      for (; !this.tokenQueue.length && this.active; ) {
        this.consumedAfterSnapshot = 0;
        const w = this._consume();
        this._ensureHibernation() || this[this.state](w);
      }
      return this.tokenQueue.shift();
    }
    write(w, Te) {
      this.active = !0, this.preprocessor.write(w, Te);
    }
    insertHtmlAtCurrentPos(w) {
      this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(w);
    }
    //Hibernation
    _ensureHibernation() {
      if (this.preprocessor.endOfChunkHit) {
        for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
          this.preprocessor.retreat();
        return this.active = !1, this.tokenQueue.push({ type: $e.HIBERNATION_TOKEN }), !0;
      }
      return !1;
    }
    //Consumption
    _consume() {
      return this.consumedAfterSnapshot++, this.preprocessor.advance();
    }
    _unconsume() {
      this.consumedAfterSnapshot--, this.preprocessor.retreat();
    }
    _reconsumeInState(w) {
      this.state = w, this._unconsume();
    }
    _consumeSequenceIfMatch(w, Te, _t) {
      let st = 0, dt = !0;
      const tt = w.length;
      let Ue = 0, Yr = Te, $o;
      for (; Ue < tt; Ue++) {
        if (Ue > 0 && (Yr = this._consume(), st++), Yr === o.EOF) {
          dt = !1;
          break;
        }
        if ($o = w[Ue], Yr !== $o && (_t || Yr !== Wr($o))) {
          dt = !1;
          break;
        }
      }
      if (!dt)
        for (; st--; )
          this._unconsume();
      return dt;
    }
    //Temp buffer
    _isTempBufferEqualToScriptString() {
      if (this.tempBuff.length !== i.SCRIPT_STRING.length)
        return !1;
      for (let w = 0; w < this.tempBuff.length; w++)
        if (this.tempBuff[w] !== i.SCRIPT_STRING[w])
          return !1;
      return !0;
    }
    //Token creation
    _createStartTagToken() {
      this.currentToken = {
        type: $e.START_TAG_TOKEN,
        tagName: "",
        selfClosing: !1,
        ackSelfClosing: !1,
        attrs: []
      };
    }
    _createEndTagToken() {
      this.currentToken = {
        type: $e.END_TAG_TOKEN,
        tagName: "",
        selfClosing: !1,
        attrs: []
      };
    }
    _createCommentToken() {
      this.currentToken = {
        type: $e.COMMENT_TOKEN,
        data: ""
      };
    }
    _createDoctypeToken(w) {
      this.currentToken = {
        type: $e.DOCTYPE_TOKEN,
        name: w,
        forceQuirks: !1,
        publicId: null,
        systemId: null
      };
    }
    _createCharacterToken(w, Te) {
      this.currentCharacterToken = {
        type: w,
        chars: Te
      };
    }
    _createEOFToken() {
      this.currentToken = { type: $e.EOF_TOKEN };
    }
    //Tag attributes
    _createAttr(w) {
      this.currentAttr = {
        name: w,
        value: ""
      };
    }
    _leaveAttrName(w) {
      $e.getTokenAttr(this.currentToken, this.currentAttr.name) === null ? this.currentToken.attrs.push(this.currentAttr) : this._err(r.duplicateAttribute), this.state = w;
    }
    _leaveAttrValue(w) {
      this.state = w;
    }
    //Token emission
    _emitCurrentToken() {
      this._emitCurrentCharacterToken();
      const w = this.currentToken;
      this.currentToken = null, w.type === $e.START_TAG_TOKEN ? this.lastStartTagName = w.tagName : w.type === $e.END_TAG_TOKEN && (w.attrs.length > 0 && this._err(r.endTagWithAttributes), w.selfClosing && this._err(r.endTagWithTrailingSolidus)), this.tokenQueue.push(w);
    }
    _emitCurrentCharacterToken() {
      this.currentCharacterToken && (this.tokenQueue.push(this.currentCharacterToken), this.currentCharacterToken = null);
    }
    _emitEOFToken() {
      this._createEOFToken(), this._emitCurrentToken();
    }
    //Characters emission
    //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(w, Te) {
      this.currentCharacterToken && this.currentCharacterToken.type !== w && this._emitCurrentCharacterToken(), this.currentCharacterToken ? this.currentCharacterToken.chars += Te : this._createCharacterToken(w, Te);
    }
    _emitCodePoint(w) {
      let Te = $e.CHARACTER_TOKEN;
      Me(w) ? Te = $e.WHITESPACE_CHARACTER_TOKEN : w === o.NULL && (Te = $e.NULL_CHARACTER_TOKEN), this._appendCharToCurrentCharacterToken(Te, je(w));
    }
    _emitSeveralCodePoints(w) {
      for (let Te = 0; Te < w.length; Te++)
        this._emitCodePoint(w[Te]);
    }
    //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
    //So we can avoid additional checks here.
    _emitChars(w) {
      this._appendCharToCurrentCharacterToken($e.CHARACTER_TOKEN, w);
    }
    // Character reference helpers
    _matchNamedCharacterReference(w) {
      let Te = null, _t = 1, st = Do(0, w);
      for (this.tempBuff.push(w); st > -1; ) {
        const dt = n[st], tt = dt < m;
        tt && dt & s && (Te = dt & l ? [n[++st], n[++st]] : [n[++st]], _t = 0);
        const Ue = this._consume();
        if (this.tempBuff.push(Ue), _t++, Ue === o.EOF)
          break;
        tt ? st = dt & u ? Do(st, Ue) : -1 : st = Ue === dt ? ++st : -1;
      }
      for (; _t--; )
        this.tempBuff.pop(), this._unconsume();
      return Te;
    }
    _isCharacterReferenceInAttribute() {
      return this.returnState === fn || this.returnState === pn || this.returnState === gn;
    }
    _isCharacterReferenceAttributeQuirk(w) {
      if (!w && this._isCharacterReferenceInAttribute()) {
        const Te = this._consume();
        return this._unconsume(), Te === o.EQUALS_SIGN || Io(Te);
      }
      return !1;
    }
    _flushCodePointsConsumedAsCharacterReference() {
      if (this._isCharacterReferenceInAttribute())
        for (let w = 0; w < this.tempBuff.length; w++)
          this.currentAttr.value += je(this.tempBuff[w]);
      else
        this._emitSeveralCodePoints(this.tempBuff);
      this.tempBuff = [];
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
    [v](w) {
      this.preprocessor.dropParsedChunk(), w === o.LESS_THAN_SIGN ? this.state = A : w === o.AMPERSAND ? (this.returnState = v, this.state = Xn) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitCodePoint(w)) : w === o.EOF ? this._emitEOFToken() : this._emitCodePoint(w);
    }
    //  RCDATA state
    //------------------------------------------------------------------
    [g](w) {
      this.preprocessor.dropParsedChunk(), w === o.AMPERSAND ? (this.returnState = g, this.state = Xn) : w === o.LESS_THAN_SIGN ? this.state = F : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? this._emitEOFToken() : this._emitCodePoint(w);
    }
    // RAWTEXT state
    //------------------------------------------------------------------
    [h](w) {
      this.preprocessor.dropParsedChunk(), w === o.LESS_THAN_SIGN ? this.state = P : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? this._emitEOFToken() : this._emitCodePoint(w);
    }
    // Script data state
    //------------------------------------------------------------------
    [E](w) {
      this.preprocessor.dropParsedChunk(), w === o.LESS_THAN_SIGN ? this.state = z : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? this._emitEOFToken() : this._emitCodePoint(w);
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
    [C](w) {
      this.preprocessor.dropParsedChunk(), w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? this._emitEOFToken() : this._emitCodePoint(w);
    }
    // Tag open state
    //------------------------------------------------------------------
    [A](w) {
      w === o.EXCLAMATION_MARK ? this.state = Mt : w === o.SOLIDUS ? this.state = R : yt(w) ? (this._createStartTagToken(), this._reconsumeInState(O)) : w === o.QUESTION_MARK ? (this._err(r.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(), this._reconsumeInState(ce)) : w === o.EOF ? (this._err(r.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken()) : (this._err(r.invalidFirstCharacterOfTagName), this._emitChars("<"), this._reconsumeInState(v));
    }
    // End tag open state
    //------------------------------------------------------------------
    [R](w) {
      yt(w) ? (this._createEndTagToken(), this._reconsumeInState(O)) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingEndTagName), this.state = v) : w === o.EOF ? (this._err(r.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken()) : (this._err(r.invalidFirstCharacterOfTagName), this._createCommentToken(), this._reconsumeInState(ce));
    }
    // Tag name state
    //------------------------------------------------------------------
    [O](w) {
      Me(w) ? this.state = Qe : w === o.SOLIDUS ? this.state = St : w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : Lt(w) ? this.currentToken.tagName += yn(w) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.tagName += t.REPLACEMENT_CHARACTER) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : this.currentToken.tagName += je(w);
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
    [F](w) {
      w === o.SOLIDUS ? (this.tempBuff = [], this.state = L) : (this._emitChars("<"), this._reconsumeInState(g));
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
    [L](w) {
      yt(w) ? (this._createEndTagToken(), this._reconsumeInState(D)) : (this._emitChars("</"), this._reconsumeInState(g));
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
    [D](w) {
      if (Lt(w))
        this.currentToken.tagName += yn(w), this.tempBuff.push(w);
      else if (Pn(w))
        this.currentToken.tagName += je(w), this.tempBuff.push(w);
      else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (Me(w)) {
            this.state = Qe;
            return;
          }
          if (w === o.SOLIDUS) {
            this.state = St;
            return;
          }
          if (w === o.GREATER_THAN_SIGN) {
            this.state = v, this._emitCurrentToken();
            return;
          }
        }
        this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(g);
      }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    [P](w) {
      w === o.SOLIDUS ? (this.tempBuff = [], this.state = U) : (this._emitChars("<"), this._reconsumeInState(h));
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    [U](w) {
      yt(w) ? (this._createEndTagToken(), this._reconsumeInState(q)) : (this._emitChars("</"), this._reconsumeInState(h));
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    [q](w) {
      if (Lt(w))
        this.currentToken.tagName += yn(w), this.tempBuff.push(w);
      else if (Pn(w))
        this.currentToken.tagName += je(w), this.tempBuff.push(w);
      else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (Me(w)) {
            this.state = Qe;
            return;
          }
          if (w === o.SOLIDUS) {
            this.state = St;
            return;
          }
          if (w === o.GREATER_THAN_SIGN) {
            this._emitCurrentToken(), this.state = v;
            return;
          }
        }
        this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(h);
      }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
    [z](w) {
      w === o.SOLIDUS ? (this.tempBuff = [], this.state = te) : w === o.EXCLAMATION_MARK ? (this.state = x, this._emitChars("<!")) : (this._emitChars("<"), this._reconsumeInState(E));
    }
    // Script data end tag open state
    //------------------------------------------------------------------
    [te](w) {
      yt(w) ? (this._createEndTagToken(), this._reconsumeInState(ee)) : (this._emitChars("</"), this._reconsumeInState(E));
    }
    // Script data end tag name state
    //------------------------------------------------------------------
    [ee](w) {
      if (Lt(w))
        this.currentToken.tagName += yn(w), this.tempBuff.push(w);
      else if (Pn(w))
        this.currentToken.tagName += je(w), this.tempBuff.push(w);
      else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (Me(w)) {
            this.state = Qe;
            return;
          } else if (w === o.SOLIDUS) {
            this.state = St;
            return;
          } else if (w === o.GREATER_THAN_SIGN) {
            this._emitCurrentToken(), this.state = v;
            return;
          }
        }
        this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(E);
      }
    }
    // Script data escape start state
    //------------------------------------------------------------------
    [x](w) {
      w === o.HYPHEN_MINUS ? (this.state = N, this._emitChars("-")) : this._reconsumeInState(E);
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
    [N](w) {
      w === o.HYPHEN_MINUS ? (this.state = Q, this._emitChars("-")) : this._reconsumeInState(E);
    }
    // Script data escaped state
    //------------------------------------------------------------------
    [G](w) {
      w === o.HYPHEN_MINUS ? (this.state = X, this._emitChars("-")) : w === o.LESS_THAN_SIGN ? this.state = re : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(w);
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
    [X](w) {
      w === o.HYPHEN_MINUS ? (this.state = Q, this._emitChars("-")) : w === o.LESS_THAN_SIGN ? this.state = re : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.state = G, this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = G, this._emitCodePoint(w));
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
    [Q](w) {
      w === o.HYPHEN_MINUS ? this._emitChars("-") : w === o.LESS_THAN_SIGN ? this.state = re : w === o.GREATER_THAN_SIGN ? (this.state = E, this._emitChars(">")) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.state = G, this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = G, this._emitCodePoint(w));
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    [re](w) {
      w === o.SOLIDUS ? (this.tempBuff = [], this.state = se) : yt(w) ? (this.tempBuff = [], this._emitChars("<"), this._reconsumeInState(me)) : (this._emitChars("<"), this._reconsumeInState(G));
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
    [se](w) {
      yt(w) ? (this._createEndTagToken(), this._reconsumeInState(ue)) : (this._emitChars("</"), this._reconsumeInState(G));
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
    [ue](w) {
      if (Lt(w))
        this.currentToken.tagName += yn(w), this.tempBuff.push(w);
      else if (Pn(w))
        this.currentToken.tagName += je(w), this.tempBuff.push(w);
      else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (Me(w)) {
            this.state = Qe;
            return;
          }
          if (w === o.SOLIDUS) {
            this.state = St;
            return;
          }
          if (w === o.GREATER_THAN_SIGN) {
            this._emitCurrentToken(), this.state = v;
            return;
          }
        }
        this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(G);
      }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
    [me](w) {
      Me(w) || w === o.SOLIDUS || w === o.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? he : G, this._emitCodePoint(w)) : Lt(w) ? (this.tempBuff.push(Wr(w)), this._emitCodePoint(w)) : Pn(w) ? (this.tempBuff.push(w), this._emitCodePoint(w)) : this._reconsumeInState(G);
    }
    // Script data double escaped state
    //------------------------------------------------------------------
    [he](w) {
      w === o.HYPHEN_MINUS ? (this.state = _e, this._emitChars("-")) : w === o.LESS_THAN_SIGN ? (this.state = Ae, this._emitChars("<")) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(w);
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
    [_e](w) {
      w === o.HYPHEN_MINUS ? (this.state = De, this._emitChars("-")) : w === o.LESS_THAN_SIGN ? (this.state = Ae, this._emitChars("<")) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.state = he, this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = he, this._emitCodePoint(w));
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    [De](w) {
      w === o.HYPHEN_MINUS ? this._emitChars("-") : w === o.LESS_THAN_SIGN ? (this.state = Ae, this._emitChars("<")) : w === o.GREATER_THAN_SIGN ? (this.state = E, this._emitChars(">")) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.state = he, this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = he, this._emitCodePoint(w));
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    [Ae](w) {
      w === o.SOLIDUS ? (this.tempBuff = [], this.state = ze, this._emitChars("/")) : this._reconsumeInState(he);
    }
    // Script data double escape end state
    //------------------------------------------------------------------
    [ze](w) {
      Me(w) || w === o.SOLIDUS || w === o.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? G : he, this._emitCodePoint(w)) : Lt(w) ? (this.tempBuff.push(Wr(w)), this._emitCodePoint(w)) : Pn(w) ? (this.tempBuff.push(w), this._emitCodePoint(w)) : this._reconsumeInState(he);
    }
    // Before attribute name state
    //------------------------------------------------------------------
    [Qe](w) {
      Me(w) || (w === o.SOLIDUS || w === o.GREATER_THAN_SIGN || w === o.EOF ? this._reconsumeInState(Vt) : w === o.EQUALS_SIGN ? (this._err(r.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = Et) : (this._createAttr(""), this._reconsumeInState(Et)));
    }
    // Attribute name state
    //------------------------------------------------------------------
    [Et](w) {
      Me(w) || w === o.SOLIDUS || w === o.GREATER_THAN_SIGN || w === o.EOF ? (this._leaveAttrName(Vt), this._unconsume()) : w === o.EQUALS_SIGN ? this._leaveAttrName(mn) : Lt(w) ? this.currentAttr.name += yn(w) : w === o.QUOTATION_MARK || w === o.APOSTROPHE || w === o.LESS_THAN_SIGN ? (this._err(r.unexpectedCharacterInAttributeName), this.currentAttr.name += je(w)) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentAttr.name += t.REPLACEMENT_CHARACTER) : this.currentAttr.name += je(w);
    }
    // After attribute name state
    //------------------------------------------------------------------
    [Vt](w) {
      Me(w) || (w === o.SOLIDUS ? this.state = St : w === o.EQUALS_SIGN ? this.state = mn : w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : (this._createAttr(""), this._reconsumeInState(Et)));
    }
    // Before attribute value state
    //------------------------------------------------------------------
    [mn](w) {
      Me(w) || (w === o.QUOTATION_MARK ? this.state = fn : w === o.APOSTROPHE ? this.state = pn : w === o.GREATER_THAN_SIGN ? (this._err(r.missingAttributeValue), this.state = v, this._emitCurrentToken()) : this._reconsumeInState(gn));
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    [fn](w) {
      w === o.QUOTATION_MARK ? this.state = Ln : w === o.AMPERSAND ? (this.returnState = fn, this.state = Xn) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentAttr.value += t.REPLACEMENT_CHARACTER) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : this.currentAttr.value += je(w);
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    [pn](w) {
      w === o.APOSTROPHE ? this.state = Ln : w === o.AMPERSAND ? (this.returnState = pn, this.state = Xn) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentAttr.value += t.REPLACEMENT_CHARACTER) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : this.currentAttr.value += je(w);
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    [gn](w) {
      Me(w) ? this._leaveAttrValue(Qe) : w === o.AMPERSAND ? (this.returnState = gn, this.state = Xn) : w === o.GREATER_THAN_SIGN ? (this._leaveAttrValue(v), this._emitCurrentToken()) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentAttr.value += t.REPLACEMENT_CHARACTER) : w === o.QUOTATION_MARK || w === o.APOSTROPHE || w === o.LESS_THAN_SIGN || w === o.EQUALS_SIGN || w === o.GRAVE_ACCENT ? (this._err(r.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += je(w)) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : this.currentAttr.value += je(w);
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
    [Ln](w) {
      Me(w) ? this._leaveAttrValue(Qe) : w === o.SOLIDUS ? this._leaveAttrValue(St) : w === o.GREATER_THAN_SIGN ? (this._leaveAttrValue(v), this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : (this._err(r.missingWhitespaceBetweenAttributes), this._reconsumeInState(Qe));
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
    [St](w) {
      w === o.GREATER_THAN_SIGN ? (this.currentToken.selfClosing = !0, this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : (this._err(r.unexpectedSolidusInTag), this._reconsumeInState(Qe));
    }
    // Bogus comment state
    //------------------------------------------------------------------
    [ce](w) {
      w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._emitCurrentToken(), this._emitEOFToken()) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.data += t.REPLACEMENT_CHARACTER) : this.currentToken.data += je(w);
    }
    // Markup declaration open state
    //------------------------------------------------------------------
    [Mt](w) {
      this._consumeSequenceIfMatch(i.DASH_DASH_STRING, w, !0) ? (this._createCommentToken(), this.state = le) : this._consumeSequenceIfMatch(i.DOCTYPE_STRING, w, !1) ? this.state = vn : this._consumeSequenceIfMatch(i.CDATA_START_STRING, w, !0) ? this.allowCDATA ? this.state = On : (this._err(r.cdataInHtmlContent), this._createCommentToken(), this.currentToken.data = "[CDATA[", this.state = ce) : this._ensureHibernation() || (this._err(r.incorrectlyOpenedComment), this._createCommentToken(), this._reconsumeInState(ce));
    }
    // Comment start state
    //------------------------------------------------------------------
    [le](w) {
      w === o.HYPHEN_MINUS ? this.state = fe : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptClosingOfEmptyComment), this.state = v, this._emitCurrentToken()) : this._reconsumeInState(Pe);
    }
    // Comment start dash state
    //------------------------------------------------------------------
    [fe](w) {
      w === o.HYPHEN_MINUS ? this.state = ht : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptClosingOfEmptyComment), this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Pe));
    }
    // Comment state
    //------------------------------------------------------------------
    [Pe](w) {
      w === o.HYPHEN_MINUS ? this.state = Je : w === o.LESS_THAN_SIGN ? (this.currentToken.data += "<", this.state = Re) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.data += t.REPLACEMENT_CHARACTER) : w === o.EOF ? (this._err(r.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.data += je(w);
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
    [Re](w) {
      w === o.EXCLAMATION_MARK ? (this.currentToken.data += "!", this.state = At) : w === o.LESS_THAN_SIGN ? this.currentToken.data += "!" : this._reconsumeInState(Pe);
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
    [At](w) {
      w === o.HYPHEN_MINUS ? this.state = Ze : this._reconsumeInState(Pe);
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    [Ze](w) {
      w === o.HYPHEN_MINUS ? this.state = be : this._reconsumeInState(Je);
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    [be](w) {
      w !== o.GREATER_THAN_SIGN && w !== o.EOF && this._err(r.nestedComment), this._reconsumeInState(ht);
    }
    // Comment end dash state
    //------------------------------------------------------------------
    [Je](w) {
      w === o.HYPHEN_MINUS ? this.state = ht : w === o.EOF ? (this._err(r.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Pe));
    }
    // Comment end state
    //------------------------------------------------------------------
    [ht](w) {
      w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : w === o.EXCLAMATION_MARK ? this.state = Wt : w === o.HYPHEN_MINUS ? this.currentToken.data += "-" : w === o.EOF ? (this._err(r.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--", this._reconsumeInState(Pe));
    }
    // Comment end bang state
    //------------------------------------------------------------------
    [Wt](w) {
      w === o.HYPHEN_MINUS ? (this.currentToken.data += "--!", this.state = Je) : w === o.GREATER_THAN_SIGN ? (this._err(r.incorrectlyClosedComment), this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--!", this._reconsumeInState(Pe));
    }
    // DOCTYPE state
    //------------------------------------------------------------------
    [vn](w) {
      Me(w) ? this.state = et : w === o.GREATER_THAN_SIGN ? this._reconsumeInState(et) : w === o.EOF ? (this._err(r.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingWhitespaceBeforeDoctypeName), this._reconsumeInState(et));
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
    [et](w) {
      Me(w) || (Lt(w) ? (this._createDoctypeToken(yn(w)), this.state = mt) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._createDoctypeToken(t.REPLACEMENT_CHARACTER), this.state = mt) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingDoctypeName), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._createDoctypeToken(je(w)), this.state = mt));
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
    [mt](w) {
      Me(w) ? this.state = bn : w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : Lt(w) ? this.currentToken.name += yn(w) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.name += t.REPLACEMENT_CHARACTER) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.name += je(w);
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
    [bn](w) {
      Me(w) || (w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this._consumeSequenceIfMatch(i.PUBLIC_STRING, w, !1) ? this.state = Wn : this._consumeSequenceIfMatch(i.SYSTEM_STRING, w, !1) ? this.state = Ti : this._ensureHibernation() || (this._err(r.invalidCharacterSequenceAfterDoctypeName), this.currentToken.forceQuirks = !0, this._reconsumeInState(ut)));
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    [Wn](w) {
      Me(w) ? this.state = It : w === o.QUOTATION_MARK ? (this._err(r.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Ce) : w === o.APOSTROPHE ? (this._err(r.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Ne) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ut));
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    [It](w) {
      Me(w) || (w === o.QUOTATION_MARK ? (this.currentToken.publicId = "", this.state = Ce) : w === o.APOSTROPHE ? (this.currentToken.publicId = "", this.state = Ne) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ut)));
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    [Ce](w) {
      w === o.QUOTATION_MARK ? this.state = Dn : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.publicId += t.REPLACEMENT_CHARACTER) : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += je(w);
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    [Ne](w) {
      w === o.APOSTROPHE ? this.state = Dn : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.publicId += t.REPLACEMENT_CHARACTER) : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += je(w);
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    [Dn](w) {
      Me(w) ? this.state = wi : w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : w === o.QUOTATION_MARK ? (this._err(r.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = pr) : w === o.APOSTROPHE ? (this._err(r.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = gr) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ut));
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    [wi](w) {
      Me(w) || (w === o.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = v) : w === o.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = pr) : w === o.APOSTROPHE ? (this.currentToken.systemId = "", this.state = gr) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ut)));
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    [Ti](w) {
      Me(w) ? this.state = Yn : w === o.QUOTATION_MARK ? (this._err(r.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = pr) : w === o.APOSTROPHE ? (this._err(r.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = gr) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ut));
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    [Yn](w) {
      Me(w) || (w === o.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = pr) : w === o.APOSTROPHE ? (this.currentToken.systemId = "", this.state = gr) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ut)));
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    [pr](w) {
      w === o.QUOTATION_MARK ? this.state = $n : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.systemId += t.REPLACEMENT_CHARACTER) : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += je(w);
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    [gr](w) {
      w === o.APOSTROPHE ? this.state = $n : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.systemId += t.REPLACEMENT_CHARACTER) : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += je(w);
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    [$n](w) {
      Me(w) || (w === o.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.unexpectedCharacterAfterDoctypeSystemIdentifier), this._reconsumeInState(ut)));
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    [ut](w) {
      w === o.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = v) : w === o.NULL ? this._err(r.unexpectedNullCharacter) : w === o.EOF && (this._emitCurrentToken(), this._emitEOFToken());
    }
    // CDATA section state
    //------------------------------------------------------------------
    [On](w) {
      w === o.RIGHT_SQUARE_BRACKET ? this.state = ki : w === o.EOF ? (this._err(r.eofInCdata), this._emitEOFToken()) : this._emitCodePoint(w);
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
    [ki](w) {
      w === o.RIGHT_SQUARE_BRACKET ? this.state = Ei : (this._emitChars("]"), this._reconsumeInState(On));
    }
    // CDATA section end state
    //------------------------------------------------------------------
    [Ei](w) {
      w === o.GREATER_THAN_SIGN ? this.state = v : w === o.RIGHT_SQUARE_BRACKET ? this._emitChars("]") : (this._emitChars("]]"), this._reconsumeInState(On));
    }
    // Character reference state
    //------------------------------------------------------------------
    [Xn](w) {
      this.tempBuff = [o.AMPERSAND], w === o.NUMBER_SIGN ? (this.tempBuff.push(w), this.state = Ao) : Io(w) ? this._reconsumeInState(Yt) : (this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
    }
    // Named character reference state
    //------------------------------------------------------------------
    [Yt](w) {
      const Te = this._matchNamedCharacterReference(w);
      if (this._ensureHibernation())
        this.tempBuff = [o.AMPERSAND];
      else if (Te) {
        const _t = this.tempBuff[this.tempBuff.length - 1] === o.SEMICOLON;
        this._isCharacterReferenceAttributeQuirk(_t) || (_t || this._errOnNextCodePoint(r.missingSemicolonAfterCharacterReference), this.tempBuff = Te), this._flushCodePointsConsumedAsCharacterReference(), this.state = this.returnState;
      } else
        this._flushCodePointsConsumedAsCharacterReference(), this.state = Si;
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
    [Si](w) {
      Io(w) ? this._isCharacterReferenceInAttribute() ? this.currentAttr.value += je(w) : this._emitCodePoint(w) : (w === o.SEMICOLON && this._err(r.unknownNamedCharacterReference), this._reconsumeInState(this.returnState));
    }
    // Numeric character reference state
    //------------------------------------------------------------------
    [Ao](w) {
      this.charRefCode = 0, w === o.LATIN_SMALL_X || w === o.LATIN_CAPITAL_X ? (this.tempBuff.push(w), this.state = Mi) : this._reconsumeInState(Ai);
    }
    // Hexademical character reference start state
    //------------------------------------------------------------------
    [Mi](w) {
      Ws(w) ? this._reconsumeInState(Ii) : (this._err(r.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
    }
    // Decimal character reference start state
    //------------------------------------------------------------------
    [Ai](w) {
      br(w) ? this._reconsumeInState(Li) : (this._err(r.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
    }
    // Hexademical character reference state
    //------------------------------------------------------------------
    [Ii](w) {
      Lo(w) ? this.charRefCode = this.charRefCode * 16 + w - 55 : Di(w) ? this.charRefCode = this.charRefCode * 16 + w - 87 : br(w) ? this.charRefCode = this.charRefCode * 16 + w - 48 : w === o.SEMICOLON ? this.state = vr : (this._err(r.missingSemicolonAfterCharacterReference), this._reconsumeInState(vr));
    }
    // Decimal character reference state
    //------------------------------------------------------------------
    [Li](w) {
      br(w) ? this.charRefCode = this.charRefCode * 10 + w - 48 : w === o.SEMICOLON ? this.state = vr : (this._err(r.missingSemicolonAfterCharacterReference), this._reconsumeInState(vr));
    }
    // Numeric character reference end state
    //------------------------------------------------------------------
    [vr]() {
      if (this.charRefCode === o.NULL)
        this._err(r.nullCharacterReference), this.charRefCode = o.REPLACEMENT_CHARACTER;
      else if (this.charRefCode > 1114111)
        this._err(r.characterReferenceOutsideUnicodeRange), this.charRefCode = o.REPLACEMENT_CHARACTER;
      else if (t.isSurrogate(this.charRefCode))
        this._err(r.surrogateCharacterReference), this.charRefCode = o.REPLACEMENT_CHARACTER;
      else if (t.isUndefinedCodePoint(this.charRefCode))
        this._err(r.noncharacterCharacterReference);
      else if (t.isControlCodePoint(this.charRefCode) || this.charRefCode === o.CARRIAGE_RETURN) {
        this._err(r.controlCharacterReference);
        const w = a[this.charRefCode];
        w && (this.charRefCode = w);
      }
      this.tempBuff = [this.charRefCode], this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState);
    }
  }
  return $e.CHARACTER_TOKEN = "CHARACTER_TOKEN", $e.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN", $e.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN", $e.START_TAG_TOKEN = "START_TAG_TOKEN", $e.END_TAG_TOKEN = "END_TAG_TOKEN", $e.COMMENT_TOKEN = "COMMENT_TOKEN", $e.DOCTYPE_TOKEN = "DOCTYPE_TOKEN", $e.EOF_TOKEN = "EOF_TOKEN", $e.HIBERNATION_TOKEN = "HIBERNATION_TOKEN", $e.MODE = {
    DATA: v,
    RCDATA: g,
    RAWTEXT: h,
    SCRIPT_DATA: E,
    PLAINTEXT: C
  }, $e.getTokenAttr = function(ve, w) {
    for (let Te = ve.attrs.length - 1; Te >= 0; Te--)
      if (ve.attrs[Te].name === w)
        return ve.attrs[Te].value;
    return null;
  }, Vl = $e, Vl;
}
var Cr = {}, Nm;
function Eo() {
  if (Nm) return Cr;
  Nm = 1;
  const e = Cr.NAMESPACES = {
    HTML: "http://www.w3.org/1999/xhtml",
    MATHML: "http://www.w3.org/1998/Math/MathML",
    SVG: "http://www.w3.org/2000/svg",
    XLINK: "http://www.w3.org/1999/xlink",
    XML: "http://www.w3.org/XML/1998/namespace",
    XMLNS: "http://www.w3.org/2000/xmlns/"
  };
  Cr.ATTRS = {
    TYPE: "type",
    ACTION: "action",
    ENCODING: "encoding",
    PROMPT: "prompt",
    NAME: "name",
    COLOR: "color",
    FACE: "face",
    SIZE: "size"
  }, Cr.DOCUMENT_MODE = {
    NO_QUIRKS: "no-quirks",
    QUIRKS: "quirks",
    LIMITED_QUIRKS: "limited-quirks"
  };
  const t = Cr.TAG_NAMES = {
    A: "a",
    ADDRESS: "address",
    ANNOTATION_XML: "annotation-xml",
    APPLET: "applet",
    AREA: "area",
    ARTICLE: "article",
    ASIDE: "aside",
    B: "b",
    BASE: "base",
    BASEFONT: "basefont",
    BGSOUND: "bgsound",
    BIG: "big",
    BLOCKQUOTE: "blockquote",
    BODY: "body",
    BR: "br",
    BUTTON: "button",
    CAPTION: "caption",
    CENTER: "center",
    CODE: "code",
    COL: "col",
    COLGROUP: "colgroup",
    DD: "dd",
    DESC: "desc",
    DETAILS: "details",
    DIALOG: "dialog",
    DIR: "dir",
    DIV: "div",
    DL: "dl",
    DT: "dt",
    EM: "em",
    EMBED: "embed",
    FIELDSET: "fieldset",
    FIGCAPTION: "figcaption",
    FIGURE: "figure",
    FONT: "font",
    FOOTER: "footer",
    FOREIGN_OBJECT: "foreignObject",
    FORM: "form",
    FRAME: "frame",
    FRAMESET: "frameset",
    H1: "h1",
    H2: "h2",
    H3: "h3",
    H4: "h4",
    H5: "h5",
    H6: "h6",
    HEAD: "head",
    HEADER: "header",
    HGROUP: "hgroup",
    HR: "hr",
    HTML: "html",
    I: "i",
    IMG: "img",
    IMAGE: "image",
    INPUT: "input",
    IFRAME: "iframe",
    KEYGEN: "keygen",
    LABEL: "label",
    LI: "li",
    LINK: "link",
    LISTING: "listing",
    MAIN: "main",
    MALIGNMARK: "malignmark",
    MARQUEE: "marquee",
    MATH: "math",
    MENU: "menu",
    META: "meta",
    MGLYPH: "mglyph",
    MI: "mi",
    MO: "mo",
    MN: "mn",
    MS: "ms",
    MTEXT: "mtext",
    NAV: "nav",
    NOBR: "nobr",
    NOFRAMES: "noframes",
    NOEMBED: "noembed",
    NOSCRIPT: "noscript",
    OBJECT: "object",
    OL: "ol",
    OPTGROUP: "optgroup",
    OPTION: "option",
    P: "p",
    PARAM: "param",
    PLAINTEXT: "plaintext",
    PRE: "pre",
    RB: "rb",
    RP: "rp",
    RT: "rt",
    RTC: "rtc",
    RUBY: "ruby",
    S: "s",
    SCRIPT: "script",
    SECTION: "section",
    SELECT: "select",
    SOURCE: "source",
    SMALL: "small",
    SPAN: "span",
    STRIKE: "strike",
    STRONG: "strong",
    STYLE: "style",
    SUB: "sub",
    SUMMARY: "summary",
    SUP: "sup",
    TABLE: "table",
    TBODY: "tbody",
    TEMPLATE: "template",
    TEXTAREA: "textarea",
    TFOOT: "tfoot",
    TD: "td",
    TH: "th",
    THEAD: "thead",
    TITLE: "title",
    TR: "tr",
    TRACK: "track",
    TT: "tt",
    U: "u",
    UL: "ul",
    SVG: "svg",
    VAR: "var",
    WBR: "wbr",
    XMP: "xmp"
  };
  return Cr.SPECIAL_ELEMENTS = {
    [e.HTML]: {
      [t.ADDRESS]: !0,
      [t.APPLET]: !0,
      [t.AREA]: !0,
      [t.ARTICLE]: !0,
      [t.ASIDE]: !0,
      [t.BASE]: !0,
      [t.BASEFONT]: !0,
      [t.BGSOUND]: !0,
      [t.BLOCKQUOTE]: !0,
      [t.BODY]: !0,
      [t.BR]: !0,
      [t.BUTTON]: !0,
      [t.CAPTION]: !0,
      [t.CENTER]: !0,
      [t.COL]: !0,
      [t.COLGROUP]: !0,
      [t.DD]: !0,
      [t.DETAILS]: !0,
      [t.DIR]: !0,
      [t.DIV]: !0,
      [t.DL]: !0,
      [t.DT]: !0,
      [t.EMBED]: !0,
      [t.FIELDSET]: !0,
      [t.FIGCAPTION]: !0,
      [t.FIGURE]: !0,
      [t.FOOTER]: !0,
      [t.FORM]: !0,
      [t.FRAME]: !0,
      [t.FRAMESET]: !0,
      [t.H1]: !0,
      [t.H2]: !0,
      [t.H3]: !0,
      [t.H4]: !0,
      [t.H5]: !0,
      [t.H6]: !0,
      [t.HEAD]: !0,
      [t.HEADER]: !0,
      [t.HGROUP]: !0,
      [t.HR]: !0,
      [t.HTML]: !0,
      [t.IFRAME]: !0,
      [t.IMG]: !0,
      [t.INPUT]: !0,
      [t.LI]: !0,
      [t.LINK]: !0,
      [t.LISTING]: !0,
      [t.MAIN]: !0,
      [t.MARQUEE]: !0,
      [t.MENU]: !0,
      [t.META]: !0,
      [t.NAV]: !0,
      [t.NOEMBED]: !0,
      [t.NOFRAMES]: !0,
      [t.NOSCRIPT]: !0,
      [t.OBJECT]: !0,
      [t.OL]: !0,
      [t.P]: !0,
      [t.PARAM]: !0,
      [t.PLAINTEXT]: !0,
      [t.PRE]: !0,
      [t.SCRIPT]: !0,
      [t.SECTION]: !0,
      [t.SELECT]: !0,
      [t.SOURCE]: !0,
      [t.STYLE]: !0,
      [t.SUMMARY]: !0,
      [t.TABLE]: !0,
      [t.TBODY]: !0,
      [t.TD]: !0,
      [t.TEMPLATE]: !0,
      [t.TEXTAREA]: !0,
      [t.TFOOT]: !0,
      [t.TH]: !0,
      [t.THEAD]: !0,
      [t.TITLE]: !0,
      [t.TR]: !0,
      [t.TRACK]: !0,
      [t.UL]: !0,
      [t.WBR]: !0,
      [t.XMP]: !0
    },
    [e.MATHML]: {
      [t.MI]: !0,
      [t.MO]: !0,
      [t.MN]: !0,
      [t.MS]: !0,
      [t.MTEXT]: !0,
      [t.ANNOTATION_XML]: !0
    },
    [e.SVG]: {
      [t.TITLE]: !0,
      [t.FOREIGN_OBJECT]: !0,
      [t.DESC]: !0
    }
  }, Cr;
}
var Bl, Hm;
function DP() {
  if (Hm) return Bl;
  Hm = 1;
  const e = Eo(), t = e.TAG_NAMES, n = e.NAMESPACES;
  function r(s) {
    switch (s.length) {
      case 1:
        return s === t.P;
      case 2:
        return s === t.RB || s === t.RP || s === t.RT || s === t.DD || s === t.DT || s === t.LI;
      case 3:
        return s === t.RTC;
      case 6:
        return s === t.OPTION;
      case 8:
        return s === t.OPTGROUP;
    }
    return !1;
  }
  function o(s) {
    switch (s.length) {
      case 1:
        return s === t.P;
      case 2:
        return s === t.RB || s === t.RP || s === t.RT || s === t.DD || s === t.DT || s === t.LI || s === t.TD || s === t.TH || s === t.TR;
      case 3:
        return s === t.RTC;
      case 5:
        return s === t.TBODY || s === t.TFOOT || s === t.THEAD;
      case 6:
        return s === t.OPTION;
      case 7:
        return s === t.CAPTION;
      case 8:
        return s === t.OPTGROUP || s === t.COLGROUP;
    }
    return !1;
  }
  function i(s, l) {
    switch (s.length) {
      case 2:
        if (s === t.TD || s === t.TH)
          return l === n.HTML;
        if (s === t.MI || s === t.MO || s === t.MN || s === t.MS)
          return l === n.MATHML;
        break;
      case 4:
        if (s === t.HTML)
          return l === n.HTML;
        if (s === t.DESC)
          return l === n.SVG;
        break;
      case 5:
        if (s === t.TABLE)
          return l === n.HTML;
        if (s === t.MTEXT)
          return l === n.MATHML;
        if (s === t.TITLE)
          return l === n.SVG;
        break;
      case 6:
        return (s === t.APPLET || s === t.OBJECT) && l === n.HTML;
      case 7:
        return (s === t.CAPTION || s === t.MARQUEE) && l === n.HTML;
      case 8:
        return s === t.TEMPLATE && l === n.HTML;
      case 13:
        return s === t.FOREIGN_OBJECT && l === n.SVG;
      case 14:
        return s === t.ANNOTATION_XML && l === n.MATHML;
    }
    return !1;
  }
  class a {
    constructor(l, u) {
      this.stackTop = -1, this.items = [], this.current = l, this.currentTagName = null, this.currentTmplContent = null, this.tmplCount = 0, this.treeAdapter = u;
    }
    //Index of element
    _indexOf(l) {
      let u = -1;
      for (let m = this.stackTop; m >= 0; m--)
        if (this.items[m] === l) {
          u = m;
          break;
        }
      return u;
    }
    //Update current element
    _isInTemplate() {
      return this.currentTagName === t.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === n.HTML;
    }
    _updateCurrentElement() {
      this.current = this.items[this.stackTop], this.currentTagName = this.current && this.treeAdapter.getTagName(this.current), this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
    }
    //Mutations
    push(l) {
      this.items[++this.stackTop] = l, this._updateCurrentElement(), this._isInTemplate() && this.tmplCount++;
    }
    pop() {
      this.stackTop--, this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this._updateCurrentElement();
    }
    replace(l, u) {
      const m = this._indexOf(l);
      this.items[m] = u, m === this.stackTop && this._updateCurrentElement();
    }
    insertAfter(l, u) {
      const m = this._indexOf(l) + 1;
      this.items.splice(m, 0, u), m === ++this.stackTop && this._updateCurrentElement();
    }
    popUntilTagNamePopped(l) {
      for (; this.stackTop > -1; ) {
        const u = this.currentTagName, m = this.treeAdapter.getNamespaceURI(this.current);
        if (this.pop(), u === l && m === n.HTML)
          break;
      }
    }
    popUntilElementPopped(l) {
      for (; this.stackTop > -1; ) {
        const u = this.current;
        if (this.pop(), u === l)
          break;
      }
    }
    popUntilNumberedHeaderPopped() {
      for (; this.stackTop > -1; ) {
        const l = this.currentTagName, u = this.treeAdapter.getNamespaceURI(this.current);
        if (this.pop(), l === t.H1 || l === t.H2 || l === t.H3 || l === t.H4 || l === t.H5 || l === t.H6 && u === n.HTML)
          break;
      }
    }
    popUntilTableCellPopped() {
      for (; this.stackTop > -1; ) {
        const l = this.currentTagName, u = this.treeAdapter.getNamespaceURI(this.current);
        if (this.pop(), l === t.TD || l === t.TH && u === n.HTML)
          break;
      }
    }
    popAllUpToHtmlElement() {
      this.stackTop = 0, this._updateCurrentElement();
    }
    clearBackToTableContext() {
      for (; this.currentTagName !== t.TABLE && this.currentTagName !== t.TEMPLATE && this.currentTagName !== t.HTML || this.treeAdapter.getNamespaceURI(this.current) !== n.HTML; )
        this.pop();
    }
    clearBackToTableBodyContext() {
      for (; this.currentTagName !== t.TBODY && this.currentTagName !== t.TFOOT && this.currentTagName !== t.THEAD && this.currentTagName !== t.TEMPLATE && this.currentTagName !== t.HTML || this.treeAdapter.getNamespaceURI(this.current) !== n.HTML; )
        this.pop();
    }
    clearBackToTableRowContext() {
      for (; this.currentTagName !== t.TR && this.currentTagName !== t.TEMPLATE && this.currentTagName !== t.HTML || this.treeAdapter.getNamespaceURI(this.current) !== n.HTML; )
        this.pop();
    }
    remove(l) {
      for (let u = this.stackTop; u >= 0; u--)
        if (this.items[u] === l) {
          this.items.splice(u, 1), this.stackTop--, this._updateCurrentElement();
          break;
        }
    }
    //Search
    tryPeekProperlyNestedBodyElement() {
      const l = this.items[1];
      return l && this.treeAdapter.getTagName(l) === t.BODY ? l : null;
    }
    contains(l) {
      return this._indexOf(l) > -1;
    }
    getCommonAncestor(l) {
      let u = this._indexOf(l);
      return --u >= 0 ? this.items[u] : null;
    }
    isRootHtmlElementCurrent() {
      return this.stackTop === 0 && this.currentTagName === t.HTML;
    }
    //Element in scope
    hasInScope(l) {
      for (let u = this.stackTop; u >= 0; u--) {
        const m = this.treeAdapter.getTagName(this.items[u]), v = this.treeAdapter.getNamespaceURI(this.items[u]);
        if (m === l && v === n.HTML)
          return !0;
        if (i(m, v))
          return !1;
      }
      return !0;
    }
    hasNumberedHeaderInScope() {
      for (let l = this.stackTop; l >= 0; l--) {
        const u = this.treeAdapter.getTagName(this.items[l]), m = this.treeAdapter.getNamespaceURI(this.items[l]);
        if ((u === t.H1 || u === t.H2 || u === t.H3 || u === t.H4 || u === t.H5 || u === t.H6) && m === n.HTML)
          return !0;
        if (i(u, m))
          return !1;
      }
      return !0;
    }
    hasInListItemScope(l) {
      for (let u = this.stackTop; u >= 0; u--) {
        const m = this.treeAdapter.getTagName(this.items[u]), v = this.treeAdapter.getNamespaceURI(this.items[u]);
        if (m === l && v === n.HTML)
          return !0;
        if ((m === t.UL || m === t.OL) && v === n.HTML || i(m, v))
          return !1;
      }
      return !0;
    }
    hasInButtonScope(l) {
      for (let u = this.stackTop; u >= 0; u--) {
        const m = this.treeAdapter.getTagName(this.items[u]), v = this.treeAdapter.getNamespaceURI(this.items[u]);
        if (m === l && v === n.HTML)
          return !0;
        if (m === t.BUTTON && v === n.HTML || i(m, v))
          return !1;
      }
      return !0;
    }
    hasInTableScope(l) {
      for (let u = this.stackTop; u >= 0; u--) {
        const m = this.treeAdapter.getTagName(this.items[u]);
        if (this.treeAdapter.getNamespaceURI(this.items[u]) === n.HTML) {
          if (m === l)
            return !0;
          if (m === t.TABLE || m === t.TEMPLATE || m === t.HTML)
            return !1;
        }
      }
      return !0;
    }
    hasTableBodyContextInTableScope() {
      for (let l = this.stackTop; l >= 0; l--) {
        const u = this.treeAdapter.getTagName(this.items[l]);
        if (this.treeAdapter.getNamespaceURI(this.items[l]) === n.HTML) {
          if (u === t.TBODY || u === t.THEAD || u === t.TFOOT)
            return !0;
          if (u === t.TABLE || u === t.HTML)
            return !1;
        }
      }
      return !0;
    }
    hasInSelectScope(l) {
      for (let u = this.stackTop; u >= 0; u--) {
        const m = this.treeAdapter.getTagName(this.items[u]);
        if (this.treeAdapter.getNamespaceURI(this.items[u]) === n.HTML) {
          if (m === l)
            return !0;
          if (m !== t.OPTION && m !== t.OPTGROUP)
            return !1;
        }
      }
      return !0;
    }
    //Implied end tags
    generateImpliedEndTags() {
      for (; r(this.currentTagName); )
        this.pop();
    }
    generateImpliedEndTagsThoroughly() {
      for (; o(this.currentTagName); )
        this.pop();
    }
    generateImpliedEndTagsWithExclusion(l) {
      for (; r(this.currentTagName) && this.currentTagName !== l; )
        this.pop();
    }
  }
  return Bl = a, Bl;
}
var jl, Fm;
function $P() {
  if (Fm) return jl;
  Fm = 1;
  const e = 3;
  class t {
    constructor(r) {
      this.length = 0, this.entries = [], this.treeAdapter = r, this.bookmark = null;
    }
    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(r) {
      const o = [];
      if (this.length >= e) {
        const i = this.treeAdapter.getAttrList(r).length, a = this.treeAdapter.getTagName(r), s = this.treeAdapter.getNamespaceURI(r);
        for (let l = this.length - 1; l >= 0; l--) {
          const u = this.entries[l];
          if (u.type === t.MARKER_ENTRY)
            break;
          const m = u.element, v = this.treeAdapter.getAttrList(m);
          this.treeAdapter.getTagName(m) === a && this.treeAdapter.getNamespaceURI(m) === s && v.length === i && o.push({ idx: l, attrs: v });
        }
      }
      return o.length < e ? [] : o;
    }
    _ensureNoahArkCondition(r) {
      const o = this._getNoahArkConditionCandidates(r);
      let i = o.length;
      if (i) {
        const a = this.treeAdapter.getAttrList(r), s = a.length, l = /* @__PURE__ */ Object.create(null);
        for (let u = 0; u < s; u++) {
          const m = a[u];
          l[m.name] = m.value;
        }
        for (let u = 0; u < s; u++)
          for (let m = 0; m < i; m++) {
            const v = o[m].attrs[u];
            if (l[v.name] !== v.value && (o.splice(m, 1), i--), o.length < e)
              return;
          }
        for (let u = i - 1; u >= e - 1; u--)
          this.entries.splice(o[u].idx, 1), this.length--;
      }
    }
    //Mutations
    insertMarker() {
      this.entries.push({ type: t.MARKER_ENTRY }), this.length++;
    }
    pushElement(r, o) {
      this._ensureNoahArkCondition(r), this.entries.push({
        type: t.ELEMENT_ENTRY,
        element: r,
        token: o
      }), this.length++;
    }
    insertElementAfterBookmark(r, o) {
      let i = this.length - 1;
      for (; i >= 0 && this.entries[i] !== this.bookmark; i--)
        ;
      this.entries.splice(i + 1, 0, {
        type: t.ELEMENT_ENTRY,
        element: r,
        token: o
      }), this.length++;
    }
    removeEntry(r) {
      for (let o = this.length - 1; o >= 0; o--)
        if (this.entries[o] === r) {
          this.entries.splice(o, 1), this.length--;
          break;
        }
    }
    clearToLastMarker() {
      for (; this.length; ) {
        const r = this.entries.pop();
        if (this.length--, r.type === t.MARKER_ENTRY)
          break;
      }
    }
    //Search
    getElementEntryInScopeWithTagName(r) {
      for (let o = this.length - 1; o >= 0; o--) {
        const i = this.entries[o];
        if (i.type === t.MARKER_ENTRY)
          return null;
        if (this.treeAdapter.getTagName(i.element) === r)
          return i;
      }
      return null;
    }
    getElementEntry(r) {
      for (let o = this.length - 1; o >= 0; o--) {
        const i = this.entries[o];
        if (i.type === t.ELEMENT_ENTRY && i.element === r)
          return i;
      }
      return null;
    }
  }
  return t.MARKER_ENTRY = "MARKER_ENTRY", t.ELEMENT_ENTRY = "ELEMENT_ENTRY", jl = t, jl;
}
var Ul, Rm;
function xn() {
  if (Rm) return Ul;
  Rm = 1;
  class e {
    constructor(n) {
      const r = {}, o = this._getOverriddenMethods(this, r);
      for (const i of Object.keys(o))
        typeof o[i] == "function" && (r[i] = n[i], n[i] = o[i]);
    }
    _getOverriddenMethods() {
      throw new Error("Not implemented");
    }
  }
  return e.install = function(t, n, r) {
    t.__mixins || (t.__mixins = []);
    for (let i = 0; i < t.__mixins.length; i++)
      if (t.__mixins[i].constructor === n)
        return t.__mixins[i];
    const o = new n(t, r);
    return t.__mixins.push(o), o;
  }, Ul = e, Ul;
}
var ql, Vm;
function B4() {
  if (Vm) return ql;
  Vm = 1;
  const e = xn();
  class t extends e {
    constructor(r) {
      super(r), this.preprocessor = r, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.offset = 0, this.col = 0, this.line = 1;
    }
    _getOverriddenMethods(r, o) {
      return {
        advance() {
          const i = this.pos + 1, a = this.html[i];
          return r.isEol && (r.isEol = !1, r.line++, r.lineStartPos = i), (a === `
` || a === "\r" && this.html[i + 1] !== `
`) && (r.isEol = !0), r.col = i - r.lineStartPos + 1, r.offset = r.droppedBufferSize + i, o.advance.call(this);
        },
        retreat() {
          o.retreat.call(this), r.isEol = !1, r.col = this.pos - r.lineStartPos + 1;
        },
        dropParsedChunk() {
          const i = this.pos;
          o.dropParsedChunk.call(this);
          const a = i - this.pos;
          r.lineStartPos -= a, r.droppedBufferSize += a, r.offset = r.droppedBufferSize + this.pos;
        }
      };
    }
  }
  return ql = t, ql;
}
var Gl, Bm;
function j4() {
  if (Bm) return Gl;
  Bm = 1;
  const e = xn(), t = Os(), n = B4();
  class r extends e {
    constructor(i) {
      super(i), this.tokenizer = i, this.posTracker = e.install(i.preprocessor, n), this.currentAttrLocation = null, this.ctLoc = null;
    }
    _getCurrentLocation() {
      return {
        startLine: this.posTracker.line,
        startCol: this.posTracker.col,
        startOffset: this.posTracker.offset,
        endLine: -1,
        endCol: -1,
        endOffset: -1
      };
    }
    _attachCurrentAttrLocationInfo() {
      this.currentAttrLocation.endLine = this.posTracker.line, this.currentAttrLocation.endCol = this.posTracker.col, this.currentAttrLocation.endOffset = this.posTracker.offset;
      const i = this.tokenizer.currentToken, a = this.tokenizer.currentAttr;
      i.location.attrs || (i.location.attrs = /* @__PURE__ */ Object.create(null)), i.location.attrs[a.name] = this.currentAttrLocation;
    }
    _getOverriddenMethods(i, a) {
      const s = {
        _createStartTagToken() {
          a._createStartTagToken.call(this), this.currentToken.location = i.ctLoc;
        },
        _createEndTagToken() {
          a._createEndTagToken.call(this), this.currentToken.location = i.ctLoc;
        },
        _createCommentToken() {
          a._createCommentToken.call(this), this.currentToken.location = i.ctLoc;
        },
        _createDoctypeToken(l) {
          a._createDoctypeToken.call(this, l), this.currentToken.location = i.ctLoc;
        },
        _createCharacterToken(l, u) {
          a._createCharacterToken.call(this, l, u), this.currentCharacterToken.location = i.ctLoc;
        },
        _createEOFToken() {
          a._createEOFToken.call(this), this.currentToken.location = i._getCurrentLocation();
        },
        _createAttr(l) {
          a._createAttr.call(this, l), i.currentAttrLocation = i._getCurrentLocation();
        },
        _leaveAttrName(l) {
          a._leaveAttrName.call(this, l), i._attachCurrentAttrLocationInfo();
        },
        _leaveAttrValue(l) {
          a._leaveAttrValue.call(this, l), i._attachCurrentAttrLocationInfo();
        },
        _emitCurrentToken() {
          const l = this.currentToken.location;
          this.currentCharacterToken && (this.currentCharacterToken.location.endLine = l.startLine, this.currentCharacterToken.location.endCol = l.startCol, this.currentCharacterToken.location.endOffset = l.startOffset), this.currentToken.type === t.EOF_TOKEN ? (l.endLine = l.startLine, l.endCol = l.startCol, l.endOffset = l.startOffset) : (l.endLine = i.posTracker.line, l.endCol = i.posTracker.col + 1, l.endOffset = i.posTracker.offset + 1), a._emitCurrentToken.call(this);
        },
        _emitCurrentCharacterToken() {
          const l = this.currentCharacterToken && this.currentCharacterToken.location;
          l && l.endOffset === -1 && (l.endLine = i.posTracker.line, l.endCol = i.posTracker.col, l.endOffset = i.posTracker.offset), a._emitCurrentCharacterToken.call(this);
        }
      };
      return Object.keys(t.MODE).forEach((l) => {
        const u = t.MODE[l];
        s[u] = function(m) {
          i.ctLoc = i._getCurrentLocation(), a[u].call(this, m);
        };
      }), s;
    }
  }
  return Gl = r, Gl;
}
var Kl, jm;
function OP() {
  if (jm) return Kl;
  jm = 1;
  const e = xn();
  class t extends e {
    constructor(r, o) {
      super(r), this.onItemPop = o.onItemPop;
    }
    _getOverriddenMethods(r, o) {
      return {
        pop() {
          r.onItemPop(this.current), o.pop.call(this);
        },
        popAllUpToHtmlElement() {
          for (let i = this.stackTop; i > 0; i--)
            r.onItemPop(this.items[i]);
          o.popAllUpToHtmlElement.call(this);
        },
        remove(i) {
          r.onItemPop(this.current), o.remove.call(this, i);
        }
      };
    }
  }
  return Kl = t, Kl;
}
var zl, Um;
function PP() {
  if (Um) return zl;
  Um = 1;
  const e = xn(), t = Os(), n = j4(), r = OP(), o = Eo().TAG_NAMES;
  class i extends e {
    constructor(s) {
      super(s), this.parser = s, this.treeAdapter = this.parser.treeAdapter, this.posTracker = null, this.lastStartTagToken = null, this.lastFosterParentingLocation = null, this.currentToken = null;
    }
    _setStartLocation(s) {
      let l = null;
      this.lastStartTagToken && (l = Object.assign({}, this.lastStartTagToken.location), l.startTag = this.lastStartTagToken.location), this.treeAdapter.setNodeSourceCodeLocation(s, l);
    }
    _setEndLocation(s, l) {
      if (this.treeAdapter.getNodeSourceCodeLocation(s) && l.location) {
        const u = l.location, m = this.treeAdapter.getTagName(s), v = l.type === t.END_TAG_TOKEN && m === l.tagName, g = {};
        v ? (g.endTag = Object.assign({}, u), g.endLine = u.endLine, g.endCol = u.endCol, g.endOffset = u.endOffset) : (g.endLine = u.startLine, g.endCol = u.startCol, g.endOffset = u.startOffset), this.treeAdapter.updateNodeSourceCodeLocation(s, g);
      }
    }
    _getOverriddenMethods(s, l) {
      return {
        _bootstrap(u, m) {
          l._bootstrap.call(this, u, m), s.lastStartTagToken = null, s.lastFosterParentingLocation = null, s.currentToken = null;
          const v = e.install(this.tokenizer, n);
          s.posTracker = v.posTracker, e.install(this.openElements, r, {
            onItemPop: function(g) {
              s._setEndLocation(g, s.currentToken);
            }
          });
        },
        _runParsingLoop(u) {
          l._runParsingLoop.call(this, u);
          for (let m = this.openElements.stackTop; m >= 0; m--)
            s._setEndLocation(this.openElements.items[m], s.currentToken);
        },
        //Token processing
        _processTokenInForeignContent(u) {
          s.currentToken = u, l._processTokenInForeignContent.call(this, u);
        },
        _processToken(u) {
          if (s.currentToken = u, l._processToken.call(this, u), u.type === t.END_TAG_TOKEN && (u.tagName === o.HTML || u.tagName === o.BODY && this.openElements.hasInScope(o.BODY)))
            for (let m = this.openElements.stackTop; m >= 0; m--) {
              const v = this.openElements.items[m];
              if (this.treeAdapter.getTagName(v) === u.tagName) {
                s._setEndLocation(v, u);
                break;
              }
            }
        },
        //Doctype
        _setDocumentType(u) {
          l._setDocumentType.call(this, u);
          const m = this.treeAdapter.getChildNodes(this.document), v = m.length;
          for (let g = 0; g < v; g++) {
            const h = m[g];
            if (this.treeAdapter.isDocumentTypeNode(h)) {
              this.treeAdapter.setNodeSourceCodeLocation(h, u.location);
              break;
            }
          }
        },
        //Elements
        _attachElementToTree(u) {
          s._setStartLocation(u), s.lastStartTagToken = null, l._attachElementToTree.call(this, u);
        },
        _appendElement(u, m) {
          s.lastStartTagToken = u, l._appendElement.call(this, u, m);
        },
        _insertElement(u, m) {
          s.lastStartTagToken = u, l._insertElement.call(this, u, m);
        },
        _insertTemplate(u) {
          s.lastStartTagToken = u, l._insertTemplate.call(this, u);
          const m = this.treeAdapter.getTemplateContent(this.openElements.current);
          this.treeAdapter.setNodeSourceCodeLocation(m, null);
        },
        _insertFakeRootElement() {
          l._insertFakeRootElement.call(this), this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
        },
        //Comments
        _appendCommentNode(u, m) {
          l._appendCommentNode.call(this, u, m);
          const v = this.treeAdapter.getChildNodes(m), g = v[v.length - 1];
          this.treeAdapter.setNodeSourceCodeLocation(g, u.location);
        },
        //Text
        _findFosterParentingLocation() {
          return s.lastFosterParentingLocation = l._findFosterParentingLocation.call(this), s.lastFosterParentingLocation;
        },
        _insertCharacters(u) {
          l._insertCharacters.call(this, u);
          const m = this._shouldFosterParentOnInsertion(), v = m && s.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current, g = this.treeAdapter.getChildNodes(v), h = m && s.lastFosterParentingLocation.beforeElement ? g.indexOf(s.lastFosterParentingLocation.beforeElement) - 1 : g.length - 1, E = g[h];
          if (this.treeAdapter.getNodeSourceCodeLocation(E)) {
            const { endLine: C, endCol: A, endOffset: R } = u.location;
            this.treeAdapter.updateNodeSourceCodeLocation(E, { endLine: C, endCol: A, endOffset: R });
          } else
            this.treeAdapter.setNodeSourceCodeLocation(E, u.location);
        }
      };
    }
  }
  return zl = i, zl;
}
var Zl, qm;
function D0() {
  if (qm) return Zl;
  qm = 1;
  const e = xn();
  class t extends e {
    constructor(r, o) {
      super(r), this.posTracker = null, this.onParseError = o.onParseError;
    }
    _setErrorLocation(r) {
      r.startLine = r.endLine = this.posTracker.line, r.startCol = r.endCol = this.posTracker.col, r.startOffset = r.endOffset = this.posTracker.offset;
    }
    _reportError(r) {
      const o = {
        code: r,
        startLine: -1,
        startCol: -1,
        startOffset: -1,
        endLine: -1,
        endCol: -1,
        endOffset: -1
      };
      this._setErrorLocation(o), this.onParseError(o);
    }
    _getOverriddenMethods(r) {
      return {
        _err(o) {
          r._reportError(o);
        }
      };
    }
  }
  return Zl = t, Zl;
}
var xl, Gm;
function NP() {
  if (Gm) return xl;
  Gm = 1;
  const e = D0(), t = B4(), n = xn();
  class r extends e {
    constructor(i, a) {
      super(i, a), this.posTracker = n.install(i, t), this.lastErrOffset = -1;
    }
    _reportError(i) {
      this.lastErrOffset !== this.posTracker.offset && (this.lastErrOffset = this.posTracker.offset, super._reportError(i));
    }
  }
  return xl = r, xl;
}
var Wl, Km;
function HP() {
  if (Km) return Wl;
  Km = 1;
  const e = D0(), t = NP(), n = xn();
  class r extends e {
    constructor(i, a) {
      super(i, a);
      const s = n.install(i.preprocessor, t, a);
      this.posTracker = s.posTracker;
    }
  }
  return Wl = r, Wl;
}
var Yl, zm;
function FP() {
  if (zm) return Yl;
  zm = 1;
  const e = D0(), t = HP(), n = j4(), r = xn();
  class o extends e {
    constructor(a, s) {
      super(a, s), this.opts = s, this.ctLoc = null, this.locBeforeToken = !1;
    }
    _setErrorLocation(a) {
      this.ctLoc && (a.startLine = this.ctLoc.startLine, a.startCol = this.ctLoc.startCol, a.startOffset = this.ctLoc.startOffset, a.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine, a.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol, a.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset);
    }
    _getOverriddenMethods(a, s) {
      return {
        _bootstrap(l, u) {
          s._bootstrap.call(this, l, u), r.install(this.tokenizer, t, a.opts), r.install(this.tokenizer, n);
        },
        _processInputToken(l) {
          a.ctLoc = l.location, s._processInputToken.call(this, l);
        },
        _err(l, u) {
          a.locBeforeToken = u && u.beforeToken, a._reportError(l);
        }
      };
    }
  }
  return Yl = o, Yl;
}
var ke = {}, Zm;
function RP() {
  if (Zm) return ke;
  Zm = 1;
  const { DOCUMENT_MODE: e } = Eo();
  ke.createDocument = function() {
    return {
      nodeName: "#document",
      mode: e.NO_QUIRKS,
      childNodes: []
    };
  }, ke.createDocumentFragment = function() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  }, ke.createElement = function(o, i, a) {
    return {
      nodeName: o,
      tagName: o,
      attrs: a,
      namespaceURI: i,
      childNodes: [],
      parentNode: null
    };
  }, ke.createCommentNode = function(o) {
    return {
      nodeName: "#comment",
      data: o,
      parentNode: null
    };
  };
  const t = function(o) {
    return {
      nodeName: "#text",
      value: o,
      parentNode: null
    };
  }, n = ke.appendChild = function(o, i) {
    o.childNodes.push(i), i.parentNode = o;
  }, r = ke.insertBefore = function(o, i, a) {
    const s = o.childNodes.indexOf(a);
    o.childNodes.splice(s, 0, i), i.parentNode = o;
  };
  return ke.setTemplateContent = function(o, i) {
    o.content = i;
  }, ke.getTemplateContent = function(o) {
    return o.content;
  }, ke.setDocumentType = function(o, i, a, s) {
    let l = null;
    for (let u = 0; u < o.childNodes.length; u++)
      if (o.childNodes[u].nodeName === "#documentType") {
        l = o.childNodes[u];
        break;
      }
    l ? (l.name = i, l.publicId = a, l.systemId = s) : n(o, {
      nodeName: "#documentType",
      name: i,
      publicId: a,
      systemId: s
    });
  }, ke.setDocumentMode = function(o, i) {
    o.mode = i;
  }, ke.getDocumentMode = function(o) {
    return o.mode;
  }, ke.detachNode = function(o) {
    if (o.parentNode) {
      const i = o.parentNode.childNodes.indexOf(o);
      o.parentNode.childNodes.splice(i, 1), o.parentNode = null;
    }
  }, ke.insertText = function(o, i) {
    if (o.childNodes.length) {
      const a = o.childNodes[o.childNodes.length - 1];
      if (a.nodeName === "#text") {
        a.value += i;
        return;
      }
    }
    n(o, t(i));
  }, ke.insertTextBefore = function(o, i, a) {
    const s = o.childNodes[o.childNodes.indexOf(a) - 1];
    s && s.nodeName === "#text" ? s.value += i : r(o, t(i), a);
  }, ke.adoptAttributes = function(o, i) {
    const a = [];
    for (let s = 0; s < o.attrs.length; s++)
      a.push(o.attrs[s].name);
    for (let s = 0; s < i.length; s++)
      a.indexOf(i[s].name) === -1 && o.attrs.push(i[s]);
  }, ke.getFirstChild = function(o) {
    return o.childNodes[0];
  }, ke.getChildNodes = function(o) {
    return o.childNodes;
  }, ke.getParentNode = function(o) {
    return o.parentNode;
  }, ke.getAttrList = function(o) {
    return o.attrs;
  }, ke.getTagName = function(o) {
    return o.tagName;
  }, ke.getNamespaceURI = function(o) {
    return o.namespaceURI;
  }, ke.getTextNodeContent = function(o) {
    return o.value;
  }, ke.getCommentNodeContent = function(o) {
    return o.data;
  }, ke.getDocumentTypeNodeName = function(o) {
    return o.name;
  }, ke.getDocumentTypeNodePublicId = function(o) {
    return o.publicId;
  }, ke.getDocumentTypeNodeSystemId = function(o) {
    return o.systemId;
  }, ke.isTextNode = function(o) {
    return o.nodeName === "#text";
  }, ke.isCommentNode = function(o) {
    return o.nodeName === "#comment";
  }, ke.isDocumentTypeNode = function(o) {
    return o.nodeName === "#documentType";
  }, ke.isElementNode = function(o) {
    return !!o.tagName;
  }, ke.setNodeSourceCodeLocation = function(o, i) {
    o.sourceCodeLocation = i;
  }, ke.getNodeSourceCodeLocation = function(o) {
    return o.sourceCodeLocation;
  }, ke.updateNodeSourceCodeLocation = function(o, i) {
    o.sourceCodeLocation = Object.assign(o.sourceCodeLocation, i);
  }, ke;
}
var xm, Wm;
function VP() {
  return Wm || (Wm = 1, xm = function(e, t) {
    return t = t || /* @__PURE__ */ Object.create(null), [e, t].reduce((n, r) => (Object.keys(r).forEach((o) => {
      n[o] = r[o];
    }), n), /* @__PURE__ */ Object.create(null));
  }), xm;
}
var Vo = {}, Ym;
function BP() {
  if (Ym) return Vo;
  Ym = 1;
  const { DOCUMENT_MODE: e } = Eo(), t = "html", n = "about:legacy-compat", r = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", o = [
    "+//silmaril//dtd html pro v0r11 19970101//",
    "-//as//dtd html 3.0 aswedit + extensions//",
    "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
    "-//ietf//dtd html 2.0 level 1//",
    "-//ietf//dtd html 2.0 level 2//",
    "-//ietf//dtd html 2.0 strict level 1//",
    "-//ietf//dtd html 2.0 strict level 2//",
    "-//ietf//dtd html 2.0 strict//",
    "-//ietf//dtd html 2.0//",
    "-//ietf//dtd html 2.1e//",
    "-//ietf//dtd html 3.0//",
    "-//ietf//dtd html 3.2 final//",
    "-//ietf//dtd html 3.2//",
    "-//ietf//dtd html 3//",
    "-//ietf//dtd html level 0//",
    "-//ietf//dtd html level 1//",
    "-//ietf//dtd html level 2//",
    "-//ietf//dtd html level 3//",
    "-//ietf//dtd html strict level 0//",
    "-//ietf//dtd html strict level 1//",
    "-//ietf//dtd html strict level 2//",
    "-//ietf//dtd html strict level 3//",
    "-//ietf//dtd html strict//",
    "-//ietf//dtd html//",
    "-//metrius//dtd metrius presentational//",
    "-//microsoft//dtd internet explorer 2.0 html strict//",
    "-//microsoft//dtd internet explorer 2.0 html//",
    "-//microsoft//dtd internet explorer 2.0 tables//",
    "-//microsoft//dtd internet explorer 3.0 html strict//",
    "-//microsoft//dtd internet explorer 3.0 html//",
    "-//microsoft//dtd internet explorer 3.0 tables//",
    "-//netscape comm. corp.//dtd html//",
    "-//netscape comm. corp.//dtd strict html//",
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    "-//sq//dtd html 2.0 hotmetal + extensions//",
    "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
    "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
    "-//spyglass//dtd html 2.0 extended//",
    "-//sun microsystems corp.//dtd hotjava html//",
    "-//sun microsystems corp.//dtd hotjava strict html//",
    "-//w3c//dtd html 3 1995-03-24//",
    "-//w3c//dtd html 3.2 draft//",
    "-//w3c//dtd html 3.2 final//",
    "-//w3c//dtd html 3.2//",
    "-//w3c//dtd html 3.2s draft//",
    "-//w3c//dtd html 4.0 frameset//",
    "-//w3c//dtd html 4.0 transitional//",
    "-//w3c//dtd html experimental 19960712//",
    "-//w3c//dtd html experimental 970421//",
    "-//w3c//dtd w3 html//",
    "-//w3o//dtd w3 html 3.0//",
    "-//webtechs//dtd mozilla html 2.0//",
    "-//webtechs//dtd mozilla html//"
  ], i = o.concat([
    "-//w3c//dtd html 4.01 frameset//",
    "-//w3c//dtd html 4.01 transitional//"
  ]), a = ["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"], s = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], l = s.concat([
    "-//w3c//dtd html 4.01 frameset//",
    "-//w3c//dtd html 4.01 transitional//"
  ]);
  function u(v) {
    const g = v.indexOf('"') !== -1 ? "'" : '"';
    return g + v + g;
  }
  function m(v, g) {
    for (let h = 0; h < g.length; h++)
      if (v.indexOf(g[h]) === 0)
        return !0;
    return !1;
  }
  return Vo.isConforming = function(v) {
    return v.name === t && v.publicId === null && (v.systemId === null || v.systemId === n);
  }, Vo.getDocumentMode = function(v) {
    if (v.name !== t)
      return e.QUIRKS;
    const g = v.systemId;
    if (g && g.toLowerCase() === r)
      return e.QUIRKS;
    let h = v.publicId;
    if (h !== null) {
      if (h = h.toLowerCase(), a.indexOf(h) > -1)
        return e.QUIRKS;
      let E = g === null ? i : o;
      if (m(h, E))
        return e.QUIRKS;
      if (E = g === null ? s : l, m(h, E))
        return e.LIMITED_QUIRKS;
    }
    return e.NO_QUIRKS;
  }, Vo.serializeContent = function(v, g, h) {
    let E = "!DOCTYPE ";
    return v && (E += v), g ? E += " PUBLIC " + u(g) : h && (E += " SYSTEM"), h !== null && (E += " " + u(h)), E;
  }, Vo;
}
var Rn = {}, Xm;
function jP() {
  if (Xm) return Rn;
  Xm = 1;
  const e = Os(), t = Eo(), n = t.TAG_NAMES, r = t.NAMESPACES, o = t.ATTRS, i = {
    TEXT_HTML: "text/html",
    APPLICATION_XML: "application/xhtml+xml"
  }, a = "definitionurl", s = "definitionURL", l = {
    attributename: "attributeName",
    attributetype: "attributeType",
    basefrequency: "baseFrequency",
    baseprofile: "baseProfile",
    calcmode: "calcMode",
    clippathunits: "clipPathUnits",
    diffuseconstant: "diffuseConstant",
    edgemode: "edgeMode",
    filterunits: "filterUnits",
    glyphref: "glyphRef",
    gradienttransform: "gradientTransform",
    gradientunits: "gradientUnits",
    kernelmatrix: "kernelMatrix",
    kernelunitlength: "kernelUnitLength",
    keypoints: "keyPoints",
    keysplines: "keySplines",
    keytimes: "keyTimes",
    lengthadjust: "lengthAdjust",
    limitingconeangle: "limitingConeAngle",
    markerheight: "markerHeight",
    markerunits: "markerUnits",
    markerwidth: "markerWidth",
    maskcontentunits: "maskContentUnits",
    maskunits: "maskUnits",
    numoctaves: "numOctaves",
    pathlength: "pathLength",
    patterncontentunits: "patternContentUnits",
    patterntransform: "patternTransform",
    patternunits: "patternUnits",
    pointsatx: "pointsAtX",
    pointsaty: "pointsAtY",
    pointsatz: "pointsAtZ",
    preservealpha: "preserveAlpha",
    preserveaspectratio: "preserveAspectRatio",
    primitiveunits: "primitiveUnits",
    refx: "refX",
    refy: "refY",
    repeatcount: "repeatCount",
    repeatdur: "repeatDur",
    requiredextensions: "requiredExtensions",
    requiredfeatures: "requiredFeatures",
    specularconstant: "specularConstant",
    specularexponent: "specularExponent",
    spreadmethod: "spreadMethod",
    startoffset: "startOffset",
    stddeviation: "stdDeviation",
    stitchtiles: "stitchTiles",
    surfacescale: "surfaceScale",
    systemlanguage: "systemLanguage",
    tablevalues: "tableValues",
    targetx: "targetX",
    targety: "targetY",
    textlength: "textLength",
    viewbox: "viewBox",
    viewtarget: "viewTarget",
    xchannelselector: "xChannelSelector",
    ychannelselector: "yChannelSelector",
    zoomandpan: "zoomAndPan"
  }, u = {
    "xlink:actuate": { prefix: "xlink", name: "actuate", namespace: r.XLINK },
    "xlink:arcrole": { prefix: "xlink", name: "arcrole", namespace: r.XLINK },
    "xlink:href": { prefix: "xlink", name: "href", namespace: r.XLINK },
    "xlink:role": { prefix: "xlink", name: "role", namespace: r.XLINK },
    "xlink:show": { prefix: "xlink", name: "show", namespace: r.XLINK },
    "xlink:title": { prefix: "xlink", name: "title", namespace: r.XLINK },
    "xlink:type": { prefix: "xlink", name: "type", namespace: r.XLINK },
    "xml:base": { prefix: "xml", name: "base", namespace: r.XML },
    "xml:lang": { prefix: "xml", name: "lang", namespace: r.XML },
    "xml:space": { prefix: "xml", name: "space", namespace: r.XML },
    xmlns: { prefix: "", name: "xmlns", namespace: r.XMLNS },
    "xmlns:xlink": { prefix: "xmlns", name: "xlink", namespace: r.XMLNS }
  }, m = Rn.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient",
    textpath: "textPath"
  }, v = {
    [n.B]: !0,
    [n.BIG]: !0,
    [n.BLOCKQUOTE]: !0,
    [n.BODY]: !0,
    [n.BR]: !0,
    [n.CENTER]: !0,
    [n.CODE]: !0,
    [n.DD]: !0,
    [n.DIV]: !0,
    [n.DL]: !0,
    [n.DT]: !0,
    [n.EM]: !0,
    [n.EMBED]: !0,
    [n.H1]: !0,
    [n.H2]: !0,
    [n.H3]: !0,
    [n.H4]: !0,
    [n.H5]: !0,
    [n.H6]: !0,
    [n.HEAD]: !0,
    [n.HR]: !0,
    [n.I]: !0,
    [n.IMG]: !0,
    [n.LI]: !0,
    [n.LISTING]: !0,
    [n.MENU]: !0,
    [n.META]: !0,
    [n.NOBR]: !0,
    [n.OL]: !0,
    [n.P]: !0,
    [n.PRE]: !0,
    [n.RUBY]: !0,
    [n.S]: !0,
    [n.SMALL]: !0,
    [n.SPAN]: !0,
    [n.STRONG]: !0,
    [n.STRIKE]: !0,
    [n.SUB]: !0,
    [n.SUP]: !0,
    [n.TABLE]: !0,
    [n.TT]: !0,
    [n.U]: !0,
    [n.UL]: !0,
    [n.VAR]: !0
  };
  Rn.causesExit = function(E) {
    const C = E.tagName;
    return C === n.FONT && (e.getTokenAttr(E, o.COLOR) !== null || e.getTokenAttr(E, o.SIZE) !== null || e.getTokenAttr(E, o.FACE) !== null) ? !0 : v[C];
  }, Rn.adjustTokenMathMLAttrs = function(E) {
    for (let C = 0; C < E.attrs.length; C++)
      if (E.attrs[C].name === a) {
        E.attrs[C].name = s;
        break;
      }
  }, Rn.adjustTokenSVGAttrs = function(E) {
    for (let C = 0; C < E.attrs.length; C++) {
      const A = l[E.attrs[C].name];
      A && (E.attrs[C].name = A);
    }
  }, Rn.adjustTokenXMLAttrs = function(E) {
    for (let C = 0; C < E.attrs.length; C++) {
      const A = u[E.attrs[C].name];
      A && (E.attrs[C].prefix = A.prefix, E.attrs[C].name = A.name, E.attrs[C].namespace = A.namespace);
    }
  }, Rn.adjustTokenSVGTagName = function(E) {
    const C = m[E.tagName];
    C && (E.tagName = C);
  };
  function g(E, C) {
    return C === r.MATHML && (E === n.MI || E === n.MO || E === n.MN || E === n.MS || E === n.MTEXT);
  }
  function h(E, C, A) {
    if (C === r.MATHML && E === n.ANNOTATION_XML) {
      for (let R = 0; R < A.length; R++)
        if (A[R].name === o.ENCODING) {
          const O = A[R].value.toLowerCase();
          return O === i.TEXT_HTML || O === i.APPLICATION_XML;
        }
    }
    return C === r.SVG && (E === n.FOREIGN_OBJECT || E === n.DESC || E === n.TITLE);
  }
  return Rn.isIntegrationPoint = function(E, C, A, R) {
    return !!((!R || R === r.HTML) && h(E, C, A) || (!R || R === r.MATHML) && g(E, C));
  }, Rn;
}
var Xl, Qm;
function UP() {
  if (Qm) return Xl;
  Qm = 1;
  const e = Os(), t = DP(), n = $P(), r = PP(), o = FP(), i = xn(), a = RP(), s = VP(), l = BP(), u = jP(), m = L0(), v = I0(), g = Eo(), h = g.TAG_NAMES, E = g.NAMESPACES, C = g.ATTRS, A = {
    scriptingEnabled: !0,
    sourceCodeLocationInfo: !1,
    onParseError: null,
    treeAdapter: a
  }, R = "hidden", O = 8, F = 3, L = "INITIAL_MODE", D = "BEFORE_HTML_MODE", P = "BEFORE_HEAD_MODE", U = "IN_HEAD_MODE", q = "IN_HEAD_NO_SCRIPT_MODE", z = "AFTER_HEAD_MODE", te = "IN_BODY_MODE", ee = "TEXT_MODE", x = "IN_TABLE_MODE", N = "IN_TABLE_TEXT_MODE", G = "IN_CAPTION_MODE", X = "IN_COLUMN_GROUP_MODE", Q = "IN_TABLE_BODY_MODE", re = "IN_ROW_MODE", se = "IN_CELL_MODE", ue = "IN_SELECT_MODE", me = "IN_SELECT_IN_TABLE_MODE", he = "IN_TEMPLATE_MODE", _e = "AFTER_BODY_MODE", De = "IN_FRAMESET_MODE", Ae = "AFTER_FRAMESET_MODE", ze = "AFTER_AFTER_BODY_MODE", Qe = "AFTER_AFTER_FRAMESET_MODE", Et = {
    [h.TR]: re,
    [h.TBODY]: Q,
    [h.THEAD]: Q,
    [h.TFOOT]: Q,
    [h.CAPTION]: G,
    [h.COLGROUP]: X,
    [h.TABLE]: x,
    [h.BODY]: te,
    [h.FRAMESET]: De
  }, Vt = {
    [h.CAPTION]: x,
    [h.COLGROUP]: x,
    [h.TBODY]: x,
    [h.TFOOT]: x,
    [h.THEAD]: x,
    [h.COL]: X,
    [h.TR]: Q,
    [h.TD]: re,
    [h.TH]: re
  }, mn = {
    [L]: {
      [e.CHARACTER_TOKEN]: Wt,
      [e.NULL_CHARACTER_TOKEN]: Wt,
      [e.WHITESPACE_CHARACTER_TOKEN]: fe,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: ht,
      [e.START_TAG_TOKEN]: Wt,
      [e.END_TAG_TOKEN]: Wt,
      [e.EOF_TOKEN]: Wt
    },
    [D]: {
      [e.CHARACTER_TOKEN]: mt,
      [e.NULL_CHARACTER_TOKEN]: mt,
      [e.WHITESPACE_CHARACTER_TOKEN]: fe,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: vn,
      [e.END_TAG_TOKEN]: et,
      [e.EOF_TOKEN]: mt
    },
    [P]: {
      [e.CHARACTER_TOKEN]: It,
      [e.NULL_CHARACTER_TOKEN]: It,
      [e.WHITESPACE_CHARACTER_TOKEN]: fe,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: Pe,
      [e.START_TAG_TOKEN]: bn,
      [e.END_TAG_TOKEN]: Wn,
      [e.EOF_TOKEN]: It
    },
    [U]: {
      [e.CHARACTER_TOKEN]: Dn,
      [e.NULL_CHARACTER_TOKEN]: Dn,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: Pe,
      [e.START_TAG_TOKEN]: Ce,
      [e.END_TAG_TOKEN]: Ne,
      [e.EOF_TOKEN]: Dn
    },
    [q]: {
      [e.CHARACTER_TOKEN]: Yn,
      [e.NULL_CHARACTER_TOKEN]: Yn,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: Pe,
      [e.START_TAG_TOKEN]: wi,
      [e.END_TAG_TOKEN]: Ti,
      [e.EOF_TOKEN]: Yn
    },
    [z]: {
      [e.CHARACTER_TOKEN]: $n,
      [e.NULL_CHARACTER_TOKEN]: $n,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: Pe,
      [e.START_TAG_TOKEN]: pr,
      [e.END_TAG_TOKEN]: gr,
      [e.EOF_TOKEN]: $n
    },
    [te]: {
      [e.CHARACTER_TOKEN]: On,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: ut,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: Ue,
      [e.END_TAG_TOKEN]: Ys,
      [e.EOF_TOKEN]: Nn
    },
    [ee]: {
      [e.CHARACTER_TOKEN]: be,
      [e.NULL_CHARACTER_TOKEN]: be,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: fe,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: fe,
      [e.END_TAG_TOKEN]: A8,
      [e.EOF_TOKEN]: I8
    },
    [x]: {
      [e.CHARACTER_TOKEN]: Hn,
      [e.NULL_CHARACTER_TOKEN]: Hn,
      [e.WHITESPACE_CHARACTER_TOKEN]: Hn,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: Xs,
      [e.END_TAG_TOKEN]: Qs,
      [e.EOF_TOKEN]: Nn
    },
    [N]: {
      [e.CHARACTER_TOKEN]: V8,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: R8,
      [e.COMMENT_TOKEN]: Oo,
      [e.DOCTYPE_TOKEN]: Oo,
      [e.START_TAG_TOKEN]: Oo,
      [e.END_TAG_TOKEN]: Oo,
      [e.EOF_TOKEN]: Oo
    },
    [G]: {
      [e.CHARACTER_TOKEN]: On,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: ut,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: B8,
      [e.END_TAG_TOKEN]: j8,
      [e.EOF_TOKEN]: Nn
    },
    [X]: {
      [e.CHARACTER_TOKEN]: $i,
      [e.NULL_CHARACTER_TOKEN]: $i,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: U8,
      [e.END_TAG_TOKEN]: q8,
      [e.EOF_TOKEN]: Nn
    },
    [Q]: {
      [e.CHARACTER_TOKEN]: Hn,
      [e.NULL_CHARACTER_TOKEN]: Hn,
      [e.WHITESPACE_CHARACTER_TOKEN]: Hn,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: G8,
      [e.END_TAG_TOKEN]: K8,
      [e.EOF_TOKEN]: Nn
    },
    [re]: {
      [e.CHARACTER_TOKEN]: Hn,
      [e.NULL_CHARACTER_TOKEN]: Hn,
      [e.WHITESPACE_CHARACTER_TOKEN]: Hn,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: z8,
      [e.END_TAG_TOKEN]: Z8,
      [e.EOF_TOKEN]: Nn
    },
    [se]: {
      [e.CHARACTER_TOKEN]: On,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: ut,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: x8,
      [e.END_TAG_TOKEN]: W8,
      [e.EOF_TOKEN]: Nn
    },
    [ue]: {
      [e.CHARACTER_TOKEN]: be,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: lh,
      [e.END_TAG_TOKEN]: uh,
      [e.EOF_TOKEN]: Nn
    },
    [me]: {
      [e.CHARACTER_TOKEN]: be,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: Y8,
      [e.END_TAG_TOKEN]: X8,
      [e.EOF_TOKEN]: Nn
    },
    [he]: {
      [e.CHARACTER_TOKEN]: On,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: ut,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: Q8,
      [e.END_TAG_TOKEN]: J8,
      [e.EOF_TOKEN]: dh
    },
    [_e]: {
      [e.CHARACTER_TOKEN]: Oi,
      [e.NULL_CHARACTER_TOKEN]: Oi,
      [e.WHITESPACE_CHARACTER_TOKEN]: ut,
      [e.COMMENT_TOKEN]: At,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: e6,
      [e.END_TAG_TOKEN]: t6,
      [e.EOF_TOKEN]: Je
    },
    [De]: {
      [e.CHARACTER_TOKEN]: fe,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: n6,
      [e.END_TAG_TOKEN]: r6,
      [e.EOF_TOKEN]: Je
    },
    [Ae]: {
      [e.CHARACTER_TOKEN]: fe,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Re,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: o6,
      [e.END_TAG_TOKEN]: i6,
      [e.EOF_TOKEN]: Je
    },
    [ze]: {
      [e.CHARACTER_TOKEN]: Pi,
      [e.NULL_CHARACTER_TOKEN]: Pi,
      [e.WHITESPACE_CHARACTER_TOKEN]: ut,
      [e.COMMENT_TOKEN]: Ze,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: s6,
      [e.END_TAG_TOKEN]: Pi,
      [e.EOF_TOKEN]: Je
    },
    [Qe]: {
      [e.CHARACTER_TOKEN]: fe,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: ut,
      [e.COMMENT_TOKEN]: Ze,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: a6,
      [e.END_TAG_TOKEN]: fe,
      [e.EOF_TOKEN]: Je
    }
  };
  class fn {
    constructor(b) {
      this.options = s(A, b), this.treeAdapter = this.options.treeAdapter, this.pendingScript = null, this.options.sourceCodeLocationInfo && i.install(this, r), this.options.onParseError && i.install(this, o, { onParseError: this.options.onParseError });
    }
    // API
    parse(b) {
      const y = this.treeAdapter.createDocument();
      return this._bootstrap(y, null), this.tokenizer.write(b, !0), this._runParsingLoop(null), y;
    }
    parseFragment(b, y) {
      y || (y = this.treeAdapter.createElement(h.TEMPLATE, E.HTML, []));
      const ie = this.treeAdapter.createElement("documentmock", E.HTML, []);
      this._bootstrap(ie, y), this.treeAdapter.getTagName(y) === h.TEMPLATE && this._pushTmplInsertionMode(he), this._initTokenizerForFragmentParsing(), this._insertFakeRootElement(), this._resetInsertionMode(), this._findFormInFragmentContext(), this.tokenizer.write(b, !0), this._runParsingLoop(null);
      const pe = this.treeAdapter.getFirstChild(ie), Oe = this.treeAdapter.createDocumentFragment();
      return this._adoptNodes(pe, Oe), Oe;
    }
    //Bootstrap parser
    _bootstrap(b, y) {
      this.tokenizer = new e(this.options), this.stopped = !1, this.insertionMode = L, this.originalInsertionMode = "", this.document = b, this.fragmentContext = y, this.headElement = null, this.formElement = null, this.openElements = new t(this.document, this.treeAdapter), this.activeFormattingElements = new n(this.treeAdapter), this.tmplInsertionModeStack = [], this.tmplInsertionModeStackTop = -1, this.currentTmplInsertionMode = null, this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1;
    }
    //Errors
    _err() {
    }
    //Parsing loop
    _runParsingLoop(b) {
      for (; !this.stopped; ) {
        this._setupTokenizerCDATAMode();
        const y = this.tokenizer.getNextToken();
        if (y.type === e.HIBERNATION_TOKEN)
          break;
        if (this.skipNextNewLine && (this.skipNextNewLine = !1, y.type === e.WHITESPACE_CHARACTER_TOKEN && y.chars[0] === `
`)) {
          if (y.chars.length === 1)
            continue;
          y.chars = y.chars.substr(1);
        }
        if (this._processInputToken(y), b && this.pendingScript)
          break;
      }
    }
    runParsingLoopForCurrentChunk(b, y) {
      if (this._runParsingLoop(y), y && this.pendingScript) {
        const ie = this.pendingScript;
        this.pendingScript = null, y(ie);
        return;
      }
      b && b();
    }
    //Text parsing
    _setupTokenizerCDATAMode() {
      const b = this._getAdjustedCurrentElement();
      this.tokenizer.allowCDATA = b && b !== this.document && this.treeAdapter.getNamespaceURI(b) !== E.HTML && !this._isIntegrationPoint(b);
    }
    _switchToTextParsing(b, y) {
      this._insertElement(b, E.HTML), this.tokenizer.state = y, this.originalInsertionMode = this.insertionMode, this.insertionMode = ee;
    }
    switchToPlaintextParsing() {
      this.insertionMode = ee, this.originalInsertionMode = te, this.tokenizer.state = e.MODE.PLAINTEXT;
    }
    //Fragment parsing
    _getAdjustedCurrentElement() {
      return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
    _findFormInFragmentContext() {
      let b = this.fragmentContext;
      do {
        if (this.treeAdapter.getTagName(b) === h.FORM) {
          this.formElement = b;
          break;
        }
        b = this.treeAdapter.getParentNode(b);
      } while (b);
    }
    _initTokenizerForFragmentParsing() {
      if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === E.HTML) {
        const b = this.treeAdapter.getTagName(this.fragmentContext);
        b === h.TITLE || b === h.TEXTAREA ? this.tokenizer.state = e.MODE.RCDATA : b === h.STYLE || b === h.XMP || b === h.IFRAME || b === h.NOEMBED || b === h.NOFRAMES || b === h.NOSCRIPT ? this.tokenizer.state = e.MODE.RAWTEXT : b === h.SCRIPT ? this.tokenizer.state = e.MODE.SCRIPT_DATA : b === h.PLAINTEXT && (this.tokenizer.state = e.MODE.PLAINTEXT);
      }
    }
    //Tree mutation
    _setDocumentType(b) {
      const y = b.name || "", ie = b.publicId || "", pe = b.systemId || "";
      this.treeAdapter.setDocumentType(this.document, y, ie, pe);
    }
    _attachElementToTree(b) {
      if (this._shouldFosterParentOnInsertion())
        this._fosterParentElement(b);
      else {
        const y = this.openElements.currentTmplContent || this.openElements.current;
        this.treeAdapter.appendChild(y, b);
      }
    }
    _appendElement(b, y) {
      const ie = this.treeAdapter.createElement(b.tagName, y, b.attrs);
      this._attachElementToTree(ie);
    }
    _insertElement(b, y) {
      const ie = this.treeAdapter.createElement(b.tagName, y, b.attrs);
      this._attachElementToTree(ie), this.openElements.push(ie);
    }
    _insertFakeElement(b) {
      const y = this.treeAdapter.createElement(b, E.HTML, []);
      this._attachElementToTree(y), this.openElements.push(y);
    }
    _insertTemplate(b) {
      const y = this.treeAdapter.createElement(b.tagName, E.HTML, b.attrs), ie = this.treeAdapter.createDocumentFragment();
      this.treeAdapter.setTemplateContent(y, ie), this._attachElementToTree(y), this.openElements.push(y);
    }
    _insertFakeRootElement() {
      const b = this.treeAdapter.createElement(h.HTML, E.HTML, []);
      this.treeAdapter.appendChild(this.openElements.current, b), this.openElements.push(b);
    }
    _appendCommentNode(b, y) {
      const ie = this.treeAdapter.createCommentNode(b.data);
      this.treeAdapter.appendChild(y, ie);
    }
    _insertCharacters(b) {
      if (this._shouldFosterParentOnInsertion())
        this._fosterParentText(b.chars);
      else {
        const y = this.openElements.currentTmplContent || this.openElements.current;
        this.treeAdapter.insertText(y, b.chars);
      }
    }
    _adoptNodes(b, y) {
      for (let ie = this.treeAdapter.getFirstChild(b); ie; ie = this.treeAdapter.getFirstChild(b))
        this.treeAdapter.detachNode(ie), this.treeAdapter.appendChild(y, ie);
    }
    //Token processing
    _shouldProcessTokenInForeignContent(b) {
      const y = this._getAdjustedCurrentElement();
      if (!y || y === this.document)
        return !1;
      const ie = this.treeAdapter.getNamespaceURI(y);
      if (ie === E.HTML || this.treeAdapter.getTagName(y) === h.ANNOTATION_XML && ie === E.MATHML && b.type === e.START_TAG_TOKEN && b.tagName === h.SVG)
        return !1;
      const pe = b.type === e.CHARACTER_TOKEN || b.type === e.NULL_CHARACTER_TOKEN || b.type === e.WHITESPACE_CHARACTER_TOKEN;
      return (b.type === e.START_TAG_TOKEN && b.tagName !== h.MGLYPH && b.tagName !== h.MALIGNMARK || pe) && this._isIntegrationPoint(y, E.MATHML) || (b.type === e.START_TAG_TOKEN || pe) && this._isIntegrationPoint(y, E.HTML) ? !1 : b.type !== e.EOF_TOKEN;
    }
    _processToken(b) {
      mn[this.insertionMode][b.type](this, b);
    }
    _processTokenInBodyMode(b) {
      mn[te][b.type](this, b);
    }
    _processTokenInForeignContent(b) {
      b.type === e.CHARACTER_TOKEN ? u6(this, b) : b.type === e.NULL_CHARACTER_TOKEN ? l6(this, b) : b.type === e.WHITESPACE_CHARACTER_TOKEN ? be(this, b) : b.type === e.COMMENT_TOKEN ? Re(this, b) : b.type === e.START_TAG_TOKEN ? d6(this, b) : b.type === e.END_TAG_TOKEN && c6(this, b);
    }
    _processInputToken(b) {
      this._shouldProcessTokenInForeignContent(b) ? this._processTokenInForeignContent(b) : this._processToken(b), b.type === e.START_TAG_TOKEN && b.selfClosing && !b.ackSelfClosing && this._err(m.nonVoidHtmlElementStartTagWithTrailingSolidus);
    }
    //Integration points
    _isIntegrationPoint(b, y) {
      const ie = this.treeAdapter.getTagName(b), pe = this.treeAdapter.getNamespaceURI(b), Oe = this.treeAdapter.getAttrList(b);
      return u.isIntegrationPoint(ie, pe, Oe, y);
    }
    //Active formatting elements reconstruction
    _reconstructActiveFormattingElements() {
      const b = this.activeFormattingElements.length;
      if (b) {
        let y = b, ie = null;
        do
          if (y--, ie = this.activeFormattingElements.entries[y], ie.type === n.MARKER_ENTRY || this.openElements.contains(ie.element)) {
            y++;
            break;
          }
        while (y > 0);
        for (let pe = y; pe < b; pe++)
          ie = this.activeFormattingElements.entries[pe], this._insertElement(ie.token, this.treeAdapter.getNamespaceURI(ie.element)), ie.element = this.openElements.current;
      }
    }
    //Close elements
    _closeTableCell() {
      this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = re;
    }
    _closePElement() {
      this.openElements.generateImpliedEndTagsWithExclusion(h.P), this.openElements.popUntilTagNamePopped(h.P);
    }
    //Insertion modes
    _resetInsertionMode() {
      for (let b = this.openElements.stackTop, y = !1; b >= 0; b--) {
        let ie = this.openElements.items[b];
        b === 0 && (y = !0, this.fragmentContext && (ie = this.fragmentContext));
        const pe = this.treeAdapter.getTagName(ie), Oe = Et[pe];
        if (Oe) {
          this.insertionMode = Oe;
          break;
        } else if (!y && (pe === h.TD || pe === h.TH)) {
          this.insertionMode = se;
          break;
        } else if (!y && pe === h.HEAD) {
          this.insertionMode = U;
          break;
        } else if (pe === h.SELECT) {
          this._resetInsertionModeForSelect(b);
          break;
        } else if (pe === h.TEMPLATE) {
          this.insertionMode = this.currentTmplInsertionMode;
          break;
        } else if (pe === h.HTML) {
          this.insertionMode = this.headElement ? z : P;
          break;
        } else if (y) {
          this.insertionMode = te;
          break;
        }
      }
    }
    _resetInsertionModeForSelect(b) {
      if (b > 0)
        for (let y = b - 1; y > 0; y--) {
          const ie = this.openElements.items[y], pe = this.treeAdapter.getTagName(ie);
          if (pe === h.TEMPLATE)
            break;
          if (pe === h.TABLE) {
            this.insertionMode = me;
            return;
          }
        }
      this.insertionMode = ue;
    }
    _pushTmplInsertionMode(b) {
      this.tmplInsertionModeStack.push(b), this.tmplInsertionModeStackTop++, this.currentTmplInsertionMode = b;
    }
    _popTmplInsertionMode() {
      this.tmplInsertionModeStack.pop(), this.tmplInsertionModeStackTop--, this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
    }
    //Foster parenting
    _isElementCausesFosterParenting(b) {
      const y = this.treeAdapter.getTagName(b);
      return y === h.TABLE || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR;
    }
    _shouldFosterParentOnInsertion() {
      return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
    }
    _findFosterParentingLocation() {
      const b = {
        parent: null,
        beforeElement: null
      };
      for (let y = this.openElements.stackTop; y >= 0; y--) {
        const ie = this.openElements.items[y], pe = this.treeAdapter.getTagName(ie), Oe = this.treeAdapter.getNamespaceURI(ie);
        if (pe === h.TEMPLATE && Oe === E.HTML) {
          b.parent = this.treeAdapter.getTemplateContent(ie);
          break;
        } else if (pe === h.TABLE) {
          b.parent = this.treeAdapter.getParentNode(ie), b.parent ? b.beforeElement = ie : b.parent = this.openElements.items[y - 1];
          break;
        }
      }
      return b.parent || (b.parent = this.openElements.items[0]), b;
    }
    _fosterParentElement(b) {
      const y = this._findFosterParentingLocation();
      y.beforeElement ? this.treeAdapter.insertBefore(y.parent, b, y.beforeElement) : this.treeAdapter.appendChild(y.parent, b);
    }
    _fosterParentText(b) {
      const y = this._findFosterParentingLocation();
      y.beforeElement ? this.treeAdapter.insertTextBefore(y.parent, b, y.beforeElement) : this.treeAdapter.insertText(y.parent, b);
    }
    //Special elements
    _isSpecialElement(b) {
      const y = this.treeAdapter.getTagName(b), ie = this.treeAdapter.getNamespaceURI(b);
      return g.SPECIAL_ELEMENTS[ie][y];
    }
  }
  Xl = fn;
  function pn(p, b) {
    let y = p.activeFormattingElements.getElementEntryInScopeWithTagName(b.tagName);
    return y ? p.openElements.contains(y.element) ? p.openElements.hasInScope(b.tagName) || (y = null) : (p.activeFormattingElements.removeEntry(y), y = null) : sn(p, b), y;
  }
  function gn(p, b) {
    let y = null;
    for (let ie = p.openElements.stackTop; ie >= 0; ie--) {
      const pe = p.openElements.items[ie];
      if (pe === b.element)
        break;
      p._isSpecialElement(pe) && (y = pe);
    }
    return y || (p.openElements.popUntilElementPopped(b.element), p.activeFormattingElements.removeEntry(b)), y;
  }
  function Ln(p, b, y) {
    let ie = b, pe = p.openElements.getCommonAncestor(b);
    for (let Oe = 0, ft = pe; ft !== y; Oe++, ft = pe) {
      pe = p.openElements.getCommonAncestor(ft);
      const Po = p.activeFormattingElements.getElementEntry(ft), ch = Po && Oe >= F;
      !Po || ch ? (ch && p.activeFormattingElements.removeEntry(Po), p.openElements.remove(ft)) : (ft = St(p, Po), ie === b && (p.activeFormattingElements.bookmark = Po), p.treeAdapter.detachNode(ie), p.treeAdapter.appendChild(ft, ie), ie = ft);
    }
    return ie;
  }
  function St(p, b) {
    const y = p.treeAdapter.getNamespaceURI(b.element), ie = p.treeAdapter.createElement(b.token.tagName, y, b.token.attrs);
    return p.openElements.replace(b.element, ie), b.element = ie, ie;
  }
  function ce(p, b, y) {
    if (p._isElementCausesFosterParenting(b))
      p._fosterParentElement(y);
    else {
      const ie = p.treeAdapter.getTagName(b), pe = p.treeAdapter.getNamespaceURI(b);
      ie === h.TEMPLATE && pe === E.HTML && (b = p.treeAdapter.getTemplateContent(b)), p.treeAdapter.appendChild(b, y);
    }
  }
  function Mt(p, b, y) {
    const ie = p.treeAdapter.getNamespaceURI(y.element), pe = y.token, Oe = p.treeAdapter.createElement(pe.tagName, ie, pe.attrs);
    p._adoptNodes(b, Oe), p.treeAdapter.appendChild(b, Oe), p.activeFormattingElements.insertElementAfterBookmark(Oe, y.token), p.activeFormattingElements.removeEntry(y), p.openElements.remove(y.element), p.openElements.insertAfter(b, Oe);
  }
  function le(p, b) {
    let y;
    for (let ie = 0; ie < O && (y = pn(p, b), !!y); ie++) {
      const pe = gn(p, y);
      if (!pe)
        break;
      p.activeFormattingElements.bookmark = y;
      const Oe = Ln(p, pe, y.element), ft = p.openElements.getCommonAncestor(y.element);
      p.treeAdapter.detachNode(Oe), ce(p, ft, Oe), Mt(p, pe, y);
    }
  }
  function fe() {
  }
  function Pe(p) {
    p._err(m.misplacedDoctype);
  }
  function Re(p, b) {
    p._appendCommentNode(b, p.openElements.currentTmplContent || p.openElements.current);
  }
  function At(p, b) {
    p._appendCommentNode(b, p.openElements.items[0]);
  }
  function Ze(p, b) {
    p._appendCommentNode(b, p.document);
  }
  function be(p, b) {
    p._insertCharacters(b);
  }
  function Je(p) {
    p.stopped = !0;
  }
  function ht(p, b) {
    p._setDocumentType(b);
    const y = b.forceQuirks ? g.DOCUMENT_MODE.QUIRKS : l.getDocumentMode(b);
    l.isConforming(b) || p._err(m.nonConformingDoctype), p.treeAdapter.setDocumentMode(p.document, y), p.insertionMode = D;
  }
  function Wt(p, b) {
    p._err(m.missingDoctype, { beforeToken: !0 }), p.treeAdapter.setDocumentMode(p.document, g.DOCUMENT_MODE.QUIRKS), p.insertionMode = D, p._processToken(b);
  }
  function vn(p, b) {
    b.tagName === h.HTML ? (p._insertElement(b, E.HTML), p.insertionMode = P) : mt(p, b);
  }
  function et(p, b) {
    const y = b.tagName;
    (y === h.HTML || y === h.HEAD || y === h.BODY || y === h.BR) && mt(p, b);
  }
  function mt(p, b) {
    p._insertFakeRootElement(), p.insertionMode = P, p._processToken(b);
  }
  function bn(p, b) {
    const y = b.tagName;
    y === h.HTML ? Ue(p, b) : y === h.HEAD ? (p._insertElement(b, E.HTML), p.headElement = p.openElements.current, p.insertionMode = U) : It(p, b);
  }
  function Wn(p, b) {
    const y = b.tagName;
    y === h.HEAD || y === h.BODY || y === h.HTML || y === h.BR ? It(p, b) : p._err(m.endTagWithoutMatchingOpenElement);
  }
  function It(p, b) {
    p._insertFakeElement(h.HEAD), p.headElement = p.openElements.current, p.insertionMode = U, p._processToken(b);
  }
  function Ce(p, b) {
    const y = b.tagName;
    y === h.HTML ? Ue(p, b) : y === h.BASE || y === h.BASEFONT || y === h.BGSOUND || y === h.LINK || y === h.META ? (p._appendElement(b, E.HTML), b.ackSelfClosing = !0) : y === h.TITLE ? p._switchToTextParsing(b, e.MODE.RCDATA) : y === h.NOSCRIPT ? p.options.scriptingEnabled ? p._switchToTextParsing(b, e.MODE.RAWTEXT) : (p._insertElement(b, E.HTML), p.insertionMode = q) : y === h.NOFRAMES || y === h.STYLE ? p._switchToTextParsing(b, e.MODE.RAWTEXT) : y === h.SCRIPT ? p._switchToTextParsing(b, e.MODE.SCRIPT_DATA) : y === h.TEMPLATE ? (p._insertTemplate(b, E.HTML), p.activeFormattingElements.insertMarker(), p.framesetOk = !1, p.insertionMode = he, p._pushTmplInsertionMode(he)) : y === h.HEAD ? p._err(m.misplacedStartTagForHeadElement) : Dn(p, b);
  }
  function Ne(p, b) {
    const y = b.tagName;
    y === h.HEAD ? (p.openElements.pop(), p.insertionMode = z) : y === h.BODY || y === h.BR || y === h.HTML ? Dn(p, b) : y === h.TEMPLATE && p.openElements.tmplCount > 0 ? (p.openElements.generateImpliedEndTagsThoroughly(), p.openElements.currentTagName !== h.TEMPLATE && p._err(m.closingOfElementWithOpenChildElements), p.openElements.popUntilTagNamePopped(h.TEMPLATE), p.activeFormattingElements.clearToLastMarker(), p._popTmplInsertionMode(), p._resetInsertionMode()) : p._err(m.endTagWithoutMatchingOpenElement);
  }
  function Dn(p, b) {
    p.openElements.pop(), p.insertionMode = z, p._processToken(b);
  }
  function wi(p, b) {
    const y = b.tagName;
    y === h.HTML ? Ue(p, b) : y === h.BASEFONT || y === h.BGSOUND || y === h.HEAD || y === h.LINK || y === h.META || y === h.NOFRAMES || y === h.STYLE ? Ce(p, b) : y === h.NOSCRIPT ? p._err(m.nestedNoscriptInHead) : Yn(p, b);
  }
  function Ti(p, b) {
    const y = b.tagName;
    y === h.NOSCRIPT ? (p.openElements.pop(), p.insertionMode = U) : y === h.BR ? Yn(p, b) : p._err(m.endTagWithoutMatchingOpenElement);
  }
  function Yn(p, b) {
    const y = b.type === e.EOF_TOKEN ? m.openElementsLeftAfterEof : m.disallowedContentInNoscriptInHead;
    p._err(y), p.openElements.pop(), p.insertionMode = U, p._processToken(b);
  }
  function pr(p, b) {
    const y = b.tagName;
    y === h.HTML ? Ue(p, b) : y === h.BODY ? (p._insertElement(b, E.HTML), p.framesetOk = !1, p.insertionMode = te) : y === h.FRAMESET ? (p._insertElement(b, E.HTML), p.insertionMode = De) : y === h.BASE || y === h.BASEFONT || y === h.BGSOUND || y === h.LINK || y === h.META || y === h.NOFRAMES || y === h.SCRIPT || y === h.STYLE || y === h.TEMPLATE || y === h.TITLE ? (p._err(m.abandonedHeadElementChild), p.openElements.push(p.headElement), Ce(p, b), p.openElements.remove(p.headElement)) : y === h.HEAD ? p._err(m.misplacedStartTagForHeadElement) : $n(p, b);
  }
  function gr(p, b) {
    const y = b.tagName;
    y === h.BODY || y === h.HTML || y === h.BR ? $n(p, b) : y === h.TEMPLATE ? Ne(p, b) : p._err(m.endTagWithoutMatchingOpenElement);
  }
  function $n(p, b) {
    p._insertFakeElement(h.BODY), p.insertionMode = te, p._processToken(b);
  }
  function ut(p, b) {
    p._reconstructActiveFormattingElements(), p._insertCharacters(b);
  }
  function On(p, b) {
    p._reconstructActiveFormattingElements(), p._insertCharacters(b), p.framesetOk = !1;
  }
  function ki(p, b) {
    p.openElements.tmplCount === 0 && p.treeAdapter.adoptAttributes(p.openElements.items[0], b.attrs);
  }
  function Ei(p, b) {
    const y = p.openElements.tryPeekProperlyNestedBodyElement();
    y && p.openElements.tmplCount === 0 && (p.framesetOk = !1, p.treeAdapter.adoptAttributes(y, b.attrs));
  }
  function Xn(p, b) {
    const y = p.openElements.tryPeekProperlyNestedBodyElement();
    p.framesetOk && y && (p.treeAdapter.detachNode(y), p.openElements.popAllUpToHtmlElement(), p._insertElement(b, E.HTML), p.insertionMode = De);
  }
  function Yt(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML);
  }
  function Si(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement();
    const y = p.openElements.currentTagName;
    (y === h.H1 || y === h.H2 || y === h.H3 || y === h.H4 || y === h.H5 || y === h.H6) && p.openElements.pop(), p._insertElement(b, E.HTML);
  }
  function Ao(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML), p.skipNextNewLine = !0, p.framesetOk = !1;
  }
  function Mi(p, b) {
    const y = p.openElements.tmplCount > 0;
    (!p.formElement || y) && (p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML), y || (p.formElement = p.openElements.current));
  }
  function Ai(p, b) {
    p.framesetOk = !1;
    const y = b.tagName;
    for (let ie = p.openElements.stackTop; ie >= 0; ie--) {
      const pe = p.openElements.items[ie], Oe = p.treeAdapter.getTagName(pe);
      let ft = null;
      if (y === h.LI && Oe === h.LI ? ft = h.LI : (y === h.DD || y === h.DT) && (Oe === h.DD || Oe === h.DT) && (ft = Oe), ft) {
        p.openElements.generateImpliedEndTagsWithExclusion(ft), p.openElements.popUntilTagNamePopped(ft);
        break;
      }
      if (Oe !== h.ADDRESS && Oe !== h.DIV && Oe !== h.P && p._isSpecialElement(pe))
        break;
    }
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML);
  }
  function Ii(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML), p.tokenizer.state = e.MODE.PLAINTEXT;
  }
  function Li(p, b) {
    p.openElements.hasInScope(h.BUTTON) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(h.BUTTON)), p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML), p.framesetOk = !1;
  }
  function vr(p, b) {
    const y = p.activeFormattingElements.getElementEntryInScopeWithTagName(h.A);
    y && (le(p, b), p.openElements.remove(y.element), p.activeFormattingElements.removeEntry(y)), p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML), p.activeFormattingElements.pushElement(p.openElements.current, b);
  }
  function Me(p, b) {
    p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML), p.activeFormattingElements.pushElement(p.openElements.current, b);
  }
  function br(p, b) {
    p._reconstructActiveFormattingElements(), p.openElements.hasInScope(h.NOBR) && (le(p, b), p._reconstructActiveFormattingElements()), p._insertElement(b, E.HTML), p.activeFormattingElements.pushElement(p.openElements.current, b);
  }
  function Lt(p, b) {
    p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML), p.activeFormattingElements.insertMarker(), p.framesetOk = !1;
  }
  function Pn(p, b) {
    p.treeAdapter.getDocumentMode(p.document) !== g.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML), p.framesetOk = !1, p.insertionMode = x;
  }
  function yt(p, b) {
    p._reconstructActiveFormattingElements(), p._appendElement(b, E.HTML), p.framesetOk = !1, b.ackSelfClosing = !0;
  }
  function Io(p, b) {
    p._reconstructActiveFormattingElements(), p._appendElement(b, E.HTML);
    const y = e.getTokenAttr(b, C.TYPE);
    (!y || y.toLowerCase() !== R) && (p.framesetOk = !1), b.ackSelfClosing = !0;
  }
  function Lo(p, b) {
    p._appendElement(b, E.HTML), b.ackSelfClosing = !0;
  }
  function Di(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._appendElement(b, E.HTML), p.framesetOk = !1, b.ackSelfClosing = !0;
  }
  function Ws(p, b) {
    b.tagName = h.IMG, yt(p, b);
  }
  function Wr(p, b) {
    p._insertElement(b, E.HTML), p.skipNextNewLine = !0, p.tokenizer.state = e.MODE.RCDATA, p.originalInsertionMode = p.insertionMode, p.framesetOk = !1, p.insertionMode = ee;
  }
  function je(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._reconstructActiveFormattingElements(), p.framesetOk = !1, p._switchToTextParsing(b, e.MODE.RAWTEXT);
  }
  function yn(p, b) {
    p.framesetOk = !1, p._switchToTextParsing(b, e.MODE.RAWTEXT);
  }
  function Do(p, b) {
    p._switchToTextParsing(b, e.MODE.RAWTEXT);
  }
  function $e(p, b) {
    p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML), p.framesetOk = !1, p.insertionMode === x || p.insertionMode === G || p.insertionMode === Q || p.insertionMode === re || p.insertionMode === se ? p.insertionMode = me : p.insertionMode = ue;
  }
  function ve(p, b) {
    p.openElements.currentTagName === h.OPTION && p.openElements.pop(), p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML);
  }
  function w(p, b) {
    p.openElements.hasInScope(h.RUBY) && p.openElements.generateImpliedEndTags(), p._insertElement(b, E.HTML);
  }
  function Te(p, b) {
    p.openElements.hasInScope(h.RUBY) && p.openElements.generateImpliedEndTagsWithExclusion(h.RTC), p._insertElement(b, E.HTML);
  }
  function _t(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML);
  }
  function st(p, b) {
    p._reconstructActiveFormattingElements(), u.adjustTokenMathMLAttrs(b), u.adjustTokenXMLAttrs(b), b.selfClosing ? p._appendElement(b, E.MATHML) : p._insertElement(b, E.MATHML), b.ackSelfClosing = !0;
  }
  function dt(p, b) {
    p._reconstructActiveFormattingElements(), u.adjustTokenSVGAttrs(b), u.adjustTokenXMLAttrs(b), b.selfClosing ? p._appendElement(b, E.SVG) : p._insertElement(b, E.SVG), b.ackSelfClosing = !0;
  }
  function tt(p, b) {
    p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML);
  }
  function Ue(p, b) {
    const y = b.tagName;
    switch (y.length) {
      case 1:
        y === h.I || y === h.S || y === h.B || y === h.U ? Me(p, b) : y === h.P ? Yt(p, b) : y === h.A ? vr(p, b) : tt(p, b);
        break;
      case 2:
        y === h.DL || y === h.OL || y === h.UL ? Yt(p, b) : y === h.H1 || y === h.H2 || y === h.H3 || y === h.H4 || y === h.H5 || y === h.H6 ? Si(p, b) : y === h.LI || y === h.DD || y === h.DT ? Ai(p, b) : y === h.EM || y === h.TT ? Me(p, b) : y === h.BR ? yt(p, b) : y === h.HR ? Di(p, b) : y === h.RB ? w(p, b) : y === h.RT || y === h.RP ? Te(p, b) : y !== h.TH && y !== h.TD && y !== h.TR && tt(p, b);
        break;
      case 3:
        y === h.DIV || y === h.DIR || y === h.NAV ? Yt(p, b) : y === h.PRE ? Ao(p, b) : y === h.BIG ? Me(p, b) : y === h.IMG || y === h.WBR ? yt(p, b) : y === h.XMP ? je(p, b) : y === h.SVG ? dt(p, b) : y === h.RTC ? w(p, b) : y !== h.COL && tt(p, b);
        break;
      case 4:
        y === h.HTML ? ki(p, b) : y === h.BASE || y === h.LINK || y === h.META ? Ce(p, b) : y === h.BODY ? Ei(p, b) : y === h.MAIN || y === h.MENU ? Yt(p, b) : y === h.FORM ? Mi(p, b) : y === h.CODE || y === h.FONT ? Me(p, b) : y === h.NOBR ? br(p, b) : y === h.AREA ? yt(p, b) : y === h.MATH ? st(p, b) : y === h.MENU ? _t(p, b) : y !== h.HEAD && tt(p, b);
        break;
      case 5:
        y === h.STYLE || y === h.TITLE ? Ce(p, b) : y === h.ASIDE ? Yt(p, b) : y === h.SMALL ? Me(p, b) : y === h.TABLE ? Pn(p, b) : y === h.EMBED ? yt(p, b) : y === h.INPUT ? Io(p, b) : y === h.PARAM || y === h.TRACK ? Lo(p, b) : y === h.IMAGE ? Ws(p, b) : y !== h.FRAME && y !== h.TBODY && y !== h.TFOOT && y !== h.THEAD && tt(p, b);
        break;
      case 6:
        y === h.SCRIPT ? Ce(p, b) : y === h.CENTER || y === h.FIGURE || y === h.FOOTER || y === h.HEADER || y === h.HGROUP || y === h.DIALOG ? Yt(p, b) : y === h.BUTTON ? Li(p, b) : y === h.STRIKE || y === h.STRONG ? Me(p, b) : y === h.APPLET || y === h.OBJECT ? Lt(p, b) : y === h.KEYGEN ? yt(p, b) : y === h.SOURCE ? Lo(p, b) : y === h.IFRAME ? yn(p, b) : y === h.SELECT ? $e(p, b) : y === h.OPTION ? ve(p, b) : tt(p, b);
        break;
      case 7:
        y === h.BGSOUND ? Ce(p, b) : y === h.DETAILS || y === h.ADDRESS || y === h.ARTICLE || y === h.SECTION || y === h.SUMMARY ? Yt(p, b) : y === h.LISTING ? Ao(p, b) : y === h.MARQUEE ? Lt(p, b) : y === h.NOEMBED ? Do(p, b) : y !== h.CAPTION && tt(p, b);
        break;
      case 8:
        y === h.BASEFONT ? Ce(p, b) : y === h.FRAMESET ? Xn(p, b) : y === h.FIELDSET ? Yt(p, b) : y === h.TEXTAREA ? Wr(p, b) : y === h.TEMPLATE ? Ce(p, b) : y === h.NOSCRIPT ? p.options.scriptingEnabled ? Do(p, b) : tt(p, b) : y === h.OPTGROUP ? ve(p, b) : y !== h.COLGROUP && tt(p, b);
        break;
      case 9:
        y === h.PLAINTEXT ? Ii(p, b) : tt(p, b);
        break;
      case 10:
        y === h.BLOCKQUOTE || y === h.FIGCAPTION ? Yt(p, b) : tt(p, b);
        break;
      default:
        tt(p, b);
    }
  }
  function Yr(p) {
    p.openElements.hasInScope(h.BODY) && (p.insertionMode = _e);
  }
  function $o(p, b) {
    p.openElements.hasInScope(h.BODY) && (p.insertionMode = _e, p._processToken(b));
  }
  function Qn(p, b) {
    const y = b.tagName;
    p.openElements.hasInScope(y) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(y));
  }
  function w8(p) {
    const b = p.openElements.tmplCount > 0, y = p.formElement;
    b || (p.formElement = null), (y || b) && p.openElements.hasInScope(h.FORM) && (p.openElements.generateImpliedEndTags(), b ? p.openElements.popUntilTagNamePopped(h.FORM) : p.openElements.remove(y));
  }
  function T8(p) {
    p.openElements.hasInButtonScope(h.P) || p._insertFakeElement(h.P), p._closePElement();
  }
  function k8(p) {
    p.openElements.hasInListItemScope(h.LI) && (p.openElements.generateImpliedEndTagsWithExclusion(h.LI), p.openElements.popUntilTagNamePopped(h.LI));
  }
  function E8(p, b) {
    const y = b.tagName;
    p.openElements.hasInScope(y) && (p.openElements.generateImpliedEndTagsWithExclusion(y), p.openElements.popUntilTagNamePopped(y));
  }
  function S8(p) {
    p.openElements.hasNumberedHeaderInScope() && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilNumberedHeaderPopped());
  }
  function ah(p, b) {
    const y = b.tagName;
    p.openElements.hasInScope(y) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(y), p.activeFormattingElements.clearToLastMarker());
  }
  function M8(p) {
    p._reconstructActiveFormattingElements(), p._insertFakeElement(h.BR), p.openElements.pop(), p.framesetOk = !1;
  }
  function sn(p, b) {
    const y = b.tagName;
    for (let ie = p.openElements.stackTop; ie > 0; ie--) {
      const pe = p.openElements.items[ie];
      if (p.treeAdapter.getTagName(pe) === y) {
        p.openElements.generateImpliedEndTagsWithExclusion(y), p.openElements.popUntilElementPopped(pe);
        break;
      }
      if (p._isSpecialElement(pe))
        break;
    }
  }
  function Ys(p, b) {
    const y = b.tagName;
    switch (y.length) {
      case 1:
        y === h.A || y === h.B || y === h.I || y === h.S || y === h.U ? le(p, b) : y === h.P ? T8(p) : sn(p, b);
        break;
      case 2:
        y === h.DL || y === h.UL || y === h.OL ? Qn(p, b) : y === h.LI ? k8(p) : y === h.DD || y === h.DT ? E8(p, b) : y === h.H1 || y === h.H2 || y === h.H3 || y === h.H4 || y === h.H5 || y === h.H6 ? S8(p) : y === h.BR ? M8(p) : y === h.EM || y === h.TT ? le(p, b) : sn(p, b);
        break;
      case 3:
        y === h.BIG ? le(p, b) : y === h.DIR || y === h.DIV || y === h.NAV || y === h.PRE ? Qn(p, b) : sn(p, b);
        break;
      case 4:
        y === h.BODY ? Yr(p) : y === h.HTML ? $o(p, b) : y === h.FORM ? w8(p) : y === h.CODE || y === h.FONT || y === h.NOBR ? le(p, b) : y === h.MAIN || y === h.MENU ? Qn(p, b) : sn(p, b);
        break;
      case 5:
        y === h.ASIDE ? Qn(p, b) : y === h.SMALL ? le(p, b) : sn(p, b);
        break;
      case 6:
        y === h.CENTER || y === h.FIGURE || y === h.FOOTER || y === h.HEADER || y === h.HGROUP || y === h.DIALOG ? Qn(p, b) : y === h.APPLET || y === h.OBJECT ? ah(p, b) : y === h.STRIKE || y === h.STRONG ? le(p, b) : sn(p, b);
        break;
      case 7:
        y === h.ADDRESS || y === h.ARTICLE || y === h.DETAILS || y === h.SECTION || y === h.SUMMARY || y === h.LISTING ? Qn(p, b) : y === h.MARQUEE ? ah(p, b) : sn(p, b);
        break;
      case 8:
        y === h.FIELDSET ? Qn(p, b) : y === h.TEMPLATE ? Ne(p, b) : sn(p, b);
        break;
      case 10:
        y === h.BLOCKQUOTE || y === h.FIGCAPTION ? Qn(p, b) : sn(p, b);
        break;
      default:
        sn(p, b);
    }
  }
  function Nn(p, b) {
    p.tmplInsertionModeStackTop > -1 ? dh(p, b) : p.stopped = !0;
  }
  function A8(p, b) {
    b.tagName === h.SCRIPT && (p.pendingScript = p.openElements.current), p.openElements.pop(), p.insertionMode = p.originalInsertionMode;
  }
  function I8(p, b) {
    p._err(m.eofInElementThatCanContainOnlyText), p.openElements.pop(), p.insertionMode = p.originalInsertionMode, p._processToken(b);
  }
  function Hn(p, b) {
    const y = p.openElements.currentTagName;
    y === h.TABLE || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR ? (p.pendingCharacterTokens = [], p.hasNonWhitespacePendingCharacterToken = !1, p.originalInsertionMode = p.insertionMode, p.insertionMode = N, p._processToken(b)) : Xt(p, b);
  }
  function L8(p, b) {
    p.openElements.clearBackToTableContext(), p.activeFormattingElements.insertMarker(), p._insertElement(b, E.HTML), p.insertionMode = G;
  }
  function D8(p, b) {
    p.openElements.clearBackToTableContext(), p._insertElement(b, E.HTML), p.insertionMode = X;
  }
  function $8(p, b) {
    p.openElements.clearBackToTableContext(), p._insertFakeElement(h.COLGROUP), p.insertionMode = X, p._processToken(b);
  }
  function O8(p, b) {
    p.openElements.clearBackToTableContext(), p._insertElement(b, E.HTML), p.insertionMode = Q;
  }
  function P8(p, b) {
    p.openElements.clearBackToTableContext(), p._insertFakeElement(h.TBODY), p.insertionMode = Q, p._processToken(b);
  }
  function N8(p, b) {
    p.openElements.hasInTableScope(h.TABLE) && (p.openElements.popUntilTagNamePopped(h.TABLE), p._resetInsertionMode(), p._processToken(b));
  }
  function H8(p, b) {
    const y = e.getTokenAttr(b, C.TYPE);
    y && y.toLowerCase() === R ? p._appendElement(b, E.HTML) : Xt(p, b), b.ackSelfClosing = !0;
  }
  function F8(p, b) {
    !p.formElement && p.openElements.tmplCount === 0 && (p._insertElement(b, E.HTML), p.formElement = p.openElements.current, p.openElements.pop());
  }
  function Xs(p, b) {
    const y = b.tagName;
    switch (y.length) {
      case 2:
        y === h.TD || y === h.TH || y === h.TR ? P8(p, b) : Xt(p, b);
        break;
      case 3:
        y === h.COL ? $8(p, b) : Xt(p, b);
        break;
      case 4:
        y === h.FORM ? F8(p, b) : Xt(p, b);
        break;
      case 5:
        y === h.TABLE ? N8(p, b) : y === h.STYLE ? Ce(p, b) : y === h.TBODY || y === h.TFOOT || y === h.THEAD ? O8(p, b) : y === h.INPUT ? H8(p, b) : Xt(p, b);
        break;
      case 6:
        y === h.SCRIPT ? Ce(p, b) : Xt(p, b);
        break;
      case 7:
        y === h.CAPTION ? L8(p, b) : Xt(p, b);
        break;
      case 8:
        y === h.COLGROUP ? D8(p, b) : y === h.TEMPLATE ? Ce(p, b) : Xt(p, b);
        break;
      default:
        Xt(p, b);
    }
  }
  function Qs(p, b) {
    const y = b.tagName;
    y === h.TABLE ? p.openElements.hasInTableScope(h.TABLE) && (p.openElements.popUntilTagNamePopped(h.TABLE), p._resetInsertionMode()) : y === h.TEMPLATE ? Ne(p, b) : y !== h.BODY && y !== h.CAPTION && y !== h.COL && y !== h.COLGROUP && y !== h.HTML && y !== h.TBODY && y !== h.TD && y !== h.TFOOT && y !== h.TH && y !== h.THEAD && y !== h.TR && Xt(p, b);
  }
  function Xt(p, b) {
    const y = p.fosterParentingEnabled;
    p.fosterParentingEnabled = !0, p._processTokenInBodyMode(b), p.fosterParentingEnabled = y;
  }
  function R8(p, b) {
    p.pendingCharacterTokens.push(b);
  }
  function V8(p, b) {
    p.pendingCharacterTokens.push(b), p.hasNonWhitespacePendingCharacterToken = !0;
  }
  function Oo(p, b) {
    let y = 0;
    if (p.hasNonWhitespacePendingCharacterToken)
      for (; y < p.pendingCharacterTokens.length; y++)
        Xt(p, p.pendingCharacterTokens[y]);
    else
      for (; y < p.pendingCharacterTokens.length; y++)
        p._insertCharacters(p.pendingCharacterTokens[y]);
    p.insertionMode = p.originalInsertionMode, p._processToken(b);
  }
  function B8(p, b) {
    const y = b.tagName;
    y === h.CAPTION || y === h.COL || y === h.COLGROUP || y === h.TBODY || y === h.TD || y === h.TFOOT || y === h.TH || y === h.THEAD || y === h.TR ? p.openElements.hasInTableScope(h.CAPTION) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(h.CAPTION), p.activeFormattingElements.clearToLastMarker(), p.insertionMode = x, p._processToken(b)) : Ue(p, b);
  }
  function j8(p, b) {
    const y = b.tagName;
    y === h.CAPTION || y === h.TABLE ? p.openElements.hasInTableScope(h.CAPTION) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(h.CAPTION), p.activeFormattingElements.clearToLastMarker(), p.insertionMode = x, y === h.TABLE && p._processToken(b)) : y !== h.BODY && y !== h.COL && y !== h.COLGROUP && y !== h.HTML && y !== h.TBODY && y !== h.TD && y !== h.TFOOT && y !== h.TH && y !== h.THEAD && y !== h.TR && Ys(p, b);
  }
  function U8(p, b) {
    const y = b.tagName;
    y === h.HTML ? Ue(p, b) : y === h.COL ? (p._appendElement(b, E.HTML), b.ackSelfClosing = !0) : y === h.TEMPLATE ? Ce(p, b) : $i(p, b);
  }
  function q8(p, b) {
    const y = b.tagName;
    y === h.COLGROUP ? p.openElements.currentTagName === h.COLGROUP && (p.openElements.pop(), p.insertionMode = x) : y === h.TEMPLATE ? Ne(p, b) : y !== h.COL && $i(p, b);
  }
  function $i(p, b) {
    p.openElements.currentTagName === h.COLGROUP && (p.openElements.pop(), p.insertionMode = x, p._processToken(b));
  }
  function G8(p, b) {
    const y = b.tagName;
    y === h.TR ? (p.openElements.clearBackToTableBodyContext(), p._insertElement(b, E.HTML), p.insertionMode = re) : y === h.TH || y === h.TD ? (p.openElements.clearBackToTableBodyContext(), p._insertFakeElement(h.TR), p.insertionMode = re, p._processToken(b)) : y === h.CAPTION || y === h.COL || y === h.COLGROUP || y === h.TBODY || y === h.TFOOT || y === h.THEAD ? p.openElements.hasTableBodyContextInTableScope() && (p.openElements.clearBackToTableBodyContext(), p.openElements.pop(), p.insertionMode = x, p._processToken(b)) : Xs(p, b);
  }
  function K8(p, b) {
    const y = b.tagName;
    y === h.TBODY || y === h.TFOOT || y === h.THEAD ? p.openElements.hasInTableScope(y) && (p.openElements.clearBackToTableBodyContext(), p.openElements.pop(), p.insertionMode = x) : y === h.TABLE ? p.openElements.hasTableBodyContextInTableScope() && (p.openElements.clearBackToTableBodyContext(), p.openElements.pop(), p.insertionMode = x, p._processToken(b)) : (y !== h.BODY && y !== h.CAPTION && y !== h.COL && y !== h.COLGROUP || y !== h.HTML && y !== h.TD && y !== h.TH && y !== h.TR) && Qs(p, b);
  }
  function z8(p, b) {
    const y = b.tagName;
    y === h.TH || y === h.TD ? (p.openElements.clearBackToTableRowContext(), p._insertElement(b, E.HTML), p.insertionMode = se, p.activeFormattingElements.insertMarker()) : y === h.CAPTION || y === h.COL || y === h.COLGROUP || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR ? p.openElements.hasInTableScope(h.TR) && (p.openElements.clearBackToTableRowContext(), p.openElements.pop(), p.insertionMode = Q, p._processToken(b)) : Xs(p, b);
  }
  function Z8(p, b) {
    const y = b.tagName;
    y === h.TR ? p.openElements.hasInTableScope(h.TR) && (p.openElements.clearBackToTableRowContext(), p.openElements.pop(), p.insertionMode = Q) : y === h.TABLE ? p.openElements.hasInTableScope(h.TR) && (p.openElements.clearBackToTableRowContext(), p.openElements.pop(), p.insertionMode = Q, p._processToken(b)) : y === h.TBODY || y === h.TFOOT || y === h.THEAD ? (p.openElements.hasInTableScope(y) || p.openElements.hasInTableScope(h.TR)) && (p.openElements.clearBackToTableRowContext(), p.openElements.pop(), p.insertionMode = Q, p._processToken(b)) : (y !== h.BODY && y !== h.CAPTION && y !== h.COL && y !== h.COLGROUP || y !== h.HTML && y !== h.TD && y !== h.TH) && Qs(p, b);
  }
  function x8(p, b) {
    const y = b.tagName;
    y === h.CAPTION || y === h.COL || y === h.COLGROUP || y === h.TBODY || y === h.TD || y === h.TFOOT || y === h.TH || y === h.THEAD || y === h.TR ? (p.openElements.hasInTableScope(h.TD) || p.openElements.hasInTableScope(h.TH)) && (p._closeTableCell(), p._processToken(b)) : Ue(p, b);
  }
  function W8(p, b) {
    const y = b.tagName;
    y === h.TD || y === h.TH ? p.openElements.hasInTableScope(y) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(y), p.activeFormattingElements.clearToLastMarker(), p.insertionMode = re) : y === h.TABLE || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR ? p.openElements.hasInTableScope(y) && (p._closeTableCell(), p._processToken(b)) : y !== h.BODY && y !== h.CAPTION && y !== h.COL && y !== h.COLGROUP && y !== h.HTML && Ys(p, b);
  }
  function lh(p, b) {
    const y = b.tagName;
    y === h.HTML ? Ue(p, b) : y === h.OPTION ? (p.openElements.currentTagName === h.OPTION && p.openElements.pop(), p._insertElement(b, E.HTML)) : y === h.OPTGROUP ? (p.openElements.currentTagName === h.OPTION && p.openElements.pop(), p.openElements.currentTagName === h.OPTGROUP && p.openElements.pop(), p._insertElement(b, E.HTML)) : y === h.INPUT || y === h.KEYGEN || y === h.TEXTAREA || y === h.SELECT ? p.openElements.hasInSelectScope(h.SELECT) && (p.openElements.popUntilTagNamePopped(h.SELECT), p._resetInsertionMode(), y !== h.SELECT && p._processToken(b)) : (y === h.SCRIPT || y === h.TEMPLATE) && Ce(p, b);
  }
  function uh(p, b) {
    const y = b.tagName;
    if (y === h.OPTGROUP) {
      const ie = p.openElements.items[p.openElements.stackTop - 1], pe = ie && p.treeAdapter.getTagName(ie);
      p.openElements.currentTagName === h.OPTION && pe === h.OPTGROUP && p.openElements.pop(), p.openElements.currentTagName === h.OPTGROUP && p.openElements.pop();
    } else y === h.OPTION ? p.openElements.currentTagName === h.OPTION && p.openElements.pop() : y === h.SELECT && p.openElements.hasInSelectScope(h.SELECT) ? (p.openElements.popUntilTagNamePopped(h.SELECT), p._resetInsertionMode()) : y === h.TEMPLATE && Ne(p, b);
  }
  function Y8(p, b) {
    const y = b.tagName;
    y === h.CAPTION || y === h.TABLE || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR || y === h.TD || y === h.TH ? (p.openElements.popUntilTagNamePopped(h.SELECT), p._resetInsertionMode(), p._processToken(b)) : lh(p, b);
  }
  function X8(p, b) {
    const y = b.tagName;
    y === h.CAPTION || y === h.TABLE || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR || y === h.TD || y === h.TH ? p.openElements.hasInTableScope(y) && (p.openElements.popUntilTagNamePopped(h.SELECT), p._resetInsertionMode(), p._processToken(b)) : uh(p, b);
  }
  function Q8(p, b) {
    const y = b.tagName;
    if (y === h.BASE || y === h.BASEFONT || y === h.BGSOUND || y === h.LINK || y === h.META || y === h.NOFRAMES || y === h.SCRIPT || y === h.STYLE || y === h.TEMPLATE || y === h.TITLE)
      Ce(p, b);
    else {
      const ie = Vt[y] || te;
      p._popTmplInsertionMode(), p._pushTmplInsertionMode(ie), p.insertionMode = ie, p._processToken(b);
    }
  }
  function J8(p, b) {
    b.tagName === h.TEMPLATE && Ne(p, b);
  }
  function dh(p, b) {
    p.openElements.tmplCount > 0 ? (p.openElements.popUntilTagNamePopped(h.TEMPLATE), p.activeFormattingElements.clearToLastMarker(), p._popTmplInsertionMode(), p._resetInsertionMode(), p._processToken(b)) : p.stopped = !0;
  }
  function e6(p, b) {
    b.tagName === h.HTML ? Ue(p, b) : Oi(p, b);
  }
  function t6(p, b) {
    b.tagName === h.HTML ? p.fragmentContext || (p.insertionMode = ze) : Oi(p, b);
  }
  function Oi(p, b) {
    p.insertionMode = te, p._processToken(b);
  }
  function n6(p, b) {
    const y = b.tagName;
    y === h.HTML ? Ue(p, b) : y === h.FRAMESET ? p._insertElement(b, E.HTML) : y === h.FRAME ? (p._appendElement(b, E.HTML), b.ackSelfClosing = !0) : y === h.NOFRAMES && Ce(p, b);
  }
  function r6(p, b) {
    b.tagName === h.FRAMESET && !p.openElements.isRootHtmlElementCurrent() && (p.openElements.pop(), !p.fragmentContext && p.openElements.currentTagName !== h.FRAMESET && (p.insertionMode = Ae));
  }
  function o6(p, b) {
    const y = b.tagName;
    y === h.HTML ? Ue(p, b) : y === h.NOFRAMES && Ce(p, b);
  }
  function i6(p, b) {
    b.tagName === h.HTML && (p.insertionMode = Qe);
  }
  function s6(p, b) {
    b.tagName === h.HTML ? Ue(p, b) : Pi(p, b);
  }
  function Pi(p, b) {
    p.insertionMode = te, p._processToken(b);
  }
  function a6(p, b) {
    const y = b.tagName;
    y === h.HTML ? Ue(p, b) : y === h.NOFRAMES && Ce(p, b);
  }
  function l6(p, b) {
    b.chars = v.REPLACEMENT_CHARACTER, p._insertCharacters(b);
  }
  function u6(p, b) {
    p._insertCharacters(b), p.framesetOk = !1;
  }
  function d6(p, b) {
    if (u.causesExit(b) && !p.fragmentContext) {
      for (; p.treeAdapter.getNamespaceURI(p.openElements.current) !== E.HTML && !p._isIntegrationPoint(p.openElements.current); )
        p.openElements.pop();
      p._processToken(b);
    } else {
      const y = p._getAdjustedCurrentElement(), ie = p.treeAdapter.getNamespaceURI(y);
      ie === E.MATHML ? u.adjustTokenMathMLAttrs(b) : ie === E.SVG && (u.adjustTokenSVGTagName(b), u.adjustTokenSVGAttrs(b)), u.adjustTokenXMLAttrs(b), b.selfClosing ? p._appendElement(b, ie) : p._insertElement(b, ie), b.ackSelfClosing = !0;
    }
  }
  function c6(p, b) {
    for (let y = p.openElements.stackTop; y > 0; y--) {
      const ie = p.openElements.items[y];
      if (p.treeAdapter.getNamespaceURI(ie) === E.HTML) {
        p._processToken(b);
        break;
      }
      if (p.treeAdapter.getTagName(ie).toLowerCase() === b.tagName) {
        p.openElements.popUntilElementPopped(ie);
        break;
      }
    }
  }
  return Xl;
}
var qP = UP();
const GP = /* @__PURE__ */ ko(qP);
class pi {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
pi.prototype.property = {};
pi.prototype.normal = {};
pi.prototype.space = null;
function U4(e, t) {
  const n = {}, r = {};
  let o = -1;
  for (; ++o < e.length; )
    Object.assign(n, e[o].property), Object.assign(r, e[o].normal);
  return new pi(n, r, t);
}
function ai(e) {
  return e.toLowerCase();
}
class on {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
on.prototype.space = null;
on.prototype.boolean = !1;
on.prototype.booleanish = !1;
on.prototype.overloadedBoolean = !1;
on.prototype.number = !1;
on.prototype.commaSeparated = !1;
on.prototype.spaceSeparated = !1;
on.prototype.commaOrSpaceSeparated = !1;
on.prototype.mustUseProperty = !1;
on.prototype.defined = !1;
let KP = 0;
const ye = Kr(), nt = Kr(), q4 = Kr(), oe = Kr(), Ve = Kr(), lo = Kr(), jt = Kr();
function Kr() {
  return 2 ** ++KP;
}
const qc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: ye,
  booleanish: nt,
  commaOrSpaceSeparated: jt,
  commaSeparated: lo,
  number: oe,
  overloadedBoolean: q4,
  spaceSeparated: Ve
}, Symbol.toStringTag, { value: "Module" })), Ql = Object.keys(qc);
class $0 extends on {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, o) {
    let i = -1;
    if (super(t, n), Jm(this, "space", o), typeof r == "number")
      for (; ++i < Ql.length; ) {
        const a = Ql[i];
        Jm(this, Ql[i], (r & qc[a]) === qc[a]);
      }
  }
}
$0.prototype.defined = !0;
function Jm(e, t, n) {
  n && (e[t] = n);
}
const zP = {}.hasOwnProperty;
function So(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (zP.call(e.properties, r)) {
      const o = e.properties[r], i = new $0(
        r,
        e.transform(e.attributes || {}, r),
        o,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[ai(r)] = r, n[ai(i.attribute)] = r;
    }
  return new pi(t, n, e.space);
}
const G4 = So({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), K4 = So({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function z4(e, t) {
  return t in e ? e[t] : t;
}
function Z4(e, t) {
  return z4(e, t.toLowerCase());
}
const x4 = So({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: Z4,
  properties: { xmlns: null, xmlnsXLink: null }
}), W4 = So({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: nt,
    ariaAutoComplete: null,
    ariaBusy: nt,
    ariaChecked: nt,
    ariaColCount: oe,
    ariaColIndex: oe,
    ariaColSpan: oe,
    ariaControls: Ve,
    ariaCurrent: null,
    ariaDescribedBy: Ve,
    ariaDetails: null,
    ariaDisabled: nt,
    ariaDropEffect: Ve,
    ariaErrorMessage: null,
    ariaExpanded: nt,
    ariaFlowTo: Ve,
    ariaGrabbed: nt,
    ariaHasPopup: null,
    ariaHidden: nt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Ve,
    ariaLevel: oe,
    ariaLive: null,
    ariaModal: nt,
    ariaMultiLine: nt,
    ariaMultiSelectable: nt,
    ariaOrientation: null,
    ariaOwns: Ve,
    ariaPlaceholder: null,
    ariaPosInSet: oe,
    ariaPressed: nt,
    ariaReadOnly: nt,
    ariaRelevant: null,
    ariaRequired: nt,
    ariaRoleDescription: Ve,
    ariaRowCount: oe,
    ariaRowIndex: oe,
    ariaRowSpan: oe,
    ariaSelected: nt,
    ariaSetSize: oe,
    ariaSort: null,
    ariaValueMax: oe,
    ariaValueMin: oe,
    ariaValueNow: oe,
    ariaValueText: null,
    role: null
  }
}), ZP = So({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: Z4,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: lo,
    acceptCharset: Ve,
    accessKey: Ve,
    action: null,
    allow: null,
    allowFullScreen: ye,
    allowPaymentRequest: ye,
    allowUserMedia: ye,
    alt: null,
    as: null,
    async: ye,
    autoCapitalize: null,
    autoComplete: Ve,
    autoFocus: ye,
    autoPlay: ye,
    blocking: Ve,
    capture: null,
    charSet: null,
    checked: ye,
    cite: null,
    className: Ve,
    cols: oe,
    colSpan: null,
    content: null,
    contentEditable: nt,
    controls: ye,
    controlsList: Ve,
    coords: oe | lo,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: ye,
    defer: ye,
    dir: null,
    dirName: null,
    disabled: ye,
    download: q4,
    draggable: nt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: ye,
    formTarget: null,
    headers: Ve,
    height: oe,
    hidden: ye,
    high: oe,
    href: null,
    hrefLang: null,
    htmlFor: Ve,
    httpEquiv: Ve,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: ye,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: ye,
    itemId: null,
    itemProp: Ve,
    itemRef: Ve,
    itemScope: ye,
    itemType: Ve,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: ye,
    low: oe,
    manifest: null,
    max: null,
    maxLength: oe,
    media: null,
    method: null,
    min: null,
    minLength: oe,
    multiple: ye,
    muted: ye,
    name: null,
    nonce: null,
    noModule: ye,
    noValidate: ye,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: ye,
    optimum: oe,
    pattern: null,
    ping: Ve,
    placeholder: null,
    playsInline: ye,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: ye,
    referrerPolicy: null,
    rel: Ve,
    required: ye,
    reversed: ye,
    rows: oe,
    rowSpan: oe,
    sandbox: Ve,
    scope: null,
    scoped: ye,
    seamless: ye,
    selected: ye,
    shadowRootClonable: ye,
    shadowRootDelegatesFocus: ye,
    shadowRootMode: null,
    shape: null,
    size: oe,
    sizes: null,
    slot: null,
    span: oe,
    spellCheck: nt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: oe,
    step: null,
    style: null,
    tabIndex: oe,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: ye,
    useMap: null,
    value: nt,
    width: oe,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Ve,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: oe,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: oe,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: ye,
    // Lists. Use CSS to reduce space between items instead
    declare: ye,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: oe,
    // `<img>` and `<object>`
    leftMargin: oe,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: oe,
    // `<body>`
    marginWidth: oe,
    // `<body>`
    noResize: ye,
    // `<frame>`
    noHref: ye,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: ye,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: ye,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: oe,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: nt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: oe,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: oe,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: ye,
    disableRemotePlayback: ye,
    prefix: null,
    property: null,
    results: oe,
    security: null,
    unselectable: null
  }
}), xP = So({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: z4,
  properties: {
    about: jt,
    accentHeight: oe,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: oe,
    amplitude: oe,
    arabicForm: null,
    ascent: oe,
    attributeName: null,
    attributeType: null,
    azimuth: oe,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: oe,
    by: null,
    calcMode: null,
    capHeight: oe,
    className: Ve,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: oe,
    diffuseConstant: oe,
    direction: null,
    display: null,
    dur: null,
    divisor: oe,
    dominantBaseline: null,
    download: ye,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: oe,
    enableBackground: null,
    end: null,
    event: null,
    exponent: oe,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: oe,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: lo,
    g2: lo,
    glyphName: lo,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: oe,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: oe,
    horizOriginX: oe,
    horizOriginY: oe,
    id: null,
    ideographic: oe,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: oe,
    k: oe,
    k1: oe,
    k2: oe,
    k3: oe,
    k4: oe,
    kernelMatrix: jt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: oe,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: oe,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: oe,
    overlineThickness: oe,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: oe,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Ve,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: oe,
    pointsAtY: oe,
    pointsAtZ: oe,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: jt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: jt,
    rev: jt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: jt,
    requiredFeatures: jt,
    requiredFonts: jt,
    requiredFormats: jt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: oe,
    specularExponent: oe,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: oe,
    strikethroughThickness: oe,
    string: null,
    stroke: null,
    strokeDashArray: jt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: oe,
    strokeOpacity: oe,
    strokeWidth: null,
    style: null,
    surfaceScale: oe,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: jt,
    tabIndex: oe,
    tableValues: null,
    target: null,
    targetX: oe,
    targetY: oe,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: jt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: oe,
    underlineThickness: oe,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: oe,
    values: null,
    vAlphabetic: oe,
    vMathematical: oe,
    vectorEffect: null,
    vHanging: oe,
    vIdeographic: oe,
    version: null,
    vertAdvY: oe,
    vertOriginX: oe,
    vertOriginY: oe,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: oe,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), WP = /^data[-\w.:]+$/i, e5 = /-[a-z]/g, YP = /[A-Z]/g;
function O0(e, t) {
  const n = ai(t);
  let r = t, o = on;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && WP.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(e5, QP);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!e5.test(i)) {
        let a = i.replace(YP, XP);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    o = $0;
  }
  return new o(r, t);
}
function XP(e) {
  return "-" + e.toLowerCase();
}
function QP(e) {
  return e.charAt(1).toUpperCase();
}
const Ps = U4([K4, G4, x4, W4, ZP], "html"), gi = U4([K4, G4, x4, W4, xP], "svg"), t5 = /[#.]/g;
function JP(e, t) {
  const n = e || "", r = {};
  let o = 0, i, a;
  for (; o < n.length; ) {
    t5.lastIndex = o;
    const s = t5.exec(n), l = n.slice(o, s ? s.index : n.length);
    l && (i ? i === "#" ? r.id = l : Array.isArray(r.className) ? r.className.push(l) : r.className = [l] : a = l, o += l.length), s && (i = s[0], o++);
  }
  return {
    type: "element",
    // @ts-expect-error: fine.
    tagName: a || t || "div",
    properties: r,
    children: []
  };
}
function n5(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function eN(e) {
  return e.join(" ").trim();
}
function r5(e) {
  const t = [], n = String(e || "");
  let r = n.indexOf(","), o = 0, i = !1;
  for (; !i; ) {
    r === -1 && (r = n.length, i = !0);
    const a = n.slice(o, r).trim();
    (a || !i) && t.push(a), o = r + 1, r = n.indexOf(",", o);
  }
  return t;
}
function tN(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const nN = /* @__PURE__ */ new Set(["menu", "submit", "reset", "button"]), Gc = {}.hasOwnProperty;
function Y4(e, t, n) {
  const r = n && sN(n);
  return (
    /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */
    /**
     * Hyperscript compatible DSL for creating virtual hast trees.
     *
     * @param {string | null} [selector]
     * @param {HProperties | HChild} [properties]
     * @param {Array<HChild>} children
     * @returns {HResult}
     */
    function(o, i, ...a) {
      let s = -1, l;
      if (o == null)
        l = { type: "root", children: [] }, a.unshift(i);
      else if (l = JP(o, t), l.tagName = l.tagName.toLowerCase(), r && Gc.call(r, l.tagName) && (l.tagName = r[l.tagName]), rN(i, l.tagName)) {
        let u;
        for (u in i)
          Gc.call(i, u) && oN(e, l.properties, u, i[u]);
      } else
        a.unshift(i);
      for (; ++s < a.length; )
        Kc(l.children, a[s]);
      return l.type === "element" && l.tagName === "template" && (l.content = { type: "root", children: l.children }, l.children = []), l;
    }
  );
}
function rN(e, t) {
  return e == null || typeof e != "object" || Array.isArray(e) ? !1 : t === "input" || !e.type || typeof e.type != "string" ? !0 : "children" in e && Array.isArray(e.children) ? !1 : t === "button" ? nN.has(e.type.toLowerCase()) : !("value" in e);
}
function oN(e, t, n, r) {
  const o = O0(e, n);
  let i = -1, a;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r)) return;
      a = r;
    } else typeof r == "boolean" ? a = r : typeof r == "string" ? o.spaceSeparated ? a = n5(r) : o.commaSeparated ? a = r5(r) : o.commaOrSpaceSeparated ? a = n5(r5(r).join(" ")) : a = o5(o, o.property, r) : Array.isArray(r) ? a = r.concat() : a = o.property === "style" ? iN(r) : String(r);
    if (Array.isArray(a)) {
      const s = [];
      for (; ++i < a.length; )
        s[i] = o5(o, o.property, a[i]);
      a = s;
    }
    o.property === "className" && Array.isArray(t.className) && (a = t.className.concat(a)), t[o.property] = a;
  }
}
function Kc(e, t) {
  let n = -1;
  if (t != null) if (typeof t == "string" || typeof t == "number")
    e.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (; ++n < t.length; )
      Kc(e, t[n]);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? Kc(e, t.children) : e.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function o5(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || ai(n) === ai(t)))
      return !0;
  }
  return n;
}
function iN(e) {
  const t = [];
  let n;
  for (n in e)
    Gc.call(e, n) && t.push([n, e[n]].join(": "));
  return t.join("; ");
}
function sN(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    t[e[n].toLowerCase()] = e[n];
  return t;
}
const Be = Y4(Ps, "div"), aN = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], lN = Y4(gi, "g", aN);
function uN(e) {
  const t = String(e), n = [], r = /\r?\n|\r/g;
  for (; r.test(t); )
    n.push(r.lastIndex);
  return n.push(t.length + 1), { toPoint: o, toOffset: i };
  function o(a) {
    let s = -1;
    if (typeof a == "number" && a > -1 && a < n[n.length - 1]) {
      for (; ++s < n.length; )
        if (n[s] > a)
          return {
            line: s + 1,
            column: a - (s > 0 ? n[s - 1] : 0) + 1,
            offset: a
          };
    }
    return { line: void 0, column: void 0, offset: void 0 };
  }
  function i(a) {
    const s = a && a.line, l = a && a.column;
    if (typeof s == "number" && typeof l == "number" && !Number.isNaN(s) && !Number.isNaN(l) && s - 1 in n) {
      const u = (n[s - 2] || 0) + l - 1 || 0;
      if (u > -1 && u < n[n.length - 1])
        return u;
    }
    return -1;
  }
}
const dN = {
  svg: "http://www.w3.org/2000/svg"
}, X4 = {}.hasOwnProperty, cN = Object.prototype;
function hN(e, t) {
  const n = t || {};
  let r, o;
  return pN(n) ? (o = n, r = {}) : (o = n.file || void 0, r = n), P0(
    {
      schema: r.space === "svg" ? gi : Ps,
      file: o,
      verbose: r.verbose,
      location: !1
    },
    e
  );
}
function P0(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const r = (
        /** @type {P5Comment} */
        t
      );
      return n = { type: "comment", value: r.data }, Zi(e, r, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const r = (
        /** @type {P5Document | P5DocumentFragment} */
        t
      ), o = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: Q4(e, t.childNodes),
        data: { quirksMode: o }
      }, e.file && e.location) {
        const i = String(e.file), a = uN(i), s = a.toPoint(0), l = a.toPoint(i.length);
        n.position = { start: s, end: l };
      }
      return n;
    }
    case "#documentType": {
      const r = (
        /** @type {P5DocumentType} */
        t
      );
      return n = { type: "doctype" }, Zi(e, r, n), n;
    }
    case "#text": {
      const r = (
        /** @type {P5Text} */
        t
      );
      return n = { type: "text", value: r.value }, Zi(e, r, n), n;
    }
    // Element.
    default:
      return n = mN(
        e,
        /** @type {P5Element} */
        t
      ), n;
  }
}
function Q4(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    r[n] = P0(e, t[n]);
  return r;
}
function mN(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === dN.svg ? gi : Ps;
  let r = -1;
  const o = {};
  for (; ++r < t.attrs.length; ) {
    const a = t.attrs[r], s = (a.prefix ? a.prefix + ":" : "") + a.name;
    X4.call(cN, s) || (o[s] = a.value);
  }
  const i = (e.schema.space === "svg" ? lN : Be)(t.tagName, o, Q4(e, t.childNodes));
  if (Zi(e, t, i), i.tagName === "template") {
    const a = (
      /** @type {P5Template} */
      t
    ), s = a.sourceCodeLocation, l = s && s.startTag && oo(s.startTag), u = s && s.endTag && oo(s.endTag), m = P0(e, a.content);
    l && u && e.file && (m.position = { start: l.end, end: u.start }), i.content = m;
  }
  return e.schema = n, i;
}
function Zi(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const r = fN(e, n, t.sourceCodeLocation);
    r && (e.location = !0, n.position = r);
  }
}
function fN(e, t, n) {
  const r = oo(n);
  if (t.type === "element") {
    const o = t.children[t.children.length - 1];
    if (r && !n.endTag && o && o.position && o.position.end && (r.end = Object.assign({}, o.position.end)), e.verbose) {
      const i = {};
      let a;
      if (n.attrs)
        for (a in n.attrs)
          X4.call(n.attrs, a) && (i[O0(e.schema, a).property] = oo(
            n.attrs[a]
          ));
      t.data = {
        position: {
          // @ts-expect-error: assume not `undefined`.
          opening: oo(n.startTag),
          closing: n.endTag ? oo(n.endTag) : null,
          properties: i
        }
      };
    }
  }
  return r;
}
function oo(e) {
  const t = i5({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = i5({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function i5(e) {
  return e.line && e.column ? e : void 0;
}
function pN(e) {
  return "messages" in e;
}
const gN = {
  abandonedHeadElementChild: {
    reason: "Unexpected metadata element after head",
    description: "Unexpected element after head. Expected the element before `</head>`",
    url: !1
  },
  abruptClosingOfEmptyComment: {
    reason: "Unexpected abruptly closed empty comment",
    description: "Unexpected `>` or `->`. Expected `-->` to close comments"
  },
  abruptDoctypePublicIdentifier: {
    reason: "Unexpected abruptly closed public identifier",
    description: "Unexpected `>`. Expected a closing `\"` or `'` after the public identifier"
  },
  abruptDoctypeSystemIdentifier: {
    reason: "Unexpected abruptly closed system identifier",
    description: "Unexpected `>`. Expected a closing `\"` or `'` after the identifier identifier"
  },
  absenceOfDigitsInNumericCharacterReference: {
    reason: "Unexpected non-digit at start of numeric character reference",
    description: "Unexpected `%c`. Expected `[0-9]` for decimal references or `[0-9a-fA-F]` for hexadecimal references"
  },
  cdataInHtmlContent: {
    reason: "Unexpected CDATA section in HTML",
    description: "Unexpected `<![CDATA[` in HTML. Remove it, use a comment, or encode special characters instead"
  },
  characterReferenceOutsideUnicodeRange: {
    reason: "Unexpected too big numeric character reference",
    description: "Unexpectedly high character reference. Expected character references to be at most hexadecimal 10ffff (or decimal 1114111)"
  },
  closingOfElementWithOpenChildElements: {
    reason: "Unexpected closing tag with open child elements",
    description: "Unexpectedly closing tag. Expected other tags to be closed first",
    url: !1
  },
  controlCharacterInInputStream: {
    reason: "Unexpected control character",
    description: "Unexpected control character `%x`. Expected a non-control code point, 0x00, or ASCII whitespace"
  },
  controlCharacterReference: {
    reason: "Unexpected control character reference",
    description: "Unexpectedly control character in reference. Expected a non-control code point, 0x00, or ASCII whitespace"
  },
  disallowedContentInNoscriptInHead: {
    reason: "Disallowed content inside `<noscript>` in `<head>`",
    description: "Unexpected text character `%c`. Only use text in `<noscript>`s in `<body>`",
    url: !1
  },
  duplicateAttribute: {
    reason: "Unexpected duplicate attribute",
    description: "Unexpectedly double attribute. Expected attributes to occur only once"
  },
  endTagWithAttributes: {
    reason: "Unexpected attribute on closing tag",
    description: "Unexpected attribute. Expected `>` instead"
  },
  endTagWithTrailingSolidus: {
    reason: "Unexpected slash at end of closing tag",
    description: "Unexpected `%c-1`. Expected `>` instead"
  },
  endTagWithoutMatchingOpenElement: {
    reason: "Unexpected unopened end tag",
    description: "Unexpected end tag. Expected no end tag or another end tag",
    url: !1
  },
  eofBeforeTagName: {
    reason: "Unexpected end of file",
    description: "Unexpected end of file. Expected tag name instead"
  },
  eofInCdata: {
    reason: "Unexpected end of file in CDATA",
    description: "Unexpected end of file. Expected `]]>` to close the CDATA"
  },
  eofInComment: {
    reason: "Unexpected end of file in comment",
    description: "Unexpected end of file. Expected `-->` to close the comment"
  },
  eofInDoctype: {
    reason: "Unexpected end of file in doctype",
    description: "Unexpected end of file. Expected a valid doctype (such as `<!doctype html>`)"
  },
  eofInElementThatCanContainOnlyText: {
    reason: "Unexpected end of file in element that can only contain text",
    description: "Unexpected end of file. Expected text or a closing tag",
    url: !1
  },
  eofInScriptHtmlCommentLikeText: {
    reason: "Unexpected end of file in comment inside script",
    description: "Unexpected end of file. Expected `-->` to close the comment"
  },
  eofInTag: {
    reason: "Unexpected end of file in tag",
    description: "Unexpected end of file. Expected `>` to close the tag"
  },
  incorrectlyClosedComment: {
    reason: "Incorrectly closed comment",
    description: "Unexpected `%c-1`. Expected `-->` to close the comment"
  },
  incorrectlyOpenedComment: {
    reason: "Incorrectly opened comment",
    description: "Unexpected `%c`. Expected `<!--` to open the comment"
  },
  invalidCharacterSequenceAfterDoctypeName: {
    reason: "Invalid sequence after doctype name",
    description: "Unexpected sequence at `%c`. Expected `public` or `system`"
  },
  invalidFirstCharacterOfTagName: {
    reason: "Invalid first character in tag name",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  misplacedDoctype: {
    reason: "Misplaced doctype",
    description: "Unexpected doctype. Expected doctype before head",
    url: !1
  },
  misplacedStartTagForHeadElement: {
    reason: "Misplaced `<head>` start tag",
    description: "Unexpected start tag `<head>`. Expected `<head>` directly after doctype",
    url: !1
  },
  missingAttributeValue: {
    reason: "Missing attribute value",
    description: "Unexpected `%c-1`. Expected an attribute value or no `%c-1` instead"
  },
  missingDoctype: {
    reason: "Missing doctype before other content",
    description: "Expected a `<!doctype html>` before anything else",
    url: !1
  },
  missingDoctypeName: {
    reason: "Missing doctype name",
    description: "Unexpected doctype end at `%c`. Expected `html` instead"
  },
  missingDoctypePublicIdentifier: {
    reason: "Missing public identifier in doctype",
    description: "Unexpected `%c`. Expected identifier for `public` instead"
  },
  missingDoctypeSystemIdentifier: {
    reason: "Missing system identifier in doctype",
    description: 'Unexpected `%c`. Expected identifier for `system` instead (suggested: `"about:legacy-compat"`)'
  },
  missingEndTagName: {
    reason: "Missing name in end tag",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  missingQuoteBeforeDoctypePublicIdentifier: {
    reason: "Missing quote before public identifier in doctype",
    description: "Unexpected `%c`. Expected `\"` or `'` instead"
  },
  missingQuoteBeforeDoctypeSystemIdentifier: {
    reason: "Missing quote before system identifier in doctype",
    description: "Unexpected `%c`. Expected `\"` or `'` instead"
  },
  missingSemicolonAfterCharacterReference: {
    reason: "Missing semicolon after character reference",
    description: "Unexpected `%c`. Expected `;` instead"
  },
  missingWhitespaceAfterDoctypePublicKeyword: {
    reason: "Missing whitespace after public identifier in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceAfterDoctypeSystemKeyword: {
    reason: "Missing whitespace after system identifier in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBeforeDoctypeName: {
    reason: "Missing whitespace before doctype name",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBetweenAttributes: {
    reason: "Missing whitespace between attributes",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: {
    reason: "Missing whitespace between public and system identifiers in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  nestedComment: {
    reason: "Unexpected nested comment",
    description: "Unexpected `<!--`. Expected `-->`"
  },
  nestedNoscriptInHead: {
    reason: "Unexpected nested `<noscript>` in `<head>`",
    description: "Unexpected `<noscript>`. Expected a closing tag or a meta element",
    url: !1
  },
  nonConformingDoctype: {
    reason: "Unexpected non-conforming doctype declaration",
    description: 'Expected `<!doctype html>` or `<!doctype html system "about:legacy-compat">`',
    url: !1
  },
  nonVoidHtmlElementStartTagWithTrailingSolidus: {
    reason: "Unexpected trailing slash on start tag of non-void element",
    description: "Unexpected `/`. Expected `>` instead"
  },
  noncharacterCharacterReference: {
    reason: "Unexpected noncharacter code point referenced by character reference",
    description: "Unexpected code point. Do not use noncharacters in HTML"
  },
  noncharacterInInputStream: {
    reason: "Unexpected noncharacter character",
    description: "Unexpected code point `%x`. Do not use noncharacters in HTML"
  },
  nullCharacterReference: {
    reason: "Unexpected NULL character referenced by character reference",
    description: "Unexpected code point. Do not use NULL characters in HTML"
  },
  openElementsLeftAfterEof: {
    reason: "Unexpected end of file",
    description: "Unexpected end of file. Expected closing tag instead",
    url: !1
  },
  surrogateCharacterReference: {
    reason: "Unexpected surrogate character referenced by character reference",
    description: "Unexpected code point. Do not use lone surrogate characters in HTML"
  },
  surrogateInInputStream: {
    reason: "Unexpected surrogate character",
    description: "Unexpected code point `%x`. Do not use lone surrogate characters in HTML"
  },
  unexpectedCharacterAfterDoctypeSystemIdentifier: {
    reason: "Invalid character after system identifier in doctype",
    description: "Unexpected character at `%c`. Expected `>`"
  },
  unexpectedCharacterInAttributeName: {
    reason: "Unexpected character in attribute name",
    description: "Unexpected `%c`. Expected whitespace, `/`, `>`, `=`, or probably an ASCII letter"
  },
  unexpectedCharacterInUnquotedAttributeValue: {
    reason: "Unexpected character in unquoted attribute value",
    description: "Unexpected `%c`. Quote the attribute value to include it"
  },
  unexpectedEqualsSignBeforeAttributeName: {
    reason: "Unexpected equals sign before attribute name",
    description: "Unexpected `%c`. Add an attribute name before it"
  },
  unexpectedNullCharacter: {
    reason: "Unexpected NULL character",
    description: "Unexpected code point `%x`. Do not use NULL characters in HTML"
  },
  unexpectedQuestionMarkInsteadOfTagName: {
    reason: "Unexpected question mark instead of tag name",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  unexpectedSolidusInTag: {
    reason: "Unexpected slash in tag",
    description: "Unexpected `%c-1`. Expected it followed by `>` or in a quoted attribute value"
  },
  unknownNamedCharacterReference: {
    reason: "Unexpected unknown named character reference",
    description: "Unexpected character reference. Expected known named character references"
  }
}, vN = "https://html.spec.whatwg.org/multipage/parsing.html#parse-error-", bN = { 2: !0, 1: !1, 0: null };
function J4(e) {
  const t = (
    /** @type {Options} */
    this.data("settings")
  ), n = Object.assign({}, t, e);
  Object.assign(this, { Parser: r });
  function r(o, i) {
    const a = n.fragment ? "parseFragment" : "parse", s = n.emitParseErrors ? u : null, l = new GP({
      sourceCodeLocationInfo: !0,
      onParseError: s,
      scriptingEnabled: !1
    });
    return hN(l[a](o), {
      space: n.space,
      file: i,
      verbose: n.verbose
    });
    function u(m) {
      const v = m.code, g = yN(v), h = n[g], E = h == null ? !0 : h, C = typeof E == "number" ? E : E ? 1 : 0, A = {
        line: m.startLine,
        column: m.startCol,
        offset: m.startOffset
      }, R = {
        line: m.endLine,
        column: m.endCol,
        offset: m.endOffset
      };
      if (C) {
        const F = gN[g] || { reason: "", description: "", url: "" }, L = i.message(O(F.reason), { start: A, end: R });
        L.source = "parse-error", L.ruleId = v, L.fatal = bN[C], L.note = O(F.description), L.url = "url" in F && F.url === !1 ? null : vN + v;
      }
      function O(F) {
        return F.replace(/%c(?:-(\d+))?/g, (L, D) => {
          const P = D ? -Number.parseInt(D, 10) : 0, U = o.charAt(m.startOffset + P);
          return U === "`" ? "` ` `" : U;
        }).replace(
          /%x/g,
          () => "0x" + o.charCodeAt(m.startOffset).toString(16).toUpperCase()
        );
      }
    }
  }
}
function yN(e) {
  return e.replace(/-[a-z]/g, (t) => t.charAt(1).toUpperCase());
}
const e3 = {
  strip: ["script"],
  clobberPrefix: "user-content-",
  clobber: ["name", "id"],
  ancestors: {
    tbody: ["table"],
    tfoot: ["table"],
    thead: ["table"],
    td: ["table"],
    th: ["table"],
    tr: ["table"]
  },
  protocols: {
    href: ["http", "https", "mailto", "xmpp", "irc", "ircs"],
    cite: ["http", "https"],
    src: ["http", "https"],
    longDesc: ["http", "https"]
  },
  tagNames: [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "br",
    "b",
    "i",
    "strong",
    "em",
    "a",
    "pre",
    "code",
    "img",
    "tt",
    "div",
    "ins",
    "del",
    "sup",
    "sub",
    "p",
    "ol",
    "ul",
    "table",
    "thead",
    "tbody",
    "tfoot",
    "blockquote",
    "dl",
    "dt",
    "dd",
    "kbd",
    "q",
    "samp",
    "var",
    "hr",
    "ruby",
    "rt",
    "rp",
    "li",
    "tr",
    "td",
    "th",
    "s",
    "strike",
    "summary",
    "details",
    "caption",
    "figure",
    "figcaption",
    "abbr",
    "bdo",
    "cite",
    "dfn",
    "mark",
    "small",
    "span",
    "time",
    "wbr",
    "input"
  ],
  attributes: {
    a: ["href"],
    img: ["src", "longDesc"],
    input: [
      ["type", "checkbox"],
      ["disabled", !0]
    ],
    li: [["className", "task-list-item"]],
    div: ["itemScope", "itemType"],
    blockquote: ["cite"],
    del: ["cite"],
    ins: ["cite"],
    q: ["cite"],
    "*": [
      "abbr",
      "accept",
      "acceptCharset",
      "accessKey",
      "action",
      "align",
      "alt",
      "ariaDescribedBy",
      "ariaHidden",
      "ariaLabel",
      "ariaLabelledBy",
      "axis",
      "border",
      "cellPadding",
      "cellSpacing",
      "char",
      "charOff",
      "charSet",
      "checked",
      "clear",
      "cols",
      "colSpan",
      "color",
      "compact",
      "coords",
      "dateTime",
      "dir",
      "disabled",
      "encType",
      "htmlFor",
      "frame",
      "headers",
      "height",
      "hrefLang",
      "hSpace",
      "isMap",
      "id",
      "label",
      "lang",
      "maxLength",
      "media",
      "method",
      "multiple",
      "name",
      "noHref",
      "noShade",
      "noWrap",
      "open",
      "prompt",
      "readOnly",
      "rel",
      "rev",
      "rows",
      "rowSpan",
      "rules",
      "scope",
      "selected",
      "shape",
      "size",
      "span",
      "start",
      "summary",
      "tabIndex",
      "target",
      "title",
      "type",
      "useMap",
      "vAlign",
      "value",
      "vSpace",
      "width",
      "itemProp"
    ]
  },
  required: {
    input: {
      type: "checkbox",
      disabled: !0
    }
  }
}, kn = {}.hasOwnProperty, Jl = {
  root: { children: s5 },
  doctype: CN,
  comment: wN,
  element: {
    tagName: n3,
    properties: TN,
    children: s5
  },
  text: { value: SN },
  "*": { data: a5, position: a5 }
};
function _N(e, t) {
  let n = { type: "root", children: [] };
  if (e && typeof e == "object" && e.type) {
    const r = t3(
      Object.assign({}, e3, t || {}),
      e,
      []
    );
    r && (Array.isArray(r) ? r.length === 1 ? n = r[0] : n.children = r : n = r);
  }
  return n;
}
function t3(e, t, n) {
  const r = t && t.type, o = { type: t.type };
  let i;
  if (kn.call(Jl, r)) {
    let a = Jl[r];
    if (typeof a == "function" && (a = a(e, t)), a) {
      const s = Object.assign({}, a, Jl["*"]);
      let l;
      i = !0;
      for (l in s)
        if (kn.call(s, l)) {
          const u = s[l](e, t[l], t, n);
          u === !1 ? (i = void 0, o[l] = t[l]) : u != null && (o[l] = u);
        }
    }
  }
  return i ? o : o.type === "element" && e.strip && !e.strip.includes(o.tagName) ? o.children : void 0;
}
function s5(e, t, n, r) {
  const o = [];
  if (Array.isArray(t)) {
    let i = -1;
    for (n.type === "element" && r.push(n.tagName); ++i < t.length; ) {
      const a = t3(e, t[i], r);
      a && (Array.isArray(a) ? o.push(...a) : o.push(a));
    }
    n.type === "element" && r.pop();
  }
  return o;
}
function CN(e) {
  return e.allowDoctypes ? { name: kN } : void 0;
}
function wN(e) {
  return e.allowComments ? { value: EN } : void 0;
}
function TN(e, t, n, r) {
  const o = n3(e, n.tagName, n, r), i = e.attributes || {}, a = e.required || {}, s = t || {}, l = Object.assign(
    {},
    l5(i["*"]),
    l5(o && kn.call(i, o) ? i[o] : [])
  ), u = {};
  let m;
  for (m in s)
    if (kn.call(s, m)) {
      let v = s[m], g;
      if (kn.call(l, m))
        g = l[m];
      else if (IN(m) && kn.call(l, "data*"))
        g = l["data*"];
      else
        continue;
      v = Array.isArray(v) ? MN(e, v, m, g) : r3(e, v, m, g), v != null && (u[m] = v);
    }
  if (o && kn.call(a, o))
    for (m in a[o])
      kn.call(u, m) || (u[m] = a[o][m]);
  return u;
}
function kN() {
  return "html";
}
function n3(e, t, n, r) {
  const o = typeof t == "string" ? t : "";
  let i = -1;
  if (!o || o === "*" || e.tagNames && !e.tagNames.includes(o))
    return !1;
  if (e.ancestors && kn.call(e.ancestors, o)) {
    for (; ++i < e.ancestors[o].length; )
      if (r.includes(e.ancestors[o][i]))
        return o;
    return !1;
  }
  return o;
}
function EN(e, t) {
  const n = typeof t == "string" ? t : "", r = n.indexOf("-->");
  return r < 0 ? n : n.slice(0, r);
}
function SN(e, t) {
  return typeof t == "string" ? t : "";
}
function a5(e, t) {
  return t;
}
function MN(e, t, n, r) {
  let o = -1;
  const i = [];
  for (; ++o < t.length; ) {
    const a = r3(e, t[o], n, r);
    a != null && i.push(a);
  }
  return i;
}
function r3(e, t, n, r) {
  if ((typeof t == "boolean" || typeof t == "number" || typeof t == "string") && AN(e, t, n) && (r.length === 0 || r.some(
    (o) => o && typeof o == "object" && "flags" in o ? o.test(String(t)) : o === t
  )))
    return e.clobberPrefix && e.clobber && e.clobber.includes(n) ? e.clobberPrefix + t : t;
}
function AN(e, t, n) {
  const r = String(t), o = r.indexOf(":"), i = r.indexOf("?"), a = r.indexOf("#"), s = r.indexOf("/"), l = e.protocols && kn.call(e.protocols, n) ? e.protocols[n].concat() : [];
  let u = -1;
  if (l.length === 0 || o < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
  s > -1 && o > s || i > -1 && o > i || a > -1 && o > a)
    return !0;
  for (; ++u < l.length; )
    if (o === l[u].length && r.slice(0, l[u].length) === l[u])
      return !0;
  return !1;
}
function l5(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; ) {
    const r = e[n];
    Array.isArray(r) ? t[r[0]] = r.slice(1) : t[r] = [];
  }
  return t;
}
function IN(e) {
  return e.length > 4 && e.slice(0, 4).toLowerCase() === "data";
}
function o3(e = e3) {
  return (t) => _N(t, e);
}
const LN = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "menuitem",
  "meta",
  "nextid",
  "param",
  "source",
  "track",
  "wbr"
], u5 = {}.hasOwnProperty;
function DN(e, t) {
  const n = t || {};
  function r(o, ...i) {
    let a = r.invalid;
    const s = r.handlers;
    if (o && u5.call(o, e)) {
      const l = String(o[e]);
      a = u5.call(s, l) ? s[l] : r.unknown;
    }
    if (a)
      return a.call(this, o, ...i);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const $N = /["&'<>`]/g, ON = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, PN = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), NN = /[|\\{}()[\]^$+*?.]/g, d5 = /* @__PURE__ */ new WeakMap();
function HN(e, t) {
  if (e = e.replace(
    t.subset ? FN(t.subset) : $N,
    r
  ), t.subset || t.escapeOnly)
    return e;
  return e.replace(ON, n).replace(PN, r);
  function n(o, i, a) {
    return t.format(
      (o.charCodeAt(0) - 55296) * 1024 + o.charCodeAt(1) - 56320 + 65536,
      a.charCodeAt(i + 2),
      t
    );
  }
  function r(o, i, a) {
    return t.format(
      o.charCodeAt(0),
      a.charCodeAt(i + 1),
      t
    );
  }
}
function FN(e) {
  let t = d5.get(e);
  return t || (t = RN(e), d5.set(e, t)), t;
}
function RN(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t.push(e[n].replace(NN, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
const VN = /[\dA-Fa-f]/;
function BN(e, t, n) {
  const r = "&#x" + e.toString(16).toUpperCase();
  return n && t && !VN.test(String.fromCharCode(t)) ? r : r + ";";
}
const jN = /\d/;
function UN(e, t, n) {
  const r = "&#" + String(e);
  return n && t && !jN.test(String.fromCharCode(t)) ? r : r + ";";
}
const qN = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], e1 = {
  nbsp: " ",
  iexcl: "¡",
  cent: "¢",
  pound: "£",
  curren: "¤",
  yen: "¥",
  brvbar: "¦",
  sect: "§",
  uml: "¨",
  copy: "©",
  ordf: "ª",
  laquo: "«",
  not: "¬",
  shy: "­",
  reg: "®",
  macr: "¯",
  deg: "°",
  plusmn: "±",
  sup2: "²",
  sup3: "³",
  acute: "´",
  micro: "µ",
  para: "¶",
  middot: "·",
  cedil: "¸",
  sup1: "¹",
  ordm: "º",
  raquo: "»",
  frac14: "¼",
  frac12: "½",
  frac34: "¾",
  iquest: "¿",
  Agrave: "À",
  Aacute: "Á",
  Acirc: "Â",
  Atilde: "Ã",
  Auml: "Ä",
  Aring: "Å",
  AElig: "Æ",
  Ccedil: "Ç",
  Egrave: "È",
  Eacute: "É",
  Ecirc: "Ê",
  Euml: "Ë",
  Igrave: "Ì",
  Iacute: "Í",
  Icirc: "Î",
  Iuml: "Ï",
  ETH: "Ð",
  Ntilde: "Ñ",
  Ograve: "Ò",
  Oacute: "Ó",
  Ocirc: "Ô",
  Otilde: "Õ",
  Ouml: "Ö",
  times: "×",
  Oslash: "Ø",
  Ugrave: "Ù",
  Uacute: "Ú",
  Ucirc: "Û",
  Uuml: "Ü",
  Yacute: "Ý",
  THORN: "Þ",
  szlig: "ß",
  agrave: "à",
  aacute: "á",
  acirc: "â",
  atilde: "ã",
  auml: "ä",
  aring: "å",
  aelig: "æ",
  ccedil: "ç",
  egrave: "è",
  eacute: "é",
  ecirc: "ê",
  euml: "ë",
  igrave: "ì",
  iacute: "í",
  icirc: "î",
  iuml: "ï",
  eth: "ð",
  ntilde: "ñ",
  ograve: "ò",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  ouml: "ö",
  divide: "÷",
  oslash: "ø",
  ugrave: "ù",
  uacute: "ú",
  ucirc: "û",
  uuml: "ü",
  yacute: "ý",
  thorn: "þ",
  yuml: "ÿ",
  fnof: "ƒ",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Epsilon: "Ε",
  Zeta: "Ζ",
  Eta: "Η",
  Theta: "Θ",
  Iota: "Ι",
  Kappa: "Κ",
  Lambda: "Λ",
  Mu: "Μ",
  Nu: "Ν",
  Xi: "Ξ",
  Omicron: "Ο",
  Pi: "Π",
  Rho: "Ρ",
  Sigma: "Σ",
  Tau: "Τ",
  Upsilon: "Υ",
  Phi: "Φ",
  Chi: "Χ",
  Psi: "Ψ",
  Omega: "Ω",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigmaf: "ς",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "φ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  thetasym: "ϑ",
  upsih: "ϒ",
  piv: "ϖ",
  bull: "•",
  hellip: "…",
  prime: "′",
  Prime: "″",
  oline: "‾",
  frasl: "⁄",
  weierp: "℘",
  image: "ℑ",
  real: "ℜ",
  trade: "™",
  alefsym: "ℵ",
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔",
  crarr: "↵",
  lArr: "⇐",
  uArr: "⇑",
  rArr: "⇒",
  dArr: "⇓",
  hArr: "⇔",
  forall: "∀",
  part: "∂",
  exist: "∃",
  empty: "∅",
  nabla: "∇",
  isin: "∈",
  notin: "∉",
  ni: "∋",
  prod: "∏",
  sum: "∑",
  minus: "−",
  lowast: "∗",
  radic: "√",
  prop: "∝",
  infin: "∞",
  ang: "∠",
  and: "∧",
  or: "∨",
  cap: "∩",
  cup: "∪",
  int: "∫",
  there4: "∴",
  sim: "∼",
  cong: "≅",
  asymp: "≈",
  ne: "≠",
  equiv: "≡",
  le: "≤",
  ge: "≥",
  sub: "⊂",
  sup: "⊃",
  nsub: "⊄",
  sube: "⊆",
  supe: "⊇",
  oplus: "⊕",
  otimes: "⊗",
  perp: "⊥",
  sdot: "⋅",
  lceil: "⌈",
  rceil: "⌉",
  lfloor: "⌊",
  rfloor: "⌋",
  lang: "〈",
  rang: "〉",
  loz: "◊",
  spades: "♠",
  clubs: "♣",
  hearts: "♥",
  diams: "♦",
  quot: '"',
  amp: "&",
  lt: "<",
  gt: ">",
  OElig: "Œ",
  oelig: "œ",
  Scaron: "Š",
  scaron: "š",
  Yuml: "Ÿ",
  circ: "ˆ",
  tilde: "˜",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  zwnj: "‌",
  zwj: "‍",
  lrm: "‎",
  rlm: "‏",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  dagger: "†",
  Dagger: "‡",
  permil: "‰",
  lsaquo: "‹",
  rsaquo: "›",
  euro: "€"
}, GN = [
  "cent",
  "copy",
  "divide",
  "gt",
  "lt",
  "not",
  "para",
  "times"
], i3 = {}.hasOwnProperty, zc = {};
let Bi;
for (Bi in e1)
  i3.call(e1, Bi) && (zc[e1[Bi]] = Bi);
const KN = /[^\dA-Za-z]/;
function zN(e, t, n, r) {
  const o = String.fromCharCode(e);
  if (i3.call(zc, o)) {
    const i = zc[o], a = "&" + i;
    return n && qN.includes(i) && !GN.includes(i) && (!r || t && t !== 61 && KN.test(String.fromCharCode(t))) ? a : a + ";";
  }
  return "";
}
function ZN(e, t, n) {
  let r = BN(e, t, n.omitOptionalSemicolons), o;
  if ((n.useNamedReferences || n.useShortestReferences) && (o = zN(
    e,
    t,
    n.omitOptionalSemicolons,
    n.attribute
  )), (n.useShortestReferences || !o) && n.useShortestReferences) {
    const i = UN(e, t, n.omitOptionalSemicolons);
    i.length < r.length && (r = i);
  }
  return o && (!n.useShortestReferences || o.length < r.length) ? o : r;
}
function uo(e, t) {
  return HN(e, Object.assign({ format: ZN }, t));
}
function xN(e, t, n, r) {
  return r.settings.bogusComments ? "<?" + uo(
    e.value,
    Object.assign({}, r.settings.characterReferences, { subset: [">"] })
  ) + ">" : "<!--" + e.value.replace(/^>|^->|<!--|-->|--!>|<!-$/g, o) + "-->";
  function o(i) {
    return uo(
      i,
      Object.assign({}, r.settings.characterReferences, {
        subset: ["<", ">"]
      })
    );
  }
}
function WN(e, t, n, r) {
  return "<!" + (r.settings.upperDoctype ? "DOCTYPE" : "doctype") + (r.settings.tightDoctype ? "" : " ") + "html>";
}
function c5(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, o = n.indexOf(t);
  for (; o !== -1; )
    r++, o = n.indexOf(t, o + t.length);
  return r;
}
function N0(e) {
  const t = (
    // @ts-expect-error looks like a node.
    e && typeof e == "object" && e.type === "text" ? (
      // @ts-expect-error looks like a text.
      e.value || ""
    ) : e
  );
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
const it = a3(1), s3 = a3(-1);
function a3(e) {
  return t;
  function t(n, r, o) {
    const i = n ? n.children : [];
    let a = (r || 0) + e, s = i && i[a];
    if (!o)
      for (; s && N0(s); )
        a += e, s = i[a];
    return s;
  }
}
const YN = {}.hasOwnProperty;
function l3(e) {
  return t;
  function t(n, r, o) {
    return YN.call(e, n.tagName) && e[n.tagName](n, r, o);
  }
}
const H0 = l3({
  html: XN,
  head: t1,
  body: QN,
  p: JN,
  li: eH,
  dt: tH,
  dd: nH,
  rt: h5,
  rp: h5,
  optgroup: rH,
  option: oH,
  menuitem: iH,
  colgroup: t1,
  caption: t1,
  thead: sH,
  tbody: aH,
  tfoot: lH,
  tr: uH,
  td: m5,
  th: m5
});
function t1(e, t, n) {
  const r = it(n, t, !0);
  return !r || r.type !== "comment" && !(r.type === "text" && N0(r.value.charAt(0)));
}
function XN(e, t, n) {
  const r = it(n, t);
  return !r || r.type !== "comment";
}
function QN(e, t, n) {
  const r = it(n, t);
  return !r || r.type !== "comment";
}
function JN(e, t, n) {
  const r = it(n, t);
  return r ? r.type === "element" && (r.tagName === "address" || r.tagName === "article" || r.tagName === "aside" || r.tagName === "blockquote" || r.tagName === "details" || r.tagName === "div" || r.tagName === "dl" || r.tagName === "fieldset" || r.tagName === "figcaption" || r.tagName === "figure" || r.tagName === "footer" || r.tagName === "form" || r.tagName === "h1" || r.tagName === "h2" || r.tagName === "h3" || r.tagName === "h4" || r.tagName === "h5" || r.tagName === "h6" || r.tagName === "header" || r.tagName === "hgroup" || r.tagName === "hr" || r.tagName === "main" || r.tagName === "menu" || r.tagName === "nav" || r.tagName === "ol" || r.tagName === "p" || r.tagName === "pre" || r.tagName === "section" || r.tagName === "table" || r.tagName === "ul") : !n || // Confusing parent.
  !(n.type === "element" && (n.tagName === "a" || n.tagName === "audio" || n.tagName === "del" || n.tagName === "ins" || n.tagName === "map" || n.tagName === "noscript" || n.tagName === "video"));
}
function eH(e, t, n) {
  const r = it(n, t);
  return !r || r.type === "element" && r.tagName === "li";
}
function tH(e, t, n) {
  const r = it(n, t);
  return r && r.type === "element" && (r.tagName === "dt" || r.tagName === "dd");
}
function nH(e, t, n) {
  const r = it(n, t);
  return !r || r.type === "element" && (r.tagName === "dt" || r.tagName === "dd");
}
function h5(e, t, n) {
  const r = it(n, t);
  return !r || r.type === "element" && (r.tagName === "rp" || r.tagName === "rt");
}
function rH(e, t, n) {
  const r = it(n, t);
  return !r || r.type === "element" && r.tagName === "optgroup";
}
function oH(e, t, n) {
  const r = it(n, t);
  return !r || r.type === "element" && (r.tagName === "option" || r.tagName === "optgroup");
}
function iH(e, t, n) {
  const r = it(n, t);
  return !r || r.type === "element" && (r.tagName === "menuitem" || r.tagName === "hr" || r.tagName === "menu");
}
function sH(e, t, n) {
  const r = it(n, t);
  return r && r.type === "element" && (r.tagName === "tbody" || r.tagName === "tfoot");
}
function aH(e, t, n) {
  const r = it(n, t);
  return !r || r.type === "element" && (r.tagName === "tbody" || r.tagName === "tfoot");
}
function lH(e, t, n) {
  return !it(n, t);
}
function uH(e, t, n) {
  const r = it(n, t);
  return !r || r.type === "element" && r.tagName === "tr";
}
function m5(e, t, n) {
  const r = it(n, t);
  return !r || r.type === "element" && (r.tagName === "td" || r.tagName === "th");
}
const dH = l3({
  html: cH,
  head: hH,
  body: mH,
  colgroup: fH,
  tbody: pH
});
function cH(e) {
  const t = it(e, -1);
  return !t || t.type !== "comment";
}
function hH(e) {
  const t = e.children, n = [];
  let r = -1;
  for (; ++r < t.length; ) {
    const o = t[r];
    if (o.type === "element" && (o.tagName === "title" || o.tagName === "base")) {
      if (n.includes(o.tagName)) return !1;
      n.push(o.tagName);
    }
  }
  return t.length > 0;
}
function mH(e) {
  const t = it(e, -1, !0);
  return !t || t.type !== "comment" && !(t.type === "text" && N0(t.value.charAt(0))) && !(t.type === "element" && (t.tagName === "meta" || t.tagName === "link" || t.tagName === "script" || t.tagName === "style" || t.tagName === "template"));
}
function fH(e, t, n) {
  const r = s3(n, t), o = it(e, -1, !0);
  return n && r && r.type === "element" && r.tagName === "colgroup" && H0(r, n.children.indexOf(r), n) ? !1 : o && o.type === "element" && o.tagName === "col";
}
function pH(e, t, n) {
  const r = s3(n, t), o = it(e, -1);
  return n && r && r.type === "element" && (r.tagName === "thead" || r.tagName === "tbody") && H0(r, n.children.indexOf(r), n) ? !1 : o && o.type === "element" && o.tagName === "tr";
}
const ji = {
  // See: <https://html.spec.whatwg.org/#attribute-name-state>.
  name: [
    [`	
\f\r &/=>`.split(""), `	
\f\r "&'/=>\``.split("")],
    [`\0	
\f\r "&'/<=>`.split(""), `\0	
\f\r "&'/<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
  unquoted: [
    [`	
\f\r &>`.split(""), `\0	
\f\r "&'<=>\``.split("")],
    [`\0	
\f\r "&'<=>\``.split(""), `\0	
\f\r "&'<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
  single: [
    ["&'".split(""), "\"&'`".split("")],
    ["\0&'".split(""), "\0\"&'`".split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
  double: [
    ['"&'.split(""), "\"&'`".split("")],
    ['\0"&'.split(""), "\0\"&'`".split("")]
  ]
};
function gH(e, t, n, r) {
  const o = r.schema, i = o.space === "svg" ? !1 : r.settings.omitOptionalTags;
  let a = o.space === "svg" ? r.settings.closeEmptyElements : r.settings.voids.includes(e.tagName.toLowerCase());
  const s = [];
  let l;
  o.space === "html" && e.tagName === "svg" && (r.schema = gi);
  const u = vH(r, e.properties), m = r.all(
    o.space === "html" && e.tagName === "template" ? e.content : e
  );
  return r.schema = o, m && (a = !1), (u || !i || !dH(e, t, n)) && (s.push("<", e.tagName, u ? " " + u : ""), a && (o.space === "svg" || r.settings.closeSelfClosing) && (l = u.charAt(u.length - 1), (!r.settings.tightSelfClosing || l === "/" || l && l !== '"' && l !== "'") && s.push(" "), s.push("/")), s.push(">")), s.push(m), !a && (!i || !H0(e, t, n)) && s.push("</" + e.tagName + ">"), s.join("");
}
function vH(e, t) {
  const n = [];
  let r = -1, o;
  if (t) {
    for (o in t)
      if (t[o] !== void 0 && t[o] !== null) {
        const i = bH(e, o, t[o]);
        i && n.push(i);
      }
  }
  for (; ++r < n.length; ) {
    const i = e.settings.tightAttributes ? n[r].charAt(n[r].length - 1) : null;
    r !== n.length - 1 && i !== '"' && i !== "'" && (n[r] += " ");
  }
  return n.join("");
}
function bH(e, t, n) {
  const r = O0(e.schema, t), o = e.settings.allowParseErrors && e.schema.space === "html" ? 0 : 1, i = e.settings.allowDangerousCharacters ? 0 : 1;
  let a = e.quote, s;
  if (r.overloadedBoolean && (n === r.attribute || n === "") ? n = !0 : (r.boolean || r.overloadedBoolean && typeof n != "string") && (n = !!n), n == null || n === !1 || typeof n == "number" && Number.isNaN(n))
    return "";
  const l = uo(
    r.attribute,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: ji.name[o][i]
    })
  );
  return n === !0 || (n = Array.isArray(n) ? (r.commaSeparated ? tN : eN)(n, {
    padLeft: !e.settings.tightCommaSeparatedLists
  }) : String(n), e.settings.collapseEmptyAttributes && !n) ? l : (e.settings.preferUnquoted && (s = uo(
    n,
    Object.assign({}, e.settings.characterReferences, {
      subset: ji.unquoted[o][i],
      attribute: !0
    })
  )), s !== n && (e.settings.quoteSmart && c5(n, a) > c5(n, e.alternative) && (a = e.alternative), s = a + uo(
    n,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: (a === "'" ? ji.single : ji.double)[o][i],
      attribute: !0
    })
  ) + a), l + (s && "=" + s));
}
function u3(e, t, n, r) {
  return n && n.type === "element" && (n.tagName === "script" || n.tagName === "style") ? e.value : uo(
    e.value,
    Object.assign({}, r.settings.characterReferences, {
      subset: ["<", "&"]
    })
  );
}
function yH(e, t, n, r) {
  return r.settings.allowDangerousHtml ? e.value : u3(e, t, n, r);
}
function _H(e, t, n, r) {
  return r.all(e);
}
const CH = DN("type", {
  invalid: wH,
  unknown: TH,
  handlers: { comment: xN, doctype: WN, element: gH, raw: yH, root: _H, text: u3 }
});
function wH(e) {
  throw new Error("Expected node, not `" + e + "`");
}
function TH(e) {
  throw new Error("Cannot compile unknown node `" + e.type + "`");
}
function kH(e, t) {
  const n = t || {}, r = n.quote || '"', o = r === '"' ? "'" : '"';
  if (r !== '"' && r !== "'")
    throw new Error("Invalid quote `" + r + "`, expected `'` or `\"`");
  return {
    one: EH,
    all: SH,
    settings: {
      omitOptionalTags: n.omitOptionalTags || !1,
      allowParseErrors: n.allowParseErrors || !1,
      allowDangerousCharacters: n.allowDangerousCharacters || !1,
      quoteSmart: n.quoteSmart || !1,
      preferUnquoted: n.preferUnquoted || !1,
      tightAttributes: n.tightAttributes || !1,
      upperDoctype: n.upperDoctype || !1,
      tightDoctype: n.tightDoctype || !1,
      bogusComments: n.bogusComments || !1,
      tightCommaSeparatedLists: n.tightCommaSeparatedLists || !1,
      tightSelfClosing: n.tightSelfClosing || !1,
      collapseEmptyAttributes: n.collapseEmptyAttributes || !1,
      allowDangerousHtml: n.allowDangerousHtml || !1,
      voids: n.voids || LN,
      characterReferences: n.characterReferences || n.entities || {},
      closeSelfClosing: n.closeSelfClosing || !1,
      closeEmptyElements: n.closeEmptyElements || !1
    },
    schema: n.space === "svg" ? gi : Ps,
    quote: r,
    alternative: o
  }.one(
    Array.isArray(e) ? { type: "root", children: e } : e,
    void 0,
    void 0
  );
}
function EH(e, t, n) {
  return CH(e, t, n, this);
}
function SH(e) {
  const t = [], n = e && e.children || [];
  let r = -1;
  for (; ++r < n.length; )
    t[r] = this.one(n[r], r, e);
  return t.join("");
}
function MH(e) {
  const t = (
    /** @type {Options} */
    this.data("settings")
  ), n = Object.assign({}, t, e);
  Object.assign(this, { Compiler: r });
  function r(o) {
    return kH(o, n);
  }
}
var n1, f5;
function Ns() {
  if (f5) return n1;
  f5 = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || e;
    return n === o;
  }
  return n1 = t, n1;
}
var r1, p5;
function d3() {
  if (p5) return r1;
  p5 = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return r1 = e, r1;
}
var o1, g5;
function AH() {
  if (g5) return o1;
  g5 = 1;
  var e = d3(), t = e(Object.keys, Object);
  return o1 = t, o1;
}
var i1, v5;
function c3() {
  if (v5) return i1;
  v5 = 1;
  var e = Ns(), t = AH(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    if (!e(i))
      return t(i);
    var a = [];
    for (var s in Object(i))
      r.call(i, s) && s != "constructor" && a.push(s);
    return a;
  }
  return i1 = o, i1;
}
var s1, b5;
function h3() {
  if (b5) return s1;
  b5 = 1;
  var e = typeof Vi == "object" && Vi && Vi.Object === Object && Vi;
  return s1 = e, s1;
}
var a1, y5;
function In() {
  if (y5) return a1;
  y5 = 1;
  var e = h3(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return a1 = n, a1;
}
var l1, _5;
function Hs() {
  if (_5) return l1;
  _5 = 1;
  var e = In(), t = e.Symbol;
  return l1 = t, l1;
}
var u1, C5;
function IH() {
  if (C5) return u1;
  C5 = 1;
  var e = Hs(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, o = e ? e.toStringTag : void 0;
  function i(a) {
    var s = n.call(a, o), l = a[o];
    try {
      a[o] = void 0;
      var u = !0;
    } catch (v) {
    }
    var m = r.call(a);
    return u && (s ? a[o] = l : delete a[o]), m;
  }
  return u1 = i, u1;
}
var d1, w5;
function LH() {
  if (w5) return d1;
  w5 = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return d1 = n, d1;
}
var c1, T5;
function vi() {
  if (T5) return c1;
  T5 = 1;
  var e = Hs(), t = IH(), n = LH(), r = "[object Null]", o = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? o : r : i && i in Object(s) ? t(s) : n(s);
  }
  return c1 = a, c1;
}
var h1, k5;
function bi() {
  if (k5) return h1;
  k5 = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return h1 = e, h1;
}
var m1, E5;
function m3() {
  if (E5) return m1;
  E5 = 1;
  var e = vi(), t = bi(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", i = "[object Proxy]";
  function a(s) {
    if (!t(s))
      return !1;
    var l = e(s);
    return l == r || l == o || l == n || l == i;
  }
  return m1 = a, m1;
}
var f1, S5;
function DH() {
  if (S5) return f1;
  S5 = 1;
  var e = In(), t = e["__core-js_shared__"];
  return f1 = t, f1;
}
var p1, M5;
function $H() {
  if (M5) return p1;
  M5 = 1;
  var e = DH(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return p1 = n, p1;
}
var g1, A5;
function f3() {
  if (A5) return g1;
  A5 = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch (o) {
      }
      try {
        return r + "";
      } catch (o) {
      }
    }
    return "";
  }
  return g1 = n, g1;
}
var v1, I5;
function OH() {
  if (I5) return v1;
  I5 = 1;
  var e = m3(), t = $H(), n = bi(), r = f3(), o = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, l = a.toString, u = s.hasOwnProperty, m = RegExp(
    "^" + l.call(u).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function v(g) {
    if (!n(g) || t(g))
      return !1;
    var h = e(g) ? m : i;
    return h.test(r(g));
  }
  return v1 = v, v1;
}
var b1, L5;
function PH() {
  if (L5) return b1;
  L5 = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return b1 = e, b1;
}
var y1, D5;
function zr() {
  if (D5) return y1;
  D5 = 1;
  var e = OH(), t = PH();
  function n(r, o) {
    var i = t(r, o);
    return e(i) ? i : void 0;
  }
  return y1 = n, y1;
}
var _1, $5;
function NH() {
  if ($5) return _1;
  $5 = 1;
  var e = zr(), t = In(), n = e(t, "DataView");
  return _1 = n, _1;
}
var C1, O5;
function F0() {
  if (O5) return C1;
  O5 = 1;
  var e = zr(), t = In(), n = e(t, "Map");
  return C1 = n, C1;
}
var w1, P5;
function HH() {
  if (P5) return w1;
  P5 = 1;
  var e = zr(), t = In(), n = e(t, "Promise");
  return w1 = n, w1;
}
var T1, N5;
function FH() {
  if (N5) return T1;
  N5 = 1;
  var e = zr(), t = In(), n = e(t, "Set");
  return T1 = n, T1;
}
var k1, H5;
function RH() {
  if (H5) return k1;
  H5 = 1;
  var e = zr(), t = In(), n = e(t, "WeakMap");
  return k1 = n, k1;
}
var E1, F5;
function Fs() {
  if (F5) return E1;
  F5 = 1;
  var e = NH(), t = F0(), n = HH(), r = FH(), o = RH(), i = vi(), a = f3(), s = "[object Map]", l = "[object Object]", u = "[object Promise]", m = "[object Set]", v = "[object WeakMap]", g = "[object DataView]", h = a(e), E = a(t), C = a(n), A = a(r), R = a(o), O = i;
  return (e && O(new e(new ArrayBuffer(1))) != g || t && O(new t()) != s || n && O(n.resolve()) != u || r && O(new r()) != m || o && O(new o()) != v) && (O = function(F) {
    var L = i(F), D = L == l ? F.constructor : void 0, P = D ? a(D) : "";
    if (P)
      switch (P) {
        case h:
          return g;
        case E:
          return s;
        case C:
          return u;
        case A:
          return m;
        case R:
          return v;
      }
    return L;
  }), E1 = O, E1;
}
var S1, R5;
function Mo() {
  if (R5) return S1;
  R5 = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return S1 = e, S1;
}
var M1, V5;
function VH() {
  if (V5) return M1;
  V5 = 1;
  var e = vi(), t = Mo(), n = "[object Arguments]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return M1 = r, M1;
}
var A1, B5;
function p3() {
  if (B5) return A1;
  B5 = 1;
  var e = VH(), t = Mo(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !o.call(a, "callee");
  };
  return A1 = i, A1;
}
var I1, j5;
function Zr() {
  if (j5) return I1;
  j5 = 1;
  var e = Array.isArray;
  return I1 = e, I1;
}
var L1, U5;
function g3() {
  if (U5) return L1;
  U5 = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return L1 = t, L1;
}
var D1, q5;
function R0() {
  if (q5) return D1;
  q5 = 1;
  var e = m3(), t = g3();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return D1 = n, D1;
}
var xi = { exports: {} }, $1, G5;
function BH() {
  if (G5) return $1;
  G5 = 1;
  function e() {
    return !1;
  }
  return $1 = e, $1;
}
xi.exports;
var K5;
function V0() {
  return K5 || (K5 = 1, function(e, t) {
    var n = In(), r = BH(), o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || r;
    e.exports = u;
  }(xi, xi.exports)), xi.exports;
}
var O1, z5;
function jH() {
  if (z5) return O1;
  z5 = 1;
  var e = vi(), t = g3(), n = Mo(), r = "[object Arguments]", o = "[object Array]", i = "[object Boolean]", a = "[object Date]", s = "[object Error]", l = "[object Function]", u = "[object Map]", m = "[object Number]", v = "[object Object]", g = "[object RegExp]", h = "[object Set]", E = "[object String]", C = "[object WeakMap]", A = "[object ArrayBuffer]", R = "[object DataView]", O = "[object Float32Array]", F = "[object Float64Array]", L = "[object Int8Array]", D = "[object Int16Array]", P = "[object Int32Array]", U = "[object Uint8Array]", q = "[object Uint8ClampedArray]", z = "[object Uint16Array]", te = "[object Uint32Array]", ee = {};
  ee[O] = ee[F] = ee[L] = ee[D] = ee[P] = ee[U] = ee[q] = ee[z] = ee[te] = !0, ee[r] = ee[o] = ee[A] = ee[i] = ee[R] = ee[a] = ee[s] = ee[l] = ee[u] = ee[m] = ee[v] = ee[g] = ee[h] = ee[E] = ee[C] = !1;
  function x(N) {
    return n(N) && t(N.length) && !!ee[e(N)];
  }
  return O1 = x, O1;
}
var P1, Z5;
function B0() {
  if (Z5) return P1;
  Z5 = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return P1 = e, P1;
}
var Wi = { exports: {} };
Wi.exports;
var x5;
function j0() {
  return x5 || (x5 = 1, function(e, t) {
    var n = h3(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i && n.process, s = function() {
      try {
        var l = o && o.require && o.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch (u) {
      }
    }();
    e.exports = s;
  }(Wi, Wi.exports)), Wi.exports;
}
var N1, W5;
function v3() {
  if (W5) return N1;
  W5 = 1;
  var e = jH(), t = B0(), n = j0(), r = n && n.isTypedArray, o = r ? t(r) : e;
  return N1 = o, N1;
}
var H1, Y5;
function UH() {
  if (Y5) return H1;
  Y5 = 1;
  var e = c3(), t = Fs(), n = p3(), r = Zr(), o = R0(), i = V0(), a = Ns(), s = v3(), l = "[object Map]", u = "[object Set]", m = Object.prototype, v = m.hasOwnProperty;
  function g(h) {
    if (h == null)
      return !0;
    if (o(h) && (r(h) || typeof h == "string" || typeof h.splice == "function" || i(h) || s(h) || n(h)))
      return !h.length;
    var E = t(h);
    if (E == l || E == u)
      return !h.size;
    if (a(h))
      return !e(h).length;
    for (var C in h)
      if (v.call(h, C))
        return !1;
    return !0;
  }
  return H1 = g, H1;
}
var qH = UH();
const GH = /* @__PURE__ */ ko(qH);
var F1, X5;
function KH() {
  if (X5) return F1;
  X5 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return F1 = e, F1;
}
var R1, Q5;
function b3() {
  if (Q5) return R1;
  Q5 = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return R1 = e, R1;
}
var V1, J5;
function Rs() {
  if (J5) return V1;
  J5 = 1;
  var e = b3();
  function t(n, r) {
    for (var o = n.length; o--; )
      if (e(n[o][0], r))
        return o;
    return -1;
  }
  return V1 = t, V1;
}
var B1, e9;
function zH() {
  if (e9) return B1;
  e9 = 1;
  var e = Rs(), t = Array.prototype, n = t.splice;
  function r(o) {
    var i = this.__data__, a = e(i, o);
    if (a < 0)
      return !1;
    var s = i.length - 1;
    return a == s ? i.pop() : n.call(i, a, 1), --this.size, !0;
  }
  return B1 = r, B1;
}
var j1, t9;
function ZH() {
  if (t9) return j1;
  t9 = 1;
  var e = Rs();
  function t(n) {
    var r = this.__data__, o = e(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return j1 = t, j1;
}
var U1, n9;
function xH() {
  if (n9) return U1;
  n9 = 1;
  var e = Rs();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return U1 = t, U1;
}
var q1, r9;
function WH() {
  if (r9) return q1;
  r9 = 1;
  var e = Rs();
  function t(n, r) {
    var o = this.__data__, i = e(o, n);
    return i < 0 ? (++this.size, o.push([n, r])) : o[i][1] = r, this;
  }
  return q1 = t, q1;
}
var G1, o9;
function Vs() {
  if (o9) return G1;
  o9 = 1;
  var e = KH(), t = zH(), n = ZH(), r = xH(), o = WH();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, G1 = i, G1;
}
var K1, i9;
function YH() {
  if (i9) return K1;
  i9 = 1;
  var e = Vs();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return K1 = t, K1;
}
var z1, s9;
function XH() {
  if (s9) return z1;
  s9 = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return z1 = e, z1;
}
var Z1, a9;
function QH() {
  if (a9) return Z1;
  a9 = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Z1 = e, Z1;
}
var x1, l9;
function JH() {
  if (l9) return x1;
  l9 = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return x1 = e, x1;
}
var W1, u9;
function Bs() {
  if (u9) return W1;
  u9 = 1;
  var e = zr(), t = e(Object, "create");
  return W1 = t, W1;
}
var Y1, d9;
function eF() {
  if (d9) return Y1;
  d9 = 1;
  var e = Bs();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Y1 = t, Y1;
}
var X1, c9;
function tF() {
  if (c9) return X1;
  c9 = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return X1 = e, X1;
}
var Q1, h9;
function nF() {
  if (h9) return Q1;
  h9 = 1;
  var e = Bs(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    var a = this.__data__;
    if (e) {
      var s = a[i];
      return s === t ? void 0 : s;
    }
    return r.call(a, i) ? a[i] : void 0;
  }
  return Q1 = o, Q1;
}
var J1, m9;
function rF() {
  if (m9) return J1;
  m9 = 1;
  var e = Bs(), t = Object.prototype, n = t.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    return e ? i[o] !== void 0 : n.call(i, o);
  }
  return J1 = r, J1;
}
var eu, f9;
function oF() {
  if (f9) return eu;
  f9 = 1;
  var e = Bs(), t = "__lodash_hash_undefined__";
  function n(r, o) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = e && o === void 0 ? t : o, this;
  }
  return eu = n, eu;
}
var tu, p9;
function iF() {
  if (p9) return tu;
  p9 = 1;
  var e = eF(), t = tF(), n = nF(), r = rF(), o = oF();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, tu = i, tu;
}
var nu, g9;
function sF() {
  if (g9) return nu;
  g9 = 1;
  var e = iF(), t = Vs(), n = F0();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return nu = r, nu;
}
var ru, v9;
function aF() {
  if (v9) return ru;
  v9 = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return ru = e, ru;
}
var ou, b9;
function js() {
  if (b9) return ou;
  b9 = 1;
  var e = aF();
  function t(n, r) {
    var o = n.__data__;
    return e(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return ou = t, ou;
}
var iu, y9;
function lF() {
  if (y9) return iu;
  y9 = 1;
  var e = js();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return iu = t, iu;
}
var su, _9;
function uF() {
  if (_9) return su;
  _9 = 1;
  var e = js();
  function t(n) {
    return e(this, n).get(n);
  }
  return su = t, su;
}
var au, C9;
function dF() {
  if (C9) return au;
  C9 = 1;
  var e = js();
  function t(n) {
    return e(this, n).has(n);
  }
  return au = t, au;
}
var lu, w9;
function cF() {
  if (w9) return lu;
  w9 = 1;
  var e = js();
  function t(n, r) {
    var o = e(this, n), i = o.size;
    return o.set(n, r), this.size += o.size == i ? 0 : 1, this;
  }
  return lu = t, lu;
}
var uu, T9;
function y3() {
  if (T9) return uu;
  T9 = 1;
  var e = sF(), t = lF(), n = uF(), r = dF(), o = cF();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, uu = i, uu;
}
var du, k9;
function hF() {
  if (k9) return du;
  k9 = 1;
  var e = Vs(), t = F0(), n = y3(), r = 200;
  function o(i, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var l = s.__data__;
      if (!t || l.length < r - 1)
        return l.push([i, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(l);
    }
    return s.set(i, a), this.size = s.size, this;
  }
  return du = o, du;
}
var cu, E9;
function mF() {
  if (E9) return cu;
  E9 = 1;
  var e = Vs(), t = YH(), n = XH(), r = QH(), o = JH(), i = hF();
  function a(s) {
    var l = this.__data__ = new e(s);
    this.size = l.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = o, a.prototype.set = i, cu = a, cu;
}
var hu, S9;
function fF() {
  if (S9) return hu;
  S9 = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o && n(t[r], r, t) !== !1; )
      ;
    return t;
  }
  return hu = e, hu;
}
var mu, M9;
function pF() {
  if (M9) return mu;
  M9 = 1;
  var e = zr(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch (r) {
    }
  }();
  return mu = t, mu;
}
var fu, A9;
function _3() {
  if (A9) return fu;
  A9 = 1;
  var e = pF();
  function t(n, r, o) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : n[r] = o;
  }
  return fu = t, fu;
}
var pu, I9;
function C3() {
  if (I9) return pu;
  I9 = 1;
  var e = _3(), t = b3(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, s) {
    var l = i[a];
    (!(r.call(i, a) && t(l, s)) || s === void 0 && !(a in i)) && e(i, a, s);
  }
  return pu = o, pu;
}
var gu, L9;
function Us() {
  if (L9) return gu;
  L9 = 1;
  var e = C3(), t = _3();
  function n(r, o, i, a) {
    var s = !i;
    i || (i = {});
    for (var l = -1, u = o.length; ++l < u; ) {
      var m = o[l], v = a ? a(i[m], r[m], m, i, r) : void 0;
      v === void 0 && (v = r[m]), s ? t(i, m, v) : e(i, m, v);
    }
    return i;
  }
  return gu = n, gu;
}
var vu, D9;
function gF() {
  if (D9) return vu;
  D9 = 1;
  function e(t, n) {
    for (var r = -1, o = Array(t); ++r < t; )
      o[r] = n(r);
    return o;
  }
  return vu = e, vu;
}
var bu, $9;
function vF() {
  if ($9) return bu;
  $9 = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var i = typeof r;
    return o = o == null ? e : o, !!o && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return bu = n, bu;
}
var yu, O9;
function w3() {
  if (O9) return yu;
  O9 = 1;
  var e = gF(), t = p3(), n = Zr(), r = V0(), o = vF(), i = v3(), a = Object.prototype, s = a.hasOwnProperty;
  function l(u, m) {
    var v = n(u), g = !v && t(u), h = !v && !g && r(u), E = !v && !g && !h && i(u), C = v || g || h || E, A = C ? e(u.length, String) : [], R = A.length;
    for (var O in u)
      (m || s.call(u, O)) && !(C && // Safari 9 has enumerable `arguments.length` in strict mode.
      (O == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (O == "offset" || O == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      E && (O == "buffer" || O == "byteLength" || O == "byteOffset") || // Skip index properties.
      o(O, R))) && A.push(O);
    return A;
  }
  return yu = l, yu;
}
var _u, P9;
function U0() {
  if (P9) return _u;
  P9 = 1;
  var e = w3(), t = c3(), n = R0();
  function r(o) {
    return n(o) ? e(o) : t(o);
  }
  return _u = r, _u;
}
var Cu, N9;
function bF() {
  if (N9) return Cu;
  N9 = 1;
  var e = Us(), t = U0();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Cu = n, Cu;
}
var wu, H9;
function yF() {
  if (H9) return wu;
  H9 = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var r in Object(t))
        n.push(r);
    return n;
  }
  return wu = e, wu;
}
var Tu, F9;
function _F() {
  if (F9) return Tu;
  F9 = 1;
  var e = bi(), t = Ns(), n = yF(), r = Object.prototype, o = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var s = t(a), l = [];
    for (var u in a)
      u == "constructor" && (s || !o.call(a, u)) || l.push(u);
    return l;
  }
  return Tu = i, Tu;
}
var ku, R9;
function q0() {
  if (R9) return ku;
  R9 = 1;
  var e = w3(), t = _F(), n = R0();
  function r(o) {
    return n(o) ? e(o, !0) : t(o);
  }
  return ku = r, ku;
}
var Eu, V9;
function CF() {
  if (V9) return Eu;
  V9 = 1;
  var e = Us(), t = q0();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Eu = n, Eu;
}
var Yi = { exports: {} };
Yi.exports;
var B9;
function wF() {
  return B9 || (B9 = 1, function(e, t) {
    var n = In(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
    function l(u, m) {
      if (m)
        return u.slice();
      var v = u.length, g = s ? s(v) : new u.constructor(v);
      return u.copy(g), g;
    }
    e.exports = l;
  }(Yi, Yi.exports)), Yi.exports;
}
var Su, j9;
function TF() {
  if (j9) return Su;
  j9 = 1;
  function e(t, n) {
    var r = -1, o = t.length;
    for (n || (n = Array(o)); ++r < o; )
      n[r] = t[r];
    return n;
  }
  return Su = e, Su;
}
var Mu, U9;
function kF() {
  if (U9) return Mu;
  U9 = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = 0, a = []; ++r < o; ) {
      var s = t[r];
      n(s, r, t) && (a[i++] = s);
    }
    return a;
  }
  return Mu = e, Mu;
}
var Au, q9;
function T3() {
  if (q9) return Au;
  q9 = 1;
  function e() {
    return [];
  }
  return Au = e, Au;
}
var Iu, G9;
function G0() {
  if (G9) return Iu;
  G9 = 1;
  var e = kF(), t = T3(), n = Object.prototype, r = n.propertyIsEnumerable, o = Object.getOwnPropertySymbols, i = o ? function(a) {
    return a == null ? [] : (a = Object(a), e(o(a), function(s) {
      return r.call(a, s);
    }));
  } : t;
  return Iu = i, Iu;
}
var Lu, K9;
function EF() {
  if (K9) return Lu;
  K9 = 1;
  var e = Us(), t = G0();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Lu = n, Lu;
}
var Du, z9;
function k3() {
  if (z9) return Du;
  z9 = 1;
  function e(t, n) {
    for (var r = -1, o = n.length, i = t.length; ++r < o; )
      t[i + r] = n[r];
    return t;
  }
  return Du = e, Du;
}
var $u, Z9;
function E3() {
  if (Z9) return $u;
  Z9 = 1;
  var e = d3(), t = e(Object.getPrototypeOf, Object);
  return $u = t, $u;
}
var Ou, x9;
function S3() {
  if (x9) return Ou;
  x9 = 1;
  var e = k3(), t = E3(), n = G0(), r = T3(), o = Object.getOwnPropertySymbols, i = o ? function(a) {
    for (var s = []; a; )
      e(s, n(a)), a = t(a);
    return s;
  } : r;
  return Ou = i, Ou;
}
var Pu, W9;
function SF() {
  if (W9) return Pu;
  W9 = 1;
  var e = Us(), t = S3();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Pu = n, Pu;
}
var Nu, Y9;
function M3() {
  if (Y9) return Nu;
  Y9 = 1;
  var e = k3(), t = Zr();
  function n(r, o, i) {
    var a = o(r);
    return t(r) ? a : e(a, i(r));
  }
  return Nu = n, Nu;
}
var Hu, X9;
function MF() {
  if (X9) return Hu;
  X9 = 1;
  var e = M3(), t = G0(), n = U0();
  function r(o) {
    return e(o, n, t);
  }
  return Hu = r, Hu;
}
var Fu, Q9;
function AF() {
  if (Q9) return Fu;
  Q9 = 1;
  var e = M3(), t = S3(), n = q0();
  function r(o) {
    return e(o, n, t);
  }
  return Fu = r, Fu;
}
var Ru, J9;
function IF() {
  if (J9) return Ru;
  J9 = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(r) {
    var o = r.length, i = new r.constructor(o);
    return o && typeof r[0] == "string" && t.call(r, "index") && (i.index = r.index, i.input = r.input), i;
  }
  return Ru = n, Ru;
}
var Vu, ef;
function LF() {
  if (ef) return Vu;
  ef = 1;
  var e = In(), t = e.Uint8Array;
  return Vu = t, Vu;
}
var Bu, tf;
function K0() {
  if (tf) return Bu;
  tf = 1;
  var e = LF();
  function t(n) {
    var r = new n.constructor(n.byteLength);
    return new e(r).set(new e(n)), r;
  }
  return Bu = t, Bu;
}
var ju, nf;
function DF() {
  if (nf) return ju;
  nf = 1;
  var e = K0();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.byteLength);
  }
  return ju = t, ju;
}
var Uu, rf;
function $F() {
  if (rf) return Uu;
  rf = 1;
  var e = /\w*$/;
  function t(n) {
    var r = new n.constructor(n.source, e.exec(n));
    return r.lastIndex = n.lastIndex, r;
  }
  return Uu = t, Uu;
}
var qu, of;
function OF() {
  if (of) return qu;
  of = 1;
  var e = Hs(), t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function r(o) {
    return n ? Object(n.call(o)) : {};
  }
  return qu = r, qu;
}
var Gu, sf;
function PF() {
  if (sf) return Gu;
  sf = 1;
  var e = K0();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.length);
  }
  return Gu = t, Gu;
}
var Ku, af;
function NF() {
  if (af) return Ku;
  af = 1;
  var e = K0(), t = DF(), n = $F(), r = OF(), o = PF(), i = "[object Boolean]", a = "[object Date]", s = "[object Map]", l = "[object Number]", u = "[object RegExp]", m = "[object Set]", v = "[object String]", g = "[object Symbol]", h = "[object ArrayBuffer]", E = "[object DataView]", C = "[object Float32Array]", A = "[object Float64Array]", R = "[object Int8Array]", O = "[object Int16Array]", F = "[object Int32Array]", L = "[object Uint8Array]", D = "[object Uint8ClampedArray]", P = "[object Uint16Array]", U = "[object Uint32Array]";
  function q(z, te, ee) {
    var x = z.constructor;
    switch (te) {
      case h:
        return e(z);
      case i:
      case a:
        return new x(+z);
      case E:
        return t(z, ee);
      case C:
      case A:
      case R:
      case O:
      case F:
      case L:
      case D:
      case P:
      case U:
        return o(z, ee);
      case s:
        return new x();
      case l:
      case v:
        return new x(z);
      case u:
        return n(z);
      case m:
        return new x();
      case g:
        return r(z);
    }
  }
  return Ku = q, Ku;
}
var zu, lf;
function HF() {
  if (lf) return zu;
  lf = 1;
  var e = bi(), t = Object.create, n = /* @__PURE__ */ function() {
    function r() {
    }
    return function(o) {
      if (!e(o))
        return {};
      if (t)
        return t(o);
      r.prototype = o;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return zu = n, zu;
}
var Zu, uf;
function FF() {
  if (uf) return Zu;
  uf = 1;
  var e = HF(), t = E3(), n = Ns();
  function r(o) {
    return typeof o.constructor == "function" && !n(o) ? e(t(o)) : {};
  }
  return Zu = r, Zu;
}
var xu, df;
function RF() {
  if (df) return xu;
  df = 1;
  var e = Fs(), t = Mo(), n = "[object Map]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return xu = r, xu;
}
var Wu, cf;
function VF() {
  if (cf) return Wu;
  cf = 1;
  var e = RF(), t = B0(), n = j0(), r = n && n.isMap, o = r ? t(r) : e;
  return Wu = o, Wu;
}
var Yu, hf;
function BF() {
  if (hf) return Yu;
  hf = 1;
  var e = Fs(), t = Mo(), n = "[object Set]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return Yu = r, Yu;
}
var Xu, mf;
function jF() {
  if (mf) return Xu;
  mf = 1;
  var e = BF(), t = B0(), n = j0(), r = n && n.isSet, o = r ? t(r) : e;
  return Xu = o, Xu;
}
var Qu, ff;
function UF() {
  if (ff) return Qu;
  ff = 1;
  var e = mF(), t = fF(), n = C3(), r = bF(), o = CF(), i = wF(), a = TF(), s = EF(), l = SF(), u = MF(), m = AF(), v = Fs(), g = IF(), h = NF(), E = FF(), C = Zr(), A = V0(), R = VF(), O = bi(), F = jF(), L = U0(), D = q0(), P = 1, U = 2, q = 4, z = "[object Arguments]", te = "[object Array]", ee = "[object Boolean]", x = "[object Date]", N = "[object Error]", G = "[object Function]", X = "[object GeneratorFunction]", Q = "[object Map]", re = "[object Number]", se = "[object Object]", ue = "[object RegExp]", me = "[object Set]", he = "[object String]", _e = "[object Symbol]", De = "[object WeakMap]", Ae = "[object ArrayBuffer]", ze = "[object DataView]", Qe = "[object Float32Array]", Et = "[object Float64Array]", Vt = "[object Int8Array]", mn = "[object Int16Array]", fn = "[object Int32Array]", pn = "[object Uint8Array]", gn = "[object Uint8ClampedArray]", Ln = "[object Uint16Array]", St = "[object Uint32Array]", ce = {};
  ce[z] = ce[te] = ce[Ae] = ce[ze] = ce[ee] = ce[x] = ce[Qe] = ce[Et] = ce[Vt] = ce[mn] = ce[fn] = ce[Q] = ce[re] = ce[se] = ce[ue] = ce[me] = ce[he] = ce[_e] = ce[pn] = ce[gn] = ce[Ln] = ce[St] = !0, ce[N] = ce[G] = ce[De] = !1;
  function Mt(le, fe, Pe, Re, At, Ze) {
    var be, Je = fe & P, ht = fe & U, Wt = fe & q;
    if (Pe && (be = At ? Pe(le, Re, At, Ze) : Pe(le)), be !== void 0)
      return be;
    if (!O(le))
      return le;
    var vn = C(le);
    if (vn) {
      if (be = g(le), !Je)
        return a(le, be);
    } else {
      var et = v(le), mt = et == G || et == X;
      if (A(le))
        return i(le, Je);
      if (et == se || et == z || mt && !At) {
        if (be = ht || mt ? {} : E(le), !Je)
          return ht ? l(le, o(be, le)) : s(le, r(be, le));
      } else {
        if (!ce[et])
          return At ? le : {};
        be = h(le, et, Je);
      }
    }
    Ze || (Ze = new e());
    var bn = Ze.get(le);
    if (bn)
      return bn;
    Ze.set(le, be), F(le) ? le.forEach(function(Ce) {
      be.add(Mt(Ce, fe, Pe, Ce, le, Ze));
    }) : R(le) && le.forEach(function(Ce, Ne) {
      be.set(Ne, Mt(Ce, fe, Pe, Ne, le, Ze));
    });
    var Wn = Wt ? ht ? m : u : ht ? D : L, It = vn ? void 0 : Wn(le);
    return t(It || le, function(Ce, Ne) {
      It && (Ne = Ce, Ce = le[Ne]), n(be, Ne, Mt(Ce, fe, Pe, Ne, le, Ze));
    }), be;
  }
  return Qu = Mt, Qu;
}
var Ju, pf;
function qF() {
  if (pf) return Ju;
  pf = 1;
  var e = UF(), t = 1, n = 4;
  function r(o) {
    return e(o, t | n);
  }
  return Ju = r, Ju;
}
var GF = qF();
const A3 = /* @__PURE__ */ ko(GF), KF = {
  news: {
    cover_image: [
      {
        url: "cover_image",
        alt_text: "image_description",
        image_focal_point_x: "image_focal_point_x",
        image_focal_point_y: "image_focal_point_y"
      }
    ],
    title: "title",
    snippet: "snippet",
    author: "author",
    time_ago: "time_ago",
    date: ["published_at"],
    time: ["published_at"]
  },
  events: {
    title: "title",
    description: "description",
    venue: "venue",
    date: ["formatted_start", "formatted_end", "all_day"],
    time: ["formatted_start", "formatted_end", "all_day"]
  },
  all_events: {
    title: "title",
    description: "description",
    venue: "venue",
    date: ["formatted_start", "formatted_end", "all_day"],
    time: ["formatted_start", "formatted_end", "all_day"]
  },
  live_feed: {
    status: "status",
    author: "author",
    avatar: "avatar",
    time_ago: "time_ago",
    date: ["time"],
    live_feed_images: "live_feed_images",
    time: ["time"]
  },
  athletics: {
    title: "title",
    home_team: "home_team",
    home_score: "home_score",
    away_team: "away_team",
    away_score: "away_score",
    date: ["formatted_date"],
    time: ["formatted_date"],
    address: "address",
    versus: "versus",
    filter_name: "filter_name"
  },
  dining: {
    breakfast: "breakfast",
    lunch: "lunch"
  }
}, Zc = (e, t, n) => {
  const r = Object.entries(t).reduce((o, [i, a]) => (a instanceof Array ? o[i] = Object.values(Zc(e, a)) : a instanceof Object ? o[i] = Zc(e, a) : a in e && (o[i] = e[a]), o), {});
  return n && ["events", "all_events", "news", "live_feed"].includes(n.DATA_TYPE) ? A0(Bn({}, r), { entry_url: ZF(e, n) }) : r;
}, zF = (e, t) => {
  if (!e) throw new Error("No data source found.");
  const n = KF[[t.DATA_TYPE]];
  return e.map((r) => Zc(r, n, t));
}, ZF = (e, t) => {
  const n = {
    all_events: "events",
    news: "article",
    live_feed: "live-feed"
  }[t.DATA_TYPE] || t.DATA_TYPE, r = `${t.PATH_PREFIX}/${n}`;
  switch (n) {
    case "events":
      return `${r}?id=${e.id}`;
    case "article":
      return `${r}/${e.id}`;
    case "live-feed":
      return `${r}#${e.id}`;
    default:
      return r;
  }
}, xF = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, WF = (e, t, n) => {
  let r;
  const o = xF[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ed(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const YF = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, XF = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, QF = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, JF = {
  date: ed({
    formats: YF,
    defaultWidth: "full"
  }),
  time: ed({
    formats: XF,
    defaultWidth: "full"
  }),
  dateTime: ed({
    formats: QF,
    defaultWidth: "full"
  })
}, eR = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, tR = (e, t, n, r) => eR[e];
function Bo(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      o = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const nR = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, rR = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, oR = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, iR = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, sR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, aR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, lR = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, uR = {
  ordinalNumber: lR,
  era: Bo({
    values: nR,
    defaultWidth: "wide"
  }),
  quarter: Bo({
    values: rR,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Bo({
    values: oR,
    defaultWidth: "wide"
  }),
  day: Bo({
    values: iR,
    defaultWidth: "wide"
  }),
  dayPeriod: Bo({
    values: sR,
    defaultWidth: "wide",
    formattingValues: aR,
    defaultFormattingWidth: "wide"
  })
};
function jo(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const a = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? cR(s, (v) => v.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      dR(s, (v) => v.test(a))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(u)
    ) : u;
    const m = t.slice(a.length);
    return { value: u, rest: m };
  };
}
function dR(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function cR(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function hR(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(o.length);
    return { value: a, rest: s };
  };
}
const mR = /^(\d+)(th|st|nd|rd)?/i, fR = /\d+/i, pR = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, gR = {
  any: [/^b/i, /^(a|c)/i]
}, vR = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, bR = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, yR = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, _R = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, CR = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, wR = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, TR = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, kR = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ER = {
  ordinalNumber: hR({
    matchPattern: mR,
    parsePattern: fR,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: jo({
    matchPatterns: pR,
    defaultMatchWidth: "wide",
    parsePatterns: gR,
    defaultParseWidth: "any"
  }),
  quarter: jo({
    matchPatterns: vR,
    defaultMatchWidth: "wide",
    parsePatterns: bR,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: jo({
    matchPatterns: yR,
    defaultMatchWidth: "wide",
    parsePatterns: _R,
    defaultParseWidth: "any"
  }),
  day: jo({
    matchPatterns: CR,
    defaultMatchWidth: "wide",
    parsePatterns: wR,
    defaultParseWidth: "any"
  }),
  dayPeriod: jo({
    matchPatterns: TR,
    defaultMatchWidth: "any",
    parsePatterns: kR,
    defaultParseWidth: "any"
  })
}, SR = {
  code: "en-US",
  formatDistance: WF,
  formatLong: JF,
  formatRelative: tR,
  localize: uR,
  match: ER,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let MR = {};
function qs() {
  return MR;
}
const I3 = 6048e5, AR = 864e5, L3 = 6e4, D3 = 36e5;
function hn(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function gf(e) {
  const t = hn(e);
  return t.setHours(0, 0, 0, 0), t;
}
function vf(e) {
  const t = hn(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function IR(e, t) {
  const n = gf(e), r = gf(t), o = +n - vf(n), i = +r - vf(r);
  return Math.round((o - i) / AR);
}
function Nr(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function LR(e) {
  const t = hn(e), n = Nr(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function DR(e) {
  const t = hn(e);
  return IR(t, LR(t)) + 1;
}
function li(e, t) {
  var n, r, o, i, a, s, l, u;
  const m = qs(), v = (u = (l = (i = (o = t == null ? void 0 : t.weekStartsOn) != null ? o : (r = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : r.weekStartsOn) != null ? i : m.weekStartsOn) != null ? l : (s = (a = m.locale) == null ? void 0 : a.options) == null ? void 0 : s.weekStartsOn) != null ? u : 0, g = hn(e), h = g.getDay(), E = (h < v ? 7 : 0) + h - v;
  return g.setDate(g.getDate() - E), g.setHours(0, 0, 0, 0), g;
}
function fs(e) {
  return li(e, { weekStartsOn: 1 });
}
function $3(e) {
  const t = hn(e), n = t.getFullYear(), r = Nr(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = fs(r), i = Nr(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const a = fs(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function $R(e) {
  const t = $3(e), n = Nr(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), fs(n);
}
function OR(e) {
  const t = hn(e), n = +fs(t) - +$R(t);
  return Math.round(n / I3) + 1;
}
function O3(e, t) {
  var n, r, o, i, a, s, l, u;
  const m = hn(e), v = m.getFullYear(), g = qs(), h = (u = (l = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) != null ? o : (r = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : g.firstWeekContainsDate) != null ? l : (s = (a = g.locale) == null ? void 0 : a.options) == null ? void 0 : s.firstWeekContainsDate) != null ? u : 1, E = Nr(e, 0);
  E.setFullYear(v + 1, 0, h), E.setHours(0, 0, 0, 0);
  const C = li(E, t), A = Nr(e, 0);
  A.setFullYear(v, 0, h), A.setHours(0, 0, 0, 0);
  const R = li(A, t);
  return m.getTime() >= C.getTime() ? v + 1 : m.getTime() >= R.getTime() ? v : v - 1;
}
function PR(e, t) {
  var n, r, o, i, a, s, l, u;
  const m = qs(), v = (u = (l = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) != null ? o : (r = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : m.firstWeekContainsDate) != null ? l : (s = (a = m.locale) == null ? void 0 : a.options) == null ? void 0 : s.firstWeekContainsDate) != null ? u : 1, g = O3(e, t), h = Nr(e, 0);
  return h.setFullYear(g, 0, v), h.setHours(0, 0, 0, 0), li(h, t);
}
function NR(e, t) {
  const n = hn(e), r = +li(n, t) - +PR(n, t);
  return Math.round(r / I3) + 1;
}
function Ie(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Jn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Ie(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Ie(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Ie(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Ie(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Ie(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Ie(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Ie(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Ie(o, t.length);
  }
}, Jr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, bf = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Jn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = O3(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = i % 100;
      return Ie(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Ie(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = $3(e);
    return Ie(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Ie(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Ie(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Ie(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Jn.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Ie(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = NR(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Ie(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = OR(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Ie(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Jn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = DR(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Ie(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return Ie(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return Ie(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return Ie(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Jr.noon : r === 0 ? o = Jr.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Jr.evening : r >= 12 ? o = Jr.afternoon : r >= 4 ? o = Jr.morning : o = Jr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Jn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Jn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ie(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ie(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Jn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Jn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Jn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return _f(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return kr(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return kr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return _f(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return kr(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return kr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + yf(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + kr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + yf(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + kr(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Ie(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return Ie(r, t.length);
  }
};
function yf(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + Ie(i, 2);
}
function _f(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ie(Math.abs(e) / 60, 2) : kr(e, t);
}
function kr(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Ie(Math.trunc(r / 60), 2), i = Ie(r % 60, 2);
  return n + o + t + i;
}
const Cf = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, P3 = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, HR = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Cf(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Cf(r, t)).replace("{{time}}", P3(o, t));
}, FR = {
  p: P3,
  P: HR
}, RR = /^D+$/, VR = /^Y+$/, BR = ["D", "DD", "YY", "YYYY"];
function jR(e) {
  return RR.test(e);
}
function UR(e) {
  return VR.test(e);
}
function qR(e, t, n) {
  const r = GR(e, t, n);
  if (console.warn(r), BR.includes(e)) throw new RangeError(r);
}
function GR(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function KR(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function zR(e) {
  if (!KR(e) && typeof e != "number")
    return !1;
  const t = hn(e);
  return !isNaN(Number(t));
}
const ZR = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, xR = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, WR = /^'([^]*?)'?$/, YR = /''/g, XR = /[a-zA-Z]/;
function QR(e, t, n) {
  var r, o, i, a, s, l, u, m, v;
  const g = qs(), h = (r = g.locale) != null ? r : SR, E = (s = (a = g.firstWeekContainsDate) != null ? a : (i = (o = g.locale) == null ? void 0 : o.options) == null ? void 0 : i.firstWeekContainsDate) != null ? s : 1, C = (v = (m = g.weekStartsOn) != null ? m : (u = (l = g.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) != null ? v : 0, A = hn(e);
  if (!zR(A))
    throw new RangeError("Invalid time value");
  let R = t.match(xR).map((F) => {
    const L = F[0];
    if (L === "p" || L === "P") {
      const D = FR[L];
      return D(F, h.formatLong);
    }
    return F;
  }).join("").match(ZR).map((F) => {
    if (F === "''")
      return { isToken: !1, value: "'" };
    const L = F[0];
    if (L === "'")
      return { isToken: !1, value: JR(F) };
    if (bf[L])
      return { isToken: !0, value: F };
    if (L.match(XR))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + L + "`"
      );
    return { isToken: !1, value: F };
  });
  h.localize.preprocessor && (R = h.localize.preprocessor(A, R));
  const O = {
    firstWeekContainsDate: E,
    weekStartsOn: C,
    locale: h
  };
  return R.map((F) => {
    if (!F.isToken) return F.value;
    const L = F.value;
    (UR(L) || jR(L)) && qR(L, t, String(e));
    const D = bf[L[0]];
    return D(A, L, h.localize, O);
  }).join("");
}
function JR(e) {
  const t = e.match(WR);
  return t ? t[1].replace(YR, "'") : e;
}
function eV(e, t) {
  const n = oV(e);
  let r;
  if (n.date) {
    const s = iV(n.date, 2);
    r = sV(s.restDateString, s.year);
  }
  if (!r || isNaN(r.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = r.getTime();
  let i = 0, a;
  if (n.time && (i = aV(n.time), isNaN(i)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (a = lV(n.timezone), isNaN(a))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const s = new Date(o + i), l = /* @__PURE__ */ new Date(0);
    return l.setFullYear(
      s.getUTCFullYear(),
      s.getUTCMonth(),
      s.getUTCDate()
    ), l.setHours(
      s.getUTCHours(),
      s.getUTCMinutes(),
      s.getUTCSeconds(),
      s.getUTCMilliseconds()
    ), l;
  }
  return new Date(o + i + a);
}
const Ui = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, tV = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, nV = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, rV = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function oV(e) {
  const t = {}, n = e.split(Ui.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Ui.timeZoneDelimiter.test(t.date) && (t.date = e.split(Ui.timeZoneDelimiter)[0], r = e.substr(
    t.date.length,
    e.length
  ))), r) {
    const o = Ui.timezone.exec(r);
    o ? (t.time = r.replace(o[1], ""), t.timezone = o[1]) : t.time = r;
  }
  return t;
}
function iV(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), r = e.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const o = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? o : i * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function sV(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(tV);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], o = Uo(n[1]), i = Uo(n[2]) - 1, a = Uo(n[3]), s = Uo(n[4]), l = Uo(n[5]) - 1;
  if (r)
    return mV(t, s, l) ? uV(t, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !cV(t, i, a) || !hV(t, o) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(t, i, Math.max(o, a)), u);
  }
}
function Uo(e) {
  return e ? parseInt(e) : 1;
}
function aV(e) {
  const t = e.match(nV);
  if (!t) return NaN;
  const n = td(t[1]), r = td(t[2]), o = td(t[3]);
  return fV(n, r, o) ? n * D3 + r * L3 + o * 1e3 : NaN;
}
function td(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function lV(e) {
  if (e === "Z") return 0;
  const t = e.match(rV);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), o = t[3] && parseInt(t[3]) || 0;
  return pV(r, o) ? n * (r * D3 + o * L3) : NaN;
}
function uV(e, t, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const o = r.getUTCDay() || 7, i = (t - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
const dV = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function N3(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function cV(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (dV[t] || (N3(e) ? 29 : 28));
}
function hV(e, t) {
  return t >= 1 && t <= (N3(e) ? 366 : 365);
}
function mV(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function fV(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function pV(e, t) {
  return t >= 0 && t <= 59;
}
function ln(e, t) {
  const n = e.includes("T") ? e.substring(0, e.lastIndexOf(".")) : e, r = eV(n);
  return QR(r, t);
}
function gV(e, t) {
  return t ? ln(e, "MMM/dd/yyyy") === ln(t, "MMM/dd/yyyy") : !0;
}
var nd, wf;
function z0() {
  if (wf) return nd;
  wf = 1;
  var e = vi(), t = Mo(), n = "[object Symbol]";
  function r(o) {
    return typeof o == "symbol" || t(o) && e(o) == n;
  }
  return nd = r, nd;
}
var rd, Tf;
function vV() {
  if (Tf) return rd;
  Tf = 1;
  var e = Zr(), t = z0(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function o(i, a) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : r.test(i) || !n.test(i) || a != null && i in Object(a);
  }
  return rd = o, rd;
}
var od, kf;
function bV() {
  if (kf) return od;
  kf = 1;
  var e = y3(), t = "Expected a function";
  function n(r, o) {
    if (typeof r != "function" || o != null && typeof o != "function")
      throw new TypeError(t);
    var i = function() {
      var a = arguments, s = o ? o.apply(this, a) : a[0], l = i.cache;
      if (l.has(s))
        return l.get(s);
      var u = r.apply(this, a);
      return i.cache = l.set(s, u) || l, u;
    };
    return i.cache = new (n.Cache || e)(), i;
  }
  return n.Cache = e, od = n, od;
}
var id, Ef;
function yV() {
  if (Ef) return id;
  Ef = 1;
  var e = bV(), t = 500;
  function n(r) {
    var o = e(r, function(a) {
      return i.size === t && i.clear(), a;
    }), i = o.cache;
    return o;
  }
  return id = n, id;
}
var sd, Sf;
function _V() {
  if (Sf) return sd;
  Sf = 1;
  var e = yV(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(o) {
    var i = [];
    return o.charCodeAt(0) === 46 && i.push(""), o.replace(t, function(a, s, l, u) {
      i.push(l ? u.replace(n, "$1") : s || a);
    }), i;
  });
  return sd = r, sd;
}
var ad, Mf;
function CV() {
  if (Mf) return ad;
  Mf = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = Array(o); ++r < o; )
      i[r] = n(t[r], r, t);
    return i;
  }
  return ad = e, ad;
}
var ld, Af;
function wV() {
  if (Af) return ld;
  Af = 1;
  var e = Hs(), t = CV(), n = Zr(), r = z0(), o = e ? e.prototype : void 0, i = o ? o.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, a) + "";
    if (r(s))
      return i ? i.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return ld = a, ld;
}
var ud, If;
function TV() {
  if (If) return ud;
  If = 1;
  var e = wV();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return ud = t, ud;
}
var dd, Lf;
function kV() {
  if (Lf) return dd;
  Lf = 1;
  var e = Zr(), t = vV(), n = _V(), r = TV();
  function o(i, a) {
    return e(i) ? i : t(i, a) ? [i] : n(r(i));
  }
  return dd = o, dd;
}
var cd, Df;
function EV() {
  if (Df) return cd;
  Df = 1;
  var e = z0();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return cd = t, cd;
}
var hd, $f;
function SV() {
  if ($f) return hd;
  $f = 1;
  var e = kV(), t = EV();
  function n(r, o) {
    o = e(o, r);
    for (var i = 0, a = o.length; r != null && i < a; )
      r = r[t(o[i++])];
    return i && i == a ? r : void 0;
  }
  return hd = n, hd;
}
var md, Of;
function MV() {
  if (Of) return md;
  Of = 1;
  var e = SV();
  function t(n, r, o) {
    var i = n == null ? void 0 : e(n, r);
    return i === void 0 ? o : i;
  }
  return md = t, md;
}
var AV = MV();
const xc = /* @__PURE__ */ ko(AV), IV = (e, t, n = "date") => {
  if (!(n in e.entries[t]))
    return { type: "text", value: "Error: Value date not found" };
  const [r, o] = e.entries[t][n], i = gV(r, o) ? "" : ln(o, "MMM/dd/yyyy"), a = ln(r, "MMM"), s = ln(r, "dd"), l = ln(r, "iiii"), u = Be("span.date", [
    Be("span.start-month", a),
    Be("span.start-date", s),
    Be("span.start-weekday", l)
  ]);
  if (i) {
    const m = ln(o, "MMM"), v = ln(o, "dd"), g = ln(o, "iiii");
    u.children = u.children.concat(
      Be("span.date-separator", "-"),
      Be("span.end-month", m),
      Be("span.end-date", v),
      Be("span.end-weekday", g)
    );
  }
  return u;
}, LV = (e, t, n = "date") => {
  if (!(n in e.entries[t]))
    return { type: "text", value: "Error: Value time not found" };
  const [r, o, i] = e.entries[t][n];
  let a;
  const s = ln(r, "h:mmaaa");
  if (i)
    return Be("span.time", Be("span.start-time", "All day"));
  const l = Be("span.time", [Be("span.start-time", s)]);
  return o && (a = ln(o, "h:mmaaa"), l.children = l.children.concat(Be("span.time-separator", "-"), Be("span.end-time", a))), l;
}, Pf = (e, t, n) => {
  let r = e.entries[t][n];
  return (r.length === 0 || !r[0].url) && (r = [{ url: xc(e, "fallback_image.url", "") }]), Be(
    `div.${n.replace(/_/g, "-")}`,
    r.map(
      (o, i) => Be(`img.entry-${t}-img-${i}`, {
        src: o.url,
        alt: o.alt_text || "",
        style: o.image_focal_point_x && o.image_focal_point_y ? { "object-position": `${o.image_focal_point_x || 50}% ${o.image_focal_point_y || 50}%` } : void 0
      })
    )
  );
}, DV = (e, t, n) => {
  const r = e.split("|");
  for (let o = 0; o < r.length; o++) {
    const i = r[o], a = xc(t.entries[n], i, xc(t, i, void 0));
    if (a !== void 0) return a;
  }
};
function $V(e) {
  const t = {
    type: "element",
    tagName: "a",
    properties: {
      href: e.link_url,
      target: e.opens_in_new_tab,
      class: "automatic-schools-menu-image-a"
    }
  }, n = {
    type: "element",
    tagName: "img",
    properties: {
      src: e.url,
      class: "automatic-schools-menu-image-img",
      alt: e.alt_text,
      width: `${e.width}`,
      height: `${e.height}`
    }
  };
  return e.action_on_click === "no_action" ? n : (t.children = [n], t);
}
const Wc = "default", H3 = "children", Z0 = (e, t, n, r = {}, o) => e ? e.tagName === H3 ? NV(e, t, n, r, o) : PV(e, t, n, r, o) : null, OV = (e) => {
  const t = {
    [Wc]: Be(null, [new Be("div", ["{{name|url}}", new Be(H3)])])
  }, n = { templates: t, children: [] };
  return (e.children || []).forEach((r) => {
    var o, i;
    if (r.tagName === "template") {
      const a = Be(null, [...((o = r.content) == null ? void 0 : o.children) || []]), s = ((i = r.properties) == null ? void 0 : i.type) || Wc;
      t[s] = a;
    } else
      n.children.push(r);
  }), n;
}, PV = (e, t, n, r, o) => (e.tagName && (e.properties.className = [
  ...Array.isArray(e.properties.className) ? e.properties.className : [],
  `${e.tagName}-${t.class || ""}`
]), Array.isArray(e.children) && (e.children = e.children.map((i) => Z0(i, t, n, r, o)).filter(Boolean)), e), NV = (e, t, n, r, o) => {
  if (!n || n.length === 0)
    return null;
  const { startRange: i, endRange: a } = FV(e.properties, n.length), { templates: s, children: l } = OV(e), u = Bn(Bn({}, r), s);
  e.children = l;
  const m = new Be(null, []);
  for (let v = i; v < a; v++) {
    const g = Bn(Bn({}, t), n[v]), h = A3(u[g.type] || u[Wc]);
    if (!h) continue;
    HV(g, t.class), Z0(h, A0(Bn({}, t), { class: g.class }), g.children, u, o);
    const E = o(h, Bn(Bn({}, t), g));
    E && m.children.push(E);
  }
  return m;
}, HV = (e, t) => {
  if (Array.isArray(e.children)) {
    const n = `${t}-${(e.name || "").replace(/\W/g, "").toLowerCase()}`;
    e.children.forEach((r) => {
      r.class = n;
    });
  }
}, FV = (e, t) => {
  let n = 0, r = t;
  if (e != null && e.idx)
    n = Number(e.idx), r = n + 1;
  else if (e != null && e.loop) {
    const [o, i] = (e.loop.match(/\d+/g) || []).map(Number);
    n = o || 0, r = i || t;
  }
  return { startRange: n, endRange: r };
}, Nf = "loop", fd = (e) => parseInt(e, 10), F3 = (e) => e.substr(2, e.length - 4).trim(), RV = (e) => fd(e) ? [0, fd(e)] : e.replace(/[()]/g, "").split(", ").map(fd), Hf = {
  "cms-header-menu": (e, t) => {
    const n = t.menus[e.properties.entity].entries;
    return t.class = e.properties.entity, Z0(e, t, n, {}, _o), _o(e, t);
  },
  "cms-sign-in-button": (e, t) => {
    const { signInButtonText: n, showSignInButton: r, signInUrl: o } = t, i = r ? Be(
      "a",
      {
        href: o,
        className: ["sign-in"],
        target: "_blank",
        "aria-label": `${n} (opens ${o} in a new tab)`
      },
      n
    ) : Be(null);
    return Be(null, [i]);
  }
}, er = {
  DATA_TYPE: "",
  PATH_PREFIX: "",
  reservedTagParser: () => {
  },
  mappingFn: () => {
  }
}, VV = ["cms-media", "cms-header-menu", "cms-sign-in-button"], BV = (e) => {
  const t = {
    "&#x26;lt;": "<",
    "&#x3C;": "<",
    "&#x26;gt;": ">"
  }, n = new RegExp(Object.keys(t).join("|"), "gi");
  return e.replace(n, (r) => t[r]);
}, R3 = (e, t, n) => {
  const r = "{{", o = "}}", i = /{{([^{][\s\S]+?[^}])}}/g, a = e.toString().match(i);
  if (!a)
    return e;
  const s = a.map((l) => {
    const u = l.indexOf(r), m = l.lastIndexOf(o);
    if (u !== 0 && !u || !m || m < u)
      throw new Error(`Syntax error at ${l}`);
    const v = F3(l), g = er.mappingFn(v, t, n);
    if (g == null)
      throw new Error(`Value ${v} not found`);
    return g;
  });
  return a.reduce((l, u, m) => l.replace(u, s[m]), e);
}, _o = (e, t, n = -1) => {
  let r = A3(e);
  const o = (s) => s.type === "text", i = (s) => s.type === "element", a = (s) => s.children && s.children.length > 0;
  if (!a(e) && o(e)) {
    const s = Ff(e, t, n);
    s.length === 1 ? i(s[0]) ? r = s[0] : r.value = s[0].value : s.length > 1 && (r = Be("span", s));
  }
  if (a(e)) {
    const s = (l) => l.tagName && VV.includes(l.tagName) && l.children;
    r.children = e.children.reduce((l, u) => {
      if (o(u))
        return [...l, ...Ff(u, t, n)];
      if (s(u)) {
        if (typeof Hf[u.tagName] == "function") {
          const m = Hf[u.tagName](u, t);
          return [...l, ...m.children];
        }
        return er.reservedTagParser(l, u, n, t);
      }
      return [...l, _o(u, t, n)];
    }, []);
  }
  return ((s) => !GH(s.properties))(e) && (r.properties = Object.fromEntries(
    Object.entries(e.properties).map(([s, l]) => [s, R3(l, t, n)])
  )), r;
}, jV = (e, t, n, r) => {
  let o = n;
  if (t.properties.idx) {
    o = t.properties.idx;
    const i = t.children.map((a) => _o(a, r, o));
    return [...e, ...i];
  }
  if (t.properties[Nf]) {
    const [i, a] = RV(t.properties[Nf]);
    let s = 0;
    a > 0 ? s = a > r.entries.length ? r.entries.length : a + i : s = r.entries.length;
    let l = [];
    for (let u = i; u < s; u++)
      l = l.concat(t.children.map((m) => _o(m, r, u)));
    return [...e, ...l];
  }
}, V3 = (e, t, n) => {
  if (!t)
    throw new Error("Data type must be specified, eg. news, live_feed, athletics, events, or dining");
  if (!n)
    throw new Error("Data source is missing.");
  er.DATA_TYPE = t, er.PATH_PREFIX = n.path_prefix, er.reservedTagParser = jV, er.mappingFn = DV;
  const r = zF(n.entries, er), o = (l) => l == "all_events" ? "events" : l.replace(/_/g, "-"), i = `${er.PATH_PREFIX}/${o(t)}`, a = Uc().use(J4, { fragment: !0, emitParseErrors: !0, duplicateAttribute: !1 }).use(o3).parse(e), s = _o(a, A0(Bn({}, n), { section_page_url: i, entries: r }));
  return BV(Uc().use(MH).stringify(s));
};
function Ff(e, t, n) {
  const r = /({{[^{][\s\S]+?[^}]}})/g, o = e.value.trim().split(r).filter((a) => a != ""), i = {
    date: IV,
    time: LV,
    cover_image: Pf,
    live_feed_images: Pf,
    schoolMenuImage: $V,
    default: function(a, s, l) {
      return { type: "text", value: R3(`{{${l}}}`, a, s) };
    }
  };
  return o.map((a) => {
    if (a.match(r)) {
      const s = F3(a);
      return i[s] ? i[s](t, n, s) : i.default(t, n, s);
    } else
      return { type: "text", value: a };
  });
}
const UV = (e) => Uc().use(J4, { fragment: !0, emitParseErrors: !0 }).use(o3).parse(e), qV = {
  name: "CustomHtml",
  props: {
    theme: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      componentKey: 0
    };
  },
  computed: {
    cssCode() {
      return this.theme.css_code;
    },
    jsCode() {
      return this.theme.js_code;
    },
    htmlCode() {
      return this.theme.html_code;
    }
  },
  watch: {
    cssCode(e, t) {
      this.hasNewValue(e, t) && this.mountCss(e);
    },
    jsCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(e);
    },
    htmlCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(this.jsCode);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mountCss(this.cssCode), this.mountJs(this.jsCode);
    });
  },
  methods: {
    hasNewValue(e, t) {
      return e && e.localeCompare && e.localeCompare(t) !== 0;
    },
    mountCss(e) {
      if (!e)
        return;
      this.removeElementIfExists("style");
      const t = document.createElement("style");
      t.type = "text/css", t.appendChild(document.createTextNode(e)), this.$refs.container.appendChild(t);
    },
    mountJs(e) {
      this.componentKey += 1, this.$nextTick(() => {
        if (!e || !this.$refs.container)
          return;
        this.removeElementIfExists("script");
        const t = document.createElement("script");
        t.type = "text/javascript", t.appendChild(document.createTextNode(e)), this.$refs.container.appendChild(t);
      });
    },
    removeElementIfExists(e) {
      const t = document.querySelector(`#${this.id} ${e}`);
      t && t.remove();
    }
  }
}, GV = ["id"], KV = ["innerHTML"];
function zV(e, t, n, r, o, i) {
  return d(), f("div", {
    id: n.theme.container_id,
    ref: "container",
    class: "custom-html"
  }, [
    (d(), f("div", {
      ref: "html_code",
      key: o.componentKey,
      innerHTML: i.htmlCode
    }, null, 8, KV))
  ], 8, GV);
}
const Gs = /* @__PURE__ */ B(qV, [["render", zV], ["__scopeId", "data-v-20687f05"]]), ZV = {
  name: "Custom",
  components: {
    CustomHtml: Gs
  },
  mixins: [lt],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    processedTheme() {
      var t, n, r, o;
      let e = "";
      try {
        const i = [], a = {
          schoolName: this.content.globals.info.school_name,
          schoolLogo: this.content.globals.logo.url || "",
          schoolTagline: this.content.globals.info.school_tag_line || "",
          schoolPath: this.content.pathPrefix || "/",
          langCode: this.content.langCode,
          langText: "",
          signInButtonText: this.signInText,
          showSignInButton: this.showSignInButton,
          signInUrl: this.signInUrl
        };
        this.content.languages.forEach((m) => {
          m.code === this.content.langCode && (a.langText = m.language), i.push(ge(ae({}, m), { name: m.language }));
        });
        const s = this.formatItems(this.content.sitemapMenuItems), l = ((o = (r = (n = (t = this.content.globals) == null ? void 0 : t.homepage) == null ? void 0 : n.schools_menu) == null ? void 0 : r.menu) == null ? void 0 : o.flat()) || y4.menu.flat(), u = {
          siteMenu: {
            dataType: "siteMenu",
            entries: s
          },
          schoolsCustomMenu: {
            dataType: "schoolsCustomMenu",
            entries: this.formatItems(l)
          },
          schoolsMenu: {
            dataType: "schoolsMenu",
            entries: this.formatItems(this.content.organizations, "schoolsMenu")
          },
          languages: {
            dataType: "languages",
            entries: i
          }
        };
        e = V3(this.theme.customData.htmlCode, "header", ge(ae({}, a), { entries: [], menus: u }));
      } catch (i) {
        e = i;
      }
      return ge(ae({}, this.theme), {
        html_code: e,
        css_code: this.theme.customData.cssCode,
        js_code: this.theme.customData.jsCode
      });
    }
  },
  methods: {
    formatItems(e, t) {
      const n = this.formatItems;
      return e.map((r) => {
        let o = ae({}, r);
        const i = {
          SchoolsMenuLink: (s) => (s.opens_in_new_tab = s.opens_in_new_tab ? "_blank" : "_self", s.url = s.link || "", s.url = s.url.toLowerCase().replace(/\s/g, "-"), s),
          SchoolsMenuImage: (s) => (s.opens_in_new_tab = s.open_in_new_tab ? "_blank" : "_self", s.url = s.url.toLowerCase().replace(/\s/g, "-"), s.height = s.preferred_height || "auto", s.width = s.preferred_width || "auto", s.alignment = s.image_alignment, s),
          link: (s) => (s.opens_in_new_tab = s.opens_in_new_tab ? "_blank" : "_self", s.url = s.mailto ? `mailto:${s.email_address}` : s.url, s.url = s.url.toLowerCase().replace(/\s/g, "-"), s.ipAddress = s.ipAddress || "", s.email_address = s.email_address || "", s),
          SchoolsMenuOrg: (s) => (s.alias = s.alias || "", s.link = s.link || "", s.link = s.link.toLowerCase().replace(/\s/g, "-"), s),
          schoolsMenu: (s) => (s.path_prefix = s.path_prefix ? s.path_prefix : "/", s),
          page: (s) => (s.link_path = `${this.content.pathPrefix}/page/${s.slug}`, s)
        }, a = o.type || t;
        return i[a] && (o = i[a](o)), Array.isArray(o.children) && (o.children = n(o.children, t)), o;
      });
    }
  }
}, xV = { class: "header-custom-code" };
function WV(e, t, n, r, o, i) {
  const a = V("CustomHtml");
  return d(), f("div", xV, [
    j(a, { theme: i.processedTheme }, null, 8, ["theme"])
  ]);
}
const YV = /* @__PURE__ */ B(ZV, [["render", WV]]), XV = {
  name: "BarNavItemWrapper",
  components: { MenuElementType: O4, DropdownArrowIcon: To, HamburgerIcon: k0, PlusIcon: E0 },
  props: {
    item: {
      type: Object,
      default: void 0
    },
    theme: {
      type: Object,
      default: () => {
      }
    },
    content: {
      type: Object,
      default: () => {
      }
    },
    colors: {
      type: Object,
      required: !0
    },
    forceShow: Boolean,
    moreMenuItem: Boolean,
    additionalMenuItem: Boolean,
    moreMenuVisible: Boolean,
    isMoreMenuItem: Boolean,
    activeId: {
      type: [String, Number],
      default: null
    },
    firstItemId: {
      type: Number,
      default: 0
    },
    lastItemId: {
      type: Number,
      default: 0
    }
  },
  emits: [
    "handle-item",
    "handle-enter-event",
    "toggle-drawer",
    "navigate",
    "handle-close",
    "next-tab",
    "focus-sub-menu"
  ],
  computed: {
    isActive() {
      var e;
      return this.moreMenuItem ? this.moreMenuVisible : ((e = this.item) == null ? void 0 : e.id) === this.activeId;
    },
    iconClass() {
      return this.isActive ? "open" : void 0;
    },
    iconColor() {
      return this.isMoreMenuItem ? this.colors["--more-text-color"] : this.colors["--text-color"];
    },
    itemId() {
      return this.moreMenuItem ? "more-menu-item" : this.item ? this.item.id : "";
    },
    hasChildren() {
      var e, t;
      return !!((t = (e = this.item) == null ? void 0 : e.children) != null && t.length);
    },
    buttonTitle() {
      var e, t;
      return ((e = this.item) == null ? void 0 : e.name) || ((t = this.item) == null ? void 0 : t.translatedTitle);
    },
    hasFocusableChildren() {
      var t, n, r;
      const e = (o) => {
        var i;
        return [o, ...((i = o.children) == null ? void 0 : i.map((a) => e(a))) || []].flat();
      };
      return (r = (n = (t = this.item.children) == null ? void 0 : t.map((o) => e(o))) == null ? void 0 : n.flat()) == null ? void 0 : r.filter((o) => o.type !== "header").length;
    },
    isHeader() {
      var e;
      return ((e = this.item) == null ? void 0 : e.type) === "header";
    },
    hasSlug() {
      var e;
      return (e = this.item) == null ? void 0 : e.slug;
    },
    ariaId() {
      return this.moreMenuItem ? "menu-button-more" : `menu-button-${this.item ? this.item.id : ""}`;
    },
    ariaHasPopup() {
      return this.moreMenuItem ? "true" : this.hasChildren ? "dialog" : "false";
    },
    ariaControls() {
      return this.moreMenuItem ? "more-menu-dropdown" : this.hasChildren ? `drawer-${this.item ? this.item.id : ""}` : void 0;
    },
    ariaExpanded() {
      if (this.moreMenuItem)
        return this.moreMenuVisible ? "true" : "false";
      if (this.hasChildren)
        return this.isActive ? "true" : "false";
    }
  },
  methods: {
    handleEnterEvent(e) {
      if (this.moreMenuItem || !this.item) {
        this.$emit("handle-enter-event");
        return;
      }
      if (this.isHeader || this.additionalMenuItem || e) {
        this.$emit("toggle-drawer", this.item);
        return;
      }
      this.$emit("navigate", this.item);
    },
    handleNextTab(e, t) {
      var s, l;
      const n = e.shiftKey, r = this.isActive, o = this.activeId && r, i = ((s = this.item) == null ? void 0 : s.id) === this.firstItemId, a = ((l = this.item) == null ? void 0 : l.id) === this.lastItemId;
      if (n) {
        if (this.isMoreMenuItem && i && !t) {
          this.$emit("handle-close");
          return;
        }
        if (!this.isMoreMenuItem && r) {
          this.$emit("handle-close");
          return;
        }
        if (a && t && this.hasChildren && o) {
          this.$emit("handle-close");
          return;
        }
      } else {
        if (this.moreMenuItem) return;
        if (o && (t && this.hasFocusableChildren || this.isHeader)) {
          this.$emit("focus-sub-menu", this.item);
          return;
        }
        this.hasFocusableChildren === 0 && !this.isMoreMenuItem && r && this.$emit("handle-close"), a && (!this.hasChildren || t && this.hasChildren && !o) && this.$emit("handle-close");
      }
    }
  }
}, QV = ["id"], JV = ["aria-expanded", "aria-haspopup", "aria-controls"], eB = {
  class: "menu-item-focusable",
  tabindex: "-1"
}, tB = { class: "sr-only" }, nB = ["aria-expanded", "aria-haspopup", "aria-controls"], rB = { class: "sr-only" };
function oB(e, t, n, r, o, i) {
  const a = V("MenuElementType"), s = V("DropdownArrowIcon");
  return n.forceShow || n.moreMenuItem || n.additionalMenuItem || n.item ? (d(), f("div", {
    key: 0,
    id: i.itemId,
    ref: i.itemId,
    class: _(["bar-menu-item", {
      "menu-dropdown-item": n.isMoreMenuItem,
      "menu-item-active": !n.isMoreMenuItem && i.isActive
    }]),
    "data-testid": "menu-item",
    onMouseover: t[8] || (t[8] = W((l) => e.$emit("handle-item", n.item), ["stop", "prevent"])),
    onTouchstart: t[9] || (t[9] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
  }, [
    j(a, {
      id: i.ariaId,
      class: _(["menu-item-text", {
        "menu-dropdown-item-active": i.isActive,
        [n.theme.style]: !!n.theme.style
      }]),
      "path-prefix": n.content.pathPrefix,
      "more-menu-title": n.theme.translations.more_dropdown_title,
      "more-menu-visible": n.moreMenuVisible,
      "fill-color": n.colors["--dropdown-text-color"],
      item: n.item,
      "aria-expanded": i.ariaExpanded,
      "aria-has-popup": i.ariaHasPopup,
      "aria-controls": i.ariaControls,
      onKeydown: [
        K(i.handleEnterEvent, ["enter"]),
        t[0] || (t[0] = K((l) => i.handleNextTab(l, !1), ["tab"]))
      ],
      onTouchstart: W(i.handleEnterEvent, ["exact", "stop", "prevent"])
    }, null, 8, ["id", "class", "path-prefix", "more-menu-title", "more-menu-visible", "fill-color", "item", "aria-expanded", "aria-has-popup", "aria-controls", "onKeydown", "onTouchstart"]),
    !i.isHeader && i.hasChildren && i.itemId !== "explore-button" && i.itemId !== "schoolsbutton" ? (d(), f("button", {
      key: 0,
      class: "menu-item-icon",
      "aria-expanded": i.ariaExpanded,
      "aria-haspopup": i.ariaHasPopup,
      "aria-controls": i.ariaControls,
      onKeydown: t[1] || (t[1] = K((l) => i.handleNextTab(l, !0), ["tab"])),
      onTouchstart: t[2] || (t[2] = W((l) => i.handleEnterEvent(!0), ["exact", "stop", "prevent"])),
      onClick: t[3] || (t[3] = W((l) => i.handleEnterEvent(!0), ["stop", "prevent"]))
    }, [
      c("span", eB, [
        j(s, {
          "dropdown-class": i.iconClass,
          "fill-color": i.iconColor
        }, null, 8, ["dropdown-class", "fill-color"]),
        c("span", tB, " Show submenu for " + k(i.buttonTitle) + " button", 1)
      ])
    ], 40, JV)) : T("", !0),
    i.isHeader || n.moreMenuItem || n.additionalMenuItem ? (d(), f(J, { key: 1 }, [
      n.moreMenuItem || n.additionalMenuItem || i.hasChildren ? (d(), f("button", {
        key: 0,
        class: _(["menu-item-icon", n.item.id]),
        "aria-expanded": i.ariaExpanded,
        "aria-haspopup": i.ariaHasPopup,
        "aria-controls": i.ariaControls,
        onMouseover: t[4] || (t[4] = W(() => {
        }, ["stop", "prevent"])),
        onTouchstart: t[5] || (t[5] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"])),
        onKeydown: t[6] || (t[6] = K((l) => i.handleNextTab(l, !0), ["tab"])),
        onClick: t[7] || (t[7] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
      }, [
        n.item.id === "explore-button" ? (d(), I(Y(n.item.icon), {
          key: 0,
          "fill-color": n.item.colors["--bg-color"],
          "fill-path-color": i.iconColor
        }, null, 8, ["fill-color", "fill-path-color"])) : (d(), I(s, {
          key: 1,
          "dropdown-class": i.iconClass,
          "fill-color": i.iconColor
        }, null, 8, ["dropdown-class", "fill-color"])),
        c("span", rB, " Show submenu for " + k(n.item.name || n.item.translatedTitle), 1)
      ], 42, nB)) : T("", !0)
    ], 64)) : T("", !0)
  ], 42, QV)) : T("", !0);
}
const B3 = /* @__PURE__ */ B(XV, [["render", oB], ["__scopeId", "data-v-f89846d5"]]), iB = {
  name: "BarNavDrawer",
  components: { BarNavDrawerItem: P4 },
  mixins: [lt],
  props: {
    activeItem: {
      type: Object,
      default: void 0
    },
    currentDomain: {
      type: String,
      default: null
    },
    isMoreMenuActive: Boolean,
    isOpen: Boolean,
    isTemporarilyHideMenu: Boolean,
    isUnderlapped: Boolean
  },
  emits: ["hide-drawer", "handle-close", "prevent-close", "handle-toggle-parent", "next-tab", "navigate"],
  data() {
    return {
      activeParent: null,
      scrollWidth: !1
    };
  },
  computed: {
    orgsWithIds() {
      return this.content.organizations.map((t, n) => ge(ae({}, t), { id: n + 1 }));
    },
    itemId() {
      return `drawer-${this.activeItem.id}`;
    },
    drawerWidth() {
      return {
        "--drawer-width": this.isUnderlapped ? "100%" : "auto",
        "--left-alignment": this.isUnderlapped ? "46px" : ""
      };
    }
  },
  watch: {
    isOpen(e) {
      if (e) {
        const { scrollWidth: t, clientWidth: n } = this.$refs["drawer-wrapper"];
        t > n && (this.scrollWidth = !0);
      }
    }
  },
  methods: {
    orgLink(e) {
      return qr(e, {
        isPreview: this.content.isPreview,
        currentDomain: this.currentDomain
      });
    },
    hideDrawer() {
      this.$emit("hide-drawer");
    },
    handleNextTab({ itemId: e, isIconButton: t, isBackwardsTab: n }) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null, this.$emit("handle-toggle-parent", { itemId: e.id });
        return;
      }
      this.activeParent = e.id, this.$emit("handle-toggle-parent", { itemId: e.id });
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    }
  }
}, sB = ["id", "aria-labelledby"], aB = {
  key: 0,
  class: "menu-item-active-line"
}, lB = { key: 0 }, uB = { class: "explore-link" }, dB = ["innerHTML"], cB = ["href", "target", "onKeydown"], hB = { key: 1 }, mB = {
  key: 0,
  class: "basic-schools-dropdown"
}, fB = ["href", "target", "onKeydown"], pB = { key: 2 };
function gB(e, t, n, r, o, i) {
  const a = V("BarNavDrawerItem");
  return d(), f("div", {
    id: i.itemId,
    ref: i.itemId,
    "aria-labelledby": `menu-button-${n.activeItem.id}`,
    "aria-modal": "true",
    class: _(["bar-nav-menu--drawer", [n.activeItem.id]]),
    style: Z([i.drawerWidth, { flexDirection: o.scrollWidth ? "column" : "row" }]),
    onMouseleave: t[3] || (t[3] = W((s) => e.$emit("hide-drawer"), ["exact", "stop", "prevent"])),
    onMouseenter: t[4] || (t[4] = (s) => e.$emit("prevent-close"))
  }, [
    c("div", {
      ref: "drawer-wrapper",
      class: _(["bar-nav-menu--drawer-content-wrapper", { scrollWidth: o.scrollWidth }])
    }, [
      j(Le, { name: "slide-fade-up" }, {
        default: S(() => [
          n.isOpen ? (d(), f("div", aB)) : T("", !0)
        ]),
        _: 1
      }),
      n.activeItem.id === "explore-button" ? (d(), f("div", lB, [
        (d(!0), f(J, null, ne(e.content.customMenuItems, (s) => (d(), f("div", {
          key: s.id,
          class: "dropdown-with-icons"
        }, [
          c("div", uB, [
            c("span", {
              innerHTML: s.icon || s.icon_cms
            }, null, 8, dB),
            c("a", {
              href: i.getLink(s.url),
              style: Z({ color: e.theme.explore_menu_text_color }),
              target: i.targetWindow(s),
              onKeydown: K((l) => i.handleNextTab({ itemId: s.id, isIconButton: !1, isBackwardsTab: l.shiftKey }), ["tab"])
            }, k(s.name), 45, cB)
          ])
        ]))), 128))
      ])) : T("", !0),
      n.activeItem.id === "schoolsbutton" ? (d(), f("div", hB, [
        e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), f("ul", mB, [
          (d(!0), f(J, null, ne(i.orgsWithIds, (s) => (d(), f("li", {
            key: s.id
          }, [
            c("a", {
              href: i.orgLink(s),
              class: "school-link",
              target: i.targetWindow(s),
              onKeydown: K((l) => i.handleNextTab({ itemId: s.id, isIconButton: !0, isBackwardsTab: l.shiftKey }), ["tab"])
            }, k(s.name), 41, fB)
          ]))), 128))
        ]))
      ])) : T("", !0),
      n.activeItem.id !== "schoolsbutton" && n.activeItem.id !== "explore-button" ? (d(), f("div", pB, [
        (d(!0), f(J, null, ne(n.activeItem.children, (s) => (d(), I(a, {
          key: s.id,
          "elem-data": s,
          "theme-style": e.theme.style,
          colors: e.colors,
          "active-parent": o.activeParent,
          "path-prefix": e.content.pathPrefix,
          onToggleParent: i.handleToggleParent,
          onHandleClose: t[0] || (t[0] = (l) => e.$emit("handle-close")),
          onNextTab: t[1] || (t[1] = (l) => e.$emit("next-tab", l)),
          onNavigate: t[2] || (t[2] = (l) => e.$emit("navigate", l))
        }, null, 8, ["elem-data", "theme-style", "colors", "active-parent", "path-prefix", "onToggleParent"]))), 128))
      ])) : T("", !0)
    ], 2)
  ], 46, sB);
}
const vB = /* @__PURE__ */ B(iB, [["render", gB], ["__scopeId", "data-v-ab83e199"]]), bB = {
  name: "BarNavMenuDropdown",
  components: { BarNavItemWrapper: B3 },
  props: {
    activeId: {
      type: [String, Number],
      default: null
    },
    isVisible: Boolean,
    moreItems: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Object,
      default: null
    },
    theme: {
      type: Object,
      default: null
    },
    content: {
      type: Object,
      default: null
    }
  },
  emits: [
    "prevent-close",
    "handle-enter-event",
    "toggle-drawer",
    "navigate",
    "open-dropdown",
    "handle-close",
    "temporarily-hide-menu",
    "focus-sub-menu"
  ],
  computed: {
    ariaId() {
      return "more-menu-dropdown";
    },
    ariaLabelledBy() {
      return "menu-button-more";
    },
    ariaExpanded() {
      return this.isVisible ? "true" : "false";
    },
    lastItemId() {
      const e = (n) => {
        var r;
        return n.type !== "header" || ((r = n.children) == null ? void 0 : r.length) > 0;
      }, t = this.moreItems.findLastIndex(e);
      return this.moreItems[t].id;
    },
    firstItemId() {
      const e = (n) => {
        var r;
        return n.type !== "header" || ((r = n.children) == null ? void 0 : r.length) > 0;
      }, t = this.moreItems.findIndex(e);
      return this.moreItems[t].id;
    }
  }
}, yB = ["id", "aria-labelledby", "aria-expanded"];
function _B(e, t, n, r, o, i) {
  const a = V("BarNavItemWrapper");
  return d(), f("div", {
    id: i.ariaId,
    "aria-labelledby": i.ariaLabelledBy,
    "aria-expanded": i.ariaExpanded,
    class: "bar-nav-menu--dropdown-item-wrapper",
    onMouseleave: t[3] || (t[3] = (s) => e.$emit("prevent-close"))
  }, [
    (d(!0), f(J, null, ne(n.moreItems, (s) => (d(), f(J, null, [
      s ? (d(), I(a, {
        ref_for: !0,
        ref: `more-${s.id}`,
        key: s.id,
        item: s,
        "force-show": !0,
        "is-more-menu-item": !0,
        "first-item-id": i.firstItemId,
        "last-item-id": i.lastItemId,
        "active-id": n.activeId,
        theme: n.theme,
        content: n.content,
        colors: n.colors,
        onNavigate: (l) => e.$emit("navigate", s),
        onHandleEnterEvent: (l) => e.$emit("handle-enter-event", s),
        onHandleItem: (l) => e.$emit("open-dropdown", s),
        onToggleDrawer: t[0] || (t[0] = (l) => e.$emit("toggle-drawer", l)),
        onHandleClose: t[1] || (t[1] = (l) => e.$emit("handle-close")),
        onFocusSubMenu: t[2] || (t[2] = (l) => e.$emit("focus-sub-menu", l))
      }, null, 8, ["item", "first-item-id", "last-item-id", "active-id", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleItem"])) : T("", !0)
    ], 64))), 256))
  ], 40, yB);
}
const CB = /* @__PURE__ */ B(bB, [["render", _B], ["__scopeId", "data-v-33993d03"]]), wB = {
  name: "M5",
  components: {
    BarNavItemWrapper: B3,
    BarNavDrawer: vB,
    BarNavMoreDropdown: CB,
    CMSSchoolsMenu: hr,
    MenuItem: xt
  },
  mixins: [M4, lt],
  emits: ["toggle-search"],
  computed: {
    moreBtnWidth() {
      var e, t;
      return ((t = (e = this.$refs) == null ? void 0 : e["more-wrapper"]) == null ? void 0 : t.clientWidth) || 10;
    },
    exploreButton() {
      var e, t, n, r;
      return {
        id: "explore-button",
        ref: "explore-button",
        class: ["explore", "button-action", "menu", this.theme.style],
        dataTestId: "explore-button",
        ariaExpanded: this.exploreMenuVisible,
        ariaControls: this.exploreMenuVisible ? "explore-menu" : null,
        children: this.content.customMenuItems,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.menu_dropdown_title) || ((n = (t = this.theme.translations) == null ? void 0 : t.header) == null ? void 0 : n.explore_dropdown_title) || "Explore",
        icon: this.theme.menu_icon === "plus" ? "PlusIcon" : "HamburgerIcon",
        colors: {
          "--fill-color": ((r = this.theme.navigation_color) == null ? void 0 : r.hex) || "#000000",
          "--fill-path-color": this.theme.navigation_icon_color.hex,
          "--bg-color": this.theme.bg_color.hex,
          "--dropdown-class": this.exploreMenuVisible ? "open" : "close",
          "--nav-color": this.theme.navigation_color.hex
        }
      };
    },
    schoolsButton() {
      var e;
      return {
        id: "schoolsbutton",
        ref: "schoolsbutton",
        class: ["schools", "button-action", "menu", this.theme.style],
        dataTestId: "schools-button",
        ariaExpanded: this.isSchoolDropdownVisible || this.customSchoolsMenuVisible,
        ariaControls: this.isSchoolDropdownVisible || this.customSchoolsMenuVisible ? "schools-menu-sm1" : null,
        icon: "FilledDropdownArrow",
        translatedTitle: this.content.orgDropdownTitle || "Schools",
        children: this.orgsWithIds,
        colors: {
          "--fill-color": ((e = this.theme.navigation_color) == null ? void 0 : e.hex) || "#000000",
          "--fill-path-color": this.theme.navigation_icon_color.hex,
          "--bg-color": this.theme.bg_color.hex,
          "--dropdown-class": this.isSchoolDropdownVisible || this.customSchoolsMenuVisible ? "open" : "close",
          "--nav-color": this.theme.navigation_color.hex
        }
      };
    },
    orgsWithIds() {
      return this.content.organizations.map((t, n) => ge(ae({}, t), { id: n + 1 }));
    }
  },
  methods: {
    isUnderlapped(e) {
      return e === null ? void 0 : !!this.underLappedItems.find((n) => n.id === e);
    },
    closeCustomSchoolsMenu() {
      this.customSchoolsMenuVisible = !1, this.handleClose();
    }
  }
}, TB = { class: "bar-nav-menu--align-right" }, kB = {
  ref: "bar-nav-item-wrapper",
  class: "bar-nav-item-wrapper"
}, EB = {
  class: "options-wrapper",
  "data-testid": "options-wrapper"
}, SB = {
  class: "options-wrapper",
  "data-testid": "options-wrapper"
}, MB = {
  ref: "more-wrapper",
  class: "bar-dropdown-more-wrapper"
}, AB = {
  ref: "bar-end-options",
  class: "bar-end-options"
}, IB = ["href"];
function LB(e, t, n, r, o, i) {
  const a = V("BarNavItemWrapper"), s = V("BarNavDrawer"), l = V("CMSSchoolsMenu"), u = V("BarNavMoreDropdown"), m = V("MenuItem"), v = Ke("click-away");
  return d(), f("div", {
    id: "m5",
    style: Z(e.colors),
    class: _(["bar-nav-menu", { "is-i-frame": e.content.isIFrame }])
  }, [
    c("div", {
      ref: "bar-nav-menu-bar",
      class: "bar-nav-menu-bar",
      onMouseleave: t[21] || (t[21] = (g) => e.mouseLeaveMenu()),
      onMouseenter: t[22] || (t[22] = (g) => e.mouseEnterMenu())
    }, [
      c("div", TB, [
        we((d(), f("div", kB, [
          c("div", EB, [
            j(a, {
              item: i.exploreButton,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              "additional-menu-item": "",
              onNavigate: e.navigate,
              onHandleItem: t[0] || (t[0] = (g) => e.showItem(i.exploreButton)),
              onToggleDrawer: t[1] || (t[1] = (g) => e.handleDrawerToggle(i.exploreButton)),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
            j(Le, { name: "slide-fade-up" }, {
              default: S(() => [
                e.activeItem && e.activeItem.id === i.exploreButton.id ? (d(), I(s, {
                  key: 0,
                  ref: `drawer-${i.exploreButton.id}`,
                  "active-item": i.exploreButton,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === i.exploreButton.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: t[2] || (t[2] = (g) => e.navigate(g)),
                  onHideDrawer: t[3] || (t[3] = (g) => e.hideDrawer("mouseleave")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[4] || (t[4] = (g) => e.preventClose(e.activeItem)),
                  onNextTab: t[5] || (t[5] = (g) => e.nextTabAction(g, "exploreButton"))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "onHandleToggleParent", "onHandleClose"])) : T("", !0)
              ]),
              _: 1
            })
          ]),
          c("div", SB, [
            j(a, {
              item: i.schoolsButton,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              "additional-menu-item": "",
              onNavigate: e.navigate,
              onHandleItem: t[6] || (t[6] = (g) => e.showItem(i.schoolsButton)),
              onToggleDrawer: t[7] || (t[7] = (g) => e.handleDrawerToggle(i.schoolsButton)),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
            j(Le, { name: "slide-fade-up" }, {
              default: S(() => [
                e.activeItem && e.activeItem.id === i.schoolsButton.id & !e.content.hasCustomSchoolsMenu ? (d(), I(s, {
                  key: 0,
                  ref: "drawer-schoolsbutton",
                  "active-item": i.schoolsButton,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === i.schoolsButton.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: e.navigate,
                  onHideDrawer: t[8] || (t[8] = (g) => e.hideDrawer("mouseleave")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[9] || (t[9] = (g) => e.preventClose(e.activeItem)),
                  onNextTab: t[10] || (t[10] = (g) => e.nextTabAction(g, "schoolsButton"))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "onHandleToggleParent", "onNavigate", "onHandleClose"])) : T("", !0)
              ]),
              _: 1
            }),
            j(Le, { name: "slide" }, {
              default: S(() => [
                e.content.hasCustomSchoolsMenu ? (d(), I(l, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  role: "menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: i.closeCustomSchoolsMenu,
                  onMouseleave: i.closeCustomSchoolsMenu
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview", "onFocusLost", "onMouseleave"])) : T("", !0)
              ]),
              _: 1
            })
          ]),
          (d(!0), f(J, null, ne(e.content.sitemapMenuItems, (g) => (d(), f("div", {
            key: g.id,
            class: "options-wrapper",
            "data-testid": "options-wrapper"
          }, [
            we(j(a, {
              item: g,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              onNavigate: e.navigate,
              onHandleEnterEvent: e.handleClose,
              onHandleItem: (h) => e.showItem(g),
              onToggleDrawer: (h) => e.handleDrawerToggle(g),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleItem", "onToggleDrawer", "onHandleClose"]), [
              [Un, e.visibleItems.find(({ id: h }) => h === g.id)]
            ]),
            j(Le, { name: "slide-fade-up" }, {
              default: S(() => [
                we(j(s, {
                  ref_for: !0,
                  ref: `drawer-${g.id}`,
                  "active-item": g,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === g.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  "is-underlapped": i.isUnderlapped(e.activeItem && e.activeItem.id),
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: e.navigate,
                  onHideDrawer: t[11] || (t[11] = (h) => e.hideDrawer("hide-drawer")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[12] || (t[12] = (h) => e.preventClose(e.activeItem)),
                  onNextTab: t[13] || (t[13] = (h) => e.nextTabAction(h))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "is-underlapped", "onHandleToggleParent", "onNavigate", "onHandleClose"]), [
                  [Un, e.activeItem && e.activeItem.id === g.id && g.children.length > 0]
                ])
              ]),
              _: 2
            }, 1024)
          ]))), 128))
        ])), [
          [v, e.hideDrawer]
        ]),
        we(c("div", MB, [
          j(a, {
            class: "bar-dropdown-button",
            "more-menu-item": "",
            "more-menu-visible": e.isMoreDropdownVisible,
            "force-show": "",
            theme: e.theme,
            item: { name: "more", children: [], id: "more" },
            content: e.content,
            colors: e.colors,
            onNavigate: e.navigate,
            onHandleEnterEvent: t[14] || (t[14] = (g) => e.isMoreDropdownVisible = !e.isMoreDropdownVisible),
            onHandleClose: e.hideMoreMenu,
            onHandleItem: t[15] || (t[15] = (g) => {
              e.handleMoreMenuToggle(e.isMoreDropdownVisible), e.hideDrawer();
            })
          }, null, 8, ["more-menu-visible", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
          j(Le, { name: "slide-fade-up" }, {
            default: S(() => [
              e.underLappedItems && e.isMoreDropdownVisible ? we((d(), I(u, {
                key: 0,
                ref: "moreDropdown",
                "active-id": e.activeItem ? e.activeItem.id : null,
                "is-visible": e.isMoreDropdownVisible,
                "more-items": e.underLappedItems,
                theme: e.theme,
                content: e.content,
                colors: e.colors,
                onNavigate: e.navigate,
                onHandleEnterEvent: e.handleClose,
                onOpenDropdown: t[16] || (t[16] = (g) => e.handleDropdownMenuOpen(g)),
                onToggleDrawer: t[17] || (t[17] = (g) => e.handleDrawerToggle(g)),
                onPreventClose: t[18] || (t[18] = (g) => e.preventClose(e.activeItem)),
                onHandleClose: e.handleClose,
                onFocusSubMenu: t[19] || (t[19] = (g) => e.focusSubMenu(g)),
                onTemporarilyHideMenu: e.temporalHide
              }, null, 8, ["active-id", "is-visible", "more-items", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleClose", "onTemporarilyHideMenu"])), [
                [v, e.hideMoreMenu]
              ]) : T("", !0)
            ]),
            _: 1
          })
        ], 512), [
          [Un, e.displayMoreButton]
        ])
      ]),
      c("div", AB, [
        !e.isMobile || !e.content.newMobileHeader ? (d(), I(m, {
          key: 0,
          item: "searchbutton",
          theme: e.theme,
          content: e.content,
          onToggleSearch: t[20] || (t[20] = (g) => e.$emit("toggle-search"))
        }, null, 8, ["theme", "content"])) : T("", !0),
        e.showSignInButton ? (d(), f("a", {
          key: 1,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank"
        }, k(e.signInText), 9, IB)) : T("", !0)
      ], 512)
    ], 544)
  ], 6);
}
const DB = /* @__PURE__ */ B(wB, [["render", LB], ["__scopeId", "data-v-8b4a97d0"]]), $B = {
  name: "CmsHeader",
  components: {
    /* eslint-disable vue/no-reserved-component-names */
    H1: rD,
    H2: TD,
    H3: SD,
    H4: C$,
    H5: z$,
    H6: CO,
    H7: FO,
    H8: tP,
    /* eslint-enable vue/no-reserved-component-names */
    Custom: YV,
    M4: M0,
    M5: DB
  },
  mixins: [Rt],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      validator(e) {
        const t = Object.keys(e);
        return [
          "customMenuItems",
          "globals",
          "hasCustomSchoolsMenu",
          "hasGalleryImages",
          "isIFrame",
          "isEditing",
          "isPreview",
          "isSearchOpen",
          "langCode",
          "langText",
          "languages",
          "menuOptions",
          "newMobileHeader",
          "orgDropdownTitle",
          "orgMenuContent",
          "organizations",
          "pathPrefix",
          "showMenu",
          "sitemapMenuItems",
          "iconLinks",
          "translations",
          "utilities"
        ].every((r) => t.includes(r));
      },
      type: Object,
      required: !0
    },
    isHomepage: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    currentDomain: {
      type: String,
      default: null
    },
    mediaSubdomain: {
      type: String,
      default: ""
    }
  },
  emits: [
    "toggle-mobile-menu",
    "toggle-menu",
    "toggle-search",
    "language-change",
    "close-menu",
    "update:utilities",
    "update:icon-links"
  ],
  data() {
    return {
      headerShouldShrink: !1,
      headerOffsetHeight: 0,
      headerClientHeight: 218,
      ticking: !1,
      debouncedToggleStickyHeaderAdj: () => {
      },
      debouncedCalculateHeaderHeight: () => {
      }
    };
  },
  computed: {
    customSchoolsMenu() {
      return this.content.hasCustomSchoolsMenu || this.theme.custom_schools_dropdown;
    },
    cmsHeaderStickyStyles() {
      const e = this.content.isPreview || !this.headerShouldBeSticky ? 0 : this.headerOffsetHeight, t = this.theme.version === "H3" && !this.isMobile && this.isHomepage && this.content.hasGalleryImages, n = this.theme.version === "H4" && !this.isMobile && this.isHomepage && this.content.hasGalleryImages;
      return {
        paddingBottom: `${e}px`,
        "--header-position": t || n ? "absolute" : "relative",
        "--header-width": t || n ? "100%" : "auto"
      };
    },
    headerShouldBeSticky() {
      var e;
      return ((e = this.theme) == null ? void 0 : e.sticky_header) && this.headerShouldShrink && !this.content.isIFrame;
    },
    // Used only to toggle settings in cms-v2-components example
    themeSettingsToWatch() {
      var e;
      return `${this.theme.version}${(e = this.theme) == null ? void 0 : e.sticky_header}`;
    },
    isBarNavEnabled() {
      var e, t;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4" || ((t = this.content.menuOptions) == null ? void 0 : t.version) === "M5";
    },
    menuOptions() {
      return ge(ae(ae({}, this.theme), this.content.menuOptions), {
        translations: this.theme.translations || this.content.menuOptions.translations,
        headerHeight: this.headerClientHeight
      });
    },
    showMenuV4() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4" && !this.isMobile && !["Custom", "H5"].includes(this.theme.version);
    },
    showMenuV5() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M5" && !this.isMobile && !["Custom", "H5"].includes(this.theme.version);
    },
    isMobile() {
      var t;
      if (!this.screenSize)
        return !1;
      let e = this.isBarNavEnabled ? 1023 : 960;
      return ((t = this.content.menuOptions) == null ? void 0 : t.version) === "M6" ? this.screenSize <= 600 : (["H5", "H6"].includes(this.theme.version) && (e = 600), this.screenSize <= e);
    },
    showSignInButton() {
      return !!(this.theme.show_sign_in_button && (this.mediaSubdomain || this.content.isPreview));
    },
    signInUrl() {
      return `https://${this.mediaSubdomain}.id.thrillshare.com`;
    },
    H3gradient() {
      var e;
      return {
        "--bg-color": this.theme.version === "H3" ? this.theme.bg_color.hex : "",
        "--background-opacity": `${(e = this.theme.background_opacity) != null ? e : "80"}%`
      };
    }
  },
  watch: {
    themeSettingsToWatch() {
      this.calculateHeaderHeight();
    }
  },
  mounted() {
    this.$nextTick(() => this.calculateHeaderHeight()), this.debouncedToggleStickyHeaderAdj = mo(this.toggleStickyHeaderAdjustments, 10), this.debouncedCalculateHeaderHeight = mo(this.calculateHeaderHeight, 100), window.addEventListener("scroll", this.debouncedToggleStickyHeaderAdj), window.addEventListener("resize", this.debouncedCalculateHeaderHeight);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.debouncedToggleStickyHeaderAdj), window.removeEventListener("resize", this.debouncedCalculateHeaderHeight);
  },
  methods: {
    toggleStickyHeaderAdjustments() {
      !this.theme.sticky_header || this.content.isIFrame || this.ticking || (this.ticking = !0, window.requestAnimationFrame(() => {
        const e = window.scrollY > this.$refs.headerWrapper.offsetHeight;
        e !== this.headerShouldShrink && (this.headerShouldShrink = e), this.ticking = !1;
      }));
    },
    async calculateHeaderHeight() {
      if (await this.$nextTick(), this.$refs.headerWrapper) {
        const e = this.$refs.headerWrapper, t = e.clientHeight, n = e.offsetHeight, r = this.isBarNavEnabled && this.screenSize > 1024 ? 54 : 0;
        this.headerOffsetHeight = n + r, t > 0 && t !== this.headerClientHeight && (this.headerClientHeight = t);
      }
    }
  }
};
function OB(e, t, n, r, o, i) {
  const a = V("M4"), s = V("M5");
  return d(), f("div", {
    id: "cms-header",
    ref: "cmsHeader",
    class: "cms-header",
    style: Z(i.cmsHeaderStickyStyles)
  }, [
    c("div", {
      ref: "headerWrapper",
      class: _(["header-bar-wrapper", [i.headerShouldBeSticky ? "sticky" : ""]]),
      style: Z(i.H3gradient)
    }, [
      (d(), I(Y(n.theme.version), {
        ref: "header",
        theme: n.theme,
        content: n.content,
        "should-shrink": o.headerShouldShrink,
        "should-be-sticky": i.headerShouldBeSticky,
        "is-mobile": i.isMobile,
        "is-homepage": n.isHomepage,
        "wrapper-component": n.wrapperComponent,
        "wrapper-props": n.wrapperProps,
        "show-sign-in-button": i.showSignInButton,
        "sign-in-url": i.signInUrl,
        onToggleMenu: t[0] || (t[0] = (l) => e.$emit("toggle-menu", l)),
        onToggleMobileMenu: t[1] || (t[1] = (l) => e.$emit("toggle-mobile-menu", l)),
        onCloseMenu: t[2] || (t[2] = (l) => e.$emit("close-menu")),
        onLanguageChange: t[3] || (t[3] = (l) => e.$emit("language-change", l)),
        onToggleSearch: t[4] || (t[4] = (l) => e.$emit("toggle-search")),
        "onUpdate:utilities": t[5] || (t[5] = (l) => e.$emit("update:utilities", l)),
        "onUpdate:iconLinks": t[6] || (t[6] = (l) => e.$emit("update:icon-links", l))
      }, {
        utility: S(({ idx: l }) => [
          M(e.$slots, "utility", { idx: l }, void 0, !0)
        ]),
        iconLink: S(({ idx: l }) => [
          M(e.$slots, "iconLink", { idx: l }, void 0, !0)
        ]),
        _: 3
      }, 40, ["theme", "content", "should-shrink", "should-be-sticky", "is-mobile", "is-homepage", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url"])),
      i.showMenuV4 ? (d(), I(a, {
        key: 0,
        theme: i.menuOptions,
        content: n.content,
        "is-mobile": i.isMobile,
        "is-preview": n.content.isPreview,
        onCloseMenu: t[7] || (t[7] = (l) => e.$emit("close-menu"))
      }, null, 8, ["theme", "content", "is-mobile", "is-preview"])) : T("", !0),
      i.showMenuV5 ? (d(), I(s, {
        key: 1,
        theme: i.menuOptions,
        content: n.content,
        "current-domain": n.currentDomain,
        "show-sign-in-button": i.showSignInButton,
        "sign-in-url": i.signInUrl,
        onCloseMenu: t[8] || (t[8] = (l) => e.$emit("toggle-menu", !1)),
        onToggleSearch: t[9] || (t[9] = (l) => e.$emit("toggle-search"))
      }, null, 8, ["theme", "content", "current-domain", "show-sign-in-button", "sign-in-url"])) : T("", !0)
    ], 6)
  ], 4);
}
const PB = /* @__PURE__ */ B($B, [["render", OB], ["__scopeId", "data-v-34cc8f5d"]]), j3 = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
function x0(e) {
  return e.replace(j3, (t, n, r, o) => "#" + n + n + r + r + o + o).substring(1).match(/.{2}/g).map((t) => parseInt(t, 16));
}
function Rf(e, t = 1) {
  return [...e.replace(j3, (r, o, i, a) => "#" + o + o + i + i + a + a).substring(1).match(/.{2}/g).map((r) => parseInt(r, 16)), t].join(",");
}
const NB = {
  name: "M1",
  mixins: [$s],
  props: {
    isActive: Boolean
  },
  emits: ["close-menu"],
  data() {
    return {
      parentList: null,
      childList: null,
      grandchildList: null
    };
  },
  computed: {
    columns() {
      if (!this.content.sitemapMenuItems || this.content.sitemapMenuItems.length < 1) return [];
      const e = 3, t = new Array(e).fill(null).map(() => []);
      let n = 0;
      return this.content.sitemapMenuItems.forEach((r) => {
        n > e - 1 && (n = 0), t[n].push(r), n += 1;
      }), t;
    },
    mainMenuRGBColor() {
      const [e, t, n] = x0(this.theme.bg_color.hex);
      return `rgba(${e}, ${t}, ${n}, .96)`;
    }
  },
  mounted() {
    this.$refs.mainmenu.focus();
  },
  methods: {
    handleTabOnCloseButton() {
      this.$refs.mainmenu.focus();
    },
    handleShiftTabOnCloseButton(e) {
      e === 0 && this.$refs["close-menu-button"].focus();
    },
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    },
    isSubMenuExpanded(e) {
      return this.activeIds.includes(e.id);
    },
    closeDropdownOnChildReverse(e, t, n) {
      e.id === n[0].id && this.toggleOpen(t.id, !1);
    },
    closeDropdownOnParentReverse(e, t) {
      e && this.toggleOpen(t.id, !1);
    },
    checkForExpandedMenu(e, t, n, r) {
      if (!e) {
        const o = r.length - 1;
        t.id === r[o].id && this.toggleOpen(n.id, !0);
      }
    },
    closeDropdownOnLastGrandchild(e, t, n) {
      const r = n.length - 1, o = t.length - 1, i = n[r].children[o].id;
      e.id === i && this.toggleOpen(e.id, !0);
    },
    closeDropdownOnLastChild(e, t) {
      const n = t.length - 1;
      e.id === t[n].id && e.children.length === 0 && this.toggleOpen(e.id, !0);
    }
  }
}, HB = {
  id: "m1",
  "data-testid": "m1"
}, FB = { "data-testid": "heading" }, RB = { class: "content" }, VB = { class: "static-links" }, BB = ["onKeydown"], jB = ["id", "target", "href"], UB = ["innerHTML"], qB = {
  key: 0,
  class: "generated-links"
}, GB = ["onMouseover"], KB = ["onKeydown"], zB = ["id", "aria-expanded", "aria-controls", "aria-describedby", "onKeydown", "onClick"], ZB = ["onKeydown", "onClick"], xB = ["id", "aria-expanded", "aria-controls", "aria-describedby"], WB = ["id", "aria-labelledby"], YB = ["onMouseover"], XB = ["onKeydown"], QB = ["onKeydown", "onClick"], JB = ["id", "aria-expanded", "aria-controls", "aria-describedby"], ej = ["id", "aria-labelledby"], tj = ["onMouseover", "onKeydown"], nj = ["onKeydown"], rj = {
  class: "button-action-content",
  tabindex: "-1"
}, oj = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, ij = ["fill"], sj = ["fill"];
function aj(e, t, n, r, o, i) {
  const a = V("MenuElement");
  return d(), f("div", HB, [
    c("div", {
      id: "mainmenu",
      ref: "mainmenu",
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      tabindex: "0",
      style: Z(`background: ${i.mainMenuRGBColor}`),
      onKeydown: [
        t[9] || (t[9] = K(W((s) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"])),
        t[10] || (t[10] = K(W(() => {
        }, ["exact", "prevent"]), ["space"])),
        t[11] || (t[11] = K(W(() => {
        }, ["exact", "prevent"]), ["up"])),
        t[12] || (t[12] = K(W(() => {
        }, ["exact", "prevent"]), ["down"]))
      ]
    }, [
      c("div", {
        style: Z(`color: ${e.theme.l1_text_color.hex || "#dddddd"};`),
        class: "heading",
        "data-testid": "heading-color"
      }, [
        c("h2", FB, k(e.translations.title), 1)
      ], 4),
      c("div", RB, [
        c("div", VB, [
          c("ul", null, [
            (d(!0), f(J, null, ne(e.content.customMenuItems, (s, l) => (d(), f("li", {
              key: s.id,
              "data-testid": "static-link",
              onKeydown: [
                K(W((u) => e.clickStaticLink(e.getLink(s.url)), ["exact", "prevent"]), ["space"]),
                K(W((u) => i.handleShiftTabOnCloseButton(l), ["shift", "exact"]), ["tab"])
              ]
            }, [
              c("a", {
                id: s.id,
                style: Z(`color: ${e.theme.icon_text_color.hex};`),
                target: s.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(s.url),
                onClick: t[0] || (t[0] = (u) => e.$emit("close-menu"))
              }, [
                c("div", null, [
                  c("div", {
                    class: _(["link-image", { "global-icon": s.cms_icon_id }]),
                    style: Z(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    c("div", {
                      class: "menu-item-icon",
                      "data-testid": "m1-icon-color",
                      style: Z(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: s.cms_icon_id ? s.icon_cms : s.icon
                    }, null, 12, UB)
                  ], 6),
                  c("span", {
                    "data-testid": "m1-icon-text",
                    style: Z(`color: ${e.theme.icon_text_color.hex};`)
                  }, k(s.name), 5)
                ])
              ], 12, jB)
            ], 40, BB))), 128))
          ])
        ]),
        i.columns.length ? (d(), f("div", qB, [
          c("ul", null, [
            (d(!0), f(J, null, ne(e.content.sitemapMenuItems, (s, l) => (d(), f("li", {
              key: `parent-${l}`,
              "data-testid": "generated-link",
              class: _({
                "has-child": s.children.length,
                open: e.activeIds.includes(s.id)
              }),
              style: Z(
                o.parentList === l ? { color: e.theme.l1_text_hover_color.hex } : { color: e.theme.l1_text_color.hex }
              ),
              onMouseover: (u) => i.setHoverColor("parentList", l),
              onMouseleave: t[6] || (t[6] = (u) => i.removeHoverColor("parentList"))
            }, [
              c("span", {
                class: "parent-menu-element-wrapper",
                onKeydown: [
                  K(W((u) => e.clickGeneratedLink(s, !0), ["exact", "prevent"]), ["enter"]),
                  K(W((u) => e.clickGeneratedLink(s, !0), ["exact", "prevent"]), ["space"])
                ]
              }, [
                j(a, {
                  id: `${s.slug || s.id}-${s.type}`,
                  element: s,
                  "toggle-fn": e.toggleOpen,
                  "path-prefix": e.content.pathPrefix,
                  "is-parent": "",
                  "cursor-pointer": "",
                  onRouterLinkClick: t[1] || (t[1] = (u) => e.$emit("close-menu"))
                }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
              ], 40, KB),
              s.children.length ? (d(), f("span", {
                key: 0,
                id: `${s.slug || s.id}-${s.type}-parent-button`,
                role: "button",
                tabindex: "-1",
                "aria-expanded": !!e.activeIds.includes(s.id),
                "aria-haspopup": "true",
                "aria-controls": `${s.slug || s.id}-${s.type}-child-list`,
                "aria-label": "Toggle Submenu",
                "aria-describedby": `${s.slug || s.id}-${s.type}`,
                onKeydown: [
                  K(W((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["enter"]),
                  K(W((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["space"])
                ],
                onClick: (u) => e.toggleOpen(s.id, !0)
              }, null, 40, zB)) : T("", !0),
              s.children.length ? (d(), f("span", {
                key: 1,
                class: "arrow-box",
                tabindex: "0",
                onKeydown: [
                  K(W((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["enter"]),
                  K(W((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["space"]),
                  K(W((u) => i.closeDropdownOnParentReverse(e.activeIds.includes(s.id), s), ["shift", "exact"]), ["tab"])
                ],
                onClick: (u) => e.toggleOpen(s.id, !0)
              }, [
                c("span", {
                  id: `${s.slug || s.id}-${s.type}-parent-button`,
                  role: "button",
                  class: "parent-arrow",
                  tabindex: "-1",
                  "aria-expanded": !!e.activeIds.includes(s.id),
                  "aria-haspopup": "true",
                  "aria-controls": `${s.slug || s.id}-${s.type}-child-list`,
                  "aria-label": "Toggle Submenu",
                  "aria-describedby": `${s.slug || s.id}-${s.type}`
                }, null, 8, xB)
              ], 40, ZB)) : T("", !0),
              c("div", {
                class: "dropdown",
                style: Z(`background: ${e.theme.l2_bg_color.hex || "#000000"};`)
              }, [
                s.children.length ? (d(), f("ul", {
                  key: 0,
                  id: `${s.slug || s.id}-${l}-child-list`,
                  "aria-labelledby": `${s.slug || s.id}-${s.type}-parent-button`
                }, [
                  (d(!0), f(J, null, ne(s.children, (u, m) => (d(), f("li", {
                    key: `child-${m}`,
                    style: Z(
                      o.childList === m ? { color: e.theme.l2_text_hover_color.hex } : { color: e.theme.l2_text_color.hex }
                    ),
                    class: _({
                      "has-child": u.children.length,
                      open: e.activeIds.includes(u.id)
                    }),
                    onMouseover: (v) => i.setHoverColor("childList", m),
                    onMouseleave: t[5] || (t[5] = (v) => i.removeHoverColor("childList"))
                  }, [
                    c("span", {
                      class: "child-menu-element-wrapper",
                      onKeydown: [
                        K(W((v) => e.clickGeneratedLink(u, !1), ["exact", "prevent"]), ["enter"]),
                        K(W((v) => e.clickGeneratedLink(u, !1), ["exact", "prevent"]), ["space"]),
                        K(W((v) => i.closeDropdownOnChildReverse(u, s, s.children), ["shift", "exact"]), ["tab"]),
                        K(W((v) => i.closeDropdownOnLastChild(u, s.children), ["exact"]), ["tab"])
                      ]
                    }, [
                      j(a, {
                        id: `${u.slug || u.id}-${u.type}`,
                        element: u,
                        "toggle-fn": e.toggleOpen,
                        "path-prefix": e.content.pathPrefix,
                        "is-sub-parent": "",
                        onRouterLinkClick: t[2] || (t[2] = (v) => e.$emit("close-menu"))
                      }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
                    ], 40, XB),
                    u.children.length ? (d(), f("span", {
                      key: 0,
                      class: "arrow-box",
                      tabindex: "0",
                      onKeydown: [
                        K(W((v) => e.toggleOpen(u.id, !1), ["exact", "prevent"]), ["enter"]),
                        K(W((v) => e.toggleOpen(u.id, !1), ["exact", "prevent"]), ["space"]),
                        K(W((v) => i.checkForExpandedMenu(i.isSubMenuExpanded(u), u, s, s.children), ["exact"]), ["tab"])
                      ],
                      onClick: (v) => e.toggleOpen(u.id, !1)
                    }, [
                      c("span", {
                        id: `${u.slug || u.id}-${u.type}-child-button`,
                        class: "child-arrow",
                        role: "button",
                        tabindex: "-1",
                        "aria-expanded": !!e.activeIds.includes(u.id),
                        "aria-haspopup": "true",
                        "aria-controls": `${u.slug || u.id}-${m}-grandchild-list`,
                        "aria-label": "Toggle Submenu",
                        "aria-describedby": `${u.slug || u.id}-${u.type}`
                      }, null, 8, JB)
                    ], 40, QB)) : T("", !0),
                    u.children.length ? (d(), f("ul", {
                      key: 1,
                      id: `${u.slug || u.id}-${m}-grandchild-list`,
                      "aria-labelledby": `${u.slug || u.id}-${u.type}-child-button`,
                      style: Z(`border-left: 1px solid ${e.theme.l2_text_color.hex}`)
                    }, [
                      (d(!0), f(J, null, ne(u.children, (v, g) => (d(), f("li", {
                        key: `grandchild-${g}`,
                        style: Z(
                          o.grandchildList === g ? { color: e.theme.l2_text_hover_color.hex } : { color: e.theme.l2_text_color.hex }
                        ),
                        onMouseover: (h) => i.setHoverColor("grandchildList", g),
                        onMouseleave: t[4] || (t[4] = (h) => i.removeHoverColor("grandchildList")),
                        onKeydown: K(W((h) => i.closeDropdownOnLastGrandchild(v, u.children, s.children), ["exact"]), ["tab"])
                      }, [
                        c("span", {
                          class: "grandchild-menu-element-wrapper",
                          onKeydown: [
                            K(W((h) => e.clickGeneratedLink(v, !1), ["exact", "prevent"]), ["enter"]),
                            K(W((h) => e.clickGeneratedLink(v, !1), ["exact", "prevent"]), ["space"])
                          ]
                        }, [
                          j(a, {
                            id: `${v.slug || v.id}-${v.type}`,
                            element: v,
                            "path-prefix": e.content.pathPrefix,
                            onRouterLinkClick: t[3] || (t[3] = (h) => e.$emit("close-menu"))
                          }, null, 8, ["id", "element", "path-prefix"])
                        ], 40, nj)
                      ], 44, tj))), 128))
                    ], 12, ej)) : T("", !0)
                  ], 46, YB))), 128))
                ], 8, WB)) : T("", !0)
              ], 4)
            ], 46, GB))), 128))
          ])
        ])) : T("", !0)
      ]),
      c("button", {
        ref: "close-menu-button",
        "data-testid": "close-menu-button",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[7] || (t[7] = (s) => e.$emit("close-menu")),
        onKeydown: t[8] || (t[8] = K(W((...s) => i.handleTabOnCloseButton && i.handleTabOnCloseButton(...s), ["exact", "prevent"]), ["tab"]))
      }, [
        c("div", rj, [
          (d(), f("svg", oj, [
            c("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.l1_text_color.hex,
              "fill-rule": "evenodd"
            }, [
              c("g", {
                id: "close_modal_icon",
                fill: e.theme.l1_text_color.hex
              }, t[13] || (t[13] = [
                c("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, sj)
            ], 8, ij)
          ]))
        ])
      ], 544)
    ], 36)
  ]);
}
const lj = /* @__PURE__ */ B(NB, [["render", aj], ["__scopeId", "data-v-0d979078"]]), uj = {
  name: "M2",
  mixins: [$s],
  emits: ["close-menu"],
  data() {
    return {
      sectionList: null,
      parentList: null,
      childList: null
    };
  },
  computed: {
    mainMenuRGBColor() {
      const [e, t, n] = x0(this.theme.bg_color.hex);
      return `rgba(${e}, ${t}, ${n}, .96)`;
    }
  },
  mounted() {
    this.$refs.mainmenu.focus();
  },
  methods: {
    handleTabOnCloseButton() {
      this.$refs.mainmenu.focus();
    },
    handleShiftTabOnCloseButton(e) {
      e === 0 && this.$refs.closeButton.focus();
    },
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    }
  }
}, dj = { id: "m2" }, cj = { class: "content" }, hj = { class: "static-links" }, mj = ["onKeydown"], fj = ["id", "target", "href"], pj = ["innerHTML"], gj = { class: "generated-links" }, vj = ["onKeydown", "onMouseover"], bj = ["id", "aria-labelledby"], yj = ["onMouseover"], _j = ["id", "aria-expanded", "aria-controls", "tabindex", "onKeydown", "onMousedown"], Cj = ["fill"], wj = ["fill", "stroke"], Tj = ["fill", "stroke"], kj = ["tabindex", "aria-controls", "aria-expanded", "aria-label", "onKeydown", "onClick"], Ej = ["id", "aria-labelledby"], Sj = ["onMouseover"], Mj = ["onKeydown"], Aj = {
  class: "button-action-content",
  tabindex: "-1"
}, Ij = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, Lj = ["fill"], Dj = ["fill"];
function $j(e, t, n, r, o, i) {
  const a = V("MenuElement");
  return d(), f("div", dj, [
    c("div", {
      id: "mainmenu",
      ref: "mainmenu",
      style: Z(`background: ${i.mainMenuRGBColor}`),
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      tabindex: "0",
      onKeydown: [
        t[7] || (t[7] = K(W((s) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"])),
        t[8] || (t[8] = K(W(() => {
        }, ["exact", "prevent"]), ["space"])),
        t[9] || (t[9] = K(W(() => {
        }, ["exact", "prevent"]), ["up"])),
        t[10] || (t[10] = K(W(() => {
        }, ["exact", "prevent"]), ["down"]))
      ]
    }, [
      c("div", cj, [
        c("div", hj, [
          c("ul", null, [
            (d(!0), f(J, null, ne(e.content.customMenuItems, (s, l) => (d(), f("li", {
              key: s.id,
              onKeydown: [
                K(W((u) => e.clickStaticLink(e.getLink(s.url)), ["exact", "prevent"]), ["space"]),
                K(W((u) => i.handleShiftTabOnCloseButton(l), ["shift", "exact"]), ["tab"])
              ]
            }, [
              c("a", {
                id: s.id,
                style: Z(`color: ${e.theme.icon_text_color.hex};`),
                target: s.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(s.url)
              }, [
                c("div", null, [
                  c("div", {
                    class: _(["link-image", { "global-icon": s.cms_icon_id }]),
                    style: Z(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    c("div", {
                      class: "menu-item-icon",
                      style: Z(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: s.cms_icon_id ? s.icon_cms : s.icon
                    }, null, 12, pj)
                  ], 6),
                  c("span", {
                    style: Z(`color: ${e.theme.icon_text_color.hex};`)
                  }, k(s.name), 5)
                ])
              ], 12, fj)
            ], 40, mj))), 128))
          ])
        ]),
        c("div", gj, [
          (d(!0), f(J, null, ne(e.content.sitemapMenuItems, (s, l) => (d(), f("div", {
            key: `section-${l}`,
            style: Z(`border-right-color: ${e.theme.text_color.hex}`),
            class: "col"
          }, [
            c("h2", {
              style: Z(
                o.sectionList === s.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
              ),
              onKeydown: [
                K(W((u) => e.clickGeneratedLink(s, !1), ["exact", "prevent"]), ["enter"]),
                K(W((u) => e.clickGeneratedLink(s, !1), ["exact", "prevent"]), ["space"])
              ],
              onMouseover: (u) => i.setHoverColor("sectionList", s.id),
              onMouseleave: t[1] || (t[1] = (u) => i.removeHoverColor("sectionList"))
            }, [
              j(a, {
                id: `${s.slug || s.id}-${s.type}`,
                element: s,
                class: _({ "has-child": s.children.length }),
                "path-prefix": e.content.pathPrefix,
                "is-parent": "",
                onRouterLinkClick: t[0] || (t[0] = (u) => e.$emit("close-menu"))
              }, null, 8, ["id", "element", "class", "path-prefix"])
            ], 44, vj),
            s.children.length ? (d(), f("ul", {
              key: 0,
              id: `${s.slug || s.id}-${l}-parent-list`,
              "aria-labelledby": `${s.slug || s.id}-${s.type}`
            }, [
              (d(!0), f(J, null, ne(s.children, (u, m) => (d(), f("li", {
                key: `parent-${m}`,
                style: Z(
                  o.parentList === u.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                ),
                class: _({
                  "has-child": u.children.length,
                  open: e.activeIds.includes(u.id)
                }),
                onMouseover: (v) => i.setHoverColor("parentList", u.id),
                onMouseleave: t[4] || (t[4] = (v) => i.removeHoverColor("parentList"))
              }, [
                u.children.length ? (d(), f("svg", {
                  key: 0,
                  id: `${u.slug || u.id}-${u.type}-parent-button`,
                  role: "button",
                  "aria-expanded": u.type !== "header" ? !!e.activeIds.includes(u.id) : "",
                  "aria-haspopup": "true",
                  "aria-controls": u.type !== "header" ? `${u.slug || u.id}-${m}-child-list` : "",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "15",
                  height: "15",
                  viewBox: "0 0 16 16",
                  class: "icon-box",
                  tabindex: u.children.length && u.type !== "header" ? "0" : "-1",
                  onKeydown: [
                    K(W((v) => e.toggleOpen(u.id, !0), ["exact", "prevent"]), ["enter"]),
                    K(W((v) => e.toggleOpen(u.id, !0), ["exact", "prevent"]), ["space"])
                  ],
                  onMousedown: W((v) => e.toggleOpen(u.id, !0), ["prevent"])
                }, [
                  c("title", null, k(`Toggle Submenu for ${u.name}`), 1),
                  c("circle", {
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.bg_color.hex,
                    cx: "10",
                    cy: "10",
                    r: "20"
                  }, null, 8, Cj),
                  e.activeIds.includes(u.id) ? (d(), f("path", {
                    key: 0,
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.text_color.hex,
                    stroke: e.theme.bg_color.hex,
                    d: "M549,659a8,8,0,1,1,8-8A8,8,0,0,1,549,659Zm4-9h-8v2h8v-2Z",
                    transform: "translate(-541 -643)"
                  }, null, 8, wj)) : (d(), f("path", {
                    key: 1,
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.text_color.hex,
                    stroke: e.theme.bg_color.hex,
                    d: "M549,638a8,8,0,1,1,8-8A8,8,0,0,1,549,638Zm4-9h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2Z",
                    transform: "translate(-541 -622)"
                  }, null, 8, Tj))
                ], 40, _j)) : T("", !0),
                c("span", {
                  class: "parent-menu-element-wrapper",
                  tabindex: u.children.length && u.type === "header" ? "0" : "-1",
                  "aria-controls": u.type === "header" ? `${u.slug || u.id}-${m}-child-list` : "",
                  "aria-expanded": u.type === "header" ? !!e.activeIds.includes(u.id) : "",
                  "aria-label": u.type === "header" ? `Toggle Submenu for ${u.name}` : "",
                  onKeydown: [
                    K(W((v) => e.clickGeneratedLink(u, !0), ["exact", "prevent"]), ["enter"]),
                    K(W((v) => e.clickGeneratedLink(u, !0), ["exact", "prevent"]), ["space"])
                  ],
                  onClick: W((v) => e.clickGeneratedLink(u, !0), ["stop"])
                }, [
                  j(a, {
                    id: `${u.slug || u.id}-${u.type}`,
                    element: u,
                    "path-prefix": e.content.pathPrefix,
                    "is-sub-parent": ""
                  }, null, 8, ["id", "element", "path-prefix"])
                ], 40, kj),
                u.children.length ? (d(), f("ul", {
                  key: 1,
                  id: `${u.slug || u.id}-${m}-child-list`,
                  "aria-labelledby": `${u.slug || u.id}-${u.type}-parent-button`
                }, [
                  (d(!0), f(J, null, ne(u.children, (v, g) => (d(), f("li", {
                    key: `child-${g}`,
                    style: Z(
                      o.childList === v.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                    ),
                    onMouseover: (h) => i.setHoverColor("childList", v.id),
                    onMouseleave: t[3] || (t[3] = (h) => i.removeHoverColor("childList"))
                  }, [
                    c("span", {
                      class: "child-menu-element-wrapper",
                      onKeydown: [
                        K(W((h) => e.clickGeneratedLink(v, !1), ["exact", "prevent"]), ["enter"]),
                        K(W((h) => e.clickGeneratedLink(v, !1), ["exact", "prevent"]), ["space"])
                      ]
                    }, [
                      j(a, {
                        id: `${v.slug || v.id}-${v.type}`,
                        element: v,
                        "path-prefix": e.content.pathPrefix,
                        onRouterLinkClick: t[2] || (t[2] = (h) => e.$emit("close-menu"))
                      }, null, 8, ["id", "element", "path-prefix"])
                    ], 40, Mj)
                  ], 44, Sj))), 128))
                ], 8, Ej)) : T("", !0)
              ], 46, yj))), 128))
            ], 8, bj)) : T("", !0)
          ], 4))), 128))
        ])
      ]),
      c("button", {
        ref: "closeButton",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[5] || (t[5] = (s) => e.$emit("close-menu")),
        onKeydown: t[6] || (t[6] = K(W((...s) => i.handleTabOnCloseButton && i.handleTabOnCloseButton(...s), ["exact", "prevent"]), ["tab"]))
      }, [
        c("div", Aj, [
          (d(), f("svg", Ij, [
            c("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.l1_text_color.hex,
              "fill-rule": "evenodd"
            }, [
              c("g", {
                id: "close_modal_icon",
                fill: e.theme.text_color.hex
              }, t[11] || (t[11] = [
                c("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, Dj)
            ], 8, Lj)
          ]))
        ])
      ], 544)
    ], 36)
  ]);
}
const Oj = /* @__PURE__ */ B(uj, [["render", $j], ["__scopeId", "data-v-19da20a5"]]), Pj = {
  name: "M3",
  mixins: [$s, Tt],
  emits: ["close-menu"],
  data() {
    return {
      sectionList: null,
      parentList: null,
      childList: null
    };
  },
  mounted() {
    this.$refs.mainmenu.focus();
  },
  methods: {
    handleTabOnCloseButton() {
      this.$refs.mainmenu.focus();
    },
    handleShiftTabOnCloseButton(e) {
      e === 0 && this.$refs["close-menu-button"].focus();
    },
    closeMenuIfOpen() {
      this.content.showMenu && !this.isPreview && this.$emit("close-menu");
    },
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    }
  }
}, Nj = { id: "m3" }, Hj = { class: "content" }, Fj = { class: "static-links" }, Rj = ["onKeydown"], Vj = ["id", "target", "href"], Bj = ["innerHTML"], jj = { class: "generated-links" }, Uj = ["onKeydown", "onMouseover"], qj = ["id", "aria-labelledby"], Gj = ["onMouseover"], Kj = ["onKeydown"], zj = ["tabindex", "onKeydown"], Zj = ["id", "aria-expanded", "aria-controls", "aria-label", "onClick"], xj = ["id", "aria-labelledby"], Wj = ["onMouseover"], Yj = ["onKeydown"], Xj = {
  class: "button-action-content",
  tabindex: "-1"
}, Qj = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, Jj = ["fill"], eU = ["fill"];
function tU(e, t, n, r, o, i) {
  const a = V("MenuElement"), s = Ke("click-away");
  return d(), f("div", Nj, [
    we((d(), f("div", {
      ref: "mainmenu",
      style: Z(`background: ${e.theme.bg_color.hex}; opacity: 0.96`),
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      tabindex: "0",
      onKeydown: t[9] || (t[9] = K(W((l) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"]))
    }, [
      c("div", {
        style: Z(`color: ${e.theme.text_color.hex || "#dddddd"};`),
        class: "heading"
      }, [
        c("h2", null, k(e.translations.title), 1)
      ], 4),
      c("div", Hj, [
        c("div", Fj, [
          c("ul", null, [
            (d(!0), f(J, null, ne(e.content.customMenuItems, (l, u) => (d(), f("li", {
              key: l.id,
              onKeydown: [
                K(W((m) => i.handleShiftTabOnCloseButton(u), ["shift", "exact"]), ["tab"]),
                K(W((m) => e.clickStaticLink(e.getLink(l.url)), ["exact", "prevent"]), ["space"])
              ]
            }, [
              c("a", {
                id: l.id,
                style: Z(`color: ${e.theme.icon_text_color.hex};`),
                target: l.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(l.url),
                onClick: t[0] || (t[0] = (m) => e.$emit("close-menu"))
              }, [
                c("div", null, [
                  c("div", {
                    class: _(["link-image", { "global-icon": l.cms_icon_id }]),
                    style: Z(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    c("div", {
                      class: "menu-item-icon",
                      style: Z(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: l.cms_icon_id ? l.icon_cms : l.icon
                    }, null, 12, Bj)
                  ], 6),
                  c("span", {
                    style: Z(`color: ${e.theme.icon_text_color.hex};`)
                  }, k(l.name), 5)
                ])
              ], 12, Vj)
            ], 40, Rj))), 128))
          ])
        ]),
        c("div", jj, [
          c("ul", null, [
            (d(!0), f(J, null, ne(e.content.sitemapMenuItems, (l, u) => (d(), f("li", {
              key: `section-${u}`
            }, [
              c("h2", {
                style: Z(
                  o.sectionList === l.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                ),
                class: _({ "has-child": l.children.length }),
                onKeydown: [
                  K(W((m) => e.clickGeneratedLink(l, !1), ["exact", "prevent"]), ["enter"]),
                  K(W((m) => e.clickGeneratedLink(l, !1), ["exact", "prevent"]), ["space"])
                ],
                onMouseover: (m) => i.setHoverColor("sectionList", l.id),
                onMouseleave: t[2] || (t[2] = (m) => i.removeHoverColor("sectionList"))
              }, [
                j(a, {
                  id: `${l.slug || l.id}-${l.type}`,
                  element: l,
                  "path-prefix": e.content.pathPrefix,
                  "is-parent": "",
                  onRouterLinkClick: t[1] || (t[1] = (m) => e.$emit("close-menu"))
                }, null, 8, ["id", "element", "path-prefix"])
              ], 46, Uj),
              l.children.length ? (d(), f("ul", {
                key: 0,
                id: `${l.slug || l.id}-${u}-parent-list`,
                "aria-labelledby": `${l.slug || l.id}-${l.type}`
              }, [
                (d(!0), f(J, null, ne(l.children, (m, v) => (d(), f("li", {
                  key: `parent-${v}`,
                  style: Z(
                    o.parentList === m.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                  ),
                  class: _({
                    "has-child": m.children.length,
                    open: e.activeIds.includes(m.id)
                  }),
                  onMouseover: (g) => i.setHoverColor("parentList", m.id),
                  onMouseleave: t[6] || (t[6] = (g) => i.removeHoverColor("parentList"))
                }, [
                  c("span", {
                    class: "parent-menu-element-wrapper",
                    onKeydown: [
                      K(W((g) => e.clickGeneratedLink(m, !0), ["exact", "prevent"]), ["enter"]),
                      K(W((g) => e.clickGeneratedLink(m, !0), ["exact", "prevent"]), ["space"])
                    ]
                  }, [
                    j(a, {
                      id: `${m.slug || m.id}-${m.type}`,
                      element: m,
                      "toggle-fn": e.toggleOpen,
                      "path-prefix": e.content.pathPrefix,
                      "is-sub-parent": "",
                      onRouterLinkClick: t[3] || (t[3] = (g) => e.$emit("close-menu"))
                    }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
                  ], 40, Kj),
                  c("span", {
                    class: "arrow-box",
                    tabindex: m.children.length ? "0" : "-1",
                    onKeydown: [
                      K(W((g) => e.toggleOpen(m.id, !0), ["exact", "prevent"]), ["enter"]),
                      K(W((g) => e.toggleOpen(m.id, !0), ["exact", "prevent"]), ["space"])
                    ]
                  }, [
                    m.children.length ? (d(), f("span", {
                      key: 0,
                      id: `${m.slug || m.id}-${m.type}-parent-button`,
                      class: "parent-arrow",
                      role: "button",
                      tabindex: "-1",
                      "aria-expanded": !!e.activeIds.includes(m.id),
                      "aria-haspopup": !0,
                      "aria-controls": `${m.slug || m.id}-${v}-child-list`,
                      "aria-label": `Toggle Submenu for ${m.name}`,
                      onClick: (g) => e.toggleOpen(m.id, !0)
                    }, null, 8, Zj)) : T("", !0)
                  ], 40, zj),
                  m.children.length ? (d(), f("ul", {
                    key: 0,
                    id: `${m.slug || m.id}-${v}-child-list`,
                    "aria-labelledby": `${m.slug || m.id}-${m.type}-parent-button`
                  }, [
                    (d(!0), f(J, null, ne(m.children, (g, h) => (d(), f("li", {
                      key: `child-${h}`,
                      style: Z(
                        o.childList === g.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                      ),
                      onMouseover: (E) => i.setHoverColor("childList", g.id),
                      onMouseleave: t[5] || (t[5] = (E) => i.removeHoverColor("childList"))
                    }, [
                      c("span", {
                        class: "child-menu-element-wrapper",
                        onKeydown: [
                          K(W((E) => e.clickGeneratedLink(g, !1), ["exact", "prevent"]), ["enter"]),
                          K(W((E) => e.clickGeneratedLink(g, !1), ["exact", "prevent"]), ["space"])
                        ]
                      }, [
                        j(a, {
                          id: `${g.slug || g.id}-${g.type}`,
                          element: g,
                          "path-prefix": e.content.pathPrefix,
                          onRouterLinkClick: t[4] || (t[4] = (E) => e.$emit("close-menu"))
                        }, null, 8, ["id", "element", "path-prefix"])
                      ], 40, Yj)
                    ], 44, Wj))), 128))
                  ], 8, xj)) : T("", !0)
                ], 46, Gj))), 128))
              ], 8, qj)) : T("", !0)
            ]))), 128))
          ])
        ])
      ]),
      c("button", {
        ref: "close-menu-button",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[7] || (t[7] = (l) => e.$emit("close-menu")),
        onKeydown: t[8] || (t[8] = K(W((...l) => i.handleTabOnCloseButton && i.handleTabOnCloseButton(...l), ["exact", "prevent"]), ["tab"]))
      }, [
        c("div", Xj, [
          (d(), f("svg", Qj, [
            c("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.text_color.hex,
              "fill-rule": "evenodd"
            }, [
              c("g", {
                id: "close_modal_icon",
                fill: e.theme.text_color.hex
              }, t[10] || (t[10] = [
                c("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, eU)
            ], 8, Jj)
          ]))
        ])
      ], 544)
    ], 36)), [
      [s, i.closeMenuIfOpen]
    ])
  ]);
}
const nU = /* @__PURE__ */ B(Pj, [["render", tU], ["__scopeId", "data-v-0342c808"]]), rU = {
  name: "CMSMenu",
  components: {
    M1: lj,
    M2: Oj,
    M3: nU
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close-menu"],
  computed: {
    hasMenu() {
      return ["M1", "M2", "M3"].includes(this.theme.version);
    }
  }
}, oU = { id: "view-menu" };
function iU(e, t, n, r, o, i) {
  return i.hasMenu ? (d(), I(Y(n.content.showMenu ? "nav" : "div"), { key: 0 }, {
    default: S(() => [
      c("div", oU, [
        j(Le, {
          name: `${n.theme.version}-fade`
        }, {
          default: S(() => [
            n.content.showMenu ? (d(), I(Y(n.theme.version), {
              key: 0,
              theme: n.theme,
              content: n.content,
              "is-preview": n.isPreview,
              onCloseMenu: t[0] || (t[0] = (a) => e.$emit("close-menu"))
            }, null, 40, ["theme", "content", "is-preview"])) : T("", !0)
          ]),
          _: 1
        }, 8, ["name"])
      ])
    ]),
    _: 1
  })) : T("", !0);
}
const sU = /* @__PURE__ */ B(rU, [["render", iU], ["__scopeId", "data-v-4d1651d4"]]), aU = {
  name: "FooterHeader",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    theme: {
      type: Object,
      required: !0
    }
  }
};
function lU(e, t, n, r, o, i) {
  return d(), f("h2", {
    style: Z(`color: ${n.theme.heading_color.hex || "#cccccc"};`),
    class: _(n.theme.style === "light" ? "" : "bold")
  }, k(n.item.content), 7);
}
const U3 = /* @__PURE__ */ B(aU, [["render", lU]]), uU = {
  name: "FooterLink",
  props: {
    item: {
      type: Object,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    }
  },
  computed: {
    getReference() {
      return this.item.mailto ? `mailto:${this.item.email_address}` : this.item.url;
    },
    linkTarget() {
      return this.item.opens_in_new_tab ? "_blank" : "_self";
    }
  }
}, dU = ["href", "target"];
function cU(e, t, n, r, o, i) {
  return d(), f("a", {
    href: i.getReference,
    target: i.linkTarget,
    style: Z({ color: n.theme.text_link_color.hex, textDecoration: "none" })
  }, k(n.item.content), 13, dU);
}
const q3 = /* @__PURE__ */ B(uU, [["render", cU]]), hU = {
  name: "FooterTextField",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    theme: {
      type: Object,
      required: !0
    }
  }
};
function mU(e, t, n, r, o, i) {
  return d(), f("p", {
    style: Z(`color: ${n.theme.text_link_color.hex || "#cccccc"};`),
    class: "textfield"
  }, k(n.item.content), 5);
}
const G3 = /* @__PURE__ */ B(hU, [["render", mU]]), fU = {
  name: "FooterImage",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    hasLink() {
      return this.item.action_on_click === "link";
    },
    opensInNewTab() {
      return this.item.open_in_new_tab ? "_blank" : "_self";
    },
    width() {
      return this.item.display === "percentage" ? `${this.item.set_ratio * 100}%` : `${this.item.preferred_width}px`;
    },
    height() {
      let e = `max-height: ${this.item.preferred_height}px`;
      return this.item.display === "percentage" && (e = "auto"), e;
    }
  }
}, pU = ["src", "alt"];
function gU(e, t, n, r, o, i) {
  return d(), f("div", {
    class: _([n.item.image_alignment, "image-container"])
  }, [
    (d(), I(Y(i.hasLink ? "a" : "div"), {
      style: Z({ width: i.width, height: i.height }),
      href: i.hasLink && n.item.link_url,
      target: i.hasLink && i.opensInNewTab,
      class: "image-wrapper"
    }, {
      default: S(() => [
        c("img", {
          src: n.item.url,
          alt: n.item.alt_text
        }, null, 8, pU)
      ]),
      _: 1
    }, 8, ["style", "href", "target"]))
  ], 2);
}
const K3 = /* @__PURE__ */ B(fU, [["render", gU], ["__scopeId", "data-v-37437fa5"]]), vU = /(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g, Yc = (e) => {
  if (typeof e != "string")
    throw new Error("Expected a string argument");
  return e.replace(vU, (n) => `<a href="tel:${n}" class="tel-link">${n}</a>`);
}, W0 = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    organizations: {
      type: Array,
      required: !0
    },
    iosLink: {
      type: String,
      default: ""
    },
    androidLink: {
      type: String,
      default: ""
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isIFrame: {
      type: Boolean,
      default: !1
    },
    currentDomain: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: ""
    }
  },
  methods: {
    addTelLinksToPhoneNumbers: Yc
  },
  computed: {
    logoImage() {
      return this.isPreview ? this.logo : this.content.logo.url;
    },
    logoWidth() {
      return this.content.logo.display === "percentage" ? `${this.content.logo.set_ratio * 100}%` : `${this.content.logo.preferred_width || 150}px`;
    },
    logoHeight() {
      return this.content.logo.display === "percentage" || !this.content.logo.preferred_height ? "100%" : `${this.content.logo.preferred_height}px`;
    },
    logoAlignment() {
      return $(this.content, "logo.image_alignment", "center");
    },
    imageWidth() {
      var e, t, n, r;
      return ((e = this.content.image) == null ? void 0 : e.display) === "percentage" ? `${((t = this.content.image) == null ? void 0 : t.set_ratio) * 100}%` : (n = this.content.image) != null && n.preferred_width ? `${(r = this.content.image) == null ? void 0 : r.preferred_width}px` : "100%";
    },
    imageHeight() {
      var e, t, n;
      return ((e = this.content.image) == null ? void 0 : e.display) === "percentage" || !((t = this.content.image) != null && t.preferred_height) ? "100%" : `${(n = this.content.image) == null ? void 0 : n.preferred_height}px`;
    },
    imageAlignment() {
      return $(this.content, "image.image_alignment", "center");
    },
    firstColumnHeader() {
      return this.content.columns[0].hasHeader || this.isPreview ? this.content.columns[0].header : !1;
    },
    info() {
      return this.content.organization_info;
    },
    currentYear() {
      return (/* @__PURE__ */ new Date()).getFullYear();
    },
    primaryOrg() {
      return this.organizations.filter((e) => e.primary);
    },
    copyrightOrg() {
      return this.organizations.length > 0 && !this.isIFrame ? this.primaryOrg[0].name : "School District";
    },
    translations() {
      return this.theme.translations;
    },
    cssVars() {
      return {
        "--bg-color": $(this.theme, "bg_color.hex", "#ffffff"),
        "--heading-color": $(this.theme, "heading_color.hex", "#cccccc"),
        "--link-color": $(this.theme, "text_link_color.hex", "#000000"),
        "--text-link-color": $(this.theme, "text_link_color.hex", "#000000"),
        "--logo-width": this.logoWidth,
        "--logo-height": this.logoHeight,
        "--logo-alignment": this.logoAlignment,
        "--image-width": this.imageWidth,
        "--image-height": this.imageHeight,
        "--image-alignment": this.imageAlignment
      };
    }
  }
}, z3 = "data:image/svg+xml,%3csvg%20width='135'%20height='40'%20viewBox='0%200%20135%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%205C0%202.23858%202.23858%200%205%200H130C132.761%200%20135%202.23858%20135%205V35C135%2037.7614%20132.761%2040%20130%2040H5C2.23857%2040%200%2037.7614%200%2035V5Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M130%201H5C2.79086%201%201%202.79086%201%205V35C1%2037.2091%202.79086%2039%205%2039H130C132.209%2039%20134%2037.2091%20134%2035V5C134%202.79086%20132.209%201%20130%201ZM5%200C2.23858%200%200%202.23858%200%205V35C0%2037.7614%202.23857%2040%205%2040H130C132.761%2040%20135%2037.7614%20135%2035V5C135%202.23858%20132.761%200%20130%200H5Z'%20fill='%23A6A6A6'/%3e%3cpath%20d='M81.5259%2019.2009V21.4919H80.0898V22.9944H81.5259V28.0994C81.5259%2029.8425%2082.3144%2030.5398%2084.2983%2030.5398C84.647%2030.5398%2084.979%2030.4983%2085.2695%2030.4485V28.9626C85.0205%2028.9875%2084.8628%2029.0041%2084.5889%2029.0041C83.7007%2029.0041%2083.3105%2028.5891%2083.3105%2027.6428V22.9944H85.2695V21.4919H83.3105V19.2009H81.5259Z'%20fill='white'/%3e%3cpath%20d='M90.3234%2030.6643C92.963%2030.6643%2094.5817%2028.8962%2094.5817%2025.9661C94.5817%2023.0525%2092.9547%2021.2761%2090.3234%2021.2761C87.6837%2021.2761%2086.0568%2023.0525%2086.0568%2025.9661C86.0568%2028.8962%2087.6754%2030.6643%2090.3234%2030.6643ZM90.3234%2029.0789C88.7711%2029.0789%2087.8995%2027.9416%2087.8995%2025.9661C87.8995%2024.0071%2088.7711%2022.8616%2090.3234%2022.8616C91.8673%2022.8616%2092.7472%2024.0071%2092.7472%2025.9661C92.7472%2027.9333%2091.8673%2029.0789%2090.3234%2029.0789Z'%20fill='white'/%3e%3cpath%20d='M95.9666%2030.49H97.7512V25.1526C97.7512%2023.8826%2098.7058%2023.0276%20100.059%2023.0276C100.374%2023.0276%20100.906%2023.0857%20101.055%2023.1355V21.3757C100.864%2021.3259%20100.524%2021.301%20100.258%2021.301C99.0794%2021.301%2098.075%2021.9485%2097.8176%2022.8367H97.6848V21.4504H95.9666V30.49Z'%20fill='white'/%3e%3cpath%20d='M105.486%2022.7952C106.806%2022.7952%20107.669%2023.7165%20107.711%2025.136H103.145C103.245%2023.7248%20104.166%2022.7952%20105.486%2022.7952ZM107.703%2028.0496C107.371%2028.7551%20106.632%2029.1453%20105.553%2029.1453C104.125%2029.1453%20103.204%2028.1409%20103.145%2026.5554V26.4558H109.529V25.8332C109.529%2022.9944%20108.01%2021.2761%20105.495%2021.2761C102.946%2021.2761%20101.328%2023.1106%20101.328%2025.9993C101.328%2028.8879%20102.913%2030.6643%20105.503%2030.6643C107.57%2030.6643%20109.014%2029.6682%20109.421%2028.0496H107.703Z'%20fill='white'/%3e%3cpath%20d='M69.8223%2027.1518C69.9599%2029.3715%2071.8097%2030.7911%2074.5628%2030.7911C77.5052%2030.7911%2079.3464%2029.3027%2079.3464%2026.9281C79.3464%2025.0612%2078.2967%2024.0287%2075.7501%2023.4351L74.3821%2023.0996C72.7647%2022.721%2072.1108%2022.2134%2072.1108%2021.3272C72.1108%2020.2088%2073.126%2019.4775%2074.6489%2019.4775C76.0942%2019.4775%2077.0923%2020.1916%2077.2729%2021.3358H79.1485C79.0366%2019.2452%2077.1955%2017.774%2074.6747%2017.774C71.9646%2017.774%2070.1578%2019.2452%2070.1578%2021.4563C70.1578%2023.2802%2071.1816%2024.3643%2073.4272%2024.8891L75.0274%2025.2763C76.6707%2025.6634%2077.3934%2026.2312%2077.3934%2027.1776C77.3934%2028.2789%2076.2577%2029.079%2074.7091%2029.079C73.0486%2029.079%2071.8957%2028.3305%2071.7323%2027.1518H69.8223Z'%20fill='white'/%3e%3cpath%20d='M51.3349%2021.301C50.1064%2021.301%2049.0439%2021.9153%2048.4961%2022.9446H48.3633V21.4504H46.645V33.4949H48.4297V29.1204H48.5708C49.0439%2030.0749%2050.0649%2030.6394%2051.3516%2030.6394C53.6343%2030.6394%2055.0869%2028.8381%2055.0869%2025.9661C55.0869%2023.094%2053.6343%2021.301%2051.3349%2021.301ZM50.8286%2029.0373C49.3345%2029.0373%2048.3965%2027.8586%2048.3965%2025.9744C48.3965%2024.0818%2049.3345%2022.9031%2050.8369%2022.9031C52.3476%2022.9031%2053.2524%2024.0569%2053.2524%2025.9661C53.2524%2027.8835%2052.3476%2029.0373%2050.8286%2029.0373Z'%20fill='white'/%3e%3cpath%20d='M61.3317%2021.301C60.1032%2021.301%2059.0407%2021.9153%2058.4929%2022.9446H58.3601V21.4504H56.6418V33.4949H58.4265V29.1204H58.5676C59.0407%2030.0749%2060.0617%2030.6394%2061.3483%2030.6394C63.6311%2030.6394%2065.0837%2028.8381%2065.0837%2025.9661C65.0837%2023.094%2063.6311%2021.301%2061.3317%2021.301ZM60.8254%2029.0373C59.3313%2029.0373%2058.3933%2027.8586%2058.3933%2025.9744C58.3933%2024.0818%2059.3313%2022.9031%2060.8337%2022.9031C62.3444%2022.9031%2063.2492%2024.0569%2063.2492%2025.9661C63.2492%2027.8835%2062.3444%2029.0373%2060.8254%2029.0373Z'%20fill='white'/%3e%3cpath%20d='M43.443%2030.49H45.4906L41.0082%2018.0751H38.9348L34.4523%2030.49H36.4311L37.5754%2027.1948H42.3073L43.443%2030.49ZM39.8725%2020.3292H40.0188L41.8169%2025.5774H38.0658L39.8725%2020.3292Z'%20fill='white'/%3e%3cpath%20d='M35.6511%208.71094V14.7H37.8135C39.5981%2014.7%2040.6316%2013.6001%2040.6316%2011.6868C40.6316%209.80249%2039.5898%208.71094%2037.8135%208.71094H35.6511ZM36.5808%209.55762H37.7097C38.9507%209.55762%2039.6853%2010.3462%2039.6853%2011.6992C39.6853%2013.073%2038.9631%2013.8533%2037.7097%2013.8533H36.5808V9.55762Z'%20fill='white'/%3e%3cpath%20d='M43.7967%2014.7871C45.1165%2014.7871%2045.9258%2013.9031%2045.9258%2012.438C45.9258%2010.9812%2045.1124%2010.093%2043.7967%2010.093C42.4769%2010.093%2041.6634%2010.9812%2041.6634%2012.438C41.6634%2013.9031%2042.4727%2014.7871%2043.7967%2014.7871ZM43.7967%2013.9944C43.0206%2013.9944%2042.5848%2013.4258%2042.5848%2012.438C42.5848%2011.4585%2043.0206%2010.8857%2043.7967%2010.8857C44.5687%2010.8857%2045.0086%2011.4585%2045.0086%2012.438C45.0086%2013.4216%2044.5687%2013.9944%2043.7967%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M52.818%2010.1802H51.9256L51.1205%2013.6292H51.0499L50.1202%2010.1802H49.2652L48.3355%2013.6292H48.2691L47.4598%2010.1802H46.555L47.8001%2014.7H48.7174L49.6471%2011.3713H49.7176L50.6515%2014.7H51.577L52.818%2010.1802Z'%20fill='white'/%3e%3cpath%20d='M53.8456%2014.7H54.7379V12.0562C54.7379%2011.3506%2055.1571%2010.9106%2055.817%2010.9106C56.477%2010.9106%2056.7924%2011.2717%2056.7924%2011.998V14.7H57.6847V11.7739C57.6847%2010.699%2057.1286%2010.093%2056.12%2010.093C55.4394%2010.093%2054.9911%2010.396%2054.7711%2010.8982H54.7047V10.1802H53.8456V14.7Z'%20fill='white'/%3e%3cpath%20d='M59.09%2014.7H59.9824V8.41626H59.09V14.7Z'%20fill='white'/%3e%3cpath%20d='M63.3384%2014.7871C64.6582%2014.7871%2065.4675%2013.9031%2065.4675%2012.438C65.4675%2010.9812%2064.6541%2010.093%2063.3384%2010.093C62.0186%2010.093%2061.2051%2010.9812%2061.2051%2012.438C61.2051%2013.9031%2062.0144%2014.7871%2063.3384%2014.7871ZM63.3384%2013.9944C62.5623%2013.9944%2062.1265%2013.4258%2062.1265%2012.438C62.1265%2011.4585%2062.5623%2010.8857%2063.3384%2010.8857C64.1104%2010.8857%2064.5503%2011.4585%2064.5503%2012.438C64.5503%2013.4216%2064.1104%2013.9944%2063.3384%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M68.1263%2014.0234C67.6407%2014.0234%2067.2879%2013.7869%2067.2879%2013.3801C67.2879%2012.9817%2067.5701%2012.77%2068.1927%2012.7285L69.2967%2012.658V13.0356C69.2967%2013.5959%2068.7986%2014.0234%2068.1263%2014.0234ZM67.898%2014.7747C68.4915%2014.7747%2068.9854%2014.5173%2069.2552%2014.0649H69.3257V14.7H70.1849V11.6121C70.1849%2010.6575%2069.5457%2010.093%2068.4126%2010.093C67.3875%2010.093%2066.657%2010.5911%2066.5657%2011.3672H67.429C67.5286%2011.0476%2067.8731%2010.865%2068.3711%2010.865C68.9812%2010.865%2069.2967%2011.1348%2069.2967%2011.6121V12.0022L68.0723%2012.0728C66.9974%2012.1392%2066.3914%2012.6082%2066.3914%2013.4216C66.3914%2014.2476%2067.0264%2014.7747%2067.898%2014.7747Z'%20fill='white'/%3e%3cpath%20d='M73.213%2014.7747C73.8355%2014.7747%2074.3626%2014.48%2074.6324%2013.9861H74.703V14.7H75.558V8.41626H74.6656V10.8982H74.5992C74.3543%2010.4001%2073.8314%2010.1055%2073.213%2010.1055C72.0716%2010.1055%2071.337%2011.0103%2071.337%2012.438C71.337%2013.8699%2072.0633%2014.7747%2073.213%2014.7747ZM73.4662%2010.9065C74.2132%2010.9065%2074.6822%2011.5%2074.6822%2012.4421C74.6822%2013.3884%2074.2174%2013.9736%2073.4662%2013.9736C72.7108%2013.9736%2072.2584%2013.3967%2072.2584%2012.438C72.2584%2011.4875%2072.7149%2010.9065%2073.4662%2010.9065Z'%20fill='white'/%3e%3cpath%20d='M81.3444%2014.7871C82.6643%2014.7871%2083.4736%2013.9031%2083.4736%2012.438C83.4736%2010.9812%2082.6601%2010.093%2081.3444%2010.093C80.0246%2010.093%2079.2111%2010.9812%2079.2111%2012.438C79.2111%2013.9031%2080.0205%2014.7871%2081.3444%2014.7871ZM81.3444%2013.9944C80.5683%2013.9944%2080.1325%2013.4258%2080.1325%2012.438C80.1325%2011.4585%2080.5683%2010.8857%2081.3444%2010.8857C82.1164%2010.8857%2082.5563%2011.4585%2082.5563%2012.438C82.5563%2013.4216%2082.1164%2013.9944%2081.3444%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M84.6548%2014.7H85.5471V12.0562C85.5471%2011.3506%2085.9663%2010.9106%2086.6262%2010.9106C87.2861%2010.9106%2087.6016%2011.2717%2087.6016%2011.998V14.7H88.4939V11.7739C88.4939%2010.699%2087.9377%2010.093%2086.9292%2010.093C86.2485%2010.093%2085.8003%2010.396%2085.5803%2010.8982H85.5139V10.1802H84.6548V14.7Z'%20fill='white'/%3e%3cpath%20d='M92.6036%209.05542V10.2009H91.8856V10.9521H92.6036V13.5046C92.6036%2014.3762%2092.9979%2014.7249%2093.9898%2014.7249C94.1642%2014.7249%2094.3302%2014.7041%2094.4754%2014.6792V13.9363C94.3509%2013.9487%2094.2721%2013.957%2094.1351%2013.957C93.691%2013.957%2093.4959%2013.7495%2093.4959%2013.2764V10.9521H94.4754V10.2009H93.4959V9.05542H92.6036Z'%20fill='white'/%3e%3cpath%20d='M95.6732%2014.7H96.5656V12.0603C96.5656%2011.3755%2096.9723%2010.9148%2097.7028%2010.9148C98.3336%2010.9148%2098.6698%2011.28%2098.6698%2012.0022V14.7H99.5622V11.7822C99.5622%2010.7073%2098.9687%2010.0972%2098.0058%2010.0972C97.3251%2010.0972%2096.8478%2010.4001%2096.6278%2010.9065H96.5573V8.41626H95.6732V14.7Z'%20fill='white'/%3e%3cpath%20d='M102.781%2010.8525C103.441%2010.8525%20103.873%2011.3132%20103.894%2012.0229H101.611C101.661%2011.3174%20102.121%2010.8525%20102.781%2010.8525ZM103.889%2013.4797C103.723%2013.8325%20103.354%2014.0276%20102.814%2014.0276C102.101%2014.0276%20101.64%2013.5254%20101.611%2012.7327V12.6829H104.802V12.3716C104.802%2010.9521%20104.043%2010.093%20102.785%2010.093C101.511%2010.093%20100.702%2011.0103%20100.702%2012.4546C100.702%2013.8989%20101.495%2014.7871%20102.789%2014.7871C103.823%2014.7871%20104.545%2014.2891%20104.748%2013.4797H103.889Z'%20fill='white'/%3e%3cpath%20d='M24.769%2020.3008C24.7907%2018.6198%2025.6934%2017.0292%2027.1256%2016.1488C26.2221%2014.8584%2024.7088%2014.0403%2023.1344%2013.9911C21.4552%2013.8148%2019.8272%2014.9959%2018.9715%2014.9959C18.0992%2014.9959%2016.7817%2014.0086%2015.363%2014.0378C13.5137%2014.0975%2011.7898%2015.1489%2010.8901%2016.7656C8.95607%2020.1141%2010.3987%2025.0351%2012.2513%2027.7417C13.1782%2029.0671%2014.2615%2030.5475%2015.6789%2030.495C17.066%2030.4375%2017.584%2029.6105%2019.2583%2029.6105C20.9171%2029.6105%2021.4031%2030.495%2022.8493%2030.4616C24.3377%2030.4375%2025.2754%2029.1304%2026.1698%2027.7925C26.8358%2026.8481%2027.3483%2025.8044%2027.6882%2024.7C25.9391%2023.9602%2024.771%2022.2%2024.769%2020.3008Z'%20fill='white'/%3e%3cpath%20d='M22.0373%2012.2111C22.8489%2011.2369%2023.2487%209.98469%2023.1518%208.72046C21.912%208.85068%2020.7668%209.44324%2019.9443%2010.3801C19.14%2011.2954%2018.7214%2012.5255%2018.8006%2013.7415C20.0408%2013.7542%2021.2601%2013.1777%2022.0373%2012.2111Z'%20fill='white'/%3e%3c/svg%3e", Z3 = "data:image/svg+xml,%3csvg%20width='135'%20height='40'%20viewBox='0%200%20135%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%205C0%202.23858%202.23858%200%205%200H130C132.761%200%20135%202.23858%20135%205V35C135%2037.7614%20132.761%2040%20130%2040H5C2.23857%2040%200%2037.7614%200%2035V5Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M130%201H5C2.79086%201%201%202.79086%201%205V35C1%2037.2091%202.79086%2039%205%2039H130C132.209%2039%20134%2037.2091%20134%2035V5C134%202.79086%20132.209%201%20130%201ZM5%200C2.23858%200%200%202.23858%200%205V35C0%2037.7614%202.23857%2040%205%2040H130C132.761%2040%20135%2037.7614%20135%2035V5C135%202.23858%20132.761%200%20130%200H5Z'%20fill='%23A6A6A6'/%3e%3cpath%20d='M68.136%2020.8861C65.784%2020.8861%2063.867%2022.6751%2063.867%2025.1391C63.867%2027.5881%2065.784%2029.3921%2068.136%2029.3921C70.489%2029.3921%2072.406%2027.5881%2072.406%2025.1391C72.405%2022.6751%2070.488%2020.8861%2068.136%2020.8861ZM68.136%2027.7181C66.847%2027.7181%2065.736%2026.6551%2065.736%2025.1401C65.736%2023.6091%2066.848%2022.5621%2068.136%2022.5621C69.425%2022.5621%2070.536%2023.6091%2070.536%2025.1401C70.536%2026.6541%2069.425%2027.7181%2068.136%2027.7181ZM58.822%2020.8861C56.47%2020.8861%2054.553%2022.6751%2054.553%2025.1391C54.553%2027.5881%2056.47%2029.3921%2058.822%2029.3921C61.175%2029.3921%2063.092%2027.5881%2063.092%2025.1391C63.092%2022.6751%2061.175%2020.8861%2058.822%2020.8861ZM58.822%2027.7181C57.533%2027.7181%2056.422%2026.6551%2056.422%2025.1401C56.422%2023.6091%2057.534%2022.5621%2058.822%2022.5621C60.111%2022.5621%2061.222%2023.6091%2061.222%2025.1401C61.223%2026.6541%2060.111%2027.7181%2058.822%2027.7181ZM47.744%2022.1921V23.9961H52.062C51.933%2025.0111%2051.595%2025.7521%2051.079%2026.2671C50.451%2026.8951%2049.468%2027.5881%2047.744%2027.5881C45.086%2027.5881%2043.008%2025.4451%2043.008%2022.7871C43.008%2020.1291%2045.086%2017.9861%2047.744%2017.9861C49.178%2017.9861%2050.225%2018.5501%2050.998%2019.2751L52.271%2018.0021C51.191%2016.9711%2049.758%2016.1821%2047.744%2016.1821C44.103%2016.1821%2041.042%2019.1461%2041.042%2022.7871C41.042%2026.4281%2044.103%2029.3921%2047.744%2029.3921C49.709%2029.3921%2051.192%2028.7471%2052.351%2027.5391C53.543%2026.3471%2053.914%2024.6711%2053.914%2023.3181C53.914%2022.9001%2053.882%2022.5131%2053.817%2022.1911H47.744V22.1921ZM93.052%2023.5931C92.698%2022.6431%2091.618%2020.8861%2089.411%2020.8861C87.22%2020.8861%2085.399%2022.6101%2085.399%2025.1391C85.399%2027.5231%2087.204%2029.3921%2089.62%2029.3921C91.569%2029.3921%2092.697%2028.2001%2093.165%2027.5071L91.715%2026.5401C91.232%2027.2491%2090.571%2027.7161%2089.62%2027.7161C88.67%2027.7161%2087.993%2027.2811%2087.558%2026.4271L93.245%2024.0751L93.052%2023.5931ZM87.252%2025.0111C87.204%2023.3671%2088.525%2022.5301%2089.476%2022.5301C90.217%2022.5301%2090.845%2022.9011%2091.055%2023.4321L87.252%2025.0111ZM82.629%2029.1351H84.497V16.6341H82.629V29.1351ZM79.567%2021.8371H79.503C79.084%2021.3371%2078.278%2020.8861%2077.264%2020.8861C75.137%2020.8861%2073.188%2022.7551%2073.188%2025.1561C73.188%2027.5401%2075.137%2029.3931%2077.264%2029.3931C78.279%2029.3931%2079.084%2028.9421%2079.503%2028.4271H79.567V29.0391C79.567%2030.6661%2078.697%2031.5361%2077.296%2031.5361C76.152%2031.5361%2075.443%2030.7151%2075.153%2030.0221L73.526%2030.6991C73.993%2031.8261%2075.233%2033.2121%2077.296%2033.2121C79.487%2033.2121%2081.34%2031.9231%2081.34%2028.7811V21.1451H79.568V21.8371H79.567ZM77.425%2027.7181C76.136%2027.7181%2075.057%2026.6381%2075.057%2025.1561C75.057%2023.6571%2076.136%2022.5621%2077.425%2022.5621C78.697%2022.5621%2079.696%2023.6571%2079.696%2025.1561C79.696%2026.6381%2078.697%2027.7181%2077.425%2027.7181ZM101.806%2016.6341H97.335V29.1351H99.2V24.3991H101.805C103.873%2024.3991%20105.907%2022.9021%20105.907%2020.5171C105.907%2018.1321%20103.874%2016.6341%20101.806%2016.6341ZM101.854%2022.6591H99.2V18.3741H101.854C103.249%2018.3741%20104.041%2019.5291%20104.041%2020.5171C104.041%2021.4851%20103.249%2022.6591%20101.854%2022.6591ZM113.386%2020.8641C112.035%2020.8641%20110.636%2021.4591%20110.057%2022.7781L111.713%2023.4691C112.067%2022.7781%20112.727%2022.5521%20113.418%2022.5521C114.383%2022.5521%20115.364%2023.1311%20115.38%2024.1601V24.2891C115.042%2024.0961%20114.318%2023.8071%20113.434%2023.8071C111.649%2023.8071%20109.831%2024.7881%20109.831%2026.6211C109.831%2028.2941%20111.295%2029.3711%20112.935%2029.3711C114.189%2029.3711%20114.881%2028.8081%20115.315%2028.1481H115.379V29.1131H117.181V24.3201C117.182%2022.1021%20115.524%2020.8641%20113.386%2020.8641ZM113.16%2027.7151C112.55%2027.7151%20111.697%2027.4091%20111.697%2026.6531C111.697%2025.6881%20112.759%2025.3181%20113.676%2025.3181C114.495%2025.3181%20114.882%2025.4951%20115.38%2025.7361C115.235%2026.8951%20114.238%2027.7151%20113.16%2027.7151ZM123.743%2021.1371L121.604%2026.5571H121.54L119.32%2021.1371H117.31L120.639%2028.7121L118.741%2032.9261H120.687L125.818%2021.1371H123.743ZM106.937%2029.1351H108.802V16.6341H106.937V29.1351Z'%20fill='white'/%3e%3cpath%20d='M47.418%209.37795C47.418%2010.216%2047.17%2010.883%2046.673%2011.381C46.109%2011.973%2045.3731%2012.269%2044.4691%2012.269C43.6031%2012.269%2042.8661%2011.969%2042.2611%2011.369C41.6551%2010.768%2041.3521%2010.024%2041.3521%209.13595C41.3521%208.24695%2041.6551%207.50295%2042.2611%206.90295C42.8661%206.30195%2043.6031%206.00195%2044.4691%206.00195C44.8991%206.00195%2045.3101%206.08595%2045.7001%206.25295C46.0911%206.42095%2046.4041%206.64395%2046.6381%206.92295L46.111%207.45095C45.714%206.97595%2045.167%206.73895%2044.468%206.73895C43.836%206.73895%2043.29%206.96095%2042.829%207.40495C42.368%207.84895%2042.1381%208.42595%2042.1381%209.13495C42.1381%209.84395%2042.368%2010.421%2042.829%2010.865C43.29%2011.309%2043.836%2011.531%2044.468%2011.531C45.138%2011.531%2045.6971%2011.308%2046.1441%2010.861C46.4341%2010.57%2046.602%2010.165%2046.647%209.64595H44.468V8.92495H47.375C47.405%209.08195%2047.418%209.23295%2047.418%209.37795Z'%20fill='white'/%3e%3cpath%20d='M52.0281%206.87201H49.2961V8.77401H51.7601V9.49501H49.2961V11.397H52.0281V12.135H48.5251V6.13501H52.0281V6.87201Z'%20fill='white'/%3e%3cpath%20d='M55.279%2012.135H54.508V6.87201H52.832V6.13501H56.955V6.87201H55.279V12.135Z'%20fill='white'/%3e%3cpath%20d='M59.938%2012.135V6.13501H60.709V12.135H59.938Z'%20fill='white'/%3e%3cpath%20d='M64.1281%2012.135H63.3572V6.87201H61.6812V6.13501H65.8042V6.87201H64.1281V12.135Z'%20fill='white'/%3e%3cpath%20d='M73.6089%2011.36C73.0189%2011.966%2072.2859%2012.269%2071.4089%2012.269C70.5319%2012.269%2069.7989%2011.966%2069.2099%2011.36C68.6199%2010.754%2068.3259%2010.012%2068.3259%209.135C68.3259%208.258%2068.6199%207.516%2069.2099%206.91C69.7989%206.304%2070.5319%206%2071.4089%206C72.2809%206%2073.0129%206.305%2073.6049%206.914C74.1969%207.523%2074.4929%208.263%2074.4929%209.135C74.4929%2010.012%2074.1979%2010.754%2073.6089%2011.36ZM69.7789%2010.857C70.2229%2011.307%2070.7659%2011.531%2071.4089%2011.531C72.0519%2011.531%2072.5959%2011.306%2073.0389%2010.857C73.4829%2010.407%2073.7059%209.833%2073.7059%209.135C73.7059%208.437%2073.4829%207.863%2073.0389%207.413C72.5959%206.963%2072.0519%206.739%2071.4089%206.739C70.7659%206.739%2070.2229%206.964%2069.7789%207.413C69.3359%207.863%2069.1129%208.437%2069.1129%209.135C69.1129%209.833%2069.3359%2010.407%2069.7789%2010.857Z'%20fill='white'/%3e%3cpath%20d='M75.5749%2012.135V6.13501H76.513L79.429%2010.802H79.4619L79.429%209.64601V6.13501H80.1999V12.135H79.3949L76.344%207.24101H76.3109L76.344%208.39701V12.135H75.5749Z'%20fill='white'/%3e%3cpath%20d='M47.418%209.37795C47.418%2010.216%2047.17%2010.883%2046.673%2011.381C46.109%2011.973%2045.3731%2012.269%2044.4691%2012.269C43.6031%2012.269%2042.8661%2011.969%2042.2611%2011.369C41.6551%2010.768%2041.3521%2010.024%2041.3521%209.13595C41.3521%208.24695%2041.6551%207.50295%2042.2611%206.90295C42.8661%206.30195%2043.6031%206.00195%2044.4691%206.00195C44.8991%206.00195%2045.3101%206.08595%2045.7001%206.25295C46.0911%206.42095%2046.4041%206.64395%2046.6381%206.92295L46.111%207.45095C45.714%206.97595%2045.167%206.73895%2044.468%206.73895C43.836%206.73895%2043.29%206.96095%2042.829%207.40495C42.368%207.84895%2042.1381%208.42595%2042.1381%209.13495C42.1381%209.84395%2042.368%2010.421%2042.829%2010.865C43.29%2011.309%2043.836%2011.531%2044.468%2011.531C45.138%2011.531%2045.6971%2011.308%2046.1441%2010.861C46.4341%2010.57%2046.602%2010.165%2046.647%209.64595H44.468V8.92495H47.375C47.405%209.08195%2047.418%209.23295%2047.418%209.37795Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M52.0281%206.87201H49.2961V8.77401H51.7601V9.49501H49.2961V11.397H52.0281V12.135H48.5251V6.13501H52.0281V6.87201Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M55.279%2012.135H54.508V6.87201H52.832V6.13501H56.955V6.87201H55.279V12.135Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M59.938%2012.135V6.13501H60.709V12.135H59.938Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M64.1281%2012.135H63.3572V6.87201H61.6812V6.13501H65.8042V6.87201H64.1281V12.135Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M73.6089%2011.36C73.0189%2011.966%2072.2859%2012.269%2071.4089%2012.269C70.5319%2012.269%2069.7989%2011.966%2069.2099%2011.36C68.6199%2010.754%2068.3259%2010.012%2068.3259%209.135C68.3259%208.258%2068.6199%207.516%2069.2099%206.91C69.7989%206.304%2070.5319%206%2071.4089%206C72.2809%206%2073.0129%206.305%2073.6049%206.914C74.1969%207.523%2074.4929%208.263%2074.4929%209.135C74.4929%2010.012%2074.1979%2010.754%2073.6089%2011.36ZM69.7789%2010.857C70.2229%2011.307%2070.7659%2011.531%2071.4089%2011.531C72.0519%2011.531%2072.5959%2011.306%2073.0389%2010.857C73.4829%2010.407%2073.7059%209.833%2073.7059%209.135C73.7059%208.437%2073.4829%207.863%2073.0389%207.413C72.5959%206.963%2072.0519%206.739%2071.4089%206.739C70.7659%206.739%2070.2229%206.964%2069.7789%207.413C69.3359%207.863%2069.1129%208.437%2069.1129%209.135C69.1129%209.833%2069.3359%2010.407%2069.7789%2010.857Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M75.5749%2012.135V6.13501H76.513L79.429%2010.802H79.4619L79.429%209.64601V6.13501H80.1999V12.135H79.3949L76.344%207.24101H76.3109L76.344%208.39701V12.135H75.5749Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cg%20filter='url(%23filter0_ii)'%3e%3cpath%20d='M10.436%206.67302C10.145%206.98102%209.97302%207.45902%209.97302%208.07802V30.194C9.97302%2030.814%2010.145%2031.291%2010.436%2031.599L10.51%2031.671L22.899%2019.282V19.136V18.99L10.51%206.60002L10.436%206.67302Z'%20fill='url(%23paint0_linear)'/%3e%3cpath%20d='M27.028%2023.413L22.899%2019.282V19.136V18.99L27.029%2014.86L27.122%2014.913L32.015%2017.693C33.412%2018.487%2033.412%2019.786%2032.015%2020.581L27.122%2023.361L27.028%2023.413Z'%20fill='url(%23paint1_linear)'/%3e%3cg%20filter='url(%23filter1_i)'%3e%3cpath%20d='M27.122%2023.36L22.898%2019.136L10.436%2031.599C10.896%2032.087%2011.657%2032.147%2012.514%2031.661L27.122%2023.36Z'%20fill='url(%23paint2_linear)'/%3e%3c/g%3e%3cpath%20d='M27.122%2014.912L12.514%206.61202C11.657%206.12502%2010.896%206.18602%2010.436%206.67402L22.899%2019.137L27.122%2014.912Z'%20fill='url(%23paint3_linear)'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_ii'%20x='9.97302'%20y='6.27594'%20width='23.0898'%20height='25.7208'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='-0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.12%200'/%3e%3cfeBlend%20mode='normal'%20in2='shape'%20result='effect1_innerShadow'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%201%200%200%200%200%201%200%200%200%200%201%200%200%200%200.25%200'/%3e%3cfeBlend%20mode='normal'%20in2='effect1_innerShadow'%20result='effect2_innerShadow'/%3e%3c/filter%3e%3cfilter%20id='filter1_i'%20x='10.436'%20y='19.136'%20width='16.686'%20height='12.8607'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='-0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.08%200'/%3e%3cfeBlend%20mode='normal'%20in2='shape'%20result='effect1_innerShadow'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear'%20x1='21.8008'%20y1='7.84402'%20x2='5.01882'%20y2='24.626'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%2300A0FF'/%3e%3cstop%20offset='0.0066'%20stop-color='%2300A1FF'/%3e%3cstop%20offset='0.2601'%20stop-color='%2300BEFF'/%3e%3cstop%20offset='0.5122'%20stop-color='%2300D2FF'/%3e%3cstop%20offset='0.7604'%20stop-color='%2300DFFF'/%3e%3cstop%20offset='1'%20stop-color='%2300E3FF'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear'%20x1='33.8335'%20y1='19.136'%20x2='9.63765'%20y2='19.136'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FFE000'/%3e%3cstop%20offset='0.4087'%20stop-color='%23FFBD00'/%3e%3cstop%20offset='0.7754'%20stop-color='%23FFA500'/%3e%3cstop%20offset='1'%20stop-color='%23FF9C00'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear'%20x1='24.8281'%20y1='21.4299'%20x2='2.06964'%20y2='44.1884'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FF3A44'/%3e%3cstop%20offset='1'%20stop-color='%23C31162'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear'%20x1='7.29743'%20y1='-0.688184'%20x2='17.4597'%20y2='9.47412'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%2332A071'/%3e%3cstop%20offset='0.0685'%20stop-color='%232DA771'/%3e%3cstop%20offset='0.4762'%20stop-color='%2315CF74'/%3e%3cstop%20offset='0.8009'%20stop-color='%2306E775'/%3e%3cstop%20offset='1'%20stop-color='%2300F076'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", x3 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%233B5998'/%3e%3cpath%20d='M24.625%206.625H7.375C6.96016%206.625%206.625%206.96016%206.625%207.375V24.625C6.625%2025.0398%206.96016%2025.375%207.375%2025.375H24.625C25.0398%2025.375%2025.375%2025.0398%2025.375%2024.625V7.375C25.375%206.96016%2025.0398%206.625%2024.625%206.625ZM22.4594%2012.0977H20.9617C19.7875%2012.0977%2019.5602%2012.6555%2019.5602%2013.4758V15.2828H22.3633L21.9977%2018.1117H19.5602V25.375H16.6375V18.1141H14.193V15.2828H16.6375V13.1969C16.6375%2010.7758%2018.1164%209.45625%2020.2773%209.45625C21.3133%209.45625%2022.2016%209.53359%2022.4617%209.56875V12.0977H22.4594Z'%20fill='white'/%3e%3c/svg%3e", W3 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2028.0.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2032%2032'%20style='enable-background:new%200%200%2032%2032;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%23231F20;}%20.st1{fill:%23FFFFFF;}%20%3c/style%3e%3cpath%20class='st0'%20d='M2,0h28c1.1,0,2,0.9,2,2v28c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z'/%3e%3cpath%20class='st1'%20d='M17.6,14.7L24,7.2h-1.5L17,13.7l-4.4-6.5H7.4l6.7,9.8l-6.7,7.8h1.5l5.9-6.8l4.7,6.8h5.1L17.6,14.7L17.6,14.7z%20M15.6,17.1l-0.7-1L9.5,8.3h2.3l4.4,6.3l0.7,1l5.7,8.1h-2.3L15.6,17.1L15.6,17.1z'/%3e%3c/svg%3e", Y3 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%23FF0000'/%3e%3cpath%20d='M26.0617%2010.9398C25.9422%2010.4946%2025.7078%2010.0886%2025.382%209.76243C25.0563%209.43625%2024.6505%209.20136%2024.2055%209.08125C22.5672%208.64063%2016%208.64062%2016%208.64062C16%208.64062%209.43281%208.64062%207.79453%209.07891C7.34927%209.19862%206.94334%209.43339%206.61751%209.75962C6.29169%2010.0859%206.05744%2010.4921%205.93828%2010.9375C5.5%2012.5781%205.5%2016%205.5%2016C5.5%2016%205.5%2019.4219%205.93828%2021.0602C6.17969%2021.9648%206.89219%2022.6773%207.79453%2022.9188C9.43281%2023.3594%2016%2023.3594%2016%2023.3594C16%2023.3594%2022.5672%2023.3594%2024.2055%2022.9188C25.1102%2022.6773%2025.8203%2021.9648%2026.0617%2021.0602C26.5%2019.4219%2026.5%2016%2026.5%2016C26.5%2016%2026.5%2012.5781%2026.0617%2010.9398ZM13.9141%2019.1406V12.8594L19.3516%2015.9766L13.9141%2019.1406Z'%20fill='white'/%3e%3c/svg%3e", X3 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%23E5017B'/%3e%3cpath%20d='M16%2011.193C13.3398%2011.193%2011.193%2013.3398%2011.193%2016C11.193%2018.6602%2013.3398%2020.807%2016%2020.807C18.6601%2020.807%2020.807%2018.6602%2020.807%2016C20.807%2013.3398%2018.6601%2011.193%2016%2011.193ZM16%2019.1242C14.2797%2019.1242%2012.8758%2017.7203%2012.8758%2016C12.8758%2014.2797%2014.2797%2012.8758%2016%2012.8758C17.7203%2012.8758%2019.1242%2014.2797%2019.1242%2016C19.1242%2017.7203%2017.7203%2019.1242%2016%2019.1242ZM21.0039%209.87578C20.3828%209.87578%2019.8812%2010.3773%2019.8812%2010.9984C19.8812%2011.6195%2020.3828%2012.1211%2021.0039%2012.1211C21.625%2012.1211%2022.1266%2011.6219%2022.1266%2010.9984C22.1267%2010.851%2022.0978%2010.7049%2022.0415%2010.5686C21.9851%2010.4323%2021.9024%2010.3085%2021.7981%2010.2042C21.6939%2010.0999%2021.57%2010.0172%2021.4337%209.96086C21.2974%209.90451%2021.1514%209.87559%2021.0039%209.87578ZM25.3703%2016C25.3703%2014.7062%2025.382%2013.4242%2025.3094%2012.1328C25.2367%2010.6328%2024.8945%209.30156%2023.7976%208.20469C22.6984%207.10547%2021.3695%206.76562%2019.8695%206.69297C18.5758%206.62031%2017.2937%206.63203%2016.0023%206.63203C14.7086%206.63203%2013.4266%206.62031%2012.1351%206.69297C10.6351%206.76562%209.3039%207.10781%208.20702%208.20469C7.1078%209.3039%206.76796%2010.6328%206.6953%2012.1328C6.62265%2013.4266%206.63436%2014.7086%206.63436%2016C6.63436%2017.2914%206.62265%2018.5758%206.6953%2019.8672C6.76796%2021.3672%207.11015%2022.6984%208.20702%2023.7953C9.30624%2024.8945%2010.6351%2025.2344%2012.1351%2025.307C13.4289%2025.3797%2014.7109%2025.368%2016.0023%2025.368C17.2961%2025.368%2018.5781%2025.3797%2019.8695%2025.307C21.3695%2025.2344%2022.7008%2024.8922%2023.7976%2023.7953C24.8969%2022.6961%2025.2367%2021.3672%2025.3094%2019.8672C25.3844%2018.5758%2025.3703%2017.2937%2025.3703%2016ZM23.3078%2021.5266C23.1367%2021.9531%2022.9305%2022.2719%2022.6%2022.6C22.2695%2022.9305%2021.9531%2023.1367%2021.5266%2023.3078C20.2937%2023.7977%2017.3664%2023.6875%2016%2023.6875C14.6336%2023.6875%2011.7039%2023.7977%2010.4711%2023.3102C10.0445%2023.1391%209.72577%2022.9328%209.39765%2022.6023C9.06718%2022.2719%208.86093%2021.9555%208.68983%2021.5289C8.20233%2020.2937%208.31249%2017.3664%208.31249%2016C8.31249%2014.6336%208.20233%2011.7039%208.68983%2010.4711C8.86093%2010.0445%209.06718%209.72578%209.39765%209.39765C9.72811%209.06953%2010.0445%208.86094%2010.4711%208.68984C11.7039%208.20234%2014.6336%208.3125%2016%208.3125C17.3664%208.3125%2020.2961%208.20234%2021.5289%208.68984C21.9555%208.86094%2022.2742%209.06719%2022.6023%209.39765C22.9328%209.72812%2023.1391%2010.0445%2023.3101%2010.4711C23.7976%2011.7039%2023.6875%2014.6336%2023.6875%2016C23.6875%2017.3664%2023.7976%2020.2937%2023.3078%2021.5266Z'%20fill='white'/%3e%3c/svg%3e", bU = {
  name: "F1",
  components: {
    FooterHeader: U3,
    FooterLink: q3,
    FooterImage: K3,
    FooterTextField: G3
  },
  mixins: [W0],
  methods: {
    orgLink(e) {
      return qr(e, {
        isPreview: this.isPreview,
        currentDomain: this.currentDomain
      });
    }
  }
}, yU = { class: "row" }, _U = {
  class: "footer-column-main",
  "data-testid": "footer-column"
}, CU = { class: "logo-wrapper" }, wU = ["src"], TU = { key: 0 }, kU = { key: 1 }, EU = { key: 2 }, SU = ["innerHTML"], MU = ["innerHTML"], AU = { key: 5 }, IU = ["innerHTML"], LU = ["href"], DU = {
  class: "footer-column-last",
  "data-testid": "footer-column"
}, $U = ["href"], OU = ["href"], PU = {
  key: 0,
  "data-social-media": "facebook",
  "data-testid": "social-icon"
}, NU = ["href"], HU = {
  key: 1,
  "data-social-media": "twitter",
  "data-testid": "social-icon"
}, FU = ["href"], RU = {
  key: 2,
  "data-social-media": "youtube",
  "data-testid": "social-icon"
}, VU = ["href"], BU = {
  key: 3,
  "data-social-media": "instagram",
  "data-testid": "social-icon"
}, jU = ["href"], UU = ["innerHTML"];
function qU(e, t, n, r, o, i) {
  return d(), f("footer", {
    id: "footer-f1",
    style: Z(e.cssVars)
  }, [
    c("div", yU, [
      c("div", _U, [
        c("div", CU, [
          e.content.hasLogo || e.isPreview ? (d(), f("img", {
            key: 0,
            src: e.logoImage,
            alt: "",
            class: "footer-logo"
          }, null, 8, wU)) : T("", !0)
        ]),
        e.firstColumnHeader ? (d(), f("h2", {
          key: 0,
          class: _(e.theme.style)
        }, k(e.firstColumnHeader), 3)) : T("", !0),
        c("p", null, [
          e.info.name ? (d(), f("span", TU, k(e.info.name), 1)) : T("", !0),
          e.info.address ? (d(), f("span", kU, k(e.info.address), 1)) : T("", !0),
          e.info.city ? (d(), f("span", EU, k(e.info.city) + ", " + k(e.info.state) + " " + k(e.info.zip), 1)) : T("", !0),
          e.info.phone_number ? (d(), f("span", {
            key: 3,
            innerHTML: e.addTelLinksToPhoneNumbers(e.info.phone_number)
          }, null, 8, SU)) : T("", !0),
          e.info.fax_number ? (d(), f("span", {
            key: 4,
            innerHTML: e.addTelLinksToPhoneNumbers(e.info.fax_number)
          }, null, 8, MU)) : T("", !0),
          e.info.email ? (d(), f("span", AU, k(e.info.email), 1)) : T("", !0)
        ]),
        c("ul", null, [
          (d(!0), f(J, null, ne(e.content.columns[0].items, (a, s) => (d(), f("li", { key: s }, [
            (d(), I(Y(a.type), {
              item: a,
              theme: e.theme,
              class: _(e.theme.style)
            }, null, 8, ["item", "theme", "class"]))
          ]))), 128))
        ]),
        e.content.hasAdditionalText && e.content.additionalTextAlignment === "left" ? (d(), f("div", {
          key: 1,
          class: "additional-text",
          innerHTML: e.content.additionalText
        }, null, 8, IU)) : T("", !0)
      ]),
      (d(!0), f(J, null, ne(e.theme.num_columns - 2, (a, s) => (d(), f("div", {
        key: s,
        class: "footer-columns",
        "data-testid": "footer-column"
      }, [
        e.content.columns[s + 1].hasHeader ? (d(), f("h2", {
          key: 0,
          class: _(e.theme.style)
        }, k(e.content.columns[s + 1].header), 3)) : T("", !0),
        s === 0 && e.content.columns[s + 1].showSchools ? (d(), f("ul", {
          key: 1,
          class: _({ "normal-window": !e.isIFrame })
        }, [
          (d(!0), f(J, null, ne(e.organizations, (l, u) => (d(), f("li", { key: u }, [
            c("a", {
              href: i.orgLink(l)
            }, k(l.name), 9, LU)
          ]))), 128))
        ], 2)) : T("", !0),
        c("ul", {
          class: _({ "normal-window": !e.isIFrame })
        }, [
          (d(!0), f(J, null, ne(e.content.columns[s + 1].items, (l, u) => (d(), f("li", { key: u }, [
            (d(), I(Y(l.type), {
              item: l,
              theme: e.theme,
              class: _(e.theme.style)
            }, null, 8, ["item", "theme", "class"]))
          ]))), 128))
        ], 2)
      ]))), 128)),
      c("div", DU, [
        c("h2", {
          class: _(e.theme.style)
        }, k(e.translations.stay_connected), 3),
        e.iosLink || e.isPreview ? (d(), f("a", {
          key: 0,
          href: e.iosLink,
          target: "_blank",
          "data-mobile-app": "ios"
        }, t[0] || (t[0] = [
          c("img", {
            class: "app-link",
            src: z3,
            alt: "Download our iOS App",
            "data-testid": "app-icon"
          }, null, -1)
        ]), 8, $U)) : T("", !0),
        e.androidLink || e.isPreview ? (d(), f("a", {
          key: 1,
          href: e.androidLink,
          target: "_blank",
          "data-mobile-app": "android"
        }, t[1] || (t[1] = [
          c("img", {
            class: "app-link",
            src: Z3,
            alt: "Download our Android App",
            "data-testid": "app-icon"
          }, null, -1)
        ]), 8, OU)) : T("", !0),
        c("ul", {
          class: _(["footer-social-links", { "normal-window": !e.isIFrame }])
        }, [
          e.content.facebook || e.isPreview ? (d(), f("li", PU, [
            c("a", {
              href: e.content.facebook,
              target: "_blank"
            }, t[2] || (t[2] = [
              c("img", {
                src: x3,
                alt: "Visit us on Facebook"
              }, null, -1)
            ]), 8, NU)
          ])) : T("", !0),
          e.content.twitter || e.isPreview ? (d(), f("li", HU, [
            c("a", {
              href: e.content.twitter,
              target: "_blank"
            }, t[3] || (t[3] = [
              c("img", {
                src: W3,
                alt: "Visit us on X, formerly Twitter"
              }, null, -1)
            ]), 8, FU)
          ])) : T("", !0),
          e.content.youtube || e.isPreview ? (d(), f("li", RU, [
            c("a", {
              href: e.content.youtube,
              target: "_blank"
            }, t[4] || (t[4] = [
              c("img", {
                src: Y3,
                alt: "Visit us on Youtube"
              }, null, -1)
            ]), 8, VU)
          ])) : T("", !0),
          e.content.instagram || e.isPreview ? (d(), f("li", BU, [
            c("a", {
              href: e.content.instagram,
              target: "_blank"
            }, t[5] || (t[5] = [
              c("img", {
                src: X3,
                alt: "Visit us on Instagram"
              }, null, -1)
            ]), 8, jU)
          ])) : T("", !0)
        ], 2)
      ])
    ]),
    e.content.hasAdditionalText && e.content.additionalTextAlignment === "center" ? (d(), f("div", {
      key: 0,
      class: "additional-text additional-text-bottom",
      innerHTML: e.content.additionalText
    }, null, 8, UU)) : T("", !0),
    c("div", {
      class: _(`apptegy-copyright ${e.theme.version && e.theme.version.toLowerCase()}`)
    }, [
      c("span", null, k(e.translations.copyright) + " © " + k(e.currentYear) + " " + k(e.copyrightOrg) + ". " + k(e.translations.all_rights_reserved), 1),
      c("span", null, [
        H(k(e.translations.powered_by) + " ", 1),
        t[6] || (t[6] = c("a", {
          href: "https://www.apptegy.com",
          target: "_blank",
          class: "notranslate"
        }, [
          H("Apptegy "),
          c("span", { class: "sr-only" }, "Visit us to learn more")
        ], -1))
      ])
    ], 2)
  ], 4);
}
const GU = /* @__PURE__ */ B(bU, [["render", qU], ["__scopeId", "data-v-e45d0272"]]), KU = {
  name: "F2",
  mixins: [W0],
  computed: {
    showDownloadApps() {
      return this.content.hasApps || this.content.columns[2].showApps || this.isPreview;
    },
    showSocialMedia() {
      return this.content.hasSocial || this.content.columns[0].hasSocial || this.isPreview;
    },
    thirdColumnHeader() {
      return this.isPreview ? this.translations.stay_connected : this.content.columns[2].hasHeader ? this.content.columns[2].header : !1;
    }
  }
}, zU = { class: "footer-wrapper" }, ZU = { class: "logo" }, xU = ["src"], WU = {
  class: "download-links",
  "data-testid": "download-links"
}, YU = {
  key: 1,
  class: "links-wrapper"
}, XU = ["href"], QU = ["href"], JU = { class: "contact-data" }, eq = {
  key: 0,
  class: "social-media"
}, tq = {
  key: 0,
  "data-social-media": "facebook",
  "data-testid": "social-icon"
}, nq = ["href"], rq = {
  key: 1,
  "data-social-media": "twitter",
  "data-testid": "social-icon"
}, oq = ["href"], iq = {
  key: 2,
  "data-social-media": "youtube",
  "data-testid": "social-icon"
}, sq = ["href"], aq = {
  key: 3,
  "data-social-media": "instagram",
  "data-testid": "social-icon"
}, lq = ["href"], uq = { key: 0 }, dq = { key: 1 }, cq = { key: 2 }, hq = { key: 3 }, mq = ["innerHTML"], fq = { key: 4 }, pq = ["innerHTML"], gq = { key: 5 }, vq = ["innerHTML"];
function bq(e, t, n, r, o, i) {
  return d(), f("footer", {
    id: "footer-f2",
    style: Z(e.cssVars)
  }, [
    c("div", zU, [
      c("div", ZU, [
        e.content.hasLogo || e.isPreview ? (d(), f("img", {
          key: 0,
          src: e.logoImage,
          alt: "",
          class: "footer-logo"
        }, null, 8, xU)) : T("", !0)
      ]),
      c("div", WU, [
        i.thirdColumnHeader ? (d(), f("h2", {
          key: 0,
          class: _(`header ${e.theme.style}`)
        }, k(i.thirdColumnHeader), 3)) : T("", !0),
        i.showDownloadApps ? (d(), f("div", YU, [
          e.iosLink || e.isPreview ? (d(), f("a", {
            key: 0,
            href: e.iosLink,
            target: "_blank",
            "data-mobile-app": "ios"
          }, t[0] || (t[0] = [
            c("img", {
              class: "app-icon",
              src: z3,
              alt: "Download our iOS App",
              "data-testid": "app-icon"
            }, null, -1)
          ]), 8, XU)) : T("", !0),
          e.androidLink || e.isPreview ? (d(), f("a", {
            key: 1,
            href: e.androidLink,
            target: "_blank",
            "data-mobile-app": "android"
          }, t[1] || (t[1] = [
            c("img", {
              class: "app-icon",
              src: Z3,
              alt: "Download our Android App",
              "data-testid": "app-icon"
            }, null, -1)
          ]), 8, QU)) : T("", !0)
        ])) : T("", !0)
      ]),
      c("div", JU, [
        i.showSocialMedia ? (d(), f("ul", eq, [
          e.content.facebook || e.isPreview ? (d(), f("li", tq, [
            c("a", {
              href: e.content.facebook,
              target: "_blank"
            }, t[2] || (t[2] = [
              c("img", {
                src: x3,
                alt: "Visit us on Facebook",
                class: "icon-img"
              }, null, -1)
            ]), 8, nq)
          ])) : T("", !0),
          e.content.twitter || e.isPreview ? (d(), f("li", rq, [
            c("a", {
              href: e.content.twitter,
              target: "_blank"
            }, t[3] || (t[3] = [
              c("img", {
                src: W3,
                alt: "Visit us on X, formerly Twitter",
                class: "icon-img"
              }, null, -1)
            ]), 8, oq)
          ])) : T("", !0),
          e.content.youtube || e.isPreview ? (d(), f("li", iq, [
            c("a", {
              href: e.content.youtube,
              target: "_blank"
            }, t[4] || (t[4] = [
              c("img", {
                src: Y3,
                alt: "Visit us on Youtube",
                class: "icon-img"
              }, null, -1)
            ]), 8, sq)
          ])) : T("", !0),
          e.content.instagram || e.isPreview ? (d(), f("li", aq, [
            c("a", {
              href: e.content.instagram,
              target: "_blank"
            }, t[5] || (t[5] = [
              c("img", {
                src: X3,
                alt: "Visit us on Instagram",
                class: "icon-img"
              }, null, -1)
            ]), 8, lq)
          ])) : T("", !0)
        ])) : T("", !0),
        e.firstColumnHeader ? (d(), f("h2", {
          key: 1,
          class: _(`header ${e.theme.style}`)
        }, k(e.firstColumnHeader), 3)) : T("", !0),
        c("div", {
          class: _(`info ${e.theme.style}`)
        }, [
          e.info.name ? (d(), f("span", uq, k(e.info.name), 1)) : T("", !0),
          t[6] || (t[6] = H("  ")),
          e.info.address ? (d(), f("span", dq, k(e.info.address), 1)) : T("", !0),
          t[7] || (t[7] = H("  ")),
          e.info.city ? (d(), f("span", cq, k(e.info.city) + ", " + k(e.info.state) + " " + k(e.info.zip), 1)) : T("", !0),
          t[8] || (t[8] = c("br", null, null, -1)),
          e.info.phone_number ? (d(), f("span", hq, [
            H(k(e.translations.phone_number) + ": ", 1),
            c("span", {
              innerHTML: e.addTelLinksToPhoneNumbers(e.info.phone_number)
            }, null, 8, mq)
          ])) : T("", !0),
          t[9] || (t[9] = H("  ")),
          e.info.fax_number ? (d(), f("span", fq, [
            H(k(e.translations.fax_number) + ": ", 1),
            c("span", {
              innerHTML: e.addTelLinksToPhoneNumbers(e.info.fax_number)
            }, null, 8, pq)
          ])) : T("", !0),
          t[10] || (t[10] = H("  ")),
          e.info.email ? (d(), f("span", gq, k(e.translations.email) + ": " + k(e.info.email), 1)) : T("", !0)
        ], 2)
      ])
    ]),
    e.content.hasAdditionalText && !e.isPreview ? (d(), f("div", {
      key: 0,
      class: "additional-text",
      innerHTML: e.content.additionalText
    }, null, 8, vq)) : T("", !0),
    c("div", {
      class: _(`apptegy-copyright ${e.theme.version && e.theme.version.toLowerCase()}`)
    }, [
      c("span", null, k(e.translations.copyright) + " © " + k(e.currentYear) + " " + k(e.copyrightOrg) + ". " + k(e.translations.all_rights_reserved), 1),
      c("span", null, [
        H(k(e.translations.powered_by) + " ", 1),
        t[11] || (t[11] = c("a", {
          href: "https://www.apptegy.com",
          target: "_blank",
          class: "notranslate"
        }, [
          H("Apptegy "),
          c("span", { class: "sr-only" }, "Visit us to learn more")
        ], -1))
      ])
    ], 2)
  ], 4);
}
const yq = /* @__PURE__ */ B(KU, [["render", bq], ["__scopeId", "data-v-b16e74b5"]]), _q = { class: "contact-info-list" }, Cq = { key: 0 }, wq = { class: "contact-info-item-wrapper" }, Tq = { key: 1 }, kq = { class: "contact-info-item-wrapper" }, Eq = ["innerHTML"], Sq = { key: 2 }, Mq = { class: "contact-info-item-wrapper" }, Aq = ["innerHTML"], Iq = { key: 3 }, Lq = { class: "contact-info-item-wrapper" }, Dq = ["href"], $q = {
  __name: "F3ContactInfo",
  props: {
    info: {
      type: Object,
      required: !0,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e, n = Mn(() => !!(t.info.address || t.info.city || t.info.state || t.info.zip)), r = Mn(() => n.value ? [t.info.address, t.info.city, t.info.state, t.info.zip].filter(Boolean).join(", ") : "");
    return (o, i) => (d(), f("ul", _q, [
      n.value ? (d(), f("li", Cq, [
        c("div", wq, [
          i[0] || (i[0] = c("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
          }, [
            c("path", {
              d: "M6 10C6 12.8226 9.62765 17.3665 11.321 19.2695C11.6882 19.6821 12.3118 19.6821 12.679 19.2695C14.3723 17.3665 18 12.8226 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10Z",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            c("path", {
              d: "M9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10Z",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)),
          c("span", null, k(r.value), 1)
        ])
      ])) : T("", !0),
      e.info.phone_number ? (d(), f("li", Tq, [
        c("div", kq, [
          i[1] || (i[1] = c("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
          }, [
            c("path", {
              d: "M5.48154 5.8797L8.22211 5.19456C8.67681 5.08088 9.14946 5.29827 9.35907 5.71748L10.678 8.35533C10.8705 8.74032 10.795 9.20529 10.4907 9.50965L10.0003 10C10.0003 10 9.00033 11 11.0003 13C13.0003 15 14.0003 14 14.0003 14L14.4907 13.5097C14.795 13.2053 15.26 13.1298 15.645 13.3223L18.2828 14.6413C18.7021 14.8509 18.9194 15.3235 18.8058 15.7782L18.1206 18.5188C18.0448 18.822 17.8296 19.0716 17.5216 19.125C16.3879 19.3214 13.3073 19.307 9.00033 15C4.69331 10.693 4.67895 7.61245 4.87535 6.4787C4.9287 6.17078 5.17836 5.95549 5.48154 5.8797Z",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)),
          c("span", {
            innerHTML: vc(Yc)(e.info.phone_number)
          }, null, 8, Eq)
        ])
      ])) : T("", !0),
      e.info.fax_number ? (d(), f("li", Sq, [
        c("div", Mq, [
          i[2] || (i[2] = c("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
          }, [
            c("path", {
              d: "M7 16H6C5.44772 16 5 15.5523 5 15V8C5 7.44772 5.44772 7 6 7H7M7 16V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V16M7 16V13C7 12.4477 7.44772 12 8 12H16C16.5523 12 17 12.4477 17 13V16M17 16H18C18.5523 16 19 15.5523 19 15V8C19 7.44772 18.5523 7 18 7H17M17 7V6C17 5.44772 16.5523 5 16 5H8C7.44772 5 7 5.44772 7 6V7M17 7H7M9 14H15M9 17H15M16.5 10V10C16.7761 10 17 9.77614 17 9.5V9.5C17 9.22386 16.7761 9 16.5 9V9C16.2239 9 16 9.22386 16 9.5V9.5C16 9.77614 16.2239 10 16.5 10Z",
              stroke: "#333333",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)),
          c("span", {
            innerHTML: vc(Yc)(e.info.fax_number)
          }, null, 8, Aq)
        ])
      ])) : T("", !0),
      e.info.email ? (d(), f("li", Iq, [
        c("div", Lq, [
          i[3] || (i[3] = c("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
          }, [
            c("path", {
              d: "M4 6H20M4 6V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V6M4 6L11.3415 12.4238C11.7185 12.7537 12.2815 12.7537 12.6585 12.4238L20 6",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)),
          c("a", {
            href: `mailto:${e.info.email}`,
            class: "link"
          }, k(e.info.email), 9, Dq)
        ])
      ])) : T("", !0)
    ]));
  }
}, Oq = /* @__PURE__ */ B($q, [["__scopeId", "data-v-ce6fae85"]]), Pq = "data:image/svg+xml,%3csvg%20width='120'%20height='40'%20viewBox='0%200%20120%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='0.5'%20y='0.5'%20width='119'%20height='39'%20rx='5.5'%20fill='white'/%3e%3crect%20x='0.5'%20y='0.5'%20width='119'%20height='39'%20rx='5.5'%20stroke='%23E1E1E1'/%3e%3cpath%20d='M24.7045%2020.763C24.7166%2019.8431%2024.9669%2018.9411%2025.4321%2018.141C25.8972%2017.3409%2026.5621%2016.6687%2027.3648%2016.1869C26.8548%2015.4758%2026.1821%2014.8907%2025.4%2014.4779C24.6178%2014.065%2023.7479%2013.836%2022.8592%2013.8088C20.9635%2013.6146%2019.1258%2014.9163%2018.1598%2014.9163C17.1751%2014.9163%2015.6878%2013.8281%2014.0862%2013.8603C13.0502%2013.893%2012.0406%2014.1871%2011.1557%2014.714C10.2708%2015.2408%209.54075%2015.9825%209.03674%2016.8668C6.85352%2020.5571%208.48201%2025.9808%2010.5734%2028.9639C11.6197%2030.4246%2012.8426%2032.0562%2014.4428%2031.9984C16.0086%2031.9349%2016.5934%2031.0235%2018.4835%2031.0235C20.3561%2031.0235%2020.9048%2031.9984%2022.5374%2031.9616C24.2176%2031.9349%2025.2762%2030.4944%2026.2859%2029.0198C27.0377%2027.979%2027.6162%2026.8287%2028%2025.6115C27.0238%2025.2084%2026.1908%2024.5337%2025.6048%2023.6715C25.0187%2022.8093%2024.7056%2021.7977%2024.7045%2020.763Z'%20fill='%231B1B1B'/%3e%3cpath%20d='M21.621%2011.8471C22.5372%2010.7734%2022.9885%209.39335%2022.8792%208C21.4796%208.14352%2020.1867%208.7966%2019.2582%209.82911C18.8043%2010.3335%2018.4566%2010.9203%2018.235%2011.556C18.0135%2012.1917%2017.9224%2012.8638%2017.9671%2013.5338C18.6672%2013.5408%2019.3597%2013.3927%2019.9927%2013.1005C20.6256%2012.8084%2021.1824%2012.3798%2021.621%2011.8471Z'%20fill='%231B1B1B'/%3e%3cpath%20d='M36.791%208.50146H38.8608C40.6494%208.50146%2041.5195%209.56494%2041.5195%2011.4941C41.5195%2013.4233%2040.6406%2014.5%2038.8608%2014.5H36.791V8.50146ZM37.7886%209.34082V13.6606H38.751C39.9375%2013.6606%2040.4956%2012.9443%2040.4956%2011.5073C40.4956%2010.0615%2039.9331%209.34082%2038.751%209.34082H37.7886ZM44.6748%209.77588C45.8877%209.77588%2046.7358%2010.5625%2046.7358%2011.8677V12.4697C46.7358%2013.8188%2045.8877%2014.5791%2044.6748%2014.5791C43.4443%2014.5791%2042.605%2013.8276%2042.605%2012.4741V11.8721C42.605%2010.6021%2043.4575%209.77588%2044.6748%209.77588ZM44.6792%2010.5625C43.9849%2010.5625%2043.5894%2011.1426%2043.5894%2011.9204V12.439C43.5894%2013.2168%2043.9585%2013.7925%2044.6792%2013.7925C45.3911%2013.7925%2045.7559%2013.2212%2045.7559%2012.439V11.9204C45.7559%2011.1426%2045.3735%2010.5625%2044.6792%2010.5625ZM53.8989%209.85498L52.6772%2014.5H51.6841L50.7129%2011.0723H50.6865L49.7329%2014.5H48.7354L47.4609%209.85498H48.5112L49.2583%2013.397H49.3022L50.2383%209.85498H51.1567L52.1191%2013.397H52.1631L52.9233%209.85498H53.8989ZM54.8657%2014.5V9.85498H55.8237V10.6899H55.8721C55.9907%2010.3252%2056.3291%209.78467%2057.2695%209.78467C58.2056%209.78467%2058.834%2010.3032%2058.834%2011.3623V14.5H57.8584V11.6479C57.8584%2010.9404%2057.4893%2010.6152%2056.9399%2010.6152C56.2192%2010.6152%2055.8413%2011.1689%2055.8413%2011.9204V14.5H54.8657ZM60.3105%2014.5V8.18506H61.2861V14.5H60.3105ZM64.6348%209.77588C65.8477%209.77588%2066.6958%2010.5625%2066.6958%2011.8677V12.4697C66.6958%2013.8188%2065.8477%2014.5791%2064.6348%2014.5791C63.4043%2014.5791%2062.5649%2013.8276%2062.5649%2012.4741V11.8721C62.5649%2010.6021%2063.4175%209.77588%2064.6348%209.77588ZM64.6392%2010.5625C63.9448%2010.5625%2063.5493%2011.1426%2063.5493%2011.9204V12.439C63.5493%2013.2168%2063.9185%2013.7925%2064.6392%2013.7925C65.3511%2013.7925%2065.7158%2013.2212%2065.7158%2012.439V11.9204C65.7158%2011.1426%2065.3335%2010.5625%2064.6392%2010.5625ZM69.2227%2014.5703C68.3218%2014.5703%2067.7021%2014.0166%2067.7021%2013.1509C67.7021%2012.3291%2068.2734%2011.7754%2069.3457%2011.7754H70.519V11.3403C70.519%2010.8086%2070.1807%2010.5581%2069.6445%2010.5581C69.1172%2010.5581%2068.8799%2010.7778%2068.8052%2011.0854H67.8779C67.9351%2010.3076%2068.5195%209.78467%2069.6753%209.78467C70.6685%209.78467%2071.4902%2010.1978%2071.4902%2011.3535V14.5H70.563V13.8979H70.519C70.3125%2014.2539%2069.9082%2014.5703%2069.2227%2014.5703ZM69.5259%2013.8145C70.0796%2013.8145%2070.519%2013.4365%2070.519%2012.9312V12.4302H69.4995C68.9326%2012.4302%2068.6821%2012.7158%2068.6821%2013.1025C68.6821%2013.5859%2069.0864%2013.8145%2069.5259%2013.8145ZM74.4961%209.79346C75.1509%209.79346%2075.6519%2010.0835%2075.832%2010.5537H75.8804V8.18506H76.856V14.5H75.9067V13.7573H75.8584C75.7178%2014.2275%2075.1597%2014.5615%2074.4829%2014.5615C73.415%2014.5615%2072.7207%2013.8013%2072.7207%2012.5752V11.7798C72.7207%2010.5537%2073.4282%209.79346%2074.4961%209.79346ZM74.7686%2010.5933C74.1182%2010.5933%2073.7139%2011.0767%2073.7139%2011.9204V12.4302C73.7139%2013.2783%2074.1226%2013.7617%2074.7905%2013.7617C75.4497%2013.7617%2075.8804%2013.2827%2075.8804%2012.4917V11.7886C75.8804%2011.0723%2075.4102%2010.5933%2074.7686%2010.5933ZM82.2129%209.77588C83.4258%209.77588%2084.2739%2010.5625%2084.2739%2011.8677V12.4697C84.2739%2013.8188%2083.4258%2014.5791%2082.2129%2014.5791C80.9824%2014.5791%2080.1431%2013.8276%2080.1431%2012.4741V11.8721C80.1431%2010.6021%2080.9956%209.77588%2082.2129%209.77588ZM82.2173%2010.5625C81.5229%2010.5625%2081.1274%2011.1426%2081.1274%2011.9204V12.439C81.1274%2013.2168%2081.4966%2013.7925%2082.2173%2013.7925C82.9292%2013.7925%2083.2939%2013.2212%2083.2939%2012.439V11.9204C83.2939%2011.1426%2082.9116%2010.5625%2082.2173%2010.5625ZM85.5308%2014.5V9.85498H86.4888V10.6899H86.5371C86.6558%2010.3252%2086.9941%209.78467%2087.9346%209.78467C88.8706%209.78467%2089.499%2010.3032%2089.499%2011.3623V14.5H88.5234V11.6479C88.5234%2010.9404%2088.1543%2010.6152%2087.605%2010.6152C86.8843%2010.6152%2086.5063%2011.1689%2086.5063%2011.9204V14.5H85.5308ZM93.2739%209.88574V8.72559H94.2275V9.88574H95.269V10.6504H94.2275V13.1157C94.2275%2013.6211%2094.4165%2013.7617%2094.9395%2013.7617C95.0713%2013.7617%2095.2471%2013.7529%2095.3218%2013.7441V14.4912C95.2427%2014.5044%2094.9175%2014.5308%2094.6978%2014.5308C93.5684%2014.5308%2093.2607%2014.1265%2093.2607%2013.1948V10.6504H92.5532V9.88574H93.2739ZM96.4995%2014.5V8.18506H97.4707V10.6899H97.519C97.6201%2010.3604%2097.998%209.78467%2098.9297%209.78467C99.835%209.78467%20100.481%2010.3076%20100.481%2011.3667V14.5H99.5098V11.6523C99.5098%2010.9448%2099.1187%2010.6152%2098.5649%2010.6152C97.8662%2010.6152%2097.4707%2011.1646%2097.4707%2011.9204V14.5H96.4995ZM103.755%2014.5791C102.489%2014.5791%20101.703%2013.8013%20101.703%2012.4917V11.8633C101.703%2010.5449%20102.564%209.77588%20103.698%209.77588C104.862%209.77588%20105.684%2010.5845%20105.684%2011.8633V12.4082H102.669V12.6367C102.669%2013.3047%20103.065%2013.7969%20103.75%2013.7969C104.26%2013.7969%20104.612%2013.5552%20104.678%2013.2651H105.631C105.574%2013.8013%20105.007%2014.5791%20103.755%2014.5791ZM102.669%2011.771H104.73V11.7095C104.73%2011.0107%20104.322%2010.5449%20103.702%2010.5449C103.083%2010.5449%20102.669%2011.0107%20102.669%2011.7095V11.771Z'%20fill='%231B1B1B'/%3e%3cpath%20d='M38.2061%2030.5H36.1758L40.3066%2018.5029H42.5391L46.6611%2030.5H44.5518L43.4883%2027.1777H39.2783L38.2061%2030.5ZM41.4316%2020.5771H41.3525L39.7266%2025.6484H43.04L41.4316%2020.5771ZM52.2644%2030.6318C51.0603%2030.6318%2050.1462%2030.0605%2049.654%2029.208H49.5837V33.585H47.6325V21.21H49.531V22.5723H49.6013C50.1111%2021.6846%2051.0603%2021.0869%2052.3083%2021.0869C54.3913%2021.0869%2055.8767%2022.6602%2055.8767%2025.4375V26.2637C55.8767%2029.0234%2054.4089%2030.6318%2052.2644%2030.6318ZM51.8161%2029.0234C53.0554%2029.0234%2053.8991%2028.0303%2053.8991%2026.1582V25.5078C53.8991%2023.7061%2053.1081%2022.6777%2051.781%2022.6777C50.4187%2022.6777%2049.5661%2023.7852%2049.5661%2025.499V26.1582C49.5661%2027.916%2050.4275%2029.0234%2051.8161%2029.0234ZM62.183%2030.6318C60.9789%2030.6318%2060.0649%2030.0605%2059.5727%2029.208H59.5024V33.585H57.5512V21.21H59.4496V22.5723H59.52C60.0297%2021.6846%2060.9789%2021.0869%2062.227%2021.0869C64.31%2021.0869%2065.7954%2022.6602%2065.7954%2025.4375V26.2637C65.7954%2029.0234%2064.3276%2030.6318%2062.183%2030.6318ZM61.7348%2029.0234C62.9741%2029.0234%2063.8178%2028.0303%2063.8178%2026.1582V25.5078C63.8178%2023.7061%2063.0268%2022.6777%2061.6996%2022.6777C60.3373%2022.6777%2059.4848%2023.7852%2059.4848%2025.499V26.1582C59.4848%2027.916%2060.3461%2029.0234%2061.7348%2029.0234ZM69.8387%2027.1689H71.7899C71.8778%2028.2061%2072.7919%2029.0938%2074.4882%2029.0938C76.0438%2029.0938%2076.9667%2028.3643%2076.9667%2027.2305C76.9667%2026.3164%2076.3514%2025.8242%2075.0682%2025.5166L73.0995%2025.0244C71.5526%2024.6641%2070.1639%2023.7412%2070.1639%2021.79C70.1639%2019.4961%2072.1679%2018.2393%2074.497%2018.2393C76.8261%2018.2393%2078.7684%2019.4961%2078.8124%2021.7373H76.8964C76.8085%2020.7178%2076.0262%2019.874%2074.4706%2019.874C73.0995%2019.874%2072.1679%2020.5244%2072.1679%2021.6406C72.1679%2022.4229%2072.7128%2022.9854%2073.829%2023.2402L75.7889%2023.7236C77.5907%2024.1631%2078.9618%2025.0156%2078.9618%2027.0547C78.9618%2029.4102%2077.0546%2030.7373%2074.3387%2030.7373C70.9989%2030.7373%2069.8827%2028.7861%2069.8387%2027.1689ZM81.3395%2021.21V18.9512H83.2555V21.21H85.066V22.7744H83.2555V27.7314C83.2555%2028.7422%2083.6334%2029.0234%2084.6793%2029.0234C84.8463%2029.0234%2085.0045%2029.0234%2085.1188%2029.0059V30.5C84.9605%2030.5264%2084.5914%2030.5615%2084.1959%2030.5615C81.9371%2030.5615%2081.3131%2029.7529%2081.3131%2027.8896V22.7744H80.0299V21.21H81.3395ZM90.3353%2021.0518C93.0071%2021.0518%2094.4573%2022.9326%2094.4573%2025.4639V26.2109C94.4573%2028.8301%2093.0159%2030.6582%2090.3353%2030.6582C87.6546%2030.6582%2086.1956%2028.8301%2086.1956%2026.2109V25.4639C86.1956%2022.9414%2087.6634%2021.0518%2090.3353%2021.0518ZM90.3353%2022.6162C88.8851%2022.6162%2088.1644%2023.8027%2088.1644%2025.4902V26.2021C88.1644%2027.8633%2088.8763%2029.085%2090.3353%2029.085C91.7943%2029.085%2092.4974%2027.8721%2092.4974%2026.2021V25.4902C92.4974%2023.7939%2091.7855%2022.6162%2090.3353%2022.6162ZM96.1055%2030.5V21.21H98.0567V22.4316H98.127C98.3643%2021.8516%2099.0586%2021.0781%20100.351%2021.0781C100.606%2021.0781%20100.825%2021.0957%20101.01%2021.1309V22.8535C100.843%2022.8096%20100.5%2022.7832%20100.175%2022.7832C98.6104%2022.7832%2098.083%2023.75%2098.083%2024.998V30.5H96.1055ZM105.743%2030.6582C103.256%2030.6582%20101.674%2029.0146%20101.674%2026.2637V25.3232C101.674%2022.7305%20103.22%2021.0518%20105.664%2021.0518C108.142%2021.0518%20109.636%2022.792%20109.636%2025.4111V26.2988H103.598V26.5186C103.598%2028.083%20104.442%2029.1201%20105.769%2029.1201C106.762%2029.1201%20107.439%2028.6279%20107.677%2027.8281H109.531C109.25%2029.3311%20108.037%2030.6582%20105.743%2030.6582ZM103.598%2024.9365H107.729V24.9189C107.729%2023.6006%20106.912%2022.5635%20105.673%2022.5635C104.416%2022.5635%20103.598%2023.6006%20103.598%2024.9189V24.9365Z'%20fill='%231B1B1B'/%3e%3c/svg%3e", Nq = "data:image/svg+xml,%3csvg%20width='120'%20height='40'%20viewBox='0%200%20120%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='0.5'%20y='0.5'%20width='119'%20height='39'%20rx='5.5'%20fill='white'/%3e%3crect%20x='0.5'%20y='0.5'%20width='119'%20height='39'%20rx='5.5'%20stroke='%23E1E1E1'/%3e%3cpath%20d='M17.8051%2019.4617L8.08984%2030.0059C8.09076%2030.0078%208.09076%2030.0106%208.09167%2030.0125C8.39005%2031.1574%209.41203%2032%2010.6256%2032C11.1111%2032%2011.5664%2031.8656%2011.957%2031.6305L11.988%2031.6118L22.9232%2025.1593L17.8051%2019.4617Z'%20fill='%23EA4335'/%3e%3cpath%20d='M27.6332%2017.6642L27.624%2017.6577L22.9029%2014.8593L17.584%2019.6994L22.922%2025.1562L27.6177%2022.3858C28.4407%2021.9305%2029.0001%2021.0431%2029.0001%2020.0204C29.0001%2019.0033%2028.4489%2018.1205%2027.6332%2017.6642Z'%20fill='%23FBBC04'/%3e%3cpath%20d='M8.08942%209.9952C8.03102%2010.2154%208%2010.4468%208%2010.6857V29.3182C8%2029.5571%208.03102%2029.7885%208.09034%2030.0078L18.1386%2019.7332L8.08942%209.9952Z'%20fill='%234285F4'/%3e%3cpath%20d='M17.8762%2020L22.904%2014.8594L11.9815%208.3836C11.5846%208.14005%2011.1211%208.00009%2010.6256%208.00009C9.41197%208.00009%208.38816%208.84456%208.08978%209.99043C8.08978%209.99136%208.08887%209.9923%208.08887%209.99323L17.8762%2020Z'%20fill='%2334A853'/%3e%3cpath%20d='M43.61%2011.71C43.61%2012.71%2043.3133%2013.5067%2042.72%2014.1C42.0533%2014.8067%2041.1767%2015.16%2040.09%2015.16C39.05%2015.16%2038.17%2014.8%2037.45%2014.08C36.73%2013.36%2036.37%2012.4733%2036.37%2011.42C36.37%2010.3667%2036.73%209.48%2037.45%208.76C38.17%208.04%2039.05%207.68%2040.09%207.68C40.6167%207.68%2041.1133%207.77333%2041.58%207.96C42.0467%208.14667%2042.43%208.41%2042.73%208.75L42.07%209.41C41.85%209.14333%2041.5633%208.93667%2041.21%208.79C40.8633%208.63667%2040.49%208.56%2040.09%208.56C39.31%208.56%2038.65%208.83%2038.11%209.37C37.5767%209.91667%2037.31%2010.6%2037.31%2011.42C37.31%2012.24%2037.5767%2012.9233%2038.11%2013.47C38.65%2014.01%2039.31%2014.28%2040.09%2014.28C40.8033%2014.28%2041.3967%2014.08%2041.87%2013.68C42.3433%2013.28%2042.6167%2012.73%2042.69%2012.03H40.09V11.17H43.56C43.5933%2011.3567%2043.61%2011.5367%2043.61%2011.71ZM48.9078%207.84V8.72H45.6478V10.99H48.5878V11.85H45.6478V14.12H48.9078V15H44.7278V7.84H48.9078ZM52.5877%208.72V15H51.6677V8.72H49.6677V7.84H54.5877V8.72H52.5877ZM58.6654%2015H57.7454V7.84H58.6654V15ZM62.5487%208.72V15H61.6287V8.72H59.6287V7.84H64.5487V8.72H62.5487ZM74.521%2011.42C74.521%2012.48%2074.1677%2013.3667%2073.461%2014.08C72.7477%2014.8%2071.8743%2015.16%2070.841%2015.16C69.801%2015.16%2068.9277%2014.8%2068.221%2014.08C67.5143%2013.3667%2067.161%2012.48%2067.161%2011.42C67.161%2010.36%2067.5143%209.47333%2068.221%208.76C68.9277%208.04%2069.801%207.68%2070.841%207.68C71.881%207.68%2072.7543%208.04333%2073.461%208.77C74.1677%209.48333%2074.521%2010.3667%2074.521%2011.42ZM68.101%2011.42C68.101%2012.2467%2068.361%2012.93%2068.881%2013.47C69.4077%2014.01%2070.061%2014.28%2070.841%2014.28C71.621%2014.28%2072.271%2014.01%2072.791%2013.47C73.3177%2012.9367%2073.581%2012.2533%2073.581%2011.42C73.581%2010.5867%2073.3177%209.90333%2072.791%209.37C72.271%208.83%2071.621%208.56%2070.841%208.56C70.061%208.56%2069.4077%208.83%2068.881%209.37C68.361%209.91%2068.101%2010.5933%2068.101%2011.42ZM76.5267%2015H75.6067V7.84H76.7267L80.2067%2013.41H80.2467L80.2067%2012.03V7.84H81.1267V15H80.1667L76.5267%209.16H76.4867L76.5267%2010.54V15Z'%20fill='%231B1B1B'/%3e%3cpath%20d='M93.5181%2031.4097H95.1469V20.3981H93.5181V31.4097ZM108.189%2024.3646L106.322%2029.1388H106.266L104.328%2024.3646H102.573L105.479%2031.0371L103.823%2034.749H105.521L110%2024.3646H108.189ZM98.9519%2030.1588C98.4176%2030.1588%2097.6739%2029.8902%2097.6739%2029.2234C97.6739%2028.3742%2098.6001%2028.0483%2099.4005%2028.0483C100.116%2028.0483%20100.454%2028.2042%20100.889%2028.4165C100.762%2029.4365%2099.892%2030.1588%2098.9519%2030.1588ZM99.1483%2024.1241C97.969%2024.1241%2096.7469%2024.6482%2096.2424%2025.8101L97.6879%2026.4188C97.9969%2025.8101%2098.5721%2025.611%2099.1762%2025.611C100.019%2025.611%20100.875%2026.121%20100.889%2027.0283V27.1411C100.594%2026.971%2099.9627%2026.7165%2099.1902%2026.7165C97.632%2026.7165%2096.0451%2027.5806%2096.0451%2029.1952C96.0451%2030.6689%2097.323%2031.6184%2098.7546%2031.6184C99.8501%2031.6184%20100.454%2031.1225%20100.833%2030.5411H100.889V31.3912H102.461V27.1692C102.461%2025.2146%20101.015%2024.1241%2099.1483%2024.1241ZM89.0821%2025.7053H86.7655V21.9308H89.0821C90.2998%2021.9308%2090.9911%2022.9482%2090.9911%2023.8176C90.9911%2024.6711%2090.2998%2025.7053%2089.0821%2025.7053ZM89.0402%2020.3981H85.1375V31.4097H86.7655V27.2379H89.0402C90.8453%2027.2379%2092.6199%2025.9184%2092.6199%2023.8176C92.6199%2021.7168%2090.8453%2020.3981%2089.0402%2020.3981ZM67.7583%2030.1606C66.6332%2030.1606%2065.6913%2029.2102%2065.6913%2027.9047C65.6913%2026.5852%2066.6332%2025.6198%2067.7583%2025.6198C68.8695%2025.6198%2069.7406%2026.5852%2069.7406%2027.9047C69.7406%2029.2102%2068.8695%2030.1606%2067.7583%2030.1606ZM69.6289%2024.9812H69.5722C69.2064%2024.5417%2068.5038%2024.1444%2067.6178%2024.1444C65.7611%2024.1444%2064.0599%2025.7898%2064.0599%2027.9047C64.0599%2030.0047%2065.7611%2031.6369%2067.6178%2031.6369C68.5038%2031.6369%2069.2064%2031.2396%2069.5722%2030.7851H69.6289V31.3251C69.6289%2032.7582%2068.8695%2033.5246%2067.6457%2033.5246C66.6471%2033.5246%2066.0282%2032.8005%2065.7751%2032.1901L64.3549%2032.7864C64.7626%2033.78%2065.8458%2035%2067.6457%2035C69.5582%2035%2071.1757%2033.8646%2071.1757%2031.0978V24.3708H69.6289V24.9812ZM72.3008%2031.4097H73.9323V20.3973H72.3008V31.4097ZM76.3362%2027.777C76.2943%2026.3298%2077.4474%2025.5916%2078.2766%2025.5916C78.9243%2025.5916%2079.4725%2025.9176%2079.6549%2026.3862L76.3362%2027.777ZM81.3989%2026.528C81.0899%2025.6912%2080.1472%2024.1444%2078.2208%2024.1444C76.3083%2024.1444%2074.7196%2025.6621%2074.7196%2027.8907C74.7196%2029.9906%2076.2943%2031.6369%2078.4032%2031.6369C80.1053%2031.6369%2081.0899%2030.5869%2081.4976%2029.9765L80.2319%2029.1247C79.8103%2029.7493%2079.2333%2030.1606%2078.4032%2030.1606C77.5739%2030.1606%2076.983%2029.7774%2076.6033%2029.0261L81.5674%2026.9534L81.3989%2026.528ZM41.8501%2025.2939V26.883H45.6184C45.5058%2027.777%2045.2107%2028.4297%2044.7612%2028.8834C44.2121%2029.4374%2043.3541%2030.0479%2041.8501%2030.0479C39.5291%2030.0479%2037.7152%2028.1602%2037.7152%2025.8189C37.7152%2023.4767%2039.5291%2021.5899%2041.8501%2021.5899C43.1018%2021.5899%2044.0157%2022.0867%2044.6905%2022.7254L45.8017%2021.604C44.8589%2020.6959%2043.6081%2020%2041.8501%2020C38.6719%2020%2036%2022.6117%2036%2025.8189C36%2029.0261%2038.6719%2031.6369%2041.8501%2031.6369C43.5653%2031.6369%2044.8589%2031.0688%2045.8715%2030.0047C46.9129%2028.9547%2047.2358%2027.4793%2047.2358%2026.2866C47.2358%2025.9176%2047.2079%2025.5775%2047.1512%2025.2939H41.8501ZM51.5208%2030.1606C50.3957%2030.1606%2049.425%2029.2243%2049.425%2027.8907C49.425%2026.5421%2050.3957%2025.6198%2051.5208%2025.6198C52.6451%2025.6198%2053.6158%2026.5421%2053.6158%2027.8907C53.6158%2029.2243%2052.6451%2030.1606%2051.5208%2030.1606ZM51.5208%2024.1444C49.4669%2024.1444%2047.7936%2025.7194%2047.7936%2027.8907C47.7936%2030.0479%2049.4669%2031.6369%2051.5208%2031.6369C53.5739%2031.6369%2055.2472%2030.0479%2055.2472%2027.8907C55.2472%2025.7194%2053.5739%2024.1444%2051.5208%2024.1444ZM59.65%2030.1606C58.5249%2030.1606%2057.5542%2029.2243%2057.5542%2027.8907C57.5542%2026.5421%2058.5249%2025.6198%2059.65%2025.6198C60.7752%2025.6198%2061.745%2026.5421%2061.745%2027.8907C61.745%2029.2243%2060.7752%2030.1606%2059.65%2030.1606ZM59.65%2024.1444C57.597%2024.1444%2055.9237%2025.7194%2055.9237%2027.8907C55.9237%2030.0479%2057.597%2031.6369%2059.65%2031.6369C61.7031%2031.6369%2063.3764%2030.0479%2063.3764%2027.8907C63.3764%2025.7194%2061.7031%2024.1444%2059.65%2024.1444Z'%20fill='%231B1B1B'/%3e%3c/svg%3e", Hq = { class: "mobile-apps" }, Fq = ["href"], Rq = ["href"], Vq = {
  __name: "F3MobileApps",
  props: {
    iosLink: {
      type: String,
      default: ""
    },
    androidLink: {
      type: String,
      default: ""
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (d(), f("div", Hq, [
      e.iosLink || e.isPreview ? (d(), f("a", {
        key: 0,
        href: e.iosLink,
        target: "_blank",
        "data-mobile-app": "ios"
      }, n[0] || (n[0] = [
        c("img", {
          class: "app-link",
          src: Pq,
          alt: "Download our iOS App",
          "data-testid": "app-icon"
        }, null, -1)
      ]), 8, Fq)) : T("", !0),
      e.androidLink || e.isPreview ? (d(), f("a", {
        key: 1,
        href: e.androidLink,
        target: "_blank",
        "data-mobile-app": "android"
      }, n[1] || (n[1] = [
        c("img", {
          class: "app-link",
          src: Nq,
          alt: "Download our Android App",
          "data-testid": "app-icon"
        }, null, -1)
      ]), 8, Rq)) : T("", !0)
    ]));
  }
}, Bq = /* @__PURE__ */ B(Vq, [["__scopeId", "data-v-ad4995b9"]]), jq = { class: "social-links" }, Uq = ["data-social-media"], qq = ["href", "aria-label"], Gq = ["innerHTML"], Kq = {
  __name: "F3SocialLinks",
  props: {
    content: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = [
      {
        key: "twitter",
        name: "twitter",
        label: "Visit us on X, formerly Twitter",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.84808 3.89844C8.21062 3.89844 8.55016 4.07708 8.75531 4.37598L12.5619 9.9248L17.5375 4.16309C17.6826 3.99506 17.8937 3.89844 18.1157 3.89844C18.7692 3.89854 19.1208 4.66631 18.6938 5.16113L13.4555 11.2275L19.0444 19.376C19.5451 20.1059 19.0223 21.0986 18.1371 21.0986H15.1879C14.8254 21.0986 14.4858 20.92 14.2807 20.6211L10.3246 14.8545L5.16644 20.834C5.02135 21.0019 4.81021 21.0986 4.58832 21.0986C3.93487 21.0984 3.58354 20.3308 4.01019 19.8359L9.43207 13.5518L3.99164 5.62109C3.49093 4.89115 4.01369 3.89844 4.89886 3.89844H7.84808ZM15.1918 19.0908C15.3596 19.3355 15.6374 19.4814 15.934 19.4814H17.1567L7.84418 5.90625C7.67634 5.66157 7.39869 5.51465 7.10199 5.51465H5.88031L15.1918 19.0908Z" fill="white"/></svg>'
      },
      {
        key: "instagram",
        name: "instagram",
        label: "Visit us on Instagram",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 4.75C6.20507 4.75 4.75 6.20507 4.75 8V16C4.75 17.7949 6.20507 19.25 8 19.25H16C17.7949 19.25 19.25 17.7949 19.25 16V8C19.25 6.20507 17.7949 4.75 16 4.75H8ZM3.25 8C3.25 5.37665 5.37665 3.25 8 3.25H16C18.6234 3.25 20.75 5.37665 20.75 8V16C20.75 18.6234 18.6234 20.75 16 20.75H8C5.37665 20.75 3.25 18.6234 3.25 16V8ZM15.65 7.6C15.65 7.18579 15.9858 6.85 16.4 6.85H16.408C16.8222 6.85 17.158 7.18579 17.158 7.6C17.158 8.01421 16.8222 8.35 16.408 8.35H16.4C15.9858 8.35 15.65 8.01421 15.65 7.6ZM12.394 9.54189C11.8842 9.4663 11.3636 9.55337 10.9062 9.79071C10.4488 10.0281 10.0779 10.4036 9.84619 10.8639C9.6145 11.3242 9.53386 11.8458 9.61573 12.3546C9.6976 12.8634 9.93781 13.3334 10.3022 13.6978C10.6666 14.0622 11.1366 14.3024 11.6454 14.3843C12.1542 14.4661 12.6758 14.3855 13.1361 14.1538C13.5964 13.9221 13.9719 13.5512 14.2093 13.0938C14.4466 12.6364 14.5337 12.1158 14.4581 11.606C14.381 11.086 14.1387 10.6047 13.767 10.233C13.3953 9.86128 12.914 9.61899 12.394 9.54189ZM10.2154 8.45928C10.9528 8.07662 11.7922 7.93624 12.614 8.05811C13.4523 8.18242 14.2284 8.57306 14.8277 9.17232C15.4269 9.77157 15.8176 10.5477 15.9419 11.386C16.0638 12.2078 15.9234 13.0472 15.5407 13.7846C15.1581 14.5221 14.5526 15.1201 13.8105 15.4937C13.0684 15.8672 12.2274 15.9972 11.4071 15.8652C10.5868 15.7332 9.82903 15.3459 9.24154 14.7585C8.65406 14.171 8.26677 13.4132 8.13478 12.5929C8.00279 11.7726 8.1328 10.9316 8.50633 10.1895C8.87987 9.44738 9.4779 8.84193 10.2154 8.45928Z" fill="white"/></svg>'
      },
      {
        key: "facebook",
        name: "facebook",
        label: "Visit us on Facebook",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.1409 4.64124C12.0317 3.75044 13.2398 3.25 14.4996 3.25H16.8996C17.3138 3.25 17.6496 3.58579 17.6496 4V7.2C17.6496 7.61421 17.3138 7.95 16.8996 7.95H14.4996C14.4863 7.95 14.4736 7.95527 14.4643 7.96464C14.4549 7.97402 14.4496 7.98674 14.4496 8V9.65H16.8996C17.1306 9.65 17.3486 9.7564 17.4908 9.93844C17.6329 10.1205 17.6832 10.3578 17.6272 10.5819L16.8272 13.7819C16.7437 14.1158 16.4438 14.35 16.0996 14.35H14.4496V20C14.4496 20.4142 14.1138 20.75 13.6996 20.75H10.4996C10.0854 20.75 9.74961 20.4142 9.74961 20V14.35H8.09961C7.6854 14.35 7.34961 14.0142 7.34961 13.6V10.4C7.34961 9.98579 7.6854 9.65 8.09961 9.65H9.74961V8C9.74961 6.74022 10.2501 5.53204 11.1409 4.64124ZM14.4996 4.75C13.6377 4.75 12.811 5.09241 12.2015 5.7019C11.592 6.3114 11.2496 7.13805 11.2496 8V10.4C11.2496 10.8142 10.9138 11.15 10.4996 11.15H8.84961V12.85H10.4996C10.9138 12.85 11.2496 13.1858 11.2496 13.6V19.25H12.9496V13.6C12.9496 13.1858 13.2854 12.85 13.6996 12.85H15.514L15.939 11.15H13.6996C13.2854 11.15 12.9496 10.8142 12.9496 10.4V8C12.9496 7.58891 13.1129 7.19467 13.4036 6.90398C13.6943 6.6133 14.0885 6.45 14.4996 6.45H16.1496V4.75H14.4996Z" fill="white"/></svg>'
      },
      {
        key: "threads",
        name: "threads",
        label: "Visit us on Threads",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8286 11.4157C15.7597 11.3827 15.6897 11.3509 15.6188 11.3204C15.4953 9.04485 14.2519 7.74208 12.164 7.72875C12.1546 7.72869 12.1451 7.72869 12.1357 7.72869C10.8869 7.72869 9.84828 8.26174 9.20902 9.23173L10.3573 10.0194C10.8348 9.29486 11.5843 9.1404 12.1362 9.1404C12.1426 9.1404 12.149 9.1404 12.1553 9.14046C12.8428 9.14484 13.3615 9.34472 13.6973 9.7345C13.9416 10.0183 14.105 10.4104 14.1859 10.9053C13.5764 10.8017 12.9173 10.7699 12.2126 10.8103C10.2276 10.9246 8.95145 12.0823 9.03715 13.691C9.08065 14.507 9.48716 15.209 10.1818 15.6676C10.7691 16.0553 11.5254 16.2448 12.3115 16.2019C13.3497 16.145 14.1641 15.7489 14.7323 15.0247C15.1638 14.4747 15.4367 13.7619 15.5572 12.8638C16.0519 13.1624 16.4186 13.5553 16.6211 14.0277C16.9654 14.8306 16.9855 16.15 15.9089 17.2257C14.9657 18.168 13.8319 18.5757 12.1183 18.5883C10.2175 18.5742 8.78 17.9646 7.84536 16.7764C6.97015 15.6638 6.51783 14.0568 6.50095 12C6.51783 9.94315 6.97015 8.33613 7.84536 7.22356C8.78 6.03541 10.2175 5.42583 12.1183 5.41171C14.0329 5.42594 15.4954 6.03845 16.4659 7.23233C16.9417 7.8178 17.3004 8.55407 17.5369 9.41253L18.8825 9.05352C18.5959 7.99685 18.1448 7.08631 17.5309 6.33117C16.2869 4.80056 14.4674 4.01626 12.123 4H12.1136C9.77399 4.01621 7.97486 4.80348 6.76621 6.33994C5.69068 7.7072 5.13589 9.60964 5.11725 11.9944L5.11719 12L5.11725 12.0056C5.13589 14.3903 5.69068 16.2928 6.76621 17.6601C7.97486 19.1965 9.77399 19.9838 12.1136 20H12.123C14.203 19.9856 15.6692 19.441 16.877 18.2343C18.4573 16.6555 18.4097 14.6766 17.8889 13.4618C17.5152 12.5906 16.8028 11.883 15.8286 11.4157ZM12.2372 14.7923C11.3672 14.8413 10.4634 14.4508 10.4188 13.6143C10.3858 12.9942 10.8602 12.3022 12.2906 12.2197C12.4544 12.2103 12.6152 12.2057 12.7731 12.2057C13.2927 12.2057 13.7788 12.2561 14.2207 12.3528C14.0559 14.4113 13.089 14.7455 12.2372 14.7923Z" fill="white"/></svg>'
      },
      {
        key: "youtube",
        name: "youtube",
        label: "Visit us on Youtube",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.06475 6.33287C3.86849 6.39253 3.68975 6.49964 3.54446 6.64494C3.39567 6.79372 3.28693 6.97758 3.22817 7.1794C2.55806 10.3582 2.55806 13.6418 3.22817 16.8206C3.28693 17.0224 3.39567 17.2063 3.54446 17.3551C3.68975 17.5004 3.86849 17.6075 4.06475 17.6671C9.31916 18.533 14.6799 18.533 19.9343 17.6671C20.1305 17.6075 20.3093 17.5004 20.4546 17.3551C20.6034 17.2063 20.7121 17.0224 20.7709 16.8206C21.441 13.6418 21.441 10.3582 20.7709 7.1794C20.7121 6.97758 20.6034 6.79372 20.4546 6.64494C20.3093 6.49964 20.1305 6.39253 19.9343 6.33287C14.6799 5.46717 9.31917 5.46717 4.06475 6.33287ZM3.77694 4.86008C9.22155 3.9581 14.7775 3.9581 20.2221 4.86008C20.2476 4.86431 20.2729 4.86985 20.2978 4.87669C20.7582 5.0029 21.1777 5.24676 21.5152 5.58428C21.8528 5.9218 22.0966 6.34136 22.2228 6.80169C22.2267 6.81587 22.2302 6.83015 22.2332 6.84453C22.9535 10.2438 22.9535 13.7562 22.2332 17.1555C22.2302 17.1698 22.2267 17.1841 22.2228 17.1983C22.0966 17.6586 21.8528 18.0782 21.5152 18.4157C21.1777 18.7532 20.7582 18.9971 20.2978 19.1233C20.2729 19.1301 20.2476 19.1357 20.2221 19.1399C14.7775 20.0421 9.22153 20.0421 3.77692 19.1399C3.75141 19.1357 3.72614 19.1301 3.70121 19.1233C3.24087 18.9971 2.82132 18.7532 2.4838 18.4157C2.14628 18.0782 1.90242 17.6586 1.77621 17.1983C1.77232 17.1841 1.76886 17.1698 1.76581 17.1555C1.04551 13.7562 1.04551 10.2438 1.76581 6.84453C1.76886 6.83015 1.77232 6.81587 1.77621 6.80169C1.90242 6.34136 2.14628 5.9218 2.4838 5.58428C2.82131 5.24676 3.24087 5.0029 3.70121 4.87669C3.72615 4.86985 3.75143 4.86431 3.77694 4.86008ZM9.62999 8.34735C9.86513 8.21422 10.1537 8.21786 10.3854 8.35688L15.3854 11.3569C15.6113 11.4924 15.7495 11.7366 15.7495 12C15.7495 12.2634 15.6113 12.5076 15.3854 12.6431L10.3854 15.6431C10.1537 15.7821 9.86513 15.7858 9.62999 15.6526C9.39486 15.5195 9.24952 15.2702 9.24952 15V9C9.24952 8.72979 9.39486 8.48048 9.62999 8.34735ZM10.7495 10.3246V13.6754L13.5418 12L10.7495 10.3246Z" fill="white"/></svg>'
      },
      {
        key: "linkedin",
        name: "linkedin",
        label: "Visit us on LinkedIn",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.22861 4.75C4.69959 4.75 4.28266 5.17484 4.28266 5.68421C4.28266 6.19358 4.69959 6.61842 5.22861 6.61842C5.75762 6.61842 6.17455 6.19358 6.17455 5.68421C6.17455 5.17484 5.75762 4.75 5.22861 4.75ZM2.78906 5.68421C2.78906 4.33325 3.88787 3.25 5.22861 3.25C6.56934 3.25 7.66815 4.33325 7.66815 5.68421C7.66815 7.03517 6.56935 8.11842 5.22861 8.11842C3.88787 8.11842 2.78906 7.03517 2.78906 5.68421ZM15.3851 9.80263C14.2341 9.80263 13.1316 10.2576 12.3198 11.0653C11.5083 11.8728 11.0536 12.9664 11.0536 14.1053V19.25H12.9455V14.1053C12.9455 13.4574 13.2043 12.8375 13.6625 12.3815C14.1206 11.9258 14.7403 11.6711 15.3851 11.6711C16.0299 11.6711 16.6496 11.9258 17.1076 12.3815C17.5659 12.8375 17.8246 13.4574 17.8246 14.1053V19.25H19.7165V14.1053C19.7165 12.9664 19.2619 11.8728 18.4503 11.0653C17.6386 10.2576 16.5361 9.80263 15.3851 9.80263ZM11.2686 9.99971C12.3616 8.91229 13.8424 8.30263 15.3851 8.30263C16.9277 8.30263 18.4086 8.91229 19.5015 9.99971C20.5947 11.0874 21.2101 12.564 21.2101 14.1053V20C21.2101 20.4142 20.8758 20.75 20.4633 20.75H17.0778C16.6654 20.75 16.331 20.4142 16.331 20V14.1053C16.331 13.8598 16.2331 13.6229 16.0564 13.4471C15.8796 13.2712 15.6382 13.1711 15.3851 13.1711C15.132 13.1711 14.8906 13.2712 14.7137 13.4471C14.5371 13.6229 14.4391 13.8598 14.4391 14.1053V20C14.4391 20.4142 14.1048 20.75 13.6923 20.75H10.3068C9.8944 20.75 9.56004 20.4142 9.56004 20V14.1053C9.56004 12.564 10.1755 11.0874 11.2686 9.99971ZM2.78906 9.89474C2.78906 9.48052 3.12342 9.14474 3.53586 9.14474H6.92135C7.3338 9.14474 7.66815 9.48052 7.66815 9.89474V20C7.66815 20.4142 7.3338 20.75 6.92135 20.75H3.53586C3.12342 20.75 2.78906 20.4142 2.78906 20V9.89474ZM4.28266 10.6447V19.25H6.17455V10.6447H4.28266Z" fill="white"/></svg>'
      }
    ], r = Mn(() => n.filter((o) => t.content[o.key] || t.isPreview));
    return (o, i) => (d(), f("ul", jq, [
      (d(!0), f(J, null, ne(r.value, (a) => (d(), f("li", {
        key: a.key,
        "data-social-media": a.name,
        "data-testid": "social-icon"
      }, [
        c("a", {
          href: e.content[a.key],
          target: "_blank",
          "aria-label": a.label
        }, [
          c("span", {
            innerHTML: a.icon
          }, null, 8, Gq)
        ], 8, qq)
      ], 8, Uq))), 128))
    ]));
  }
}, zq = /* @__PURE__ */ B(Kq, [["__scopeId", "data-v-252ff1aa"]]), Zq = {
  href: "https://www.apptegy.com",
  target: "_blank",
  class: "notranslate"
}, xq = { class: "sr-only" }, Wq = {
  __name: "F3Copyright",
  props: {
    translations: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    org: {
      type: String,
      required: !0
    },
    theme: {
      type: Object,
      required: !0,
      default: () => ({ version: "" })
    }
  },
  setup(e) {
    const t = e, n = Mn(() => (/* @__PURE__ */ new Date()).getFullYear()), r = Mn(() => t.theme.version ? t.theme.version.toLowerCase() : "");
    return (o, i) => (d(), f("div", {
      class: _(["apptegy-copyright", r.value])
    }, [
      c("span", null, [
        H(k(e.translations.copyright) + " © " + k(n.value) + ". " + k(e.org) + ". " + k(e.translations.all_rights_reserved) + " " + k(e.translations.powered_by) + " ", 1),
        c("a", Zq, [
          i[0] || (i[0] = H(" Apptegy")),
          c("span", xq, k(e.translations.visit_us), 1)
        ]),
        i[1] || (i[1] = H(". "))
      ])
    ], 2));
  }
}, Yq = /* @__PURE__ */ B(Wq, [["__scopeId", "data-v-37499707"]]), Xq = {
  name: "F3",
  components: {
    FooterHeader: U3,
    FooterLink: q3,
    FooterImage: K3,
    FooterTextField: G3,
    F3ContactInfo: Oq,
    F3MobileApps: Bq,
    F3SocialLinks: zq,
    F3Copyright: Yq
  },
  mixins: [W0],
  computed: {
    showContactInfo() {
      return Object.values(this.info).some(Boolean);
    },
    showMobileApps() {
      return this.content.hasApps || this.isPreview;
    },
    showSocialLinks() {
      return this.content.hasSocial || this.isPreview;
    },
    enableImage() {
      var e, t;
      return (t = (e = this.theme) == null ? void 0 : e.enable_image) != null ? t : !1;
    },
    numColumns() {
      var e, t;
      return (t = (e = this.theme) == null ? void 0 : e.num_columns) != null ? t : 1;
    },
    wrapperClasses() {
      return [`layout-cols-${this.numColumns}`, this.enableImage ? "with-image" : "no-image"];
    }
  }
}, Qq = { class: "columns-wrapper" }, Jq = {
  key: 0,
  class: "logo-wrapper"
}, eG = ["src"], tG = { class: "columns-area" }, nG = { class: "column-item-content" }, rG = ["innerHTML"], oG = {
  key: 0,
  class: "column-item-content"
}, iG = {
  key: 0,
  class: "image-area"
}, sG = ["src", "alt"], aG = ["innerHTML"];
function lG(e, t, n, r, o, i) {
  var m, v;
  const a = V("F3ContactInfo"), s = V("F3MobileApps"), l = V("F3SocialLinks"), u = V("F3Copyright");
  return d(), f("footer", {
    id: "footer-f3",
    style: Z(e.cssVars)
  }, [
    c("div", {
      class: _(["content-wrapper", i.wrapperClasses])
    }, [
      c("div", Qq, [
        e.content.hasLogo || e.isPreview ? (d(), f("div", Jq, [
          c("img", {
            src: e.logoImage,
            alt: "logo",
            class: "footer-logo"
          }, null, 8, eG)
        ])) : T("", !0),
        c("div", tG, [
          (d(!0), f(J, null, ne(i.numColumns, (g) => (d(), f("div", {
            key: `column-${g}`,
            class: "column-item"
          }, [
            g === 1 ? (d(), f(J, { key: 0 }, [
              c("div", nG, [
                e.firstColumnHeader ? (d(), f("h2", {
                  key: 0,
                  class: _(e.theme.style)
                }, k(e.firstColumnHeader), 3)) : T("", !0),
                i.showContactInfo ? (d(), I(a, {
                  key: 1,
                  info: e.info
                }, null, 8, ["info"])) : T("", !0)
              ]),
              i.showMobileApps ? (d(), I(s, {
                key: 0,
                "is-preview": e.isPreview,
                "ios-link": e.iosLink,
                "android-link": e.androidLink
              }, null, 8, ["is-preview", "ios-link", "android-link"])) : T("", !0),
              i.showSocialLinks ? (d(), I(l, {
                key: 1,
                "is-preview": e.isPreview,
                content: e.content
              }, null, 8, ["is-preview", "content"])) : T("", !0),
              e.content.hasAdditionalText && e.content.additionalTextAlignment === "left" ? (d(), f("div", {
                key: 2,
                class: "additional-text",
                innerHTML: e.content.additionalText
              }, null, 8, rG)) : T("", !0)
            ], 64)) : (d(), f(J, { key: 1 }, [
              e.content.columns[g - 1] ? (d(), f("div", oG, [
                e.content.columns[g - 1].hasHeader ? (d(), f("h2", {
                  key: 0,
                  class: _(e.theme.style)
                }, k(e.content.columns[g - 1].header), 3)) : T("", !0),
                c("ul", null, [
                  (d(!0), f(J, null, ne(e.content.columns[g - 1].items, (h, E) => (d(), f("li", { key: E }, [
                    (d(), I(Y(h.type), {
                      item: h,
                      theme: e.theme,
                      class: _(e.theme.style)
                    }, null, 8, ["item", "theme", "class"]))
                  ]))), 128))
                ])
              ])) : T("", !0)
            ], 64))
          ]))), 128))
        ])
      ]),
      i.enableImage ? (d(), f("div", iG, [
        c("img", {
          src: (m = e.content.image) == null ? void 0 : m.url,
          alt: (v = e.content.image) == null ? void 0 : v.alt_text
        }, null, 8, sG)
      ])) : T("", !0)
    ], 2),
    e.content.hasAdditionalText && e.content.additionalTextAlignment === "center" ? (d(), f("div", {
      key: 0,
      class: "additional-text center",
      innerHTML: e.content.additionalText
    }, null, 8, aG)) : T("", !0),
    j(u, {
      translations: e.translations,
      org: e.copyrightOrg,
      theme: e.theme
    }, null, 8, ["translations", "org", "theme"])
  ], 4);
}
const uG = /* @__PURE__ */ B(Xq, [["render", lG], ["__scopeId", "data-v-79570736"]]), dG = {
  name: "CmsFooter",
  components: {
    F1: GU,
    F2: yq,
    F3: uG,
    CustomHtml: Gs
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    organizations: {
      type: Array,
      default: () => []
    },
    iosLink: {
      type: String,
      default: ""
    },
    androidLink: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    currentDomain: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    themeVersion() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.version) == null ? void 0 : t.toLowerCase()) || "";
    },
    translations() {
      return this.theme.translations;
    },
    cssVars() {
      return {
        "--bg-color": $(this.theme, "bg_color.hex", "#ffffff"),
        "--separator-color": $(this.theme, "separator_color.hex", "#ffffff"),
        "--text-color": $(this.theme, "text_link_color.hex", "#000000"),
        "--apptegy-link-color": $(this.theme, "apptegy_link_color.hex", "#000000"),
        "--social-media-icon-color": $(this.theme, "social_media_icon_color.hex", "#000000")
      };
    }
  }
};
function cG(e, t, n, r, o, i) {
  const a = V("custom-html");
  return d(), f("div", null, [
    n.theme.version !== "CustomFooter" ? (d(), f("div", {
      key: 0,
      id: "cms-footer",
      style: Z(i.cssVars)
    }, [
      (d(), I(Y(n.theme.version), {
        theme: n.theme,
        content: n.content,
        organizations: n.organizations,
        "ios-link": n.iosLink,
        "android-link": n.androidLink,
        "is-preview": n.isPreview,
        "is-i-frame": n.isIFrame,
        "current-domain": n.currentDomain,
        logo: n.logo
      }, null, 8, ["theme", "content", "organizations", "ios-link", "android-link", "is-preview", "is-i-frame", "current-domain", "logo"]))
    ], 4)) : (d(), I(a, {
      key: 1,
      theme: n.theme
    }, null, 8, ["theme"]))
  ]);
}
const hG = /* @__PURE__ */ B(dG, [["render", cG], ["__scopeId", "data-v-182ba638"]]);
var pd, Vf;
function mG() {
  if (Vf) return pd;
  Vf = 1;
  var e = ws();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return pd = t, pd;
}
var gd, Bf;
function fG() {
  if (Bf) return gd;
  Bf = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return gd = e, gd;
}
var vd, jf;
function pG() {
  if (jf) return vd;
  jf = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return vd = e, vd;
}
var bd, Uf;
function gG() {
  if (Uf) return bd;
  Uf = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return bd = e, bd;
}
var yd, qf;
function vG() {
  if (qf) return yd;
  qf = 1;
  var e = ws(), t = t0(), n = sg(), r = 200;
  function o(i, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var l = s.__data__;
      if (!t || l.length < r - 1)
        return l.push([i, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(l);
    }
    return s.set(i, a), this.size = s.size, this;
  }
  return yd = o, yd;
}
var _d, Gf;
function bG() {
  if (Gf) return _d;
  Gf = 1;
  var e = ws(), t = mG(), n = fG(), r = pG(), o = gG(), i = vG();
  function a(s) {
    var l = this.__data__ = new e(s);
    this.size = l.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = o, a.prototype.set = i, _d = a, _d;
}
var Cd, Kf;
function yG() {
  if (Kf) return Cd;
  Kf = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o && n(t[r], r, t) !== !1; )
      ;
    return t;
  }
  return Cd = e, Cd;
}
var wd, zf;
function _G() {
  if (zf) return wd;
  zf = 1;
  var e = Rr(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch (r) {
    }
  }();
  return wd = t, wd;
}
var Td, Zf;
function Q3() {
  if (Zf) return Td;
  Zf = 1;
  var e = _G();
  function t(n, r, o) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : n[r] = o;
  }
  return Td = t, Td;
}
var kd, xf;
function J3() {
  if (xf) return kd;
  xf = 1;
  var e = Q3(), t = e0(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, s) {
    var l = i[a];
    (!(r.call(i, a) && t(l, s)) || s === void 0 && !(a in i)) && e(i, a, s);
  }
  return kd = o, kd;
}
var Ed, Wf;
function Ks() {
  if (Wf) return Ed;
  Wf = 1;
  var e = J3(), t = Q3();
  function n(r, o, i, a) {
    var s = !i;
    i || (i = {});
    for (var l = -1, u = o.length; ++l < u; ) {
      var m = o[l], v = a ? a(i[m], r[m], m, i, r) : void 0;
      v === void 0 && (v = r[m]), s ? t(i, m, v) : e(i, m, v);
    }
    return i;
  }
  return Ed = n, Ed;
}
var Sd, Yf;
function CG() {
  if (Yf) return Sd;
  Yf = 1;
  function e(t, n) {
    for (var r = -1, o = Array(t); ++r < t; )
      o[r] = n(r);
    return o;
  }
  return Sd = e, Sd;
}
var Md, Xf;
function e8() {
  if (Xf) return Md;
  Xf = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var i = typeof r;
    return o = o == null ? e : o, !!o && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return Md = n, Md;
}
var Ad, Qf;
function t8() {
  if (Qf) return Ad;
  Qf = 1;
  var e = CG(), t = mg(), n = Fr(), r = r0(), o = e8(), i = pg(), a = Object.prototype, s = a.hasOwnProperty;
  function l(u, m) {
    var v = n(u), g = !v && t(u), h = !v && !g && r(u), E = !v && !g && !h && i(u), C = v || g || h || E, A = C ? e(u.length, String) : [], R = A.length;
    for (var O in u)
      (m || s.call(u, O)) && !(C && // Safari 9 has enumerable `arguments.length` in strict mode.
      (O == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (O == "offset" || O == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      E && (O == "buffer" || O == "byteLength" || O == "byteOffset") || // Skip index properties.
      o(O, R))) && A.push(O);
    return A;
  }
  return Ad = l, Ad;
}
var Id, Jf;
function Y0() {
  if (Jf) return Id;
  Jf = 1;
  var e = t8(), t = hg(), n = Ms();
  function r(o) {
    return n(o) ? e(o) : t(o);
  }
  return Id = r, Id;
}
var Ld, ep;
function wG() {
  if (ep) return Ld;
  ep = 1;
  var e = Ks(), t = Y0();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Ld = n, Ld;
}
var Dd, tp;
function TG() {
  if (tp) return Dd;
  tp = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var r in Object(t))
        n.push(r);
    return n;
  }
  return Dd = e, Dd;
}
var $d, np;
function kG() {
  if (np) return $d;
  np = 1;
  var e = ur(), t = Es(), n = TG(), r = Object.prototype, o = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var s = t(a), l = [];
    for (var u in a)
      u == "constructor" && (s || !o.call(a, u)) || l.push(u);
    return l;
  }
  return $d = i, $d;
}
var Od, rp;
function X0() {
  if (rp) return Od;
  rp = 1;
  var e = t8(), t = kG(), n = Ms();
  function r(o) {
    return n(o) ? e(o, !0) : t(o);
  }
  return Od = r, Od;
}
var Pd, op;
function EG() {
  if (op) return Pd;
  op = 1;
  var e = Ks(), t = X0();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Pd = n, Pd;
}
var Wo = { exports: {} };
Wo.exports;
var ip;
function SG() {
  return ip || (ip = 1, function(e, t) {
    var n = dn(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
    function l(u, m) {
      if (m)
        return u.slice();
      var v = u.length, g = s ? s(v) : new u.constructor(v);
      return u.copy(g), g;
    }
    e.exports = l;
  }(Wo, Wo.exports)), Wo.exports;
}
var Nd, sp;
function MG() {
  if (sp) return Nd;
  sp = 1;
  function e(t, n) {
    var r = -1, o = t.length;
    for (n || (n = Array(o)); ++r < o; )
      n[r] = t[r];
    return n;
  }
  return Nd = e, Nd;
}
var Hd, ap;
function AG() {
  if (ap) return Hd;
  ap = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = 0, a = []; ++r < o; ) {
      var s = t[r];
      n(s, r, t) && (a[i++] = s);
    }
    return a;
  }
  return Hd = e, Hd;
}
var Fd, lp;
function n8() {
  if (lp) return Fd;
  lp = 1;
  function e() {
    return [];
  }
  return Fd = e, Fd;
}
var Rd, up;
function Q0() {
  if (up) return Rd;
  up = 1;
  var e = AG(), t = n8(), n = Object.prototype, r = n.propertyIsEnumerable, o = Object.getOwnPropertySymbols, i = o ? function(a) {
    return a == null ? [] : (a = Object(a), e(o(a), function(s) {
      return r.call(a, s);
    }));
  } : t;
  return Rd = i, Rd;
}
var Vd, dp;
function IG() {
  if (dp) return Vd;
  dp = 1;
  var e = Ks(), t = Q0();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Vd = n, Vd;
}
var Bd, cp;
function r8() {
  if (cp) return Bd;
  cp = 1;
  function e(t, n) {
    for (var r = -1, o = n.length, i = t.length; ++r < o; )
      t[i + r] = n[r];
    return t;
  }
  return Bd = e, Bd;
}
var jd, hp;
function o8() {
  if (hp) return jd;
  hp = 1;
  var e = cg(), t = e(Object.getPrototypeOf, Object);
  return jd = t, jd;
}
var Ud, mp;
function i8() {
  if (mp) return Ud;
  mp = 1;
  var e = r8(), t = o8(), n = Q0(), r = n8(), o = Object.getOwnPropertySymbols, i = o ? function(a) {
    for (var s = []; a; )
      e(s, n(a)), a = t(a);
    return s;
  } : r;
  return Ud = i, Ud;
}
var qd, fp;
function LG() {
  if (fp) return qd;
  fp = 1;
  var e = Ks(), t = i8();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return qd = n, qd;
}
var Gd, pp;
function s8() {
  if (pp) return Gd;
  pp = 1;
  var e = r8(), t = Fr();
  function n(r, o, i) {
    var a = o(r);
    return t(r) ? a : e(a, i(r));
  }
  return Gd = n, Gd;
}
var Kd, gp;
function DG() {
  if (gp) return Kd;
  gp = 1;
  var e = s8(), t = Q0(), n = Y0();
  function r(o) {
    return e(o, n, t);
  }
  return Kd = r, Kd;
}
var zd, vp;
function $G() {
  if (vp) return zd;
  vp = 1;
  var e = s8(), t = i8(), n = X0();
  function r(o) {
    return e(o, n, t);
  }
  return zd = r, zd;
}
var Zd, bp;
function OG() {
  if (bp) return Zd;
  bp = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(r) {
    var o = r.length, i = new r.constructor(o);
    return o && typeof r[0] == "string" && t.call(r, "index") && (i.index = r.index, i.input = r.input), i;
  }
  return Zd = n, Zd;
}
var xd, yp;
function PG() {
  if (yp) return xd;
  yp = 1;
  var e = dn(), t = e.Uint8Array;
  return xd = t, xd;
}
var Wd, _p;
function J0() {
  if (_p) return Wd;
  _p = 1;
  var e = PG();
  function t(n) {
    var r = new n.constructor(n.byteLength);
    return new e(r).set(new e(n)), r;
  }
  return Wd = t, Wd;
}
var Yd, Cp;
function NG() {
  if (Cp) return Yd;
  Cp = 1;
  var e = J0();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.byteLength);
  }
  return Yd = t, Yd;
}
var Xd, wp;
function HG() {
  if (wp) return Xd;
  wp = 1;
  var e = /\w*$/;
  function t(n) {
    var r = new n.constructor(n.source, e.exec(n));
    return r.lastIndex = n.lastIndex, r;
  }
  return Xd = t, Xd;
}
var Qd, Tp;
function FG() {
  if (Tp) return Qd;
  Tp = 1;
  var e = bs(), t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function r(o) {
    return n ? Object(n.call(o)) : {};
  }
  return Qd = r, Qd;
}
var Jd, kp;
function RG() {
  if (kp) return Jd;
  kp = 1;
  var e = J0();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.length);
  }
  return Jd = t, Jd;
}
var ec, Ep;
function VG() {
  if (Ep) return ec;
  Ep = 1;
  var e = J0(), t = NG(), n = HG(), r = FG(), o = RG(), i = "[object Boolean]", a = "[object Date]", s = "[object Map]", l = "[object Number]", u = "[object RegExp]", m = "[object Set]", v = "[object String]", g = "[object Symbol]", h = "[object ArrayBuffer]", E = "[object DataView]", C = "[object Float32Array]", A = "[object Float64Array]", R = "[object Int8Array]", O = "[object Int16Array]", F = "[object Int32Array]", L = "[object Uint8Array]", D = "[object Uint8ClampedArray]", P = "[object Uint16Array]", U = "[object Uint32Array]";
  function q(z, te, ee) {
    var x = z.constructor;
    switch (te) {
      case h:
        return e(z);
      case i:
      case a:
        return new x(+z);
      case E:
        return t(z, ee);
      case C:
      case A:
      case R:
      case O:
      case F:
      case L:
      case D:
      case P:
      case U:
        return o(z, ee);
      case s:
        return new x();
      case l:
      case v:
        return new x(z);
      case u:
        return n(z);
      case m:
        return new x();
      case g:
        return r(z);
    }
  }
  return ec = q, ec;
}
var tc, Sp;
function BG() {
  if (Sp) return tc;
  Sp = 1;
  var e = ur(), t = Object.create, n = /* @__PURE__ */ function() {
    function r() {
    }
    return function(o) {
      if (!e(o))
        return {};
      if (t)
        return t(o);
      r.prototype = o;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return tc = n, tc;
}
var nc, Mp;
function jG() {
  if (Mp) return nc;
  Mp = 1;
  var e = BG(), t = o8(), n = Es();
  function r(o) {
    return typeof o.constructor == "function" && !n(o) ? e(t(o)) : {};
  }
  return nc = r, nc;
}
var rc, Ap;
function UG() {
  if (Ap) return rc;
  Ap = 1;
  var e = Ss(), t = wo(), n = "[object Map]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return rc = r, rc;
}
var oc, Ip;
function qG() {
  if (Ip) return oc;
  Ip = 1;
  var e = UG(), t = o0(), n = i0(), r = n && n.isMap, o = r ? t(r) : e;
  return oc = o, oc;
}
var ic, Lp;
function GG() {
  if (Lp) return ic;
  Lp = 1;
  var e = Ss(), t = wo(), n = "[object Set]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return ic = r, ic;
}
var sc, Dp;
function KG() {
  if (Dp) return sc;
  Dp = 1;
  var e = GG(), t = o0(), n = i0(), r = n && n.isSet, o = r ? t(r) : e;
  return sc = o, sc;
}
var ac, $p;
function zG() {
  if ($p) return ac;
  $p = 1;
  var e = bG(), t = yG(), n = J3(), r = wG(), o = EG(), i = SG(), a = MG(), s = IG(), l = LG(), u = DG(), m = $G(), v = Ss(), g = OG(), h = VG(), E = jG(), C = Fr(), A = r0(), R = qG(), O = ur(), F = KG(), L = Y0(), D = X0(), P = 1, U = 2, q = 4, z = "[object Arguments]", te = "[object Array]", ee = "[object Boolean]", x = "[object Date]", N = "[object Error]", G = "[object Function]", X = "[object GeneratorFunction]", Q = "[object Map]", re = "[object Number]", se = "[object Object]", ue = "[object RegExp]", me = "[object Set]", he = "[object String]", _e = "[object Symbol]", De = "[object WeakMap]", Ae = "[object ArrayBuffer]", ze = "[object DataView]", Qe = "[object Float32Array]", Et = "[object Float64Array]", Vt = "[object Int8Array]", mn = "[object Int16Array]", fn = "[object Int32Array]", pn = "[object Uint8Array]", gn = "[object Uint8ClampedArray]", Ln = "[object Uint16Array]", St = "[object Uint32Array]", ce = {};
  ce[z] = ce[te] = ce[Ae] = ce[ze] = ce[ee] = ce[x] = ce[Qe] = ce[Et] = ce[Vt] = ce[mn] = ce[fn] = ce[Q] = ce[re] = ce[se] = ce[ue] = ce[me] = ce[he] = ce[_e] = ce[pn] = ce[gn] = ce[Ln] = ce[St] = !0, ce[N] = ce[G] = ce[De] = !1;
  function Mt(le, fe, Pe, Re, At, Ze) {
    var be, Je = fe & P, ht = fe & U, Wt = fe & q;
    if (Pe && (be = At ? Pe(le, Re, At, Ze) : Pe(le)), be !== void 0)
      return be;
    if (!O(le))
      return le;
    var vn = C(le);
    if (vn) {
      if (be = g(le), !Je)
        return a(le, be);
    } else {
      var et = v(le), mt = et == G || et == X;
      if (A(le))
        return i(le, Je);
      if (et == se || et == z || mt && !At) {
        if (be = ht || mt ? {} : E(le), !Je)
          return ht ? l(le, o(be, le)) : s(le, r(be, le));
      } else {
        if (!ce[et])
          return At ? le : {};
        be = h(le, et, Je);
      }
    }
    Ze || (Ze = new e());
    var bn = Ze.get(le);
    if (bn)
      return bn;
    Ze.set(le, be), F(le) ? le.forEach(function(Ce) {
      be.add(Mt(Ce, fe, Pe, Ce, le, Ze));
    }) : R(le) && le.forEach(function(Ce, Ne) {
      be.set(Ne, Mt(Ce, fe, Pe, Ne, le, Ze));
    });
    var Wn = Wt ? ht ? m : u : ht ? D : L, It = vn ? void 0 : Wn(le);
    return t(It || le, function(Ce, Ne) {
      It && (Ne = Ce, Ce = le[Ne]), n(be, Ne, Mt(Ce, fe, Pe, Ne, le, Ze));
    }), be;
  }
  return ac = Mt, ac;
}
var lc, Op;
function ZG() {
  if (Op) return lc;
  Op = 1;
  var e = zG(), t = 1, n = 4;
  function r(o) {
    return e(o, t | n);
  }
  return lc = r, lc;
}
var xG = ZG();
const WG = /* @__PURE__ */ Co(xG), yi = {
  mixins: [kt],
  components: { DraggableWrapper: vt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    programs: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    colors() {
      const e = this.sharedThemeColors(), t = $(this.theme, "box_bg_color.hex", "none"), n = `${t}cc`;
      return ge(ae({}, e), {
        "--accent-color": $(this.theme, "accent_color.hex", "#fff"),
        "--text-color": $(this.theme, "text_color.hex", "#fff"),
        "--hover-text-color": $(this.theme, "hover_text_color.hex", "initial"),
        "--box-bg-color": t,
        "--box-bg-color-opacity": n,
        "--hover-bg-color": $(this.theme, "hover_bg_color.hex", "initial"),
        "--hover-line-color": $(this.theme, "hover_line_color.hex", "initial"),
        "--title-color": $(this.theme, "title_color.hex", "--heading-color", "initial"),
        "--arrow-icon-color": $(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-icon-hover-color": $(this.theme, "arrow_icon_hover_color.hex", "initial"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "initial"),
        "--program-image-border-color": $(
          this.theme,
          "program_image_border_color.hex",
          $(this.theme, "globalThemeSettings.secondaryColor")
        ),
        "--link-color": $(this.theme, "link_color.hex", "#0070E0"),
        "--link-hover-color": $(this.theme, "link_hover_color.hex", "#0070E0")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.programs.component_header_top || this.isEditing);
    }
  }
}, YG = {
  name: "P1",
  mixins: [yi],
  data() {
    return {
      hoverIndex: -1,
      editIdx: -1,
      descriptionTabIndex: -1
    };
  },
  computed: {
    getLinkFormData() {
      const e = WG(this.programs.content[this.editIdx].link);
      return this.programs.read_more_link || (e.name = this.programs.content[this.editIdx].title), e;
    }
  },
  methods: {
    showLinkButton(e) {
      return this.hoverIndex === e && this.programs.read_more_link;
    },
    setHoverIndex(e) {
      this.hoverIndex = e;
    },
    async toggleVisibility(e, t) {
      var n, r, o, i;
      this.isEditing || (t.preventDefault(), this.programs.details_on_hover && (this.hoverIndex = this.hoverIndex === e ? -1 : e, this.descriptionTabIndex = -1, await this.$nextTick(), ((r = (n = this.$refs.programDescription) == null ? void 0 : n[0]) == null ? void 0 : r.scrollHeight) > ((i = (o = this.$refs.programDescription) == null ? void 0 : o[0]) == null ? void 0 : i.clientHeight) && (this.descriptionTabIndex = 0, this.$refs.programDescription[0].focus({ showFocus: !0 }))));
    },
    closeOnBlur(e) {
      e.currentTarget.contains(e.relatedTarget) || (this.hoverIndex = -1);
    }
  }
}, XG = ["data-testid"], QG = ["data-testid"], JG = ["tabindex", "aria-haspopup", "aria-labelledby", "aria-describedby", "role", "onKeydown", "onFocus", "onMouseover"], eK = ["src", "alt"], tK = {
  key: 1,
  class: "program-image"
}, nK = {
  key: 0,
  class: "hover-content"
}, rK = {
  class: "middle",
  role: "document"
}, oK = ["id"], iK = ["id", "tabindex"], sK = {
  key: 0,
  class: "program-link"
}, aK = {
  key: 1,
  maxlength: "26"
};
function lK(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "programs-p1",
    class: _(e.theme.style),
    style: Z(e.colors)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`
        }, [
          e.displayHeaderTop ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.programs.component_header_top), 1)
            ], !0)
          ], 8, QG)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.programs.component_header), 1)
          ], !0)
        ], 8, XG)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.programs.content,
      "onUpdate:modelValue": t[7] || (t[7] = (s) => e.programs.content = s),
      "item-key": "index",
      class: "programs-wrapper"
    }), {
      item: S(({ element: s, index: l }) => [
        c("div", {
          class: _([e.programs.num_columns === 3 ? "three-column" : "four-column", "program"])
        }, [
          M(e.$slots, "controls", { idx: l }, void 0, !0),
          c("div", {
            class: "image-wrapper image-border-accent",
            tabindex: e.programs.details_on_hover ? 0 : "",
            "aria-haspopup": !!e.programs.details_on_hover,
            "aria-labelledby": e.programs.details_on_hover && `dialog${l}Title`,
            "aria-describedby": e.programs.details_on_hover && `dialog${l}Desc`,
            role: e.programs.details_on_hover && "dialog",
            "data-testid": "program-content",
            onKeydown: [
              K(W((u) => i.toggleVisibility(l, u), ["exact"]), ["enter"]),
              K(W((u) => i.toggleVisibility(l, u), ["exact"]), ["space"])
            ],
            onFocus: (u) => i.toggleVisibility(l, u),
            onBlur: t[5] || (t[5] = (...u) => i.closeOnBlur && i.closeOnBlur(...u)),
            onMouseover: (u) => o.hoverIndex = l,
            onMouseleave: t[6] || (t[6] = (u) => o.hoverIndex = -1)
          }, [
            s.image.url ? (d(), f("img", {
              key: 0,
              src: s.image.url,
              alt: s.image.alt_text,
              loading: "lazy",
              class: "program-image"
            }, null, 8, eK)) : (d(), f("div", tK)),
            c("div", {
              class: _([[
                e.theme.style,
                e.theme.text_background,
                {
                  "hover-enter": e.programs.details_on_hover && o.hoverIndex === l
                }
              ], "content-box"])
            }, [
              e.programs.details_on_hover && o.hoverIndex === l ? (d(), f("div", nK, [
                t[8] || (t[8] = c("div", { class: "top-bar" }, null, -1)),
                c("div", rK, [
                  c("div", {
                    class: _([e.theme.style, "title"])
                  }, [
                    s.link.url && !e.programs.read_more_link ? (d(), I(Y(e.isEditing ? "div" : "a"), {
                      key: 0,
                      id: `dialog${l}Title`,
                      href: s.link.url,
                      target: s.link.opens_in_new_tab ? "_blank" : "",
                      onKeydown: [
                        t[0] || (t[0] = K((u) => i.setHoverIndex(-1), ["tab"])),
                        t[1] || (t[1] = K(W(() => {
                        }, ["exact", "stop"]), ["enter"]))
                      ]
                    }, {
                      default: S(() => [
                        M(e.$slots, "title", { idx: l }, () => [
                          H(k(s.title), 1)
                        ], !0)
                      ]),
                      _: 2
                    }, 1064, ["id", "href", "target"])) : (d(), f("p", {
                      key: 1,
                      id: `dialog${l}Title`,
                      maxlength: "26"
                    }, [
                      M(e.$slots, "title", { idx: l }, () => [
                        H(k(s.title), 1)
                      ], !0)
                    ], 8, oK))
                  ], 2),
                  c("p", {
                    id: `dialog${l}Desc`,
                    ref: "programDescription",
                    class: _([[{ editing: e.isEditing }, e.theme.style], "program-description"]),
                    tabindex: o.descriptionTabIndex,
                    "aria-label": "program-description"
                  }, [
                    M(e.$slots, "description", { idx: l }, () => [
                      H(k(s.description), 1)
                    ], !0)
                  ], 10, iK),
                  i.showLinkButton(l) ? (d(), f("div", sK, [
                    (d(), I(Y(e.isEditing ? "div" : "a"), {
                      "aria-label": s.link.name,
                      href: s.link.url,
                      target: s.link.opens_in_new_tab ? "_blank" : "",
                      onKeydown: [
                        t[2] || (t[2] = K((u) => i.setHoverIndex(-1), ["tab"])),
                        t[3] || (t[3] = K(W(() => {
                        }, ["exact", "stop"]), ["enter"]))
                      ]
                    }, {
                      default: S(() => [
                        M(e.$slots, "link", { idx: l }, () => [
                          H(k(s.link.name), 1)
                        ], !0)
                      ]),
                      _: 2
                    }, 1064, ["aria-label", "href", "target"]))
                  ])) : T("", !0)
                ])
              ])) : (d(), f("div", {
                key: 1,
                class: _(["normal-content title", e.theme.style])
              }, [
                !e.programs.details_on_hover && s.link.url ? (d(), I(Y(e.isEditing ? "div" : "a"), {
                  key: 0,
                  href: s.link.url,
                  target: s.link.opens_in_new_tab ? "_blank" : "",
                  onKeydown: t[4] || (t[4] = K(W(() => {
                  }, ["exact", "stop"]), ["enter"]))
                }, {
                  default: S(() => [
                    M(e.$slots, "title", { idx: l }, () => [
                      H(k(s.title), 1)
                    ], !0)
                  ]),
                  _: 2
                }, 1064, ["href", "target"])) : (d(), f("p", aK, [
                  M(e.$slots, "title", { idx: l }, () => [
                    H(k(s.title), 1)
                  ], !0)
                ]))
              ], 2))
            ], 2)
          ], 40, JG)
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const uK = /* @__PURE__ */ B(YG, [["render", lK], ["__scopeId", "data-v-37097e37"]]), dK = {
  name: "P2",
  mixins: [yi],
  data() {
    return {
      direction: "forward",
      content: []
    };
  },
  computed: {
    seeAllURL() {
      return $(this.programs, "see_all_link.url", !1);
    },
    seeAll() {
      return this.programs.see_all && (!!this.seeAllURL || this.isEditing);
    },
    programRows() {
      let e = [[]];
      return this.programs.content.length > 0 && (e = this.content.slice(1).reduce(
        (t, n, r) => (this.isEditing || r % 4 !== 0 || r === 0 ? t[t.length - 1].push(n) : t.push([n]), t),
        [[]]
      )), this.programs.slider ? [e[0]] : e;
    },
    opensInNewTab() {
      return this.programs.see_all_link.opens_in_new_tab ? "_blank" : "";
    }
  },
  watch: {
    programs: {
      handler(e) {
        this.content = e.content.map((t, n) => ge(ae({}, t), {
          idx: n
        }));
      },
      deep: !0,
      immediate: !0
    }
  },
  methods: {
    previous() {
      this.direction = "backward", this.$nextTick(() => {
        this.content.splice(0, 0, this.content.pop());
      });
    },
    next() {
      this.direction = "forward", this.$nextTick(() => {
        this.content.push(this.content.shift());
      });
    }
  }
}, cK = ["data-testid"], hK = ["data-testid"], mK = ["target", "href", "data-testid"], fK = { class: "main-program" }, pK = {
  key: 0,
  "data-testid": "component-header-top"
}, gK = ["data-testid"], vK = ["target", "href", "data-testid"], bK = { class: "main-program-text" }, yK = {
  key: 0,
  class: "purple arrows"
}, _K = {
  class: "left-arrow-button",
  role: "button"
}, CK = {
  class: "right-arrow-button",
  role: "button"
}, wK = {
  key: 0,
  class: "light-bold arrows"
}, TK = {
  class: "left-arrow-button",
  role: "button"
}, kK = {
  class: "right-arrow-button",
  role: "button"
}, EK = ["src", "alt"], SK = { class: "stacked-programs" }, MK = { class: "small-first-program" }, AK = { class: "aspect-ratio-box" }, IK = ["src", "alt"], LK = { class: "aspect-ratio-box" }, DK = ["src", "alt"], $K = { class: "aspect-ratio-box" }, OK = ["src", "alt"], PK = ["target", "href", "data-testid"];
function NK(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return e.programs.content.length > 0 ? (d(), f("div", {
    key: 0,
    id: "programs-v2",
    style: Z(e.colors),
    class: _(e.theme.style),
    "data-testid": "p2"
  }, [
    e.screenSize <= 960 || e.theme.style === "purple" ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-above"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          class: _({ "no-border": !i.seeAll }),
          "data-testid": `header-${e.theme.style}-above`
        }, [
          e.displayHeaderTop ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.programs.component_header_top), 1)
            ], !0)
          ], 8, hK)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.programs.component_header), 1)
          ], !0)
        ], 10, cK)
      ]),
      default: S(() => [
        i.seeAll && e.screenSize > 600 && e.theme.style !== "purple" ? (d(), f("a", {
          key: 0,
          target: i.opensInNewTab,
          href: `${e.pathPrefix}${i.seeAllURL}`,
          "data-testid": `see-all-${e.theme.style}-above`,
          onClick: t[0] || (t[0] = (s) => e.$emit("edit-see-all-link", s))
        }, [
          H(k(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
          M(e.$slots, "link", {}, void 0, !0)
        ], 8, mK)) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : T("", !0),
    c("div", fK, [
      c("div", {
        class: _(["main-program-left", e.theme.style])
      }, [
        e.screenSize > 960 && e.theme.style !== "purple" ? (d(), I(a, {
          key: 0,
          class: _([e.theme.style, "see-all-top"]),
          "theme-options": e.theme
        }, {
          header: S(() => [
            e.theme.style === "monterrey" && (e.programs.component_header_top || e.isEditing) ? (d(), f("h3", pK, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.programs.component_header_top), 1)
              ], !0)
            ])) : T("", !0),
            c("h2", {
              class: _({ "no-border": !i.seeAll }),
              "data-testid": `header-${e.theme.style}-top`
            }, [
              M(e.$slots, "header", {}, () => [
                H(k(e.programs.component_header), 1)
              ], !0)
            ], 10, gK)
          ]),
          default: S(() => [
            i.seeAll ? (d(), f("a", {
              key: 0,
              class: "hide-on-xs",
              target: i.opensInNewTab,
              href: `${e.pathPrefix}${i.seeAllURL}`,
              "data-testid": `see-all-${e.theme.style}-top`,
              onClick: t[1] || (t[1] = (s) => e.$emit("edit-see-all-link", s))
            }, [
              H(k(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
              M(e.$slots, "link", {}, void 0, !0)
            ], 8, vK)) : T("", !0)
          ]),
          _: 3
        }, 8, ["class", "theme-options"])) : T("", !0),
        c("div", bK, [
          e.theme.style === "purple" && e.programs.slider ? (d(), f("div", yK, [
            c("div", _K, [
              (d(), f("svg", {
                class: "purple-left-arrow",
                width: "31",
                height: "71",
                viewBox: "0 0 31 71",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[2] || (t[2] = (...s) => i.previous && i.previous(...s))
              }, t[7] || (t[7] = [
                c("path", {
                  class: "arrow-stroke",
                  d: "M28 68.2969L3 35.6597L28 3.02245",
                  stroke: "#4C4C4C",
                  "stroke-width": "5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]))),
              t[8] || (t[8] = c("span", { class: "sr-only" }, "Reverse Slider", -1))
            ]),
            c("div", CK, [
              (d(), f("svg", {
                class: "purple-right-arrow",
                width: "31",
                height: "71",
                viewBox: "0 0 31 71",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[3] || (t[3] = (...s) => i.next && i.next(...s))
              }, t[9] || (t[9] = [
                c("path", {
                  class: "arrow-stroke",
                  d: "M3 3.01953L28 35.6567L3 68.294",
                  stroke: "#4C4C4C",
                  "stroke-width": "5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]))),
              t[10] || (t[10] = c("span", { class: "sr-only" }, "Advance Slider", -1))
            ])
          ])) : T("", !0),
          j(Le, {
            appear: "",
            mode: "out-in",
            name: "fade-vertical"
          }, {
            default: S(() => [
              (d(), f("h3", {
                key: o.content[0].idx,
                class: _([[e.theme.style, o.direction], "main program-title"])
              }, [
                o.content[0].link && o.content[0].link.url ? (d(), I(Y(e.isEditing ? "div" : "a"), {
                  key: 0,
                  href: o.content[0].link.url,
                  target: o.content[0].link.opens_in_new_tab ? "_blank" : ""
                }, {
                  default: S(() => [
                    M(e.$slots, "title", {
                      idx: o.content[0].idx
                    }, () => [
                      H(k(o.content[0].title), 1)
                    ], !0)
                  ]),
                  _: 3
                }, 8, ["href", "target"])) : M(e.$slots, "title", {
                  key: 1,
                  idx: o.content[0].idx
                }, () => [
                  H(k(o.content[0].title), 1)
                ], !0)
              ], 2))
            ]),
            _: 3
          }),
          j(Le, {
            appear: "",
            mode: "out-in",
            name: "fade-vertical"
          }, {
            default: S(() => [
              (d(), f("p", {
                key: o.content[0].idx,
                class: _([[e.theme.style, o.direction], "main program-description"])
              }, [
                M(e.$slots, "description", {
                  idx: o.content[0].idx
                }, () => [
                  H(k(o.content[0].description), 1)
                ], !0)
              ], 2))
            ]),
            _: 3
          })
        ])
      ], 2),
      c("div", {
        class: _(["main-program-image", { editing: e.isEditing }])
      }, [
        M(e.$slots, "controls", {
          idx: o.content[0].idx
        }, void 0, !0),
        ["light", "bold", "monterrey", "sydney"].includes(e.theme.style) && e.programs.slider ? (d(), f("div", wK, [
          M(e.$slots, "main-controls", {}, () => [
            c("div", TK, [
              (d(), f("svg", {
                class: "left-arrow",
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[4] || (t[4] = (...s) => i.previous && i.previous(...s))
              }, t[11] || (t[11] = [
                c("path", {
                  class: "arrow-bg",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M-6.10352e-05 0L63.9999 0L63.9999 64L-6.10352e-05 64L-6.10352e-05 0Z",
                  fill: "#014990"
                }, null, -1),
                c("path", {
                  class: "arrow-stroke",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M26 32L38 19.5L36.5 18L22.9999 32.0428L36.5 46L38 44.5L26 32Z",
                  fill: "white"
                }, null, -1)
              ]))),
              t[12] || (t[12] = c("span", { class: "sr-only" }, "Reverse Slider", -1))
            ]),
            c("div", kK, [
              (d(), f("svg", {
                class: "right-arrow",
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[5] || (t[5] = (...s) => i.next && i.next(...s))
              }, t[13] || (t[13] = [
                c("path", {
                  class: "arrow-bg",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M64.0001 64L5.34058e-05 64L5.90008e-05 -1.78036e-06L64.0001 3.8147e-06L64.0001 64Z",
                  fill: "#014990"
                }, null, -1),
                c("path", {
                  class: "arrow-stroke",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M38 32L26 44.5L27.5 46L41.0001 31.9572L27.5 18L26 19.5L38 32Z",
                  fill: "white"
                }, null, -1)
              ]))),
              t[14] || (t[14] = c("span", { class: "sr-only" }, "Advance Slider", -1))
            ])
          ], !0)
        ])) : T("", !0),
        j(Le, {
          appear: "",
          mode: "out-in",
          name: "fade-vertical"
        }, {
          default: S(() => [
            (d(), f("div", {
              key: o.content[0].idx,
              class: _([o.direction, "aspect-ratio-box main"])
            }, [
              c("img", {
                class: "image-border-accent",
                src: o.content[0].image.url,
                alt: o.content[0].image.alt_text,
                loading: "lazy"
              }, null, 8, EK)
            ], 2))
          ]),
          _: 1
        })
      ], 2)
    ]),
    c("ul", SK, [
      c("li", MK, [
        c("div", AK, [
          c("img", {
            class: "image-border-accent",
            src: o.content[0].image.url,
            alt: o.content[0].image.alt_text,
            loading: "lazy"
          }, null, 8, IK)
        ]),
        c("h3", {
          class: _([e.theme.style, "program-title"])
        }, [
          o.content[0].link && o.content[0].link.url ? (d(), I(Y(e.isEditing ? "div" : "a"), {
            key: 0,
            href: o.content[0].link.url,
            target: o.content[0].link.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "title", {
                idx: o.content[0].idx
              }, () => [
                H(k(o.content[0].title), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["href", "target"])) : M(e.$slots, "title", {
            key: 1,
            idx: o.content[0].idx
          }, () => [
            H(k(o.content[0].title), 1)
          ], !0)
        ], 2),
        c("p", {
          class: _([e.theme.style, "program-description"])
        }, [
          M(e.$slots, "description", {
            idx: o.content[0].idx
          }, () => [
            H(k(o.content[0].description), 1)
          ], !0)
        ], 2)
      ]),
      (d(!0), f(J, null, ne(o.content.slice(1), (s) => (d(), f("li", {
        key: s.idx,
        "data-testid": "programs-content"
      }, [
        c("div", LK, [
          M(e.$slots, "small-controls", {
            idx: s.idx
          }, void 0, !0),
          c("img", {
            src: s.image.url,
            alt: s.image.alt_text,
            class: "program-image image-border-accent",
            loading: "lazy"
          }, null, 8, DK)
        ]),
        c("h3", {
          class: _([e.theme.style, "program-title"])
        }, [
          s.link && s.link.url ? (d(), I(Y(e.isEditing ? "div" : "a"), {
            key: 0,
            href: s.link.url,
            target: s.link.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "title", {
                idx: o.content[0].idx
              }, () => [
                H(k(s.title), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target"])) : M(e.$slots, "title", {
            key: 1,
            idx: o.content[0].idx
          }, () => [
            H(k(s.title), 1)
          ], !0)
        ], 2),
        c("p", {
          class: _([e.theme.style, "program-description"])
        }, [
          M(e.$slots, "description", {
            idx: o.content[0].idx
          }, () => [
            H(k(s.description), 1)
          ], !0)
        ], 2)
      ]))), 128))
    ]),
    c("div", null, [
      (d(!0), f(J, null, ne(i.programRows, (s, l) => (d(), I(zn, {
        key: l + 1,
        tag: "ul",
        name: "program-row",
        class: _(["program-row", { "less-than-4": s.length < 4 }])
      }, {
        default: S(() => [
          (d(!0), f(J, null, ne(s, (u) => (d(), f("li", {
            key: u.idx,
            class: _([o.direction, ["row-of-" + s.length]])
          }, [
            M(e.$slots, "controls", {
              idx: u.idx
            }, void 0, !0),
            c("div", $K, [
              c("img", {
                src: u.image.url,
                alt: u.image.alt_text,
                class: "program-image image-border-accent",
                loading: "lazy"
              }, null, 8, OK)
            ]),
            c("h3", {
              class: _([e.theme.style, "program-title"])
            }, [
              u.link && u.link.url ? (d(), I(Y(e.isEditing ? "div" : "a"), {
                key: 0,
                href: u.link.url,
                target: u.link.opens_in_new_tab ? "_blank" : ""
              }, {
                default: S(() => [
                  M(e.$slots, "title", {
                    idx: u.idx
                  }, () => [
                    H(k(u.title), 1)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "target"])) : M(e.$slots, "title", {
                key: 1,
                idx: u.idx
              }, () => [
                H(k(u.title), 1)
              ], !0)
            ], 2),
            c("p", {
              class: _([e.theme.style, "program-description"])
            }, [
              M(e.$slots, "description", {
                idx: u.idx
              }, () => [
                H(k(u.description), 1)
              ], !0)
            ], 2)
          ], 2))), 128))
        ]),
        _: 2
      }, 1032, ["class"]))), 128))
    ]),
    e.programs.see_all ? (d(), I(a, {
      key: 1,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        i.seeAll && (e.screenSize < 600 || e.theme.style === "purple") ? (d(), f("a", {
          key: 0,
          target: i.opensInNewTab,
          href: `${e.pathPrefix}${i.seeAllURL}`,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[6] || (t[6] = (s) => e.$emit("edit-see-all-link", s))
        }, [
          H(k(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
          M(e.$slots, "link", {}, void 0, !0)
        ], 8, PK)) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6)) : T("", !0);
}
const HK = /* @__PURE__ */ B(dK, [["render", NK], ["__scopeId", "data-v-bfc47d2c"]]), FK = {
  name: "P3",
  components: {
    CardSlider: cn
  },
  mixins: [yi, bt],
  computed: {
    content() {
      return this.programs.content;
    },
    sliderCenterSize() {
      return 600;
    },
    p3Colors() {
      return ge(ae({}, this.colors), {
        "--heading-description-color": $(this.theme, "heading_description_color.hex", "#000000"),
        "--top-heading-color": $(this.theme, "top_heading_color.hex", "#000000"),
        "--card-1-bg-color": $(this.theme, "programs_card_1_bg_color.hex", "#4e0188"),
        "--card-1-heading-color": $(this.theme, "programs_card_1_heading_color.hex", "#ffffff"),
        "--card-1-text-color": $(this.theme, "programs_card_1_text_color.hex", "#ffffff"),
        "--card-1-box-color": $(this.theme, "programs_card_1_box_color.hex", "#ffffff"),
        "--card-2-bg-color": $(this.theme, "programs_card_2_bg_color.hex", "#86259C"),
        "--card-2-heading-color": $(this.theme, "programs_card_2_heading_color.hex", "#ffffff"),
        "--card-2-text-color": $(this.theme, "programs_card_2_text_color.hex", "#ffffff"),
        "--card-2-box-color": $(this.theme, "programs_card_2_box_color.hex", "#ffffff"),
        "--card-3-bg-color": $(this.theme, "programs_card_3_bg_color.hex", "#fcD40b"),
        "--card-3-heading-color": $(this.theme, "programs_card_3_heading_color.hex", "#131313"),
        "--card-3-text-color": $(this.theme, "programs_card_3_text_color.hex", "#131313"),
        "--card-3-box-color": $(this.theme, "programs_card_3_box_color.hex", "#ffffff"),
        "--card-4-bg-color": $(this.theme, "programs_card_4_bg_color.hex", "#b22785"),
        "--card-4-heading-color": $(this.theme, "programs_card_4_heading_color.hex", "#ffffff"),
        "--card-4-text-color": $(this.theme, "programs_card_4_text_color.hex", "#ffffff"),
        "--card-4-box-color": $(this.theme, "programs_card_4_box_color.hex", "#ffffff"),
        "--card-5-bg-color": $(this.theme, "programs_card_5_bg_color.hex", "#5e49ec"),
        "--card-5-heading-color": $(this.theme, "programs_card_5_heading_color.hex", "#ffffff"),
        "--card-5-text-color": $(this.theme, "programs_card_5_text_color.hex", "#000000"),
        "--card-5-box-color": $(this.theme, "programs_card_5_box_color.hex", "#ffffff")
      });
    }
  }
}, RK = { class: "header-wrapper" }, VK = {
  key: 0,
  "data-testid": "component-header-top",
  class: "header-top"
}, BK = {
  key: 0,
  class: "header-description",
  "data-testid": "header-description"
}, jK = ["data-testid", "aria-label"], UK = { class: "program-card-wrapper" }, qK = { class: "program-bottom-card" }, GK = { class: "program-description" }, KK = ["innerHTML"];
function zK(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "programs-v3",
    "data-testid": "P3",
    style: Z(i.p3Colors),
    class: _([e.theme.style, { editing: e.isEditing }])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("div", RK, [
          c("div", null, [
            c("h2", null, [
              e.displayHeaderTop ? (d(), f("span", VK, [
                M(e.$slots, "header-top", {}, () => [
                  H(k(e.programs.component_header_top), 1)
                ], !0)
              ])) : T("", !0),
              M(e.$slots, "header", {}, () => [
                H(k(e.programs.component_header), 1)
              ], !0)
            ])
          ]),
          e.programs.component_header_description || e.isEditing ? (d(), f("div", BK, [
            M(e.$slots, "header-description", {}, () => [
              H(k(e.programs.component_header_description), 1)
            ], !0)
          ])) : T("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.programs.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        (d(), I(Y(e.wrapperComponent), Se({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.programs.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.programs.content = l),
          class: [{ "all-cards-visible": e.allCardsVisible }, "programs-wrapper"],
          "item-key": "index"
        }), {
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              class: _(["program", `card-${u + 1}`, `card-style-${u % 5 + 1}`]),
              "data-testid": `programCard${u + 1}`,
              "aria-label": `${u + 1} of ${i.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              "data-attr": "program-content"
            }, [
              M(e.$slots, "controls", { idx: u }, void 0, !0),
              M(e.$slots, "image", { idx: u }, () => [
                (d(), I(Y(l.image ? "img" : "div"), {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  loading: "lazy",
                  class: "program-image"
                }, null, 8, ["src", "alt"]))
              ], !0),
              c("div", UK, [
                c("div", qK, [
                  (d(), I(Y(l.link && l.link.url && !e.isEditing ? "a" : "span"), {
                    href: l.link.url,
                    target: l.link.opens_in_new_tab ? "_blank" : null,
                    class: _(["program-title", { "is-editing": e.isEditing }])
                  }, {
                    default: S(() => [
                      M(e.$slots, "title", {
                        title: l.title,
                        idx: u
                      }, () => [
                        H(k(l.title), 1)
                      ], !0)
                    ]),
                    _: 2
                  }, 1032, ["href", "target", "class"])),
                  c("span", GK, [
                    M(e.$slots, "description", {
                      title: l.description,
                      idx: u
                    }, () => [
                      c("span", {
                        class: "description-link",
                        innerHTML: l.description
                      }, null, 8, KK)
                    ], !0)
                  ])
                ])
              ])
            ], 10, jK)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const ZK = /* @__PURE__ */ B(FK, [["render", zK], ["__scopeId", "data-v-f678074c"]]), xK = {
  name: "P4",
  mixins: [yi],
  data() {
    return {
      activeItem: 0
    };
  },
  computed: {
    programsContent: {
      get() {
        return this.programs.content.slice(0, 5);
      },
      set(e) {
        this.programs.content = e;
      }
    },
    programsLength() {
      return this.programs.content.length;
    },
    cssVars() {
      return ge(ae({}, this.colors), {
        "--active-headline-color": $(this.theme, "active_headline_color.hex", "#000000"),
        "--active-line-color": $(this.theme, "active_line_color.hex", "#000000"),
        "--headline-color": $(this.theme, "headline_color.hex", "#000000"),
        "--card-bg-color": $(this.theme, "card_bg_color.hex", "#FFFFFF"),
        "--card-border-color": $(this.theme, "card_border_color.hex", "#000000")
      });
    }
  },
  methods: {
    activateTab(e) {
      this.activeItem = e;
    },
    onKeyDown(e) {
      if (this.isEditing) return;
      const n = {
        ArrowLeft: this.focusPreviousTab,
        ArrowRight: this.focusNextTab,
        Home: this.focusFirstTab,
        End: this.focusLastTab
      }[e.key];
      n && n.call(this);
    },
    focusActiveTab() {
      this.$refs["tab-" + this.activeItem][0].focus();
    },
    focusPreviousTab() {
      this.activeItem > 0 ? this.activeItem -= 1 : this.activeItem = this.programsLength - 1, this.focusActiveTab();
    },
    focusNextTab() {
      this.activeItem < this.programsLength - 1 ? this.activeItem += 1 : this.activeItem = 0, this.focusActiveTab();
    },
    focusFirstTab() {
      this.activeItem = 0, this.focusActiveTab();
    },
    focusLastTab() {
      this.activeItem = this.programsLength - 1, this.focusActiveTab();
    }
  }
}, WK = { class: "columns-wrapper" }, YK = ["data-testid"], XK = { class: "column-1" }, QK = ["data-testid"], JK = ["data-testid"], ez = ["id", "tabindex", "aria-selected", "aria-controls", "onClick"], tz = { class: "column-2" }, nz = ["id", "aria-labelledby"], rz = { class: "program-card" }, oz = { class: "card-title" }, iz = {
  key: 0,
  class: "card-description"
}, sz = ["innerHTML"];
function az(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["programs-v4", e.theme.style]),
    style: Z(i.cssVars)
  }, [
    c("div", WK, [
      e.programs.has_header && e.isPurpleStyle ? (d(), I(a, {
        key: 0,
        class: _(["see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header", {}, () => [
              H(k(e.programs.component_header), 1)
            ])
          ], 8, YK)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])) : T("", !0),
      c("div", XK, [
        e.programs.has_header && !e.isPurpleStyle ? (d(), I(a, {
          key: 0,
          class: _(["see-all-top", e.theme.style]),
          "theme-options": e.theme
        }, {
          header: S(() => [
            c("h2", {
              "data-testid": `header-${e.theme.style}-top`
            }, [
              e.isMonterreyStyle ? (d(), f("span", {
                key: 0,
                "data-testid": `header-${e.theme.style}-top`,
                class: "header-top"
              }, [
                M(e.$slots, "header-top", {}, () => [
                  H(k(e.programs.component_header_top), 1)
                ])
              ], 8, JK)) : T("", !0),
              M(e.$slots, "header", {}, () => [
                H(k(e.programs.component_header), 1)
              ])
            ], 8, QK)
          ]),
          _: 3
        }, 8, ["class", "theme-options"])) : T("", !0),
        (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
          modelValue: i.programsContent,
          "onUpdate:modelValue": t[1] || (t[1] = (s) => i.programsContent = s),
          class: ["programs-tabs", e.theme.style],
          role: "tablist",
          "item-key": "index",
          "aria-label": "programs-tabs"
        }), {
          item: S(({ element: s, index: l }) => [
            c("button", {
              id: `tab-${l}`,
              ref: `tab-${l}`,
              role: "tab",
              tabindex: String(o.activeItem === l ? 0 : -1),
              "aria-selected": String(o.activeItem === l),
              "aria-controls": `tabpanel-${l}`,
              class: _(["tab-button", { active: l === o.activeItem, [e.theme.style]: !0 }]),
              "data-testid": "tab-button",
              onClick: (u) => i.activateTab(l),
              onKeydown: t[0] || (t[0] = (u) => i.onKeyDown(u))
            }, [
              M(e.$slots, "drag"),
              M(e.$slots, "headline", { idx: l }, () => [
                H(k(s.headline), 1)
              ])
            ], 42, ez)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      c("div", tz, [
        (d(!0), f(J, null, ne(i.programsContent, (s, l) => (d(), f("div", {
          id: ["tabpanel-" + l],
          key: l,
          "aria-labelledby": l,
          role: "tabpanel",
          class: _([{ active: l === o.activeItem }, "program-slide"]),
          "data-testid": "program-slide"
        }, [
          M(e.$slots, "controls", { idx: l }),
          M(e.$slots, "image", { idx: l }, () => [
            (d(), I(Y(s.image.url ? "img" : "div"), {
              src: s.image.url,
              alt: s.image.alt_text,
              class: "program-image"
            }, null, 8, ["src", "alt"]))
          ]),
          c("div", rz, [
            c("h2", oz, [
              M(e.$slots, "title", { idx: l }, () => [
                H(k(s.title), 1)
              ])
            ]),
            e.programs.has_snippet ? (d(), f("div", iz, [
              M(e.$slots, "description", {
                description: s.description,
                idx: l
              }, () => [
                c("span", {
                  innerHTML: s.description
                }, null, 8, sz)
              ])
            ])) : T("", !0),
            e.programs.read_more_link ? (d(), I(Y(e.isEditing ? "div" : "a"), {
              key: 1,
              class: "card-link",
              href: s.link.url,
              target: s.link.opens_in_new_tab ? "_blank" : ""
            }, {
              default: S(() => [
                M(e.$slots, "link", { idx: l }, () => [
                  H(k(s.link.name), 1)
                ])
              ]),
              _: 2
            }, 1032, ["href", "target"])) : T("", !0)
          ])
        ], 10, nz))), 128))
      ])
    ])
  ], 6);
}
const lz = /* @__PURE__ */ B(xK, [["render", az], ["__scopeId", "data-v-815d8972"]]), a8 = {
  props: {
    // Index of the item considered active in the carrousel view
    activeIndex: {
      type: Number,
      default: 3
    },
    // Minimum pixel distance to trigger a swipe action
    swipeThreshold: {
      type: Number,
      default: 50
    },
    // Interval time in ms for auto-scrolling
    autoScrollIntervalTime: {
      type: Number,
      default: 6e3
    },
    // Duration in ms for the slide animation
    animationDuration: {
      type: Number,
      default: 500
    },
    // Number of positions to shift the array for the carrousel effect
    carrouselShift: {
      type: Number,
      default: 3
    },
    // Minimum number of items before mirroring is applied
    itemsMirrorLimit: {
      type: Number,
      default: 7
    }
  },
  data() {
    return {
      carrouselItems: [],
      isOnAnimation: !1,
      // provide each item with a unique id in format xxx-{index}
      carrouselActiveIdx: this.activeIndex,
      isAutoScroll: !1,
      autoScrollInterval: null,
      onFocus: !1,
      swipeStartX: 0,
      isSwiping: !1
    };
  },
  computed: {
    isMirrorArray() {
      return this.isEditing ? !1 : this.carrouselItems.length < this.itemsMirrorLimit;
    },
    content() {
      let e = [...this.carrouselItems];
      return this.isEditing || e.length < 3 ? e : (this.isMirrorArray && (e = [...e, ...e]), this.shiftArray(e, this.carrouselShift));
    }
  },
  methods: {
    shiftArray(e, t) {
      const n = e.length - t;
      return [...e.slice(n), ...e.slice(0, n)];
    },
    onAnimation() {
      return new Promise((e) => {
        this.isOnAnimation = !0, setTimeout(() => {
          this.isOnAnimation = !1, e();
        }, this.animationDuration);
      });
    },
    async moveItem({ direction: e = "next", autofocus: t = !1 } = {}) {
      if (this.isOnAnimation) return;
      const n = this.$refs.carrousel;
      if (!n) return;
      const r = n.children;
      this.reorderItems(n, r, e), this.updateTabIndexes(r), t && this.focusActiveItem(r), this.isAutoScroll && this.resetAutoScroll(), await this.onAnimation();
    },
    async setActiveItem(e, t = !1) {
      if (this.isOnAnimation) return;
      const n = this.$refs.carrousel;
      if (!n || n.children.length === 0 || n.children.length < 3 || e < 0 || e >= n.children.length)
        return;
      if (e === this.activeIndex) {
        t && this.focusActiveItem(n.children);
        return;
      }
      const r = e - this.activeIndex, o = r > 0 ? "next" : "prev", i = Math.abs(r);
      for (let a = 0; a < i; a++) {
        const s = a === i - 1 && t;
        await this.moveItem({ direction: o, autofocus: s });
      }
    },
    reorderItems(e, t, n) {
      var r, o;
      n === "next" ? e.appendChild(t[0]) : n === "prev" && e.prepend(t[t.length - 1]), this.carrouselActiveIdx = +((o = (r = t[this.activeIndex]) == null ? void 0 : r.id) == null ? void 0 : o.split("-").at(-1));
    },
    updateTabIndexes(e) {
      Array.from(e).forEach((t) => t.setAttribute("tabindex", "-1")), e[this.activeIndex] && e[this.activeIndex].setAttribute("tabindex", "0");
    },
    focusActiveItem(e) {
      var t;
      (t = e[this.activeIndex]) == null || t.focus();
    },
    getItemNumber(e) {
      let t;
      const n = this.content.length, r = 3;
      if (this.isMirrorArray) {
        const o = n / 2;
        t = (e % o + o - r) % o + 1;
      } else
        t = e - r + 1, t < 1 && (t += n);
      return t;
    },
    handleSwipeStart(e) {
      this.isSwiping = !0, this.swipeStartX = e.touches ? e.touches[0].clientX : e.clientX;
    },
    handleSwipeEnd(e) {
      if (!this.isSwiping) return;
      this.isSwiping = !1;
      const n = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - this.swipeStartX;
      n > this.swipeThreshold ? this.moveItem({ direction: "prev" }) : n < -this.swipeThreshold && this.moveItem({ direction: "next" });
    },
    toggleAutoScroll() {
      this.isAutoScroll ? this.stopAutoScroll() : this.startAutoScroll();
    },
    handleFocus() {
      this.onFocus = !0;
    },
    handleBlur() {
      this.onFocus = !1;
    },
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        this.moveItem({ direction: "next", autofocus: this.onFocus });
      }, this.autoScrollIntervalTime), this.isAutoScroll = !0;
    },
    stopAutoScroll() {
      clearInterval(this.autoScrollInterval), this.isAutoScroll = !1;
    },
    resetAutoScroll() {
      this.stopAutoScroll(), this.startAutoScroll();
    }
  },
  beforeDestroy() {
    this.stopAutoScroll();
  }
}, uz = {
  name: "P5",
  mixins: [yi, a8],
  props: {
    animationDuration: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      carrouselItems: this.programs.content || []
    };
  },
  computed: {
    p5Colors() {
      return ge(ae({}, this.colors), {
        "--heading-description-color": $(this.theme, "heading_description_color.hex", "#000"),
        "--icon-bg-color": $(this.theme, "icon_bg_color.hex", "#FFD6D6"),
        "--icon-color": $(this.theme, "icon_color.hex", "#741819")
      });
    },
    nextSlideText() {
      return $(this.theme, "translations.next_slide", "Next slide");
    },
    previousSlideText() {
      return $(this.theme, "translations.previous_slide", "Previous slide");
    }
  },
  methods: {
    handleProgramClick(e) {
      const t = e.currentTarget, n = this.$refs.carrousel, r = Array.from(n.children).indexOf(t);
      this.setActiveItem(r, !0);
    },
    getProgramAriaLabel(e, t) {
      return `${this.getItemNumber(e)} of ${this.content.length}, ${t.title}`;
    }
  }
}, dz = { class: "programs-wrapper" }, cz = { class: "header-wrapper" }, hz = {
  key: 0,
  class: "header"
}, mz = {
  key: 1,
  class: "header-description",
  "data-testid": "header-description"
}, fz = {
  key: 0,
  class: "carrousel-container",
  role: "region",
  "aria-roledescription": "carousel"
}, pz = ["id", "data-testid", "aria-label", "tabindex", "onClick"], gz = {
  key: 0,
  class: "icon-wrapper"
}, vz = ["innerHTML"], bz = { class: "program-content" }, yz = { class: "program-title" }, _z = ["innerHTML"], Cz = { class: "program" }, wz = { class: "icon-wrapper" }, Tz = ["innerHTML"], kz = { class: "program-content" }, Ez = { class: "program-title" }, Sz = { class: "program-title" }, Mz = { class: "program-description" }, Az = ["innerHTML"], Iz = {
  key: 0,
  class: "card-link"
}, Lz = {
  key: 2,
  role: "group",
  "aria-label": "slide controls",
  class: "carrousel-controls"
}, Dz = { class: "nav" }, $z = ["aria-label"], Oz = ["aria-label"];
function Pz(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["programs-v5", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "P5",
    style: Z(i.p5Colors)
  }, [
    c("div", dz, [
      j(a, {
        class: _([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("div", cz, [
            e.programs.has_header ? (d(), f("div", hz, [
              c("h2", null, [
                M(e.$slots, "header", {}, () => [
                  H(k(e.programs.component_header), 1)
                ], !0)
              ])
            ])) : T("", !0),
            e.programs.has_header_description ? (d(), f("div", mz, [
              M(e.$slots, "header-description", {}, () => [
                H(k(e.programs.component_header_description), 1)
              ], !0)
            ])) : T("", !0)
          ])
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      e.isEditing ? (d(), I(Y(e.wrapperComponent), Se({ key: 1 }, e.wrapperProps, {
        modelValue: e.programs.content,
        "onUpdate:modelValue": t[8] || (t[8] = (s) => e.programs.content = s),
        "item-key": "id",
        class: "draggable-carrousel"
      }), {
        item: S(({ element: s, index: l }) => [
          c("div", Cz, [
            M(e.$slots, "controls", { idx: l }, void 0, !0),
            e.programs.has_visuals ? (d(), f("div", {
              key: 0,
              class: _(["program-header", { "icon-only": e.theme.enable_icons }])
            }, [
              e.theme.enable_icons ? M(e.$slots, "icon", {
                key: 0,
                idx: l
              }, () => [
                c("div", wz, [
                  s.icon ? (d(), f("span", {
                    key: 0,
                    class: "raw-svg",
                    "data-testid": "program-icon",
                    innerHTML: s.icon
                  }, null, 8, Tz)) : T("", !0)
                ])
              ], !0) : M(e.$slots, "image", {
                key: 1,
                idx: l
              }, () => [
                (d(), I(Y(s.image && s.image.url ? "img" : "div"), {
                  src: s.image && s.image.url,
                  alt: s.image && s.image.alt_text,
                  loading: "lazy",
                  class: "program-image"
                }, null, 8, ["src", "alt"]))
              ], !0)
            ], 2)) : T("", !0),
            c("div", kz, [
              c("span", Ez, [
                M(e.$slots, "title", {
                  title: s.title,
                  idx: l
                }, () => [
                  c("span", Sz, k(s.title), 1)
                ], !0)
              ]),
              c("span", Mz, [
                M(e.$slots, "description", {
                  description: s.description,
                  idx: l
                }, () => [
                  c("span", {
                    class: "description-link",
                    innerHTML: s.description
                  }, null, 8, Az)
                ], !0)
              ]),
              e.programs.read_more_link ? (d(), f("div", Iz, [
                M(e.$slots, "link", { idx: l }, () => [
                  H(k(s.link.name), 1)
                ], !0)
              ])) : T("", !0)
            ])
          ])
        ]),
        _: 3
      }, 16, ["modelValue"])) : (d(), f("div", fz, [
        c("div", {
          ref: "carrousel",
          class: _([
            "carrousel-wrapper",
            {
              swiping: e.isSwiping,
              single: e.content.length === 1,
              small: e.content.length < 5
            }
          ]),
          onTouchstart: t[4] || (t[4] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onTouchend: t[5] || (t[5] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s)),
          onMousedown: t[6] || (t[6] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onMouseup: t[7] || (t[7] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s))
        }, [
          (d(!0), f(J, null, ne(e.content, (s, l) => (d(), f("div", {
            id: `carrousel-item-${l}`,
            key: l,
            class: "program",
            "data-testid": `programCard${l}`,
            "aria-label": i.getProgramAriaLabel(l, s),
            role: "group",
            "aria-roledescription": "slide",
            "data-attr": "program-content",
            tabindex: l === 3 ? 0 : -1,
            onKeyup: [
              t[0] || (t[0] = K((u) => e.moveItem({ direction: "prev", autofocus: !0 }), ["left"])),
              t[1] || (t[1] = K((u) => e.moveItem({ direction: "next", autofocus: !0 }), ["right"]))
            ],
            onFocus: t[2] || (t[2] = (...u) => e.handleFocus && e.handleFocus(...u)),
            onBlur: t[3] || (t[3] = (...u) => e.handleBlur && e.handleBlur(...u)),
            onClick: (u) => i.handleProgramClick(u, l)
          }, [
            e.programs.has_visuals ? (d(), f("div", {
              key: 0,
              class: _(["program-header", { "icon-only": e.theme.enable_icons }])
            }, [
              e.theme.enable_icons ? (d(), f("div", gz, [
                s.icon ? (d(), f("span", {
                  key: 0,
                  class: "raw-svg",
                  "data-testid": "program-icon",
                  innerHTML: s.icon
                }, null, 8, vz)) : T("", !0)
              ])) : (d(), I(Y(s.image && s.image.url ? "img" : "div"), {
                key: 1,
                src: s.image && s.image.url,
                alt: s.image && s.image.alt_text,
                loading: "lazy",
                class: "program-image"
              }, null, 8, ["src", "alt"]))
            ], 2)) : T("", !0),
            c("div", bz, [
              c("span", yz, k(s.title), 1),
              c("span", {
                class: _([
                  "program-description",
                  {
                    full: !e.programs.has_visuals,
                    "with-icons": e.programs.has_visuals && e.theme.enable_icons
                  }
                ])
              }, [
                c("span", {
                  class: "description-link",
                  innerHTML: s.description
                }, null, 8, _z)
              ], 2),
              e.programs.read_more_link && s.link ? (d(), I(Y(e.isPreview ? "div" : "a"), {
                key: 0,
                class: "card-link",
                href: s.link.url,
                target: s.link.opens_in_new_tab ? "_blank" : "",
                tabindex: e.carrouselActiveIdx === l ? 0 : -1
              }, {
                default: S(() => [
                  H(k(s.link.name), 1)
                ]),
                _: 2
              }, 1032, ["href", "target", "tabindex"])) : T("", !0)
            ])
          ], 40, pz))), 128))
        ], 34)
      ])),
      e.programs.slider ? (d(), f("div", Lz, [
        c("div", Dz, [
          c("button", {
            class: "carrousel-nav prev",
            "aria-label": i.previousSlideText,
            onClick: t[9] || (t[9] = (s) => e.moveItem({ direction: "prev" }))
          }, t[11] || (t[11] = [
            c("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "26",
              height: "14",
              viewBox: "0 0 26 14",
              fill: "none",
              "aria-hidden": "true"
            }, [
              c("path", {
                d: "M1 7L7 13M1 7L7 1M1 7L25 7",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]), 8, $z),
          c("button", {
            class: "carrousel-nav next",
            "aria-label": i.nextSlideText,
            onClick: t[10] || (t[10] = (s) => e.moveItem({ direction: "next" }))
          }, t[12] || (t[12] = [
            c("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "26",
              height: "14",
              viewBox: "0 0 26 14",
              fill: "none",
              "aria-hidden": "true"
            }, [
              c("path", {
                d: "M25 7L19 1M25 7L19 13M25 7H1",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]), 8, Oz)
        ]),
        t[13] || (t[13] = c("div", { class: "accent-bar" }, null, -1))
      ])) : T("", !0)
    ])
  ], 6);
}
const Nz = /* @__PURE__ */ B(uz, [["render", Pz], ["__scopeId", "data-v-f3967577"]]), Hz = {
  name: "Programs",
  components: {
    P1: uK,
    P2: HK,
    P3: ZK,
    P4: lz,
    P5: Nz
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  }
};
function Fz(e, t, n, r, o, i) {
  return d(), I(Y(n.theme.version), {
    theme: n.theme,
    programs: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    "is-preview": n.isPreview,
    onEditSeeAllLink: t[0] || (t[0] = (a) => {
      e.$emit("edit-see-all-link", a);
    })
  }, {
    "header-top": S(() => [
      M(e.$slots, "header-top")
    ]),
    header: S(() => [
      M(e.$slots, "header")
    ]),
    "header-description": S(() => [
      M(e.$slots, "header-description")
    ]),
    controls: S(({ idx: a }) => [
      M(e.$slots, "controls", { idx: a })
    ]),
    "main-controls": S(() => [
      M(e.$slots, "main-controls")
    ]),
    "small-controls": S(({ idx: a }) => [
      M(e.$slots, "small-controls", { idx: a })
    ]),
    image: S(({ idx: a }) => [
      M(e.$slots, "image", { idx: a })
    ]),
    icon: S(({ idx: a }) => [
      M(e.$slots, "icon", { idx: a })
    ]),
    link: S(({ idx: a }) => [
      M(e.$slots, "link", { idx: a })
    ]),
    title: S(({ title: a, idx: s }) => [
      M(e.$slots, "title", {
        title: a,
        idx: s
      })
    ]),
    description: S(({ description: a, idx: s }) => [
      M(e.$slots, "description", {
        description: a,
        idx: s
      })
    ]),
    headline: S(({ idx: a }) => [
      M(e.$slots, "headline", { idx: a })
    ]),
    drag: S(() => [
      M(e.$slots, "drag")
    ]),
    _: 3
  }, 40, ["theme", "programs", "wrapper-component", "wrapper-props", "is-editing", "is-preview"]);
}
const Rz = /* @__PURE__ */ B(Hz, [["render", Fz]]), Vz = ["regular", "pill"], Bz = (e) => (t) => e.includes(t), jz = {
  name: "EventTag",
  props: {
    displayText: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: "regular",
      validator: Bz(Vz)
    },
    bgColor: {
      type: String,
      default: "#F3F3F3"
    },
    fontColor: {
      type: String,
      default: "#000"
    }
  },
  computed: {
    text() {
      return this.variant === "pill" ? this.displayText : `| ${this.displayText}`;
    },
    cssVars() {
      return {
        "--bg-color": this.bgColor,
        "--font-color": `${this.fontColor}CC`
      };
    }
  }
}, Uz = { class: "tag-tooltip tag-tooltip-bottom" }, qz = { class: "tag-tooltip-text" };
function Gz(e, t, n, r, o, i) {
  return d(), f("div", Uz, [
    n.displayText ? (d(), f("div", {
      key: 0,
      style: Z(i.cssVars),
      class: _([n.variant, "event-tag"])
    }, k(i.text), 7)) : T("", !0),
    c("div", qz, k(n.displayText), 1)
  ]);
}
const Kz = /* @__PURE__ */ B(jz, [["render", Gz], ["__scopeId", "data-v-c536c1f9"]]), xr = {
  components: { EventTag: Kz },
  mixins: [kt],
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    events: {
      type: Array,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    eventsConfig: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    componentId: {
      type: String,
      required: !0
    }
  },
  computed: {
    theme() {
      return this.options;
    },
    colors() {
      var t, n;
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--date-color": $(this.theme, "date_color.hex", "initial"),
        "--date-bg-color": $(this.theme, "date_bg_color.hex", "initial"),
        "--time-color": $(this.theme, "time_color.hex", "initial"),
        "--location-color": $(this.theme, "location_color.hex", "initial"),
        "--bg-color": $(this.theme, "bg_color.hex", "#fff"),
        "--event-bg-color": $(this.theme, "event_bg_color.hex", "none"),
        "--event-title-color": $(this.theme, "event_title_color.hex", "initial"),
        "--event-separator-color": $(this.theme, "event_separator_color.hex", "#000"),
        "--event-border-color": $(this.theme, "event_border_color.hex", "#000"),
        event_section_tag_color: $(this.theme, "event_section_tag_color.hex", "#F3F3F3"),
        event_section_tag_text_color: $(this.theme, "event_section_tag_text_color.hex", "#fff"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "#fff"),
        "--event-arrow-color": $(this.theme, "event_arrow_color.hex", "#fff"),
        "--pager-color": $(this.theme, "pager_color.hex", "#fff"),
        "--event-bg-color-1": $(this.theme, "event_bg_color_1.hex", "#fff"),
        "--event-date-border-color": $(this.theme, "event_date_border_color.hex", "#fff"),
        "--event-bg-color-3": $(this.theme, "event_bg_color_3.hex", "#fff"),
        "--event-text-color-1": $(this.theme, "event_text_color_1.hex", "#fff"),
        "--event-text-color-3": $(this.theme, "event_text_color_3.hex", "#000"),
        "--percentage-date-opacity": `${(t = this.theme.percentage_date_opacity) != null ? t : 0}%`,
        "--percentage-button-opacity": `${(n = this.theme.percentage_button_opacity) != null ? n : 0}%`
      });
    },
    timeColor() {
      return $(this.theme, "time_color.hex", "initial");
    },
    translations() {
      return this.options.translations || {};
    },
    isPurpleStyle() {
      return this.options.style === "purple";
    },
    isMonterreyStyle() {
      return this.options.style === "monterrey";
    },
    seeAllLinkHref() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.href) || this.link("events");
    },
    seeAllLinkName() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.eventsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    },
    visibleItems() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.num_rows) || 4;
    }
  },
  methods: {
    /**
     * Parses cms_formatted_date string and returns structured date/time information
     * Handles common formats:
     * - "Nov 29, 2025 from 5:30 PM to 10:45 PM" (single day with time range)
     * - "Nov 29, 2025 from 5:30 PM" (single day with start time only)
     * - "Nov 29, 2025" (single day all day)
     * - "Nov 29, 2025 to Dec 1, 2025 from 5:30 PM to 10:45 PM" (date range with time)
     * - "Nov 29, 2025 to Dec 1, 2025" (date range all day)
     */
    parseCmsFormattedDate(e) {
      if (!e || typeof e != "string")
        return null;
      const t = e.replace(/\s+/g, " ").trim().replace(/\s+from\s*$/i, ""), [n = "", r = ""] = t.split(/\s+from\s+/i), [o = "", i = ""] = n.split(/\s+to\s+/i), a = (v) => {
        if (!v) return null;
        const g = v.match(/^(\w+)\s+(\d{1,2}),?\s*(\d{4})?$/);
        return g ? {
          month: g[1] || "",
          day: g[2] || "",
          year: g[3] || "",
          full: v
        } : null;
      }, s = a(o), l = i ? a(i) : null, u = r ? r.replace(/\s+to\s+/gi, " — ").toUpperCase() : "", m = n.replace(/\s+to\s+/gi, " — ");
      return {
        startDate: s,
        endDate: l,
        time: {
          formatted: u,
          isAllDay: !r
        },
        dateRange: {
          formatted: m
        }
      };
    },
    startDateMonth(e) {
      var n;
      const t = this.parseCmsFormattedDate(e);
      return ((n = t == null ? void 0 : t.startDate) == null ? void 0 : n.month) || "";
    },
    startDateDay(e) {
      var n;
      const t = this.parseCmsFormattedDate(e);
      return ((n = t == null ? void 0 : t.startDate) == null ? void 0 : n.day) || "";
    },
    endDateMonth(e) {
      var n;
      const t = this.parseCmsFormattedDate(e);
      return ((n = t == null ? void 0 : t.endDate) == null ? void 0 : n.month) || "";
    },
    endDateDay(e) {
      var n;
      const t = this.parseCmsFormattedDate(e);
      return ((n = t == null ? void 0 : t.endDate) == null ? void 0 : n.day) || "";
    },
    formatDateAndTime(e, t) {
      const n = this.parseCmsFormattedDate(e);
      return n ? t === "date" ? n.dateRange.formatted : t === "time" ? n.time.isAllDay ? this.translations.all_day : n.time.formatted : "" : "";
    },
    displayEventTags(e) {
      return this.eventsConfig.display_tags && this.eventSectionName(e);
    },
    eventSectionName(e) {
      return e.sectionDisplayName || e.custom_section_name;
    },
    getFormattedDate(e, t = " | ") {
      var l, u, m, v;
      const n = this.parseCmsFormattedDate(e);
      if (!n)
        return "";
      const r = ((l = n.startDate) == null ? void 0 : l.month) || "", o = ((u = n.endDate) == null ? void 0 : u.month) || "", i = ((m = n.startDate) == null ? void 0 : m.day) || "", a = ((v = n.endDate) == null ? void 0 : v.day) || "", s = n.time.isAllDay ? this.translations.all_day : n.time.formatted;
      return !o || !a ? s ? `${r} ${i}${t}${s}` : `${r} ${i}` : r === o && i === a ? s : s ? `${r} ${i} - ${o} ${a}${t}${s}` : `${r} ${i} - ${o} ${a}`;
    }
  }
}, zz = {
  name: "E1",
  mixins: [xr],
  computed: {
    eventsOnHomepage() {
      return this.events.slice(0, 4);
    },
    lessThanFourEvents() {
      return this.eventsOnHomepage.length <= 3;
    }
  }
}, Zz = ["data-testid"], xz = { class: "events-title-wrapper" }, Wz = ["href"], Yz = { class: "sr-only" }, Xz = {
  key: 0,
  class: "event-tag-wrapper"
};
function Qz(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("event-tag");
  return d(), f("div", {
    id: "events-e1",
    style: Z(e.colors),
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e1"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Zz)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["hide-on-xs hide-on-lg-three-cols see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: _(["events-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), f(J, null, ne(i.eventsOnHomepage, (l, u) => (d(), f("div", {
        key: `${u}-${l.title}`,
        class: _(["events-card grow events-accent-border", { "less-than-four-events": i.lessThanFourEvents }]),
        "data-testid": "events-content"
      }, [
        c("p", {
          class: _(["events-date", e.theme.style])
        }, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 3),
        c("p", {
          class: _(["events-time", e.theme.style])
        }, k(e.formatDateAndTime(l.cms_formatted_date, "time")), 3),
        c("div", xz, [
          c("a", {
            href: e.link(`events?id=${l.id}`),
            "data-testid": "events-title",
            class: "events-title"
          }, [
            H(k(l.title) + " ", 1),
            c("span", Yz, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 1)
          ], 8, Wz)
        ]),
        e.displayEventTags(l) ? (d(), f("div", Xz, [
          j(s, {
            variant: "pill",
            "display-text": e.eventSectionName(l),
            "bg-color": e.colors.event_section_tag_color,
            "font-color": e.colors.event_section_tag_text_color
          }, null, 8, ["display-text", "bg-color", "font-color"])
        ])) : T("", !0)
      ], 2))), 128))
    ], 2),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const Jz = /* @__PURE__ */ B(zz, [["render", Qz], ["__scopeId", "data-v-cb66b5e5"]]), eZ = {
  name: "E2",
  mixins: [xr]
}, tZ = ["data-testid"], nZ = { class: "events-date-and-time" }, rZ = { class: "events-title" }, oZ = ["href"], iZ = { class: "sr-only" }, sZ = {
  key: 0,
  class: "event-tag-wrapper"
};
function aZ(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("event-tag");
  return d(), f("div", {
    id: "events-e2",
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    style: Z(e.colors),
    "data-testid": "e2"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, tZ)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: _(["events-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), f(J, null, ne(e.events.slice(0, 8), (l, u) => (d(), f("div", {
        key: `${u}-${l.title}`,
        class: "events-card",
        "data-testid": "events-content"
      }, [
        c("p", nZ, [
          c("span", {
            class: _(["events-date", e.theme.style])
          }, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 3),
          c("span", {
            class: _(["events-time", e.theme.style])
          }, k(e.formatDateAndTime(l.cms_formatted_date, "time")), 3)
        ]),
        c("h3", rZ, [
          c("a", {
            href: e.isPreview ? void 0 : `${e.pathPrefix}/events?id=${l.id}`
          }, [
            H(k(l.title) + " ", 1),
            c("span", iZ, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 1)
          ], 8, oZ)
        ]),
        e.displayEventTags(l) ? (d(), f("div", sZ, [
          j(s, {
            variant: "pill",
            "display-text": e.eventSectionName(l),
            "bg-color": e.colors.event_section_tag_color,
            "font-color": e.colors.event_section_tag_text_color
          }, null, 8, ["display-text", "bg-color", "font-color"])
        ])) : T("", !0)
      ]))), 128))
    ], 2),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const lZ = /* @__PURE__ */ B(eZ, [["render", aZ], ["__scopeId", "data-v-6b81d5a6"]]), uZ = {
  name: "E3",
  mixins: [xr],
  computed: {
    backgroundStyle() {
      return this.options.show_background_image ? {
        backgroundImage: `linear-gradient(${this.options.bg_color.hex}e6, ${this.options.bg_color.hex}e6), url(${$(
          this.eventsConfig,
          "background_image.url"
        )})`,
        backgroundSize: "cover"
      } : !1;
    }
  }
}, dZ = ["data-testid"], cZ = { class: "events-v3__events" }, hZ = ["href"], mZ = { class: "sr-only" }, fZ = { class: "events-v3__events__event__time" }, pZ = { class: "events-v3__footer" };
function gZ(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("event-tag");
  return d(), f("div", {
    id: "events-v3",
    class: _([e.options.style, { "is-editing": e.isEditing }]),
    style: Z([i.backgroundStyle, e.colors]),
    "data-testid": "e3"
  }, [
    c("div", {
      class: _(["events-v3__header__button", e.options.style])
    }, [
      j(a, {
        class: _([e.options.style, "see-all-top"]),
        "theme-options": e.theme,
        "data-testid": "see-all-top"
      }, {
        header: S(() => [
          e.isMonterreyStyle ? (d(), f("h3", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, dZ)) : T("", !0),
          (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
            "data-testid": `header-${e.theme.style}-top`
          }, {
            default: S(() => [
              M(e.$slots, "header", {}, () => [
                H(k(e.sectionHeader), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["data-testid"]))
        ]),
        default: S(() => [
          e.options.style !== "purple" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
            key: 0,
            class: _(["hide-on-xs see-all-button", e.options.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.options.style}-top`,
            onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])
    ], 2),
    c("div", cZ, [
      (d(!0), f(J, null, ne(e.events.slice(0, 4), (l, u) => (d(), f("div", {
        key: u,
        class: _(["events-v3__events__event grow", [e.options.style, { "is-editing": e.isEditing }]]),
        "data-testid": "events-content"
      }, [
        c("div", {
          class: _(["events-v3__events__event__date events-date", e.options.style])
        }, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 3),
        c("a", {
          href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${l.id}`,
          class: "events-v3__events__event__title"
        }, [
          H(k(l.title) + " ", 1),
          c("span", mZ, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 1)
        ], 8, hZ),
        c("div", fZ, [
          H(k(e.formatDateAndTime(l.cms_formatted_date, "time")) + " ", 1),
          e.displayEventTags(l) ? (d(), I(s, {
            key: 0,
            "display-text": e.eventSectionName(l),
            "bg-color": e.timeColor
          }, null, 8, ["display-text", "bg-color"])) : T("", !0)
        ])
      ], 2))), 128))
    ]),
    c("div", pZ, [
      e.options.style === "purple" || e.screenSize < 600 ? (d(), I(a, {
        key: 0,
        class: _([e.options.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.options.style}-bottom`
      }, {
        default: S(() => [
          (d(), I(Y(e.isEditing ? "button" : "a"), {
            class: _(["see-all-button", e.options.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
    ])
  ], 6);
}
const vZ = /* @__PURE__ */ B(uZ, [["render", gZ], ["__scopeId", "data-v-a850dc5f"]]), bZ = {
  name: "OriginalSliderButton",
  props: {
    iconColor: {
      type: String,
      default: "#000000"
    },
    translatedAria: {
      type: String,
      default: ""
    },
    direction: {
      type: String,
      default: "left"
    }
  }
}, yZ = { class: "btn_content" }, _Z = {
  class: "normal",
  viewBox: "0 0 30 69",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CZ = ["fill"], wZ = ["fill"], TZ = {
  class: "hover",
  viewBox: "0 0 33 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kZ = ["fill"], EZ = ["fill"], SZ = { class: "sr-only" };
function MZ(e, t, n, r, o, i) {
  return d(), f("button", {
    class: _(["cards-slider-arrow", n.direction]),
    onClick: t[0] || (t[0] = (a) => e.$emit(`go-${n.direction}`))
  }, [
    c("span", yZ, [
      (d(), f("svg", _Z, [
        n.direction === "left" ? (d(), f("path", {
          key: 0,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M29.0391 68.4702C27.9511 69.3202 26.38 69.1273 25.5299 68.0392L0.529939 36.0392C-0.176646 35.1348 -0.176646 33.8654 0.529939 32.961L25.5299 0.961001C26.38 -0.127035 27.9511 -0.319974 29.0391 0.530047C30.1271 1.38008 30.3201 2.95119 29.4701 4.03923L5.67249 34.5001L29.4701 64.961C30.3201 66.049 30.1271 67.6201 29.0391 68.4702Z"
        }, null, 8, CZ)) : (d(), f("path", {
          key: 1,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.46088 0.53005C2.54891 -0.319977 4.12002 -0.127034 4.97005 0.961001L29.97 32.961C30.6766 33.8654 30.6766 35.1348 29.97 36.0392L4.97005 68.0392C4.12002 69.1273 2.54891 69.3202 1.46088 68.4702C0.372844 67.6201 0.179901 66.049 1.02993 64.961L24.8275 34.5001L1.02993 4.03922C0.179901 2.95119 0.372844 1.38008 1.46088 0.53005Z"
        }, null, 8, wZ))
      ])),
      (d(), f("svg", TZ, [
        n.direction === "left" ? (d(), f("path", {
          key: 0,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M31.4626 71.1523C29.7217 72.5123 27.208 72.2036 25.8479 70.4628L0.847911 38.4628C-0.282628 37.0157 -0.282628 34.9847 0.847911 33.5376L25.8479 1.53761C27.208 -0.20324 29.7217 -0.511948 31.4626 0.848091C33.2034 2.20814 33.5122 4.72191 32.1521 6.46277L9.07599 36.0002L32.1521 65.5376C33.5121 67.2785 33.2034 69.7922 31.4626 71.1523Z"
        }, null, 8, kZ)) : (d(), f("path", {
          key: 1,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.5376 0.84808C3.27846 -0.511963 5.79223 -0.203254 7.15228 1.5376L32.1523 33.5376C33.2828 34.9847 33.2828 37.0157 32.1523 38.4628L7.15228 70.4628C5.79223 72.2036 3.27846 72.5123 1.5376 71.1523C-0.203254 69.7922 -0.511963 67.2785 0.84808 65.5376L23.9242 36.0002L0.84808 6.46275C-0.511963 4.7219 -0.203254 2.20812 1.5376 0.84808Z"
        }, null, 8, EZ))
      ])),
      c("span", SZ, k(n.translatedAria), 1)
    ])
  ], 2);
}
const AZ = /* @__PURE__ */ B(bZ, [["render", MZ], ["__scopeId", "data-v-34444ce7"]]), IZ = {
  name: "Slider",
  components: { OriginalSliderButton: AZ },
  props: {
    totalCards: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    currentCard: {
      type: Number,
      default: 0
    },
    allCardsVisible: {
      type: Boolean
    },
    sectionHeader: {
      type: String,
      required: !0
    },
    hideXSmall: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    buttonStyles() {
      var e, t;
      return {
        "--background-color": ((t = (e = this.themeStyles) == null ? void 0 : e.arrow_background_color) == null ? void 0 : t.hex) || "#fff"
      };
    },
    arrowIconColor() {
      return $(this.themeStyles, "arrow_icon_color.hex", "#000");
    },
    nextSlideText() {
      return $(this.themeStyles, "translations.next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return $(this.themeStyles, "translations.previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    }
  }
}, LZ = ["aria-label"];
function DZ(e, t, n, r, o, i) {
  const a = V("OriginalSliderButton");
  return d(), f("div", {
    "aria-label": n.sectionHeader,
    style: Z(i.buttonStyles),
    class: _([{ "hide-x-small": n.hideXSmall }, "cards-slider"]),
    role: "region",
    "aria-roledescription": "carousel"
  }, [
    M(e.$slots, "button-left", {}, () => [
      j(a, {
        direction: "left",
        "icon-color": i.arrowIconColor,
        "translated-aria": i.previousSlideText,
        onGoLeft: t[0] || (t[0] = (s) => e.$emit("scroll-left"))
      }, null, 8, ["icon-color", "translated-aria"])
    ]),
    M(e.$slots, "default"),
    M(e.$slots, "button-right", {}, () => [
      j(a, {
        direction: "right",
        "icon-color": i.arrowIconColor,
        "translated-aria": i.nextSlideText,
        onGoRight: t[1] || (t[1] = (s) => e.$emit("scroll-right"))
      }, null, 8, ["icon-color", "translated-aria"])
    ])
  ], 14, LZ);
}
const eh = /* @__PURE__ */ B(IZ, [["render", DZ], ["__scopeId", "data-v-af515ce7"]]), $Z = {
  name: "E4",
  components: { Slider: eh },
  mixins: [xr, bt],
  computed: {
    content() {
      return this.events;
    },
    eventsContent() {
      return this.isSliderShown ? this.content : this.content.slice(0, 4);
    },
    isSliderShown() {
      return this.screenSize > 960;
    },
    themeStyles() {
      var e, t;
      return ge(ae({}, this.theme), {
        arrow_icon_color: { hex: ((t = (e = this.theme) == null ? void 0 : e.event_arrow_color) == null ? void 0 : t.hex) || "#000" }
      });
    }
  },
  methods: {
    isInRange(e, t) {
      return e >= t - 3 && e <= t + 3;
    },
    isTheLastOneInRange(e, t) {
      return e === t + 3;
    },
    isTheFirstOneInRange(e, t) {
      return e === t;
    },
    cardClassObj(e, t) {
      return {
        "events-card-hidden": !this.isInRange(e, t) && this.isSliderShown,
        "events-card-no-border": this.isTheLastOneInRange(e, t),
        "events-card-first": this.isTheFirstOneInRange(e, t)
      };
    }
  }
}, OZ = ["data-testid"], PZ = ["data-testid"], NZ = { class: "cards-slider-content" }, HZ = ["aria-label"], FZ = ["href"], RZ = { class: "sr-only" };
function VZ(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("event-tag"), l = V("Slider"), u = Ke("touch");
  return d(), f("div", {
    id: "events-e4",
    style: Z(e.colors),
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e4"
  }, [
    e.screenSize >= 600 && e.theme.style === "purple" ? (d(), I(a, {
      key: 0,
      "theme-options": e.theme,
      class: _(["see-all-above hide-on-xs", e.theme.style]),
      "data-testid": `header-${e.theme.style}-above`
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-above`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, OZ)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-above`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      _: 3
    }, 8, ["theme-options", "class", "data-testid"])) : T("", !0),
    c("div", {
      class: _(["events-info", e.theme.style])
    }, [
      e.theme.style !== "purple" || e.screenSize < 600 ? (d(), I(a, {
        key: 0,
        class: _([e.theme.style, "see-all-top"]),
        "theme-options": e.theme,
        "data-testid": `header-${e.theme.style}-top`
      }, {
        header: S(() => [
          e.isMonterreyStyle ? (d(), f("h3", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, PZ)) : T("", !0),
          (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
            "data-testid": `header-${e.theme.style}-top`
          }, {
            default: S(() => [
              M(e.$slots, "header", {}, () => [
                H(k(e.sectionHeader), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["data-testid"]))
        ]),
        default: S(() => [
          e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
            key: 0,
            class: _(["hide-on-xs see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (m) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options", "data-testid"])) : T("", !0),
      j(l, {
        "total-cards": i.content.length,
        "current-card": e.currentCard,
        "all-cards-visible": e.allCardsVisible,
        "section-header": e.sectionHeader,
        "theme-styles": i.themeStyles,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        default: S(() => [
          c("div", NZ, [
            c("div", {
              ref: "scrollWrapper",
              class: _([{ "all-cards-visible": e.allCardsVisible }, "cards-slider-container"])
            }, [
              (d(!0), f(J, null, ne(i.eventsContent, (m, v) => we((d(), f("div", {
                ref_for: !0,
                ref: `sliderCard-${v}`,
                key: v,
                class: _(["events-card", [e.theme.style, i.cardClassObj(v, e.currentCard), { "is-editing": e.isEditing }]]),
                "aria-label": `${v + 1} of ${i.content.length}`,
                role: "group",
                "aria-roledescription": "slide",
                "data-attr": "event-content",
                "data-testid": "events-content"
              }, [
                c("p", {
                  class: _(["events-date", e.theme.style])
                }, k(e.formatDateAndTime(m.cms_formatted_date, "date")), 3),
                c("a", {
                  class: _(["events-title", e.theme.style]),
                  href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${m.id}`
                }, [
                  H(k(m.title) + " ", 1),
                  c("span", RZ, k(e.formatDateAndTime(m.cms_formatted_date, "date")), 1)
                ], 10, FZ),
                c("p", {
                  class: _(["events-time", e.theme.style])
                }, [
                  H(k(e.formatDateAndTime(m.cms_formatted_date, "time")) + " ", 1),
                  e.displayEventTags(m) ? (d(), I(s, {
                    key: 0,
                    "display-text": e.eventSectionName(m),
                    "bg-color": e.timeColor
                  }, null, 8, ["display-text", "bg-color"])) : T("", !0)
                ], 2),
                t[2] || (t[2] = c("div", { class: "events-card-mobile-border-top" }, null, -1)),
                t[3] || (t[3] = c("div", { class: "events-card-mobile-border-right" }, null, -1))
              ], 10, HZ)), [
                [
                  u,
                  e.scrollRight,
                  "swipe",
                  { left: !0 }
                ],
                [
                  u,
                  e.scrollLeft,
                  "swipe",
                  { right: !0 }
                ]
              ])), 128))
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["total-cards", "current-card", "all-cards-visible", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"]),
      e.theme.style === "purple" || e.screenSize < 600 ? (d(), I(a, {
        key: 1,
        class: _([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.theme.style}-bottom`
      }, {
        default: S(() => [
          (d(), I(Y(e.isEditing ? "button" : "a"), {
            class: _(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[1] || (t[1] = (m) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
    ], 2)
  ], 6);
}
const BZ = /* @__PURE__ */ B($Z, [["render", VZ], ["__scopeId", "data-v-05ce2c28"]]), jZ = {
  name: "E5",
  components: { CardSlider: cn },
  mixins: [xr, bt],
  computed: {
    content() {
      return this.events.slice(0, 12);
    },
    sliderCenterSize() {
      return 599;
    },
    seeAllStyles() {
      return this.theme.style === "purple" ? "see-all-above" : "see-all-top";
    },
    cssVars() {
      return ge(ae({}, this.colors), {
        "--event-bg-color-2": $(this.theme, "event_bg_color_2.hex", "#fff"),
        "--event-text-color-2": $(this.theme, "event_text_color_2.hex", "#000"),
        "--event-bg-color-4": $(this.theme, "event_bg_color_4.hex", "#fff"),
        "--event-text-color-4": $(this.theme, "event_text_color_4.hex", "#000")
      });
    }
  },
  methods: {
    iconAndTagColor(e) {
      return e + 1 > 4 ? this.cssVars[`--event-text-color-${(e + 1) % 4}`] : this.cssVars[`--event-text-color-${e + 1}`];
    }
  }
}, UZ = ["data-testid"], qZ = ["data-testid"], GZ = ["aria-label"], KZ = { class: "start-date" }, zZ = {
  class: "date-month",
  "data-testid": "start-month"
}, ZZ = {
  class: "date-day",
  "data-testid": "start-day"
}, xZ = { key: 0 }, WZ = {
  key: 1,
  class: "end-date"
}, YZ = {
  class: "date-month",
  "data-testid": "end-month"
}, XZ = {
  class: "date-day",
  "data-testid": "end-day"
}, QZ = ["href"], JZ = { class: "time-section details" }, ex = { class: "icon-wrapper" }, tx = {
  class: "icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nx = ["stroke"], rx = {
  key: 0,
  class: "location-section details"
}, ox = { class: "icon-wrapper" }, ix = {
  class: "icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sx = ["fill"], ax = ["stroke"], lx = {
  key: 1,
  class: "section-tag"
};
function ux(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "events-e5",
    style: Z(i.cssVars),
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e5"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-above"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, qZ)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, UZ)
      ]),
      default: S(() => [
        !e.isPurpleStyle && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      class: _({ "is-editing": e.isEditing }),
      "pager-section-count": e.pagerSectionCount,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        c("div", {
          ref: "scrollWrapper",
          class: _(["events-wrapper", { "all-cards-visible": e.allCardsVisible }])
        }, [
          (d(!0), f(J, null, ne(i.content, (l, u) => (d(), f("div", {
            key: u,
            ref_for: !0,
            ref: `sliderCard-${u}`,
            class: _(["card-content", `card-${u}`]),
            "aria-label": `${u + 1} of ${i.content.length}`,
            "data-testid": "events-content",
            role: "group",
            "aria-roledescription": "slide"
          }, [
            (d(), f("div", {
              key: `${u}-${l.title}`,
              class: _(["card events-card card-color", [e.theme.style, `card-color-${u % 4 + 1}`]]),
              "data-testid": "events-content-item"
            }, [
              c("div", {
                class: _(["events-date", e.theme.style])
              }, [
                c("div", KZ, [
                  c("div", zZ, k(e.startDateMonth(l.cms_formatted_date)), 1),
                  c("div", ZZ, k(e.startDateDay(l.cms_formatted_date)), 1)
                ]),
                e.endDateMonth(l.cms_formatted_date) ? (d(), f("div", xZ, "-")) : T("", !0),
                e.endDateMonth(l.cms_formatted_date) ? (d(), f("div", WZ, [
                  c("div", YZ, k(e.endDateMonth(l.cms_formatted_date)), 1),
                  c("div", XZ, k(e.endDateDay(l.cms_formatted_date)), 1)
                ])) : T("", !0)
              ], 2),
              c("a", {
                class: _(["events-title", e.theme.style]),
                href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${l.id}`
              }, k(l.title), 11, QZ),
              c("div", JZ, [
                c("div", ex, [
                  (d(), f("svg", tx, [
                    c("path", {
                      d: "M11.5 12.381C11.5 12.5269 11.5638 12.6656 11.6746 12.7606L14.3413 15.0463C14.5509 15.226 14.8666 15.2017 15.0463 14.9921C15.226 14.7824 15.2017 14.4668 14.9921 14.287L12.5 12.151V8.66667C12.5 8.39052 12.2761 8.16667 12 8.16667C11.7239 8.16667 11.5 8.39052 11.5 8.66667V12.381ZM19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12Z",
                      stroke: i.iconAndTagColor(u),
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 8, nx)
                  ]))
                ]),
                c("p", {
                  class: _(["events-time", e.theme.style])
                }, k(e.formatDateAndTime(l.cms_formatted_date, "time")), 3)
              ]),
              l.venue ? (d(), f("div", rx, [
                c("div", ox, [
                  (d(), f("svg", ix, [
                    c("rect", {
                      x: "12",
                      y: "11.125",
                      width: "1",
                      height: "9",
                      fill: i.iconAndTagColor(u)
                    }, null, 8, sx),
                    c("circle", {
                      cx: "12.5",
                      cy: "6.625",
                      r: "5",
                      stroke: i.iconAndTagColor(u)
                    }, null, 8, ax)
                  ]))
                ]),
                c("p", {
                  class: _(["events-location", e.theme.style])
                }, k(l.venue), 3)
              ])) : T("", !0),
              e.displayEventTags(l) ? (d(), f("div", lx, k(e.eventSectionName(l)), 1)) : T("", !0),
              t[2] || (t[2] = c("div", { class: "events-card-mobile-border-top" }, null, -1)),
              t[3] || (t[3] = c("div", { class: "events-card-mobile-border-right" }, null, -1))
            ], 2))
          ], 10, GZ))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "class", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button see-all-events", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const dx = /* @__PURE__ */ B(jZ, [["render", ux], ["__scopeId", "data-v-45b5b2db"]]), cx = {
  name: "E6",
  mixins: [xr],
  props: {
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    content() {
      return this.events.slice(0, 6);
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    logoStyles() {
      return {
        "--logo-url": `url(${this.logo})`
      };
    }
  }
}, hx = ["data-testid"], mx = ["data-testid"], fx = {
  key: 0,
  class: "logo"
}, px = { class: "start-date" }, gx = { class: "month" }, vx = { class: "date-number" }, bx = { class: "details" }, yx = { class: "event-title" }, _x = ["href"], Cx = { class: "event-dates" }, wx = { class: "event-location" };
function Tx(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["events-e6", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: Z(e.colors),
    "data-testid": "e6"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          i.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, mx)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, hx)
      ]),
      default: S(() => [
        !i.isPurpleStyle && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: "events-container",
      style: Z(i.logoStyles)
    }, [
      n.logo ? (d(), f("div", fx)) : T("", !0),
      c("div", {
        class: _(["events-wrapper", { "is-editing": e.isEditing }])
      }, [
        (d(!0), f(J, null, ne(i.content, (s, l) => (d(), f("div", {
          key: `${l}-${s.title}`,
          class: "event-card",
          "data-testid": "events-content"
        }, [
          c("div", px, [
            c("div", gx, k(e.startDateMonth(s.cms_formatted_date)), 1),
            c("div", vx, k(e.startDateDay(s.cms_formatted_date)), 1)
          ]),
          c("div", bx, [
            c("div", yx, [
              c("a", {
                class: _(["events-title", e.theme.style]),
                href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${s.id}`
              }, k(s.title), 11, _x)
            ]),
            c("div", Cx, [
              t[2] || (t[2] = c("br", null, null, -1)),
              H(" " + k(e.getFormattedDate(s.cms_formatted_date, " ")), 1)
            ]),
            c("div", wx, k(s.venue), 1)
          ])
        ]))), 128))
      ], 2)
    ], 4),
    i.isPurpleStyle || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const kx = /* @__PURE__ */ B(cx, [["render", Tx], ["__scopeId", "data-v-4022f92a"]]), Ex = {
  name: "E7",
  mixins: [xr],
  emits: ["open-modal"]
}, Sx = ["data-testid"], Mx = ["data-testid"], Ax = { class: "button-text" }, Ix = { class: "month" }, Lx = { class: "date-number" }, Dx = { class: "event-title" }, $x = ["href"], Ox = {
  key: 1,
  class: "event-tag"
}, Px = { class: "button-text" };
function Nx(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("EventTag");
  return d(), f("div", {
    class: _(["events-e7", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: Z(e.colors),
    "data-testid": "e7"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, Mx)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, Sx)
      ]),
      default: S(() => [
        !e.isMonterreyStyle && !e.isPurpleStyle && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            c("div", Ax, k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: _(["events-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), f(J, null, ne(e.events.slice(0, e.visibleItems), (l) => (d(), f("div", {
        key: l.id,
        class: "events-card",
        "data-testid": "events-content"
      }, [
        c("div", {
          class: _(["events-date", e.theme.style])
        }, [
          c("div", Ix, k(e.startDateMonth(l.cms_formatted_date)), 1),
          c("div", Lx, k(e.startDateDay(l.cms_formatted_date)), 1)
        ], 2),
        c("div", {
          class: _(["events-description", e.theme.style])
        }, [
          c("div", Dx, [
            c("a", {
              class: _(["events-title", e.theme.style]),
              href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${l.id}`
            }, k(l.title), 11, $x)
          ]),
          c("div", {
            class: _(["events-time", e.theme.style])
          }, k(e.getFormattedDate(l.cms_formatted_date)), 3),
          l.venue ? (d(), f("div", {
            key: 0,
            class: _(["events-location", e.theme.style])
          }, k(l.venue), 3)) : T("", !0),
          e.displayEventTags(l) ? (d(), f("div", Ox, [
            j(s, {
              variant: "pill",
              "display-text": e.eventSectionName(l),
              "bg-color": e.colors.event_section_tag_color,
              "font-color": e.colors.event_section_tag_text_color
            }, null, 8, ["display-text", "bg-color", "font-color"])
          ])) : T("", !0)
        ], 2)
      ]))), 128))
    ], 2),
    e.isMonterreyStyle || e.isPurpleStyle || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            c("div", Px, k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const Hx = /* @__PURE__ */ B(Ex, [["render", Nx], ["__scopeId", "data-v-fa560b25"]]), Fx = {
  name: "CmsEvents",
  components: {
    E1: Jz,
    E2: lZ,
    E3: vZ,
    E4: BZ,
    E5: dx,
    E6: kx,
    E7: Hx
  },
  props: {
    options: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    isPreview: Boolean,
    eventsConfig: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isEditing: Boolean,
    componentId: {
      type: String,
      required: !0
    },
    logo: {
      type: String,
      default: ""
    }
  }
}, Rx = {
  id: "view-events",
  class: "view-events events-versions"
};
function Vx(e, t, n, r, o, i) {
  return d(), f("div", Rx, [
    (d(), I(Y(n.options.version), {
      options: n.options,
      events: n.content,
      "is-preview": n.isPreview,
      "events-config": n.eventsConfig,
      "component-id": n.componentId,
      "path-prefix": n.pathPrefix,
      logo: n.logo,
      "is-editing": n.isEditing,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["options", "events", "is-preview", "events-config", "component-id", "path-prefix", "logo", "is-editing"]))
  ]);
}
const Bx = /* @__PURE__ */ B(Fx, [["render", Vx], ["__scopeId", "data-v-23ed585b"]]), fr = {
  mixins: [kt],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    posts: {
      type: Array,
      required: !0
    },
    fallbackImage: {
      type: Object,
      default: () => ({})
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    livefeedConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    isEditing: Boolean
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      let t = $(this.theme, "link_card_bg_color.hex", "#fff");
      return t.startsWith("#") || (t = `#${t}`), ge(ae({}, e), {
        "--top-heading-color": $(this.theme, "top_heading_color.hex", "#fff"),
        "--bottom-heading-color": $(this.theme, "bottom_heading_color.hex", "#fff"),
        "--header-accent-color": $(this.theme, "header_accent_color.hex", "#333"),
        "--button-border-color": $(this.theme, "button_border_color.hex", "#fff"),
        "--link-color": $(this.theme, "post_link_color.hex", "#0000ee"),
        "--time-and-author-color": $(this.theme, "time_and_author_text_color.hex", e["--heading-color"]),
        "--post-bg-color": $(this.theme, "post_bg_color.hex", "#dfdfdf"),
        "--post-text-color": $(this.theme, "post_text_color.hex", "#333"),
        "--panel-bg-color": $(this.theme, "panel_bg_color.hex", "#fff"),
        "--image-border-color": $(
          this.theme,
          "image_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--link-card-bg-color": t,
        "--arrow-border-color": $(this.theme, "arrow_border_color.hex", "#fff"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "#ffffff"),
        "--arrow-icon-color": $(this.theme, "arrow_icon_color.hex", "#ffffff"),
        "--pager-color": $(this.theme, "pager_color.hex", "#000"),
        "--time-color": $(this.theme, "time_color.hex", "#000"),
        "--author-color": $(this.theme, "author_text_color.hex", "#000")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("live-feed");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  },
  methods: {
    openLightbox(e) {
      this.isIFrame || this.$emit("openLightbox", e);
    },
    saveFocusElement(e) {
      this.isIFrame || this.$emit("saveFocusElement", e.target);
    },
    onClickImage(e, t, n) {
      this.saveFocusElement(e), this.openLightbox({ images: t, idx: n });
    },
    clickSeeAllButton() {
      this.isIFrame || this.$router.push({ path: `${this.pathPrefix}/live-feed` });
    },
    viewImageText(e) {
      return e.live_feed_images.length > 1 ? this.translations.view_images : this.translations.view_image;
    },
    // Preferably we shouldn't render user-provided HTML
    // https://vuejs.org/v2/guide/syntax.html#Raw-HTML
    getPostContent(e, t) {
      const n = dg(e.status, t), r = `
        <a aria-labelledby="LF-${e.id}" href="${this.pathPrefix}/live-feed#${e.id}">
          Read More
        </a>
      `;
      return n.endsWith("...") ? rv(n).concat(r) : n;
    }
  }
}, jx = {
  name: "LF1",
  mixins: [fr],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  },
  methods: {
    thumbnailImages(e) {
      return e.length > 4 ? e.slice(0, 3) : e;
    }
  }
}, Ux = ["data-testid"], qx = { class: "live-feed-post-header" }, Gx = ["src"], Kx = { class: "live-feed-author" }, zx = ["aria-labelledby", "aria-posinset", "aria-setsize"], Zx = ["id", "innerHTML"], xx = ["onKeydown", "onClick"], Wx = {
  class: "button-action-content",
  tabindex: "-1"
}, Yx = {
  key: 1,
  class: "thumbnails"
}, Xx = ["src", "alt", "onKeydown", "onClick"], Qx = ["onKeydown", "onClick"];
function Jx(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "LF1",
    class: _(e.theme.style),
    style: Z(e.colors),
    "data-testid": "lf1",
    role: "feed"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Ux)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(!0), f(J, null, ne(i.filteredPosts, (s, l) => (d(), f("div", {
      key: `${l}-${s.author}-LF`,
      class: _(["live-feed-post", [e.theme.style, { "is-editing": e.isEditing }]]),
      "data-testid": "live-feed-content"
    }, [
      c("div", qx, [
        c("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          role: "presentation",
          loading: "lazy"
        }, null, 8, Gx),
        c("span", Kx, k(s.author), 1),
        c("span", {
          class: _(["live-feed-time", e.theme.style])
        }, k(s.time_ago), 3)
      ]),
      c("div", {
        class: _(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": l + 1,
        "aria-setsize": i.filteredPosts.length
      }, [
        c("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, Zx),
        !e.theme.show_thumbnails && s.live_feed_images.length > 0 ? (d(), f("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (u) => e.onClickImage(u, s.live_feed_images)
        }, [
          c("div", Wx, k(e.viewImageText(s)), 1)
        ], 40, xx)) : T("", !0),
        e.theme.show_thumbnails && s.live_feed_images.length > 0 ? (d(), f("div", Yx, [
          (d(!0), f(J, null, ne(i.thumbnailImages(s.live_feed_images), (u, m) => (d(), f("img", {
            key: `${u.id}`,
            tabindex: "0",
            class: "thumbnail",
            loading: "lazy",
            src: u.url,
            alt: u.alt_text,
            onKeydown: [
              K(W((v) => e.onClickImage(v, s.live_feed_images, m), ["exact", "prevent"]), ["enter"]),
              K(W((v) => e.onClickImage(v, s.live_feed_images, m), ["exact", "prevent"]), ["space"])
            ],
            onClick: (v) => e.onClickImage(v, s.live_feed_images, m)
          }, null, 40, Xx))), 128)),
          s.live_feed_images.length > 4 ? (d(), f("div", {
            key: 0,
            style: Z({ "--lf-more-bg-image": `url(${s.live_feed_images[3].url})` }),
            tabindex: "0",
            class: "thumbnail more-images",
            onKeydown: [
              K(W((u) => e.onClickImage(u, s.live_feed_images, 3), ["exact", "prevent"]), ["enter"]),
              K(W((u) => e.onClickImage(u, s.live_feed_images, 3), ["exact", "prevent"]), ["space"])
            ],
            onClick: (u) => e.onClickImage(u, s.live_feed_images, 3)
          }, [
            c("span", null, "+ " + k(s.live_feed_images.length - 3), 1)
          ], 44, Qx)) : T("", !0)
        ])) : T("", !0)
      ], 10, zx)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const eW = /* @__PURE__ */ B(jx, [["render", Jx], ["__scopeId", "data-v-b6b428e4"]]), tW = {
  name: "LF2",
  mixins: [fr],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  }
}, nW = ["data-testid"], rW = { class: "live-feed-post-header" }, oW = ["src"], iW = { class: "live-feed-time-and-author" }, sW = ["aria-labelledby", "aria-posinset", "aria-setsize"], aW = ["id", "innerHTML"], lW = ["onKeydown", "onClick"], uW = {
  class: "button-action-content",
  tabindex: "-1"
};
function dW(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "LF2",
    style: Z(e.colors),
    class: _(e.theme.style),
    role: "feed"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, nW)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(!0), f(J, null, ne(i.filteredPosts, (s, l) => (d(), f("div", {
      key: `${l}-${s.author}-LF`,
      class: _(["live-feed-post", { "is-editing": e.isEditing }]),
      "data-testid": "live-feed-content"
    }, [
      c("div", rW, [
        c("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          role: "presentation",
          loading: "lazy"
        }, null, 8, oW),
        c("span", iW, k(s.time_ago) + ", " + k(s.author), 1)
      ]),
      c("div", {
        class: _(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": l + 1,
        "aria-setsize": i.filteredPosts.length
      }, [
        c("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, aW),
        e.isPreview || s.live_feed_images.length > 0 ? (d(), f("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (u) => e.onClickImage(u, s.live_feed_images)
        }, [
          c("div", uW, k(e.viewImageText(s)), 1)
        ], 40, lW)) : T("", !0)
      ], 10, sW)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const cW = /* @__PURE__ */ B(tW, [["render", dW], ["__scopeId", "data-v-a7eaf91b"]]), hW = {
  name: "LF3",
  mixins: [fr],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  }
}, mW = ["data-testid"], fW = { class: "live-feed-post-header" }, pW = ["src"], gW = { class: "live-feed-time-and-author" }, vW = ["aria-labelledby", "aria-posinset", "aria-setsize"], bW = ["id", "innerHTML"], yW = ["onKeydown", "onClick"], _W = {
  class: "button-action-content",
  tabindex: "-1"
};
function CW(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "LF3",
    style: Z(e.colors),
    class: _(e.theme.style),
    role: "feed"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, mW)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(!0), f(J, null, ne(i.filteredPosts, (s, l) => (d(), f("div", {
      key: `${l}-${s.author}-LF`,
      class: _(["live-feed-post", { "is-editing": e.isEditing }]),
      "data-testid": "live-feed-content"
    }, [
      c("div", fW, [
        c("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          role: "presentation",
          loading: "lazy"
        }, null, 8, pW),
        c("span", gW, k(s.time_ago) + ", " + k(s.author), 1)
      ]),
      c("div", {
        class: _(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": l + 1,
        "aria-setsize": i.filteredPosts.length
      }, [
        c("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, bW),
        e.isPreview || s.live_feed_images.length > 0 ? (d(), f("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (u) => e.onClickImage(u, s.live_feed_images)
        }, [
          c("div", _W, k(e.viewImageText(s)), 1)
        ], 40, yW)) : T("", !0)
      ], 10, vW)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const wW = /* @__PURE__ */ B(hW, [["render", CW], ["__scopeId", "data-v-f35e219d"]]), TW = {
  name: "LF4",
  mixins: [fr],
  data() {
    return {
      displayImage: "",
      displayImageAlt: ""
    };
  },
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  },
  mounted() {
    this.setDisplayImage();
  },
  methods: {
    setImage(e) {
      if (e.live_feed_images.length >= 1) {
        this.displayImage = e.live_feed_images[0].url, this.displayImageAlt = e.live_feed_images[0].alt_text;
        return;
      }
      this.setDisplayImage();
    },
    setDisplayImage() {
      var e, t, n, r, o, i;
      this.displayImage = ((n = (t = (e = this.filteredPosts[0]) == null ? void 0 : e.live_feed_images) == null ? void 0 : t[0]) == null ? void 0 : n.url) || this.fallbackImage.url, this.displayImageAlt = ((i = (o = (r = this.filteredPosts[0]) == null ? void 0 : r.live_feed_images) == null ? void 0 : o[0]) == null ? void 0 : i.alt_text) || "";
    }
  }
}, kW = { class: "LF4__container" }, EW = ["data-testid"], SW = { class: "LF4__posts__container-images" }, MW = ["src", "alt"], AW = ["onMouseover"], IW = { class: "LF4__posts__container__post__avatar" }, LW = ["src"], DW = { class: "LF4__posts__container__post__info" }, $W = { class: "live-feed-time" }, OW = ["aria-labelledby", "aria-posinset", "aria-setsize"], PW = ["id", "innerHTML"], NW = ["onKeydown", "onClick"], HW = {
  class: "button-action-content",
  tabindex: "-1"
}, FW = { class: "LF4__posts__image" }, RW = ["src", "alt"];
function VW(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "LF4",
    style: Z(e.colors),
    class: _(e.theme.style),
    role: "feed"
  }, [
    c("div", kW, [
      c("div", {
        class: _([e.theme.style, "LF4__posts"])
      }, [
        c("div", {
          class: _(["LF4__posts__container", e.theme.style])
        }, [
          j(a, {
            class: _([e.theme.style, "see-all-top"]),
            "theme-options": e.theme
          }, {
            header: S(() => [
              e.isMonterreyStyle ? (d(), f("h3", {
                key: 0,
                "data-testid": `header-${e.theme.style}-top`
              }, [
                M(e.$slots, "header-top", {}, () => [
                  H(k(e.sectionHeaderTop), 1)
                ], !0)
              ], 8, EW)) : T("", !0),
              (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
                "data-testid": `header-${e.theme.style}-top`
              }, {
                default: S(() => [
                  M(e.$slots, "header", {}, () => [
                    H(k(e.sectionHeader), 1)
                  ], !0)
                ]),
                _: 3
              }, 8, ["data-testid"]))
            ]),
            default: S(() => [
              e.theme.style === "bold" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
                key: 0,
                class: _(["see-all-button", e.theme.style]),
                href: e.seeAllLinkHref,
                target: e.seeAllLinkTarget,
                "data-testid": `see-all-${e.theme.style}-top`,
                onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
              }, {
                default: S(() => [
                  H(k(e.seeAllLinkName), 1)
                ]),
                _: 1
              }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
            ]),
            _: 3
          }, 8, ["class", "theme-options"]),
          c("div", SW, [
            c("img", {
              class: "LF4__posts__container-images__image",
              src: o.displayImage,
              alt: o.displayImageAlt,
              loading: "lazy"
            }, null, 8, MW)
          ]),
          (d(!0), f(J, null, ne(i.filteredPosts, (s, l) => (d(), f("div", {
            key: `${l}-${s.author}-LF`,
            class: _([[e.theme.style, { "is-editing": e.isEditing }], "LF4__posts__container__post"]),
            "data-testid": "live-feed-content",
            onMouseover: (u) => i.setImage(s)
          }, [
            c("div", IW, [
              c("img", {
                src: s.avatar,
                alt: "",
                role: "presentation"
              }, null, 8, LW)
            ]),
            c("div", DW, [
              c("div", {
                class: _([e.theme.style, "LF4__posts__container__post__info__time-author"])
              }, [
                H(k(s.author) + ", ", 1),
                c("span", $W, k(s.time_ago), 1)
              ], 2),
              c("div", {
                class: _([e.theme.style, "live-feed-details"]),
                role: "article",
                tabindex: "0",
                "aria-labelledby": `LF-${s.id}`,
                "aria-posinset": l + 1,
                "aria-setsize": i.filteredPosts.length
              }, [
                c("div", {
                  id: `LF-${s.id}`,
                  class: _(["LF4__posts__container__post__info__text", e.theme.style]),
                  innerHTML: e.getPostContent(s)
                }, null, 10, PW),
                e.isPreview || s.live_feed_images.length > 0 ? (d(), f("button", {
                  key: 0,
                  class: "view-images button-action",
                  "data-testid": "live-feed-images-button",
                  "aria-haspopup": "true",
                  onKeydown: [
                    K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
                    K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
                  ],
                  onClick: (u) => e.onClickImage(u, s.live_feed_images)
                }, [
                  c("div", HW, k(e.viewImageText(s)), 1)
                ], 40, NW)) : T("", !0)
              ], 10, OW)
            ])
          ], 42, AW))), 128)),
          (e.isEditing || e.posts.length > 4) && (e.theme.style !== "bold" || e.screenSize < 600) ? (d(), I(a, {
            key: 0,
            class: _([e.theme.style, "see-all-bottom"]),
            "theme-options": e.theme,
            "data-testid": "see-all-bottom"
          }, {
            default: S(() => [
              (d(), I(Y(e.isEditing ? "button" : "a"), {
                class: _(["see-all-button", e.theme.style]),
                href: e.seeAllLinkHref,
                target: e.seeAllLinkTarget,
                "data-testid": `see-all-${e.theme.style}-bottom`,
                onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
              }, {
                default: S(() => [
                  H(k(e.seeAllLinkName), 1)
                ]),
                _: 1
              }, 8, ["class", "href", "target", "data-testid"]))
            ]),
            _: 1
          }, 8, ["class", "theme-options"])) : T("", !0)
        ], 2),
        c("div", FW, [
          c("img", {
            class: "LF4__posts__image__img",
            src: o.displayImage,
            alt: o.displayImageAlt
          }, null, 8, RW)
        ])
      ], 2)
    ])
  ], 6);
}
const BW = /* @__PURE__ */ B(TW, [["render", VW], ["__scopeId", "data-v-13ae5631"]]), jW = {
  name: "LF5",
  mixins: [fr],
  data() {
    return {
      active: null,
      collapsedSibling: null
    };
  },
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 3);
    }
  },
  methods: {
    setActiveCard(e) {
      this.active = e;
      const t = Math.min(window.innerWidth, document.documentElement.clientWidth);
      if (t > 600 && t < 1281 || this.isPreview && t > 1080 && t < 1441) {
        this.collapsedSibling = e === 0 ? 1 : 0;
        return;
      }
      e < 2 ? this.collapsedSibling = e + 1 : e === 2 && (this.collapsedSibling = 1);
    }
  }
}, UW = ["data-testid"], qW = { class: "live-feed--post-container" }, GW = ["onMouseenter"], KW = { class: "live-feed--card-description" }, zW = { class: "live-feed--card-description--icon" }, ZW = ["src"], xW = { class: "live-feed-time" }, WW = ["aria-labelledby", "aria-posinset", "aria-setsize"], YW = ["id", "innerHTML"], XW = ["onKeydown", "onClick"], QW = {
  class: "button-action-content",
  tabindex: "-1"
}, JW = { class: "live-feed--card-image" }, eY = ["src", "alt"];
function tY(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "live-feed-lf5",
    class: _(e.theme.style),
    style: Z(e.colors),
    role: "feed"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, UW)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["hide-on-xs hide-on-lg-three-cols see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", qW, [
      (d(!0), f(J, null, ne(i.filteredPosts, (s, l) => (d(), f("div", {
        key: `${l}-${s.author}-LF`,
        class: _(["live-feed--card", [{ collapsed: l === o.collapsedSibling }, { "is-editing": e.isEditing }]]),
        "data-testid": "live-feed-content",
        onMouseenter: (u) => i.setActiveCard(l),
        onMouseleave: t[1] || (t[1] = (u) => {
          o.active = null, o.collapsedSibling = null;
        })
      }, [
        c("div", KW, [
          c("div", zW, [
            c("img", {
              src: s.avatar,
              alt: "",
              role: "presentation",
              loading: "lazy"
            }, null, 8, ZW)
          ]),
          c("div", {
            class: _(["live-feed--card-description--header", e.theme.style])
          }, [
            c("span", null, [
              H(k(s.author) + " - ", 1),
              c("span", xW, k(s.time_ago), 1)
            ])
          ], 2),
          c("div", {
            class: _([e.theme.style, "live-feed-details"]),
            role: "article",
            tabindex: "0",
            "aria-labelledby": `LF-${s.id}`,
            "aria-posinset": l + 1,
            "aria-setsize": i.filteredPosts.length
          }, [
            c("div", {
              id: `LF-${s.id}`,
              class: _(["live-feed--card-description--content", e.theme.style]),
              innerHTML: e.getPostContent(s, 120)
            }, null, 10, YW),
            e.isPreview || s.live_feed_images.length > 0 ? (d(), f("button", {
              key: 0,
              class: "view-images button-action",
              "aria-haspopup": "true",
              onKeydown: [
                K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
                K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
              ],
              onClick: (u) => e.onClickImage(u, s.live_feed_images)
            }, [
              c("div", QW, k(e.viewImageText(s)), 1)
            ], 40, XW)) : T("", !0)
          ], 10, WW)
        ]),
        c("div", JW, [
          c("img", {
            src: s.live_feed_images.length > 0 ? s.live_feed_images[0].url : e.fallbackImage.url,
            alt: s.live_feed_images.length > 0 ? s.live_feed_images[0].alt_text : "",
            loading: "lazy"
          }, null, 8, eY)
        ])
      ], 42, GW))), 128))
    ]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[2] || (t[2] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const nY = /* @__PURE__ */ B(jW, [["render", tY], ["__scopeId", "data-v-2034cbed"]]), rY = {
  name: "LF6Buttons",
  props: {
    arrowColor: {
      type: String,
      default: "#fff"
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    borderColor: {
      type: String,
      default: "#fff"
    },
    previousSlideText: {
      type: String,
      default: ""
    },
    nextSlideText: {
      type: String,
      default: ""
    }
  }
}, oY = {
  class: "buttons",
  role: "group",
  "aria-label": "slide controls"
}, iY = ["aria-label"], sY = {
  width: "15",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aY = ["stroke"], lY = ["aria-label"], uY = {
  width: "15",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dY = ["stroke"];
function cY(e, t, n, r, o, i) {
  return d(), f("div", oY, [
    c("button", {
      class: "button",
      style: Z({
        "background-color": n.backgroundColor,
        "border-color": n.borderColor
      }),
      "aria-label": n.previousSlideText,
      onClick: t[0] || (t[0] = (a) => e.$emit("scroll-left")),
      onKeyup: t[1] || (t[1] = K((a) => e.$emit("scroll-left"), ["left"]))
    }, [
      (d(), f("svg", sY, [
        c("path", {
          d: "M1 6h13M1 6l4.79 5M1 6l4.79-5",
          stroke: n.arrowColor,
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, aY)
      ]))
    ], 44, iY),
    c("button", {
      class: "button mirror",
      style: Z({
        "background-color": n.backgroundColor,
        "border-color": n.borderColor
      }),
      "aria-label": n.nextSlideText,
      onClick: t[2] || (t[2] = (a) => e.$emit("scroll-right")),
      onKeyup: t[3] || (t[3] = K((a) => e.$emit("scroll-right"), ["right"]))
    }, [
      (d(), f("svg", uY, [
        c("path", {
          d: "M1 6h13M1 6l4.79 5M1 6l4.79-5",
          stroke: n.arrowColor,
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, dY)
      ]))
    ], 44, lY)
  ]);
}
const hY = /* @__PURE__ */ B(rY, [["render", cY], ["__scopeId", "data-v-0ee870d6"]]);
var uc, Pp;
function mY() {
  if (Pp) return uc;
  Pp = 1;
  function e(t, n, r) {
    var o = -1, i = t.length;
    n < 0 && (n = -n > i ? 0 : i + n), r = r > i ? i : r, r < 0 && (r += i), i = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var a = Array(i); ++o < i; )
      a[o] = t[o + n];
    return a;
  }
  return uc = e, uc;
}
var dc, Np;
function fY() {
  if (Np) return dc;
  Np = 1;
  var e = e0(), t = Ms(), n = e8(), r = ur();
  function o(i, a, s) {
    if (!r(s))
      return !1;
    var l = typeof a;
    return (l == "number" ? t(s) && n(a, s.length) : l == "string" && a in s) ? e(s[a], i) : !1;
  }
  return dc = o, dc;
}
var cc, Hp;
function pY() {
  if (Hp) return cc;
  Hp = 1;
  var e = ug(), t = 1 / 0, n = 17976931348623157e292;
  function r(o) {
    if (!o)
      return o === 0 ? o : 0;
    if (o = e(o), o === t || o === -t) {
      var i = o < 0 ? -1 : 1;
      return i * n;
    }
    return o === o ? o : 0;
  }
  return cc = r, cc;
}
var hc, Fp;
function gY() {
  if (Fp) return hc;
  Fp = 1;
  var e = pY();
  function t(n) {
    var r = e(n), o = r % 1;
    return r === r ? o ? r - o : r : 0;
  }
  return hc = t, hc;
}
var mc, Rp;
function vY() {
  if (Rp) return mc;
  Rp = 1;
  var e = mY(), t = fY(), n = gY(), r = Math.ceil, o = Math.max;
  function i(a, s, l) {
    (l ? t(a, s, l) : s === void 0) ? s = 1 : s = o(n(s), 0);
    var u = a == null ? 0 : a.length;
    if (!u || s < 1)
      return [];
    for (var m = 0, v = 0, g = Array(r(u / s)); m < u; )
      g[v++] = e(a, m, m += s);
    return g;
  }
  return mc = i, mc;
}
var bY = vY();
const yY = /* @__PURE__ */ Co(bY), _Y = {
  name: "LF6",
  components: {
    Pager: n0,
    LFButtons: hY
  },
  mixins: [fr, bt],
  props: {
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    sliderCenterSize() {
      return this.screenSize;
    },
    logoStyles() {
      return {
        "--logo-url": `url(${this.logo})`
      };
    },
    nextSlideText() {
      var e;
      return ((e = this.theme.translations) == null ? void 0 : e.next_slide) || "Next slide";
    },
    previousSlideText() {
      var e;
      return ((e = this.theme.translations) == null ? void 0 : e.previous_slide) || "Previous slide";
    },
    content() {
      return yY(this.posts, 3);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    getGalleryType(e) {
      const t = e.live_feed_images.length;
      return t > 4 ? "cols-4 overflow" : `cols-${t}`;
    },
    goToCard(e) {
      this.currentCard = e - 1, this.calculateScroll();
    },
    handleFocusChange(e) {
      e !== this.currentCard && (this.currentCard = e, this.calculateScroll());
    },
    setCardHeight() {
      if (this.isEditing)
        return;
      this.$refs.scrollWrapper.style.minHeight = "auto";
      const e = Math.max(
        ...Array.from(this.content.length).map((n, r) => this.$refs[`sliderCard-${r}`].offsetHeight)
      ), t = this.content.length <= 2 ? 48 : 0;
      this.$refs.scrollWrapper.style.minHeight = `${e + t}px`;
    }
  }
}, CY = ["data-testid"], wY = ["data-testid"], TY = { class: "controls" }, kY = ["aria-label"], EY = ["id", "aria-label", "onFocusin"], SY = ["id"], MY = { class: "header" }, AY = ["src"], IY = { class: "time-author" }, LY = ["aria-labelledby", "aria-posinset", "aria-setsize"], DY = ["id", "innerHTML"], $Y = ["data-see-more", "aria-label", "onClick"], OY = ["src"];
function PY(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("LFButtons"), l = V("Pager");
  return d(), f("div", {
    id: "LF6",
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    style: Z(e.colors),
    "data-testid": "lf6",
    role: "feed"
  }, [
    j(a, {
      class: _(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, wY)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, CY)
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": "see-all-bold-top",
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: "slider-container",
      style: Z(i.logoStyles)
    }, [
      c("div", TY, [
        j(a, {
          class: _(e.theme.style),
          "theme-options": e.theme,
          "data-testid": "lf-link"
        }, {
          default: S(() => [
            e.theme.style !== "bold" || e.screenSize <= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
              key: 0,
              class: _([e.theme.style, "see-all-button"]),
              href: e.seeAllLinkHref,
              target: e.seeAllLinkTarget,
              "data-testid": `see-all-${e.theme.style}-button`,
              onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
            }, {
              default: S(() => [
                H(k(e.seeAllLinkName), 1)
              ]),
              _: 1
            }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
          ]),
          _: 1
        }, 8, ["class", "theme-options"]),
        c("div", {
          "aria-label": e.sectionHeader,
          role: "region",
          "aria-roledescription": "carousel",
          class: "control-actions-wrapper"
        }, [
          j(s, {
            "arrow-color": e.theme.arrow_icon_color.hex,
            "background-color": e.theme.arrow_background_color.hex,
            "border-color": e.theme.arrow_border_color.hex,
            "previous-slide-text": i.previousSlideText,
            "next-slide-text": i.nextSlideText,
            onScrollLeft: e.scrollLeft,
            onScrollRight: e.scrollRight
          }, null, 8, ["arrow-color", "background-color", "border-color", "previous-slide-text", "next-slide-text", "onScrollLeft", "onScrollRight"]),
          j(l, {
            "total-cards": i.content.length,
            "pager-color": e.theme.pager_color.hex,
            "theme-styles": e.theme,
            "current-card": e.currentCard,
            "pager-section-count": i.content.length,
            class: "pager",
            onGoToSection: i.goToCard
          }, null, 8, ["total-cards", "pager-color", "theme-styles", "current-card", "pager-section-count", "onGoToSection"])
        ], 8, kY)
      ]),
      c("div", {
        ref: "scrollWrapper",
        class: _(["slider", { "is-editing": e.isEditing }])
      }, [
        (d(!0), f(J, null, ne(i.content, (u, m) => (d(), f("div", {
          id: `slide-${m}`,
          key: m,
          ref_for: !0,
          ref: `sliderCard-${m}`,
          class: _(`slide slide-${m} ${m === e.currentCard && "active"}`),
          "aria-label": `${m + 1} of ${i.content.length}`,
          "data-testid": "live-feed-content",
          role: "group",
          "aria-roledescription": "slide",
          onFocusin: (v) => i.handleFocusChange(m)
        }, [
          (d(!0), f(J, null, ne(u, (v, g) => (d(), f("div", {
            id: g,
            key: g,
            class: "post"
          }, [
            c("div", MY, [
              c("img", {
                src: v.avatar,
                class: "avatar",
                alt: "",
                role: "presentation",
                loading: "lazy"
              }, null, 8, AY),
              c("span", IY, k(v.author) + " | " + k(v.time_ago), 1)
            ]),
            c("div", {
              class: "details",
              role: "article",
              tabindex: "0",
              "aria-labelledby": `LF-${v.id}`,
              "aria-posinset": g + 1,
              "aria-setsize": u.length
            }, [
              c("div", {
                id: `LF-${v.id}`,
                class: "post-content",
                innerHTML: e.getPostContent(v, 200)
              }, null, 8, DY),
              v.live_feed_images.length ? (d(), f("div", {
                key: 0,
                class: _(["gallery", i.getGalleryType(v)])
              }, [
                (d(!0), f(J, null, ne(v.live_feed_images, (h, E) => (d(), f("button", {
                  key: `gallery-item-${E}`,
                  "data-see-more": v.live_feed_images.length > 4 && `+ ${v.live_feed_images.length - 4}`,
                  "aria-label": e.translations.open_image_in_modal,
                  class: "gallery-item",
                  onClick: (C) => e.onClickImage(C, v.live_feed_images)
                }, [
                  c("img", {
                    class: "gallery-image",
                    src: h.url,
                    alt: "",
                    loading: "lazy"
                  }, null, 8, OY)
                ], 8, $Y))), 128))
              ], 2)) : T("", !0)
            ], 8, LY)
          ], 8, SY))), 128))
        ], 42, EY))), 128))
      ], 2)
    ], 4)
  ], 6);
}
const NY = /* @__PURE__ */ B(_Y, [["render", PY], ["__scopeId", "data-v-0723837b"]]), HY = {
  name: "LF7",
  components: { CardSlider: cn },
  mixins: [fr, bt],
  computed: {
    content() {
      return this.posts.slice(0, 12);
    },
    sliderCenterSize() {
      return 599;
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    }
  },
  methods: {
    extraImagesContent(e) {
      return e.live_feed_images.length > 4 ? `+ ${e.live_feed_images.length - 3}` : "";
    },
    backgroundImage(e, t) {
      return {
        backgroundImage: `url("${e.live_feed_images[t].url}")`
      };
    }
  }
}, FY = ["data-testid"], RY = ["data-testid"], VY = ["aria-label"], BY = { class: "post live-feed-details" }, jY = { class: "post-info" }, UY = ["src"], qY = { class: "author" }, GY = { class: "time-ago" }, KY = ["id", "innerHTML"], zY = { class: "thumbnails-wrapper" }, ZY = ["aria-label", "data-before", "data-testid", "onClick"];
function xY(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    class: _(["live-feed-lf7", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: Z(e.colors),
    "data-testid": "lf7"
  }, [
    j(a, {
      class: _(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          i.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, RY)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, FY)
      ]),
      default: S(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      class: _({ "is-editing": e.isEditing }),
      "pager-section-count": e.pagerSectionCount,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        c("div", {
          ref: "scrollWrapper",
          class: _(["posts-wrapper", { "all-cards-visible": e.allCardsVisible }])
        }, [
          (d(!0), f(J, null, ne(i.content, (l, u) => (d(), f("div", {
            key: `${l}-${u}`,
            ref_for: !0,
            ref: `sliderCard-${u}`,
            class: _(["card-content", `card-${u}`]),
            "data-testid": "live-feed-content",
            "aria-label": `${u + 1} of ${i.content.length}`,
            role: "group",
            "aria-roledescription": "slide"
          }, [
            c("div", BY, [
              c("div", jY, [
                c("img", {
                  src: l.avatar,
                  role: "presentation",
                  loading: "lazy"
                }, null, 8, UY),
                c("div", qY, k(l.author), 1),
                t[2] || (t[2] = c("span", null, "|", -1)),
                c("div", GY, k(l.time_ago), 1)
              ]),
              c("div", {
                id: `LF-${l.id}`,
                class: "post-status",
                innerHTML: e.getPostContent(l)
              }, null, 8, KY),
              c("div", zY, [
                (d(!0), f(J, null, ne(l.live_feed_images.slice(0, 4), (m, v) => (d(), f("button", {
                  key: m.id + v,
                  class: "live-feed-image-thumbnail",
                  "aria-label": e.translations.open_image_in_modal,
                  "data-before": i.extraImagesContent(l),
                  style: Z(i.backgroundImage(l, v)),
                  "data-testid": `live-feed-images-button-${v}`,
                  onClick: (g) => e.$emit("openLightbox", { images: l.live_feed_images, idx: v })
                }, null, 12, ZY))), 128))
              ])
            ])
          ], 10, VY))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "class", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const WY = /* @__PURE__ */ B(HY, [["render", xY], ["__scopeId", "data-v-7551fe7e"]]), YY = {
  name: "ImageGallery",
  props: {
    images: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      activeItem: 0
    };
  },
  methods: {
    activateItem(e) {
      this.activeItem = e;
    },
    activateNext() {
      let e = this.activeItem + 1;
      e >= this.images.length && (e = 0), this.activeItem = e;
    },
    activatePrev() {
      let e = this.activeItem - 1;
      e < 0 && (e = this.images.length - 1), this.activeItem = e;
    },
    handleImageClick(e) {
      this.$emit("image-click", { e });
    }
  }
}, XY = {
  class: "image-gallery",
  "data-testid": "image-gallery"
}, QY = {
  key: 0,
  class: "gallery-image"
}, JY = ["src", "alt"], eX = {
  key: 0,
  class: "gallery-controls"
}, tX = { class: "indicators" }, nX = {
  class: "buttons",
  role: "group",
  "aria-label": "slide controls"
};
function rX(e, t, n, r, o, i) {
  return d(), f("div", XY, [
    c("div", {
      class: "gallery-track",
      onClick: t[0] || (t[0] = (a) => i.handleImageClick(a))
    }, [
      t[3] || (t[3] = c("div", {
        class: "gallery-overlay",
        "data-testid": "gallery-overlay"
      }, null, -1)),
      (d(!0), f(J, null, ne(n.images, (a, s) => (d(), f("div", {
        key: a.id + s,
        class: _(["gallery-slide", o.activeItem === s && "is-active"]),
        "data-testid": "gallery-slide"
      }, [
        a.url ? (d(), f("div", QY, [
          c("img", {
            src: a.url,
            alt: a.alt_text
          }, null, 8, JY)
        ])) : T("", !0)
      ], 2))), 128))
    ]),
    n.images.length > 1 ? (d(), f("div", eX, [
      c("div", tX, k(o.activeItem + 1) + " / " + k(n.images.length), 1),
      c("div", nX, [
        c("button", {
          class: "button left",
          "aria-label": "button prev",
          onClick: t[1] || (t[1] = (...a) => i.activatePrev && i.activatePrev(...a))
        }, t[4] || (t[4] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ])),
        c("button", {
          class: "button right",
          "aria-label": "button next",
          onClick: t[2] || (t[2] = (...a) => i.activateNext && i.activateNext(...a))
        }, t[5] || (t[5] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]))
      ])
    ])) : T("", !0)
  ]);
}
const oX = /* @__PURE__ */ B(YY, [["render", rX], ["__scopeId", "data-v-49126e1d"]]), iX = {
  name: "LF8",
  components: { Slider: eh, ImageGallery: oX },
  mixins: [fr, bt],
  computed: {
    content() {
      return this.posts;
    },
    sliderCenterSize() {
      return 599;
    },
    cssVars() {
      var e, t;
      return ge(ae({}, this.colors), {
        "--percentage-button-opacity": `${(e = this.theme.percentage_button_opacity) != null ? e : 0}%`,
        "--image-gradient-color": $(this.theme, "image_gradient_color.hex", "#000000"),
        "--image-gradient-opacity": `${(t = this.theme.image_gradient_opacity) != null ? t : 80}%`,
        "--indicators-color": $(this.theme, "indicators_color.hex", "#FFFFFF"),
        "--arrow-color": $(this.theme, "arrow_color.hex", "#FFFFFF"),
        "--button-border-color": $(this.theme, "button_border_color.hex", "#FFFFFF")
      });
    }
  }
}, sX = { class: "wrapper" }, aX = ["data-testid"], lX = ["data-testid"], uX = { class: "button-text" }, dX = {
  ref: "scrollWrapper",
  class: "cards-wrapper"
}, cX = ["aria-label"], hX = ["aria-labelledby", "aria-posinset", "aria-setsize"], mX = { class: "card-header" }, fX = ["src"], pX = { class: "author" }, gX = { class: "time-ago" }, vX = ["id", "innerHTML"], bX = {
  key: 0,
  class: "card-gallery"
}, yX = {
  class: "buttons-container",
  role: "group",
  "aria-label": "slide controls"
}, _X = { class: "button-text" };
function CX(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("ImageGallery"), l = V("Slider");
  return d(), f("div", {
    class: _(["live-feed-lf8", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: Z(i.cssVars),
    "data-testid": "lf8",
    role: "feed"
  }, [
    c("div", sX, [
      j(a, {
        class: _(["see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (d(), f("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.sectionHeaderTop), 1)
              ], !0)
            ], 8, lX)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ], 8, aX)
        ]),
        default: S(() => [
          e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
            key: 0,
            class: _(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              c("div", uX, k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      j(l, {
        "current-card": e.currentCard,
        class: _(["slider", { "is-editing": e.isEditing }]),
        "total-cards": i.content.length,
        "theme-styles": e.theme,
        "section-header": e.sectionHeader,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        "button-left": S(() => [
          c("button", {
            class: "slider-button left",
            "aria-label": "button prev",
            onKeyup: t[1] || (t[1] = K((...u) => e.scrollLeft && e.scrollLeft(...u), ["left"])),
            onClick: t[2] || (t[2] = (...u) => e.scrollLeft && e.scrollLeft(...u))
          }, t[10] || (t[10] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 32)
        ]),
        "button-right": S(() => [
          c("button", {
            class: "slider-button right",
            "aria-label": "button next",
            onKeyup: t[3] || (t[3] = K((...u) => e.scrollRight && e.scrollRight(...u), ["right"])),
            onClick: t[4] || (t[4] = (...u) => e.scrollRight && e.scrollRight(...u))
          }, t[11] || (t[11] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 32)
        ]),
        default: S(() => [
          c("div", dX, [
            (d(!0), f(J, null, ne(i.content, (u, m) => (d(), f("div", {
              key: `${u}-${m}`,
              ref_for: !0,
              ref: `sliderCard-${m}`,
              class: _(["card", `card-${m}`]),
              "data-testid": "live-feed-content",
              "aria-label": `${m + 1} of ${i.content.length}`,
              role: "group",
              "aria-roledescription": "slide"
            }, [
              c("div", {
                class: "card-content",
                role: "article",
                tabindex: "0",
                "aria-labelledby": `LF-${u.id}`,
                "aria-posinset": m + 1,
                "aria-setsize": i.content.length
              }, [
                c("div", mX, [
                  c("img", {
                    src: u.avatar,
                    role: "presentation",
                    loading: "lazy"
                  }, null, 8, fX),
                  c("div", pX, k(u.author), 1),
                  c("div", gX, k(u.time_ago), 1)
                ]),
                c("div", {
                  id: `LF-${u.id}`,
                  class: "card-description",
                  innerHTML: e.getPostContent(u)
                }, null, 8, vX)
              ], 8, hX),
              u.live_feed_images.length >= 1 && e.screenSize > 600 ? (d(), f("div", bX, [
                j(s, {
                  images: u.live_feed_images,
                  onImageClick: (v) => e.onClickImage(v, u.live_feed_images)
                }, null, 8, ["images", "onImageClick"])
              ])) : T("", !0)
            ], 10, cX))), 128))
          ], 512)
        ]),
        _: 1
      }, 8, ["current-card", "class", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft"]),
      c("div", yX, [
        c("button", {
          class: "slider-button left",
          "aria-label": "button prev",
          onKeyup: t[5] || (t[5] = K((...u) => e.scrollLeft && e.scrollLeft(...u), ["left"])),
          onClick: t[6] || (t[6] = (...u) => e.scrollLeft && e.scrollLeft(...u))
        }, t[12] || (t[12] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]), 32),
        c("button", {
          class: "slider-button right",
          "aria-label": "button next",
          onKeyup: t[7] || (t[7] = K((...u) => e.scrollRight && e.scrollRight(...u), ["right"])),
          onClick: t[8] || (t[8] = (...u) => e.scrollRight && e.scrollRight(...u))
        }, t[13] || (t[13] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]), 32)
      ]),
      e.theme.style === "purple" || e.screenSize < 600 ? (d(), I(a, {
        key: 0,
        class: _([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.theme.style}-bottom`
      }, {
        default: S(() => [
          (d(), I(Y(e.isEditing ? "button" : "a"), {
            class: _(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[9] || (t[9] = (u) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              c("div", _X, k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
    ])
  ], 6);
}
const wX = /* @__PURE__ */ B(iX, [["render", CX], ["__scopeId", "data-v-45fd8393"]]), TX = {
  name: "LiveFeed",
  components: {
    LF1: eW,
    LF2: cW,
    LF3: wW,
    LF4: BW,
    LF5: nY,
    LF6: NY,
    LF7: WY,
    LF8: wX
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    fallbackImage: {
      type: Object,
      default: () => {
      }
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    livefeedConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: Boolean,
    logo: {
      type: String,
      default: ""
    }
  },
  methods: {
    openLightbox(e) {
      this.$emit("toggleLightbox", e);
    },
    saveFocusElement(e) {
      this.$emit("savePrevFocusedElem", e);
    }
  }
}, kX = { id: "cms-live-feed" };
function EX(e, t, n, r, o, i) {
  return d(), f("div", kX, [
    (d(), I(Y(n.theme.version), {
      theme: n.theme,
      posts: n.content,
      "livefeed-config": n.livefeedConfig,
      "component-id": n.componentId,
      "fallback-image": n.fallbackImage,
      "path-prefix": n.pathPrefix,
      "is-preview": n.isPreview,
      "is-i-frame": n.isIFrame,
      "is-editing": n.isEditing,
      logo: n.logo,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal")),
      onSaveFocusElement: t[1] || (t[1] = (a) => i.saveFocusElement(a)),
      onOpenLightbox: t[2] || (t[2] = (a) => i.openLightbox(a))
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "posts", "livefeed-config", "component-id", "fallback-image", "path-prefix", "is-preview", "is-i-frame", "is-editing", "logo"]))
  ]);
}
const SX = /* @__PURE__ */ B(TX, [["render", EX], ["__scopeId", "data-v-cf483d17"]]), _i = {
  mixins: [kt],
  components: { DraggableWrapper: vt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    stats: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    isPreview: Boolean
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors(), t = e["--heading-color"];
      return ge(ae({}, e), {
        "--accent-color": $(this.theme, "accent_color.hex", "#FFF"),
        "--arrow-color": $(this.theme, "arrow_icon_color.hex", "#FFF"),
        "--card-bg-color": $(this.theme, "card_bg_color.hex", t),
        "--card-2-bg-color": $(this.theme, "card_2_bg_color.hex", "#FCD40B"),
        "--card-3-bg-color": $(this.theme, "card_3_bg_color.hex", "#131313"),
        "--card-border-color": $(this.theme, "card_border_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--card-top-border": $(this.theme, "card_top_border.hex", t),
        "--color": $(this.theme, "color.hex", t),
        "--color-2": $(this.theme, "color_2.hex", t),
        "--color-3": $(this.theme, "color_3.hex", t),
        "--description-color": $(this.theme, "description_color.hex", t),
        "--headline-color": $(this.theme, "headline_color.hex", "#FFF"),
        "--icon-bg-color": $(this.theme, "icon_bg_color.hex", t),
        "--icon-color": $(this.theme, "icon_color.hex", t),
        "--link-color": $(this.theme, "link_color.hex", "#FFF"),
        "--link-hover-color": $(this.theme, "link_hover_color.hex", "#FFF"),
        "--snippet-color": $(this.theme, "snippet_color.hex", "#333"),
        "--stats-header-color": $(this.theme, "stats_header_color.hex", "#FFF"),
        "--stats-slider-header-width": this.stats.headline && this.stats.slider ? "calc(100%/3 - 16px)" : "calc(25% - 18px)"
      });
    },
    translations() {
      return this.theme.translations;
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.stats.component_header_top || this.isEditing);
    },
    backgroundStyle() {
      var t, n;
      if (!((t = this.stats.bg_image) != null && t.url) || !this.theme.show_background_image) return null;
      const e = `${this.theme.bg_color.hex}e6`;
      return {
        backgroundImage: `linear-gradient(${e}, ${e}), url(${((n = this.stats.bg_image) == null ? void 0 : n.url) || ""})`,
        backgroundSize: "cover",
        backgroundPosition: "center center"
      };
    }
  }
}, MX = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, AX = {
  width: "22",
  height: "32",
  viewBox: "0 0 22 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, IX = ["fill"];
function LX(e, t, n, r, o, i) {
  return d(), f("svg", AX, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17 20.2059V30.9971C17 31.3818 16.779 31.7315 16.434 31.8988C16.296 31.9639 16.148 31.997 16 31.997C15.777 31.997 15.556 31.9219 15.375 31.7776L11 28.278L6.625 31.7776C6.324 32.018 5.915 32.0631 5.566 31.8988C5.221 31.7315 5 31.3818 5 30.9971V20.2059C1.994 18.2402 0 14.8498 0 10.9986C0 4.93325 4.935 0 11 0C17.065 0 22 4.93325 22 10.9986C22 14.8498 20.006 18.2402 17 20.2059ZM7 28.9162L10.375 26.2172C10.74 25.9246 11.26 25.9246 11.625 26.2172L15 28.9162V21.2338C13.758 21.7207 12.412 21.9982 11 21.9982C9.588 21.9982 8.242 21.7207 7 21.2338V28.9162ZM11 1.99875C6.037 1.99875 2 6.03632 2 10.9986C2 15.9599 6.037 19.9975 11 19.9975C15.963 19.9975 20 15.9599 20 10.9986C20 6.03632 15.963 1.99875 11 1.99875ZM13 15.998H9C8.447 15.998 8 15.5502 8 14.9981C8 14.4461 8.447 13.9982 9 13.9982H10V9.41265L8.707 10.7051C8.512 10.9014 8.256 10.9986 8 10.9986C7.744 10.9986 7.488 10.9014 7.293 10.7051C6.902 10.3153 6.902 9.68215 7.293 9.29142L10.292 6.2928C10.385 6.19962 10.495 6.12649 10.618 6.07539C10.733 6.0283 10.855 6.00626 10.977 6.00326C10.985 6.00326 10.992 5.99825 11 5.99825C11.007 5.99825 11.012 6.00225 11.019 6.00225C11.143 6.00526 11.266 6.0283 11.382 6.07539C11.627 6.17758 11.822 6.37195 11.923 6.61741C11.973 6.73863 12 6.86788 12 6.99712C12 6.99812 12 6.99812 12 6.99912V13.9982H13C13.553 13.9982 14 14.4461 14 14.9981C14 15.5502 13.553 15.998 13 15.998Z",
      fill: n.color
    }, null, 8, IX)
  ]);
}
const DX = /* @__PURE__ */ B(MX, [["render", LX]]), $X = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, OX = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, PX = ["fill"];
function NX(e, t, n, r, o, i) {
  return d(), f("svg", OX, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 32C7.178 32 0 24.823 0 16C0 7.178 7.178 0 16 0C24.822 0 32 7.178 32 16C32 24.823 24.822 32 16 32ZM4.948 24.542C6.752 22.358 7.753 19.708 7.951 17H2.048C2.25 19.832 3.307 22.425 4.948 24.542ZM7.95 15C7.753 12.293 6.751 9.643 4.946 7.46C3.306 9.577 2.25 12.169 2.048 15H7.95ZM15 2.051C11.622 2.291 8.579 3.739 6.286 5.957C8.517 8.548 9.737 11.741 9.944 15H15V2.051ZM15 17H9.945C9.738 20.259 8.518 23.453 6.288 26.045C8.581 28.262 11.623 29.709 15 29.949V17ZM29.952 17H24.049C24.247 19.708 25.249 22.358 27.053 24.541C28.693 22.424 29.75 19.832 29.952 17ZM17 29.949C20.378 29.709 23.42 28.261 25.713 26.044C23.483 23.452 22.262 20.259 22.055 17H17V29.949ZM17 2.051V15H22.055C22.262 11.741 23.483 8.548 25.713 5.956C23.42 3.739 20.378 2.291 17 2.051ZM27.053 7.458C25.249 9.643 24.247 12.293 24.049 15H29.952C29.75 12.168 28.693 9.576 27.053 7.458Z",
      fill: n.color
    }, null, 8, PX)
  ]);
}
const HX = /* @__PURE__ */ B($X, [["render", NX]]), FX = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, RX = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VX = ["fill"];
function BX(e, t, n, r, o, i) {
  return d(), f("svg", RX, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30 26H26.85L29.8 30.45C30.1 30.9 30 31.55 29.5 31.85C29.4 31.95 29.2 32 29 32C28.7 32 28.35 31.85 28.15 31.55L24.45 26H17V30C17 30.55 16.55 31 16 31C15.45 31 15 30.55 15 30V26H7.55L3.85 31.55C3.65 31.85 3.3 32 3 32C2.8 32 2.6 31.95 2.45 31.85C2 31.55 1.85 30.9 2.15 30.45L5.1 26H2C0.9 26 0 25.1 0 24V6C0 4.9 0.9 4 2 4H15V1C15 0.45 15.45 0 16 0C16.55 0 17 0.45 17 1V4H30C31.1 4 32 4.9 32 6V24C32 25.1 31.1 26 30 26ZM30 24V10H2V24H30ZM2 6V8H30V6H2Z",
      fill: n.color
    }, null, 8, VX)
  ]);
}
const jX = /* @__PURE__ */ B(FX, [["render", BX]]), UX = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, qX = {
  width: "28",
  height: "32",
  viewBox: "0 0 28 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, GX = ["fill"];
function KX(e, t, n, r, o, i) {
  return d(), f("svg", qX, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M27 29V31C27 31.552 26.553 32 26 32H20C19.447 32 19 31.552 19 31V29H9V31C9 31.552 8.553 32 8 32H2C1.447 32 1 31.552 1 31V29C0.447 29 0 28.552 0 28V3C0 1.346 1.346 0 3 0H25C26.654 0 28 1.346 28 3V28C28 28.552 27.553 29 27 29ZM21 30H25V29H21V30ZM3 30H7V29H3V30ZM26 3C26 2.449 25.552 2 25 2H3C2.448 2 2 2.449 2 3V7H26V3ZM26 9H2V17H26V9ZM26 19H2V27H26V19ZM6 21C7.102 21 8 21.897 8 23C8 24.103 7.102 25 6 25C4.897 25 4 24.103 4 23C4 21.897 4.897 21 6 21ZM22 21C23.102 21 24 21.897 24 23C24 24.103 23.102 25 22 25C20.897 25 20 24.103 20 23C20 21.897 20.897 21 22 21Z",
      fill: n.color
    }, null, 8, GX)
  ]);
}
const zX = /* @__PURE__ */ B(UX, [["render", KX]]), ZX = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, xX = {
  width: "26",
  height: "32",
  viewBox: "0 0 26 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, WX = ["fill"];
function YX(e, t, n, r, o, i) {
  return d(), f("svg", xX, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25.4203 27C26.0792 28.25 26.1806 29.5 25.623 30.45C25.0149 31.45 23.8492 32 22.3794 32H3.62695C2.15716 32 0.940789 31.45 0.383285 30.45C-0.17422 29.5 -0.123538 28.25 0.535331 27L7.98562 13.8V2C7.42812 2 6.97198 1.55 6.97198 1C6.97198 0.45 7.42812 0 7.98562 0H17.97C18.5275 0 18.9837 0.45 18.9837 1C18.9837 1.5 18.5782 1.9 18.1221 2V14L25.4203 27ZM13.0032 7H10.0129V9H13.0032C13.5607 9 14.0168 9.45 14.0168 10C14.0168 10.55 13.5607 11 13.0032 11H10.0129V14.05V14.1C10.0129 14.15 10.0129 14.25 9.96223 14.3C9.96223 14.35 9.91155 14.45 9.91155 14.5V14.55L2.30921 27.95C2.00512 28.55 1.90375 29.05 2.10648 29.4C2.30921 29.75 2.86672 30 3.62695 30H22.3794C23.1396 30 23.6971 29.8 23.8999 29.4C24.1026 29.05 24.0519 28.55 23.6971 27.95L16.0948 14.5C15.9427 14.2 15.9427 13.9 16.0441 13.6V2H9.96223V5H12.9525C13.51 5 13.9661 5.45 13.9661 6C13.9661 6.55 13.5607 7 13.0032 7Z",
      fill: n.color
    }, null, 8, WX)
  ]);
}
const XX = /* @__PURE__ */ B(ZX, [["render", YX]]), QX = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, JX = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eQ = ["fill"];
function tQ(e, t, n, r, o, i) {
  return d(), f("svg", JX, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.7909 3.612L21.9725 16.317L28.6932 23.037C28.6932 23.037 28.6932 23.038 28.6942 23.038L28.6992 23.043C28.7464 23.091 28.7705 23.151 28.8066 23.205C28.8428 23.259 28.89 23.304 28.9151 23.367L28.9181 23.373C28.9181 23.373 28.9181 23.374 28.9191 23.374L31.9235 30.617C32.0791 30.991 31.9927 31.421 31.7066 31.707C31.5148 31.898 31.2597 32 30.9997 32C30.8711 32 30.7396 31.975 30.6171 31.924L23.3753 28.919C23.3743 28.919 23.3733 28.918 23.3712 28.918L23.3672 28.916C23.314 28.894 23.2769 28.853 23.2307 28.824C23.1664 28.784 23.0981 28.755 23.0429 28.699L23.0379 28.695C23.0369 28.694 23.0369 28.694 23.0369 28.693L17.0412 22.698L14.9907 25.352C15.0731 26.699 14.6272 28.048 13.6452 29.203C12.154 30.957 9.70396 32 7.08116 32C7.05706 32 7.03397 32 7.00987 32C4.68529 31.983 2.29847 30.807 0.291199 28.688C0.0100414 28.391 -0.0622564 27.953 0.109451 27.582C0.27915 27.211 0.648671 26.981 1.0674 27.001C3.7394 27.136 4.02256 26.17 4.49652 24.571C4.7114 23.846 4.95541 23.024 5.47354 22.316C6.48972 20.928 8.0622 20.064 9.57041 20L11.8779 17.572L1.29132 6.95C1.26923 6.927 1.26119 6.898 1.24111 6.873C1.21902 6.855 1.19291 6.848 1.17283 6.828C0.416716 6.074 0.00100414 5.069 0 4.001C0 2.933 0.415712 1.928 1.17183 1.171C1.92693 0.416 2.93107 0 3.99947 0C5.06787 0 6.07301 0.416 6.82812 1.171C6.84921 1.193 6.85724 1.222 6.87632 1.245C6.89941 1.264 6.92753 1.272 6.94861 1.293L17.4077 11.751L28.2754 0.311C28.4632 0.112 28.7253 0 28.9994 0C30.5418 0 31.9998 1.458 31.9998 3C31.9998 3.221 31.9265 3.436 31.7909 3.612ZM29.149 29.15L27.6408 25.515L25.5141 27.642L29.149 29.15ZM23.7498 26.578L26.5774 23.75L20.7404 17.912L18.2743 21.103L23.7498 26.578ZM7.08718 23.497C6.7749 23.925 6.59917 24.516 6.41341 25.141C6.02481 26.452 5.52475 28.132 3.42611 28.761C4.60095 29.561 5.83503 29.991 7.02392 30C7.043 30 7.06309 30 7.08216 30C9.12558 30 11.0053 29.22 12.1219 27.908C12.7756 27.139 13.0708 26.265 13.0035 25.418L9.60556 22.02C8.6938 22.064 7.74088 22.604 7.08718 23.497ZM5.53479 2.707C5.5127 2.685 5.50567 2.657 5.48559 2.633C5.4635 2.614 5.43538 2.607 5.41329 2.585C4.65818 1.83 3.34176 1.83 2.58565 2.586C2.20809 2.964 1.99923 3.466 1.99923 4.001C1.99923 4.534 2.20809 5.036 2.58464 5.413C2.60774 5.436 2.61577 5.466 2.63686 5.491C2.65895 5.509 2.68707 5.517 2.70715 5.538L3.99746 6.832L6.82812 4L5.53479 2.707ZM8.24194 5.414L5.40928 8.248L13.2556 16.121L16.03 13.201L8.24194 5.414ZM29.3428 2.092L11.3959 20.982L13.9033 23.489L29.9423 2.733C29.8369 2.474 29.5979 2.222 29.3428 2.092Z",
      fill: n.color
    }, null, 8, eQ)
  ]);
}
const nQ = /* @__PURE__ */ B(QX, [["render", tQ]]), rQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, oQ = {
  width: "32",
  height: "26",
  viewBox: "0 0 32 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iQ = ["fill"];
function sQ(e, t, n, r, o, i) {
  return d(), f("svg", oQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31 21.9873H29C28.447 21.9873 28 21.5398 28 20.9872C28 20.4366 28.447 19.989 29 19.989H30V2.00429H2V20.0531H15C15.553 20.0531 16 20.4366 16 20.9872C16 21.5398 15.553 21.9873 15 21.9873H1C0.447 21.9873 0 21.5398 0 20.9872V1.00513C0 0.453498 0.447 0.00598145 1 0.00598145H31C31.553 0.00598145 32 0.453498 32 1.00513V20.9872C32 21.5398 31.553 21.9873 31 21.9873ZM22 10.9957C24.757 10.9957 27 13.2372 27 15.9924C27 17.1097 26.618 18.1319 25.995 18.9649C25.995 18.9739 26 18.9809 26 18.9899V24.9848C26 25.3522 25.797 25.6916 25.472 25.8658C25.324 25.9449 25.162 25.984 25 25.984C24.806 25.984 24.612 25.9279 24.445 25.8158L22 24.1869L19.555 25.8158C19.249 26.02 18.853 26.04 18.528 25.8658C18.203 25.6916 18 25.3522 18 24.9848V18.9899C18 18.9809 18.005 18.9739 18.005 18.9649C17.382 18.1319 17 17.1097 17 15.9924C17 13.2372 19.243 10.9957 22 10.9957ZM22 12.995C20.346 12.995 19 14.3395 19 15.9924C19 17.6453 20.346 18.9899 22 18.9899C23.654 18.9899 25 17.6453 25 15.9924C25 14.3395 23.654 12.995 22 12.995ZM21.445 22.1545C21.781 21.9313 22.219 21.9313 22.555 22.1545L24 23.1176V20.5647C23.386 20.833 22.712 20.9872 22 20.9872C21.288 20.9872 20.613 20.833 20 20.5647V23.1176L21.445 22.1545ZM15 10.0416C15.553 10.0416 16 10.445 16 10.9957C16 11.5483 15.553 11.9958 15 11.9958H9C8.447 11.9958 8 11.5483 8 10.9957C8 10.445 8.447 10.0416 9 10.0416H15ZM5 7.9992C4.447 7.9992 4 7.55169 4 7.00005C4 6.44841 4.447 6.03694 5 6.03694H27C27.553 6.03694 28 6.44841 28 7.00005C28 7.55169 27.553 7.9992 27 7.9992H5Z",
      fill: n.color
    }, null, 8, iQ)
  ]);
}
const aQ = /* @__PURE__ */ B(rQ, [["render", sQ]]), lQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, uQ = {
  width: "25",
  height: "33",
  viewBox: "0 0 25 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dQ = ["fill"];
function cQ(e, t, n, r, o, i) {
  return d(), f("svg", uQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.55567 0C4.69663 0 3.998 0.699099 3.998 1.55839V26.8914C3.998 27.7516 4.69685 28.4492 5.55567 28.4492H22.8797C23.7392 28.4492 24.4373 27.7515 24.4373 26.8914L24.4507 9.09668C24.4507 9.07071 24.4543 9.04756 24.4507 9.02997V9.01535C24.4581 8.98566 24.4507 8.94257 24.4507 8.8917C24.4507 8.59877 24.3093 8.33899 24.0918 8.17674L16.1802 0.260977C15.9739 0.0561669 15.7006 0.00255148 15.4538 0.0325386C15.4031 0.0178254 15.331 0 15.2543 0H5.55567ZM5.7807 26.6664L5.78397 1.74266H14.6593V8.8917C14.6593 9.40065 15.0835 9.75501 15.559 9.75501H22.6547V26.6664H5.7807ZM16.442 8.00033V3.04523L21.3947 8.00033H16.442ZM1.549 4.00017C0.693308 4.00017 0 4.70059 0 5.55789V30.8916C0 31.7509 0.698628 32.45 1.55767 32.45H18.8823C19.2991 32.45 19.6921 32.2858 19.9851 31.9879C20.2784 31.6909 20.4361 31.2951 20.4306 30.8789L20.4206 30.2112C20.4132 29.7031 19.9833 29.3573 19.5315 29.3335L19.5239 29.3331L19.5164 29.3332C19.0237 29.3404 18.6318 29.7454 18.638 30.2374L18.6506 30.6666H1.78259L1.77408 5.78289H2.20567C2.69715 5.78289 3.09667 5.38447 3.09667 4.89153C3.09667 4.3994 2.6973 4.00017 2.20567 4.00017H1.549Z",
      fill: n.color
    }, null, 8, dQ)
  ]);
}
const hQ = /* @__PURE__ */ B(lQ, [["render", cQ]]), mQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, fQ = {
  width: "26",
  height: "33",
  viewBox: "0 0 26 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pQ = ["fill"];
function gQ(e, t, n, r, o, i) {
  return d(), f("svg", fQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 27.9811V30.091H15C15.55 30.091 16 30.4929 16 31.0455C16 31.5981 15.55 32.0502 15 32.0502H7C6.45 32.0502 6 31.5981 6 31.0455C6 30.4929 6.45 30.091 7 30.091H10V27.9811C7.8 27.8304 5.6 27.1271 3.5 25.9215C3 25.6201 2.85 25.0172 3.15 24.5651C3.45 24.0628 4.05 23.9121 4.5 24.2135C6.65 25.4694 8.8 26.0722 11 26.0722C18.15 26.0722 24 20.2449 24 13.0612C24 8.43953 21.6 4.26999 17.5 1.90892C17 1.60751 16.85 1.00468 17.15 0.552564C17.45 0.0502093 18.05 -0.100497 18.5 0.200916C23.2 2.91363 26 7.73624 26 13.0612C26 20.9482 19.8 27.4285 12 27.9811ZM22 13.011C22 19.0895 17.05 24.0125 11 24.0125C4.95 24.0125 0 19.0895 0 13.011C0 6.93247 4.95 2.00939 11 2.00939C17.05 2.00939 22 6.93247 22 13.011ZM11 4.01881C6.05 4.01881 2 8.03765 2 13.011C2 17.9843 6.05 22.0031 11 22.0031C15.95 22.0031 20 17.9843 20 13.011C20 8.03765 15.95 4.01881 11 4.01881Z",
      fill: n.color
    }, null, 8, pQ)
  ]);
}
const vQ = /* @__PURE__ */ B(mQ, [["render", gQ]]), bQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, yQ = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _Q = ["fill"];
function CQ(e, t, n, r, o, i) {
  return d(), f("svg", yQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M32 17C32 20.86 28.8599 24 25.0005 24C21.1411 24 18 20.86 18 17C18 16.517 18.0492 16.046 18.1426 15.591C17.8543 15.39 17.1452 15 16 15C14.8639 15 14.1557 15.386 13.8584 15.592C13.9508 16.047 14 16.518 14 17C14 20.86 10.8599 24 7.0005 24C3.14114 24 0 20.86 0 17C0 16.75 0.0150678 16.504 0.0401808 16.26C0.00401809 16.125 -0.0100452 15.983 0.0140633 15.836L2.01406 3.836C2.17579 2.535 3.43446 0 7.0005 0C7.55299 0 8 0.448 8 1C8 1.552 7.55299 2 7.0005 2C4.2893 2 4.00301 4.037 3.99297 4.124L2.77549 11.432C3.95078 10.538 5.41236 10 7.0005 10C9.66047 10 11.9779 11.492 13.1622 13.683C13.78 13.346 14.7172 13 16 13C17.2838 13 18.22 13.346 18.8388 13.682C20.0231 11.492 22.3405 10 25.0005 10C26.5876 10 28.0492 10.537 29.2245 11.432L28.0141 4.164C27.9769 3.916 27.6183 2 25.0005 2C24.447 2 24 1.552 24 1C24 0.448 24.447 0 25.0005 0C28.5655 0 29.8242 2.535 29.992 3.876L31.9859 15.836C32.0111 15.983 31.997 16.125 31.9598 16.261C31.9859 16.504 32 16.75 32 17ZM7.0005 12C4.24309 12 2 14.243 2 17C2 19.757 4.24309 22 7.0005 22C9.75691 22 12 19.757 12 17C12 14.243 9.75691 12 7.0005 12ZM25.0005 12C22.2431 12 20 14.243 20 17C20 19.757 22.2431 22 25.0005 22C27.7569 22 30 19.757 30 17C30 14.243 27.7569 12 25.0005 12Z",
      fill: n.color
    }, null, 8, _Q)
  ]);
}
const wQ = /* @__PURE__ */ B(bQ, [["render", CQ]]), TQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, kQ = {
  width: "30",
  height: "33",
  viewBox: "0 0 30 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, EQ = ["fill"];
function SQ(e, t, n, r, o, i) {
  return d(), f("svg", kQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M28.9995 7.00245H24.9995V11.0037C24.9995 11.5559 24.5517 12.0048 23.9995 12.0048C23.4473 12.0048 22.9995 11.5559 22.9995 11.0037V7.00245H18.9995C18.4473 7.00245 17.9995 6.55463 17.9995 6.00239C17.9995 5.45014 18.4091 5.06759 18.9624 5.06759H22.9995V1.00107C22.9995 0.448823 23.4473 0 23.9995 0C24.5517 0 24.9995 0.448823 24.9995 1.00107V5.06759H29.0025C29.5557 5.06759 29.9995 5.45014 29.9995 6.00239C29.9995 6.55463 29.5517 7.00245 28.9995 7.00245ZM23.3439 31.9488C23.2304 31.991 23.114 32.01 22.9995 32.01C22.5919 32.01 22.2093 31.759 22.0608 31.3544L17.9463 20.1288H6.05272L1.93826 31.3544C1.7475 31.8735 1.17722 32.1386 0.655127 31.9488C0.137055 31.758 -0.12901 31.1837 0.0617534 30.6656L11.0608 0.656668C11.2043 0.262065 11.5798 0 11.9995 0C12.4192 0 12.7947 0.262065 12.9383 0.656668L23.9383 30.6656C24.128 31.1837 23.862 31.758 23.3439 31.9488ZM11.9995 3.90587L6.78967 18.1206H17.2104L11.9995 3.90587Z",
      fill: n.color
    }, null, 8, EQ)
  ]);
}
const MQ = /* @__PURE__ */ B(TQ, [["render", SQ]]), AQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, IQ = {
  width: "32",
  height: "28",
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, LQ = ["fill"];
function DQ(e, t, n, r, o, i) {
  return d(), f("svg", IQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M29.9355 23.8376C28.7979 23.8376 27.871 22.904 27.871 21.759C27.871 20.9929 28.289 20.3299 28.9032 19.9687V12.1175L24.7546 14.5042C24.7577 14.5385 24.7742 14.5687 24.7742 14.6031V24.8764C24.7742 24.916 24.7556 24.9503 24.7515 24.9899C24.7432 25.0606 24.7319 25.1273 24.7102 25.1959C24.6895 25.2594 24.6627 25.3167 24.6307 25.375C24.5987 25.4322 24.5646 25.4843 24.5223 25.5363C24.4759 25.5915 24.4253 25.6362 24.3685 25.681C24.3386 25.7049 24.32 25.7382 24.2859 25.7591C24.1404 25.8507 20.6483 27.9938 15.4839 27.9938C10.3195 27.9938 6.82735 25.8507 6.68181 25.7591C6.64774 25.7382 6.62916 25.7049 6.59923 25.681C6.54245 25.6362 6.49187 25.5915 6.44542 25.5353C6.4031 25.4843 6.36903 25.4322 6.33703 25.375C6.30503 25.3167 6.27819 25.2594 6.25755 25.1959C6.23587 25.1273 6.22452 25.0606 6.21626 24.9899C6.21213 24.9513 6.19355 24.917 6.19355 24.8764V14.6031C6.19355 14.5687 6.21006 14.5385 6.21316 14.5042L0.520258 11.2286C0.198194 11.0444 0 10.6998 0 10.3272C0 9.95355 0.198194 9.60902 0.520258 9.42479L14.9719 1.11037C15.2877 0.928217 15.679 0.928217 15.9959 1.11037L30.4475 9.42479C30.7695 9.60902 30.9677 9.95355 30.9677 10.3272C30.9677 10.3449 30.9554 10.3595 30.9543 10.3782C30.9554 10.4022 30.9677 10.423 30.9677 10.4469V19.9687C31.5819 20.3299 32 20.9929 32 21.759C32 22.904 31.0741 23.8376 29.9355 23.8376ZM22.7097 24.2571V15.6804L15.9959 19.543C15.8379 19.6346 15.6604 19.6804 15.4839 19.6804C15.3074 19.6804 15.1298 19.6346 14.9719 19.543L8.25806 15.6804V24.254C9.29445 24.7765 11.9515 25.9162 15.4839 25.9162C19.0369 25.9162 21.6785 24.7796 22.7097 24.2571ZM15.4839 3.20979L3.11329 10.3272L15.4839 17.4436L27.8545 10.3272L15.4839 3.20979Z",
      fill: n.color
    }, null, 8, LQ)
  ]);
}
const $Q = /* @__PURE__ */ B(AQ, [["render", DQ]]), OQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, PQ = {
  width: "33",
  height: "29",
  viewBox: "0 0 33 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NQ = ["fill"];
function HQ(e, t, n, r, o, i) {
  return d(), f("svg", PQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.0462 2.957H13.8656L8.9928 28.1971C8.89233 28.5986 8.59091 28.8997 8.23926 29C8.18903 29 8.08856 29 8.03832 29C7.73691 29 7.38526 28.8495 7.23455 28.5484L0.201588 18.5627C-0.0998244 18.1111 0.000646586 17.509 0.452766 17.1577C0.904885 16.8566 1.50771 16.957 1.85936 17.4086L7.48573 25.4875L12.0572 1.80288C12.0572 1.7527 12.0572 1.7527 12.0572 1.70252C12.0572 1.65234 12.1074 1.55198 12.1576 1.5018C12.2079 1.45162 12.2079 1.40144 12.2581 1.35126C12.3083 1.30108 12.3586 1.2509 12.4088 1.20073C12.459 1.15055 12.5093 1.15055 12.5595 1.10037C12.6098 1.05019 12.66 1.05019 12.7605 1.00001C12.8107 1.00001 12.8609 0.949829 12.9614 0.949829C13.0116 0.949829 13.0116 0.949829 13.0619 0.949829H31.0964C31.649 0.949829 32.1011 1.40144 32.1011 1.95341C32.1011 2.50538 31.5988 2.957 31.0462 2.957ZM16.4779 7.17205C16.93 6.87098 17.5831 7.02151 17.8342 7.47313L22.0038 14.147L26.1733 7.47313C26.4747 7.02151 27.0776 6.87098 27.5297 7.17205C27.9818 7.47313 28.1325 8.07528 27.8311 8.57707L23.1592 16.0538L27.8311 23.5305C28.1325 23.9821 27.9818 24.6344 27.5297 24.9355C27.379 25.0359 27.178 25.086 26.9771 25.086C26.6254 25.086 26.324 24.9355 26.1231 24.6344L21.9535 18.0108L17.784 24.6344C17.5831 24.9355 17.2816 25.086 16.93 25.086C16.7291 25.086 16.5784 25.0359 16.3774 24.9355C15.9253 24.6344 15.7746 24.0323 16.076 23.5305L20.7479 16.0538L16.1765 8.52689C15.8751 8.07528 16.0258 7.47313 16.4779 7.17205Z",
      fill: n.color
    }, null, 8, NQ)
  ]);
}
const FQ = /* @__PURE__ */ B(OQ, [["render", HQ]]), RQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, VQ = {
  width: "32",
  height: "38",
  viewBox: "0 0 32 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, BQ = ["fill"];
function jQ(e, t, n, r, o, i) {
  return d(), f("svg", VQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.9702 8.89879C31.9829 8.9717 31.9898 9.0423 31.9875 9.11521C31.9863 9.18696 31.9759 9.25525 31.9609 9.327C31.9437 9.4057 31.9217 9.47861 31.8883 9.55268C31.8745 9.58509 31.8745 9.62097 31.8572 9.65337L24.8414 22.3181C25.7754 23.9233 26.2909 25.7218 26.2909 27.5897C26.2909 33.3278 21.6794 37.9977 16.0105 37.9977C10.3416 37.9977 5.73017 33.3278 5.73017 27.5897C5.73017 25.7207 6.24679 23.921 7.17969 22.3181L0.165057 9.65337C0.146607 9.62097 0.146607 9.58509 0.132769 9.55268C0.10048 9.47861 0.0774174 9.4057 0.0612732 9.327C0.0451291 9.25525 0.0347507 9.18696 0.0335976 9.11521C0.0312913 9.0423 0.0393633 8.9717 0.0508949 8.89879C0.0635796 8.82009 0.0831832 8.74718 0.112012 8.67311C0.124697 8.63955 0.12239 8.60367 0.138535 8.57011L3.56571 1.63188C3.57839 1.60526 3.60722 1.59369 3.62221 1.56823C3.69832 1.43977 3.79518 1.33098 3.91396 1.2407C3.95547 1.2083 3.99353 1.17936 4.03965 1.1539C4.17342 1.07868 4.31871 1.03123 4.47785 1.01502C4.50322 1.01271 4.52282 0.994191 4.54819 0.993034C4.55857 0.991877 4.56664 0.995349 4.57702 0.995349C4.58048 0.995349 4.58394 0.993034 4.5874 0.993034H26.8629C26.9793 0.993034 27.0866 1.0266 27.1927 1.06016C27.2872 1.03933 27.3726 0.989562 27.4729 0.993034C27.8915 1.00808 28.2686 1.25343 28.4554 1.63188L31.8825 8.57011C31.8987 8.60367 31.8964 8.63955 31.9102 8.67311C31.939 8.74718 31.9575 8.82009 31.9702 8.89879ZM16.0105 35.6853C20.419 35.6853 24.0065 32.0536 24.0065 27.5897C24.0065 25.9405 23.5164 24.3481 22.587 22.9836C21.4269 21.2834 19.6833 20.1053 17.6757 19.6655C17.1337 19.5532 16.5698 19.4953 16.0105 19.4953C15.4513 19.4953 14.8874 19.5532 14.3315 19.6689C12.34 20.1053 10.5953 21.2834 9.4341 22.9847C8.50581 24.3469 8.01457 25.9405 8.01457 27.5897C8.01457 32.0536 11.602 35.6853 16.0105 35.6853ZM17.309 17.301L21.4073 10.2436H10.6138L14.6971 17.2756C15.5723 17.1645 16.4441 17.1957 17.309 17.301ZM2.45291 9.05619L8.68686 20.3101C9.73392 19.2396 10.9943 18.4109 12.3942 17.8751L4.66927 4.57036L2.45291 9.05619ZM9.27035 7.93126H22.7507L25.4364 3.30539H6.58466L9.27035 7.93126ZM27.3518 4.57036L19.6395 17.8531C21.0394 18.3936 22.2941 19.2315 23.3365 20.3078L29.5682 9.05619L27.3518 4.57036Z",
      fill: n.color
    }, null, 8, BQ)
  ]);
}
const UQ = /* @__PURE__ */ B(RQ, [["render", jQ]]), qQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, GQ = {
  width: "32",
  height: "29",
  viewBox: "0 0 32 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, KQ = ["fill"];
function zQ(e, t, n, r, o, i) {
  return d(), f("svg", GQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M29.452 24H20.22L20.82 27H22.047C22.599 27 23.047 27.447 23.047 28C23.047 28.553 22.599 29 22.047 29H10.047C9.495 29 9.047 28.553 9.047 28C9.047 27.447 9.495 27 10.047 27H11.18L11.78 24H2.548C1.143 24 0 22.857 0 21.452V2.548C0 1.143 1.143 0 2.548 0H29.452C30.857 0 32 1.143 32 2.548V21.452C32 22.857 30.857 24 29.452 24ZM18.78 27L18.18 24H13.82L13.22 27H18.78ZM2.548 22H29.452C29.754 22 30 21.754 30 21.452V20H2V21.452C2 21.754 2.246 22 2.548 22ZM29.452 2H2.548C2.246 2 2 2.246 2 2.548V18H30V2.548C30 2.246 29.754 2 29.452 2Z",
      fill: n.color
    }, null, 8, KQ)
  ]);
}
const ZQ = /* @__PURE__ */ B(qQ, [["render", zQ]]), xQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, WQ = {
  width: "32",
  height: "30",
  viewBox: "0 0 32 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YQ = ["fill"];
function XQ(e, t, n, r, o, i) {
  return d(), f("svg", WQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30 30H2C0.898 30 0 29.103 0 28V7C0 5.897 0.898 5 2 5H10V3C10 1.346 11.346 0 13 0H19C20.654 0 22 1.346 22 3V5H30C31.102 5 32 5.897 32 7V28C32 29.103 31.102 30 30 30ZM17 28H29.996L29.998 16H26V17.285C26 18.782 24.654 20 23 20C22.234 20 21.503 19.735 20.94 19.254C20.343 18.742 20 18.024 20 17.285V16H17V28ZM22 17.285C22 17.497 22.151 17.658 22.241 17.735C22.438 17.903 22.715 18 23 18C23.532 18 24 17.666 24 17.285V14H22V17.285ZM2 28H15V16H12V17.285C12 18.782 10.654 20 9 20C8.234 20 7.503 19.735 6.94 19.254C6.343 18.742 6 18.024 6 17.285V16H2V28ZM10 17.285V14H8V17.285C8 17.497 8.151 17.658 8.241 17.735C8.438 17.903 8.715 18 9 18C9.532 18 10 17.666 10 17.285ZM20 3C20 2.448 19.552 2 19 2H13C12.448 2 12 2.448 12 3V5H20V3ZM2 7V14H6V13C6 12.448 6.447 12 7 12H11C11.553 12 12 12.448 12 13V14H20V13C20 12.448 20.447 12 21 12H25C25.553 12 26 12.448 26 13V14H29.999L30 7H2Z",
      fill: n.color
    }, null, 8, YQ)
  ]);
}
const QQ = /* @__PURE__ */ B(xQ, [["render", XQ]]), JQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, eJ = {
  width: "32",
  height: "28",
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tJ = ["fill"];
function nJ(e, t, n, r, o, i) {
  return d(), f("svg", eJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.0006 11.9999C30.9956 11.9999 30.9875 11.9999 30.9805 11.9999H26.9838V22.0007H28.9826C29.535 22.0007 29.9811 22.4485 29.9811 23.0006C29.9811 23.5526 29.535 24.0005 28.9826 24.0005H2.99831C2.44596 24.0005 1.99887 23.5526 1.99887 23.0006C1.99887 22.4485 2.44596 22.0007 2.99831 22.0007H4.99718V11.9999H0.999436C0.559363 11.9999 0.171418 11.7113 0.0431051 11.2895C-0.0842053 10.8687 0.079193 10.4129 0.445085 10.1674L15.4356 0.167566C15.7714 -0.0558552 16.2095 -0.0558552 16.5443 0.167566L31.4246 10.0933C31.7644 10.2536 32 10.5992 32 11C32 11.552 31.5529 11.9999 31.0006 11.9999ZM21.9866 22.0007H24.9849V11.9999H21.9866V22.0007ZM16.9894 22.0007H19.9877V11.9999H16.9894V22.0007ZM14.9905 22.0007V11.9999H11.9501V22.0007H14.9905ZM6.93791 22.0007H9.99436V11.9999H6.93791V22.0007ZM15.99 2.2014L4.30048 10.0001H27.6805L15.99 2.2014ZM0.999436 26.0002H30.9805C31.5329 26.0002 31.98 26.4481 31.98 27.0001C31.98 27.5532 31.5329 28 30.9805 28H0.999436C0.44709 28 0 27.5532 0 27.0001C0 26.4481 0.44709 26.0002 0.999436 26.0002Z",
      fill: n.color
    }, null, 8, tJ)
  ]);
}
const rJ = /* @__PURE__ */ B(JQ, [["render", nJ]]), oJ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, iJ = {
  width: "28",
  height: "33",
  viewBox: "0 0 28 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sJ = ["fill"];
function aJ(e, t, n, r, o, i) {
  return d(), f("svg", iJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.219 17.4369C23.242 18.8659 28 24.1269 28 30.0179V31.0169C28 31.5669 27.552 32.0139 27 32.0139H1C0.448 32.0139 0 31.5669 0 31.0169V30.0179C0 24.1269 4.758 18.8659 10.78 17.4369C7.406 16.1399 5 12.8779 5 9.05893C5 4.10593 9.038 0.0759277 14 0.0759277C18.962 0.0759277 23 4.10593 23 9.05893C23 12.8779 20.594 16.1399 17.219 17.4369ZM2 30.0179H26C26 24.1699 20.393 19.0399 14 19.0399C7.607 19.0399 2 24.1699 2 30.0179ZM14 2.07293C10.14 2.07293 7 5.20693 7 9.05893C7 12.9109 10.14 16.0449 14 16.0449C17.86 16.0449 21 12.9109 21 9.05893C21 5.20693 17.86 2.07293 14 2.07293Z",
      fill: n.color
    }, null, 8, sJ)
  ]);
}
const lJ = /* @__PURE__ */ B(oJ, [["render", aJ]]), uJ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, dJ = {
  width: "30",
  height: "32",
  viewBox: "0 0 30 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cJ = ["fill"];
function hJ(e, t, n, r, o, i) {
  return d(), f("svg", dJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M27 20.794V27C27 28.005 26.269 28.962 25.299 29.227L15.263 31.964C15.175 31.988 15.087 32 14.999 32C14.76 32 14.537 31.908 14.359 31.757C14.331 31.759 14.306 31.77 14.278 31.77C14.111 31.77 13.941 31.747 13.772 31.701L4.702 29.227C3.731 28.962 3 28.005 3 27V20.794C1.567 20.288 0 18.835 0 17C0 15.164 1.567 13.711 3 13.206V11C3 10.423 3.247 9.904 3.677 9.576C4.105 9.247 4.669 9.146 5.229 9.299L14.298 11.772C14.483 11.822 14.648 11.918 14.812 12.015L24.772 9.298C25.327 9.147 25.894 9.247 26.323 9.576C26.753 9.904 27 10.423 27 11V13.206C28.433 13.711 30 15.164 30 17C30 18.835 28.433 20.288 27 20.794ZM2 17C2 18.033 3.375 19 4 19C4.408 19 5 18.22 5 17C5 15.779 4.408 15 4 15C3.375 15 2 15.966 2 17ZM14 14C14 13.901 13.867 13.727 13.772 13.701L5 11.309V13.237C6.173 13.777 7 15.229 7 17C7 18.771 6.173 20.223 5 20.763V27C5 27.099 5.133 27.272 5.229 27.298L14 29.69V14ZM25 11.309L15.96 13.774C15.969 13.851 16 13.923 16 14V29.69L24.772 27.298C24.867 27.272 25 27.099 25 27V20.763C23.827 20.223 23 18.771 23 17C23 15.229 23.827 13.777 25 13.237V11.309ZM26 15C25.592 15 25 15.779 25 17C25 18.22 25.592 19 26 19C26.625 19 28 18.033 28 17C28 15.966 26.625 15 26 15ZM15 10C12.243 10 10 7.757 10 5C10 2.243 12.243 0 15 0C17.757 0 20 2.243 20 5C20 7.757 17.757 10 15 10ZM15 2C13.346 2 12 3.346 12 5C12 6.654 13.346 8 15 8C16.654 8 18 6.654 18 5C18 3.346 16.654 2 15 2Z",
      fill: n.color
    }, null, 8, cJ)
  ]);
}
const mJ = /* @__PURE__ */ B(uJ, [["render", hJ]]), fJ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, pJ = {
  width: "33",
  height: "33",
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gJ = ["fill"];
function vJ(e, t, n, r, o, i) {
  return d(), f("svg", pJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.9511 15.2675C31.8112 15.6861 31.4205 15.9511 31.0026 15.9511C30.8969 15.9511 30.7912 15.934 30.6854 15.8989L26.0083 14.335L25.7032 15.2625C25.6196 15.5155 25.4394 15.7253 25.2017 15.8447C25.0618 15.915 24.9067 15.9511 24.7526 15.9511C24.6459 15.9511 24.5402 15.934 24.4375 15.8999L17.0044 13.4256V15.133C18.7242 15.5807 20.004 17.1335 20.004 18.9935C20.004 20.0274 19.5992 20.9629 18.9528 21.6736L22.9321 31.6269C23.1375 32.1408 22.8878 32.722 22.3753 32.9278C22.2535 32.977 22.1276 33 22.0037 33C21.607 33 21.2314 32.7611 21.0754 32.3707L17.241 22.7797C16.8493 22.9082 16.4385 22.9955 16.0045 22.9955C15.5695 22.9955 15.1597 22.9082 14.768 22.7797L10.9326 32.3707C10.7766 32.7611 10.401 33 10.0042 33C9.88039 33 9.75453 32.977 9.63269 32.9278C9.12016 32.722 8.87045 32.1408 9.07586 31.6269L13.0552 21.6746C12.4088 20.9629 12.004 20.0274 12.004 18.9935C12.004 17.1335 13.2838 15.5807 15.0036 15.133V12.991C15.0036 12.9137 15.0308 12.8465 15.0479 12.7752L9.09902 10.7948L8.9651 11.2645C8.83923 11.7042 8.43848 11.9903 8.00449 11.9903C7.91286 11.9903 7.82023 11.9782 7.7286 11.9511L0.729478 9.9506C0.197823 9.79904 -0.110296 9.24496 0.0417497 8.71397L2.0415 1.7107C2.19354 1.17871 2.75138 0.873565 3.278 1.02413L10.2771 3.02463C10.8088 3.1772 11.1169 3.73028 10.9648 4.26127L10.7484 5.01911L26.3184 10.2005C26.842 10.3742 27.1249 10.9393 26.9528 11.4623L26.6336 12.4339L31.3198 14.0018C31.8434 14.1765 32.1253 14.7436 31.9511 15.2675ZM3.68983 3.22237L2.23986 8.30142L7.31677 9.75286L7.41645 9.40255C7.42451 9.33128 7.41947 9.26102 7.44263 9.19075C7.45773 9.14458 7.49096 9.11146 7.51211 9.0703L8.76673 4.67382L3.68983 3.22237ZM14.0037 18.9935C14.0037 20.0967 14.9019 20.994 16.0045 20.994C17.1061 20.994 18.0042 20.0967 18.0042 18.9935C18.0042 17.8894 17.1061 16.992 16.0045 16.992C14.9019 16.992 14.0037 17.8894 14.0037 18.9935ZM10.1986 6.94433L9.6488 8.87055L24.1163 13.6846L24.7406 11.7845L10.1986 6.94433Z",
      fill: n.color
    }, null, 8, gJ)
  ]);
}
const bJ = /* @__PURE__ */ B(fJ, [["render", vJ]]), yJ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, _J = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CJ = ["fill"];
function wJ(e, t, n, r, o, i) {
  return d(), f("svg", _J, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M26 10.9V14C26 19.176 22.046 23.446 17 23.95V30H23C23.553 30 24 30.448 24 31C24 31.552 23.553 32 23 32H9C8.447 32 8 31.552 8 31C8 30.448 8.447 30 9 30H15V23.95C9.954 23.446 6 19.176 6 14V10.9C2.507 10.272 0 6.454 0 3C0 2.448 0.447 2 1 2H6V1C6 0.448 6.447 0 7 0H25C25.553 0 26 0.448 26 1V2H31C31.553 2 32 2.448 32 3C32 6.454 29.493 10.272 26 10.9ZM6 4H2.094C2.481 6.114 4.029 8.274 6 8.845V4ZM24 2H8V14C8 18.411 11.589 22 16 22C20.411 22 24 18.411 24 14V2ZM26 4V8.845C27.971 8.274 29.519 6.114 29.906 4H26ZM18 17H14C13.447 17 13 16.552 13 16C13 15.448 13.447 15 14 15H15V9.414L13.707 10.707C13.316 11.097 12.684 11.097 12.293 10.707C11.902 10.316 11.902 9.683 12.293 9.293L15.293 6.293C15.579 6.006 16.009 5.922 16.383 6.076C16.757 6.231 17 6.596 17 7V15H18C18.553 15 19 15.448 19 16C19 16.552 18.553 17 18 17Z",
      fill: n.color
    }, null, 8, CJ)
  ]);
}
const TJ = /* @__PURE__ */ B(yJ, [["render", wJ]]), kJ = {
  name: "S1",
  components: {
    CmsBadge: DX,
    CmsBasketball: HX,
    CmsBlackboard: jX,
    CmsBus: zX,
    CmsChemistry: XX,
    CmsDesign: nQ,
    CmsDiploma: aQ,
    CmsDocuments: hQ,
    CmsGeography: vQ,
    CmsGlasses: wQ,
    CmsGrade: MQ,
    CmsGraduationCap: $Q,
    CmsMath: FQ,
    CmsMedal: UQ,
    CmsMonitor: ZQ,
    CmsSchoolBag: QQ,
    CmsSchoolBuilding: rJ,
    CmsStaff: lJ,
    CmsStudent: mJ,
    CmsTelescope: bJ,
    CmsTrophy: TJ
  },
  mixins: [_i]
}, EJ = {
  key: 0,
  "data-testid": "component-header-top"
}, SJ = ["data-testid"], MJ = { class: "stats-info" }, AJ = { class: "stats-card-border" }, IJ = {
  class: "stats-card stats-accent-border",
  "data-testid": "stats-accent-border"
}, LJ = { class: "svg-wrapper" }, DJ = ["innerHTML"];
function $J(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "stats-s1",
    class: _(e.theme.style),
    style: Z(e.colors),
    "data-testid": "S1"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.displayHeaderTop ? (d(), f("h3", EJ, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.stats.component_header_top), 1)
          ], !0)
        ])) : T("", !0),
        c("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header", {}, () => [
            H(k(e.stats.component_header), 1)
          ], !0)
        ], 8, SJ)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.stats.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.stats.content = s),
      "item-key": "index",
      class: "stats-wrapper"
    }), {
      item: S(({ element: s, index: l }) => [
        c("div", MJ, [
          M(e.$slots, "controls", { idx: l }, void 0, !0),
          c("div", AJ, [
            c("div", IJ, [
              c("div", LJ, [
                M(e.$slots, "icon", { idx: l }, () => [
                  s.icon ? (d(), f("span", {
                    key: 0,
                    class: "raw-svg",
                    "data-testid": "stats-icon",
                    innerHTML: s.icon
                  }, null, 8, DJ)) : s.name ? (d(), I(Y(`cms-${s.name.replace(/\s/g, "-")}`), {
                    key: 1,
                    "data-testid": "stats-icon",
                    color: `${e.theme.icon_color.hex}`
                  }, null, 8, ["color"])) : T("", !0)
                ], !0)
              ])
            ])
          ]),
          e.stats.headline ? (d(), f("h3", {
            key: 0,
            class: _(["stats-headline", e.theme.style]),
            "data-testid": "stats-headline"
          }, [
            M(e.$slots, "headline", { idx: l }, () => [
              H(k(s.headline), 1)
            ], !0)
          ], 2)) : T("", !0),
          e.stats.snippet ? (d(), f("p", {
            key: 1,
            class: _(["stats-snippet", e.theme.style]),
            "data-testid": "stats-snippet"
          }, [
            M(e.$slots, "snippet", { idx: l }, () => [
              H(k(s.snippet), 1)
            ], !0)
          ], 2)) : T("", !0)
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const OJ = /* @__PURE__ */ B(kJ, [["render", $J], ["__scopeId", "data-v-201e6dff"]]), PJ = {
  methods: {
    isShortList(e) {
      var n;
      return (e || ((n = this.items) == null ? void 0 : n.length)) <= this.sliderCapacity;
    },
    goRight(e) {
      this.isShortList(e) || (this.currentCard + this.sliderCapacity === this.cardsLength ? this.currentCard = 0 : this.currentCard += 1, this.move());
    },
    goLeft(e) {
      this.isShortList(e) || (this.currentCard === 0 ? this.currentCard = this.cardsLength - this.sliderCapacity : this.currentCard -= 1, this.move());
    },
    move() {
      const t = (this.$refs[`slider-card-${this.currentCard}`] ? this : this.getSlot()).$refs[`slider-card-${this.currentCard}`], { slider: n } = this.$refs, { left: r } = this.getRelativePos(t);
      n.$el.style.transform = `translateX(-${r}px)`;
    },
    getSlot() {
      const e = Object.keys(this.$slots)[this.currentCard], [t] = this.$slots[e]();
      return t.context;
    },
    getRelativePos(e) {
      const t = e.parentNode.getBoundingClientRect(), n = e.getBoundingClientRect(), r = {};
      return r.top = n.top - t.top + e.parentNode.scrollTop, r.right = n.right - t.right, r.bottom = n.bottom - t.bottom, r.left = n.left - t.left + e.parentNode.scrollLeft, r;
    }
  }
}, NJ = {
  name: "S2",
  mixins: [_i, Rt, PJ],
  data() {
    return {
      currentCard: 0,
      cardsLength: 0
    };
  },
  computed: {
    component_header() {
      return this.stats.stats_header;
    },
    stats_header() {
      return this.stats.component_header;
    },
    sliderCapacity() {
      return this.screenSize < 600 ? 1 : this.screenSize >= 1600 && !this.hasHeader ? 4 : this.screenSize >= 960 && this.hasHeader && this.hasSlider ? 3 : 4;
    },
    lowSliderCount() {
      var t;
      const e = ((t = this.stats.content) == null ? void 0 : t.length) || 0;
      return this.hasSlider && e < this.sliderCapacity;
    },
    hasHeader() {
      return this.stats.headline;
    },
    hasSlider() {
      return this.stats.slider && !this.isEditing;
    },
    hasTwoRows() {
      return this.screenSize >= 600 && this.screenSize < 960;
    },
    showArrows() {
      return this.screenSize >= 600 && this.hasSlider && this.stats.content.length > this.sliderCapacity;
    },
    backgroundImage() {
      return this.stats.bg_image && this.stats.bg_image.url ? {
        backgroundImage: `linear-gradient(${this.theme.bg_color.hex}e6, ${this.theme.bg_color.hex}e6), ${`url(${this.stats.bg_image.url})`}`
      } : !1;
    },
    hasDots() {
      return !!(this.hasSlider && this.stats.content.length > this.sliderCapacity);
    },
    dotCount() {
      const e = this.sliderCapacity, t = this.stats.content.length;
      return Math.ceil(t / e);
    },
    activeStatIdx() {
      return Math.ceil(this.currentCard / this.sliderCapacity + 1) === this.dotCount ? this.dotCount : Math.floor(this.currentCard / this.sliderCapacity + 1);
    }
  },
  mounted() {
    this.cardsLength = this.stats.content.length;
  },
  methods: {
    sliderCardOptions(e) {
      return {
        "stats-card-hidden": !this.isInRange(e, this.currentCard) && this.hasSlider,
        "stats-card-no-border": this.isTheLastOneInRange(e, this.currentCard),
        "stats-card-no-header": !this.hasHeader,
        "stats-card-no-slider": !this.hasSlider
      };
    },
    setScreenSize() {
      this.hasSlider && (this.screenSize = document.documentElement.clientWidth, this.lowSliderCount || this.move());
    },
    moveForward() {
      this.isEditing || (this.hasTwoRows ? (this.currentCard + this.sliderCapacity >= this.cardsLength ? this.currentCard = 0 : this.currentCard += 2, this.move()) : this.goRight(this.cardsLength));
    },
    moveBack() {
      this.isEditing || (this.hasTwoRows ? (this.currentCard <= 1 ? this.cardsLength % 2 !== 0 ? this.currentCard = this.cardsLength - this.sliderCapacity + 1 : this.currentCard = this.cardsLength - this.sliderCapacity : this.currentCard -= 2, this.move()) : this.goLeft(this.cardsLength));
    },
    isInRange(e, t) {
      return e >= t && e <= t + this.sliderCapacity - 1;
    },
    isTheLastOneInRange(e, t) {
      return e === t + this.sliderCapacity - 1 && this.hasSlider;
    },
    dotMove(e) {
      const t = this.sliderCapacity, n = this.stats.content.length, r = (e - 1) * t;
      if (e === this.dotCount && n < this.dotCount * t) {
        const o = n - t, i = n % 2 === 0;
        this.currentCard = this.hasTwoRows && !i ? o + 1 : o;
      } else
        this.currentCard = r;
      this.move();
    }
  }
}, HJ = { key: 0 }, FJ = ["data-testid"], RJ = { class: "stat-content" }, VJ = { class: "slider-nav" }, BJ = ["onClick"], jJ = {
  class: "button-action-content",
  tabindex: "-1",
  role: "button"
}, UJ = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qJ = ["fill"], GJ = ["fill"], KJ = {
  class: "button-action-content",
  tabindex: "-1",
  role: "button"
}, zJ = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ZJ = ["fill"], xJ = ["fill"];
function WJ(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = Ke("touch");
  return d(), f("div", {
    id: "stats-s2",
    class: _([[{ "no-slider": !i.hasSlider }, e.theme.style], "stats-s2"]),
    style: Z([i.backgroundImage, e.colors])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.displayHeaderTop ? (d(), f("h3", HJ, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.stats.component_header_top), 1)
          ], !0)
        ])) : T("", !0),
        c("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header", {}, () => [
            H(k(i.component_header), 1)
          ], !0)
        ], 8, FJ)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: _(["stats-info", { "stats-info-w-header": i.hasHeader }])
    }, [
      i.hasHeader && i.hasSlider ? (d(), f("div", {
        key: 0,
        class: _([e.theme.style, "stats-header"])
      }, [
        M(e.$slots, "stats-header", {}, () => [
          H(k(i.stats_header), 1)
        ], !0)
      ], 2)) : T("", !0),
      c("div", {
        class: _(["cards-slider", { "cards-slider-no-slider": !i.hasSlider, "cards-slider-w-header": i.hasHeader }])
      }, [
        we((d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
          ref: "slider",
          modelValue: e.stats.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.stats.content = l),
          "item-key": "index",
          class: [{ "cards-slider-container-wrap": !i.hasSlider, "cards-slider-container-center": i.lowSliderCount }, "cards-slider-container"]
        }), {
          header: S(() => [
            i.hasHeader && !i.hasSlider ? (d(), f("div", {
              key: 0,
              class: _([e.theme.style, "stats-card stats-card-no-slider stats-header-card"])
            }, [
              M(e.$slots, "stats-header", {}, () => [
                H(k(i.stats_header), 1)
              ], !0)
            ], 2)) : T("", !0)
          ]),
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `slider-card-${u}`,
              class: _(["stats-card", i.sliderCardOptions(u)]),
              "data-testid": "stats-content"
            }, [
              M(e.$slots, "controls", { idx: u }, void 0, !0),
              c("div", RJ, [
                c("p", {
                  class: _(["stat-headline", [{ "no-slider": !i.hasSlider }, e.theme.style]])
                }, [
                  M(e.$slots, "headline", { idx: u }, () => [
                    H(k(l.headline), 1)
                  ], !0)
                ], 2),
                c("p", {
                  class: _(["stat-description", e.theme.style])
                }, [
                  M(e.$slots, "snippet", { idx: u }, () => [
                    H(k(l.snippet), 1)
                  ], !0)
                ], 2)
              ])
            ], 2)
          ]),
          _: 3
        }, 16, ["modelValue", "class"])), [
          [
            s,
            i.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            s,
            i.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        i.hasDots ? (d(), f("div", {
          key: 0,
          class: _([{ "slider-dots-w-header": i.hasHeader }, "slider-dots"])
        }, [
          c("ul", VJ, [
            (d(!0), f(J, null, ne(i.dotCount, (l) => (d(), f("li", {
              key: l,
              class: _({ activeStatIdx: l === i.activeStatIdx, unactiveStat: l !== i.activeStatIdx }),
              onClick: (u) => i.dotMove(l)
            }, t[5] || (t[5] = [
              c("span", { class: "circle" }, null, -1)
            ]), 10, BJ))), 128))
          ])
        ], 2)) : T("", !0)
      ], 2)
    ], 2),
    i.showArrows ? (d(), f("div", {
      key: 0,
      class: _(["navigation", { "navigation-w-header": i.hasHeader }])
    }, [
      c("div", {
        class: _(["arrows", { "arrows-w-header": i.hasHeader }])
      }, [
        c("button", {
          class: _(["left-arrow button-action", { "left-arrow-w-header": i.hasHeader }]),
          onClick: t[1] || (t[1] = (...l) => i.moveBack && i.moveBack(...l)),
          onKeydown: t[2] || (t[2] = K(W((...l) => i.moveBack && i.moveBack(...l), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", jJ, [
            (d(), f("svg", UJ, [
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M-0.00012207 0H63.9999V62.9999H-0.00012207V0Z",
                "fill-opacity": "0.9",
                fill: e.theme.icon_bg_color.hex
              }, null, 8, qJ),
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M24.7803 31.209L37.1333 43.8414L35.7324 45.265L21.9999 31.2222L35.9117 17L37.2991 18.4104L24.7803 31.209Z",
                fill: e.theme.icon_color.hex
              }, null, 8, GJ)
            ])),
            t[6] || (t[6] = c("span", { class: "sr-only" }, "Reverse Slider", -1))
          ])
        ], 34),
        c("button", {
          class: _(["right-arrow button-action", { "right-arrow-w-header": i.hasHeader }]),
          onClick: t[3] || (t[3] = (l) => i.moveForward()),
          onKeydown: t[4] || (t[4] = K((l) => i.moveForward(), ["enter"]))
        }, [
          c("div", KJ, [
            (d(), f("svg", zJ, [
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 0H63.9999V62.9999H0V0Z",
                "fill-opacity": "0.9",
                fill: e.theme.icon_bg_color.hex
              }, null, 8, ZJ),
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M38.5191 31.209L26.1659 43.8414L27.5668 45.265L41.2995 31.2222L27.3874 17L26 18.4104L38.5191 31.209Z",
                fill: e.theme.icon_color.hex
              }, null, 8, xJ)
            ])),
            t[7] || (t[7] = c("span", { class: "sr-only" }, "Advance Slider", -1))
          ])
        ], 34)
      ], 2)
    ], 2)) : T("", !0)
  ], 6);
}
const YJ = /* @__PURE__ */ B(NJ, [["render", WJ], ["__scopeId", "data-v-e1d0f8bd"]]), XJ = {
  name: "S3",
  mixins: [_i]
}, QJ = ["data-testid"], JJ = {
  key: 0,
  class: "header-top"
}, eee = {
  key: 0,
  class: "stats-card-img"
}, tee = ["src", "alt"], nee = {
  key: 1,
  class: "stats-content-body"
}, ree = ["innerHTML"], oee = { class: "stats-card-body" }, iee = { class: "stats-card-body-snippet-text" };
function see(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["stats-s3", e.theme.style]),
    "data-testid": "S3",
    style: Z(e.colors)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`,
          class: "no-border"
        }, [
          e.displayHeaderTop ? (d(), f("span", JJ, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.stats.component_header_top), 1)
            ], !0)
          ])) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.stats.component_header), 1)
          ], !0)
        ], 8, QJ)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.stats.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.stats.content = s),
      "item-key": "index",
      class: "stats-container stats-wrapper"
    }), {
      item: S(({ element: s, index: l }) => [
        c("div", {
          class: "stats-card",
          style: Z({ backgroundColor: s.bg_color }),
          "data-testid": "stats-content"
        }, [
          M(e.$slots, "controls", { idx: l }, void 0, !0),
          s.bg_image ? (d(), f("div", eee, [
            M(e.$slots, "image", { idx: l }, () => [
              s.bg_image.url ? (d(), f("img", {
                key: 0,
                class: "stat-card-img",
                src: s.bg_image.url,
                alt: s.bg_image.alt_text
              }, null, 8, tee)) : T("", !0)
            ], !0)
          ])) : (d(), f("div", nee, [
            e.stats.icon ? (d(), f("div", {
              key: 0,
              class: "svg-wrapper",
              style: Z({ fill: s.color })
            }, [
              M(e.$slots, "icon", { idx: l }, () => [
                c("span", {
                  class: "raw-svg",
                  "data-testid": "stats-icon",
                  innerHTML: s.icon
                }, null, 8, ree)
              ], !0)
            ], 4)) : T("", !0),
            c("div", oee, [
              e.stats.headline ? (d(), f("div", {
                key: 0,
                class: "stats-card-body-headline",
                style: Z({ color: s.color })
              }, [
                M(e.$slots, "headline", { idx: l }, () => [
                  c("h3", null, k(s.headline), 1)
                ], !0)
              ], 4)) : T("", !0),
              e.stats.snippet ? (d(), f("div", {
                key: 1,
                class: "stats-card-body-snippet",
                style: Z({ color: s.color })
              }, [
                M(e.$slots, "snippet", { idx: l }, () => [
                  c("p", iee, k(s.snippet), 1)
                ], !0)
              ], 4)) : T("", !0)
            ])
          ]))
        ], 4)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const aee = /* @__PURE__ */ B(XJ, [["render", see], ["__scopeId", "data-v-bf23411e"]]), lee = {
  name: "S4",
  components: {
    Pager: n0
  },
  mixins: [_i, bt],
  props: {
    startIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentStatCardIndex: 0,
      statsImageCards: [],
      scrollInterval: () => {
      },
      sliderOverlayIndex: 0,
      pauseScroll: !1
    };
  },
  computed: {
    statsV4Colors() {
      var e, t, n, r, o, i, a, s;
      return ge(ae({}, this.colors), {
        "--control-border-color": ((t = (e = this.theme) == null ? void 0 : e.button_border_color) == null ? void 0 : t.hex) || "#000",
        "--control-bg-color": ((r = (n = this.theme) == null ? void 0 : n.button_bg_color) == null ? void 0 : r.hex) || "#fff",
        "--pager-color": ((i = (o = this.theme) == null ? void 0 : o.pager_color) == null ? void 0 : i.hex) || "#fff",
        "--overlay-color": ((s = (a = this.theme) == null ? void 0 : a.overlay_color) == null ? void 0 : s.hex) || "#fff",
        "--overlay-opacity": `${this.theme.percentage_opacity || "80"}%`
      });
    },
    content() {
      return this.statsImageCards;
    },
    sliderCenterSize() {
      return this.mobileScreenSize ? 600 : 1e6;
    },
    mobileScreenSize() {
      return this.screenSize < 1023;
    },
    activeStat() {
      return this.mappedStats[this.currentStatCardIndex] || {
        top_stats: { headline: "", snippet: "" },
        bottom_stats: { headline: "", snippet: "" }
      };
    },
    mappedStats() {
      const e = this.startIndex ? this.stats.nested_content.slice(this.startIndex).concat(this.stats.nested_content.slice(0, this.startIndex)) : this.stats.nested_content;
      return (e == null ? void 0 : e.map((t, n) => ge(ae({}, t), {
        left_image: ge(ae({}, t.left_image), {
          internalIdx: n
        }),
        right_image: ge(ae({}, t.right_image), {
          internalIdx: n
        })
      }))) || [];
    }
  },
  created() {
    this.statsImageCards = this.getStatsImageCards(), this.currentStatCardIndex = this.startIndex;
  },
  async mounted() {
    this.currentCard = Math.floor(this.statsImageCards.length / 2), await this.$nextTick(), this.mobileScreenSize && (this.currentCard -= 1), this.startScroll(), this.calculateScroll(!0);
  },
  beforeUnmount() {
    this.clearScroll();
  },
  methods: {
    startScroll() {
      this.isEditing || !this.mappedStats.length || (this.scrollInterval = setInterval(this.handleScroll, 4e3));
    },
    clearScroll() {
      clearInterval(this.scrollInterval);
    },
    getStatsImageCards() {
      var n, r, o, i;
      if (!this.mappedStats.length)
        return [];
      const e = [
        ...this.mappedStats.slice(1, this.mappedStats.length).map((a) => (a == null ? void 0 : a.left_image) || {}),
        ge(ae({}, ((r = (n = this.mappedStats) == null ? void 0 : n[0]) == null ? void 0 : r.left_image) || {}), {
          position: "left_image"
        })
      ], t = [
        ge(ae({}, ((i = (o = this.mappedStats) == null ? void 0 : o[0]) == null ? void 0 : i.right_image) || {}), {
          position: "right_image"
        }),
        ...this.mappedStats.slice(1, this.mappedStats.length).map((a) => (a == null ? void 0 : a.right_image) || {})
      ];
      return [...e, {}, ...t];
    },
    togglePlayPause() {
      if (this.pauseScroll = !this.pauseScroll, this.pauseScroll) {
        this.clearScroll();
        return;
      }
      this.startScroll();
    },
    async handleScroll(e) {
      if (this.isEditing || this.pauseScroll || this.mappedStats.length <= 1)
        return;
      this.currentStatCardIndex = e || (this.currentStatCardIndex + 1) % this.mappedStats.length, this.sliderOverlayIndex = this.currentStatCardIndex, await new Promise((r) => setTimeout(r, 1e3));
      const t = this.mappedStats[this.currentStatCardIndex].left_image;
      this.statsImageCards[this.currentCard] = ae({}, t);
      const n = this.mappedStats.at(this.currentStatCardIndex - 1).right_image;
      this.statsImageCards.push(ae({}, n)), this.statsImageCards.splice(0, 1), this.currentCard -= 1, this.mobileScreenSize && (this.currentCard -= 1), this.$refs.scrollWrapper.style["scroll-behavior"] = "auto", this.calculateScroll(), this.$refs.scrollWrapper.style["scroll-behavior"] = "smooth", await this.$nextTick(), this.scrollRight(), this.mobileScreenSize && (this.currentCard += 1);
    }
  }
}, uee = ["data-testid"], dee = ["data-testid"], cee = {
  ref: "scrollWrapper",
  class: "card-wrapper"
}, hee = { class: "stat-image-wrapper" }, mee = ["src", "alt"], fee = { class: "stats-pager" }, pee = { class: "stat-text-wrapper" }, gee = { class: "stats-action-button-container" }, vee = {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bee = {
  key: 0,
  d: "M38 27.9984L23 36.3123L23 19.6846L38 27.9984Z",
  fill: "#333333"
};
function yee(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("Pager");
  return d(), f("div", {
    class: _(["stats-v4", { "is-editing": e.isEditing }, e.theme.style]),
    "data-testid": "S4",
    style: Z(i.statsV4Colors)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`
        }, [
          e.displayHeaderTop ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.stats.component_header_top), 1)
            ], !0)
          ], 8, dee)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.stats.component_header), 1)
          ], !0)
        ], 8, uee)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", cee, [
      (d(!0), f(J, null, ne(o.statsImageCards, (l, u) => (d(), f("div", {
        key: u,
        ref_for: !0,
        ref: `sliderCard-${u}`,
        class: _(["stat-card", e.isEditing && "is-editing"])
      }, [
        c("div", hee, [
          M(e.$slots, l.position ? "image" : "image-alt", {
            idx: u,
            position: l.position
          }, () => [
            c("img", {
              src: l.url ? l.url : "",
              alt: l.alt_text ? l.alt_text : "",
              class: "stat-image",
              loading: "lazy"
            }, null, 8, mee)
          ], !0),
          c("div", {
            class: _(["stat-image-overlay", { "overlay-visible": o.sliderOverlayIndex === l.internalIdx }])
          }, null, 2)
        ])
      ], 2))), 128)),
      c("div", {
        class: _(["stats-main-card stat-card", { "is-editing": e.isEditing }])
      }, [
        c("div", fee, [
          j(s, {
            "total-cards": i.mappedStats.length,
            "theme-styles": e.theme,
            "pager-color": e.theme.pager_color ? e.theme.pager_color.hex : "#fff",
            "current-card": o.currentStatCardIndex,
            "pager-section-count": i.mappedStats.length
          }, null, 8, ["total-cards", "theme-styles", "pager-color", "current-card", "pager-section-count"])
        ]),
        c("div", pee, [
          (d(), I(Y(e.isEditing ? "div" : "transition-group"), {
            duration: 1e3,
            tag: "div",
            name: "stats-fade",
            class: _(["stats-text-transition stat-top-text", { "no-snippet": !e.stats.snippet, "no-headline": !e.stats.headline }])
          }, {
            default: S(() => [
              e.stats.headline ? (d(), f("div", {
                key: `${o.currentStatCardIndex}-top`,
                class: "stats-top-text"
              }, [
                M(e.$slots, "headline", {}, () => [
                  H(k(i.activeStat.top_stats.headline), 1)
                ], !0)
              ])) : T("", !0),
              e.stats.snippet ? (d(), f("div", {
                key: `${o.currentStatCardIndex}-bottom`,
                class: "stats-bottom-text"
              }, [
                M(e.$slots, "snippet", {}, () => [
                  H(k(i.activeStat.top_stats.snippet), 1)
                ], !0)
              ])) : T("", !0)
            ]),
            _: 3
          }, 8, ["class"])),
          t[1] || (t[1] = c("div", { class: "stats-divider" }, null, -1)),
          (d(), I(Y(e.isEditing ? "div" : "transition-group"), {
            duration: 1e3,
            tag: "div",
            name: "stats-fade",
            class: _(["stats-text-transition stat-bottom-text", { "no-snippet": !e.stats.snippet, "no-headline": !e.stats.headline }])
          }, {
            default: S(() => [
              e.stats.headline ? (d(), f("div", {
                key: `${o.currentStatCardIndex}-top`,
                class: "stats-top-text"
              }, [
                M(e.$slots, "bottom-headline", {}, () => [
                  H(k(i.activeStat.bottom_stats.headline), 1)
                ], !0)
              ])) : T("", !0),
              e.stats.snippet ? (d(), f("div", {
                key: `${o.currentStatCardIndex}-bottom`,
                class: "stats-bottom-text"
              }, [
                M(e.$slots, "bottom-snippet", {}, () => [
                  H(k(i.activeStat.bottom_stats.snippet), 1)
                ], !0)
              ])) : T("", !0)
            ]),
            _: 3
          }, 8, ["class"]))
        ])
      ], 2)
    ], 512),
    c("div", gee, [
      c("button", {
        class: "stats-action-button",
        onClick: t[0] || (t[0] = (...l) => i.togglePlayPause && i.togglePlayPause(...l))
      }, [
        (d(), f("svg", vee, [
          c("g", null, [
            t[4] || (t[4] = c("rect", {
              x: "-0.5",
              y: "0.5",
              width: "55",
              height: "55",
              transform: "matrix(-1 0 0 1 55 0)",
              stroke: "#333333"
            }, null, -1)),
            o.pauseScroll ? (d(), f("path", bee)) : (d(), f(J, { key: 1 }, [
              t[2] || (t[2] = c("path", {
                d: "M24 21.5V33.5",
                stroke: "black",
                "stroke-width": "3",
                "stroke-linecap": "round"
              }, null, -1)),
              t[3] || (t[3] = c("path", {
                d: "M32 21.5V33.5",
                stroke: "black",
                "stroke-width": "3",
                "stroke-linecap": "round"
              }, null, -1))
            ], 64))
          ])
        ]))
      ])
    ])
  ], 6);
}
const _ee = /* @__PURE__ */ B(lee, [["render", yee], ["__scopeId", "data-v-eea51a61"]]);
/*!
 * strings: 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Cee = /(?:^\s+|\s+$)/g, wee = /([\uD800-\uDBFF][\uDC00-\uDFFF](?:[\u200D\uFE0F][\uD800-\uDBFF][\uDC00-\uDFFF]){2,}|\uD83D\uDC69(?:\u200D(?:(?:\uD83D\uDC69\u200D)?\uD83D\uDC67|(?:\uD83D\uDC69\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2642\u2640]\uFE0F|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDD27\uDCBC\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC6F\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3C-\uDD3E\uDDD6-\uDDDF])\u200D[\u2640\u2642]\uFE0F|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|(?:\u26F9|\uD83C[\uDFCC\uDFCB]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])\uFE0F|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC69\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708]))\uFE0F|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83D\uDC69\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\u200D(?:(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F)/;
function th(e) {
  var t = e.nodeType, n = "";
  if (t === 1 || t === 9 || t === 11) {
    if (typeof e.textContent == "string")
      return e.textContent;
    for (e = e.firstChild; e; e = e.nextSibling)
      n += th(e);
  } else if (t === 3 || t === 4)
    return e.nodeValue;
  return n;
}
function wn(e, t, n, r, o) {
  if (e += "", n && (e = e.trim ? e.trim() : e.replace(Cee, "")), t && t !== "")
    return e.replace(/>/g, "&gt;").replace(/</g, "&lt;").split(t);
  for (var i = [], a = e.length, s = 0, l, u; s < a; s++)
    u = e.charAt(s), (u.charCodeAt(0) >= 55296 && u.charCodeAt(0) <= 56319 || e.charCodeAt(s + 1) >= 65024 && e.charCodeAt(s + 1) <= 65039) && (l = ((e.substr(s, 12).split(wee) || [])[1] || "").length || 2, u = e.substr(s, l), i.emoji = 1, s += l - 1), i.push(o ? u : u === ">" ? "&gt;" : u === "<" ? "&lt;" : r && u === " " && (e.charAt(s - 1) === " " || e.charAt(s + 1) === " ") ? "&nbsp;" : u);
  return i;
}
/*!
 * ScrambleTextPlugin 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Xi = /* @__PURE__ */ function() {
  function e(n) {
    this.chars = wn(n), this.sets = [], this.length = 50;
    for (var r = 0; r < 20; r++)
      this.sets[r] = Bp(80, this.chars);
  }
  var t = e.prototype;
  return t.grow = function(r) {
    for (var o = 0; o < 20; o++)
      this.sets[o] += Bp(r - this.length, this.chars);
    this.length = r;
  }, e;
}(), Ar, l8, u8 = function() {
  return Ar || typeof window != "undefined" && (Ar = window.gsap) && Ar.registerPlugin && Ar;
}, Tee = 1, Vp = /\s+/g, Bp = function(t, n) {
  for (var r = n.length, o = ""; --t > -1; )
    o += n[~~(Math.random() * r)];
  return o;
}, Xc = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", jp = Xc.toLowerCase(), kee = {
  upperCase: new Xi(Xc),
  lowerCase: new Xi(jp),
  upperAndLowerCase: new Xi(Xc + jp)
}, Up = function() {
  l8 = Ar = u8();
}, zs = {
  version: "3.13.0",
  name: "scrambleText",
  register: function(t, n, r) {
    Ar = t, Up();
  },
  init: function(t, n, r, o, i) {
    if (l8 || Up(), this.prop = "innerHTML" in t ? "innerHTML" : "textContent" in t ? "textContent" : 0, !!this.prop) {
      this.target = t, typeof n != "object" && (n = {
        text: n
      });
      var a = n.text || n.value || "", s = n.trim !== !1, l = this, u, m, v, g;
      return l.delimiter = u = n.delimiter || "", l.original = wn(th(t).replace(Vp, " ").split("&nbsp;").join(""), u, s), (a === "{original}" || a === !0 || a == null) && (a = l.original.join(u)), l.text = wn((a || "").replace(Vp, " "), u, s), l.hasClass = !!(n.newClass || n.oldClass), l.newClass = n.newClass, l.oldClass = n.oldClass, g = u === "", l.textHasEmoji = g && !!l.text.emoji, l.charsHaveEmoji = !!n.chars && !!wn(n.chars).emoji, l.length = g ? l.original.length : l.original.join(u).length, l.lengthDif = (g ? l.text.length : l.text.join(u).length) - l.length, l.fillChar = n.fillChar || n.chars && ~n.chars.indexOf(" ") ? "&nbsp;" : "", l.charSet = v = kee[n.chars || "upperCase"] || new Xi(n.chars), l.speed = 0.05 / (n.speed || 1), l.prevScrambleTime = 0, l.setIndex = Math.random() * 20 | 0, m = l.length + Math.max(l.lengthDif, 0), m > v.length && v.grow(m), l.chars = v.sets[l.setIndex], l.revealDelay = n.revealDelay || 0, l.tweenLength = n.tweenLength !== !1, l.tween = r, l.rightToLeft = !!n.rightToLeft, l._props.push("scrambleText", "text"), Tee;
    }
  },
  render: function(t, n) {
    var r = n.target, o = n.prop, i = n.text, a = n.delimiter, s = n.tween, l = n.prevScrambleTime, u = n.revealDelay, m = n.setIndex, v = n.chars, g = n.charSet, h = n.length, E = n.textHasEmoji, C = n.charsHaveEmoji, A = n.lengthDif, R = n.tweenLength, O = n.oldClass, F = n.newClass, L = n.rightToLeft, D = n.fillChar, P = n.speed, U = n.original, q = n.hasClass, z = i.length, te = s._time, ee = te - l, x, N, G, X, Q, re, se, ue, me, he, _e;
    u && (s._from && (te = s._dur - te), t = te === 0 ? 0 : te < u ? 1e-6 : te === s._dur ? 1 : s._ease((te - u) / (s._dur - u))), t < 0 ? t = 0 : t > 1 && (t = 1), L && (t = 1 - t), x = ~~(t * z + 0.5), t ? ((ee > P || ee < -P) && (n.setIndex = m = (m + (Math.random() * 19 | 0)) % 20, n.chars = g.sets[m], n.prevScrambleTime += ee), X = v) : X = U.join(a), _e = s._from ? t : 1 - t, he = h + (R ? s._from ? _e * _e * _e : 1 - _e * _e * _e : 1) * A, L ? t === 1 && (s._from || s.data === "isFromStart") ? (G = "", X = U.join(a)) : (se = i.slice(x).join(a), C ? G = wn(X).slice(0, he - (E ? wn(se) : se).length + 0.5 | 0).join("") : G = X.substr(0, he - (E ? wn(se) : se).length + 0.5 | 0), X = se) : (G = i.slice(0, x).join(a), N = (E ? wn(G) : G).length, C ? X = wn(X).slice(N, he + 0.5 | 0).join("") : X = X.substr(N, he - N + 0.5 | 0)), q ? (ue = L ? O : F, me = L ? F : O, Q = ue && x !== 0, re = me && x !== z, se = (Q ? "<span class='" + ue + "'>" : "") + G + (Q ? "</span>" : "") + (re ? "<span class='" + me + "'>" : "") + a + X + (re ? "</span>" : "")) : se = G + a + X, r[o] = D === "&nbsp;" && ~se.indexOf("  ") ? se.split("  ").join("&nbsp;&nbsp;") : se;
  }
};
zs.emojiSafeSplit = wn;
zs.getText = th;
u8() && Ar.registerPlugin(zs);
const Eee = {
  name: "S5",
  components: {
    CardSlider: cn
  },
  mixins: [_i, bt],
  data() {
    return {
      usersReducedMotionPreference: !1
    };
  },
  computed: {
    s5Styles() {
      var e;
      return {
        "--content-alignment": ((e = this.stats.alignment) == null ? void 0 : e.value) || "Left"
      };
    },
    content() {
      return this.stats.content;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight(), this.usersReducedMotionPreference = window.matchMedia("(prefers-reduced-motion: reduce)").matches, !this.usersReducedMotionPreference && !this.isEditing && this.updateCounter();
    }), window.addEventListener("resize", this.setCardHeight), tr.registerPlugin(zs);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`statsCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`statsCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`statsCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    },
    updateCounter() {
      const e = document.querySelectorAll(".stats-counter"), t = new Intl.NumberFormat("en-US", {
        style: "decimal",
        notation: "compact",
        compactDisplay: "short",
        maximumFractionDigits: 1
      });
      e.forEach((n, r) => {
        tr.timeline(n, {
          defaults: { ease: "none" },
          scrambleText: {
            text: String(this.stats.content[r].counter_start),
            chars: "0123456789"
          },
          duration: 2
        }).to(n, {
          scrambleText: {
            text: t.format(this.stats.content[r].counter_end),
            chars: "0123456789"
          },
          duration: 2
        });
      });
    }
  }
}, See = ["data-testid"], Mee = ["data-testid"], Aee = ["aria-label"], Iee = {
  key: 0,
  class: "svg-wrapper"
}, Lee = ["innerHTML"], Dee = ["src"], $ee = { class: "snippet-link-container" };
function Oee(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "stats-s5",
    class: _(e.theme.style),
    style: Z([e.backgroundStyle, e.colors, i.s5Styles]),
    "data-testid": "S5"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.stats.headline ? (d(), f("h2", {
          key: 0,
          "data-testid": `header-${e.theme.style}`,
          class: _([e.theme.style, "stat-header"])
        }, [
          M(e.$slots, "header", {}, () => [
            H(k(e.stats.component_header), 1)
          ], !0)
        ], 10, See)) : T("", !0)
      ]),
      default: S(() => [
        e.stats.show_description ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-description`,
          class: _([e.theme.style, "stat-description"])
        }, [
          M(e.$slots, "description", {}, () => [
            H(k(e.stats.component_description), 1)
          ], !0)
        ], 10, Mee)) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": "wide",
      "has-pager": !1,
      "has-accent": "",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "screen-size": e.screenSize,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.stats.component_header,
      class: "card-slider",
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        (d(), I(Y(e.wrapperComponent), Se({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.stats.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.stats.content = l),
          "item-key": "index",
          class: ["stats-wrapper", { "all-cards-visible": e.allCardsVisible, "is-editing": e.isEditing }]
        }), {
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              class: _(["stats-info", { "is-editing": e.isEditing }]),
              "aria-label": `${u + 1} of ${i.content.length}`,
              role: "group",
              "aria-roledescription": "slide"
            }, [
              c("div", {
                ref: `statsCard-${u}`,
                "data-testid": "stats-card",
                class: _(["stats-card", e.isEditing])
              }, [
                M(e.$slots, "controls", { idx: u }, void 0, !0),
                e.theme.icons_or_images && e.stats.show_icons_or_images ? (d(), f("div", Iee, [
                  M(e.$slots, "icon", { idx: u }, () => {
                    var m;
                    return [
                      l.icon && e.theme.icons_or_images === "icons" ? (d(), f("span", {
                        key: 0,
                        class: "raw-svg",
                        "data-testid": "stats-icon",
                        innerHTML: l.icon
                      }, null, 8, Lee)) : (d(), f("img", {
                        key: 1,
                        class: "stats-image",
                        "data-testid": "stats-image",
                        src: ((m = l.image) == null ? void 0 : m.url) || "",
                        alt: ""
                      }, null, 8, Dee))
                    ];
                  }, !0)
                ])) : T("", !0),
                c("h3", {
                  class: _(["stats-counter", [e.theme.style, `stats-counter-${u}`]]),
                  "data-testid": "stats-counter"
                }, [
                  M(e.$slots, "headline", { idx: u }, () => [
                    H(k(o.usersReducedMotionPreference ? l.counter_end : l.counter_start), 1)
                  ], !0)
                ], 2),
                c("div", $ee, [
                  e.stats.snippet ? (d(), f("p", {
                    key: 0,
                    class: _(["stats-snippet", e.theme.style]),
                    "data-testid": "stats-snippet"
                  }, [
                    M(e.$slots, "snippet", { idx: u }, () => [
                      H(k(l.snippet), 1)
                    ], !0)
                  ], 2)) : T("", !0),
                  M(e.$slots, "link", { idx: u }, () => {
                    var m, v;
                    return [
                      e.stats.show_links ? (d(), I(Y(e.isPreview || e.isEditing ? "div" : "a"), {
                        key: 0,
                        href: ((m = l.link) == null ? void 0 : m.href) || "#",
                        class: _(["stat-link", e.theme.style]),
                        target: ((v = l.link) == null ? void 0 : v.target) || "_blank",
                        "data-testid": "stat-link"
                      }, {
                        default: S(() => {
                          var g;
                          return [
                            H(k(((g = l.link) == null ? void 0 : g.name) || ""), 1)
                          ];
                        }),
                        _: 2
                      }, 1032, ["href", "class", "target"])) : T("", !0)
                    ];
                  }, !0)
                ])
              ], 2)
            ], 10, Aee)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "screen-size", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const Pee = /* @__PURE__ */ B(Eee, [["render", Oee], ["__scopeId", "data-v-0a8d4d6d"]]), Nee = {
  name: "Stats",
  components: {
    S1: OJ,
    S2: YJ,
    S3: aee,
    S4: _ee,
    S5: Pee
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    startIndex: {
      type: Number,
      default: 0
    },
    isEditing: Boolean,
    isPreview: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function Hee(e, t, n, r, o, i) {
  return d(), I(Y(n.theme.version), {
    theme: n.theme,
    stats: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    "is-preview": n.isPreview,
    "start-index": n.startIndex
  }, {
    "header-top": S(() => [
      M(e.$slots, "header-top")
    ]),
    header: S(() => [
      M(e.$slots, "header")
    ]),
    description: S(() => [
      M(e.$slots, "description")
    ]),
    "stats-header": S(() => [
      M(e.$slots, "stats-header")
    ]),
    controls: S(({ idx: a }) => [
      M(e.$slots, "controls", { idx: a })
    ]),
    icon: S(({ idx: a }) => [
      M(e.$slots, "icon", { idx: a })
    ]),
    image: S(({ idx: a, position: s }) => [
      M(e.$slots, "image", {
        idx: a,
        position: s
      })
    ]),
    headline: S(({ idx: a }) => [
      M(e.$slots, "headline", { idx: a })
    ]),
    snippet: S(({ idx: a }) => [
      M(e.$slots, "snippet", { idx: a })
    ]),
    link: S(({ idx: a }) => [
      M(e.$slots, "link", { idx: a })
    ]),
    "bottom-headline": S(({ idx: a }) => [
      M(e.$slots, "bottom-headline", { idx: a })
    ]),
    "bottom-snippet": S(({ idx: a }) => [
      M(e.$slots, "bottom-snippet", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "stats", "wrapper-component", "wrapper-props", "is-editing", "is-preview", "start-index"]);
}
const Fee = /* @__PURE__ */ B(Nee, [["render", Hee]]), nh = {
  mixins: [Rt, kt],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    isPlaceholder: Boolean,
    videoSlotsItems: {
      type: Array,
      default: () => []
    },
    currentVideoThrillshare: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeItem: 0,
      isPlaying: !1,
      readMoreOpen: !1
    };
  },
  methods: {
    playPause(e, t, n) {
      const r = document.getElementById(e);
      if (!r) return;
      const o = n || (this.isPlaying ? "pause" : "play");
      if (t === "youtube")
        r.contentWindow.postMessage(`{"event":"command","func":"${o}Video","args":""}`, "*");
      else if (t === "vimeo") {
        const i = r.querySelector("iframe");
        i && i.contentWindow.postMessage(`{"method":"${o}"}`, "*");
      }
    },
    setIsPlaying({ isPlaying: e }) {
      this.isPlaying = e;
    },
    parseVideo(e) {
      let t = null;
      return e.match(
        /(http:\/\/|https:\/\/|)(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/
      ), RegExp.$3.indexOf("youtu") > -1 ? t = "youtube" : RegExp.$3.indexOf("vimeo") > -1 && (t = "vimeo"), {
        type: t,
        id: RegExp.$6
      };
    },
    getThumbnail(e) {
      return `https://vumbnail.com/${e}_large.jpg`;
    }
  },
  watch: {
    currentVideoThrillshare(e, t) {
      t !== e && (this.activeItem = e);
    },
    content() {
      this.activeItem = this.currentVideoThrillshare;
    }
  },
  computed: {
    videoItems() {
      return this.content.videos.map((e) => {
        const { type: t, id: n } = this.parseVideo(e.url), r = this.getThumbnail(n, t);
        return ge(ae({}, e), {
          type: t,
          thumbnail: r,
          videoId: n
        });
      });
    },
    currentItem() {
      return this.videoItems.length === 0 ? {} : this.videoItems[this.activeItem];
    },
    isDesktop() {
      return this.screenSize >= 960;
    },
    colors() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--heading-color": $(this.theme, "heading_color.hex", "#333"),
        "--header-accent-color": $(this.theme, "header_accent_color.hex", "#333"),
        "--video-title-color": $(this.theme, "video_title_color.hex", "#333"),
        "--video-text-color": $(this.theme, "video_text_color.hex", "#333"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "#333"),
        "--arrow-text-color": $(this.theme, "arrow_text_color.hex", "#fff"),
        "--pager-color": $(this.theme, "pager_color.hex", "#333")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayTopHeader() {
      return this.theme.style === "monterrey" && (this.content.component_header_top || this.isEditing);
    }
  }
};
var qi = { exports: {} }, qp;
function Ree() {
  if (qp) return qi.exports;
  qp = 1;
  var e = typeof Reflect == "object" ? Reflect : null, t = e && typeof e.apply == "function" ? e.apply : function(D, P, U) {
    return Function.prototype.apply.call(D, P, U);
  }, n;
  e && typeof e.ownKeys == "function" ? n = e.ownKeys : Object.getOwnPropertySymbols ? n = function(D) {
    return Object.getOwnPropertyNames(D).concat(Object.getOwnPropertySymbols(D));
  } : n = function(D) {
    return Object.getOwnPropertyNames(D);
  };
  function r(L) {
    console && console.warn && console.warn(L);
  }
  var o = Number.isNaN || function(D) {
    return D !== D;
  };
  function i() {
    i.init.call(this);
  }
  qi.exports = i, qi.exports.once = R, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
  var a = 10;
  function s(L) {
    if (typeof L != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof L);
  }
  Object.defineProperty(i, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return a;
    },
    set: function(L) {
      if (typeof L != "number" || L < 0 || o(L))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + L + ".");
      a = L;
    }
  }), i.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, i.prototype.setMaxListeners = function(D) {
    if (typeof D != "number" || D < 0 || o(D))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + D + ".");
    return this._maxListeners = D, this;
  };
  function l(L) {
    return L._maxListeners === void 0 ? i.defaultMaxListeners : L._maxListeners;
  }
  i.prototype.getMaxListeners = function() {
    return l(this);
  }, i.prototype.emit = function(D) {
    for (var P = [], U = 1; U < arguments.length; U++) P.push(arguments[U]);
    var q = D === "error", z = this._events;
    if (z !== void 0)
      q = q && z.error === void 0;
    else if (!q)
      return !1;
    if (q) {
      var te;
      if (P.length > 0 && (te = P[0]), te instanceof Error)
        throw te;
      var ee = new Error("Unhandled error." + (te ? " (" + te.message + ")" : ""));
      throw ee.context = te, ee;
    }
    var x = z[D];
    if (x === void 0)
      return !1;
    if (typeof x == "function")
      t(x, this, P);
    else
      for (var N = x.length, G = E(x, N), U = 0; U < N; ++U)
        t(G[U], this, P);
    return !0;
  };
  function u(L, D, P, U) {
    var q, z, te;
    if (s(P), z = L._events, z === void 0 ? (z = L._events = /* @__PURE__ */ Object.create(null), L._eventsCount = 0) : (z.newListener !== void 0 && (L.emit(
      "newListener",
      D,
      P.listener ? P.listener : P
    ), z = L._events), te = z[D]), te === void 0)
      te = z[D] = P, ++L._eventsCount;
    else if (typeof te == "function" ? te = z[D] = U ? [P, te] : [te, P] : U ? te.unshift(P) : te.push(P), q = l(L), q > 0 && te.length > q && !te.warned) {
      te.warned = !0;
      var ee = new Error("Possible EventEmitter memory leak detected. " + te.length + " " + String(D) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      ee.name = "MaxListenersExceededWarning", ee.emitter = L, ee.type = D, ee.count = te.length, r(ee);
    }
    return L;
  }
  i.prototype.addListener = function(D, P) {
    return u(this, D, P, !1);
  }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(D, P) {
    return u(this, D, P, !0);
  };
  function m() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function v(L, D, P) {
    var U = { fired: !1, wrapFn: void 0, target: L, type: D, listener: P }, q = m.bind(U);
    return q.listener = P, U.wrapFn = q, q;
  }
  i.prototype.once = function(D, P) {
    return s(P), this.on(D, v(this, D, P)), this;
  }, i.prototype.prependOnceListener = function(D, P) {
    return s(P), this.prependListener(D, v(this, D, P)), this;
  }, i.prototype.removeListener = function(D, P) {
    var U, q, z, te, ee;
    if (s(P), q = this._events, q === void 0)
      return this;
    if (U = q[D], U === void 0)
      return this;
    if (U === P || U.listener === P)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete q[D], q.removeListener && this.emit("removeListener", D, U.listener || P));
    else if (typeof U != "function") {
      for (z = -1, te = U.length - 1; te >= 0; te--)
        if (U[te] === P || U[te].listener === P) {
          ee = U[te].listener, z = te;
          break;
        }
      if (z < 0)
        return this;
      z === 0 ? U.shift() : C(U, z), U.length === 1 && (q[D] = U[0]), q.removeListener !== void 0 && this.emit("removeListener", D, ee || P);
    }
    return this;
  }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(D) {
    var P, U, q;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[D] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[D]), this;
    if (arguments.length === 0) {
      var z = Object.keys(U), te;
      for (q = 0; q < z.length; ++q)
        te = z[q], te !== "removeListener" && this.removeAllListeners(te);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (P = U[D], typeof P == "function")
      this.removeListener(D, P);
    else if (P !== void 0)
      for (q = P.length - 1; q >= 0; q--)
        this.removeListener(D, P[q]);
    return this;
  };
  function g(L, D, P) {
    var U = L._events;
    if (U === void 0)
      return [];
    var q = U[D];
    return q === void 0 ? [] : typeof q == "function" ? P ? [q.listener || q] : [q] : P ? A(q) : E(q, q.length);
  }
  i.prototype.listeners = function(D) {
    return g(this, D, !0);
  }, i.prototype.rawListeners = function(D) {
    return g(this, D, !1);
  }, i.listenerCount = function(L, D) {
    return typeof L.listenerCount == "function" ? L.listenerCount(D) : h.call(L, D);
  }, i.prototype.listenerCount = h;
  function h(L) {
    var D = this._events;
    if (D !== void 0) {
      var P = D[L];
      if (typeof P == "function")
        return 1;
      if (P !== void 0)
        return P.length;
    }
    return 0;
  }
  i.prototype.eventNames = function() {
    return this._eventsCount > 0 ? n(this._events) : [];
  };
  function E(L, D) {
    for (var P = new Array(D), U = 0; U < D; ++U)
      P[U] = L[U];
    return P;
  }
  function C(L, D) {
    for (; D + 1 < L.length; D++)
      L[D] = L[D + 1];
    L.pop();
  }
  function A(L) {
    for (var D = new Array(L.length), P = 0; P < D.length; ++P)
      D[P] = L[P].listener || L[P];
    return D;
  }
  function R(L, D) {
    return new Promise(function(P, U) {
      function q(te) {
        L.removeListener(D, z), U(te);
      }
      function z() {
        typeof L.removeListener == "function" && L.removeListener("error", q), P([].slice.call(arguments));
      }
      F(L, D, z, { once: !0 }), D !== "error" && O(L, q, { once: !0 });
    });
  }
  function O(L, D, P) {
    typeof L.on == "function" && F(L, "error", D, P);
  }
  function F(L, D, P, U) {
    if (typeof L.on == "function")
      U.once ? L.once(D, P) : L.on(D, P);
    else if (typeof L.addEventListener == "function")
      L.addEventListener(D, function q(z) {
        U.once && L.removeEventListener(D, q), P(z);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof L);
  }
  return qi.exports;
}
/*! load-script2. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var fc, Gp;
function Vee() {
  return Gp || (Gp = 1, fc = function(t, n, r) {
    return new Promise((o, i) => {
      const a = document.createElement("script");
      a.async = !0, a.src = t;
      for (const [l, u] of Object.entries(n || {}))
        a.setAttribute(l, u);
      a.onload = () => {
        a.onerror = a.onload = null, o(a);
      }, a.onerror = () => {
        a.onerror = a.onload = null, i(new Error(`Failed to load ${t}`));
      }, (r || document.head || document.getElementsByTagName("head")[0]).appendChild(a);
    });
  }), fc;
}
/*! yt-player. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var pc, Kp;
function Bee() {
  if (Kp) return pc;
  Kp = 1;
  const e = Ree().EventEmitter, t = Vee(), n = "https://www.youtube.com/iframe_api", r = {
    "-1": "unstarted",
    0: "ended",
    1: "playing",
    2: "paused",
    3: "buffering",
    5: "cued"
  }, o = {
    // The request contains an invalid parameter value. For example, this error
    // occurs if you specify a videoId that does not have 11 characters, or if the
    // videoId contains invalid characters, such as exclamation points or asterisks.
    INVALID_PARAM: 2,
    // The requested content cannot be played in an HTML5 player or another error
    // related to the HTML5 player has occurred.
    HTML5_ERROR: 5,
    // The video requested was not found. This error occurs when a video has been
    // removed (for any reason) or has been marked as private.
    NOT_FOUND: 100,
    // The owner of the requested video does not allow it to be played in embedded
    // players.
    UNPLAYABLE_1: 101,
    // This error is the same as 101. It's just a 101 error in disguise!
    UNPLAYABLE_2: 150
  }, i = [];
  class a extends e {
    constructor(l, u) {
      super();
      const m = typeof l == "string" ? document.querySelector(l) : l;
      m.id ? this._id = m.id : this._id = m.id = "ytplayer-" + Math.random().toString(16).slice(2, 8), this._opts = Object.assign({
        width: 640,
        height: 360,
        autoplay: !1,
        captions: void 0,
        controls: !0,
        keyboard: !0,
        fullscreen: !0,
        annotations: !0,
        modestBranding: !1,
        related: !0,
        timeupdateFrequency: 1e3,
        playsInline: !0,
        start: 0
      }, u), this.videoId = null, this.destroyed = !1, this._api = null, this._autoplay = !1, this._player = null, this._ready = !1, this._queue = [], this._interval = null, this._startInterval = this._startInterval.bind(this), this._stopInterval = this._stopInterval.bind(this), this.on("playing", this._startInterval), this.on("unstarted", this._stopInterval), this.on("ended", this._stopInterval), this.on("paused", this._stopInterval), this.on("buffering", this._stopInterval), this._loadIframeAPI((v, g) => {
        if (v) return this._destroy(new Error("YouTube Iframe API failed to load"));
        this._api = g, this.videoId && this.load(this.videoId, this._autoplay, this._start);
      });
    }
    load(l, u = !1, m = 0) {
      if (!this.destroyed && (this.videoId = l, this._autoplay = u, this._start = m, !!this._api)) {
        if (!this._player) {
          this._createPlayer(l);
          return;
        }
        this._ready && (u ? this._player.loadVideoById(l, m) : this._player.cueVideoById(l, m));
      }
    }
    play() {
      this._ready ? this._player.playVideo() : this._queueCommand("play");
    }
    pause() {
      this._ready ? this._player.pauseVideo() : this._queueCommand("pause");
    }
    stop() {
      this._ready ? this._player.stopVideo() : this._queueCommand("stop");
    }
    seek(l) {
      this._ready ? this._player.seekTo(l, !0) : this._queueCommand("seek", l);
    }
    setVolume(l) {
      this._ready ? this._player.setVolume(l) : this._queueCommand("setVolume", l);
    }
    getVolume() {
      return this._ready && this._player.getVolume() || 0;
    }
    mute() {
      this._ready ? this._player.mute() : this._queueCommand("mute");
    }
    unMute() {
      this._ready ? this._player.unMute() : this._queueCommand("unMute");
    }
    isMuted() {
      return this._ready && this._player.isMuted() || !1;
    }
    setSize(l, u) {
      this._ready ? this._player.setSize(l, u) : this._queueCommand("setSize", l, u);
    }
    setPlaybackRate(l) {
      this._ready ? this._player.setPlaybackRate(l) : this._queueCommand("setPlaybackRate", l);
    }
    setPlaybackQuality(l) {
      this._ready ? this._player.setPlaybackQuality(l) : this._queueCommand("setPlaybackQuality", l);
    }
    getPlaybackRate() {
      return this._ready && this._player.getPlaybackRate() || 1;
    }
    getAvailablePlaybackRates() {
      return this._ready && this._player.getAvailablePlaybackRates() || [1];
    }
    getDuration() {
      return this._ready && this._player.getDuration() || 0;
    }
    getProgress() {
      return this._ready && this._player.getVideoLoadedFraction() || 0;
    }
    getState() {
      return this._ready && r[this._player.getPlayerState()] || "unstarted";
    }
    getCurrentTime() {
      return this._ready && this._player.getCurrentTime() || 0;
    }
    destroy() {
      this._destroy();
    }
    _destroy(l) {
      this.destroyed || (this.destroyed = !0, this._player && (this._player.stopVideo && this._player.stopVideo(), this._player.destroy()), this.videoId = null, this._id = null, this._opts = null, this._api = null, this._player = null, this._ready = !1, this._queue = null, this._stopInterval(), this.removeListener("playing", this._startInterval), this.removeListener("paused", this._stopInterval), this.removeListener("buffering", this._stopInterval), this.removeListener("unstarted", this._stopInterval), this.removeListener("ended", this._stopInterval), l && this.emit("error", l));
    }
    _queueCommand(l, ...u) {
      this.destroyed || this._queue.push([l, u]);
    }
    _flushQueue() {
      for (; this._queue.length; ) {
        const l = this._queue.shift();
        this[l[0]].apply(this, l[1]);
      }
    }
    _loadIframeAPI(l) {
      if (window.YT && typeof window.YT.Player == "function")
        return l(null, window.YT);
      i.push(l), Array.from(document.getElementsByTagName("script")).some((g) => g.src === n) || t(n).catch((g) => {
        for (; i.length; )
          i.shift()(g);
      });
      const v = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        for (typeof v == "function" && v(); i.length; )
          i.shift()(null, window.YT);
      };
    }
    _createPlayer(l) {
      if (this.destroyed) return;
      const u = this._opts;
      this._player = new this._api.Player(this._id, {
        width: u.width,
        height: u.height,
        videoId: l,
        // (Not part of documented API) This parameter controls the hostname that
        // videos are loaded from. Set to `'https://www.youtube-nocookie.com'`
        // for enhanced privacy.
        host: u.host,
        playerVars: {
          // This parameter specifies whether the initial video will automatically
          // start to play when the player loads. Supported values are 0 or 1. The
          // default value is 0.
          autoplay: u.autoplay ? 1 : 0,
          // Setting the parameter's value to 1 causes closed captions to be shown
          // by default, even if the user has turned captions off. The default
          // behavior is based on user preference.
          cc_load_policy: u.captions != null ? u.captions !== !1 ? 1 : 0 : void 0,
          // default to not setting this option
          // Sets the player's interface language. The parameter value is an ISO
          // 639-1 two-letter language code or a fully specified locale. For
          // example, fr and fr-ca are both valid values. Other language input
          // codes, such as IETF language tags (BCP 47) might also be handled
          // properly.
          hl: u.captions != null && u.captions !== !1 ? u.captions : void 0,
          // default to not setting this option
          // This parameter specifies the default language that the player will
          // use to display captions. Set the parameter's value to an ISO 639-1
          // two-letter language code.
          cc_lang_pref: u.captions != null && u.captions !== !1 ? u.captions : void 0,
          // default to not setting this option
          // This parameter indicates whether the video player controls are
          // displayed. For IFrame embeds that load a Flash player, it also defines
          // when the controls display in the player as well as when the player
          // will load. Supported values are:
          //   - controls=0 – Player controls do not display in the player. For
          //                  IFrame embeds, the Flash player loads immediately.
          //   - controls=1 – (default) Player controls display in the player. For
          //                  IFrame embeds, the controls display immediately and
          //                  the Flash player also loads immediately.
          //   - controls=2 – Player controls display in the player. For IFrame
          //                  embeds, the controls display and the Flash player
          //                  loads after the user initiates the video playback.
          controls: u.controls ? 2 : 0,
          // Setting the parameter's value to 1 causes the player to not respond to
          // keyboard controls. The default value is 0, which means that keyboard
          // controls are enabled.
          disablekb: u.keyboard ? 0 : 1,
          // Setting the parameter's value to 1 enables the player to be
          // controlled via IFrame or JavaScript Player API calls. The default
          // value is 0, which means that the player cannot be controlled using
          // those APIs.
          enablejsapi: 1,
          // Setting this parameter to 0 prevents the fullscreen button from
          // displaying in the player. The default value is 1, which causes the
          // fullscreen button to display.
          fs: u.fullscreen ? 1 : 0,
          // Setting the parameter's value to 1 causes video annotations to be
          // shown by default, whereas setting to 3 causes video annotations to not
          // be shown by default. The default value is 1.
          iv_load_policy: u.annotations ? 1 : 3,
          // This parameter lets you use a YouTube player that does not show a
          // YouTube logo. Set the parameter value to 1 to prevent the YouTube logo
          // from displaying in the control bar. Note that a small YouTube text
          // label will still display in the upper-right corner of a paused video
          // when the user's mouse pointer hovers over the player.
          modestbranding: u.modestBranding ? 1 : 0,
          // This parameter provides an extra security measure for the IFrame API
          // and is only supported for IFrame embeds. If you are using the IFrame
          // API, which means you are setting the enablejsapi parameter value to 1,
          // you should always specify your domain as the origin parameter value.
          origin: window.location.origin,
          // This parameter controls whether videos play inline or fullscreen in an
          // HTML5 player on iOS. Valid values are:
          //   - 0: This value causes fullscreen playback. This is currently the
          //        default value, though the default is subject to change.
          //   - 1: This value causes inline playback for UIWebViews created with
          //        the allowsInlineMediaPlayback property set to TRUE.
          playsinline: u.playsInline ? 1 : 0,
          // This parameter indicates whether the player should show related
          // videos from the same channel (0) or from any channel (1) when
          // playback of the video ends. The default value is 1.
          rel: u.related ? 1 : 0,
          // (Not part of documented API) Allow html elements with higher z-index
          // to be shown on top of the YouTube player.
          wmode: "opaque",
          // This parameter causes the player to begin playing the video at the given number
          // of seconds from the start of the video. The parameter value is a positive integer.
          // Note that similar to the seek function, the player will look for the closest
          // keyframe to the time you specify. This means that sometimes the play head may seek
          // to just before the requested time, usually no more than around two seconds.
          start: u.start
        },
        events: {
          onReady: () => this._onReady(l),
          onStateChange: (m) => this._onStateChange(m),
          onPlaybackQualityChange: (m) => this._onPlaybackQualityChange(m),
          onPlaybackRateChange: (m) => this._onPlaybackRateChange(m),
          onError: (m) => this._onError(m)
        }
      });
    }
    /**
     * This event fires when the player has finished loading and is ready to begin
     * receiving API calls.
     */
    _onReady(l) {
      this.destroyed || (this._ready = !0, this.load(this.videoId, this._autoplay, this._start), this._flushQueue());
    }
    /**
     * Called when the player's state changes. We emit friendly events so the user
     * doesn't need to use YouTube's YT.PlayerState.* event constants.
     */
    _onStateChange(l) {
      if (this.destroyed) return;
      const u = r[l.data];
      if (u)
        ["paused", "buffering", "ended"].includes(u) && this._onTimeupdate(), this.emit(u), ["unstarted", "playing", "cued"].includes(u) && this._onTimeupdate();
      else
        throw new Error("Unrecognized state change: " + l);
    }
    /**
     * This event fires whenever the video playback quality changes. Possible
     * values are: 'small', 'medium', 'large', 'hd720', 'hd1080', 'highres'.
     */
    _onPlaybackQualityChange(l) {
      this.destroyed || this.emit("playbackQualityChange", l.data);
    }
    /**
     * This event fires whenever the video playback rate changes.
     */
    _onPlaybackRateChange(l) {
      this.destroyed || this.emit("playbackRateChange", l.data);
    }
    /**
     * This event fires if an error occurs in the player.
     */
    _onError(l) {
      if (this.destroyed) return;
      const u = Number(l.data);
      if (u !== o.HTML5_ERROR) {
        if (u === o.UNPLAYABLE_1 || u === o.UNPLAYABLE_2 || u === o.NOT_FOUND || u === o.INVALID_PARAM)
          return this.emit("unplayable", this.videoId);
        this._destroy(new Error("YouTube Player Error. Unknown error code: " + u));
      }
    }
    /**
     * This event fires when the time indicated by the `getCurrentTime()` method
     * has been updated.
     */
    _onTimeupdate() {
      this.emit("timeupdate", this.getCurrentTime());
    }
    _startInterval() {
      this._interval = setInterval(() => this._onTimeupdate(), this._opts.timeupdateFrequency);
    }
    _stopInterval() {
      clearInterval(this._interval), this._interval = null;
    }
  }
  return pc = a, pc;
}
var jee = Bee();
const Uee = /* @__PURE__ */ Co(jee);
/*! @vimeo/player v2.25.1 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */
function zp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Zp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zp(Object(n), !0).forEach(function(r) {
      Qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ct() {
  Ct = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, r = Object.defineProperty || function(x, N, G) {
    x[N] = G.value;
  }, o = typeof Symbol == "function" ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
  function l(x, N, G) {
    return Object.defineProperty(x, N, {
      value: G,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), x[N];
  }
  try {
    l({}, "");
  } catch (x) {
    l = function(N, G, X) {
      return N[G] = X;
    };
  }
  function u(x, N, G, X) {
    var Q = N && N.prototype instanceof g ? N : g, re = Object.create(Q.prototype), se = new z(X || []);
    return r(re, "_invoke", {
      value: D(x, G, se)
    }), re;
  }
  function m(x, N, G) {
    try {
      return {
        type: "normal",
        arg: x.call(N, G)
      };
    } catch (X) {
      return {
        type: "throw",
        arg: X
      };
    }
  }
  e.wrap = u;
  var v = {};
  function g() {
  }
  function h() {
  }
  function E() {
  }
  var C = {};
  l(C, i, function() {
    return this;
  });
  var A = Object.getPrototypeOf, R = A && A(A(te([])));
  R && R !== t && n.call(R, i) && (C = R);
  var O = E.prototype = g.prototype = Object.create(C);
  function F(x) {
    ["next", "throw", "return"].forEach(function(N) {
      l(x, N, function(G) {
        return this._invoke(N, G);
      });
    });
  }
  function L(x, N) {
    function G(Q, re, se, ue) {
      var me = m(x[Q], x, re);
      if (me.type !== "throw") {
        var he = me.arg, _e = he.value;
        return _e && typeof _e == "object" && n.call(_e, "__await") ? N.resolve(_e.__await).then(function(De) {
          G("next", De, se, ue);
        }, function(De) {
          G("throw", De, se, ue);
        }) : N.resolve(_e).then(function(De) {
          he.value = De, se(he);
        }, function(De) {
          return G("throw", De, se, ue);
        });
      }
      ue(me.arg);
    }
    var X;
    r(this, "_invoke", {
      value: function(Q, re) {
        function se() {
          return new N(function(ue, me) {
            G(Q, re, ue, me);
          });
        }
        return X = X ? X.then(se, se) : se();
      }
    });
  }
  function D(x, N, G) {
    var X = "suspendedStart";
    return function(Q, re) {
      if (X === "executing") throw new Error("Generator is already running");
      if (X === "completed") {
        if (Q === "throw") throw re;
        return ee();
      }
      for (G.method = Q, G.arg = re; ; ) {
        var se = G.delegate;
        if (se) {
          var ue = P(se, G);
          if (ue) {
            if (ue === v) continue;
            return ue;
          }
        }
        if (G.method === "next") G.sent = G._sent = G.arg;
        else if (G.method === "throw") {
          if (X === "suspendedStart") throw X = "completed", G.arg;
          G.dispatchException(G.arg);
        } else G.method === "return" && G.abrupt("return", G.arg);
        X = "executing";
        var me = m(x, N, G);
        if (me.type === "normal") {
          if (X = G.done ? "completed" : "suspendedYield", me.arg === v) continue;
          return {
            value: me.arg,
            done: G.done
          };
        }
        me.type === "throw" && (X = "completed", G.method = "throw", G.arg = me.arg);
      }
    };
  }
  function P(x, N) {
    var G = N.method, X = x.iterator[G];
    if (X === void 0) return N.delegate = null, G === "throw" && x.iterator.return && (N.method = "return", N.arg = void 0, P(x, N), N.method === "throw") || G !== "return" && (N.method = "throw", N.arg = new TypeError("The iterator does not provide a '" + G + "' method")), v;
    var Q = m(X, x.iterator, N.arg);
    if (Q.type === "throw") return N.method = "throw", N.arg = Q.arg, N.delegate = null, v;
    var re = Q.arg;
    return re ? re.done ? (N[x.resultName] = re.value, N.next = x.nextLoc, N.method !== "return" && (N.method = "next", N.arg = void 0), N.delegate = null, v) : re : (N.method = "throw", N.arg = new TypeError("iterator result is not an object"), N.delegate = null, v);
  }
  function U(x) {
    var N = {
      tryLoc: x[0]
    };
    1 in x && (N.catchLoc = x[1]), 2 in x && (N.finallyLoc = x[2], N.afterLoc = x[3]), this.tryEntries.push(N);
  }
  function q(x) {
    var N = x.completion || {};
    N.type = "normal", delete N.arg, x.completion = N;
  }
  function z(x) {
    this.tryEntries = [{
      tryLoc: "root"
    }], x.forEach(U, this), this.reset(!0);
  }
  function te(x) {
    if (x) {
      var N = x[i];
      if (N) return N.call(x);
      if (typeof x.next == "function") return x;
      if (!isNaN(x.length)) {
        var G = -1, X = function Q() {
          for (; ++G < x.length; ) if (n.call(x, G)) return Q.value = x[G], Q.done = !1, Q;
          return Q.value = void 0, Q.done = !0, Q;
        };
        return X.next = X;
      }
    }
    return {
      next: ee
    };
  }
  function ee() {
    return {
      value: void 0,
      done: !0
    };
  }
  return h.prototype = E, r(O, "constructor", {
    value: E,
    configurable: !0
  }), r(E, "constructor", {
    value: h,
    configurable: !0
  }), h.displayName = l(E, s, "GeneratorFunction"), e.isGeneratorFunction = function(x) {
    var N = typeof x == "function" && x.constructor;
    return !!N && (N === h || (N.displayName || N.name) === "GeneratorFunction");
  }, e.mark = function(x) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(x, E) : (x.__proto__ = E, l(x, s, "GeneratorFunction")), x.prototype = Object.create(O), x;
  }, e.awrap = function(x) {
    return {
      __await: x
    };
  }, F(L.prototype), l(L.prototype, a, function() {
    return this;
  }), e.AsyncIterator = L, e.async = function(x, N, G, X, Q) {
    Q === void 0 && (Q = Promise);
    var re = new L(u(x, N, G, X), Q);
    return e.isGeneratorFunction(N) ? re : re.next().then(function(se) {
      return se.done ? se.value : re.next();
    });
  }, F(O), l(O, s, "Generator"), l(O, i, function() {
    return this;
  }), l(O, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(x) {
    var N = Object(x), G = [];
    for (var X in N) G.push(X);
    return G.reverse(), function Q() {
      for (; G.length; ) {
        var re = G.pop();
        if (re in N) return Q.value = re, Q.done = !1, Q;
      }
      return Q.done = !0, Q;
    };
  }, e.values = te, z.prototype = {
    constructor: z,
    reset: function(x) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(q), !x) for (var N in this) N.charAt(0) === "t" && n.call(this, N) && !isNaN(+N.slice(1)) && (this[N] = void 0);
    },
    stop: function() {
      this.done = !0;
      var x = this.tryEntries[0].completion;
      if (x.type === "throw") throw x.arg;
      return this.rval;
    },
    dispatchException: function(x) {
      if (this.done) throw x;
      var N = this;
      function G(me, he) {
        return re.type = "throw", re.arg = x, N.next = me, he && (N.method = "next", N.arg = void 0), !!he;
      }
      for (var X = this.tryEntries.length - 1; X >= 0; --X) {
        var Q = this.tryEntries[X], re = Q.completion;
        if (Q.tryLoc === "root") return G("end");
        if (Q.tryLoc <= this.prev) {
          var se = n.call(Q, "catchLoc"), ue = n.call(Q, "finallyLoc");
          if (se && ue) {
            if (this.prev < Q.catchLoc) return G(Q.catchLoc, !0);
            if (this.prev < Q.finallyLoc) return G(Q.finallyLoc);
          } else if (se) {
            if (this.prev < Q.catchLoc) return G(Q.catchLoc, !0);
          } else {
            if (!ue) throw new Error("try statement without catch or finally");
            if (this.prev < Q.finallyLoc) return G(Q.finallyLoc);
          }
        }
      }
    },
    abrupt: function(x, N) {
      for (var G = this.tryEntries.length - 1; G >= 0; --G) {
        var X = this.tryEntries[G];
        if (X.tryLoc <= this.prev && n.call(X, "finallyLoc") && this.prev < X.finallyLoc) {
          var Q = X;
          break;
        }
      }
      Q && (x === "break" || x === "continue") && Q.tryLoc <= N && N <= Q.finallyLoc && (Q = null);
      var re = Q ? Q.completion : {};
      return re.type = x, re.arg = N, Q ? (this.method = "next", this.next = Q.finallyLoc, v) : this.complete(re);
    },
    complete: function(x, N) {
      if (x.type === "throw") throw x.arg;
      return x.type === "break" || x.type === "continue" ? this.next = x.arg : x.type === "return" ? (this.rval = this.arg = x.arg, this.method = "return", this.next = "end") : x.type === "normal" && N && (this.next = N), v;
    },
    finish: function(x) {
      for (var N = this.tryEntries.length - 1; N >= 0; --N) {
        var G = this.tryEntries[N];
        if (G.finallyLoc === x) return this.complete(G.completion, G.afterLoc), q(G), v;
      }
    },
    catch: function(x) {
      for (var N = this.tryEntries.length - 1; N >= 0; --N) {
        var G = this.tryEntries[N];
        if (G.tryLoc === x) {
          var X = G.completion;
          if (X.type === "throw") {
            var Q = X.arg;
            q(G);
          }
          return Q;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(x, N, G) {
      return this.delegate = {
        iterator: te(x),
        resultName: N,
        nextLoc: G
      }, this.method === "next" && (this.arg = void 0), v;
    }
  }, e;
}
function xp(e, t, n, r, o, i, a) {
  try {
    var s = e[i](a), l = s.value;
  } catch (u) {
    n(u);
    return;
  }
  s.done ? t(l) : Promise.resolve(l).then(r, o);
}
function Er(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, o) {
      var i = e.apply(t, n);
      function a(l) {
        xp(i, r, o, a, s, "next", l);
      }
      function s(l) {
        xp(i, r, o, a, s, "throw", l);
      }
      a(void 0);
    });
  };
}
function d8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qee(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, m8(r.key), r);
  }
}
function c8(e, t, n) {
  return t && qee(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Qi(e, t, n) {
  return t = m8(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Gee(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && di(e, t);
}
function ui(e) {
  return ui = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ui(e);
}
function di(e, t) {
  return di = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, di(e, t);
}
function h8() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (e) {
    return !1;
  }
}
function Ji(e, t, n) {
  return h8() ? Ji = Reflect.construct.bind() : Ji = function(o, i, a) {
    var s = [null];
    s.push.apply(s, i);
    var l = Function.bind.apply(o, s), u = new l();
    return a && di(u, a.prototype), u;
  }, Ji.apply(null, arguments);
}
function Kee(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Qc(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Qc = function(r) {
    if (r === null || !Kee(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t != "undefined") {
      if (t.has(r)) return t.get(r);
      t.set(r, o);
    }
    function o() {
      return Ji(r, arguments, ui(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), di(o, r);
  }, Qc(e);
}
function es(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zee(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return es(e);
}
function Zee(e) {
  var t = h8();
  return function() {
    var r = ui(e), o;
    if (t) {
      var i = ui(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return zee(this, o);
  };
}
function xee(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function m8(e) {
  var t = xee(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var f8 = typeof global != "undefined" && {}.toString.call(global) === "[object global]";
function Wp(e, t) {
  return e.indexOf(t.toLowerCase()) === 0 ? e : "".concat(t.toLowerCase()).concat(e.substr(0, 1).toUpperCase()).concat(e.substr(1));
}
function Wee(e) {
  return !!(e && e.nodeType === 1 && "nodeName" in e && e.ownerDocument && e.ownerDocument.defaultView);
}
function Yee(e) {
  return !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e;
}
function Hr(e) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(e);
}
function p8(e) {
  var t = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return t.test(e);
}
function Xee(e) {
  for (var t = (e || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/), n = (t && t[1] || "").replace("player.", ""), r = [".videoji.hk", ".vimeo.work", ".videoji.cn"], o = 0, i = r; o < i.length; o++) {
    var a = i[o];
    if (n.endsWith(a))
      return n;
  }
  return "vimeo.com";
}
function g8() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.id, n = e.url, r = t || n;
  if (!r)
    throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (Yee(r))
    return "https://vimeo.com/".concat(r);
  if (Hr(r))
    return r.replace("http:", "https:");
  throw t ? new TypeError("“".concat(t, "” is not a valid video id.")) : new TypeError("“".concat(r, "” is not a vimeo.com url."));
}
var Yp = function(t, n, r) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "addEventListener", i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "removeEventListener", a = typeof n == "string" ? [n] : n;
  return a.forEach(function(s) {
    t[o](s, r);
  }), {
    cancel: function() {
      return a.forEach(function(l) {
        return t[i](l, r);
      });
    }
  };
}, Qee = typeof Array.prototype.indexOf != "undefined", Jee = typeof window != "undefined" && typeof window.postMessage != "undefined";
if (!f8 && (!Qee || !Jee))
  throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var co = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ete(e, t) {
  return t = { exports: {} }, e(t, t.exports), t.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function(e) {
  if (e.WeakMap)
    return;
  var t = Object.prototype.hasOwnProperty, n = Object.defineProperty && function() {
    try {
      return Object.defineProperty({}, "x", {
        value: 1
      }).x === 1;
    } catch (i) {
    }
  }(), r = function(i, a, s) {
    n ? Object.defineProperty(i, a, {
      configurable: !0,
      writable: !0,
      value: s
    }) : i[a] = s;
  };
  e.WeakMap = function() {
    function i() {
      if (this === void 0)
        throw new TypeError("Constructor WeakMap requires 'new'");
      if (r(this, "_id", s("_WeakMap")), arguments.length > 0)
        throw new TypeError("WeakMap iterable is not supported");
    }
    r(i.prototype, "delete", function(u) {
      if (a(this, "delete"), !o(u))
        return !1;
      var m = u[this._id];
      return m && m[0] === u ? (delete u[this._id], !0) : !1;
    }), r(i.prototype, "get", function(u) {
      if (a(this, "get"), !!o(u)) {
        var m = u[this._id];
        if (m && m[0] === u)
          return m[1];
      }
    }), r(i.prototype, "has", function(u) {
      if (a(this, "has"), !o(u))
        return !1;
      var m = u[this._id];
      return !!(m && m[0] === u);
    }), r(i.prototype, "set", function(u, m) {
      if (a(this, "set"), !o(u))
        throw new TypeError("Invalid value used as weak map key");
      var v = u[this._id];
      return v && v[0] === u ? (v[1] = m, this) : (r(u, this._id, [u, m]), this);
    });
    function a(u, m) {
      if (!o(u) || !t.call(u, "_id"))
        throw new TypeError(m + " method called on incompatible receiver " + typeof u);
    }
    function s(u) {
      return u + "_" + l() + "." + l();
    }
    function l() {
      return Math.random().toString().substring(2);
    }
    return r(i, "_polyfill", !0), i;
  }();
  function o(i) {
    return Object(i) === i;
  }
})(typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : co);
var Qt = ete(function(e) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function(n, r, o) {
    r[n] = r[n] || o(), e.exports && (e.exports = r[n]);
  })("Promise", co, function() {
    var n, r, o, i = Object.prototype.toString, a = typeof setImmediate != "undefined" ? function(F) {
      return setImmediate(F);
    } : setTimeout;
    try {
      Object.defineProperty({}, "x", {}), n = function(F, L, D, P) {
        return Object.defineProperty(F, L, {
          value: D,
          writable: !0,
          configurable: P !== !1
        });
      };
    } catch (O) {
      n = function(L, D, P) {
        return L[D] = P, L;
      };
    }
    o = /* @__PURE__ */ function() {
      var F, L, D;
      function P(U, q) {
        this.fn = U, this.self = q, this.next = void 0;
      }
      return {
        add: function(q, z) {
          D = new P(q, z), L ? L.next = D : F = D, L = D, D = void 0;
        },
        drain: function() {
          var q = F;
          for (F = L = r = void 0; q; )
            q.fn.call(q.self), q = q.next;
        }
      };
    }();
    function s(O, F) {
      o.add(O, F), r || (r = a(o.drain));
    }
    function l(O) {
      var F, L = typeof O;
      return O != null && (L == "object" || L == "function") && (F = O.then), typeof F == "function" ? F : !1;
    }
    function u() {
      for (var O = 0; O < this.chain.length; O++)
        m(this, this.state === 1 ? this.chain[O].success : this.chain[O].failure, this.chain[O]);
      this.chain.length = 0;
    }
    function m(O, F, L) {
      var D, P;
      try {
        F === !1 ? L.reject(O.msg) : (F === !0 ? D = O.msg : D = F.call(void 0, O.msg), D === L.promise ? L.reject(TypeError("Promise-chain cycle")) : (P = l(D)) ? P.call(D, L.resolve, L.reject) : L.resolve(D));
      } catch (U) {
        L.reject(U);
      }
    }
    function v(O) {
      var F, L = this;
      if (!L.triggered) {
        L.triggered = !0, L.def && (L = L.def);
        try {
          (F = l(O)) ? s(function() {
            var D = new E(L);
            try {
              F.call(O, function() {
                v.apply(D, arguments);
              }, function() {
                g.apply(D, arguments);
              });
            } catch (P) {
              g.call(D, P);
            }
          }) : (L.msg = O, L.state = 1, L.chain.length > 0 && s(u, L));
        } catch (D) {
          g.call(new E(L), D);
        }
      }
    }
    function g(O) {
      var F = this;
      F.triggered || (F.triggered = !0, F.def && (F = F.def), F.msg = O, F.state = 2, F.chain.length > 0 && s(u, F));
    }
    function h(O, F, L, D) {
      for (var P = 0; P < F.length; P++)
        (function(q) {
          O.resolve(F[q]).then(function(te) {
            L(q, te);
          }, D);
        })(P);
    }
    function E(O) {
      this.def = O, this.triggered = !1;
    }
    function C(O) {
      this.promise = O, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
    }
    function A(O) {
      if (typeof O != "function")
        throw TypeError("Not a function");
      if (this.__NPO__ !== 0)
        throw TypeError("Not a promise");
      this.__NPO__ = 1;
      var F = new C(this);
      this.then = function(D, P) {
        var U = {
          success: typeof D == "function" ? D : !0,
          failure: typeof P == "function" ? P : !1
        };
        return U.promise = new this.constructor(function(z, te) {
          if (typeof z != "function" || typeof te != "function")
            throw TypeError("Not a function");
          U.resolve = z, U.reject = te;
        }), F.chain.push(U), F.state !== 0 && s(u, F), U.promise;
      }, this.catch = function(D) {
        return this.then(void 0, D);
      };
      try {
        O.call(void 0, function(D) {
          v.call(F, D);
        }, function(D) {
          g.call(F, D);
        });
      } catch (L) {
        g.call(F, L);
      }
    }
    var R = n(
      {},
      "constructor",
      A,
      /*configurable=*/
      !1
    );
    return A.prototype = R, n(
      R,
      "__NPO__",
      0,
      /*configurable=*/
      !1
    ), n(A, "resolve", function(F) {
      var L = this;
      return F && typeof F == "object" && F.__NPO__ === 1 ? F : new L(function(P, U) {
        if (typeof P != "function" || typeof U != "function")
          throw TypeError("Not a function");
        P(F);
      });
    }), n(A, "reject", function(F) {
      return new this(function(D, P) {
        if (typeof D != "function" || typeof P != "function")
          throw TypeError("Not a function");
        P(F);
      });
    }), n(A, "all", function(F) {
      var L = this;
      return i.call(F) != "[object Array]" ? L.reject(TypeError("Not an array")) : F.length === 0 ? L.resolve([]) : new L(function(P, U) {
        if (typeof P != "function" || typeof U != "function")
          throw TypeError("Not a function");
        var q = F.length, z = Array(q), te = 0;
        h(L, F, function(x, N) {
          z[x] = N, ++te === q && P(z);
        }, U);
      });
    }), n(A, "race", function(F) {
      var L = this;
      return i.call(F) != "[object Array]" ? L.reject(TypeError("Not an array")) : new L(function(P, U) {
        if (typeof P != "function" || typeof U != "function")
          throw TypeError("Not a function");
        h(L, F, function(z, te) {
          P(te);
        }, U);
      });
    }), A;
  });
}), qn = /* @__PURE__ */ new WeakMap();
function qo(e, t, n) {
  var r = qn.get(e.element) || {};
  t in r || (r[t] = []), r[t].push(n), qn.set(e.element, r);
}
function ps(e, t) {
  var n = qn.get(e.element) || {};
  return n[t] || [];
}
function gs(e, t, n) {
  var r = qn.get(e.element) || {};
  if (!r[t])
    return !0;
  if (!n)
    return r[t] = [], qn.set(e.element, r), !0;
  var o = r[t].indexOf(n);
  return o !== -1 && r[t].splice(o, 1), qn.set(e.element, r), r[t] && r[t].length === 0;
}
function tte(e, t) {
  var n = ps(e, t);
  if (n.length < 1)
    return !1;
  var r = n.shift();
  return gs(e, t, r), r;
}
function nte(e, t) {
  var n = qn.get(e);
  qn.set(t, n), qn.delete(e);
}
function Zs(e) {
  if (typeof e == "string")
    try {
      e = JSON.parse(e);
    } catch (t) {
      return console.warn(t), {};
    }
  return e;
}
function wr(e, t, n) {
  if (!(!e.element.contentWindow || !e.element.contentWindow.postMessage)) {
    var r = {
      method: t
    };
    n !== void 0 && (r.value = n);
    var o = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    o >= 8 && o < 10 && (r = JSON.stringify(r)), e.element.contentWindow.postMessage(r, e.origin);
  }
}
function rte(e, t) {
  t = Zs(t);
  var n = [], r;
  if (t.event) {
    if (t.event === "error") {
      var o = ps(e, t.data.method);
      o.forEach(function(a) {
        var s = new Error(t.data.message);
        s.name = t.data.name, a.reject(s), gs(e, t.data.method, a);
      });
    }
    n = ps(e, "event:".concat(t.event)), r = t.data;
  } else if (t.method) {
    var i = tte(e, t.method);
    i && (n.push(i), r = t.value);
  }
  n.forEach(function(a) {
    try {
      if (typeof a == "function") {
        a.call(e, r);
        return;
      }
      a.resolve(r);
    } catch (s) {
    }
  });
}
var ote = ["airplay", "audio_tracks", "audiotrack", "autopause", "autoplay", "background", "byline", "cc", "chapter_id", "chapters", "chromecast", "color", "colors", "controls", "dnt", "end_time", "fullscreen", "height", "id", "interactive_params", "keyboard", "loop", "maxheight", "maxwidth", "muted", "play_button_position", "playsinline", "portrait", "progress_bar", "quality_selector", "responsive", "speed", "start_time", "texttrack", "title", "transcript", "transparent", "unmute_button", "url", "vimeo_logo", "volume", "watch_full_video", "width"];
function v8(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return ote.reduce(function(n, r) {
    var o = e.getAttribute("data-vimeo-".concat(r));
    return (o || o === "") && (n[r] = o === "" ? 1 : o), n;
  }, t);
}
function rh(e, t) {
  var n = e.html;
  if (!t)
    throw new TypeError("An element must be provided");
  if (t.getAttribute("data-vimeo-initialized") !== null)
    return t.querySelector("iframe");
  var r = document.createElement("div");
  return r.innerHTML = n, t.appendChild(r.firstChild), t.setAttribute("data-vimeo-initialized", "true"), t.querySelector("iframe");
}
function b8(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function(r, o) {
    if (!Hr(e))
      throw new TypeError("“".concat(e, "” is not a vimeo.com url."));
    var i = Xee(e), a = "https://".concat(i, "/api/oembed.json?url=").concat(encodeURIComponent(e));
    for (var s in t)
      t.hasOwnProperty(s) && (a += "&".concat(s, "=").concat(encodeURIComponent(t[s])));
    var l = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
    l.open("GET", a, !0), l.onload = function() {
      if (l.status === 404) {
        o(new Error("“".concat(e, "” was not found.")));
        return;
      }
      if (l.status === 403) {
        o(new Error("“".concat(e, "” is not embeddable.")));
        return;
      }
      try {
        var u = JSON.parse(l.responseText);
        if (u.domain_status_code === 403) {
          rh(u, n), o(new Error("“".concat(e, "” is not embeddable.")));
          return;
        }
        r(u);
      } catch (m) {
        o(m);
      }
    }, l.onerror = function() {
      var u = l.status ? " (".concat(l.status, ")") : "";
      o(new Error("There was an error fetching the embed code from Vimeo".concat(u, ".")));
    }, l.send();
  });
}
function ite() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t = [].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), n = function(o) {
    "console" in window && console.error && console.error("There was an error creating an embed: ".concat(o));
  };
  t.forEach(function(r) {
    try {
      if (r.getAttribute("data-vimeo-defer") !== null)
        return;
      var o = v8(r), i = g8(o);
      b8(i, o, r).then(function(a) {
        return rh(a, r);
      }).catch(n);
    } catch (a) {
      n(a);
    }
  });
}
function ste() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var t = function(r) {
      if (Hr(r.origin) && !(!r.data || r.data.event !== "spacechange")) {
        for (var o = e.querySelectorAll("iframe"), i = 0; i < o.length; i++)
          if (o[i].contentWindow === r.source) {
            var a = o[i].parentElement;
            a.style.paddingBottom = "".concat(r.data.data[0].bottom, "px");
            break;
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function ate() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var t = function(r) {
      if (Hr(r.origin)) {
        var o = Zs(r.data);
        if (!(!o || o.event !== "ready"))
          for (var i = e.querySelectorAll("iframe"), a = 0; a < i.length; a++) {
            var s = i[a], l = s.contentWindow === r.source;
            if (p8(s.src) && l) {
              var u = new oh(s);
              u.callMethod("appendVideoMetadata", window.location.href);
            }
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function lte() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var t = function(o) {
      "console" in window && console.error && console.error("There was an error getting video Id: ".concat(o));
    }, n = function(o) {
      if (Hr(o.origin)) {
        var i = Zs(o.data);
        if (!(!i || i.event !== "ready"))
          for (var a = e.querySelectorAll("iframe"), s = function() {
            var m = a[l], v = m.contentWindow === o.source;
            if (p8(m.src) && v) {
              var g = new oh(m);
              g.getVideoId().then(function(h) {
                var E = new RegExp("[?&]vimeo_t_".concat(h, "=([^&#]*)")).exec(window.location.href);
                if (E && E[1]) {
                  var C = decodeURI(E[1]);
                  g.setCurrentTime(C);
                }
              }).catch(t);
            }
          }, l = 0; l < a.length; l++)
            s();
      }
    };
    window.addEventListener("message", n);
  }
}
function ute() {
  var e = function() {
    for (var r, o = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
      // New WebKit
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
      // Old WebKit
      ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
    ], i = 0, a = o.length, s = {}; i < a; i++)
      if (r = o[i], r && r[1] in document) {
        for (i = 0; i < r.length; i++)
          s[o[0][i]] = r[i];
        return s;
      }
    return !1;
  }(), t = {
    fullscreenchange: e.fullscreenchange,
    fullscreenerror: e.fullscreenerror
  }, n = {
    request: function(o) {
      return new Promise(function(i, a) {
        var s = function u() {
          n.off("fullscreenchange", u), i();
        };
        n.on("fullscreenchange", s), o = o || document.documentElement;
        var l = o[e.requestFullscreen]();
        l instanceof Promise && l.then(s).catch(a);
      });
    },
    exit: function() {
      return new Promise(function(o, i) {
        if (!n.isFullscreen) {
          o();
          return;
        }
        var a = function l() {
          n.off("fullscreenchange", l), o();
        };
        n.on("fullscreenchange", a);
        var s = document[e.exitFullscreen]();
        s instanceof Promise && s.then(a).catch(i);
      });
    },
    on: function(o, i) {
      var a = t[o];
      a && document.addEventListener(a, i);
    },
    off: function(o, i) {
      var a = t[o];
      a && document.removeEventListener(a, i);
    }
  };
  return Object.defineProperties(n, {
    isFullscreen: {
      get: function() {
        return !!document[e.fullscreenElement];
      }
    },
    element: {
      enumerable: !0,
      get: function() {
        return document[e.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function() {
        return !!document[e.fullscreenEnabled];
      }
    }
  }), n;
}
var dte = {
  role: "viewer",
  autoPlayMuted: !0,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
}, cte = /* @__PURE__ */ function(e) {
  Gee(n, e);
  var t = Zee(n);
  function n(r, o) {
    var i, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    return d8(this, n), i = t.call(this), Qi(es(i), "logger", void 0), Qi(es(i), "speedAdjustment", 0), Qi(es(i), "adjustSpeed", /* @__PURE__ */ function() {
      var l = Er(/* @__PURE__ */ Ct().mark(function u(m, v) {
        var g;
        return Ct().wrap(function(E) {
          for (; ; ) switch (E.prev = E.next) {
            case 0:
              if (i.speedAdjustment !== v) {
                E.next = 2;
                break;
              }
              return E.abrupt("return");
            case 2:
              return E.next = 4, m.getPlaybackRate();
            case 4:
              return E.t0 = E.sent, E.t1 = i.speedAdjustment, E.t2 = E.t0 - E.t1, E.t3 = v, g = E.t2 + E.t3, i.log("New playbackRate:  ".concat(g)), E.next = 12, m.setPlaybackRate(g);
            case 12:
              i.speedAdjustment = v;
            case 13:
            case "end":
              return E.stop();
          }
        }, u);
      }));
      return function(u, m) {
        return l.apply(this, arguments);
      };
    }()), i.logger = s, i.init(o, r, Zp(Zp({}, dte), a)), i;
  }
  return c8(n, [{
    key: "disconnect",
    value: function() {
      this.dispatchEvent(new Event("disconnect"));
    }
    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function() {
      var r = Er(/* @__PURE__ */ Ct().mark(function i(a, s, l) {
        var u = this, m, v, g;
        return Ct().wrap(function(E) {
          for (; ; ) switch (E.prev = E.next) {
            case 0:
              return E.next = 2, this.waitForTOReadyState(a, "open");
            case 2:
              if (l.role !== "viewer") {
                E.next = 10;
                break;
              }
              return E.next = 5, this.updatePlayer(a, s, l);
            case 5:
              m = Yp(a, "change", function() {
                return u.updatePlayer(a, s, l);
              }), v = this.maintainPlaybackPosition(a, s, l), this.addEventListener("disconnect", function() {
                v.cancel(), m.cancel();
              }), E.next = 14;
              break;
            case 10:
              return E.next = 12, this.updateTimingObject(a, s);
            case 12:
              g = Yp(s, ["seeked", "play", "pause", "ratechange"], function() {
                return u.updateTimingObject(a, s);
              }, "on", "off"), this.addEventListener("disconnect", function() {
                return g.cancel();
              });
            case 14:
            case "end":
              return E.stop();
          }
        }, i, this);
      }));
      function o(i, a, s) {
        return r.apply(this, arguments);
      }
      return o;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function() {
      var r = Er(/* @__PURE__ */ Ct().mark(function i(a, s) {
        return Ct().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.t0 = a, u.next = 3, s.getCurrentTime();
            case 3:
              return u.t1 = u.sent, u.next = 6, s.getPaused();
            case 6:
              if (!u.sent) {
                u.next = 10;
                break;
              }
              u.t2 = 0, u.next = 13;
              break;
            case 10:
              return u.next = 12, s.getPlaybackRate();
            case 12:
              u.t2 = u.sent;
            case 13:
              u.t3 = u.t2, u.t4 = {
                position: u.t1,
                velocity: u.t3
              }, u.t0.update.call(u.t0, u.t4);
            case 16:
            case "end":
              return u.stop();
          }
        }, i);
      }));
      function o(i, a) {
        return r.apply(this, arguments);
      }
      return o;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function() {
      var r = Er(/* @__PURE__ */ Ct().mark(function i(a, s, l) {
        var u, m, v;
        return Ct().wrap(function(h) {
          for (; ; ) switch (h.prev = h.next) {
            case 0:
              if (u = a.query(), m = u.position, v = u.velocity, typeof m == "number" && s.setCurrentTime(m), typeof v != "number") {
                h.next = 25;
                break;
              }
              if (v !== 0) {
                h.next = 11;
                break;
              }
              return h.next = 6, s.getPaused();
            case 6:
              if (h.t0 = h.sent, h.t0 !== !1) {
                h.next = 9;
                break;
              }
              s.pause();
            case 9:
              h.next = 25;
              break;
            case 11:
              if (!(v > 0)) {
                h.next = 25;
                break;
              }
              return h.next = 14, s.getPaused();
            case 14:
              if (h.t1 = h.sent, h.t1 !== !0) {
                h.next = 19;
                break;
              }
              return h.next = 18, s.play().catch(/* @__PURE__ */ function() {
                var E = Er(/* @__PURE__ */ Ct().mark(function C(A) {
                  return Ct().wrap(function(O) {
                    for (; ; ) switch (O.prev = O.next) {
                      case 0:
                        if (!(A.name === "NotAllowedError" && l.autoPlayMuted)) {
                          O.next = 5;
                          break;
                        }
                        return O.next = 3, s.setMuted(!0);
                      case 3:
                        return O.next = 5, s.play().catch(function(F) {
                          return console.error("Couldn't play the video from TimingSrcConnector. Error:", F);
                        });
                      case 5:
                      case "end":
                        return O.stop();
                    }
                  }, C);
                }));
                return function(C) {
                  return E.apply(this, arguments);
                };
              }());
            case 18:
              this.updatePlayer(a, s, l);
            case 19:
              return h.next = 21, s.getPlaybackRate();
            case 21:
              if (h.t2 = h.sent, h.t3 = v, h.t2 === h.t3) {
                h.next = 25;
                break;
              }
              s.setPlaybackRate(v);
            case 25:
            case "end":
              return h.stop();
          }
        }, i, this);
      }));
      function o(i, a, s) {
        return r.apply(this, arguments);
      }
      return o;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function(o, i, a) {
      var s = this, l = a.allowedDrift, u = a.maxAllowedDrift, m = a.minCheckInterval, v = a.maxRateAdjustment, g = a.maxTimeToCatchUp, h = Math.min(g, Math.max(m, u)) * 1e3, E = /* @__PURE__ */ function() {
        var A = Er(/* @__PURE__ */ Ct().mark(function R() {
          var O, F, L, D, P;
          return Ct().wrap(function(q) {
            for (; ; ) switch (q.prev = q.next) {
              case 0:
                if (q.t0 = o.query().velocity === 0, q.t0) {
                  q.next = 6;
                  break;
                }
                return q.next = 4, i.getPaused();
              case 4:
                q.t1 = q.sent, q.t0 = q.t1 === !0;
              case 6:
                if (!q.t0) {
                  q.next = 8;
                  break;
                }
                return q.abrupt("return");
              case 8:
                return q.t2 = o.query().position, q.next = 11, i.getCurrentTime();
              case 11:
                if (q.t3 = q.sent, O = q.t2 - q.t3, F = Math.abs(O), s.log("Drift: ".concat(O)), !(F > u)) {
                  q.next = 22;
                  break;
                }
                return q.next = 18, s.adjustSpeed(i, 0);
              case 18:
                i.setCurrentTime(o.query().position), s.log("Resync by currentTime"), q.next = 29;
                break;
              case 22:
                if (!(F > l)) {
                  q.next = 29;
                  break;
                }
                return L = F / g, D = v, P = L < D ? (D - L) / 2 : D, q.next = 28, s.adjustSpeed(i, P * Math.sign(O));
              case 28:
                s.log("Resync by playbackRate");
              case 29:
              case "end":
                return q.stop();
            }
          }, R);
        }));
        return function() {
          return A.apply(this, arguments);
        };
      }(), C = setInterval(function() {
        return E();
      }, h);
      return {
        cancel: function() {
          return clearInterval(C);
        }
      };
    }
    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function(o) {
      var i;
      (i = this.logger) === null || i === void 0 || i.call(this, "TimingSrcConnector: ".concat(o));
    }
  }, {
    key: "waitForTOReadyState",
    value: (
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function(o, i) {
        return new Promise(function(a) {
          var s = function l() {
            o.readyState === i ? a() : o.addEventListener("readystatechange", l, {
              once: !0
            });
          };
          s();
        });
      }
    )
  }]), n;
}(/* @__PURE__ */ Qc(EventTarget)), eo = /* @__PURE__ */ new WeakMap(), gc = /* @__PURE__ */ new WeakMap(), Dt = {}, oh = /* @__PURE__ */ function() {
  function e(t) {
    var n = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (d8(this, e), window.jQuery && t instanceof jQuery && (t.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), t = t[0]), typeof document != "undefined" && typeof t == "string" && (t = document.getElementById(t)), !Wee(t))
      throw new TypeError("You must pass either a valid element or a valid id.");
    if (t.nodeName !== "IFRAME") {
      var o = t.querySelector("iframe");
      o && (t = o);
    }
    if (t.nodeName === "IFRAME" && !Hr(t.getAttribute("src") || ""))
      throw new Error("The player element passed isn’t a Vimeo embed.");
    if (eo.has(t))
      return eo.get(t);
    this._window = t.ownerDocument.defaultView, this.element = t, this.origin = "*";
    var i = new Qt(function(s, l) {
      if (n._onMessage = function(v) {
        if (!(!Hr(v.origin) || n.element.contentWindow !== v.source)) {
          n.origin === "*" && (n.origin = v.origin);
          var g = Zs(v.data), h = g && g.event === "error", E = h && g.data && g.data.method === "ready";
          if (E) {
            var C = new Error(g.data.message);
            C.name = g.data.name, l(C);
            return;
          }
          var A = g && g.event === "ready", R = g && g.method === "ping";
          if (A || R) {
            n.element.setAttribute("data-ready", "true"), s();
            return;
          }
          rte(n, g);
        }
      }, n._window.addEventListener("message", n._onMessage), n.element.nodeName !== "IFRAME") {
        var u = v8(t, r), m = g8(u);
        b8(m, u, t).then(function(v) {
          var g = rh(v, t);
          return n.element = g, n._originalElement = t, nte(t, g), eo.set(n.element, n), v;
        }).catch(l);
      }
    });
    if (gc.set(this, i), eo.set(this.element, this), this.element.nodeName === "IFRAME" && wr(this, "ping"), Dt.isEnabled) {
      var a = function() {
        return Dt.exit();
      };
      this.fullscreenchangeHandler = function() {
        Dt.isFullscreen ? qo(n, "event:exitFullscreen", a) : gs(n, "event:exitFullscreen", a), n.ready().then(function() {
          wr(n, "fullscreenchange", Dt.isFullscreen);
        });
      }, Dt.on("fullscreenchange", this.fullscreenchangeHandler);
    }
    return this;
  }
  return c8(e, [{
    key: "callMethod",
    value: function(n) {
      var r = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return new Qt(function(i, a) {
        return r.ready().then(function() {
          qo(r, n, {
            resolve: i,
            reject: a
          }), wr(r, n, o);
        }).catch(a);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function(n) {
      var r = this;
      return new Qt(function(o, i) {
        return n = Wp(n, "get"), r.ready().then(function() {
          qo(r, n, {
            resolve: o,
            reject: i
          }), wr(r, n);
        }).catch(i);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function(n, r) {
      var o = this;
      return new Qt(function(i, a) {
        if (n = Wp(n, "set"), r == null)
          throw new TypeError("There must be a value to set.");
        return o.ready().then(function() {
          qo(o, n, {
            resolve: i,
            reject: a
          }), wr(o, n, r);
        }).catch(a);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (!r)
        throw new TypeError("You must pass a callback function.");
      if (typeof r != "function")
        throw new TypeError("The callback must be a function.");
      var o = ps(this, "event:".concat(n));
      o.length === 0 && this.callMethod("addEventListener", n).catch(function() {
      }), qo(this, "event:".concat(n), r);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (r && typeof r != "function")
        throw new TypeError("The callback must be a function.");
      var o = gs(this, "event:".concat(n), r);
      o && this.callMethod("removeEventListener", n).catch(function(i) {
      });
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function(n) {
      return this.callMethod("loadVideo", n);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function() {
      var n = gc.get(this) || new Qt(function(r, o) {
        o(new Error("Unknown player. Probably unloaded."));
      });
      return Qt.resolve(n);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.callMethod("addCuePoint", {
        time: n,
        data: r
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function(n) {
      return this.callMethod("removeCuePoint", n);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass a language.");
      return this.callMethod("enableTextTrack", {
        language: n,
        kind: r
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function() {
      return this.callMethod("disableTextTrack");
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function() {
      return this.callMethod("pause");
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function() {
      return this.callMethod("play");
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function() {
      return Dt.isEnabled ? Dt.request(this.element) : this.callMethod("requestFullscreen");
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function() {
      return Dt.isEnabled ? Dt.exit() : this.callMethod("exitFullscreen");
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function() {
      return Dt.isEnabled ? Qt.resolve(Dt.isFullscreen) : this.get("fullscreen");
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function() {
      return this.callMethod("requestPictureInPicture");
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function() {
      return this.callMethod("exitPictureInPicture");
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function() {
      return this.get("pictureInPicture");
    }
    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function() {
      return this.callMethod("remotePlaybackPrompt");
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function() {
      return this.callMethod("unload");
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function() {
      var n = this;
      return new Qt(function(r) {
        if (gc.delete(n), eo.delete(n.element), n._originalElement && (eo.delete(n._originalElement), n._originalElement.removeAttribute("data-vimeo-initialized")), n.element && n.element.nodeName === "IFRAME" && n.element.parentNode && (n.element.parentNode.parentNode && n._originalElement && n._originalElement !== n.element.parentNode ? n.element.parentNode.parentNode.removeChild(n.element.parentNode) : n.element.parentNode.removeChild(n.element)), n.element && n.element.nodeName === "DIV" && n.element.parentNode) {
          n.element.removeAttribute("data-vimeo-initialized");
          var o = n.element.querySelector("iframe");
          o && o.parentNode && (o.parentNode.parentNode && n._originalElement && n._originalElement !== o.parentNode ? o.parentNode.parentNode.removeChild(o.parentNode) : o.parentNode.removeChild(o));
        }
        n._window.removeEventListener("message", n._onMessage), Dt.isEnabled && Dt.off("fullscreenchange", n.fullscreenchangeHandler), r();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function() {
      return this.get("autopause");
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function(n) {
      return this.set("autopause", n);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function() {
      return this.get("buffered");
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function() {
      return this.get("cameraProps");
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function(n) {
      return this.set("cameraProps", n);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function() {
      return this.get("chapters");
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function() {
      return this.get("currentChapter");
    }
    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function() {
      return this.get("color");
    }
    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function() {
      return Qt.all([this.get("colorOne"), this.get("colorTwo"), this.get("colorThree"), this.get("colorFour")]);
    }
    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function(n) {
      return this.set("color", n);
    }
    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function(n) {
      if (!Array.isArray(n))
        return new Qt(function(i, a) {
          return a(new TypeError("Argument must be an array."));
        });
      var r = new Qt(function(i) {
        return i(null);
      }), o = [n[0] ? this.set("colorOne", n[0]) : r, n[1] ? this.set("colorTwo", n[1]) : r, n[2] ? this.set("colorThree", n[2]) : r, n[3] ? this.set("colorFour", n[3]) : r];
      return Qt.all(o);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function() {
      return this.get("cuePoints");
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return this.get("currentTime");
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function(n) {
      return this.set("currentTime", n);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function() {
      return this.get("duration");
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function() {
      return this.get("ended");
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function() {
      return this.get("loop");
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function(n) {
      return this.set("loop", n);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function(n) {
      return this.set("muted", n);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function() {
      return this.get("muted");
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function() {
      return this.get("paused");
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function() {
      return this.get("playbackRate");
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function(n) {
      return this.set("playbackRate", n);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function() {
      return this.get("played");
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function() {
      return this.get("qualities");
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function() {
      return this.get("quality");
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function(n) {
      return this.set("quality", n);
    }
    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function() {
      return this.get("remotePlaybackAvailability");
    }
    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function() {
      return this.get("remotePlaybackState");
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function() {
      return this.get("seekable");
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function() {
      return this.get("seeking");
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function() {
      return this.get("textTracks");
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function() {
      return this.get("videoEmbedCode");
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function() {
      return this.get("videoId");
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function() {
      return this.get("videoTitle");
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function() {
      return this.get("videoWidth");
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function() {
      return this.get("videoHeight");
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function() {
      return this.get("videoUrl");
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function() {
      return this.get("volume");
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function(n) {
      return this.set("volume", n);
    }
    /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */
    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function() {
      var t = Er(/* @__PURE__ */ Ct().mark(function r(o, i) {
        var a = this, s;
        return Ct().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (o) {
                u.next = 2;
                break;
              }
              throw new TypeError("A Timing Object must be provided.");
            case 2:
              return u.next = 4, this.ready();
            case 4:
              return s = new cte(this, o, i), wr(this, "notifyTimingObjectConnect"), s.addEventListener("disconnect", function() {
                return wr(a, "notifyTimingObjectDisconnect");
              }), u.abrupt("return", s);
            case 8:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r, o) {
        return t.apply(this, arguments);
      }
      return n;
    }()
  }]), e;
}();
f8 || (Dt = ute(), ite(), ste(), ate(), lte());
const hte = {
  name: "VideoPlayer",
  props: {
    url: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    typeVideo: {
      type: String,
      default: ""
    },
    elementId: {
      type: String,
      default: "playerVideo"
    },
    autoplay: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      player: {
        vimeo: null,
        youtube: null
      }
    };
  },
  watch: {
    async url() {
      if (this.player.vimeo)
        try {
          await this.player.vimeo.destroy(), this.player.vimeo = null;
        } catch (e) {
          console.error("Error destroying ");
        }
      else this.player.youtube && (this.player.youtube.destroy(), this.player.youtube = null);
      this.typeVideo === "vimeo" ? this.loadVimeoPlayer() : this.loadYoutubePlayer();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.typeVideo === "vimeo" ? this.loadVimeoPlayer() : this.loadYoutubePlayer();
    });
  },
  created() {
    this.$nextTick(() => {
      this.setStylesToIFrame();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.setStylesToIFrame();
    });
  },
  methods: {
    createVimeoPlayer() {
      return !this.$refs[this.elementId] || !this.$refs[this.elementId].id ? !1 : (this.player.vimeo = new oh(this.$refs[this.elementId], {
        url: this.url,
        responsive: !0
      }), this.player.vimeo.on("play", () => {
        this.$emit("eventToEmit", { id: this.id, isPlaying: !0 });
      }), this.player.vimeo.on("pause", () => {
        this.$emit("eventToEmit", { id: this.id, isPlaying: !1 });
      }), !0);
    },
    createYoutubePlayer() {
      return !this.$refs[this.elementId] || !this.$refs[this.elementId].id ? !1 : (this.player.youtube = new Uee(this.$refs[this.elementId]), this.player.youtube.on("paused", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !1,
          elementId: this.elementId
        });
      }), this.player.youtube.on("ended", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !1,
          elementId: this.elementId
        });
      }), this.player.youtube.on("playing", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !0,
          elementId: this.elementId
        });
      }), !0);
    },
    loadVimeoPlayer() {
      !this.player.vimeo && !this.createVimeoPlayer() || (this.player.vimeo.loadVideo(this.url), this.player.vimeo.play());
    },
    loadYoutubePlayer() {
      !this.player.youtube && !this.createYoutubePlayer() || (this.player.youtube.load(this.id, this.autoplay), this.setStylesToIFrame());
    },
    setStylesToIFrame() {
      const e = this.$refs[this.elementId];
      e && (e.style.left = "0", e.style.top = "0", e.style.width = "100%", e.style.height = "100%", e.style.position = "absolute");
    }
  }
}, mte = {
  class: "video-player",
  "data-testid": "video-player"
}, fte = ["id"];
function pte(e, t, n, r, o, i) {
  return d(), f("div", mte, [
    c("div", {
      id: n.elementId,
      ref: n.elementId
    }, null, 8, fte)
  ]);
}
const y8 = /* @__PURE__ */ B(hte, [["render", pte], ["__scopeId", "data-v-5fa63831"]]), gte = {
  name: "V1",
  components: {
    VideoPlayer: y8
  },
  mixins: [nh],
  props: {
    componentId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    prevItem() {
      let e = this.activeItem - 1;
      return e < 0 && (e = this.videoItems.length - 1), this.videoItems[e];
    },
    nextItem() {
      let e = this.activeItem + 1;
      return e >= this.videoItems.length && (e = 0), this.videoItems[e];
    }
  },
  methods: {
    activateItem(e) {
      this.readMoreOpen = !1, this.activeItem = e, this.$emit("setCurrentVideoThrillshare", e);
    },
    activateNext() {
      let e = this.activeItem + 1;
      e >= this.videoItems.length && (e = 0), this.activateItem(e);
    },
    activatePrev() {
      let e = this.activeItem - 1;
      e < 0 && (e = this.videoItems.length - 1), this.activateItem(e);
    },
    readMoreToggle() {
      this.readMoreOpen = !this.readMoreOpen;
    },
    isOverflow() {
      this.$nextTick(() => this.$refs.description.offsetHeight < this.$refs.description.scrollHeight || this.$refs.description.offsetWidth < this.$refs.description.scrollWidth);
    }
  }
}, vte = ["data-testid"], bte = ["data-testid"], yte = { class: "video-wrapper" }, _te = {
  key: 0,
  class: "thumbnail"
}, Cte = ["src"], wte = { class: "buttons" }, Tte = ["aria-label"], kte = ["aria-label"], Ete = { class: "mirrors" }, Ste = { class: "prev" }, Mte = { class: "thumbnail" }, Ate = ["src"], Ite = { class: "title" }, Lte = { class: "next" }, Dte = { class: "thumbnail" }, $te = ["src"], Ote = { class: "title" }, Pte = { class: "video-info" }, Nte = {
  class: "title",
  "data-testid": "title"
}, Hte = {
  key: 1,
  class: "dots"
}, Fte = ["onClick"], Rte = {
  key: 2,
  class: "buttons"
}, Vte = ["aria-label"], Bte = ["aria-label"];
function jte(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("VideoPlayer");
  return d(), f("div", {
    id: "video-component",
    class: _(e.theme.style),
    style: Z(e.colors),
    "data-testid": "V1"
  }, [
    e.content.show_headline ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`,
          class: "no-border"
        }, [
          e.displayTopHeader ? (d(), f("span", {
            key: 0,
            class: "header-top",
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.content.component_header_top), 1)
            ], !0)
          ], 8, bte)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.content.headline), 1)
          ], !0)
        ], 8, vte)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : T("", !0),
    c("div", yte, [
      c("div", {
        class: "video",
        tabindex: "0",
        onKeyup: [
          t[0] || (t[0] = K((...l) => i.activateNext && i.activateNext(...l), ["right"])),
          t[1] || (t[1] = K((...l) => i.activatePrev && i.activatePrev(...l), ["left"]))
        ]
      }, [
        M(e.$slots, "delete-btn", {
          index: e.currentItem.position
        }, void 0, !0),
        M(e.$slots, `video-item-${e.currentItem.position}`, {}, () => [
          e.isPlaceholder ? (d(), f("div", _te, [
            c("img", {
              src: e.currentItem.thumbnail,
              alt: "",
              "data-testid": "current-image"
            }, null, 8, Cte)
          ])) : (d(), I(s, {
            key: 1,
            id: e.currentItem.videoId,
            ref: "main-video-player",
            "element-id": `${n.componentId}-main-video-player`,
            "video-id": e.currentItem.videoId,
            "type-video": e.currentItem.type,
            url: e.currentItem.url,
            autoplay: !1,
            responsive: !0,
            class: "player",
            onEventToEmit: e.setIsPlaying
          }, null, 8, ["id", "element-id", "video-id", "type-video", "url", "onEventToEmit"]))
        ], !0)
      ], 32),
      e.isDesktop && e.videoItems.length > 1 ? (d(), f(J, { key: 0 }, [
        c("div", wte, [
          c("button", {
            class: "prev",
            "aria-label": e.translations.left_arrow || "Previous Video",
            onClick: t[2] || (t[2] = (...l) => i.activatePrev && i.activatePrev(...l)),
            onKeyup: t[3] || (t[3] = K((...l) => i.activatePrev && i.activatePrev(...l), ["left"]))
          }, t[11] || (t[11] = [
            c("div", { class: "icon" }, null, -1)
          ]), 40, Tte),
          c("button", {
            class: "next",
            "aria-label": e.translations.right_arrow || "Next Video",
            onClick: t[4] || (t[4] = (...l) => i.activateNext && i.activateNext(...l)),
            onKeyup: t[5] || (t[5] = K((...l) => i.activateNext && i.activateNext(...l), ["right"]))
          }, t[12] || (t[12] = [
            c("div", { class: "icon" }, null, -1)
          ]), 40, kte)
        ]),
        c("div", Ete, [
          c("div", Ste, [
            M(e.$slots, `video-item-${i.prevItem.position}`, {}, () => [
              c("div", Mte, [
                c("img", {
                  src: i.prevItem.thumbnail,
                  alt: "",
                  "data-testid": "previous-image"
                }, null, 8, Ate)
              ]),
              c("div", Ite, k(i.prevItem.title), 1)
            ], !0)
          ]),
          c("div", Lte, [
            M(e.$slots, `video-item-${i.nextItem.position}`, {}, () => [
              c("div", Dte, [
                c("img", {
                  src: i.nextItem.thumbnail,
                  alt: "",
                  "data-testid": "next-image"
                }, null, 8, $te)
              ]),
              c("div", Ote, k(i.nextItem.title), 1)
            ], !0)
          ])
        ])
      ], 64)) : T("", !0)
    ]),
    c("div", Pte, [
      M(e.$slots, "main-video-alt-text", {
        index: e.currentItem.position
      }, void 0, !0),
      c("div", Nte, [
        M(e.$slots, "main-video-title", {
          index: e.currentItem.position
        }, () => [
          H(k(e.currentItem.title), 1)
        ], !0)
      ]),
      c("div", {
        ref: "description",
        class: _(["description", { more: e.readMoreOpen }]),
        "data-testid": "description"
      }, [
        M(e.$slots, "main-video-description", {
          index: e.currentItem.position
        }, () => [
          H(k(e.currentItem.description), 1)
        ], !0)
      ], 2),
      i.isOverflow ? (d(), f("button", {
        key: 0,
        class: "read-more",
        onClick: t[6] || (t[6] = (...l) => i.readMoreToggle && i.readMoreToggle(...l))
      }, k(e.readMoreOpen ? "Read less" : "Read more"), 1)) : T("", !0)
    ]),
    e.videoItems.length > 1 ? (d(), f("div", Hte, [
      (d(!0), f(J, null, ne(e.videoItems, (l, u) => (d(), f("div", {
        id: "dot-item",
        key: l.id,
        class: _(["dot", e.activeItem == u ? "active" : ""]),
        onClick: (m) => i.activateItem(u)
      }, null, 10, Fte))), 128))
    ])) : T("", !0),
    !e.isDesktop && e.videoItems.length > 1 ? (d(), f("div", Rte, [
      c("button", {
        class: "prev",
        "aria-label": e.translations.left_arrow || "Previous Video",
        onClick: t[7] || (t[7] = (...l) => i.activatePrev && i.activatePrev(...l)),
        onKeyup: t[8] || (t[8] = K((...l) => i.activatePrev && i.activatePrev(...l), ["left"]))
      }, t[13] || (t[13] = [
        c("div", { class: "icon" }, null, -1)
      ]), 40, Vte),
      c("button", {
        class: "next",
        "aria-label": e.translations.right_arrow || "Next Video",
        onClick: t[9] || (t[9] = (...l) => i.activateNext && i.activateNext(...l)),
        onKeyup: t[10] || (t[10] = K((...l) => i.activateNext && i.activateNext(...l), ["right"]))
      }, t[14] || (t[14] = [
        c("div", { class: "icon" }, null, -1)
      ]), 40, Bte)
    ])) : T("", !0)
  ], 6);
}
const Ute = /* @__PURE__ */ B(gte, [["render", jte], ["__scopeId", "data-v-860fbe66"]]), qte = {
  name: "V2",
  components: {
    VideoPlayer: y8
  },
  mixins: [nh],
  props: {
    componentId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    activateItem(e) {
      this.activeItem = e, this.playPause(`${this.componentId}-main-video-player`, this.currentItem.type), this.$emit("setCurrentVideoThrillshare", e);
    }
  }
}, Gte = ["data-testid"], Kte = ["data-testid"], zte = { class: "wrapper" }, Zte = ["aria-label"], xte = { class: "video" }, Wte = {
  key: 0,
  class: "thumbnail"
}, Yte = ["src"], Xte = { class: "video-info" }, Qte = {
  class: "title",
  "data-testid": "title"
}, Jte = {
  ref: "description",
  class: "description",
  "data-testid": "description"
}, ene = {
  key: 1,
  class: "sidebar"
}, tne = ["id", "alert-label", "onClick", "onKeyup"], nne = { class: "video" }, rne = {
  class: "secondary-title",
  "data-testid": "title"
}, one = { class: "thumbnail" }, ine = ["src"], sne = {
  key: 0,
  class: "info"
}, ane = { class: "title" }, lne = { class: "description" };
function une(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("VideoPlayer");
  return d(), f("div", {
    id: "video-component",
    class: _(e.theme.style),
    style: Z(e.colors),
    "data-testid": "V2"
  }, [
    e.content.show_headline ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`,
          class: "no-border"
        }, [
          e.displayTopHeader ? (d(), f("span", {
            key: 0,
            class: "header-top",
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.content.component_header_top), 1)
            ], !0)
          ], 8, Kte)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.content.headline), 1)
          ], !0)
        ], 8, Gte)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : T("", !0),
    c("div", zte, [
      e.isDesktop || e.videoItems.length === 1 ? (d(), f("div", {
        key: 0,
        class: "main-video",
        tabindex: "0",
        "aria-label": `${e.translations.video_player || "Video player"}: ${e.currentItem.alt_text}`,
        role: "region"
      }, [
        c("div", xte, [
          M(e.$slots, "delete-btn", {
            index: e.currentItem.position
          }, void 0, !0),
          M(e.$slots, `video-item-${e.currentItem.position}`, {}, () => [
            e.isPlaceholder ? (d(), f("div", Wte, [
              c("img", {
                src: e.currentItem.thumbnail,
                alt: "",
                "data-testid": "current-item"
              }, null, 8, Yte)
            ])) : (d(), I(s, {
              key: 1,
              id: e.currentItem.videoId,
              ref: "main-video-player",
              class: "player",
              "element-id": `${n.componentId}-main-video-player`,
              "video-id": e.currentItem.videoId,
              "type-video": e.currentItem.type,
              url: e.currentItem.url,
              autoplay: !1,
              responsive: !0,
              onEventToEmit: e.setIsPlaying
            }, null, 8, ["id", "element-id", "video-id", "type-video", "url", "onEventToEmit"]))
          ], !0)
        ]),
        c("div", Xte, [
          M(e.$slots, "main-video-alt-text", {
            altText: e.currentItem.alt_text,
            index: e.currentItem.position
          }, void 0, !0),
          c("div", Qte, [
            M(e.$slots, "main-video-title", {
              index: e.currentItem.position
            }, () => [
              H(k(e.currentItem.title), 1)
            ], !0)
          ]),
          c("div", Jte, [
            M(e.$slots, "main-video-description", {
              index: e.currentItem.position
            }, () => [
              H(k(e.currentItem.description), 1)
            ], !0)
          ], 512)
        ])
      ], 8, Zte)) : T("", !0),
      e.videoItems.length > 1 ? (d(), f("div", ene, [
        (d(!0), f(J, null, ne(e.videoItems, (l, u) => (d(), f("div", {
          id: `sidebar-item-${u}`,
          key: l.id,
          tabindex: 0,
          role: "button",
          class: _(["sidebar-item", e.activeItem === u && "active"]),
          "alert-label": `${e.translations.display_video || "Display video"}: ${l.alt_text}`,
          onClick: (m) => i.activateItem(u),
          onKeyup: K((m) => i.activateItem(u), ["enter"]),
          "on:eventToEmit": t[0] || (t[0] = (...m) => e.setIsPlaying && e.setIsPlaying(...m))
        }, [
          c("div", nne, [
            M(e.$slots, "delete-btn", {
              index: l.position
            }, void 0, !0),
            M(e.$slots, `video-item-${l.position}`, {}, () => [
              c("div", {
                class: _(["video-mask", e.activeItem === u && !e.isDesktop && "hidden"])
              }, [
                c("div", {
                  class: _(["button", e.isPlaying && e.activeItem === u ? "pause" : "play"])
                }, null, 2),
                c("div", rne, k(l.title), 1),
                c("div", one, [
                  c("img", {
                    src: l.thumbnail,
                    alt: ""
                  }, null, 8, ine)
                ])
              ], 2)
            ], !0),
            e.isDesktop ? T("", !0) : (d(), I(s, {
              key: 0,
              id: l.videoId,
              ref_for: !0,
              ref: `video-player-${u}`,
              class: "player",
              "video-id": l.videoId,
              "type-video": l.type,
              url: l.url,
              autoplay: !1,
              responsive: !0,
              "element-id": `${n.componentId}-video-player-${u}`,
              onEventToEmit: e.setIsPlaying
            }, null, 8, ["id", "video-id", "type-video", "url", "element-id", "onEventToEmit"]))
          ]),
          e.isDesktop ? T("", !0) : (d(), f("div", sne, [
            c("div", ane, k(l.title), 1),
            c("div", lne, k(l.description), 1)
          ]))
        ], 42, tne))), 128))
      ])) : T("", !0)
    ])
  ], 6);
}
const dne = /* @__PURE__ */ B(qte, [["render", une], ["__scopeId", "data-v-4b61d270"]]), cne = {
  name: "CmsVideo",
  components: {
    V1: Ute,
    V2: dne
  },
  mixins: [nh],
  data() {
    return {
      componentId: Math.floor(Math.random() * 1e5)
    };
  }
}, hne = { id: "view-video" };
function mne(e, t, n, r, o, i) {
  return d(), f("div", hne, [
    (d(), I(Y(e.theme.version), {
      theme: e.theme,
      content: e.content,
      "is-editing": e.isEditing,
      "component-id": o.componentId,
      "is-placeholder": e.isPlaceholder,
      "video-slots-items": e.videoSlotsItems,
      "current-video-thrillshare": e.currentVideoThrillshare,
      onSetCurrentVideoThrillshare: t[0] || (t[0] = (a) => e.$emit("setCurrentVideoThrillshare", a)),
      onDeleteVideo: t[1] || (t[1] = (a) => {
        e.$emit("deleteVideo", a);
      })
    }, ng({
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      "main-video-description": S(({ index: a }) => [
        M(e.$slots, "main-video-description", { index: a }, void 0, !0)
      ]),
      "main-video-title": S(({ index: a }) => [
        M(e.$slots, "main-video-title", { index: a }, void 0, !0)
      ]),
      "main-video-alt-text": S(({ index: a }) => [
        M(e.$slots, "main-video-alt-text", { index: a }, void 0, !0)
      ]),
      "delete-btn": S(({ index: a }) => [
        M(e.$slots, "delete-btn", { index: a }, void 0, !0)
      ]),
      "main-video-slot": S(({ index: a }) => [
        M(e.$slots, "main-video-slot", { index: a }, void 0, !0)
      ]),
      _: 2
    }, [
      ne(e.videoSlotsItems, (a) => ({
        name: a.name,
        fn: S(() => [
          M(e.$slots, a.name, {
            index: a.index
          }, void 0, !0)
        ])
      }))
    ]), 1064, ["theme", "content", "is-editing", "component-id", "is-placeholder", "video-slots-items", "current-video-thrillshare"]))
  ]);
}
const fne = /* @__PURE__ */ B(cne, [["render", mne], ["__scopeId", "data-v-e4f3e80d"]]), Ci = {
  mixins: [kt],
  components: { DraggableWrapper: vt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    spotlights: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  },
  computed: {
    colors() {
      var t, n;
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--bg-color": $(this.theme, "bg_color.hex", "#fff"),
        "--top-heading-color": $(this.theme, "top_heading_color.hex", "#000000"),
        "--quote-color": $(this.theme, "quote_color.hex", "#000"),
        "--name-color": $(this.theme, "name_color.hex", "#000"),
        "--arrow-icon-color": $(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "initial"),
        "--arrow-background-opacity": `${(t = this.theme.arrow_background_opacity) != null ? t : "0"}%`,
        "--arrow-border-color": $(this.theme, "arrow_border_color.hex", "initial"),
        "--image-border-color": $(
          this.theme,
          "image_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--textarea-border-color": $(this.theme, "textarea_border_color.hex", "#00000014"),
        "--textarea-border-accent-color": $(
          this.theme,
          "textarea_border_accent_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--percentage-button-opacity": `${(n = this.theme.percentage_button_opacity) != null ? n : "0"}%`
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.spotlights.component_header_top || this.isEditing);
    },
    isLightStyle() {
      return this.theme.style === "light";
    },
    isBoldStyle() {
      return this.theme.style === "bold";
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    isMobile() {
      return this.screenSize < 600;
    },
    isDesktop() {
      return this.screenSize >= 960;
    }
  }
}, pne = {
  props: {
    spotlight: {
      type: Object,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    },
    showName: {
      type: Boolean,
      default: !0
    },
    withSlider: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      sliderClass: this.withSlider ? "with-slider" : "no-slider"
    };
  }
}, gne = ["src", "alt"], vne = {
  key: 1,
  class: "no-image"
}, bne = {
  class: "spotlight-text",
  "data-testid": "spotlight-text"
}, yne = { key: 0 };
function _ne(e, t, n, r, o, i) {
  return d(), f("div", {
    class: _(o.sliderClass)
  }, [
    M(e.$slots, "controls"),
    c("div", {
      class: _(["spotlight-image rounded-image", o.sliderClass])
    }, [
      M(e.$slots, "image", {}, () => [
        n.spotlight.image.url ? (d(), f("img", {
          key: 0,
          src: n.spotlight.image.url,
          alt: n.spotlight.image.alt_text,
          class: "rounded-image",
          "data-testid": "spotlight-accent-border",
          loading: "lazy"
        }, null, 8, gne)) : (d(), f("div", vne))
      ])
    ], 2),
    c("div", bne, [
      c("div", {
        class: _(["spotlight-quote", [n.theme.style, o.sliderClass]])
      }, [
        c("p", null, [
          M(e.$slots, "quote", {}, () => [
            H(k(n.spotlight.quote), 1)
          ])
        ])
      ], 2),
      n.showName ? (d(), f("div", {
        key: 0,
        class: _(["spotlight-author", o.sliderClass]),
        "data-testid": "spotlight-author-name"
      }, [
        c("p", null, [
          n.spotlight.quote.length > 0 && n.spotlight.author.length > 0 ? (d(), f("span", yne, "- ")) : T("", !0),
          M(e.$slots, "author", {}, () => [
            H(k(n.spotlight.author), 1)
          ])
        ])
      ], 2)) : T("", !0)
    ])
  ], 2);
}
const Cne = /* @__PURE__ */ B(pne, [["render", _ne], ["__scopeId", "data-v-8ecd974d"]]), wne = {
  name: "SL1",
  components: { Slider: eh, SpotlightCard: Cne },
  mixins: [Ci, bt],
  computed: {
    content() {
      return this.spotlights.content;
    },
    showSlider() {
      return this.spotlights.show_slider && !this.isEditing;
    },
    sliderCenterSize() {
      return 599;
    }
  }
}, Tne = { key: 0 }, kne = ["data-testid"], Ene = { class: "cards-slider-container" }, Sne = ["aria-label"];
function Mne(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("SpotlightCard"), l = V("Slider"), u = Ke("touch");
  return d(), f("div", {
    id: "SL1",
    class: _(e.theme.style),
    style: Z(e.colors)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.displayHeaderTop ? (d(), f("h3", Tne, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.spotlights.component_header_top), 1)
          ], !0)
        ])) : T("", !0),
        c("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header", {}, () => [
            H(k(e.spotlights.component_header), 1)
          ], !0)
        ], 8, kne)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), I(Y(i.showSlider ? "div" : e.wrapperComponent), Se({
      modelValue: e.spotlights.content,
      "onUpdate:modelValue": t[0] || (t[0] = (m) => e.spotlights.content = m)
    }, e.wrapperProps, {
      class: [{ editing: e.isEditing, "no-slider": !i.showSlider }, "spotlights-content"],
      "item-key": "id"
    }), ng({
      default: S(() => [
        i.showSlider ? (d(), I(l, {
          key: 0,
          "total-cards": i.content.length,
          "current-card": e.currentCard,
          "all-cards-visible": e.allCardsVisible,
          "section-header": e.spotlights.component_header,
          "hide-x-small": !1,
          "theme-styles": e.theme,
          class: "slider-container",
          "data-testid": "spotlight-slider",
          onScrollRight: e.scrollRight,
          onScrollLeft: e.scrollLeft
        }, {
          default: S(() => [
            c("div", {
              ref: "scrollWrapper",
              class: _([{ "all-cards-visible": e.allCardsVisible }, "cards-slider-content"]),
              "item-key": "index"
            }, [
              c("div", Ene, [
                (d(!0), f(J, null, ne(e.spotlights.content, (m, v) => we((d(), f("div", {
                  ref_for: !0,
                  ref: `sliderCard-${v}`,
                  key: v,
                  class: _(["spotlight with-slider", { "is-editing": e.isEditing }]),
                  "aria-label": `${v + 1} of ${e.spotlights.content.length}`,
                  role: "group",
                  "aria-roledescription": "slide",
                  "data-testid": "spotlights-content-item"
                }, [
                  j(s, {
                    theme: e.theme,
                    spotlight: m,
                    "show-name": e.spotlights.show_name,
                    "with-slider": !0
                  }, null, 8, ["theme", "spotlight", "show-name"])
                ], 10, Sne)), [
                  [
                    u,
                    e.scrollRight,
                    "swipe",
                    { left: !0 }
                  ],
                  [
                    u,
                    e.scrollLeft,
                    "swipe",
                    { right: !0 }
                  ]
                ])), 128))
              ])
            ], 2)
          ]),
          _: 1
        }, 8, ["total-cards", "current-card", "all-cards-visible", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"])) : T("", !0)
      ]),
      _: 2
    }, [
      i.showSlider ? void 0 : {
        name: "item",
        fn: S(({ element: m, index: v }) => [
          j(s, {
            class: "spotlight no-slider",
            theme: e.theme,
            spotlight: m,
            "show-name": e.spotlights.show_name
          }, {
            controls: S(() => [
              M(e.$slots, "controls", { idx: v }, void 0, !0)
            ]),
            image: S(() => [
              M(e.$slots, "image", { idx: v }, void 0, !0)
            ]),
            quote: S(() => [
              M(e.$slots, "quote", { idx: v }, void 0, !0)
            ]),
            author: S(() => [
              M(e.$slots, "author", { idx: v }, void 0, !0)
            ]),
            _: 2
          }, 1032, ["theme", "spotlight", "show-name"])
        ]),
        key: "0"
      }
    ]), 1040, ["modelValue", "class"]))
  ], 6);
}
const Ane = /* @__PURE__ */ B(wne, [["render", Mne], ["__scopeId", "data-v-73c2e755"]]), Ine = {
  name: "SL2",
  components: {
    CardSlider: cn
  },
  mixins: [Ci, bt],
  computed: {
    content() {
      return this.spotlights.content;
    },
    sliderCenterSize() {
      return 599;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`spotlightCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    }
  }
}, Lne = ["data-testid"], Dne = ["data-testid"], $ne = ["aria-label"], One = ["src", "alt"], Pne = { class: "card-quote-text" }, Nne = {
  key: 0,
  class: "card-author-text",
  "data-testid": "spotlight-author"
};
function Hne(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "SL2",
    "data-testid": "SL2",
    style: Z(e.colors),
    class: _([e.theme.style, e.isEditing && "editing"])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.displayHeaderTop ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.spotlights.component_header_top), 1)
            ], !0)
          ], 8, Dne)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.spotlights.component_header), 1)
          ], !0)
        ], 8, Lne)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": e.sliderCenterElements ? "bottom" : "top",
      "current-card": e.currentCard,
      "has-pager": !1,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.spotlights.component_header,
      class: _([{ "show-accent-left": e.currentCard === 0, "buttons-top": !e.sliderCenterElements }, "spotlight-container"]),
      "pager-orientation": "left",
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        (d(), I(Y(e.wrapperComponent), Se({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.spotlights.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.spotlights.content = l),
          class: [{ "all-cards-visible": e.allCardsVisible }, "spotlight-wrapper"],
          "item-key": "id"
        }), {
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              "aria-label": `${u + 1} of ${i.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              class: "spotlight"
            }, [
              M(e.$slots, "controls", { idx: u }, void 0, !0),
              M(e.$slots, "image", { idx: u }, () => [
                c("img", {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  class: "spotlight-image",
                  loading: "lazy"
                }, null, 8, One)
              ], !0),
              c("div", {
                ref: `spotlightCard-${u}`,
                "data-testid": "spotlight-card",
                class: "spotlight-card"
              }, [
                c("div", Pne, [
                  M(e.$slots, "quote", { idx: u }, () => [
                    H(k(l.quote), 1)
                  ], !0)
                ]),
                e.spotlights.show_name ? (d(), f("div", Nne, [
                  M(e.$slots, "author", { idx: u }, () => [
                    H(k(l.author), 1)
                  ], !0)
                ])) : T("", !0)
              ], 512)
            ], 8, $ne)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["nav-orientation", "current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "class", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const Fne = /* @__PURE__ */ B(Ine, [["render", Hne], ["__scopeId", "data-v-241d2edf"]]), Rne = {
  name: "SL3",
  components: {
    CardSlider: cn
  },
  mixins: [Ci, bt],
  computed: {
    content() {
      return this.spotlights.content;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`spotlightCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    }
  }
}, Vne = ["data-testid"], Bne = ["data-testid"], jne = ["aria-label"], Une = { class: "card-quote-text" }, qne = {
  key: 0,
  class: "card-author-text",
  "data-testid": "spotlight-author"
}, Gne = ["src", "alt"];
function Kne(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "SL3",
    "data-testid": "SL3",
    style: Z(e.colors),
    class: _([e.theme.style, { editing: e.isEditing }])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.displayHeaderTop ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.spotlights.component_header_top), 1)
            ], !0)
          ], 8, Bne)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.spotlights.component_header), 1)
          ], !0)
        ], 8, Vne)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.spotlights.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        (d(), I(Y(e.wrapperComponent), Se({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.spotlights.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.spotlights.content = l),
          class: [{ "all-cards-visible": e.allCardsVisible }, "spotlight-wrapper"],
          "item-key": "id"
        }), {
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              "aria-label": `${u + 1} of ${i.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              class: "spotlight"
            }, [
              M(e.$slots, "controls", { idx: u }, void 0, !0),
              c("div", {
                ref: `spotlightCard-${u}`,
                "data-testid": "spotlight-card",
                class: "spotlight-card"
              }, [
                c("div", Une, [
                  M(e.$slots, "quote", { idx: u }, () => [
                    H(k(l.quote), 1)
                  ], !0)
                ]),
                e.spotlights.show_name ? (d(), f("div", qne, [
                  M(e.$slots, "author", { idx: u }, () => [
                    H(k(l.author), 1)
                  ], !0)
                ])) : T("", !0)
              ], 512),
              M(e.$slots, "image", { idx: u }, () => [
                c("img", {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  class: "spotlight-image",
                  loading: "lazy"
                }, null, 8, Gne)
              ], !0)
            ], 8, jne)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const zne = /* @__PURE__ */ B(Rne, [["render", Kne], ["__scopeId", "data-v-0c9ba3f8"]]), Zne = {
  name: "IconButton",
  props: {
    iconColor: {
      type: String,
      default: "#fff"
    },
    backgroundColor: {
      type: String,
      default: "#000"
    },
    borderColor: {
      type: String,
      default: "#fff"
    },
    opacity: {
      type: String,
      default: "100"
    },
    width: {
      type: String,
      default: "60"
    },
    height: {
      type: String,
      default: "60"
    },
    mirror: {
      type: Boolean,
      default: !1
    },
    onClick: {
      type: Function,
      default: () => {
      }
    }
  },
  computed: {
    cssVars() {
      return {
        "--icon-color": this.iconColor,
        "--bg-color": this.backgroundColor,
        "--border-color": this.borderColor,
        "--opacity": `${this.opacity}%`,
        "--width": `${this.width}px`,
        "--height": `${this.height}px`
      };
    }
  }
};
function xne(e, t, n, r, o, i) {
  return d(), f("button", {
    class: "icon-button",
    style: Z(i.cssVars),
    onClick: t[0] || (t[0] = (a) => e.$emit("on-click"))
  }, [
    c("div", {
      class: _(["icon-wrapper", { mirror: n.mirror }])
    }, [
      M(e.$slots, "icon", {}, void 0, !0)
    ], 2)
  ], 4);
}
const Wne = /* @__PURE__ */ B(Zne, [["render", xne], ["__scopeId", "data-v-c77efb17"]]), Yne = {
  name: "SL4",
  components: { IconButton: Wne },
  mixins: [Ci],
  data() {
    return {
      activeItem: 0,
      autoplayInterval: null,
      autoPlay: !0,
      isOverflow: !1
    };
  },
  computed: {
    content() {
      var e;
      return (e = this.spotlights.content) != null ? e : [];
    },
    currentItem() {
      return this.content.length > 0 ? this.content[this.activeItem] : {
        id: 0,
        author_id: 0,
        quote: "",
        author: "",
        role: "",
        image: { url: "", alt_text: "" },
        link: { name: "", href: "", target: "" }
      };
    },
    borderColor() {
      return de(this.colors["--bg-color"]).isLight() ? "#000000" : "#FFFFFF";
    },
    cssVars() {
      return ge(ae({}, this.colors), {
        "--image-border-color": this.borderColor
      });
    }
  },
  mounted() {
    this.isEditing || (this.$nextTick(() => {
      this.checkOverflow();
    }), window.addEventListener("resize", this.checkOverflow), this.startAutoplay());
  },
  beforeUnmount() {
    clearInterval(this.autoplayInterval), window.removeEventListener("resize", this.checkOverflow);
  },
  methods: {
    itemSelect(e) {
      this.activeItem = e, !this.isEditing && this.autoPlay && this.restartAutoplay();
    },
    previousItem() {
      this.itemSelect((this.activeItem - 1 + this.content.length) % this.content.length);
    },
    nextItem() {
      this.itemSelect((this.activeItem + 1) % this.content.length);
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(this.nextItem, 8e3);
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    restartAutoplay() {
      this.stopAutoplay(), this.startAutoplay();
    },
    toggleAutoplay() {
      this.isEditing || (this.autoPlay = !this.autoPlay, this.autoPlay ? this.startAutoplay() : this.stopAutoplay());
    },
    checkOverflow() {
      this.isOverflow = this.isMobile ? !1 : this.$refs.thumbnails && this.$refs.thumbnails.scrollHeight > this.$refs.thumbnails.clientHeight;
    }
  }
}, Xne = { class: "spotlight-wrapper" }, Qne = ["data-testid"], Jne = ["data-testid"], ere = { class: "col-1" }, tre = { class: "spotlight-quote-container" }, nre = { class: "col-2" }, rre = {
  key: 0,
  class: "author-role-container"
}, ore = { class: "gallery-container" }, ire = { class: "gallery-track" }, sre = ["fill"], are = {
  key: 1,
  width: "56",
  height: "12",
  viewBox: "0 0 6 12",
  xmlns: "http://www.w3.org/2000/svg"
}, lre = ["fill"], ure = {
  width: "22",
  height: "12",
  viewBox: "0 0 22 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dre = ["stroke"], cre = ["onClick"], hre = {
  key: 0,
  class: "author-role-container"
}, mre = {
  width: "22",
  height: "12",
  viewBox: "0 0 22 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fre = ["stroke"], pre = { class: "main-image" };
function gre(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("IconButton");
  return d(), f("div", {
    class: _(["spotlight-v4", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "SL4",
    style: Z(i.cssVars)
  }, [
    c("div", Xne, [
      j(a, {
        "theme-options": e.theme,
        class: _(["see-all-top", e.theme.style])
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (d(), f("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.spotlights.component_header_top), 1)
              ], !0)
            ], 8, Jne)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.spotlights.component_header), 1)
            ], !0)
          ], 8, Qne)
        ]),
        default: S(() => {
          var l, u;
          return [
            e.isBoldStyle && !e.isMobile ? (d(), I(Y(e.isEditing ? "button" : "a"), {
              key: 0,
              class: _(["see-all-button", e.theme.style]),
              href: (l = i.currentItem.link) == null ? void 0 : l.href,
              target: (u = i.currentItem.link) == null ? void 0 : u.target
            }, {
              default: S(() => [
                H(k(i.currentItem.link.name) + " ", 1),
                M(e.$slots, "link", { idx: o.activeItem }, void 0, !0)
              ]),
              _: 3
            }, 8, ["class", "href", "target"])) : T("", !0)
          ];
        }),
        _: 3
      }, 8, ["theme-options", "class"]),
      c("div", ere, [
        c("div", tre, [
          (d(!0), f(J, null, ne(i.content, (l, u) => (d(), f("div", {
            key: u,
            class: _(["spotlight-quote-text", e.theme.style, { active: u === o.activeItem }])
          }, [
            M(e.$slots, "quote", { idx: o.activeItem }, () => [
              H(k(l.quote), 1)
            ], !0)
          ], 2))), 128))
        ]),
        e.isBoldStyle || e.isLightStyle && !e.isDesktop ? T("", !0) : (d(), I(a, {
          key: 0,
          class: _(e.theme.style),
          "theme-options": e.theme
        }, {
          default: S(() => {
            var l, u;
            return [
              (d(), I(Y(e.isEditing ? "button" : "a"), {
                class: _(["see-all-button", e.theme.style]),
                href: (l = i.currentItem.link) == null ? void 0 : l.href,
                target: (u = i.currentItem.link) == null ? void 0 : u.target
              }, {
                default: S(() => {
                  var m;
                  return [
                    H(k((m = i.currentItem.link) == null ? void 0 : m.name) + " ", 1),
                    M(e.$slots, "link", { idx: o.activeItem }, void 0, !0)
                  ];
                }),
                _: 3
              }, 8, ["class", "href", "target"]))
            ];
          }),
          _: 3
        }, 8, ["class", "theme-options"]))
      ]),
      c("div", nre, [
        e.isMobile ? (d(), f("div", rre, [
          (d(!0), f(J, null, ne(i.content, (l, u) => (d(), f("div", {
            key: u,
            class: _(["author-role-text", { active: u === o.activeItem }])
          }, [
            c("div", {
              class: _(["spotlight-author-text", e.theme.style])
            }, [
              M(e.$slots, "author", { idx: o.activeItem }, () => [
                H(k(l.author), 1)
              ], !0)
            ], 2),
            c("div", {
              class: _(["spotlight-role-text", e.theme.style])
            }, [
              M(e.$slots, "role", { idx: o.activeItem }, () => [
                H(k(l.role), 1)
              ], !0)
            ], 2)
          ], 2))), 128))
        ])) : T("", !0),
        c("div", ore, [
          c("div", ire, [
            e.isEditing ? T("", !0) : (d(), I(s, {
              key: 0,
              class: "play-button",
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex,
              onOnClick: i.toggleAutoplay
            }, {
              icon: S(() => [
                o.autoPlay ? (d(), f("svg", {
                  key: 0,
                  width: "56",
                  height: "56",
                  viewBox: "0 0 56 56",
                  fill: e.theme.arrow_icon_color.hex,
                  xmlns: "http://www.w3.org/2000/svg"
                }, t[0] || (t[0] = [
                  c("rect", {
                    x: "21",
                    y: "15",
                    width: "5",
                    height: "24"
                  }, null, -1),
                  c("rect", {
                    x: "30",
                    y: "15",
                    width: "5",
                    height: "24"
                  }, null, -1)
                ]), 8, sre)) : (d(), f("svg", are, [
                  c("path", {
                    d: "M0 12L6 6L0 0V12Z",
                    fill: e.theme.arrow_icon_color.hex
                  }, null, 8, lre)
                ]))
              ]),
              _: 1
            }, 8, ["background-color", "opacity", "border-color", "onOnClick"])),
            o.isOverflow ? (d(), I(s, {
              key: 1,
              class: "back-button",
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex,
              onOnClick: i.previousItem
            }, {
              icon: S(() => [
                (d(), f("svg", ure, [
                  c("path", {
                    d: "M2 9.85742L10.3279 2.29789C10.7091 1.95181 11.2909 1.95181 11.6721 2.29789L20 9.85742",
                    stroke: e.theme.arrow_icon_color.hex,
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, 8, dre)
                ]))
              ]),
              _: 1
            }, 8, ["background-color", "opacity", "border-color", "onOnClick"])) : T("", !0),
            c("div", {
              ref: "thumbnails",
              class: _(["thumbnails-container", { "is-overflow": o.isOverflow }])
            }, [
              (d(!0), f(J, null, ne(i.content, (l, u) => (d(), f("div", {
                key: u,
                class: _([{ active: u === o.activeItem }, "thumbnail"]),
                onClick: (m) => i.itemSelect(u)
              }, [
                e.isMobile ? T("", !0) : (d(), f("div", hre, [
                  c("div", {
                    class: _(["spotlight-author-text", e.theme.style])
                  }, [
                    M(e.$slots, "author", { idx: u }, () => [
                      H(k(l.author), 1)
                    ], !0)
                  ], 2),
                  c("div", {
                    class: _(["spotlight-author-text", e.theme.style])
                  }, [
                    M(e.$slots, "role", { idx: u }, () => [
                      H(k(l.role), 1)
                    ], !0)
                  ], 2)
                ])),
                (d(), I(Y(l.image.url ? "img" : "div"), {
                  draggable: "false",
                  src: l.image.url,
                  alt: l.image.alt_text,
                  class: "mini-image"
                }, null, 8, ["src", "alt"]))
              ], 10, cre))), 128))
            ], 2),
            o.isOverflow ? (d(), I(s, {
              key: 2,
              class: "next-button",
              mirror: "",
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex,
              onOnClick: i.nextItem
            }, {
              icon: S(() => [
                (d(), f("svg", mre, [
                  c("path", {
                    d: "M2 9.85742L10.3279 2.29789C10.7091 1.95181 11.2909 1.95181 11.6721 2.29789L20 9.85742",
                    stroke: e.theme.arrow_icon_color.hex,
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, 8, fre)
                ]))
              ]),
              _: 1
            }, 8, ["background-color", "opacity", "border-color", "onOnClick"])) : T("", !0)
          ]),
          c("div", pre, [
            (d(!0), f(J, null, ne(i.content, (l, u) => (d(), I(Y(l.image.url ? "img" : "div"), {
              key: u,
              draggable: "false",
              src: i.currentItem.image.url,
              alt: i.currentItem.image.alt_text,
              class: _(["active-image", { active: u === o.activeItem }])
            }, null, 8, ["src", "alt", "class"]))), 128)),
            M(e.$slots, "image", { idx: o.activeItem }, void 0, !0)
          ])
        ])
      ]),
      e.isBoldStyle && e.isMobile || e.isLightStyle && !e.isDesktop ? (d(), I(a, {
        key: 0,
        class: _([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme
      }, {
        default: S(() => {
          var l, u;
          return [
            (d(), I(Y(e.isEditing ? "button" : "a"), {
              class: _(["see-all-button", e.theme.style]),
              href: (l = i.currentItem.link) == null ? void 0 : l.href,
              target: (u = i.currentItem.link) == null ? void 0 : u.target
            }, {
              default: S(() => {
                var m;
                return [
                  H(k((m = i.currentItem.link) == null ? void 0 : m.name) + " ", 1),
                  M(e.$slots, "link", { idx: e.idx }, void 0, !0)
                ];
              }),
              _: 3
            }, 8, ["class", "href", "target"]))
          ];
        }),
        _: 3
      }, 8, ["class", "theme-options"])) : T("", !0)
    ])
  ], 6);
}
const vre = /* @__PURE__ */ B(Yne, [["render", gre], ["__scopeId", "data-v-84435ad0"]]), bre = {
  name: "SL5",
  components: {
    CardSlider: cn
  },
  mixins: [Ci, bt],
  data() {
    return {
      activeTabIdx: 0,
      defaultNestedContent: [
        {
          cards: [],
          icon: "",
          label: "",
          show_image_icons: !0,
          show_headline: !0,
          show_snippet: !0
        }
      ]
    };
  },
  computed: {
    nestedContent() {
      var e, t;
      return (t = (e = this.spotlights) == null ? void 0 : e.nested_content) != null ? t : this.defaultNestedContent;
    },
    activeTabData() {
      return this.nestedContent[this.activeTabIdx];
    },
    content() {
      return this.activeTabData.cards;
    },
    cssVars() {
      return ge(ae({}, this.colors), {
        "--button-bg-color": $(this.theme, "button_bg_color.hex", "#5D5FEF"),
        "--button-border-color": $(this.theme, "button_border_color.hex", "#8f91ff"),
        "--button-icon-color": $(this.theme, "button_icon_color.hex", "#8f91ff"),
        "--button-text-color": $(this.theme, "button_text_color.hex", "#8f91ff"),
        "--button-active-bg-color": $(this.theme, "button_active_bg_color.hex", "#5D5FEF"),
        "--button-active-border-color": $(this.theme, "button_active_border_color.hex", "#fff"),
        "--button-active-icon-color": $(this.theme, "button_active_icon_color.hex", "#fff"),
        "--button-active-text-color": $(this.theme, "button_active_text_color.hex", "#fff"),
        "--image-gradient-color": $(this.theme, "image_gradient_color.hex", "#000000"),
        "--quote-icon-color": $(this.theme, "quote_icon_color.hex", "#fff"),
        "--role-color": $(this.theme, "role_color.hex", "#000"),
        "--line-color": $(this.theme, "line_color.hex", "#8f91ff")
      });
    }
  },
  methods: {
    tabActivate(e) {
      this.activeTabIdx = e, this.$emit("update:selectedIdx", this.activeTabIdx);
    }
  }
}, yre = { class: "spotlight-wrapper" }, _re = ["data-testid"], Cre = ["data-testid"], wre = ["onClick"], Tre = {
  key: 0,
  class: "icon-wrapper"
}, kre = ["innerHTML"], Ere = ["aria-label"], Sre = { class: "top" }, Mre = {
  key: 0,
  class: "mask"
}, Are = ["src", "alt"], Ire = {
  key: 2,
  class: "no-image"
}, Lre = { class: "content" }, Dre = {
  key: 0,
  class: "icon-wrapper"
}, $re = ["innerHTML"], Ore = {
  key: 1,
  class: "snippet"
}, Pre = { class: "bottom" }, Nre = {
  key: 0,
  "data-testid": "spotlight-card",
  class: "name-role-wrapper"
}, Hre = { class: "role" }, Fre = ["aria-label"], Rre = ["aria-label"];
function Vre(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    class: _(["spotlight-v5", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "SL5",
    style: Z(i.cssVars)
  }, [
    c("div", yre, [
      j(a, {
        class: _([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.displayHeaderTop ? (d(), f("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.spotlights.component_header_top), 1)
              ], !0)
            ], 8, Cre)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.spotlights.component_header), 1)
            ], !0)
          ], 8, _re)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
        modelValue: e.spotlights.nested_content,
        "onUpdate:modelValue": t[0] || (t[0] = (l) => e.spotlights.nested_content = l),
        "item-key": "id",
        class: ["spotlight-tabs", { editing: e.isEditing }]
      }), {
        item: S(({ element: l, index: u }) => [
          c("button", {
            class: _(["tab-button", { active: u === o.activeTabIdx }]),
            onClick: (m) => i.tabActivate(u)
          }, [
            M(e.$slots, "controls", { idx: u }, void 0, !0),
            e.spotlights.show_icons ? (d(), f("div", Tre, [
              M(e.$slots, "tab-icon", { idx: u }, () => [
                c("span", {
                  class: "icon",
                  innerHTML: l.icon
                }, null, 8, kre)
              ], !0)
            ])) : T("", !0),
            e.spotlights.show_tab_labels ? (d(), f("div", {
              key: 1,
              class: _(["label", [e.theme.style]])
            }, [
              M(e.$slots, "label", { idx: u }, () => [
                H(k(l.label), 1)
              ], !0)
            ], 2)) : T("", !0)
          ], 10, wre)
        ]),
        _: 3
      }, 16, ["modelValue", "class"])),
      i.activeTabData && i.activeTabData.cards && i.activeTabData.cards.length ? (d(), I(s, {
        key: 0,
        "nav-orientation": "bottom",
        "pager-orientation": "right",
        "current-card": e.currentCard,
        "pager-section-count": e.pagerSectionCount,
        "total-cards": i.activeTabData.cards.length,
        "section-header": e.spotlights.component_header,
        "has-pager": !1,
        "theme-styles": e.theme,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft,
        onGoToSection: e.goToSection
      }, {
        "button-left": S(() => [
          c("button", {
            class: "slider-button left",
            "aria-label": e.translations.previous_item || "Previous Item",
            onKeyup: t[2] || (t[2] = K((...l) => e.scrollLeft && e.scrollLeft(...l), ["left"])),
            onClick: t[3] || (t[3] = (...l) => e.scrollLeft && e.scrollLeft(...l))
          }, t[6] || (t[6] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 40, Fre)
        ]),
        "button-right": S(() => [
          c("button", {
            class: "slider-button right",
            "aria-label": e.translations.next_item || "Next Item",
            onKeyup: t[4] || (t[4] = K((...l) => e.scrollRight && e.scrollRight(...l), ["right"])),
            onClick: t[5] || (t[5] = (...l) => e.scrollRight && e.scrollRight(...l))
          }, t[7] || (t[7] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 40, Rre)
        ]),
        default: S(() => [
          (d(), I(Y(e.wrapperComponent), Se({ ref: "scrollWrapper" }, e.wrapperProps, {
            modelValue: i.activeTabData.cards,
            "onUpdate:modelValue": t[1] || (t[1] = (l) => i.activeTabData.cards = l),
            "item-key": "id",
            class: "cards-wrapper"
          }), {
            item: S(({ element: l, index: u }) => [
              c("div", {
                ref: `sliderCard-${u}`,
                "aria-label": `${u + 1} of ${i.activeTabData.cards.length}`,
                role: "group",
                "aria-roledescription": "slide",
                class: _(["card", { editing: e.isEditing }])
              }, [
                c("div", Sre, [
                  M(e.$slots, "tab-controls", {
                    idx: u,
                    tabIdx: o.activeTabIdx
                  }, void 0, !0),
                  l.image.url ? (d(), f("div", Mre)) : T("", !0),
                  l.image.url ? (d(), f("img", {
                    key: 1,
                    src: l.image.url,
                    alt: l.image.alt_text,
                    class: "image",
                    draggable: "false",
                    loading: "lazy"
                  }, null, 8, Are)) : T("", !0),
                  !l.image.url && e.isEditing ? (d(), f("div", Ire)) : T("", !0),
                  c("div", Lre, [
                    i.activeTabData.show_image_icons ? (d(), f("div", Dre, [
                      M(e.$slots, "icon", {
                        idx: u,
                        tabIdx: o.activeTabIdx
                      }, () => [
                        c("span", {
                          class: "icon",
                          innerHTML: l.icon
                        }, null, 8, $re)
                      ], !0)
                    ])) : T("", !0),
                    i.activeTabData.show_snippet ? (d(), f("p", Ore, [
                      M(e.$slots, "snippet", {
                        idx: u,
                        tabIdx: o.activeTabIdx
                      }, () => [
                        H(k(l.snippet), 1)
                      ], !0)
                    ])) : T("", !0)
                  ])
                ]),
                c("div", Pre, [
                  i.activeTabData.show_headline ? (d(), f("div", Nre, [
                    c("div", {
                      class: _(["name", [e.theme.style]]),
                      "data-testid": "spotlight-name"
                    }, [
                      M(e.$slots, "author", {
                        idx: u,
                        tabIdx: o.activeTabIdx
                      }, () => [
                        H(k(l.name), 1)
                      ], !0)
                    ], 2),
                    c("div", Hre, [
                      M(e.$slots, "role", {
                        idx: u,
                        tabIdx: o.activeTabIdx
                      }, () => [
                        H(k(l.role), 1)
                      ], !0)
                    ])
                  ])) : T("", !0)
                ])
              ], 10, Ere)
            ]),
            _: 3
          }, 16, ["modelValue"]))
        ]),
        _: 3
      }, 8, ["current-card", "pager-section-count", "total-cards", "section-header", "theme-styles", "onScrollRight", "onScrollLeft", "onGoToSection"])) : T("", !0)
    ])
  ], 6);
}
const Bre = /* @__PURE__ */ B(bre, [["render", Vre], ["__scopeId", "data-v-a3f88a2f"]]), jre = {
  name: "Spotlight",
  components: {
    SL1: Ane,
    SL2: Fne,
    SL3: zne,
    SL4: vre,
    SL5: Bre
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  },
  methods: {
    handleSelectedIdx(e) {
      this.$emit("update:selectedIdx", e);
    }
  }
}, Ure = { id: "view-spotlight" };
function qre(e, t, n, r, o, i) {
  return d(), f("div", Ure, [
    (d(), I(Y(n.theme.version), {
      theme: n.theme,
      spotlights: n.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "is-editing": n.isEditing,
      "onUpdate:selectedIdx": i.handleSelectedIdx
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      controls: S(({ idx: a }) => [
        M(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      "tab-controls": S(({ idx: a, tabIdx: s }) => [
        M(e.$slots, "tab-controls", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      image: S(({ idx: a }) => [
        M(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      title: S(({ title: a, idx: s }) => [
        M(e.$slots, "title", {
          title: a,
          idx: s
        }, void 0, !0)
      ]),
      quote: S(({ quote: a, idx: s }) => [
        M(e.$slots, "quote", {
          quote: a,
          idx: s
        }, void 0, !0)
      ]),
      author: S(({ author: a, idx: s, tabIdx: l }) => [
        M(e.$slots, "author", {
          author: a,
          idx: s,
          tabIdx: l
        }, void 0, !0)
      ]),
      role: S(({ role: a, idx: s, tabIdx: l }) => [
        M(e.$slots, "role", {
          role: a,
          idx: s,
          tabIdx: l
        }, void 0, !0)
      ]),
      icon: S(({ idx: a, tabIdx: s }) => [
        M(e.$slots, "icon", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      "tab-icon": S(({ idx: a }) => [
        M(e.$slots, "tab-icon", { idx: a }, void 0, !0)
      ]),
      label: S(({ label: a, idx: s }) => [
        M(e.$slots, "label", {
          label: a,
          idx: s
        }, void 0, !0)
      ]),
      snippet: S(({ idx: a, tabIdx: s }) => [
        M(e.$slots, "snippet", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      link: S(({ idx: a }) => [
        M(e.$slots, "link", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "spotlights", "wrapper-component", "wrapper-props", "is-editing", "onUpdate:selectedIdx"]))
  ]);
}
const Gre = /* @__PURE__ */ B(jre, [["render", qre], ["__scopeId", "data-v-f0dee26f"]]), Kre = {
  mixins: [kt],
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    athletics: {
      type: Array,
      required: !0
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    athleticsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  computed: {
    theme() {
      return this.options;
    },
    colors() {
      const e = this.sharedThemeColors(), t = $(this.theme, "athletic_bg_color.hex", "none"), n = $(this.theme, "athletic_title_color.hex", "initial");
      return ge(ae({}, e), {
        "--athletic-bg-color": t,
        "--athletic-title-color": n,
        "--date-color": $(this.theme, "date_color.hex", "initial"),
        "--time-color": $(this.theme, "time_color.hex", "initial"),
        "--athletic-separator-color": $(this.theme, "athletic_separator_color.hex", "#000"),
        "--athletic-card-border": $(
          this.theme,
          "athletic_card_border.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--vs-tag-bg-color": $(this.theme, "vs_tag_bg.hex", t),
        "--vs-tag-text-color": $(this.theme, "vs_tag_color.hex", n)
      });
    },
    translations() {
      return this.options.translations;
    },
    isMonterreyStyle() {
      return this.options.style === "monterrey";
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("athletics");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  }
}, zre = {
  name: "A1",
  mixins: [Kre]
}, Zre = ["data-testid"], xre = { class: "athletics-match" }, Wre = {
  key: 0,
  "data-testid": "versus"
}, Yre = {
  key: 1,
  "data-testid": "non-versus"
};
function Xre(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "athletics-a1",
    style: Z(e.colors),
    "data-testid": "a1",
    class: _(e.theme.style)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Zre)) : T("", !0),
        (d(), I(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.options.style !== "purple" && e.screenSize > 600 ? (d(), I(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: _(["athletics-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), f(J, null, ne(e.athletics.slice(0, 6), (s, l) => (d(), f("div", {
        key: `${l}-${s.title}`,
        class: "athletics-card athletic-accent-border",
        "data-testid": "athletic-accent-border"
      }, [
        c("p", {
          class: _(["athletics-date", e.options.style])
        }, k(s.month) + " " + k(s.day), 3),
        c("div", {
          class: _(["athletics-time", e.options.style])
        }, k(s.time), 3),
        c("div", {
          class: _(["athletics-filter", e.options.style])
        }, k(s.filter_name), 3),
        c("h3", xre, [
          s.versus ? (d(), f("div", Wre, [
            H(k(s.away_team) + " ", 1),
            c("span", null, k(e.translations.at), 1),
            H(" " + k(s.home_team), 1)
          ])) : (d(), f("div", Yre, k(s.title), 1))
        ])
      ]))), 128))
    ], 2),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), I(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), I(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const Qre = /* @__PURE__ */ B(zre, [["render", Xre], ["__scopeId", "data-v-ca02bffd"]]), Jre = {
  name: "CmsAthletics",
  components: {
    A1: Qre
  },
  props: {
    options: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    athleticsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  }
}, eoe = { id: "view-athletics" };
function toe(e, t, n, r, o, i) {
  return d(), f("div", eoe, [
    (d(), I(Y(n.options.version), {
      options: n.options,
      "component-id": n.componentId,
      athletics: n.content,
      "athletics-config": n.athleticsConfig,
      "is-editing": n.isEditing,
      "path-prefix": n.pathPrefix,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["options", "component-id", "athletics", "athletics-config", "is-editing", "path-prefix"]))
  ]);
}
const noe = /* @__PURE__ */ B(Jre, [["render", toe], ["__scopeId", "data-v-efaab17b"]]), roe = {
  name: "SvgArrow"
}, ooe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 21",
  fill: "none"
};
function ioe(e, t, n, r, o, i) {
  return d(), f("svg", ooe, t[0] || (t[0] = [
    c("mask", {
      id: "path-1-inside-1_1",
      fill: "white"
    }, [
      c("path", { d: "M15.5 0L26 10.5L15 21L13.5 19.5L22 11.5H0V9.5H22L14 1.5L15.5 0Z" })
    ], -1),
    c("path", {
      d: "M15.5 0L26 10.5L15 21L13.5 19.5L22 11.5H0V9.5H22L14 1.5L15.5 0Z",
      class: "arrow_svg",
      "stroke-width": "4",
      mask: "url(#path-1-inside-1_1)"
    }, null, -1)
  ]));
}
const soe = /* @__PURE__ */ B(roe, [["render", ioe]]), xs = {
  mixins: [kt],
  components: { DraggableWrapper: vt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    buttons: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--bg-color": $(this.theme, "bg_color.hex", "#fff"),
        "--text-color": $(this.theme, "text_color.hex", "#000"),
        "--arrow-color": $(this.theme, "arrow_color.hex", "#000"),
        "--arrow-color-hover": $(this.theme, "arrow_color_hover.hex", "#000"),
        "--button-text-color": $(this.theme, "button_text_color.hex", "#fff"),
        "--button-bg-color": $(this.theme, "button_bg_color.hex", "#000"),
        "--border-radius": `${this.theme.border_radius}px`,
        "--percentage-opacity": `${100 - this.theme.percentage_opacity}%`,
        "--icon-and-text-color": $(this.theme, "icon_and_text_color.hex", "#fff")
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, aoe = {
  name: "B1",
  components: { SvgArrow: soe },
  mixins: [xs]
}, loe = { "data-testid": "buttons-content" };
function uoe(e, t, n, r, o, i) {
  const a = V("SvgArrow");
  return d(), f("div", {
    id: "buttons-b1",
    "data-testid": "B1",
    class: _(e.theme.style),
    style: Z(e.colors)
  }, [
    (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.buttons.content = s),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: S(({ element: s, index: l }) => [
        c("div", loe, [
          (d(), I(Y(e.isEditing ? "div" : "a"), {
            href: s.link,
            target: s.opens_in_new_tab ? "_blank" : "",
            class: "button-link"
          }, {
            default: S(() => [
              M(e.$slots, "controls", { idx: l }, void 0, !0),
              M(e.$slots, "title", { idx: l }, () => [
                H(k(s.title), 1)
              ], !0),
              j(a)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const doe = /* @__PURE__ */ B(aoe, [["render", uoe], ["__scopeId", "data-v-d157672d"]]), coe = {
  name: "B2",
  mixins: [xs]
};
function hoe(e, t, n, r, o, i) {
  return d(), f("div", {
    id: "buttons-b2",
    "data-testid": "B2",
    class: _([e.theme.style, { uppercase: e.theme.uppercase }]),
    style: Z(e.colors)
  }, [
    (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => e.buttons.content = a),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: S(({ element: a, index: s }) => [
        c("div", null, [
          (d(), I(Y(e.isEditing ? "div" : "a"), {
            href: a.link,
            target: a.opens_in_new_tab ? "_blank" : "",
            class: "button-link",
            "data-testid": "buttons-content"
          }, {
            default: S(() => [
              M(e.$slots, "controls", { idx: s }, void 0, !0),
              c("span", null, [
                M(e.$slots, "title", { idx: s }, () => [
                  H(k(a.title), 1)
                ], !0)
              ])
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const moe = /* @__PURE__ */ B(coe, [["render", hoe], ["__scopeId", "data-v-dac6a587"]]), foe = {
  name: "B3",
  mixins: [xs],
  computed: {
    buttonCount() {
      return this.buttons.content.length;
    },
    iconsActive() {
      return this.buttons.icons_active;
    },
    buttonClasses() {
      return [`buttons-${this.buttonCount}`, { "can-stack": this.buttonCount > 4 }, this.theme.style];
    },
    borderColor() {
      return de(this.colors["--button-bg-color"]).isLight() ? "rgba(0, 0, 0, 0.15)" : "rgba(255,255,255, 0.15)";
    },
    cssVars() {
      return ge(ae({}, this.colors), {
        "--button-border": `1px solid ${this.borderColor}`
      });
    }
  }
}, poe = {
  key: 0,
  class: "icon-wrapper",
  "aria-hidden": "true"
}, goe = { class: "raw-svg" }, voe = ["innerHTML"], boe = { class: "button-title" };
function yoe(e, t, n, r, o, i) {
  return d(), f("div", {
    id: "buttons-b3",
    "data-testid": "B3",
    class: _(e.theme.style),
    style: Z(i.cssVars)
  }, [
    (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => e.buttons.content = a),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: S(({ element: a, index: s }) => [
        c("div", {
          class: _(["button", i.buttonClasses])
        }, [
          (d(), I(Y(e.isEditing ? "div" : "a"), {
            href: a.link,
            class: _([[e.theme.style, !i.iconsActive && "no-icons"], "button-link"]),
            target: a.opens_in_new_tab ? "_blank" : "",
            "data-testid": "buttons-content"
          }, {
            default: S(() => [
              M(e.$slots, "controls", { idx: s }, void 0, !0),
              i.iconsActive ? (d(), f("div", poe, [
                c("span", goe, [
                  M(e.$slots, "icon", { idx: s }, () => [
                    c("span", {
                      "data-testid": "svg",
                      innerHTML: a.icon
                    }, null, 8, voe)
                  ], !0)
                ])
              ])) : T("", !0),
              c("span", boe, [
                M(e.$slots, "title", { idx: s }, () => [
                  H(k(a.title), 1)
                ], !0)
              ])
            ]),
            _: 2
          }, 1032, ["href", "class", "target"]))
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const _oe = /* @__PURE__ */ B(foe, [["render", yoe], ["__scopeId", "data-v-2e00171e"]]), Coe = {
  name: "B4",
  mixins: [xs],
  props: {
    logo: {
      type: String,
      required: !0
    }
  },
  computed: {
    content: {
      get() {
        return this.buttons.content.slice(0, 3);
      },
      set(e) {
        this.buttons.content = e;
      }
    },
    b4Colors() {
      return {
        // ...this.cssVars,
        "--button-1-bg-color": $(this.theme, "button_1_bg_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--button-1-border-color": $(this.theme, "button_1_border_color.hex", "#fff"),
        "--button-1-text-color": $(this.theme, "button_1_text_color.hex", "#fff"),
        "--button-2-bg-color": $(this.theme, "button_2_bg_color.hex", this.theme.globalThemeSettings.primaryColor),
        "--button-2-border-color": $(this.theme, "button_2_border_color.hex", "#fff"),
        "--button-2-text-color": $(this.theme, "button_2_text_color.hex", "#fff"),
        "--button-3-bg-color": $(this.theme, "button_3_bg_color.hex", "#000"),
        "--button-3-border-color": $(this.theme, "button_3_border_color.hex", "#fff"),
        "--button-3-text-color": $(this.theme, "button_3_text_color.hex", "#fff")
      };
    }
  }
}, woe = { class: "button-title-wrapper" }, Toe = ["src"];
function koe(e, t, n, r, o, i) {
  return d(), f("div", {
    "data-testid": "B4",
    class: _(["B4", e.theme.style]),
    style: Z(i.b4Colors)
  }, [
    (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: i.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => i.content = a),
      "item-key": "index",
      class: "button-wrapper"
    }), {
      item: S(({ element: a, index: s }) => [
        (d(), I(Y(e.isEditing ? "div" : "a"), {
          class: _(["button", `button-style-${s + 1}`]),
          href: a.link,
          target: a.opens_in_new_tab ? "_blank" : "",
          "data-testid": "button"
        }, {
          default: S(() => [
            M(e.$slots, "controls", { idx: s }, void 0, !0),
            c("div", woe, [
              c("div", {
                class: _([e.theme.style, "button-title"])
              }, [
                M(e.$slots, "title", {
                  title: a.title,
                  idx: s
                }, () => [
                  H(k(a.title), 1)
                ], !0)
              ], 2),
              c("img", {
                src: n.logo,
                alt: "",
                "data-testid": "button-image"
              }, null, 8, Toe)
            ])
          ]),
          _: 2
        }, 1032, ["class", "href", "target"]))
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Eoe = /* @__PURE__ */ B(Coe, [["render", koe], ["__scopeId", "data-v-8248f642"]]), Soe = {
  name: "Buttons",
  components: {
    B1: doe,
    B2: moe,
    B3: _oe,
    B4: Eoe
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    logo: {
      type: String,
      default: ""
    }
  }
};
function Moe(e, t, n, r, o, i) {
  return d(), I(Y(n.theme.version), {
    theme: n.theme,
    buttons: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    logo: n.logo
  }, {
    controls: S(({ idx: a }) => [
      M(e.$slots, "controls", { idx: a })
    ]),
    icon: S(({ idx: a }) => [
      M(e.$slots, "icon", { idx: a })
    ]),
    title: S(({ title: a, idx: s }) => [
      M(e.$slots, "title", {
        title: a,
        idx: s
      })
    ]),
    _: 3
  }, 8, ["theme", "buttons", "wrapper-component", "wrapper-props", "is-editing", "logo"]);
}
const Aoe = /* @__PURE__ */ B(Soe, [["render", Moe]]), Ioe = {
  name: "IconLinkButtons",
  components: { DraggableWrapper: vt },
  props: {
    modelValue: {
      type: Array,
      required: !0
    },
    buttons: {
      type: Array,
      required: !0
    },
    themeStyle: {
      type: String,
      default: "light"
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || e.name === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    buttonBgColor: {
      type: String,
      default: "#000"
    },
    buttonIconAndTextColor: {
      type: String,
      default: "#fff"
    },
    width: {
      type: String,
      default: ""
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    cssVars() {
      return {
        "--iconlink-button-bg-color": this.buttonBgColor,
        "--iconlink-button-icon-text-color": this.buttonIconAndTextColor,
        "--iconlink-container-width": this.width || `${Math.ceil(this.buttons.length / 2) * 182}px`,
        "--iconlink-border-color": `1px solid ${this.borderColor}`
      };
    },
    borderColor() {
      return de(this.buttonBgColor).isLight() ? "rgba(0, 0, 0, 0.15)" : "rgba(255,255,255, 0.15)";
    },
    buttonModel: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, Loe = { class: "button-container" }, Doe = {
  key: 0,
  class: "icon-wrapper",
  "aria-hidden": "true"
}, $oe = { class: "raw-svg" }, Ooe = ["innerHTML"];
function Poe(e, t, n, r, o, i) {
  return d(), I(Y(n.wrapperComponent), Se(n.wrapperProps, {
    modelValue: i.buttonModel,
    "onUpdate:modelValue": t[0] || (t[0] = (a) => i.buttonModel = a),
    style: i.cssVars,
    "item-key": "index",
    class: "icon-link-buttons"
  }), {
    item: S(({ element: a, index: s }) => [
      (d(), I(Y(!a.href || n.isEditing ? "div" : "a"), {
        href: a.href,
        target: a.target || "_self",
        class: "button",
        "data-testid": "icon-button"
      }, {
        default: S(() => [
          M(e.$slots, "controls", { idx: s }, void 0, !0),
          c("div", Loe, [
            a.icon || n.isEditing ? (d(), f("div", Doe, [
              c("span", $oe, [
                M(e.$slots, "icon", {
                  icon: a.icon,
                  idx: s
                }, () => [
                  c("span", {
                    innerHTML: a.icon
                  }, null, 8, Ooe)
                ], !0)
              ])
            ])) : T("", !0),
            c("span", {
              class: _(["button-title", n.themeStyle])
            }, [
              M(e.$slots, "title", {
                title: a.title,
                idx: s
              }, () => [
                H(k(a.title), 1)
              ], !0)
            ], 2)
          ])
        ]),
        _: 2
      }, 1032, ["href", "target"]))
    ]),
    _: 3
  }, 16, ["modelValue", "style"]);
}
const Noe = /* @__PURE__ */ B(Ioe, [["render", Poe], ["__scopeId", "data-v-34984675"]]), ih = {
  mixins: [kt],
  components: {
    IconLinkButtons: Noe,
    DraggableWrapper: vt
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    about: {
      type: Object,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    watermark: {
      type: String,
      default: ""
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--top-heading-color": $(this.theme, "top_heading_color.hex", "#000"),
        "--text-color": $(this.theme, "text_color.hex", "#000"),
        "--text-link-color": $(this.theme, "text_link_color.hex", "#000"),
        "--watermark-url": `url(${this.watermark})`,
        "--card-top-header-color": $(this.theme, "card_top_header_color.hex", "#000"),
        "--card-bottom-header-color": $(this.theme, "card_bottom_header_color.hex", "#000")
      });
    },
    buttonBgColor() {
      return $(this.theme, "button_bg_color.hex", "#000");
    },
    buttonIconAndTextColor() {
      return $(this.theme, "icon_and_text_color.hex", "#fff");
    }
  }
}, Hoe = {
  name: "AboutV1",
  mixins: [ih],
  computed: {
    aboutImageUrl() {
      var e;
      return (e = this.about.image) == null ? void 0 : e.url;
    },
    aboutImageAltText() {
      var e;
      return (e = this.about.image) == null ? void 0 : e.alt_text;
    }
  }
}, Foe = ["data-testid"], Roe = ["data-testid"], Voe = { class: "main-content" }, Boe = { class: "left-content" }, joe = ["src", "alt"], Uoe = ["innerHTML"];
function qoe(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("IconLinkButtons");
  return d(), f("div", {
    id: "about-v1",
    class: _([e.theme.style, { editing: e.isEditing }]),
    style: Z(e.colors),
    "data-testid": "AboutV1"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.theme.style === "monterrey" && (e.about.component_header_top || e.isEditing) ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.about.component_header_top), 1)
            ], !0)
          ], 8, Roe)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.about.component_header), 1)
          ], !0)
        ], 8, Foe)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Voe, [
      c("div", Boe, [
        M(e.$slots, "image", {}, () => [
          e.about.has_image ? (d(), f("img", {
            key: 0,
            src: i.aboutImageUrl,
            alt: i.aboutImageAltText,
            class: "left-image",
            "data-testid": "about-image",
            loading: "lazy"
          }, null, 8, joe)) : T("", !0)
        ], !0),
        M(e.$slots, "text", {}, () => [
          c("span", {
            class: "left-text text-block",
            innerHTML: e.about.component_text
          }, null, 8, Uoe)
        ], !0)
      ]),
      j(s, {
        modelValue: e.about.links,
        "onUpdate:modelValue": t[0] || (t[0] = (l) => e.about.links = l),
        buttons: e.about.links,
        "wrapper-component": e.wrapperComponent,
        "wrapper-props": e.wrapperProps,
        "theme-style": e.theme.style,
        "button-bg-color": e.buttonBgColor,
        "button-icon-and-text-color": e.buttonIconAndTextColor,
        "is-editing": e.isEditing
      }, {
        controls: S(({ idx: l }) => [
          M(e.$slots, "controls", { idx: l }, void 0, !0)
        ]),
        icon: S(({ idx: l }) => [
          M(e.$slots, "icon", { idx: l }, void 0, !0)
        ]),
        title: S(({ title: l, idx: u }) => [
          M(e.$slots, "title", {
            title: l,
            idx: u
          }, void 0, !0)
        ]),
        _: 3
      }, 8, ["modelValue", "buttons", "wrapper-component", "wrapper-props", "theme-style", "button-bg-color", "button-icon-and-text-color", "is-editing"])
    ])
  ], 6);
}
const Goe = /* @__PURE__ */ B(Hoe, [["render", qoe], ["__scopeId", "data-v-87352126"]]), Koe = {
  name: "AboutV2",
  mixins: [ih, Rt],
  computed: {
    isDesktop() {
      return this.screenSize > 1280;
    }
  }
}, zoe = { class: "main-content" }, Zoe = {
  key: 0,
  class: "image-wrapper"
}, xoe = ["src"], Woe = ["data-testid"], Yoe = { class: "main-text" }, Xoe = ["innerHTML"];
function Qoe(e, t, n, r, o, i) {
  const a = V("IconLinkButtons");
  return d(), f("div", {
    class: _([{ editing: e.isEditing }, "about-v2"]),
    style: Z(e.colors),
    "data-testid": "AboutV2"
  }, [
    c("div", zoe, [
      c("div", {
        class: _([e.theme.style, "top-content"])
      }, [
        e.about.has_accent_logo ? (d(), f("div", Zoe, [
          t[1] || (t[1] = c("svg", {
            width: "16",
            height: "55",
            viewBox: "0 0 16 55",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "accent-icon"
          }, [
            c("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M7.67334 11.7812L7.67334 54.7812H8.67334L8.67334 11.7813L7.67334 11.7812Z",
              fill: "#000"
            }),
            c("rect", {
              width: "10.0781",
              height: "9.82776",
              transform: "matrix(0.704554 0.70965 -0.704554 0.70965 7.91162 0)",
              fill: "#000"
            })
          ], -1)),
          e.watermark ? (d(), f("img", {
            key: 0,
            src: e.watermark,
            alt: "",
            class: "left-image",
            loading: "lazy"
          }, null, 8, xoe)) : T("", !0)
        ])) : T("", !0),
        e.about.has_header ? (d(), f("h2", {
          key: 1,
          class: "header-text",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header", {}, () => [
            H(k(e.about.component_header), 1)
          ], !0)
        ], 8, Woe)) : T("", !0),
        c("span", Yoe, [
          M(e.$slots, "text", {}, () => [
            c("span", {
              innerHTML: e.about.component_text
            }, null, 8, Xoe)
          ], !0)
        ])
      ], 2),
      j(a, {
        modelValue: e.about.links,
        "onUpdate:modelValue": t[0] || (t[0] = (s) => e.about.links = s),
        buttons: e.about.links,
        "wrapper-component": e.wrapperComponent,
        "wrapper-props": e.wrapperProps,
        "theme-style": e.theme.style,
        "button-bg-color": e.buttonBgColor,
        "button-icon-and-text-color": e.buttonIconAndTextColor,
        width: i.isDesktop ? "100%" : "",
        "is-editing": e.isEditing
      }, {
        controls: S(({ idx: s }) => [
          M(e.$slots, "controls", { idx: s }, void 0, !0)
        ]),
        icon: S(({ idx: s }) => [
          M(e.$slots, "icon", { idx: s }, void 0, !0)
        ]),
        title: S(({ title: s, idx: l }) => [
          M(e.$slots, "title", {
            title: s,
            idx: l
          }, void 0, !0)
        ]),
        _: 3
      }, 8, ["modelValue", "buttons", "wrapper-component", "wrapper-props", "theme-style", "button-bg-color", "button-icon-and-text-color", "width", "is-editing"])
    ])
  ], 6);
}
const Joe = /* @__PURE__ */ B(Koe, [["render", Qoe], ["__scopeId", "data-v-3e2fce17"]]), eie = {
  name: "AboutV3",
  mixins: [ih],
  data() {
    return {
      wrapperHeight: "unset"
    };
  },
  computed: {
    aboutLinks: {
      get() {
        return this.about.links.slice(0, 5);
      },
      set(e) {
        this.about.links = e;
      }
    }
  },
  async mounted() {
    window.addEventListener("resize", this.setHeight), await this.$nextTick(), this.setHeight();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setHeight);
  },
  methods: {
    setHeight() {
      const e = this.$refs[`card-${this.aboutLinks.length - 1}`];
      if (!e)
        return;
      const t = this.$refs.cardWrapper, r = e.getBoundingClientRect().top - t.$el.getBoundingClientRect().top + e.clientHeight;
      this.wrapperHeight = `${r}px`;
    }
  }
}, tie = { class: "top-container" }, nie = ["data-testid"], rie = ["data-testid"], oie = ["innerHTML"], iie = { class: "card-top-title" }, sie = { class: "card-title" }, aie = { class: "card-image" }, lie = ["src", "alt"];
function uie(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    style: Z(e.colors),
    class: _([e.theme.style, "about-v3"])
  }, [
    c("div", tie, [
      j(a, {
        class: _([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}`,
            class: "no-border"
          }, [
            e.theme.style === "monterrey" && (e.about.component_header_top || e.isEditing) ? (d(), f("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.about.component_header_top), 1)
              ])
            ], 8, rie)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.about.component_header), 1)
            ])
          ], 8, nie)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      M(e.$slots, "text", {}, () => [
        c("span", {
          class: "text-block",
          innerHTML: e.about.component_text
        }, null, 8, oie)
      ])
    ]),
    (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
      ref: "cardWrapper",
      modelValue: i.aboutLinks,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => i.aboutLinks = s),
      style: { height: o.wrapperHeight },
      "item-key": "index",
      class: "card-wrapper"
    }), {
      item: S(({ element: s, index: l }) => [
        (d(), I(Y(e.isEditing || !s.href ? "div" : "a"), {
          ref: `card-${l}`,
          href: s.href,
          target: s.target,
          class: "card",
          "data-testid": "about-card"
        }, {
          default: S(() => [
            M(e.$slots, "controls", { idx: l }),
            c("div", {
              class: _(["card-left", e.theme.style])
            }, [
              c("div", iie, [
                M(e.$slots, "top-title", { idx: l }, () => [
                  H(k(s.top_title), 1)
                ])
              ]),
              c("div", sie, [
                M(e.$slots, "title", { idx: l }, () => [
                  H(k(s.title), 1)
                ])
              ])
            ], 2),
            c("div", aie, [
              M(e.$slots, "image", { idx: l }, () => [
                c("img", {
                  src: s.image && s.image.url,
                  alt: s.image && s.image.alt_text
                }, null, 8, lie)
              ])
            ])
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["modelValue", "style"]))
  ], 6);
}
const die = /* @__PURE__ */ B(eie, [["render", uie], ["__scopeId", "data-v-aebe3b92"]]), cie = {
  name: "About",
  components: {
    AboutV1: Goe,
    AboutV2: Joe,
    AboutV3: die
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    watermark: {
      type: String,
      default: ""
    }
  }
}, hie = { id: "view-about" };
function mie(e, t, n, r, o, i) {
  return d(), f("div", hie, [
    (d(), I(Y(n.theme.version), {
      theme: n.theme,
      about: n.content,
      "is-editing": n.isEditing,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      watermark: n.watermark
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      image: S(({ idx: a }) => [
        M(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      text: S(() => [
        M(e.$slots, "text", {}, void 0, !0)
      ]),
      controls: S(({ idx: a }) => [
        M(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      icon: S(({ idx: a }) => [
        M(e.$slots, "icon", { idx: a }, void 0, !0)
      ]),
      "top-title": S(({ idx: a }) => [
        M(e.$slots, "top-title", { idx: a }, void 0, !0)
      ]),
      title: S(({ idx: a }) => [
        M(e.$slots, "title", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "about", "is-editing", "wrapper-component", "wrapper-props", "watermark"]))
  ]);
}
const fie = /* @__PURE__ */ B(cie, [["render", mie], ["__scopeId", "data-v-602a1639"]]);
/*!
  * focus-trap-vue v4.0.2
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
const pie = {
  escapeDeactivates: {
    type: Boolean,
    default: !0
  },
  returnFocusOnDeactivate: {
    type: Boolean,
    default: !0
  },
  allowOutsideClick: {
    type: [Boolean, Function],
    default: !0
  },
  clickOutsideDeactivates: [Boolean, Function],
  initialFocus: [String, Function, Boolean],
  fallbackFocus: [String, Function],
  checkCanFocusTrap: Function,
  checkCanReturnFocus: Function,
  delayInitialFocus: {
    type: Boolean,
    default: !0
  },
  document: Object,
  preventScroll: Boolean,
  setReturnFocus: [Object, String, Boolean, Function],
  tabbableOptions: Object
}, _8 = _6({
  props: Object.assign({
    active: {
      // TODO: could be options for activate but what about the options for deactivating?
      type: Boolean,
      default: !0
    }
  }, pie),
  emits: [
    "update:active",
    "activate",
    "postActivate",
    "deactivate",
    "postDeactivate"
  ],
  render() {
    return this.renderImpl();
  },
  setup(e, { slots: t, emit: n }) {
    let r;
    const o = ho(null), i = Mn(() => {
      const s = o.value;
      return s && (s instanceof HTMLElement ? s : s.$el);
    });
    function a() {
      return r || (r = S4(i.value, {
        escapeDeactivates: e.escapeDeactivates,
        allowOutsideClick: e.allowOutsideClick,
        returnFocusOnDeactivate: e.returnFocusOnDeactivate,
        clickOutsideDeactivates: e.clickOutsideDeactivates,
        onActivate: () => {
          n("update:active", !0), n("activate");
        },
        onDeactivate: () => {
          n("update:active", !1), n("deactivate");
        },
        onPostActivate: () => n("postActivate"),
        onPostDeactivate: () => n("postDeactivate"),
        initialFocus: e.initialFocus,
        fallbackFocus: e.fallbackFocus,
        tabbableOptions: e.tabbableOptions,
        delayInitialFocus: e.delayInitialFocus,
        preventScroll: e.preventScroll
      }));
    }
    return Jc(() => {
      vs(() => e.active, (s) => {
        s && i.value ? a().activate() : r && (r.deactivate(), (!i.value || i.value.nodeType === Node.COMMENT_NODE) && (r = null));
      }, { immediate: !0, flush: "post" });
    }), C6(() => {
      r && r.deactivate(), r = null;
    }), {
      activate() {
        a().activate();
      },
      deactivate() {
        r && r.deactivate();
      },
      renderImpl() {
        if (!t.default)
          return null;
        const s = t.default().filter((u) => u.type !== w6);
        return !s || !s.length || s.length > 1 ? (console.error("[focus-trap-vue]: FocusTrap requires exactly one child."), s) : T6(s[0], { ref: o });
      }
    };
  }
});
function $t(e, ...t) {
  const n = t.find((r) => e[r]);
  return n ? e[n] : { hex: "" };
}
const gie = {
  name: "CmsAlertModal",
  components: {
    SvgClose: mi,
    FocusTrap: _8
  },
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    alertContent: {
      type: String,
      default: ""
    },
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      hideCloseBtnFocusOutline: !0,
      isActive: !0
    };
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--overlay-bg-color": $t(this.globalsInfo, "alert_lightbox_overlay").hex || "#000",
        "--container-bg-color": $t(this.globalsInfo, "alert_bg_color").hex || "#fff",
        "--body-text-color": $t(this.globalsInfo, "alert_text_color").hex || "#000",
        "--body-link-color": $t(this.globalsInfo, "alert_link_color").hex || "#000"
      };
    },
    closeBtnFocusOutlineCSSClass() {
      return this.hideCloseBtnFocusOutline ? "cms-alert-modal__close--no-focus-outline" : "";
    }
  },
  methods: {
    closeModal(e = !1) {
      this.isActive && (this.isActive = !1, this.$emit("close", { closedByKeyboard: e }));
    }
  }
}, vie = { class: "cms-alert-modal__container-wrapper" }, bie = ["aria-label"], yie = ["aria-label"], _ie = { class: "cms-alert-modal__body" }, Cie = ["innerHTML"];
function wie(e, t, n, r, o, i) {
  const a = V("SvgClose"), s = V("FocusTrap");
  return d(), f("div", {
    id: "cms-alert-modal",
    style: Z(i.colors)
  }, [
    c("div", vie, [
      j(s, {
        "initial-focus": () => e.$refs["close-button"],
        "fallback-focus": () => e.$refs["close-button"],
        active: o.isActive,
        "click-outside-deactivates": "",
        "escape-deactivates": "",
        onDeactivate: i.closeModal
      }, {
        default: S(() => [
          c("section", {
            ref: "modal-container",
            class: "cms-alert-modal__container",
            "aria-label": n.translations.legacyContainer,
            role: "alertdialog",
            "aria-modal": "true"
          }, [
            c("button", {
              ref: "close-button",
              "aria-label": n.translations.legacyBody,
              class: _(["cms-alert-modal__close", i.closeBtnFocusOutlineCSSClass]),
              "aria-describedby": "alert-modal-body",
              onClick: t[0] || (t[0] = (l) => i.closeModal()),
              onKeydown: [
                t[1] || (t[1] = K(W((l) => i.closeModal(!0), ["exact", "prevent"]), ["enter"])),
                t[2] || (t[2] = K(W((l) => i.closeModal(!0), ["exact", "prevent"]), ["space"])),
                t[3] || (t[3] = K(W((...l) => e.closeAllModals && e.closeAllModals(...l), ["exact", "prevent"]), ["esc"])),
                t[4] || (t[4] = K(W((l) => o.hideCloseBtnFocusOutline = !1, ["exact"]), ["tab"]))
              ]
            }, [
              j(a)
            ], 42, yie),
            c("div", _ie, [
              c("div", {
                id: "alert-modal-body",
                class: "cms-alert-modal__body-content",
                innerHTML: n.alertContent
              }, null, 8, Cie)
            ])
          ], 8, bie)
        ]),
        _: 1
      }, 8, ["initial-focus", "fallback-focus", "active", "onDeactivate"])
    ])
  ], 4);
}
const Tie = /* @__PURE__ */ B(gie, [["render", wie], ["__scopeId", "data-v-a8b1fc60"]]), kie = {
  name: "AlertBanner",
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    alertContent: {
      type: String,
      default: ""
    }
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--banner-bg-color": $t(this.globalsInfo, "alert_bg_color").hex || "#cc314b",
        "--banner-text-color": $t(this.globalsInfo, "alert_text_color").hex || "#fff",
        "--banner-link-color": $t(this.globalsInfo, "alert_link_color").hex || "#fff"
      };
    }
  }
}, Eie = ["innerHTML"];
function Sie(e, t, n, r, o, i) {
  return d(), f("div", {
    id: "alert-banner",
    style: Z(i.colors)
  }, [
    c("div", {
      class: "alert-banner__content",
      innerHTML: n.alertContent
    }, null, 8, Eie)
  ], 4);
}
const Mie = /* @__PURE__ */ B(kie, [["render", Sie], ["__scopeId", "data-v-ac60c6f3"]]);
function Aie(e, t, n, { maxPadding: r = 25, minPadding: o = 5, smallModalMaxRatioOfViewport: i = 0.3, largeModalMinRatioOfViewport: a = 0.9 } = {}) {
  const s = e / t;
  let l;
  if (s <= i)
    l = r;
  else if (s < a) {
    const m = (s - i) / (a - i);
    l = r - (r - o) * m;
  } else
    l = o;
  const u = Math.min(1, n / t);
  return l = l * u, Math.max(o, Math.min(l, r));
}
const Iie = {
  name: "CmsAlertModalSeparate",
  components: {
    SvgClose: mi,
    FocusTrap: _8
  },
  mixins: [Rt],
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    modalArray: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isFocusTrapActive: !1,
      containerHeight: 0
    };
  },
  mounted() {
    document.body.style.overflow = "hidden", this.focusByClassName(".close"), this.updateContainerHeight(), this.$nextTick(() => {
      this.activateFocusTrap();
    });
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
  computed: {
    dynamicPadding() {
      return typeof window != "undefined" ? `${Aie(this.containerHeight, window.innerHeight, this.screenSize)}vh` : "0vh";
    },
    globalsInfo() {
      var e;
      return (e = this.globals.info) != null ? e : {};
    },
    colors() {
      return {
        "--overlay-bg-color": $t(this.globalsInfo, "alert_lightbox_overlay").hex || "#000",
        "--container-bg-color": $t(this.globalsInfo, "alert_bg_color").hex || "#fff",
        "--body-text-color": $t(this.globalsInfo, "alert_text_color").hex || "#000",
        "--body-link-color": $t(this.globalsInfo, "alert_link_color").hex || "#000"
      };
    },
    containsMultipleModals() {
      return this.modalArray.length > 1;
    },
    containsImage() {
      return this.modalArray.some((e) => e.image.url);
    },
    containsLongText() {
      return this.modalArray.some((e) => e.content.length > 100);
    },
    svgFillColor() {
      return de(this.colors["--overlay-bg-color"]).isLight() ? "#000" : "#fff";
    }
  },
  watch: {
    screenSize() {
      this.updateContainerHeight();
    }
  },
  methods: {
    activateFocusTrap() {
      this.$refs.modalContainer && (this.isFocusTrapActive = !0, this.focusByClassName(".close"));
    },
    updateContainerHeight() {
      this.$nextTick(() => {
        this.$refs.modalContainer && (this.containerHeight = this.$refs.modalContainer.clientHeight);
      });
    },
    closeModal(e, t = !1) {
      const n = this.modalArray.length <= 1, o = { alertId: e, closedByKeyboard: n && t };
      this.$emit("close", o), n || (this.updateContainerHeight(), this.focusByClassName(".close"));
    },
    closeAllModals() {
      this.modalArray.forEach((e, t) => {
        const n = t === this.modalArray.length - 1;
        this.$emit("close", { alertId: e.id, closedByKeyboard: n });
      });
    },
    generateModalClasses() {
      return [
        this.containsMultipleModals ? "multi-modal" : "single-modal",
        this.containsImage ? "has-image" : "no-image",
        this.containsLongText ? "long-text" : "short-text"
      ];
    },
    focusByClassName(e) {
      this.$nextTick(() => {
        const t = this.$el.querySelector(e);
        t && t.focus();
      });
    }
  }
}, Lie = {
  class: "container-wrapper",
  ref: "modalContainer"
}, Die = ["onClick", "onKeydown", "aria-describedby"], $ie = {
  class: "container",
  role: "alertdialog",
  "aria-modal": "true"
}, Oie = {
  key: 0,
  class: "image"
}, Pie = ["src", "alt"], Nie = ["id"], Hie = ["innerHTML"];
function Fie(e, t, n, r, o, i) {
  const a = V("SvgClose"), s = V("FocusTrap");
  return d(), I(s, { active: o.isFocusTrapActive }, {
    default: S(() => [
      c("div", {
        class: "cms-alert-modal",
        style: Z([i.colors, { paddingTop: i.dynamicPadding }]),
        onKeydown: t[1] || (t[1] = K(W((...l) => i.closeAllModals && i.closeAllModals(...l), ["exact", "prevent"]), ["esc"]))
      }, [
        c("div", Lie, [
          (d(!0), f(J, null, ne(n.modalArray, (l, u) => (d(), f("div", {
            key: u,
            class: _(["individual-container-wrapper", ...i.generateModalClasses()])
          }, [
            c("button", {
              class: "close",
              onClick: (m) => i.closeModal(l.id),
              onKeydown: [
                K(W((m) => i.closeModal(l.id, !0), ["exact", "prevent"]), ["enter"]),
                K(W((m) => i.closeModal(l.id, !0), ["exact", "prevent"]), ["space"])
              ],
              "aria-describedby": `alert-modal-body-'${l.id}`
            }, [
              j(a, { "fill-color": i.svgFillColor }, null, 8, ["fill-color"])
            ], 40, Die),
            c("section", $ie, [
              l.image.url ? (d(), f("div", Oie, [
                c("img", {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  onLoad: t[0] || (t[0] = (...m) => i.updateContainerHeight && i.updateContainerHeight(...m))
                }, null, 40, Pie)
              ])) : T("", !0),
              l.content ? (d(), f("div", {
                key: 1,
                id: "alert-modal-body-" + l.id,
                class: "body"
              }, [
                c("div", {
                  class: "body-content",
                  innerHTML: l.content
                }, null, 8, Hie)
              ], 8, Nie)) : T("", !0)
            ])
          ], 2))), 128))
        ], 512)
      ], 36)
    ]),
    _: 1
  }, 8, ["active"]);
}
const Rie = /* @__PURE__ */ B(Iie, [["render", Fie], ["__scopeId", "data-v-e619a4b5"]]), Vie = {
  name: "CmsAlertBannerSeparate",
  components: {
    SvgClose: mi
  },
  data() {
    return {
      hideCloseBtnFocusOutline: !0
    };
  },
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    bannerArray: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--banner-bg-color": $t(this.globalsInfo, "alert_bg_color").hex || "#cc314b",
        "--banner-text-color": $t(this.globalsInfo, "alert_text_color").hex || "#fff",
        "--banner-link-color": $t(this.globalsInfo, "alert_link_color").hex || "#fff"
      };
    },
    closeBtnFocusOutlineCSSClass() {
      return this.hideCloseBtnFocusOutline ? "no-focus-outline" : "";
    },
    svgFillColor() {
      return de(this.colors["--banner-bg-color"]).isLight() ? "#000" : "#fff";
    }
  },
  methods: {
    closeBanner(e) {
      this.$emit("close", { alertId: e });
    }
  }
}, Bie = { class: "alert-banners" }, jie = { class: "banner-wrapper" }, Uie = ["innerHTML"], qie = ["onClick", "onKeydown"];
function Gie(e, t, n, r, o, i) {
  const a = V("SvgClose");
  return d(), f("div", Bie, [
    (d(!0), f(J, null, ne(n.bannerArray, (s) => (d(), f("div", {
      key: s.id,
      class: "banner",
      style: Z(i.colors)
    }, [
      c("div", jie, [
        c("div", {
          class: "content",
          innerHTML: s.content
        }, null, 8, Uie),
        c("button", {
          class: _(["close", i.closeBtnFocusOutlineCSSClass]),
          onClick: (l) => i.closeBanner(s.id),
          onKeydown: [
            K(W((l) => i.closeBanner(s.id), ["exact", "prevent"]), ["enter"]),
            K(W((l) => i.closeBanner(s.id), ["exact", "prevent"]), ["space"]),
            t[0] || (t[0] = K(W((l) => o.hideCloseBtnFocusOutline = !1, ["exact"]), ["tab"]))
          ]
        }, [
          j(a, { "fill-color": i.svgFillColor }, null, 8, ["fill-color"])
        ], 42, qie)
      ])
    ], 4))), 128))
  ]);
}
const Kie = /* @__PURE__ */ B(Vie, [["render", Gie], ["__scopeId", "data-v-7140ef94"]]), zie = {
  name: "Parallax",
  props: {
    config: {
      type: Object,
      required: !0
    }
  }
}, Zie = { class: "parallax-section" }, xie = {
  ref: "parallax",
  class: "parallax-container"
}, Wie = { class: "image-container" }, Yie = ["src"];
function Xie(e, t, n, r, o, i) {
  return d(), f("div", Zie, [
    c("div", xie, [
      c("div", {
        class: "parallax",
        style: Z({ backgroundImage: `url(${n.config.background_image.url})` })
      }, null, 4)
    ], 512),
    c("div", Wie, [
      c("img", {
        class: "full-image",
        src: n.config.background_image.url
      }, null, 8, Yie)
    ])
  ]);
}
const Qie = /* @__PURE__ */ B(zie, [["render", Xie], ["__scopeId", "data-v-e745b867"]]), Jie = {
  computed: {
    colors() {
      return {
        "--button-one-bg-color": $(this.theme, "button_one.bg_color.hex", "#333"),
        "--button-one-icon-and-text-color": $(this.theme, "button_one.icon_and_text_color.hex", "#fff"),
        "--button-two-bg-color": $(this.theme, "button_two.bg_color.hex", "#fff"),
        "--button-two-icon-and-text-color": $(this.theme, "button_two.icon_and_text_color.hex", "#333"),
        "--button-three-bg-color": $(this.theme, "button_three.bg_color.hex", "#333"),
        "--button-three-icon-and-text-color": $(this.theme, "button_three.icon_and_text_color.hex", "#fff"),
        "--button-four-bg-color": $(this.theme, "button_four.bg_color.hex", "#fff"),
        "--button-four-icon-and-text-color": $(this.theme, "button_four.icon_and_text_color.hex", "#333"),
        "--button-five-bg-color": $(this.theme, "button_five.bg_color.hex", "#333"),
        "--button-five-icon-and-text-color": $(this.theme, "button_five.icon_and_text_color.hex", "#fff"),
        "--button-mobile-bg-color": $(this.theme, "button_mobile.bg_color.hex", "#333"),
        "--button-mobile-icon-and-text-color": $(this.theme, "button_mobile.icon_and_text_color.hex", "#fff")
      };
    },
    translations() {
      return $(this.theme, "translations", {});
    }
  }
}, ese = {
  name: "MobileSvgArrow",
  props: {
    fillColor: {
      type: String,
      required: !0
    }
  }
}, tse = {
  width: "17",
  height: "16",
  viewBox: "0 0 19 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nse = ["fill"];
function rse(e, t, n, r, o, i) {
  return d(), f("svg", tse, [
    c("path", {
      d: "M18 9C18.5523 9 19 8.55228 19 8C19 7.44772 18.5523 7 18 7L18 9ZM0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM18 7L1 7L1 9L18 9L18 7Z",
      fill: n.fillColor
    }, null, 8, nse)
  ]);
}
const ose = /* @__PURE__ */ B(ese, [["render", rse]]), ise = {
  name: "FN1",
  components: {
    mobileNavIcon: ose
  },
  mixins: [Jie],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    floatingNav: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      navExpanded: !1,
      pageYOffset: 0
    };
  },
  computed: {
    buttonShape() {
      return this.floatingNav.shape;
    },
    navPosition() {
      return this.floatingNav.is_fixed ? "nav-fixed" : "nav-absolute";
    },
    mobileFill() {
      return $(this.theme, "button_mobile.icon_and_text_color.hex", "#fff");
    },
    isScrolled() {
      return this.pageYOffset > 100;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    togglePanel() {
      this.navExpanded = !this.navExpanded;
    },
    buttonHref(e) {
      return e.mailto ? `mailto:${e.email_address}` : e.url;
    },
    onScroll() {
      this.pageYOffset = window.pageYOffset;
    }
  }
}, sse = { class: "nav-wrapper" }, ase = { class: "button-link" }, lse = { class: "link-wrapper" }, use = ["href", "target"], dse = { class: "link-wrapper" }, cse = {
  class: "icon-wrapper",
  "data-testid": "svg",
  "aria-hidden": "true"
}, hse = { class: "raw-svg" }, mse = ["innerHTML"];
function fse(e, t, n, r, o, i) {
  const a = V("mobile-nav-icon");
  return d(), f("div", {
    id: "floating-nav",
    "data-testid": "FN1",
    class: _([i.navPosition, { "is-scrolled": i.isScrolled }]),
    style: Z([e.colors])
  }, [
    c("div", sse, [
      c("div", {
        class: _(["mobile-menu-button button", [i.buttonShape, { expanded: o.navExpanded }]]),
        onClick: t[0] || (t[0] = (...s) => i.togglePanel && i.togglePanel(...s))
      }, [
        c("div", ase, [
          c("div", lse, [
            c("div", {
              class: _(["icon-wrapper", { expanded: o.navExpanded }]),
              "data-testid": "svg",
              "aria-hidden": "true"
            }, [
              j(a, { "fill-color": i.mobileFill }, null, 8, ["fill-color"])
            ], 2),
            c("span", {
              class: _(["button-title", n.theme.style])
            }, k(e.translations.mobile_menu_title || "Collapse Menu"), 3)
          ])
        ])
      ], 2),
      c("div", {
        class: _(["button-wrapper", o.navExpanded ? "expanded" : "hiddenButtons"])
      }, [
        (d(!0), f(J, null, ne(n.floatingNav.buttons, (s, l) => (d(), f("div", {
          key: `floating-nav-${l}`,
          class: _(["button", i.buttonShape]),
          "data-testid": "fn1-button"
        }, [
          c("a", {
            class: _(["button-link", n.theme.style]),
            href: i.buttonHref(s),
            target: s.opens_in_new_tab ? "_blank" : "",
            "data-testid": "links"
          }, [
            c("div", dse, [
              c("div", cse, [
                c("span", hse, [
                  c("span", {
                    "data-testid": "svg",
                    innerHTML: s.icon
                  }, null, 8, mse)
                ])
              ]),
              c("span", {
                class: _(["button-title", n.theme.style])
              }, k(s.title), 3)
            ])
          ], 10, use)
        ], 2))), 128))
      ], 2)
    ])
  ], 6);
}
const pse = /* @__PURE__ */ B(ise, [["render", fse], ["__scopeId", "data-v-b318b410"]]), gse = {
  name: "FloatingNav",
  components: {
    FN1: pse
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    floatingNav: {
      type: Object,
      default: () => ({})
    }
  }
};
function vse(e, t, n, r, o, i) {
  return d(), I(Y(n.theme.version), {
    theme: n.theme,
    "floating-nav": n.floatingNav
  }, null, 8, ["theme", "floating-nav"]);
}
const bse = /* @__PURE__ */ B(gse, [["render", vse]]), sh = {
  mixins: [kt],
  components: { DraggableWrapper: vt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    blocks: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    blockHasLink(e) {
      var t;
      return !this.isEditing && ((t = e.link) == null ? void 0 : t.href);
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--description-color": $(this.theme, "description_color.hex", "initial"),
        "--arrow-icon-color": $(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "initial"),
        "--pager-color": $(this.theme, "pager_color.hex", "#ffffff"),
        "--box-text-color": $(this.theme, "box_text_color.hex", "#000000"),
        "--box-bg-color": $(this.theme, "box_bg_color.hex", "#ffffff"),
        "--box-gradient-color": $(this.theme, "gradient_overlay.hex", "#ffffff")
      });
    },
    translations() {
      return this.theme.translations;
    },
    content() {
      return this.blocks.content;
    }
  }
}, yse = {
  name: "OS1",
  components: { CardSlider: cn },
  mixins: [bt, sh],
  computed: {
    sliderCenterSize() {
      return 599;
    },
    showDescription() {
      return this.blocks.has_description && !Br(this.blocks.component_header_description) || this.blocks.has_description && this.isEditing;
    },
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    }
  },
  methods: {
    fourCardColorPattern(e) {
      return `card-style-${e % 5 + 1}`;
    }
  }
}, _se = { class: "header-wrapper" }, Cse = ["data-testid"], wse = ["data-testid"], Tse = {
  key: 0,
  class: "header-description",
  "data-testid": "component-header-description"
}, kse = ["data-testid", "aria-label"], Ese = { class: "box" };
function Sse(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "our-schools-v1",
    "data-testid": "OS1",
    class: _([e.theme.style, e.isEditing && "editing"]),
    style: Z(e.colors)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("div", _se, [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (d(), f("span", {
              key: 0,
              class: "header-top",
              "data-testid": `header-${e.theme.style}-top`
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.blocks.component_header_top), 1)
              ], !0)
            ], 8, wse)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.blocks.component_header), 1)
            ], !0)
          ], 8, Cse),
          i.showDescription ? (d(), f("div", Tse, [
            M(e.$slots, "header-description", {}, () => [
              H(k(e.blocks.component_header_description), 1)
            ], !0)
          ])) : T("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      class: _({ "all-cards-visible": e.allCardsVisible }),
      "nav-orientation": "wide",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "total-cards": e.blocks.content.length,
      "theme-styles": e.theme,
      "section-header": e.blocks.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        (d(), I(Y(e.wrapperComponent), Se({
          ref: "scrollWrapper",
          modelValue: e.blocks.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.blocks.content = l),
          class: ["scroll-wrapper", { "all-cards-visible": e.allCardsVisible }]
        }, e.wrapperProps, {
          "item-key": "index",
          "data-testid": "blocks-array"
        }), {
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              class: _([[`card-${u + 1}`, i.fourCardColorPattern(u)], "our-schools"]),
              "data-testid": `Card${u + 1}`,
              role: "group",
              "aria-roledescription": "slide",
              "aria-label": `${u + 1} of ${e.blocks.content.length}`
            }, [
              M(e.$slots, "controls", { idx: u }, void 0, !0),
              (d(), I(Y(e.blockHasLink(l) ? "a" : "div"), {
                href: e.blockHasLink(l) && l.link.href,
                role: e.blockHasLink(l) && "link",
                target: e.blockHasLink(l) && l.link.target,
                "data-testid": "block-link"
              }, {
                default: S(() => [
                  c("span", Ese, [
                    M(e.$slots, "box", { idx: u }, () => [
                      H(k(l.box), 1)
                    ], !0)
                  ]),
                  M(e.$slots, "image", { idx: u }, () => [
                    (d(), I(Y(l.image ? "img" : "div"), {
                      src: l.image.url,
                      alt: l.link.href ? "" : l.image.alt_text,
                      class: "our-schools-image",
                      "data-testid": "block-image",
                      loading: "lazy"
                    }, null, 8, ["src", "alt"]))
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "role", "target"]))
            ], 10, kse)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["class", "current-card", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const Mse = /* @__PURE__ */ B(yse, [["render", Sse], ["__scopeId", "data-v-cd6f874a"]]), Ase = {
  name: "OS2",
  mixins: [sh],
  data() {
    return {
      hoverIndex: -1
    };
  },
  computed: {
    colorsWithOpacity() {
      const e = this.colors["--box-gradient-color"], t = `rgba(${Rf(e, 1)})`, n = `rgba(${Rf(e, 0)})`;
      return ge(ae({}, this.colors), {
        "--box-bg-color-initial-opacity": t,
        "--box-bg-color-final-opacity": n
      });
    },
    columnClass() {
      return this.blocks.content.length <= 3 ? "three-column" : this.blocks.num_columns === 4 ? "four-column" : "three-column";
    }
  }
}, Ise = ["data-testid"], Lse = ["data-testid"], Dse = ["onMouseover"], $se = ["src", "alt"], Ose = {
  key: 1,
  class: "our-schools-image"
}, Pse = {
  key: 1,
  class: "title-container",
  "data-testid": "no-link-block",
  maxlength: "26"
};
function Nse(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["our-schools-v2", e.theme.style]),
    "data-testid": "OS2",
    style: Z(i.colorsWithOpacity)
  }, [
    j(a, {
      class: _(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`,
          class: _({ "no-border": e.theme.style === "bold" })
        }, [
          e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.blocks.component_header_top), 1)
            ], !0)
          ], 8, Lse)) : T("", !0),
          M(e.$slots, "header", {
            dataTestid: `header-${e.theme.style}`
          }, () => [
            H(k(e.blocks.component_header), 1)
          ], !0)
        ], 10, Ise)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.blocks.content,
      "onUpdate:modelValue": t[1] || (t[1] = (s) => e.blocks.content = s),
      class: "our-schools-wrapper",
      "data-testid": "blocks-array",
      "item-key": "index"
    }), {
      item: S(({ element: s, index: l }) => [
        c("div", {
          class: _(["block", i.columnClass]),
          "data-testid": "our-schools-block-content"
        }, [
          M(e.$slots, "controls", { idx: l }, void 0, !0),
          c("div", {
            class: "image-wrapper image-border-accent",
            role: "dialog",
            onMouseover: (u) => o.hoverIndex = l,
            onMouseleave: t[0] || (t[0] = (u) => o.hoverIndex = -1)
          }, [
            s.image.url ? (d(), f("img", {
              key: 0,
              src: s.image.url,
              alt: s.image.alt_text,
              loading: "lazy",
              class: "our-schools-image"
            }, null, 8, $se)) : (d(), f("div", Ose)),
            c("div", {
              class: _([[
                e.theme.style,
                {
                  "hover-enter": o.hoverIndex === l
                }
              ], "content-box gradient"])
            }, null, 2),
            c("div", {
              class: _([e.theme.style, "title"])
            }, [
              s.link.href ? (d(), I(Y(e.isEditing ? "div" : "a"), {
                key: 0,
                class: "title-container",
                "data-testid": "link-block",
                href: s.link.href,
                target: s.link.target || "_self"
              }, {
                default: S(() => [
                  M(e.$slots, "box", { idx: l }, () => [
                    H(k(s.box), 1)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "target"])) : (d(), f("p", Pse, [
                M(e.$slots, "box", { idx: l }, () => [
                  H(k(s.box), 1)
                ], !0)
              ]))
            ], 2)
          ], 40, Dse)
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Hse = /* @__PURE__ */ B(Ase, [["render", Nse], ["__scopeId", "data-v-fe3d0b84"]]), Fse = {
  name: "OS3",
  mixins: [sh],
  computed: {
    OS3Colors() {
      var e, t;
      return ge(ae({}, this.colors), {
        "--icon-color": ((e = this.theme.icon_color) == null ? void 0 : e.hex) || "#fff",
        "--icon-bg-color": ((t = this.theme.icon_bg_color) == null ? void 0 : t.hex) || "#000"
      });
    }
  },
  methods: {
    isLink({ link: e }) {
      return !this.isEditing && (e == null ? void 0 : e.href) && this.blocks.has_link;
    }
  }
}, Rse = {
  key: 0,
  class: "header-top"
}, Vse = {
  key: 0,
  class: "our-schools-icon"
}, Bse = {
  class: "icon-wrapper",
  "aria-hidden": "true"
}, jse = { class: "raw-svg" }, Use = ["innerHTML"];
function qse(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["our-schools-v3", e.theme.style]),
    style: Z(i.OS3Colors)
  }, [
    j(a, {
      class: _(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          class: _({ "no-border": e.theme.style === "bold" })
        }, [
          e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (d(), f("span", Rse, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.blocks.component_header_top), 1)
            ], !0)
          ])) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.blocks.component_header), 1)
          ], !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.blocks.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.blocks.content = s),
      class: "our-schools-wrapper",
      "item-key": "index"
    }), {
      item: S(({ element: s, index: l }) => {
        var u, m;
        return [
          (d(), I(Y(i.isLink(s) ? "a" : "div"), {
            href: i.isLink(s) ? (u = s.link) == null ? void 0 : u.href : void 0,
            target: i.isLink(s) ? (m = s.link) == null ? void 0 : m.target : void 0,
            class: "our-schools-block"
          }, {
            default: S(() => [
              M(e.$slots, "controls", { idx: l }, void 0, !0),
              (d(), I(Y(s.image ? "img" : "div"), {
                src: s.image.url,
                class: "our-schools-image",
                loading: "lazy",
                alt: ""
              }, null, 8, ["src"])),
              c("div", {
                class: _(["our-schools-block-text", e.theme.style])
              }, [
                M(e.$slots, "box", { idx: l }, () => [
                  H(k(s.box), 1)
                ], !0)
              ], 2),
              s.icon || e.isEditing ? (d(), f("div", Vse, [
                c("div", Bse, [
                  c("span", jse, [
                    M(e.$slots, "icon", { idx: l }, () => [
                      c("span", {
                        innerHTML: s.icon
                      }, null, 8, Use)
                    ], !0)
                  ])
                ])
              ])) : T("", !0)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ];
      }),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Gse = /* @__PURE__ */ B(Fse, [["render", qse], ["__scopeId", "data-v-75f4750e"]]), Kse = {
  name: "CmsOurSchools",
  components: {
    OS1: Mse,
    OS2: Hse,
    OS3: Gse
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  }
}, zse = { class: "our-schools-container" };
function Zse(e, t, n, r, o, i) {
  return d(), f("div", zse, [
    (d(), I(Y(n.theme.version), {
      theme: n.theme,
      blocks: n.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "is-editing": n.isEditing
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      "header-bottom": S(() => [
        M(e.$slots, "header-bottom", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      "header-description": S(() => [
        M(e.$slots, "header-description", {}, void 0, !0)
      ]),
      controls: S(({ idx: a }) => [
        M(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      image: S(({ idx: a }) => [
        M(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      box: S(({ idx: a }) => [
        M(e.$slots, "box", { idx: a }, void 0, !0)
      ]),
      icon: S(({ idx: a }) => [
        M(e.$slots, "icon", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "blocks", "wrapper-component", "wrapper-props", "is-editing"]))
  ]);
}
const xse = /* @__PURE__ */ B(Kse, [["render", Zse], ["__scopeId", "data-v-89630ecf"]]), Wse = {
  components: {
    CustomHtml: Gs
  },
  props: {
    theme: {
      type: Object,
      default: () => {
      }
    },
    content: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    processedTheme() {
      if (!this.theme.section || this.theme.section.type === "none" || Br(this.content))
        return this.theme;
      let e = "";
      try {
        e = V3(this.theme.html_code, this.theme.section.type, this.content);
      } catch (t) {
        e = t;
      }
      return ge(ae({}, this.theme), {
        html_code: e
      });
    }
  }
}, Yse = { class: "media-custom-code" };
function Xse(e, t, n, r, o, i) {
  const a = V("CustomHtml");
  return d(), f("div", Yse, [
    j(a, { theme: i.processedTheme }, null, 8, ["theme"])
  ]);
}
const Qse = /* @__PURE__ */ B(Wse, [["render", Xse]]), C8 = {
  mixins: [kt],
  components: { DraggableWrapper: vt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isActive: !1,
      isOverflow: !1,
      debouncedHandleResize: null,
      hasShadowLeft: !1,
      hasShadowRight: !1
    };
  },
  created() {
    this.isActive = this.isPreview || this.isEditing, this.debouncedHandleResize = mo(this.handleResize, 100);
  },
  mounted() {
    this.handleResize(), window.addEventListener("resize", this.debouncedHandleResize), window.addEventListener("scroll", this.onWindowScroll);
  },
  unmounted() {
    window.removeEventListener("resize", this.debouncedHandleResize), window.removeEventListener("scroll", this.onWindowScroll);
  },
  methods: {
    handleResize() {
      this.isOverflow = this.$refs.flexWrapper.scrollWidth > this.$refs.scrollWrapper.offsetWidth, this.handleScroll();
    },
    handleScroll() {
      const e = this.$refs.scrollWrapper;
      if (!e || !this.isOverflow) {
        this.hasShadowLeft = !1, this.hasShadowRight = !1;
        return;
      }
      this.hasShadowLeft = e.scrollLeft > 0, this.hasShadowRight = e.scrollWidth - e.scrollLeft - e.clientWidth > 1;
    },
    onScroll(e = "left", t = 120) {
      const o = {
        left: t * (e === "left" ? -1 : 1),
        behavior: "smooth"
      };
      this.$refs.scrollWrapper.scrollBy(ae({}, o));
    },
    stickyFooterActiveToggle() {
      this.isActive = !this.isActive;
    },
    onWindowScroll() {
      window.scrollY > window.innerHeight / 2 && (this.isActive = !0, window.removeEventListener("scroll", this.onWindowScroll));
    }
  },
  computed: {
    toggleButtonText() {
      return this.isActive ? this.content.hide_text_label || "hide" : this.content.show_text_label || "show";
    },
    hasPillButton() {
      return this.content.show_pill_button || this.isPreview;
    },
    hasSocialIcons() {
      return this.content.show_social_icons || this.isPreview;
    },
    cssVars() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--bg-color": $(this.theme, "bg_color.hex", "#333"),
        "--hide-button-and-bar-color": $(this.theme, "hide_button_and_bar_color.hex", "#f8cb43"),
        "--hide-button-text-color": $(this.theme, "hide_button_text_color.hex", "#fff"),
        "--icon-color": $(this.theme, "icon_color.hex", "#fff"),
        "--icon-text-color": $(this.theme, "icon_text_color.hex", "#fff"),
        "--social-media-icon-color": $(this.theme, "social_media_icon_color.hex", "#fff"),
        "--pill-button-color": $(this.theme, "pill_button_color.hex", "#f8cb43"),
        "--pill-button-text-color": $(this.theme, "pill_button_text_color.hex", "#333"),
        "--separator-color": $(this.theme, "separator_color.hex", "#fff"),
        "--scroll-shadow-color": `${x0($(this.theme, "bg_color.hex", "#333")).join(", ")}`
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, Jse = {
  name: "StickyFooterV1",
  mixins: [C8]
}, eae = { class: "text" }, tae = {
  ref: "scrollWrapper",
  class: "scroll-wrapper"
}, nae = {
  ref: "flexWrapper",
  class: "flex-wrapper"
}, rae = { class: "icon-wrapper" }, oae = ["innerHTML"], iae = { class: "title" }, sae = { class: "icon-wrapper" }, aae = ["innerHTML"];
function lae(e, t, n, r, o, i) {
  return d(), f("div", {
    class: _(["sticky-footer-v1", [
      e.theme.style,
      {
        "sf-active": e.isActive,
        "sf-overflow": e.isOverflow,
        "sf-editing": e.isEditing
      }
    ]]),
    style: Z(e.cssVars),
    "data-testid": "StickyFooterV1"
  }, [
    M(e.$slots, "toggle", {}, () => [
      c("button", {
        class: _(["hs-toggle-button", [{ "sf-active": e.isActive }]]),
        onClick: t[0] || (t[0] = (...a) => e.stickyFooterActiveToggle && e.stickyFooterActiveToggle(...a))
      }, [
        c("span", eae, k(e.toggleButtonText), 1),
        c("div", {
          class: _(["icon-arrow", { "sf-active": e.isActive }])
        }, null, 2)
      ], 2)
    ], !0),
    c("div", tae, [
      e.isOverflow ? (d(), f("button", {
        key: 0,
        class: "scroll-button left",
        onClick: t[1] || (t[1] = (a) => e.onScroll("left"))
      }, t[5] || (t[5] = [
        c("div", { class: "icon-arrow" }, null, -1)
      ]))) : T("", !0),
      c("div", nae, [
        e.hasPillButton ? (d(), I(Y(e.isEditing ? "div" : "a"), {
          key: 0,
          class: "pill-button",
          "data-testid": "pill-button",
          href: e.content.pill_button.link,
          target: e.content.pill_button.opens_in_new_tab ? "_blank" : ""
        }, {
          default: S(() => [
            M(e.$slots, "pill-button-controls", {}, void 0, !0),
            M(e.$slots, "pill-button-title", {}, () => [
              H(k(e.content.pill_button.title), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["href", "target"])) : T("", !0),
        (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
          modelValue: e.content.icon_buttons,
          "onUpdate:modelValue": t[2] || (t[2] = (a) => e.content.icon_buttons = a),
          "item-key": "index",
          class: "icon-buttons"
        }), {
          item: S(({ element: a, index: s }) => [
            (d(), I(Y(e.isEditing ? "div" : "a"), {
              id: a.icon_id,
              class: "button",
              "data-testid": "icon-button",
              href: a.link,
              target: a.opens_in_new_tab ? "_blank" : ""
            }, {
              default: S(() => [
                M(e.$slots, "icon-button-controls", { idx: s }, void 0, !0),
                c("div", rae, [
                  M(e.$slots, "icon-button-icon", { idx: s }, () => [
                    c("span", {
                      innerHTML: a.icon
                    }, null, 8, oae)
                  ], !0)
                ]),
                c("span", iae, [
                  M(e.$slots, "icon-button-title", { idx: s }, () => [
                    H(k(a.title), 1)
                  ], !0)
                ])
              ]),
              _: 2
            }, 1032, ["id", "href", "target"]))
          ]),
          _: 3
        }, 16, ["modelValue"])),
        e.hasSocialIcons ? (d(), I(Y(e.wrapperComponent), Se({ key: 1 }, e.wrapperProps, {
          modelValue: e.content.social_media_icons,
          "onUpdate:modelValue": t[3] || (t[3] = (a) => e.content.social_media_icons = a),
          "item-key": "index",
          class: "social-media"
        }), {
          item: S(({ element: a, index: s }) => [
            (d(), I(Y(e.isEditing ? "div" : "a"), {
              id: a.icon_id,
              class: "icons",
              "data-testid": "social-media-button",
              href: a.link,
              target: a.opens_in_new_tab ? "_blank" : ""
            }, {
              default: S(() => [
                M(e.$slots, "social-media-controls", { idx: s }, void 0, !0),
                c("div", sae, [
                  M(e.$slots, "social-media-icon", { idx: s }, () => [
                    c("span", {
                      innerHTML: a.icon
                    }, null, 8, aae)
                  ], !0)
                ])
              ]),
              _: 2
            }, 1032, ["id", "href", "target"]))
          ]),
          _: 3
        }, 16, ["modelValue"])) : T("", !0)
      ], 512),
      e.isOverflow ? (d(), f("button", {
        key: 1,
        class: "scroll-button right",
        onClick: t[4] || (t[4] = (a) => e.onScroll("right"))
      }, t[6] || (t[6] = [
        c("div", { class: "icon-arrow" }, null, -1)
      ]))) : T("", !0)
    ], 512)
  ], 6);
}
const uae = /* @__PURE__ */ B(Jse, [["render", lae], ["__scopeId", "data-v-8cad4dcb"]]), dae = {
  name: "StickyFooterV2",
  mixins: [C8]
}, cae = ["aria-expanded"], hae = { class: "text" }, mae = { class: "icon-wrapper" }, fae = ["innerHTML"], pae = { class: "icon-wrapper" }, gae = ["innerHTML"], vae = { class: "title" };
function bae(e, t, n, r, o, i) {
  var a, s;
  return d(), f("div", {
    class: _(["sticky-footer-v2", [e.theme.style]]),
    style: Z(e.cssVars),
    "data-testid": "StickyFooterV2"
  }, [
    c("div", {
      class: _(["sticky-footer-wrapper", [
        {
          "sf-active": e.isActive,
          "sf-overflow": e.isOverflow,
          "sf-editing": e.isEditing
        }
      ]])
    }, [
      M(e.$slots, "toggle", {}, () => [
        c("button", {
          class: _(["hs-toggle-button", [{ "sf-active": e.isActive }]]),
          "aria-label": "Toggle Footer",
          "aria-expanded": e.isActive,
          onClick: t[0] || (t[0] = (...l) => e.stickyFooterActiveToggle && e.stickyFooterActiveToggle(...l))
        }, [
          c("span", hae, k(e.toggleButtonText), 1),
          c("span", {
            class: _(["icon-arrow", { "sf-active": e.isActive }])
          }, null, 2)
        ], 10, cae)
      ], !0),
      c("div", {
        ref: "scrollWrapper",
        class: _(["scroll-wrapper", { "has-shadow-left": e.hasShadowLeft, "has-shadow-right": e.hasShadowRight }]),
        onScrollPassive: t[5] || (t[5] = (...l) => e.handleScroll && e.handleScroll(...l))
      }, [
        e.isOverflow ? (d(), f("button", {
          key: 0,
          "aria-label": "Scroll left",
          class: "scroll-button left",
          onClick: t[1] || (t[1] = (l) => e.onScroll("left"))
        }, t[6] || (t[6] = [
          c("span", { class: "icon-arrow" }, null, -1)
        ]))) : T("", !0),
        c("div", {
          ref: "flexWrapper",
          class: _(["flex-wrapper", { center: !e.hasSocialIcons && !e.hasPillButton }])
        }, [
          e.hasSocialIcons ? (d(), I(Y(e.wrapperComponent), Se({ key: 0 }, e.wrapperProps, {
            modelValue: e.content.social_media_icons,
            "onUpdate:modelValue": t[2] || (t[2] = (l) => e.content.social_media_icons = l),
            "item-key": "index",
            class: "social-media"
          }), {
            item: S(({ element: l, index: u }) => [
              (d(), I(Y(e.isEditing ? "div" : "a"), {
                id: l.icon_id,
                class: "icons",
                "data-testid": "social-media-button",
                href: l.link,
                target: l.opens_in_new_tab ? "_blank" : ""
              }, {
                default: S(() => [
                  c("div", mae, [
                    M(e.$slots, "social-media-icon", { idx: u }, () => [
                      c("span", {
                        innerHTML: l.icon
                      }, null, 8, fae)
                    ], !0)
                  ]),
                  M(e.$slots, "social-media-controls", { idx: u }, void 0, !0)
                ]),
                _: 2
              }, 1032, ["id", "href", "target"]))
            ]),
            _: 3
          }, 16, ["modelValue"])) : T("", !0),
          (d(), I(Y(e.wrapperComponent), Se(e.wrapperProps, {
            modelValue: e.content.icon_buttons,
            "onUpdate:modelValue": t[3] || (t[3] = (l) => e.content.icon_buttons = l),
            "item-key": "index",
            class: "icon-buttons"
          }), {
            item: S(({ element: l, index: u }) => [
              (d(), I(Y(e.isEditing ? "div" : "a"), {
                id: l.icon_id,
                class: "button",
                "data-testid": "icon-button",
                href: l.link,
                target: l.opens_in_new_tab ? "_blank" : ""
              }, {
                default: S(() => [
                  c("div", pae, [
                    M(e.$slots, "icon-button-icon", { idx: u }, () => [
                      c("span", {
                        innerHTML: l.icon
                      }, null, 8, gae)
                    ], !0)
                  ]),
                  c("span", vae, [
                    M(e.$slots, "icon-button-title", { idx: u }, () => [
                      H(k(l.title), 1)
                    ], !0)
                  ]),
                  M(e.$slots, "icon-button-controls", { idx: u }, void 0, !0)
                ]),
                _: 2
              }, 1032, ["id", "href", "target"]))
            ]),
            _: 3
          }, 16, ["modelValue"])),
          e.hasPillButton ? (d(), I(Y(e.isEditing ? "div" : "a"), {
            key: 1,
            class: "pill-button",
            "data-testid": "pill-button",
            href: (a = e.content.pill_button) == null ? void 0 : a.link,
            target: (s = e.content.pill_button) != null && s.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "pill-button-title", {}, () => {
                var l;
                return [
                  H(k((l = e.content.pill_button) == null ? void 0 : l.title), 1)
                ];
              }, !0),
              M(e.$slots, "pill-button-controls", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["href", "target"])) : T("", !0)
        ], 2),
        e.isOverflow ? (d(), f("button", {
          key: 1,
          "aria-label": "Scroll right",
          class: "scroll-button right",
          onClick: t[4] || (t[4] = (l) => e.onScroll("right"))
        }, t[7] || (t[7] = [
          c("span", { class: "icon-arrow" }, null, -1)
        ]))) : T("", !0)
      ], 34)
    ], 2)
  ], 6);
}
const yae = /* @__PURE__ */ B(dae, [["render", bae], ["__scopeId", "data-v-5c33ff1d"]]), _ae = {
  name: "StickyFooter",
  components: {
    StickyFooterV1: uae,
    StickyFooterV2: yae
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function Cae(e, t, n, r, o, i) {
  return d(), I(Y(n.theme.version), {
    theme: n.theme,
    content: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-preview": n.isPreview,
    "is-editing": n.isEditing
  }, {
    toggle: S(() => [
      M(e.$slots, "toggle")
    ]),
    "pill-button-controls": S(() => [
      M(e.$slots, "pill-button-controls")
    ]),
    "pill-button-title": S(({ title: a }) => [
      M(e.$slots, "pill-button-title", { title: a })
    ]),
    "icon-button-controls": S(({ idx: a }) => [
      M(e.$slots, "icon-button-controls", { idx: a })
    ]),
    "icon-button-title": S(({ title: a, idx: s }) => [
      M(e.$slots, "icon-button-title", {
        title: a,
        idx: s
      })
    ]),
    "icon-button-icon": S(({ idx: a }) => [
      M(e.$slots, "icon-button-icon", { idx: a })
    ]),
    "social-media-controls": S(({ idx: a }) => [
      M(e.$slots, "social-media-controls", { idx: a })
    ]),
    "social-media-icon": S(({ idx: a }) => [
      M(e.$slots, "social-media-icon", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "is-preview", "is-editing"]);
}
const wae = /* @__PURE__ */ B(_ae, [["render", Cae]]), Tae = {
  name: "CustomComponent",
  components: { DraggableWrapper: vt },
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: Object,
      default: vt,
      validator(e) {
        return (e == null ? void 0 : e.name) === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    }
  },
  computed: {
    cssCode() {
      return this.theme.css_code;
    },
    jsCode() {
      return this.theme.js_code;
    },
    htmlTree() {
      let e = {};
      try {
        e = UV(this.theme.html_code);
      } catch (t) {
        e = "";
      }
      return e;
    }
  },
  watch: {
    cssCode(e, t) {
      this.hasNewValue(e, t) && this.mountCss(e);
    },
    jsCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(e);
    },
    htmlCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(this.jsCode);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mountCss(this.cssCode), this.mountJs(this.jsCode);
    });
  },
  methods: {
    customComponent(e) {
      return {
        "cms-input": { slotName: "input", tag: "span" },
        "cms-textarea": {
          slotName: "textarea",
          tag: "span",
          style: "white-space: pre-line;"
        },
        "cms-image": { slotName: "image", tag: "span" },
        "cms-icon": { slotName: "icon", tag: "span" },
        "cms-richtextarea": {
          slotName: "richtextarea",
          tag: "span"
        }
      }[e];
    },
    hasNewValue(e, t) {
      return e && e.localeCompare && e.localeCompare(t) !== 0;
    },
    mountCss(e) {
      this.removeElementIfExists("style");
      const t = document.createElement("style");
      t.type = "text/css", t.appendChild(document.createTextNode(e)), this.$el.appendChild(t);
    },
    mountJs(e) {
      this.componentKey += 1, this.$nextTick(() => {
        this.removeElementIfExists("script");
        const t = document.createElement("script");
        t.type = "text/javascript", t.appendChild(document.createTextNode(e)), this.$el.appendChild(t);
      });
    },
    removeElementIfExists(e) {
      const t = document.querySelector(`#${this.id} ${e}`);
      t && t.remove();
    },
    dragHandler(e, t) {
      this.$emit("on-drag", {
        oldIndex: e.oldIndex,
        newIndex: e.newIndex,
        loopName: t
      });
    }
  },
  render() {
    var r;
    const e = (o) => {
      if (!o.properties) return {};
      const i = Object.entries(o.properties).filter(([a]) => a.startsWith("data"));
      return i.length ? i.reduce(
        (a, [s, l]) => ge(ae({}, a), {
          [s.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()]: l
        }),
        {}
      ) : {};
    }, t = (o, i, a) => {
      var l, u, m, v, g, h, E, C, A;
      const s = ae({
        id: (l = o.properties) == null ? void 0 : l.id,
        class: (u = o.properties) == null ? void 0 : u.className,
        style: (m = this.customComponent(o.tagName)) == null ? void 0 : m.style,
        className: (g = (v = o.properties) == null ? void 0 : v.className) == null ? void 0 : g.join(" "),
        name: null,
        link: null,
        limit: null,
        src: (h = o.properties) == null ? void 0 : h.src,
        alt: (E = o.properties) == null ? void 0 : E.alt,
        "aspect-ratio": null
      }, e(o));
      if (o.tagName === "cms-loop") {
        const R = () => {
          var L, D;
          const O = ((L = this.content.loop) == null ? void 0 : L[o.properties.name]) || [];
          return [
            ...Array(this.isPreview ? Number((D = o.properties) == null ? void 0 : D.limit) || 5 : O.length || 1)
          ].map(
            (P, U) => {
              var q, z, te;
              return No("div", {}, [
                (z = (q = this.$slots).dragControls) == null ? void 0 : z.call(q, {
                  loopName: o.properties.name,
                  loopIndex: U
                })[0],
                ...(te = o.children) == null ? void 0 : te.map((ee) => t(ee, o.properties.name, U))
              ]);
            }
          );
        };
        return No(
          this.wrapperComponent,
          ge(ae({}, s), {
            itemKey: "index",
            modelValue: R(),
            class: [...(s == null ? void 0 : s.class) || "", this.isEditing ? "custom-component-loop-wrapper" : ""],
            handle: ".drag-handle",
            onUpdate: (O) => this.dragHandler(O, o.properties.name)
          }),
          {
            item: ({ element: O }) => O,
            footer: () => {
              var O, F, L, D, P, U;
              return [
                [
                  !o.properties.limit || !((F = (O = this.content.loop) == null ? void 0 : O[o.properties.name]) != null && F.length) || Number(o.properties.limit) > ((D = (L = this.content.loop) == null ? void 0 : L[o.properties.name]) == null ? void 0 : D.length) ? (U = (P = this.$slots).addLoopElement) == null ? void 0 : U.call(P, {
                    loopName: o.properties.name
                  })[0] : []
                ]
              ];
            }
          }
        );
      }
      return this.customComponent(o.tagName) ? No(this.customComponent(o.tagName).tag, s, [
        this.$slots[this.customComponent(o.tagName).slotName]({
          customName: o.properties.name,
          link: o.properties.hasOwnProperty("link"),
          aspectRatio: (C = o.properties["aspect-ratio"]) != null ? C : "unset",
          inLoop: !!i,
          loopName: i,
          loopIndex: a
        })[0]
      ]) : o.type === "text" ? o.value : No(
        o.tagName,
        s,
        (A = o.children) == null ? void 0 : A.map((R) => t(R, i, a))
      );
    }, n = (r = this.htmlTree.children) == null ? void 0 : r.map((o) => t(o));
    return No("div", { id: this.theme.container_id }, n);
  }
}, kae = {
  mixins: [kt, a8],
  components: { DraggableWrapper: vt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    timeline: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      carrouselItems: this.timeline.items || [],
      isAutoScroll: this.timeline.auto_scroll
    };
  },
  mounted() {
    this.isAutoScroll && !this.isEditing && !this.timeline.hide_component && this.startAutoScroll();
  },
  methods: {
    getAriaLabel(e, t) {
      return `item ${this.getItemNumber(e)} of ${this.carrouselItems.length}, ${t.year}, ${t.title}, ${t.description}, 'Use the left and right arrow keys to navigate'`;
    }
  },
  computed: {
    playPauseAriaLabel() {
      return this.isAutoScroll ? "Pause timeline autoscroll" : "Start timeline autoscroll";
    },
    cssVars() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--bg-color": $(this.theme, "bg_color.hex", "#000"),
        "--button-bg-color": $(this.theme, "button_bg_color.hex", "#fff"),
        "--button-icon-color": $(this.theme, "button_icon_color.hex", "#fff"),
        "--name-color": $(this.theme, "name_color.hex", "#fff"),
        "--wave-line-color": $(this.theme, "wave_line_color.hex", "#fff"),
        "--scroll-text-color": $(this.theme, "scroll_text_color.hex", "#fff"),
        "--year-text-color": $(this.theme, "year_text_color.hex", "#fff"),
        "--year-bg-color": $(this.theme, "year_bg_color.hex", "#000"),
        "--card-text-color": $(this.theme, "card_text_color.hex", "#fff")
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, Eae = {
  name: "TimelineV1",
  mixins: [kae]
}, Sae = { class: "timeline-wrapper" }, Mae = ["data-testid"], Aae = {
  key: 1,
  class: "timeline-box"
}, Iae = {
  class: "buttons-container",
  role: "none"
}, Lae = ["aria-label"], Dae = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, $ae = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, Oae = ["id", "tabindex", "aria-label"], Pae = { class: "item-image" }, Nae = { class: "item-year" }, Hae = { class: "item-body-text" }, Fae = { class: "item-description" }, Rae = { class: "item-title" }, Vae = {
  class: "navigation-instructions",
  "aria-live": "assertive",
  "aria-atomic": "true"
}, Bae = { key: 0 }, jae = { class: "item carrousel-item" }, Uae = { class: "item-image edit" }, qae = { class: "item-year" }, Gae = { class: "item-body-text" }, Kae = { class: "item-description" }, zae = { class: "item-title" };
function Zae(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    style: Z(e.cssVars),
    class: _([
      "timeline-v1",
      e.theme.style,
      { "is-editing": e.isEditing },
      { animated: e.theme.wave_animations },
      { hide: e.timeline.hide_component }
    ]),
    "data-testid": "TimelineV1"
  }, [
    c("div", Sae, [
      e.timeline.show_component_header ? (d(), I(a, {
        key: 0,
        class: _(["timeline-header see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header", {}, () => [
              H(k(e.timeline.component_header), 1)
            ], !0)
          ], 8, Mae)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])) : T("", !0),
      e.isEditing ? (d(), I(Y(e.wrapperComponent), Se({ key: 2 }, e.wrapperProps, {
        modelValue: e.timeline.items,
        "onUpdate:modelValue": t[13] || (t[13] = (s) => e.timeline.items = s),
        "item-key": "id",
        class: "draggable-carrousel editable"
      }), {
        item: S(({ element: s, index: l }) => [
          c("div", jae, [
            c("div", Uae, [
              M(e.$slots, "image", { idx: l }, void 0, !0),
              (d(), I(Y(s.image.url ? "img" : "div"), {
                src: s.image.url,
                alt: s.image.alt_text,
                class: "image"
              }, null, 8, ["src", "alt"])),
              c("span", qae, [
                M(e.$slots, "year", { idx: l }, () => [
                  H(k(s.year), 1)
                ], !0)
              ]),
              c("div", Gae, [
                c("span", Kae, [
                  M(e.$slots, "description", { idx: l }, () => [
                    H(k(s.description), 1)
                  ], !0)
                ]),
                c("span", zae, [
                  M(e.$slots, "title", { idx: l }, () => [
                    H(k(s.title), 1)
                  ], !0)
                ])
              ])
            ])
          ])
        ]),
        _: 3
      }, 16, ["modelValue"])) : (d(), f("div", Aae, [
        t[18] || (t[18] = c("svg", {
          class: "wave-line primary-wave",
          viewBox: "0 24 150 28",
          preserveAspectRatio: "none",
          "shape-rendering": "auto"
        }, [
          c("defs", null, [
            c("path", {
              id: "wave",
              d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            })
          ]),
          c("use", {
            "xlink:href": "#wave",
            x: "50",
            y: "0"
          })
        ], -1)),
        c("div", Iae, [
          e.timeline.auto_scroll ? T("", !0) : (d(), f("button", {
            key: 0,
            class: "slider-button left prev",
            "aria-label": "previous item",
            role: "none",
            onKeyup: t[0] || (t[0] = K((s) => e.moveItem({ direction: "prev" }), ["left"])),
            onClick: t[1] || (t[1] = (s) => e.moveItem({ direction: "prev" }))
          }, t[14] || (t[14] = [
            c("svg", {
              dth: "15",
              height: "28",
              viewBox: "0 0 15 28",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              c("path", {
                fill: "white",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 14L15 1.5L13.5 -1.31134e-07L-1.30849e-05 14.0428L13.5 28L15 26.5L3 14Z"
              })
            ], -1)
          ]), 32)),
          e.timeline.auto_scroll ? T("", !0) : (d(), f("button", {
            key: 1,
            class: "slider-button right next",
            "aria-label": "next item",
            role: "none",
            onKeyup: t[2] || (t[2] = K((s) => e.moveItem({ direction: "next" }), ["right"])),
            onClick: t[3] || (t[3] = (s) => e.moveItem({ direction: "next" }))
          }, t[15] || (t[15] = [
            c("svg", {
              dth: "15",
              height: "28",
              viewBox: "0 0 15 28",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              c("path", {
                fill: "white",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 14L15 1.5L13.5 -1.31134e-07L-1.30849e-05 14.0428L13.5 28L15 26.5L3 14Z"
              })
            ], -1)
          ]), 32)),
          e.timeline.auto_scroll ? (d(), f("button", {
            key: 2,
            class: "play-pause",
            "aria-label": e.playPauseAriaLabel,
            onClick: t[4] || (t[4] = (...s) => e.toggleAutoScroll && e.toggleAutoScroll(...s))
          }, [
            e.isAutoScroll ? (d(), f("svg", Dae, t[16] || (t[16] = [
              c("g", null, [
                c("path", {
                  d: "M8 6V18",
                  "stroke-linecap": "round"
                }),
                c("path", {
                  d: "M16 6V18",
                  "stroke-linecap": "round"
                })
              ], -1)
            ]))) : (d(), f("svg", $ae, t[17] || (t[17] = [
              c("g", null, [
                c("path", { d: "M18.25 11.567C18.5833 11.7594 18.5833 12.2406 18.25 12.433L7.75 18.4952C7.41667 18.6876 7 18.4471 7 18.0622L7 5.93782C7 5.55292 7.41667 5.31236 7.75 5.50481L18.25 11.567Z" })
              ], -1)
            ])))
          ], 8, Lae)) : T("", !0)
        ]),
        c("div", {
          ref: "carrousel",
          role: "none",
          class: "carrousel",
          onTouchstart: t[9] || (t[9] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onTouchend: t[10] || (t[10] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s)),
          onMousedown: t[11] || (t[11] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onMouseup: t[12] || (t[12] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s))
        }, [
          (d(!0), f(J, null, ne(e.content, (s, l) => (d(), f("div", {
            id: `carrousel-item-${l}`,
            key: l,
            tabindex: l === 3 ? 0 : -1,
            class: "item carrousel-item",
            "aria-label": e.getAriaLabel(l, s),
            role: "group",
            onKeyup: [
              t[5] || (t[5] = K((u) => e.moveItem({ direction: "prev", autofocus: !0 }), ["left"])),
              t[6] || (t[6] = K((u) => e.moveItem({ direction: "next", autofocus: !0 }), ["right"]))
            ],
            onFocus: t[7] || (t[7] = (...u) => e.handleFocus && e.handleFocus(...u)),
            onBlur: t[8] || (t[8] = (...u) => e.handleBlur && e.handleBlur(...u))
          }, [
            c("div", Pae, [
              (d(), I(Y(s.image.url ? "img" : "div"), {
                src: s.image.url,
                alt: s.image.alt_text,
                class: "image"
              }, null, 8, ["src", "alt"])),
              c("span", Nae, k(s.year), 1),
              c("div", Hae, [
                c("span", Fae, k(s.description), 1),
                c("span", Rae, k(s.title), 1)
              ])
            ])
          ], 40, Oae))), 128))
        ], 544),
        t[19] || (t[19] = c("svg", {
          class: "wave-line secondary-wave",
          viewBox: "0 24 150 28",
          preserveAspectRatio: "none",
          "shape-rendering": "auto"
        }, [
          c("defs", null, [
            c("path", {
              id: "wave",
              d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            })
          ]),
          c("use", {
            "xlink:href": "#wave",
            x: "48",
            y: "3"
          })
        ], -1)),
        c("div", Vae, [
          e.onFocus ? (d(), f("span", Bae, "Use the left and right arrow keys to navigate")) : T("", !0)
        ])
      ])),
      e.timeline.show_scroll_text ? (d(), f("div", {
        key: 3,
        class: _(["scroll-text", e.theme.style])
      }, [
        M(e.$slots, "scroll", {}, () => [
          H(k(e.timeline.scroll_text), 1)
        ], !0)
      ], 2)) : T("", !0)
    ])
  ], 6);
}
const xae = /* @__PURE__ */ B(Eae, [["render", Zae], ["__scopeId", "data-v-b253921a"]]), Wae = {
  name: "Timeline",
  components: {
    TimelineV1: xae
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    timeline: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function Yae(e, t, n, r, o, i) {
  return d(), I(Y(n.theme.version), {
    theme: n.theme,
    timeline: n.timeline,
    "is-preview": n.isPreview,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing
  }, {
    header: S(() => [
      M(e.$slots, "header")
    ]),
    year: S(({ idx: a }) => [
      M(e.$slots, "year", { idx: a })
    ]),
    title: S(({ idx: a }) => [
      M(e.$slots, "title", { idx: a })
    ]),
    description: S(({ idx: a }) => [
      M(e.$slots, "description", { idx: a })
    ]),
    scroll: S(() => [
      M(e.$slots, "scroll")
    ]),
    image: S(({ idx: a }) => [
      M(e.$slots, "image", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "timeline", "is-preview", "wrapper-component", "wrapper-props", "is-editing"]);
}
const Xae = /* @__PURE__ */ B(Wae, [["render", Yae]]), Qae = {
  mixins: [Rt, kt],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      function t(n) {
        const r = $(n, "cta_color_option") === "solid", o = $(n, "cta_gradient_direction", "down"), i = $(n, "cta_background_color.hex", "initial"), a = r ? i : $(n, "cta_background_secondary_color.hex", i);
        return o == "center" ? {
          "--cta-gradient": `radial-gradient(${i}, ${a})`,
          "--cta-gradient-fancy": `radial-gradient(in oklch, ${i}, ${a})`
        } : {
          "--cta-gradient": `linear-gradient(to ${o}, ${i}, ${a})`,
          "--cta-gradient-fancy": `linear-gradient(in oklch to ${o}, ${i}, ${a})`
        };
      }
      return ge(ae(ae({}, e), t(this.theme)), {
        "--cta-title-color": $(this.theme, "cta_title_color.hex", "initial"),
        "--cta-subtitle-color": $(this.theme, "cta_subtitle_color.hex", "initial"),
        "--cta-divider-color": $(this.theme, "cta_divider_color.hex", "initial"),
        "--cta-text-color": $(this.theme, "cta_text_color.hex", "initial"),
        "--cta-border-color": $(this.theme, "cta_border_color.hex", "initial"),
        "--cta-border-width": $(this.theme, "cta_border_width", "1") + "px",
        "--cta-button-color": $(this.theme, "cta_button_color.hex", "initial"),
        "--cta-button-text-color": $(this.theme, "cta_button_text_color.hex", "initial"),
        "--cta-button-hover": $(this.theme, "cta_button_hover.hex", "initial"),
        "--cta-overlay-color": de($(this.theme, "cta_overlay_color.hex", "initial")).setAlpha(0.85).toRgbString()
      });
    },
    translations() {
      return this.theme.translations;
    },
    isMobile() {
      return this.screenSize < 601;
    },
    isBordered() {
      return $(this.theme, "cta_border_enabled", !0);
    },
    isImageEnabled() {
      return $(this.theme, "cta_image_enabled", !0);
    },
    isParallaxEnabled() {
      return $(this.theme, "cta_parallax_enabled", !0);
    },
    buttonStyle() {
      return $(this.theme, "cta_button_style", "solid");
    }
  }
}, Jae = {
  name: "CTA1",
  mixins: [Qae],
  computed: {
    buttonComponent() {
      return this.isEditing ? "div" : this.isPreview ? "button" : "a";
    }
  }
}, ele = {
  key: 0,
  ref: "parallax",
  class: "parallax-container"
}, tle = {
  key: 1,
  class: "image-container"
}, nle = ["src"], rle = {
  key: 1,
  class: "solid-background"
}, ole = { class: "content-container" }, ile = { class: "cta-title" }, sle = {
  key: 0,
  class: "cta-subtitle"
}, ale = {
  key: 1,
  class: "cta-divider"
}, lle = {
  key: 2,
  class: "cta-text-content"
}, ule = { class: "cta-buttons" };
function dle(e, t, n, r, o, i) {
  var a, s, l, u, m, v, g, h, E;
  return d(), f("div", {
    id: "cta-v1",
    class: _([e.theme.style, { isPreview: e.isPreview, isEditing: e.isEditing }]),
    style: Z(e.colors),
    "data-testid": "CTA1"
  }, [
    e.isImageEnabled && ((a = e.content) != null && a.image) && ((l = (s = e.content) == null ? void 0 : s.image) != null && l.url) ? (d(), f(J, { key: 0 }, [
      e.isParallaxEnabled ? (d(), f("div", ele, [
        c("div", {
          class: "parallax",
          style: Z({ backgroundImage: `url(${(m = (u = e.content) == null ? void 0 : u.image) == null ? void 0 : m.url})` })
        }, null, 4),
        t[0] || (t[0] = c("div", { class: "image-overlay" }, null, -1))
      ], 512)) : (d(), f("div", tle, [
        c("img", {
          class: "full-image",
          src: (g = (v = e.content) == null ? void 0 : v.image) == null ? void 0 : g.url,
          alt: ""
        }, null, 8, nle),
        t[1] || (t[1] = c("div", { class: "image-overlay" }, null, -1))
      ]))
    ], 64)) : (d(), f("div", rle)),
    c("div", {
      class: _(["content-overlay", [e.isBordered && "bordered"]])
    }, [
      c("div", ole, [
        c("h2", ile, [
          M(e.$slots, "title", {
            title: e.content.title
          }, () => [
            H(k(e.content.title), 1)
          ], !0)
        ]),
        e.content.subtitle_enabled ? (d(), f("h3", sle, [
          M(e.$slots, "subtitle", {
            subtitle: e.content.subtitle
          }, () => [
            H(k(e.content.subtitle), 1)
          ], !0)
        ])) : T("", !0),
        e.content.paragraph_enabled ? (d(), f("hr", ale)) : T("", !0),
        e.content.paragraph_enabled ? (d(), f("p", lle, [
          M(e.$slots, "text", {
            text: e.content.text
          }, () => [
            H(k(e.content.text), 1)
          ], !0)
        ])) : T("", !0),
        c("div", ule, [
          (h = e.content.button_1) != null && h.enabled ? (d(), I(Y(i.buttonComponent), {
            key: 0,
            class: _(["cta-button cta-button-1", e.buttonStyle]),
            href: e.content.button_1.link,
            target: e.content.button_1.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "button1", {
                button: e.content.button_1
              }, () => [
                H(k(e.content.button_1.label), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["class", "href", "target"])) : T("", !0),
          (E = e.content.button_2) != null && E.enabled ? (d(), I(Y(i.buttonComponent), {
            key: 1,
            class: _(["cta-button cta-button-2", e.buttonStyle]),
            href: e.content.button_2.link,
            target: e.content.button_2.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "button2", {
                button: e.content.button_2
              }, () => [
                H(k(e.content.button_2.label), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["class", "href", "target"])) : T("", !0)
        ])
      ])
    ], 2)
  ], 6);
}
const cle = /* @__PURE__ */ B(Jae, [["render", dle], ["__scopeId", "data-v-48f57ea5"]]), hle = {
  name: "CallToAction",
  components: {
    CTA1: cle
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  }
}, mle = { id: "view-call-to-aciton" };
function fle(e, t, n, r, o, i) {
  return d(), f("div", mle, [
    (d(), I(Y(n.theme.version), {
      theme: n.theme,
      content: n.content,
      "is-editing": n.isEditing,
      "is-preview": n.isPreview
    }, {
      title: S(() => [
        M(e.$slots, "title")
      ]),
      subtitle: S(() => [
        M(e.$slots, "subtitle")
      ]),
      text: S(() => [
        M(e.$slots, "text")
      ]),
      button1: S(() => [
        M(e.$slots, "button1")
      ]),
      button2: S(() => [
        M(e.$slots, "button2")
      ]),
      _: 3
    }, 8, ["theme", "content", "is-editing", "is-preview"]))
  ]);
}
const ple = /* @__PURE__ */ B(hle, [["render", fle]]), Xp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CmsAbout: fie,
  CmsAlertBanner: Mie,
  CmsAlertBannerSeparate: Kie,
  CmsAlertModal: Tie,
  CmsAlertModalSeparate: Rie,
  CmsAthletics: noe,
  CmsButtons: Aoe,
  CmsCallToAction: ple,
  CmsCustomComponent: Tae,
  CmsCustomHtml: Gs,
  CmsEvents: Bx,
  CmsFloatingNav: bse,
  CmsFooter: hG,
  CmsGallery: BE,
  CmsHeader: PB,
  CmsLiveFeed: SX,
  CmsMediaCustomHtml: Qse,
  CmsMenu: sU,
  CmsOurSchools: xse,
  CmsParallax: Qie,
  CmsPrograms: Rz,
  CmsSpotlight: Gre,
  CmsStats: Fee,
  CmsStickyFooter: wae,
  CmsTimeline: Xae,
  CmsVideo: fne,
  News: ty
}, Symbol.toStringTag, { value: "Module" })), gle = {
  install(e) {
    e.use(E6), Object.keys(Xp).forEach((t) => {
      e.component(t, Xp[t]);
    });
  }
}, yle = gle;
export {
  yle as plugin
};
//# sourceMappingURL=cms-components.es.js.map
